/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 330);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(337);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(process, module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "css", function() { return css; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "keyframes", function() { return keyframes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "injectGlobal", function() { return injectGlobal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isStyledComponent", function() { return isStyledComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "consolidateStreamedStyles", function() { return consolidateStreamedStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ThemeProvider", function() { return ThemeProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withTheme", function() { return withTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ServerStyleSheet", function() { return ServerStyleSheet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StyleSheetManager", function() { return StyleSheetManager; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS", function() { return __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylis__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_stylis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_is__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_is__);








var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

// 
var isPlainObject = (function (x) {
  return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x.constructor === Object;
});

// 


/**
 * Parse errors.md and turn it into a simple hash of code: message
 */
var ERRORS =  false ? {
  "1": "Cannot create styled-component for component: %s.\n\n",
  "2": "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n* Are you trying to reuse it across renders?\n* Are you accidentally calling collectStyles twice?\n\n",
  "3": "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",
  "4": "The `StyleSheetManager` expects a valid target or sheet prop!\n\n* Does this error occur on the client and is your target falsy?\n* Does this error occur on the server and is the sheet falsy?\n\n",
  "5": "The clone method cannot be used on the client!\n\n* Are you running in a client-like environment on the server?\n* Are you trying to run SSR on the client?\n\n",
  "6": "Trying to insert a new style tag, but the given Node is unmounted!\n\n* Are you using a custom target that isn't mounted?\n* Does your document not have a valid head element?\n* Have you accidentally removed a style tag manually?\n\n",
  "7": "ThemeProvider: Please return an object from your \"theme\" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n",
  "8": "ThemeProvider: Please make your \"theme\" prop an object.\n\n",
  "9": "Missing document `<head>`\n\n",
  "10": "Cannot find sheet for given tag\n\n",
  "11": "A plain React class (%s) has been interpolated into styles, probably as a component selector (https://www.styled-components.com/docs/advanced#referring-to-other-components). Only styled-component classes can be targeted in this fashion."
} : {};

/**
 * super basic version of sprintf
 */
function format() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var a = args[0];
  var b = [];
  var c = void 0;

  for (c = 1; c < args.length; c += 1) {
    b.push(args[c]);
  }

  b.forEach(function (d) {
    a = a.replace(/%[a-z]/, d);
  });

  return a;
}

/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 */

var StyledComponentsError = function (_Error) {
  inherits(StyledComponentsError, _Error);

  function StyledComponentsError(code) {
    classCallCheck(this, StyledComponentsError);

    for (var _len2 = arguments.length, interpolations = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      interpolations[_key2 - 1] = arguments[_key2];
    }

    if (true) {
      var _this = possibleConstructorReturn(this, _Error.call(this, 'An error occurred. See https://github.com/styled-components/styled-components/blob/master/src/utils/errors.md#' + code + ' for more information. ' + (interpolations ? 'Additional arguments: ' + interpolations.join(', ') : '')));
    } else {
      var _this = possibleConstructorReturn(this, _Error.call(this, format.apply(undefined, [ERRORS[code]].concat(interpolations))));
    }
    return possibleConstructorReturn(_this);
  }

  return StyledComponentsError;
}(Error);

// 

var objToCss = function objToCss(obj, prevKey) {
  var css = Object.keys(obj).filter(function (key) {
    var chunk = obj[key];
    return chunk !== undefined && chunk !== null && chunk !== false && chunk !== '';
  }).map(function (key) {
    if (isPlainObject(obj[key])) return objToCss(obj[key], key);
    return __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName___default()(key) + ': ' + obj[key] + ';';
  }).join(' ');
  return prevKey ? prevKey + ' {\n  ' + css + '\n}' : css;
};

var flatten = function flatten(chunks, executionContext) {
  return chunks.reduce(function (ruleSet, chunk) {
    /* Remove falsey values */
    if (chunk === undefined || chunk === null || chunk === false || chunk === '') {
      return ruleSet;
    }

    /* Flatten ruleSet */
    if (Array.isArray(chunk)) {
      ruleSet.push.apply(ruleSet, flatten(chunk, executionContext));
      return ruleSet;
    }

    /* Handle other components */
    if (chunk.hasOwnProperty('styledComponentId')) {
      // $FlowFixMe not sure how to make this pass
      ruleSet.push('.' + chunk.styledComponentId);
      return ruleSet;
    }

    /* Either execute or defer the function */
    if (typeof chunk === 'function') {
      if (executionContext) {
        var nextChunk = chunk(executionContext);
        /* Throw if a React Element was given styles */
        if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(nextChunk)) {
          var elementName = chunk.displayName || chunk.name;
          throw new StyledComponentsError(11, elementName);
        }
        ruleSet.push.apply(ruleSet, flatten([nextChunk], executionContext));
      } else ruleSet.push(chunk);

      return ruleSet;
    }

    /* Handle objects */
    ruleSet.push(
    // $FlowFixMe have to add %checks somehow to isPlainObject
    isPlainObject(chunk) ? objToCss(chunk) : chunk.toString());

    return ruleSet;
  }, []);
};

// 

var COMMENT_REGEX = /^\s*\/\/.*$/gm;

// NOTE: This stylis instance is only used to split rules from SSR'd style tags
var stylisSplitter = new __WEBPACK_IMPORTED_MODULE_2_stylis___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: false,
  compress: false,
  semicolon: true
});

var stylis = new __WEBPACK_IMPORTED_MODULE_2_stylis___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: true,
  compress: false,
  semicolon: false // NOTE: This means "autocomplete missing semicolons"
});

// Wrap `insertRulePlugin to build a list of rules,
// and then make our own plugin to return the rules. This
// makes it easier to hook into the existing SSR architecture

var parsingRules = [];
// eslint-disable-next-line consistent-return
var returnRulesPlugin = function returnRulesPlugin(context) {
  if (context === -2) {
    var parsedRules = parsingRules;
    parsingRules = [];
    return parsedRules;
  }
};

var parseRulesPlugin = __WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet___default()(function (rule) {
  parsingRules.push(rule);
});

stylis.use([parseRulesPlugin, returnRulesPlugin]);
stylisSplitter.use([parseRulesPlugin, returnRulesPlugin]);

var stringifyRules = function stringifyRules(rules, selector, prefix) {
  var flatCSS = rules.join('').replace(COMMENT_REGEX, ''); // replace JS comments

  var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;

  return stylis(prefix || !selector ? '' : selector, cssStr);
};

var splitByRules = function splitByRules(css) {
  return stylisSplitter('', css);
};

// 

function isStyledComponent(target) /* : %checks */{
  return (
    // $FlowFixMe TODO: flow for styledComponentId
    typeof target === 'function' && typeof target.styledComponentId === 'string'
  );
}

// 

/* This function is DEPRECATED and will be removed on the next major version release.
 * It was needed to rehydrate all style blocks prepended to chunks before React
 * tries to rehydrate its HTML stream. Since the master StyleSheet will now detect
 * the use of streamed style tags and will perform the rehydration earlier when needed
 * this function will not be needed anymore */
function consolidateStreamedStyles() {
  if (false) {
    // eslint-disable-next-line no-console
    console.warn('styled-components automatically does streaming SSR rehydration now.\n' + 'Calling consolidateStreamedStyles manually is no longer necessary and a noop now.\n' + '- Please remove the consolidateStreamedStyles call from your client.');
  }
}

// 
/* eslint-disable no-bitwise */

/* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
 * counterparts */
var charsLength = 52;

/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */
var getAlphabeticChar = function getAlphabeticChar(code) {
  return String.fromCharCode(code + (code > 25 ? 39 : 97));
};

/* input a number, usually a hash and convert it to base-52 */
var generateAlphabeticName = function generateAlphabeticName(code) {
  var name = '';
  var x = void 0;

  /* get a char and divide by alphabet-length */
  for (x = code; x > charsLength; x = Math.floor(x / charsLength)) {
    name = getAlphabeticChar(x % charsLength) + name;
  }

  return getAlphabeticChar(x % charsLength) + name;
};

// 

var interleave = (function (strings, interpolations) {
  var result = [strings[0]];

  for (var i = 0, len = interpolations.length; i < len; i += 1) {
    result.push(interpolations[i], strings[i + 1]);
  }

  return result;
});

// 
var EMPTY_ARRAY = Object.freeze([]);
var EMPTY_OBJECT = Object.freeze({});

// 

var css = (function (styles) {
  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  if (typeof styles === 'function' || isPlainObject(styles)) {
    // $FlowFixMe
    return flatten(interleave(EMPTY_ARRAY, [styles].concat(interpolations)));
  }

  // $FlowFixMe
  return flatten(interleave(styles, interpolations));
});

// 


var SC_ATTR = typeof process !== 'undefined' && Object({"NODE_ENV":"production","PUBLIC_URL":""}).SC_ATTR || 'data-styled-components';
var SC_STREAM_ATTR = 'data-styled-streamed';
var CONTEXT_KEY = '__styled-components-stylesheet__';

var IS_BROWSER = typeof window !== 'undefined' && 'HTMLElement' in window;

var DISABLE_SPEEDY = "production" !== 'production';

// 
var SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm;

var extractComps = (function (maybeCSS) {
  var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
  var existingComponents = [];
  css.replace(SC_COMPONENT_ID, function (match, componentId, matchIndex) {
    existingComponents.push({ componentId: componentId, matchIndex: matchIndex });
    return match;
  });
  return existingComponents.map(function (_ref, i) {
    var componentId = _ref.componentId,
        matchIndex = _ref.matchIndex;

    var nextComp = existingComponents[i + 1];
    var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
    return { componentId: componentId, cssFromDOM: cssFromDOM };
  });
});

// 
/* eslint-disable camelcase, no-undef */

var getNonce = (function () {
  return  true ? __webpack_require__.nc : null;
});

// 
// Helper to call a given function, only once
var once = (function (cb) {
  var called = false;

  return function () {
    if (!called) {
      called = true;
      cb();
    }
  };
});

// 
/* These are helpers for the StyleTags to keep track of the injected
 * rule names for each (component) ID that they're keeping track of.
 * They're crucial for detecting whether a name has already been
 * injected.
 * (This excludes rehydrated names) */

/* adds a new ID:name pairing to a names dictionary */
var addNameForId = function addNameForId(names, id, name) {
  if (name) {
    // eslint-disable-next-line no-param-reassign
    var namesForId = names[id] || (names[id] = Object.create(null));
    namesForId[name] = true;
  }
};

/* resets an ID entirely by overwriting it in the dictionary */
var resetIdNames = function resetIdNames(names, id) {
  // eslint-disable-next-line no-param-reassign
  names[id] = Object.create(null);
};

/* factory for a names dictionary checking the existance of an ID:name pairing */
var hasNameForId = function hasNameForId(names) {
  return function (id, name) {
    return names[id] !== undefined && names[id][name];
  };
};

/* stringifies names for the html/element output */
var stringifyNames = function stringifyNames(names) {
  var str = '';
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    str += Object.keys(names[id]).join(' ') + ' ';
  }
  return str.trim();
};

/* clones the nested names dictionary */
var cloneNames = function cloneNames(names) {
  var clone = Object.create(null);
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    clone[id] = _extends({}, names[id]);
  }
  return clone;
};

// 

/* These are helpers that deal with the insertRule (aka speedy) API
 * They are used in the StyleTags and specifically the speedy tag
 */

/* retrieve a sheet for a given style tag */
var sheetForTag = function sheetForTag(tag) {
  // $FlowFixMe
  if (tag.sheet) return tag.sheet;

  /* Firefox quirk requires us to step through all stylesheets to find one owned by the given tag */
  var size = document.styleSheets.length;
  for (var i = 0; i < size; i += 1) {
    var sheet = document.styleSheets[i];
    // $FlowFixMe
    if (sheet.ownerNode === tag) return sheet;
  }

  /* we should always be able to find a tag */
  throw new StyledComponentsError(10);
};

/* insert a rule safely and return whether it was actually injected */
var safeInsertRule = function safeInsertRule(sheet, cssRule, index) {
  /* abort early if cssRule string is falsy */
  if (!cssRule) return false;

  var maxIndex = sheet.cssRules.length;

  try {
    /* use insertRule and cap passed index with maxIndex (no of cssRules) */
    sheet.insertRule(cssRule, index <= maxIndex ? index : maxIndex);
  } catch (err) {
    /* any error indicates an invalid rule */
    return false;
  }

  return true;
};

/* deletes `size` rules starting from `removalIndex` */
var deleteRules = function deleteRules(sheet, removalIndex, size) {
  var lowerBound = removalIndex - size;
  for (var i = removalIndex; i > lowerBound; i -= 1) {
    sheet.deleteRule(i);
  }
};

// 

/* this marker separates component styles and is important for rehydration */
var makeTextMarker = function makeTextMarker(id) {
  return '\n/* sc-component-id: ' + id + ' */\n';
};

/* add up all numbers in array up until and including the index */
var addUpUntilIndex = function addUpUntilIndex(sizes, index) {
  var totalUpToIndex = 0;
  for (var i = 0; i <= index; i += 1) {
    totalUpToIndex += sizes[i];
  }

  return totalUpToIndex;
};

/* create a new style tag after lastEl */
var makeStyleTag = function makeStyleTag(target, tagEl, insertBefore) {
  var el = document.createElement('style');
  el.setAttribute(SC_ATTR, '');

  var nonce = getNonce();
  if (nonce) {
    el.setAttribute('nonce', nonce);
  }

  /* Work around insertRule quirk in EdgeHTML */
  el.appendChild(document.createTextNode(''));

  if (target && !tagEl) {
    /* Append to target when no previous element was passed */
    target.appendChild(el);
  } else {
    if (!tagEl || !target || !tagEl.parentNode) {
      throw new StyledComponentsError(6);
    }

    /* Insert new style tag after the previous one */
    tagEl.parentNode.insertBefore(el, insertBefore ? tagEl : tagEl.nextSibling);
  }

  return el;
};

/* takes a css factory function and outputs an html styled tag factory */
var wrapAsHtmlTag = function wrapAsHtmlTag(css, names) {
  return function (additionalAttrs) {
    var nonce = getNonce();
    var attrs = [nonce && 'nonce="' + nonce + '"', SC_ATTR + '="' + stringifyNames(names) + '"', additionalAttrs];

    var htmlAttr = attrs.filter(Boolean).join(' ');
    return '<style ' + htmlAttr + '>' + css() + '</style>';
  };
};

/* takes a css factory function and outputs an element factory */
var wrapAsElement = function wrapAsElement(css, names) {
  return function () {
    var _props;

    var props = (_props = {}, _props[SC_ATTR] = stringifyNames(names), _props);

    var nonce = getNonce();
    if (nonce) {
      // $FlowFixMe
      props.nonce = nonce;
    }

    // eslint-disable-next-line react/no-danger
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('style', _extends({}, props, { dangerouslySetInnerHTML: { __html: css() } }));
  };
};

var getIdsFromMarkersFactory = function getIdsFromMarkersFactory(markers) {
  return function () {
    return Object.keys(markers);
  };
};

/* speedy tags utilise insertRule */
var makeSpeedyTag = function makeSpeedyTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);
  var sizes = [];

  var extractImport = getImportRuleTag !== undefined;
  /* indicates whther getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = sizes.length;
    sizes.push(0);
    resetIdNames(names, id);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var sheet = sheetForTag(el);
    var insertIndex = addUpUntilIndex(sizes, marker);

    var injectedRules = 0;
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var cssRule = cssRules[i];
      var mayHaveImport = extractImport; /* @import rules are reordered to appear first */
      if (mayHaveImport && cssRule.indexOf('@import') !== -1) {
        importRules.push(cssRule);
      } else if (safeInsertRule(sheet, cssRule, insertIndex + injectedRules)) {
        mayHaveImport = false;
        injectedRules += 1;
      }
    }

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }

    sizes[marker] += injectedRules; /* add up no of injected rules */
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    var size = sizes[marker];
    var sheet = sheetForTag(el);
    var removalIndex = addUpUntilIndex(sizes, marker);
    deleteRules(sheet, removalIndex, size);
    sizes[marker] = 0;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var _sheetForTag = sheetForTag(el),
        cssRules = _sheetForTag.cssRules;

    var str = '';

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += makeTextMarker(id);
      var marker = markers[id];
      var end = addUpUntilIndex(sizes, marker);
      var size = sizes[marker];
      for (var i = end - size; i < end; i += 1) {
        var rule = cssRules[i];
        if (rule !== undefined) {
          str += rule.cssText;
        }
      }
    }

    return str;
  };

  return {
    styleTag: el,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    css: css,
    toHTML: wrapAsHtmlTag(css, names),
    toElement: wrapAsElement(css, names),
    clone: function clone() {
      throw new StyledComponentsError(5);
    }
  };
};

var makeTextNode = function makeTextNode(id) {
  return document.createTextNode(makeTextMarker(id));
};

var makeBrowserTag = function makeBrowserTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);

  var extractImport = getImportRuleTag !== undefined;

  /* indicates whther getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = makeTextNode(id);
    el.appendChild(markers[id]);
    names[id] = Object.create(null);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var rule = cssRules[i];
      var mayHaveImport = extractImport;
      if (mayHaveImport && rule.indexOf('@import') !== -1) {
        importRules.push(rule);
      } else {
        mayHaveImport = false;
        var separator = i === cssRulesSize - 1 ? '' : ' ';
        marker.appendData('' + rule + separator);
      }
    }

    addNameForId(names, id, name);

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    /* create new empty text node and replace the current one */
    var newMarker = makeTextNode(id);
    el.replaceChild(newMarker, marker);
    markers[id] = newMarker;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += markers[id].data;
    }
    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeServerTagInternal = function makeServerTagInternal(namesArg, markersArg) {
  var names = namesArg === undefined ? Object.create(null) : namesArg;
  var markers = markersArg === undefined ? Object.create(null) : markersArg;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    return markers[id] = [''];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    marker[0] += cssRules.join(' ');
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;
    marker[0] = '';
    resetIdNames(names, id);
  };

  var css = function css() {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      var cssForId = markers[id][0];
      if (cssForId) {
        str += makeTextMarker(id) + cssForId;
      }
    }
    return str;
  };

  var clone = function clone() {
    var namesClone = cloneNames(names);
    var markersClone = Object.create(null);

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      markersClone[id] = [markers[id][0]];
    }

    return makeServerTagInternal(namesClone, markersClone);
  };

  var tag = {
    clone: clone,
    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    styleTag: null,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };

  return tag;
};

var makeServerTag = function makeServerTag() {
  return makeServerTagInternal();
};

var makeTag = function makeTag(target, tagEl, forceServer, insertBefore, getImportRuleTag) {
  if (IS_BROWSER && !forceServer) {
    var el = makeStyleTag(target, tagEl, insertBefore);

    if (DISABLE_SPEEDY) {
      return makeBrowserTag(el, getImportRuleTag);
    } else {
      return makeSpeedyTag(el, getImportRuleTag);
    }
  }

  return makeServerTag();
};

/* wraps a given tag so that rehydration is performed once when necessary */
var makeRehydrationTag = function makeRehydrationTag(tag, els, extracted, immediateRehydration) {
  /* rehydration function that adds all rules to the new tag */
  var rehydrate = once(function () {
    /* add all extracted components to the new tag */
    for (var i = 0, len = extracted.length; i < len; i += 1) {
      var _extracted$i = extracted[i],
          componentId = _extracted$i.componentId,
          cssFromDOM = _extracted$i.cssFromDOM;

      var cssRules = splitByRules(cssFromDOM);
      tag.insertRules(componentId, cssRules);
    }

    /* remove old HTMLStyleElements, since they have been rehydrated */
    for (var _i = 0, _len = els.length; _i < _len; _i += 1) {
      var el = els[_i];
      if (el.parentNode) {
        el.parentNode.removeChild(el);
      }
    }
  });

  if (immediateRehydration) rehydrate();

  return _extends({}, tag, {
    /* add rehydration hook to insertion methods */
    insertMarker: function insertMarker(id) {
      rehydrate();
      return tag.insertMarker(id);
    },
    insertRules: function insertRules(id, cssRules, name) {
      rehydrate();
      return tag.insertRules(id, cssRules, name);
    }
  });
};

// 

var SPLIT_REGEX = /\s+/;

/* determine the maximum number of components before tags are sharded */
var MAX_SIZE = void 0;
if (IS_BROWSER) {
  /* in speedy mode we can keep a lot more rules in a sheet before a slowdown can be expected */
  MAX_SIZE = DISABLE_SPEEDY ? 40 : 1000;
} else {
  /* for servers we do not need to shard at all */
  MAX_SIZE = -1;
}

var sheetRunningId = 0;
var master = void 0;

var StyleSheet = function () {
  /* a map from ids to tags */
  /* deferred rules for a given id */
  /* this is used for not reinjecting rules via hasNameForId() */
  /* when rules for an id are removed using remove() we have to ignore rehydratedNames for it */
  /* a list of tags belonging to this StyleSheet */
  /* a tag for import rules */
  /* current capacity until a new tag must be created */
  /* children (aka clones) of this StyleSheet inheriting all and future injections */

  function StyleSheet() {
    var _this = this;

    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : IS_BROWSER ? document.head : null;
    var forceServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    classCallCheck(this, StyleSheet);

    this.getImportRuleTag = function () {
      var importRuleTag = _this.importRuleTag;

      if (importRuleTag !== undefined) {
        return importRuleTag;
      }

      var firstTag = _this.tags[0];
      var insertBefore = true;

      return _this.importRuleTag = makeTag(_this.target, firstTag ? firstTag.styleTag : null, _this.forceServer, insertBefore);
    };

    sheetRunningId += 1;
    this.id = sheetRunningId;
    this.sealed = false;
    this.forceServer = forceServer;
    this.target = forceServer ? null : target;
    this.tagMap = {};
    this.deferred = {};
    this.rehydratedNames = {};
    this.ignoreRehydratedNames = {};
    this.tags = [];
    this.capacity = 1;
    this.clones = [];
  }

  /* rehydrate all SSR'd style tags */


  StyleSheet.prototype.rehydrate = function rehydrate() {
    if (!IS_BROWSER || this.forceServer) {
      return this;
    }

    var els = [];
    var extracted = [];
    var isStreamed = false;

    /* retrieve all of our SSR style elements from the DOM */
    var nodes = document.querySelectorAll('style[' + SC_ATTR + ']');
    var nodesSize = nodes.length;

    /* abort rehydration if no previous style tags were found */
    if (nodesSize === 0) {
      return this;
    }

    for (var i = 0; i < nodesSize; i += 1) {
      // $FlowFixMe: We can trust that all elements in this query are style elements
      var el = nodes[i];

      /* check if style tag is a streamed tag */
      if (!isStreamed) isStreamed = !!el.getAttribute(SC_STREAM_ATTR);

      /* retrieve all component names */
      var elNames = (el.getAttribute(SC_ATTR) || '').trim().split(SPLIT_REGEX);
      var elNamesSize = elNames.length;
      for (var j = 0; j < elNamesSize; j += 1) {
        var name = elNames[j];
        /* add rehydrated name to sheet to avoid readding styles */
        this.rehydratedNames[name] = true;
      }

      /* extract all components and their CSS */
      extracted.push.apply(extracted, extractComps(el.textContent));

      /* store original HTMLStyleElement */
      els.push(el);
    }

    /* abort rehydration if nothing was extracted */
    var extractedSize = extracted.length;
    if (extractedSize === 0) {
      return this;
    }

    /* create a tag to be used for rehydration */
    var tag = this.makeTag(null);
    var rehydrationTag = makeRehydrationTag(tag, els, extracted, isStreamed);

    /* reset capacity and adjust MAX_SIZE by the initial size of the rehydration */
    this.capacity = Math.max(1, MAX_SIZE - extractedSize);
    this.tags.push(rehydrationTag);

    /* retrieve all component ids */
    for (var _j = 0; _j < extractedSize; _j += 1) {
      this.tagMap[extracted[_j].componentId] = rehydrationTag;
    }

    return this;
  };

  /* retrieve a "master" instance of StyleSheet which is typically used when no other is available
   * The master StyleSheet is targeted by injectGlobal, keyframes, and components outside of any
    * StyleSheetManager's context */


  /* reset the internal "master" instance */
  StyleSheet.reset = function reset() {
    var forceServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    master = new StyleSheet(undefined, forceServer).rehydrate();
  };

  /* adds "children" to the StyleSheet that inherit all of the parents' rules
   * while their own rules do not affect the parent */


  StyleSheet.prototype.clone = function clone() {
    var sheet = new StyleSheet(this.target, this.forceServer);
    /* add to clone array */
    this.clones.push(sheet);

    /* clone all tags */
    sheet.tags = this.tags.map(function (tag) {
      var ids = tag.getIds();
      var newTag = tag.clone();

      /* reconstruct tagMap */
      for (var i = 0; i < ids.length; i += 1) {
        sheet.tagMap[ids[i]] = newTag;
      }

      return newTag;
    });

    /* clone other maps */
    sheet.rehydratedNames = _extends({}, this.rehydratedNames);
    sheet.deferred = _extends({}, this.deferred);

    return sheet;
  };

  /* force StyleSheet to create a new tag on the next injection */


  StyleSheet.prototype.sealAllTags = function sealAllTags() {
    this.capacity = 1;
    this.sealed = true;
  };

  StyleSheet.prototype.makeTag = function makeTag$$1(tag) {
    var lastEl = tag ? tag.styleTag : null;
    var insertBefore = false;

    return makeTag(this.target, lastEl, this.forceServer, insertBefore, this.getImportRuleTag);
  };

  /* get a tag for a given componentId, assign the componentId to one, or shard */
  StyleSheet.prototype.getTagForId = function getTagForId(id) {
    /* simply return a tag, when the componentId was already assigned one */
    var prev = this.tagMap[id];
    if (prev !== undefined && !this.sealed) {
      return prev;
    }

    var tag = this.tags[this.tags.length - 1];

    /* shard (create a new tag) if the tag is exhausted (See MAX_SIZE) */
    this.capacity -= 1;
    if (this.capacity === 0) {
      this.capacity = MAX_SIZE;
      this.sealed = false;
      tag = this.makeTag(tag);
      this.tags.push(tag);
    }

    return this.tagMap[id] = tag;
  };

  /* mainly for injectGlobal to check for its id */


  StyleSheet.prototype.hasId = function hasId(id) {
    return this.tagMap[id] !== undefined;
  };

  /* caching layer checking id+name to already have a corresponding tag and injected rules */


  StyleSheet.prototype.hasNameForId = function hasNameForId(id, name) {
    /* exception for rehydrated names which are checked separately */
    if (this.ignoreRehydratedNames[id] === undefined && this.rehydratedNames[name]) {
      return true;
    }

    var tag = this.tagMap[id];
    return tag !== undefined && tag.hasNameForId(id, name);
  };

  /* registers a componentId and registers it on its tag */


  StyleSheet.prototype.deferredInject = function deferredInject(id, cssRules) {
    /* don't inject when the id is already registered */
    if (this.tagMap[id] !== undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].deferredInject(id, cssRules);
    }

    this.getTagForId(id).insertMarker(id);
    this.deferred[id] = cssRules;
  };

  /* injects rules for a given id with a name that will need to be cached */


  StyleSheet.prototype.inject = function inject(id, cssRules, name) {
    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].inject(id, cssRules, name);
    }

    var tag = this.getTagForId(id);

    /* add deferred rules for component */
    if (this.deferred[id] !== undefined) {
      // Combine passed cssRules with previously deferred CSS rules
      // NOTE: We cannot mutate the deferred array itself as all clones
      // do the same (see clones[i].inject)
      var rules = this.deferred[id].concat(cssRules);
      tag.insertRules(id, rules, name);
      this.deferred[id] = undefined;
    } else {
      tag.insertRules(id, cssRules, name);
    }
  };

  /* removes all rules for a given id, which doesn't remove its marker but resets it */


  StyleSheet.prototype.remove = function remove(id) {
    var tag = this.tagMap[id];
    if (tag === undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].remove(id);
    }

    /* remove all rules from the tag */
    tag.removeRules(id);
    /* ignore possible rehydrated names */
    this.ignoreRehydratedNames[id] = true;
    /* delete possible deferred rules */
    this.deferred[id] = undefined;
  };

  StyleSheet.prototype.toHTML = function toHTML() {
    return this.tags.map(function (tag) {
      return tag.toHTML();
    }).join('');
  };

  StyleSheet.prototype.toReactElements = function toReactElements() {
    var id = this.id;


    return this.tags.map(function (tag, i) {
      var key = 'sc-' + id + '-' + i;
      return Object(__WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"])(tag.toElement(), { key: key });
    });
  };

  createClass(StyleSheet, null, [{
    key: 'master',
    get: function get$$1() {
      return master || (master = new StyleSheet().rehydrate());
    }

    /* NOTE: This is just for backwards-compatibility with jest-styled-components */

  }, {
    key: 'instance',
    get: function get$$1() {
      return StyleSheet.master;
    }
  }]);
  return StyleSheet;
}();

var _StyleSheetManager$ch;

var StyleSheetManager = function (_Component) {
  inherits(StyleSheetManager, _Component);

  function StyleSheetManager() {
    classCallCheck(this, StyleSheetManager);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  StyleSheetManager.prototype.getChildContext = function getChildContext() {
    var _ref;

    return _ref = {}, _ref[CONTEXT_KEY] = this.sheetInstance, _ref;
  };

  StyleSheetManager.prototype.componentWillMount = function componentWillMount() {
    if (this.props.sheet) {
      this.sheetInstance = this.props.sheet;
    } else if (this.props.target) {
      this.sheetInstance = new StyleSheet(this.props.target);
    } else {
      throw new StyledComponentsError(4);
    }
  };

  StyleSheetManager.prototype.render = function render() {
    /* eslint-disable react/prop-types */
    // Flow v0.43.1 will report an error accessing the `children` property,
    // but v0.47.0 will not. It is necessary to use a type cast instead of
    // a "fixme" comment to satisfy both Flow versions.
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.only(this.props.children);
  };

  return StyleSheetManager;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

StyleSheetManager.childContextTypes = (_StyleSheetManager$ch = {}, _StyleSheetManager$ch[CONTEXT_KEY] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(StyleSheet), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(ServerStyleSheet)]).isRequired, _StyleSheetManager$ch);
 false ? StyleSheetManager.propTypes = {
  sheet: PropTypes.oneOfType([PropTypes.instanceOf(StyleSheet), PropTypes.instanceOf(ServerStyleSheet)]),
  target: PropTypes.shape({
    appendChild: PropTypes.func.isRequired
  })
} : void 0;

// 

var ServerStyleSheet = function () {
  function ServerStyleSheet() {
    classCallCheck(this, ServerStyleSheet);

    /* The master sheet might be reset, so keep a reference here */
    this.masterSheet = StyleSheet.master;
    this.instance = this.masterSheet.clone();
    this.closed = false;
  }

  ServerStyleSheet.prototype.complete = function complete() {
    if (!this.closed) {
      /* Remove closed StyleSheets from the master sheet */
      var index = this.masterSheet.clones.indexOf(this.instance);
      this.masterSheet.clones.splice(index, 1);
      this.closed = true;
    }
  };

  ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
    if (this.closed) {
      throw new StyledComponentsError(2);
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      StyleSheetManager,
      { sheet: this.instance },
      children
    );
  };

  ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
    this.complete();
    return this.instance.toHTML();
  };

  ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
    this.complete();
    return this.instance.toReactElements();
  };

  ServerStyleSheet.prototype.interleaveWithNodeStream = function interleaveWithNodeStream(readableStream) {
    var _this = this;

    {
      throw new StyledComponentsError(3);
    }

    /* the tag index keeps track of which tags have already been emitted */
    var instance = this.instance;

    var instanceTagIndex = 0;

    var streamAttr = SC_STREAM_ATTR + '="true"';

    var transformer = new stream.Transform({
      transform: function appendStyleChunks(chunk, /* encoding */_, callback) {
        var tags = instance.tags;

        var html = '';

        /* retrieve html for each new style tag */
        for (; instanceTagIndex < tags.length; instanceTagIndex += 1) {
          var tag = tags[instanceTagIndex];
          html += tag.toHTML(streamAttr);
        }

        /* force our StyleSheets to emit entirely new tags */
        instance.sealAllTags();

        /* prepend style html to chunk */
        this.push(html + chunk);
        callback();
      }
    });

    readableStream.on('end', function () {
      return _this.complete();
    });
    readableStream.on('error', function (err) {
      _this.complete();

      // forward the error to the transform stream
      transformer.emit('error', err);
    });

    return readableStream.pipe(transformer);
  };

  return ServerStyleSheet;
}();

// 

var LIMIT = 200;

var createWarnTooManyClasses = (function (displayName) {
  var generatedClasses = {};
  var warningSeen = false;

  return function (className) {
    if (!warningSeen) {
      generatedClasses[className] = true;
      if (Object.keys(generatedClasses).length >= LIMIT) {
        // Unable to find latestRule in test environment.
        /* eslint-disable no-console, prefer-template */
        console.warn('Over ' + LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs({\n' + '    style: ({ background }) => ({\n' + '      background,\n' + '    }),\n' + '  })`width: 100%;`\n\n' + '  <Component />');
        warningSeen = true;
        generatedClasses = {};
      }
    }
  };
});

// 

var determineTheme = (function (props, fallbackTheme, defaultProps) {
  // Props should take precedence over ThemeProvider, which should take precedence over
  // defaultProps, but React automatically puts defaultProps on props.

  /* eslint-disable react/prop-types */
  var isDefaultTheme = defaultProps && props.theme === defaultProps.theme;
  var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme;
  /* eslint-enable */

  return theme;
});

// 
var escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
var dashesAtEnds = /(^-|-$)/g;

/**
 * TODO: Explore using CSS.escape when it becomes more available
 * in evergreen browsers.
 */
function escape(str) {
  return str
  // Replace all possible CSS selectors
  .replace(escapeRegex, '-')

  // Remove extraneous hyphens at the start and end
  .replace(dashesAtEnds, '');
}

// 

function getComponentName(target) {
  return target.displayName || target.name || 'Component';
}

// 

function isTag(target) /* : %checks */{
  return typeof target === 'string';
}

// 

function generateDisplayName(target) {
  return isTag(target) ? 'styled.' + target : 'Styled(' + getComponentName(target) + ')';
}

// 
/* eslint-disable max-len */
/**
 * Trying to avoid the unknown-prop errors on styled components by filtering by
 * React's attribute whitelist.
 *
 * To regenerate this regex:
 *
 * 1. `npm i -g regexgen` (https://github.com/devongovett/regexgen)
 * 2. Run `regexgen` with the list of space-separated words below as input
 * 3. Surround the emitted regex with this: `/^(GENERATED_REGEX)$/` -- this will ensure a full string match
 *    and no false positives from partials
 * */
/*
children dangerouslySetInnerHTML key ref autoFocus defaultValue valueLink defaultChecked checkedLink innerHTML suppressContentEditableWarning onFocusIn onFocusOut className onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown onKeyPress onKeyUp onFocus onBlur onChange onInput onInvalid onSubmit onReset onClick onContextMenu onDoubleClick onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onAnimationStart onAnimationEnd onAnimationIteration onTransitionEnd onCopyCapture onCutCapture onPasteCapture onCompositionEndCapture onCompositionStartCapture onCompositionUpdateCapture onKeyDownCapture onKeyPressCapture onKeyUpCapture onFocusCapture onBlurCapture onChangeCapture onInputCapture onSubmitCapture onResetCapture onClickCapture onContextMenuCapture onDoubleClickCapture onDragCapture onDragEndCapture onDragEnterCapture onDragExitCapture onDragLeaveCapture onDragOverCapture onDragStartCapture onDropCapture onMouseDownCapture onMouseEnterCapture onMouseLeaveCapture onMouseMoveCapture onMouseOutCapture onMouseOverCapture onMouseUpCapture onSelectCapture onTouchCancelCapture onTouchEndCapture onTouchMoveCapture onTouchStartCapture onScrollCapture onWheelCapture onAbortCapture onCanPlayCapture onCanPlayThroughCapture onDurationChangeCapture onEmptiedCapture onEncryptedCapture onEndedCapture onErrorCapture onLoadedDataCapture onLoadedMetadataCapture onLoadStartCapture onPauseCapture onPlayCapture onPlayingCapture onProgressCapture onRateChangeCapture onSeekedCapture onSeekingCapture onStalledCapture onSuspendCapture onTimeUpdateCapture onVolumeChangeCapture onWaitingCapture onLoadCapture onAnimationStartCapture onAnimationEndCapture onAnimationIterationCapture onTransitionEndCapture accept acceptCharset accessKey action allowFullScreen allowTransparency alt as async autoComplete autoPlay capture cellPadding cellSpacing charSet challenge checked cite classID className cols colSpan content contentEditable contextMenu controlsList controls coords crossOrigin data dateTime default defer dir disabled download draggable encType form formAction formEncType formMethod formNoValidate formTarget frameBorder headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media mediaGroup method min minLength multiple muted name nonce noValidate open optimum pattern placeholder playsInline poster preload profile radioGroup readOnly referrerPolicy rel required reversed role rows rowSpan sandbox scope scoped scrolling seamless selected shape size sizes span spellCheck src srcDoc srcLang srcSet start step style summary tabIndex target title type useMap value width wmode wrap about datatype inlist prefix property resource typeof vocab autoCapitalize autoCorrect autoSave color itemProp itemScope itemType itemID itemRef results security unselectable accentHeight accumulate additive alignmentBaseline allowReorder alphabetic amplitude arabicForm ascent attributeName attributeType autoReverse azimuth baseFrequency baseProfile baselineShift bbox begin bias by calcMode capHeight clip clipPath clipRule clipPathUnits colorInterpolation colorInterpolationFilters colorProfile colorRendering contentScriptType contentStyleType cursor cx cy d decelerate descent diffuseConstant direction display divisor dominantBaseline dur dx dy edgeMode elevation enableBackground end exponent externalResourcesRequired fill fillOpacity fillRule filter filterRes filterUnits floodColor floodOpacity focusable fontFamily fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontWeight format from fx fy g1 g2 glyphName glyphOrientationHorizontal glyphOrientationVertical glyphRef gradientTransform gradientUnits hanging horizAdvX horizOriginX ideographic imageRendering in in2 intercept k k1 k2 k3 k4 kernelMatrix kernelUnitLength kerning keyPoints keySplines keyTimes lengthAdjust letterSpacing lightingColor limitingConeAngle local markerEnd markerMid markerStart markerHeight markerUnits markerWidth mask maskContentUnits maskUnits mathematical mode numOctaves offset opacity operator order orient orientation origin overflow overlinePosition overlineThickness paintOrder panose1 pathLength patternContentUnits patternTransform patternUnits pointerEvents points pointsAtX pointsAtY pointsAtZ preserveAlpha preserveAspectRatio primitiveUnits r radius refX refY renderingIntent repeatCount repeatDur requiredExtensions requiredFeatures restart result rotate rx ry scale seed shapeRendering slope spacing specularConstant specularExponent speed spreadMethod startOffset stdDeviation stemh stemv stitchTiles stopColor stopOpacity strikethroughPosition strikethroughThickness string stroke strokeDasharray strokeDashoffset strokeLinecap strokeLinejoin strokeMiterlimit strokeOpacity strokeWidth surfaceScale systemLanguage tableValues targetX targetY textAnchor textDecoration textRendering textLength to transform u1 u2 underlinePosition underlineThickness unicode unicodeBidi unicodeRange unitsPerEm vAlphabetic vHanging vIdeographic vMathematical values vectorEffect version vertAdvY vertOriginX vertOriginY viewBox viewTarget visibility widths wordSpacing writingMode x xHeight x1 x2 xChannelSelector xlinkActuate xlinkArcrole xlinkHref xlinkRole xlinkShow xlinkTitle xlinkType xmlBase xmlns xmlnsXlink xmlLang xmlSpace y y1 y2 yChannelSelector z zoomAndPan onPointerDown onPointerMove onPointerUp onPointerCancel onGotPointerCapture onLostPointerCapture onPointerEnter onPointerLeave onPointerOver onPointerOut class for autofocus
*/
/* eslint-enable max-len */

var ATTRIBUTE_REGEX = /^((?:s(?:uppressContentEditableWarn|croll|pac)|(?:shape|image|text)Render|(?:letter|word)Spac|vHang|hang)ing|(?:on(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:Animation|Touch|Load|Drag)Start|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|Lo(?:stPointer|ad)|TimeUpdate|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|GotPointer|MouseDown|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|KeyPress|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|P(?:rogress|laying)|DragEnd|Key(?:Down|Up)|(?:MouseU|Dro)p|(?:Wait|Seek)ing|Scroll|Focus|Paste|Abort|Drag|Play|Blur)Captur|alignmentBaselin|(?:limitingConeAng|xlink(?:(?:Arcr|R)o|Tit)|s(?:urfaceSca|ty|ca)|unselectab|baseProfi|fontSty|(?:focus|dragg)ab|multip|profi|tit)l|d(?:ominantBaselin|efaultValu)|onPointerLeav|a(?:uto(?:Capitaliz|Revers|Sav)|dditiv)|(?:(?:formNoValid|xlinkActu|noValid|accumul|rot)a|autoComple|decelera)t|(?:(?:attribute|item)T|datat)yp|onPointerMov|(?:attribute|glyph)Nam|playsInlin|(?:writing|input|edge)Mod|(?:formE|e)ncTyp|(?:amplitu|mo)d|(?:xlinkTy|itemSco|keyTy|slo)p|(?:xmlSpa|non)c|fillRul|(?:dateTi|na)m|r(?:esourc|ol)|xmlBas|wmod)e|(?:glyphOrientationHorizont|loc)al|(?:externalResourcesRequir|select|revers|mut)ed|c(?:o(?:lorInterpolationFilter|ord)s|o(?:lor(?:Interpolation)?|nt(?:rols|ent))|(?:ontentS(?:cript|tyle)Typ|o(?:ntentEditab|lorProfi)l|l(?:assNam|ipRul)|a(?:lcMod|ptur)|it)e|olorRendering|l(?:ipPathUnits|assID)|(?:ontrolsLis|apHeigh)t|h(?:eckedLink|a(?:llenge|rSet)|ildren|ecked)|ell(?:Spac|Padd)ing|o(?:ntextMenu|ls)|(?:rossOrigi|olSpa)n|l(?:ip(?:Path)?|ass)|ursor|[xy])|glyphOrientationVertical|d(?:angerouslySetInnerHTML|efaultChecked|ownload|isabled|isplay|[xy])|(?:s(?:trikethroughThickn|eaml)es|(?:und|ov)erlineThicknes|r(?:equiredExtension|adiu)|(?:requiredFeatur|tableValu|stitchTil|numOctav|filterR)e|key(?:(?:Splin|Tim)e|Param)|auto[Ff]ocu|header|bia)s|(?:(?:st(?:rikethroughPosi|dDevia)|(?:und|ov)erlinePosi|(?:textDecor|elev)a|orienta)tio|(?:strokeLinejo|orig)i|on(?:PointerDow|FocusI)|formActio|zoomAndPa|directio|(?:vers|act)io|rowSpa|begi|ico)n|o(?:n(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:Animation|Touch|Load|Drag)Start|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|TimeUpdate|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|MouseDown|P(?:rogress|laying)|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|KeyPress|DragEnd|Key(?:Down|Up)|(?:Wait|Seek)ing|(?:MouseU|Dro)p|Scroll|Paste|Focus|Abort|Drag|Play|Load|Blur)|rient)|p(?:reserveA(?:spectRatio|lpha)|ointsAt[X-Z]|anose1)|(?:patternContent|ma(?:sk(?:Content)?|rker)|primitive|gradient|pattern|filter)Units|(?:(?:allowTranspar|baseFrequ)enc|re(?:ferrerPolic|adOnl)|(?:(?:st(?:roke|op)O|floodO|fillO|o)pac|integr|secur)it|visibilit|fontFamil|accessKe|propert|summar)y|(?:gradientT|patternT|t)ransform|(?:[xy]ChannelSelect|lightingCol|textAnch|floodCol|stopCol|operat|htmlF)or|(?:strokeMiterlimi|(?:specularConsta|repeatCou|fontVaria)n|(?:(?:specularE|e)xpon|renderingInt|asc)en|d(?:iffuseConsta|esce)n|(?:fontSizeAdju|lengthAdju|manife)s|baselineShif|onPointerOu|vectorEffec|(?:(?:mar(?:ker|gin)|x)H|accentH|fontW)eigh|markerStar|a(?:utoCorrec|bou)|onFocusOu|intercep|restar|forma|inlis|heigh|lis)t|(?:(?:st(?:rokeDasho|artO)|o)ffs|acceptChars|formTarg|viewTarg|srcS)et|k(?:ernel(?:UnitLength|Matrix)|[1-4])|(?:(?:enableBackgrou|markerE)n|s(?:p(?:readMetho|ee)|ee)|formMetho|(?:markerM|onInval)i|preloa|metho|kin)d|strokeDasharray|(?:onPointerCanc|lab)el|(?:allowFullScre|hidd)en|systemLanguage|(?:(?:o(?:nPointer(?:Ent|Ov)|rd)|allowReord|placehold|frameBord|paintOrd|post)e|repeatDu|d(?:efe|u))r|v(?:Mathematical|ert(?:Origin[XY]|AdvY)|alues|ocab)|(?:pointerEve|keyPoi)nts|(?:strokeLineca|onPointerU|itemPro|useMa|wra|loo)p|h(?:oriz(?:Origin|Adv)X|ttpEquiv)|(?:vI|i)deographic|unicodeRange|mathematical|vAlphabetic|u(?:nicodeBidi|[12])|(?:fontStretc|hig)h|(?:(?:mar(?:ker|gin)W|strokeW)id|azimu)th|(?:xmlnsXl|valueL)ink|mediaGroup|spellCheck|(?:text|m(?:in|ax))Length|(?:unitsPerE|optimu|fro)m|r(?:adioGroup|e(?:sults|f[XY]|l)|ows|[xy])|a(?:rabicForm|l(?:phabetic|t)|sync)|pathLength|innerHTML|xlinkShow|(?:xlinkHr|glyphR)ef|(?:tabInde|(?:sand|b)bo|viewBo)x|(?:(?:href|xml|src)La|kerni)ng|autoPlay|o(?:verflow|pen)|f(?:o(?:ntSize|rm?)|il(?:ter|l))|r(?:e(?:quired|sult|f))?|divisor|p(?:attern|oints)|unicode|d(?:efault|ata|ir)?|i(?:temRef|n2|s)|t(?:arget[XY]|o)|srcDoc|s(?:coped|te(?:m[hv]|p)|pan)|(?:width|size)s|prefix|typeof|itemID|s(?:t(?:roke|art)|hape|cope|rc)|t(?:arget|ype)|(?:stri|la)ng|a(?:ccept|s)|m(?:edia|a(?:sk|x)|in)|x(?:mlns)?|width|value|size|href|k(?:ey)?|end|low|by|i[dn]|y[12]|g[12]|x[12]|f[xy]|[yz])$/;

/* From DOMProperty */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
var isCustomAttribute = RegExp.prototype.test.bind(new RegExp('^(x|data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'));

var validAttr = (function (name) {
  return ATTRIBUTE_REGEX.test(name) || isCustomAttribute(name.toLowerCase());
});

// 

function hasInInheritanceChain(child, parent) {
  var target = child;

  while (target) {
    target = Object.getPrototypeOf(target);

    if (target && target === parent) {
      return true;
    }
  }

  return false;
}

// 
/**
 * Creates a broadcast that can be listened to, i.e. simple event emitter
 *
 * @see https://github.com/ReactTraining/react-broadcast
 */

var createBroadcast = function createBroadcast(initialState) {
  var listeners = {};
  var id = 0;
  var state = initialState;

  function publish(nextState) {
    state = nextState;

    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (var key in listeners) {
      var listener = listeners[key];
      if (listener === undefined) {
        // eslint-disable-next-line no-continue
        continue;
      }

      listener(state);
    }
  }

  function subscribe(listener) {
    var currentId = id;
    listeners[currentId] = listener;
    id += 1;
    listener(state);
    return currentId;
  }

  function unsubscribe(unsubID) {
    listeners[unsubID] = undefined;
  }

  return { publish: publish, subscribe: subscribe, unsubscribe: unsubscribe };
};

var _contextShape, _ThemeProvider$contex;

// NOTE: DO NOT CHANGE, changing this is a semver major change!
var CHANNEL = '__styled-components__';
var CHANNEL_NEXT = CHANNEL + 'next__';

var CONTEXT_CHANNEL_SHAPE = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
  getTheme: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  subscribe: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  unsubscribe: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
});

var contextShape = (_contextShape = {}, _contextShape[CHANNEL] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, _contextShape[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _contextShape);

var warnChannelDeprecated = void 0;
if (false) {
  warnChannelDeprecated = once(function () {
    // eslint-disable-next-line no-console
    console.warn('Warning: Usage of `context.' + CHANNEL + '` as a function is deprecated. It will be replaced with the object on `.context.' + CHANNEL_NEXT + '` in a future version.');
  });
}

var isFunction = function isFunction(test) {
  return typeof test === 'function';
};

/**
 * Provide a theme to an entire react component tree via context and event listeners (have to do
 * both context and event emitter as pure components block context updates)
 */

var ThemeProvider = function (_Component) {
  inherits(ThemeProvider, _Component);

  function ThemeProvider() {
    classCallCheck(this, ThemeProvider);

    var _this = possibleConstructorReturn(this, _Component.call(this));

    _this.unsubscribeToOuterId = -1;

    _this.getTheme = _this.getTheme.bind(_this);
    return _this;
  }

  ThemeProvider.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    // If there is a ThemeProvider wrapper anywhere around this theme provider, merge this theme
    // with the outer theme
    var outerContext = this.context[CHANNEL_NEXT];
    if (outerContext !== undefined) {
      this.unsubscribeToOuterId = outerContext.subscribe(function (theme) {
        _this2.outerTheme = theme;

        if (_this2.broadcast !== undefined) {
          _this2.publish(_this2.props.theme);
        }
      });
    }

    this.broadcast = createBroadcast(this.getTheme());
  };

  ThemeProvider.prototype.getChildContext = function getChildContext() {
    var _this3 = this,
        _babelHelpers$extends;

    return _extends({}, this.context, (_babelHelpers$extends = {}, _babelHelpers$extends[CHANNEL_NEXT] = {
      getTheme: this.getTheme,
      subscribe: this.broadcast.subscribe,
      unsubscribe: this.broadcast.unsubscribe
    }, _babelHelpers$extends[CHANNEL] = function (subscriber) {
      if (false) {
        warnChannelDeprecated();
      }

      // Patch the old `subscribe` provide via `CHANNEL` for older clients.
      var unsubscribeId = _this3.broadcast.subscribe(subscriber);
      return function () {
        return _this3.broadcast.unsubscribe(unsubscribeId);
      };
    }, _babelHelpers$extends));
  };

  ThemeProvider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.theme !== nextProps.theme) {
      this.publish(nextProps.theme);
    }
  };

  ThemeProvider.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.unsubscribeToOuterId !== -1) {
      this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeToOuterId);
    }
  };

  // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation


  ThemeProvider.prototype.getTheme = function getTheme(passedTheme) {
    var theme = passedTheme || this.props.theme;

    if (isFunction(theme)) {
      var mergedTheme = theme(this.outerTheme);

      if (false) {
        throw new StyledComponentsError(7);
      }

      return mergedTheme;
    }

    if (theme === null || Array.isArray(theme) || (typeof theme === 'undefined' ? 'undefined' : _typeof(theme)) !== 'object') {
      throw new StyledComponentsError(8);
    }

    return _extends({}, this.outerTheme, theme);
  };

  ThemeProvider.prototype.publish = function publish(theme) {
    this.broadcast.publish(this.getTheme(theme));
  };

  ThemeProvider.prototype.render = function render() {
    if (!this.props.children) {
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.only(this.props.children);
  };

  return ThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

ThemeProvider.childContextTypes = contextShape;
ThemeProvider.contextTypes = (_ThemeProvider$contex = {}, _ThemeProvider$contex[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _ThemeProvider$contex);

var _babelHelpers$extends;

// HACK for generating all static styles without needing to allocate
// an empty execution context every single time...
var STATIC_EXECUTION_CONTEXT = {};

var modifiedContextShape = _extends({}, contextShape, (_babelHelpers$extends = {}, _babelHelpers$extends[CONTEXT_KEY] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(StyleSheet), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(ServerStyleSheet)]), _babelHelpers$extends));

var identifiers = {};

/* We depend on components having unique IDs */
var generateId = function generateId(ComponentStyle, _displayName, parentComponentId) {
  var displayName = typeof _displayName !== 'string' ? 'sc' : escape(_displayName);

  /**
   * This ensures uniqueness if two components happen to share
   * the same displayName.
   */
  var nr = (identifiers[displayName] || 0) + 1;
  identifiers[displayName] = nr;

  var componentId = displayName + '-' + ComponentStyle.generateName(displayName + nr);

  return parentComponentId !== undefined ? parentComponentId + '-' + componentId : componentId;
};

var warnExtendDeprecated = function warnExtendDeprecated() {};
if (false) {
  warnExtendDeprecated = once(function () {
    // eslint-disable-next-line no-console
    console.warn('Warning: The "extend" API will be removed in the upcoming v4.0 release. Use styled(StyledComponent) instead. You can find more information here: https://github.com/styled-components/styled-components/issues/1546');
  });
}

// $FlowFixMe

var BaseStyledComponent = function (_Component) {
  inherits(BaseStyledComponent, _Component);

  function BaseStyledComponent() {
    var _temp, _this, _ret;

    classCallCheck(this, BaseStyledComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.attrs = {}, _this.state = {
      theme: null,
      generatedClassName: ''
    }, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
  }

  BaseStyledComponent.prototype.unsubscribeFromContext = function unsubscribeFromContext() {
    if (this.unsubscribeId !== -1) {
      this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
    }
  };

  BaseStyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props) {
    var attrs = this.constructor.attrs;

    var context = _extends({}, props, { theme: theme });
    if (attrs === undefined) {
      return context;
    }

    this.attrs = Object.keys(attrs).reduce(function (acc, key) {
      var attr = attrs[key];

      // eslint-disable-next-line no-param-reassign
      acc[key] = typeof attr === 'function' && !hasInInheritanceChain(attr, __WEBPACK_IMPORTED_MODULE_1_react__["Component"]) ? attr(context) : attr;
      return acc;
    }, {});

    return _extends({}, context, this.attrs);
  };

  BaseStyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
    var _constructor = this.constructor,
        attrs = _constructor.attrs,
        componentStyle = _constructor.componentStyle,
        warnTooManyClasses = _constructor.warnTooManyClasses;

    var styleSheet = this.context[CONTEXT_KEY] || StyleSheet.master;

    // statically styled-components don't need to build an execution context object,
    // and shouldn't be increasing the number of class names
    if (componentStyle.isStatic && attrs === undefined) {
      return componentStyle.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, styleSheet);
    } else {
      var executionContext = this.buildExecutionContext(theme, props);
      var className = componentStyle.generateAndInjectStyles(executionContext, styleSheet);

      if (false) {
        warnTooManyClasses(className);
      }

      return className;
    }
  };

  BaseStyledComponent.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var componentStyle = this.constructor.componentStyle;

    var styledContext = this.context[CHANNEL_NEXT];

    // If this is a statically-styled component, we don't need to the theme
    // to generate or build styles.
    if (componentStyle.isStatic) {
      var generatedClassName = this.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, this.props);
      this.setState({ generatedClassName: generatedClassName });
      // If there is a theme in the context, subscribe to the event emitter. This
      // is necessary due to pure components blocking context updates, this circumvents
      // that by updating when an event is emitted
    } else if (styledContext !== undefined) {
      var subscribe = styledContext.subscribe;

      this.unsubscribeId = subscribe(function (nextTheme) {
        // This will be called once immediately
        var theme = determineTheme(_this2.props, nextTheme, _this2.constructor.defaultProps);

        var generatedClassName = _this2.generateAndInjectStyles(theme, _this2.props);

        _this2.setState({ theme: theme, generatedClassName: generatedClassName });
      });
    } else {
      // eslint-disable-next-line react/prop-types
      var theme = this.props.theme || EMPTY_OBJECT;
      var _generatedClassName = this.generateAndInjectStyles(theme, this.props);
      this.setState({ theme: theme, generatedClassName: _generatedClassName });
    }
  };

  BaseStyledComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this3 = this;

    // If this is a statically-styled component, we don't need to listen to
    // props changes to update styles
    var componentStyle = this.constructor.componentStyle;

    if (componentStyle.isStatic) {
      return;
    }

    this.setState(function (prevState) {
      var theme = determineTheme(nextProps, prevState.theme, _this3.constructor.defaultProps);
      var generatedClassName = _this3.generateAndInjectStyles(theme, nextProps);

      return { theme: theme, generatedClassName: generatedClassName };
    });
  };

  BaseStyledComponent.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unsubscribeFromContext();
  };

  BaseStyledComponent.prototype.render = function render() {
    // eslint-disable-next-line react/prop-types
    var innerRef = this.props.innerRef;
    var generatedClassName = this.state.generatedClassName;
    var _constructor2 = this.constructor,
        styledComponentId = _constructor2.styledComponentId,
        target = _constructor2.target;


    var isTargetTag = isTag(target);

    var className = [
    // eslint-disable-next-line react/prop-types
    this.props.className, styledComponentId, this.attrs.className, generatedClassName].filter(Boolean).join(' ');

    var baseProps = _extends({}, this.attrs, {
      className: className
    });

    if (isStyledComponent(target)) {
      baseProps.innerRef = innerRef;
    } else {
      baseProps.ref = innerRef;
    }

    var propsForElement = baseProps;
    var key = void 0;

    for (key in this.props) {
      // Don't pass through non HTML tags through to HTML elements
      // always omit innerRef
      if (key !== 'innerRef' && key !== 'className' && (!isTargetTag || validAttr(key))) {
        propsForElement[key] = key === 'style' && key in this.attrs ? _extends({}, this.attrs[key], this.props[key]) : this.props[key];
      }
    }

    return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(target, propsForElement);
  };

  return BaseStyledComponent;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var _StyledComponent = (function (ComponentStyle, constructWithOptions) {
  var createStyledComponent = function createStyledComponent(target, options, rules) {
    var _options$isClass = options.isClass,
        isClass = _options$isClass === undefined ? !isTag(target) : _options$isClass,
        _options$displayName = options.displayName,
        displayName = _options$displayName === undefined ? generateDisplayName(target) : _options$displayName,
        _options$componentId = options.componentId,
        componentId = _options$componentId === undefined ? generateId(ComponentStyle, options.displayName, options.parentComponentId) : _options$componentId,
        _options$ParentCompon = options.ParentComponent,
        ParentComponent = _options$ParentCompon === undefined ? BaseStyledComponent : _options$ParentCompon,
        extendingRules = options.rules,
        attrs = options.attrs;


    var styledComponentId = options.displayName && options.componentId ? escape(options.displayName) + '-' + options.componentId : options.componentId || componentId;

    var componentStyle = new ComponentStyle(extendingRules === undefined ? rules : extendingRules.concat(rules), attrs, styledComponentId);

    var StyledComponent = function (_ParentComponent) {
      inherits(StyledComponent, _ParentComponent);

      function StyledComponent() {
        classCallCheck(this, StyledComponent);
        return possibleConstructorReturn(this, _ParentComponent.apply(this, arguments));
      }

      StyledComponent.withComponent = function withComponent(tag) {
        var previousComponentId = options.componentId,
            optionsToCopy = objectWithoutProperties(options, ['componentId']);


        var newComponentId = previousComponentId && previousComponentId + '-' + (isTag(tag) ? tag : escape(getComponentName(tag)));

        var newOptions = _extends({}, optionsToCopy, {
          componentId: newComponentId,
          ParentComponent: StyledComponent
        });

        return createStyledComponent(tag, newOptions, rules);
      };

      createClass(StyledComponent, null, [{
        key: 'extend',
        get: function get$$1() {
          var rulesFromOptions = options.rules,
              parentComponentId = options.componentId,
              optionsToCopy = objectWithoutProperties(options, ['rules', 'componentId']);


          var newRules = rulesFromOptions === undefined ? rules : rulesFromOptions.concat(rules);

          var newOptions = _extends({}, optionsToCopy, {
            rules: newRules,
            parentComponentId: parentComponentId,
            ParentComponent: StyledComponent
          });

          warnExtendDeprecated();

          return constructWithOptions(createStyledComponent, target, newOptions);
        }
      }]);
      return StyledComponent;
    }(ParentComponent);

    StyledComponent.attrs = attrs;
    StyledComponent.componentStyle = componentStyle;
    StyledComponent.contextTypes = modifiedContextShape;
    StyledComponent.displayName = displayName;
    StyledComponent.styledComponentId = styledComponentId;
    StyledComponent.target = target;


    if (false) {
      StyledComponent.warnTooManyClasses = createWarnTooManyClasses(displayName);
    }

    if (isClass) {
      __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(StyledComponent, target, {
        // all SC-specific things should not be hoisted
        attrs: true,
        componentStyle: true,
        displayName: true,
        extend: true,
        styledComponentId: true,
        target: true,
        warnTooManyClasses: true,
        withComponent: true
      });
    }

    return StyledComponent;
  };

  return createStyledComponent;
});

// Source: https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash(str) {
  var l = str.length | 0,
      h = l | 0,
      i = 0,
      k;

  while (l >= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;

    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    k ^= k >>> 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);

    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;

    l -= 4;
    ++i;
  }

  switch (l) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  }

  h ^= h >>> 13;
  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  h ^= h >>> 15;

  return h >>> 0;
}

// 

var areStylesCacheable = IS_BROWSER;

var isStaticRules = function isStaticRules(rules, attrs) {
  for (var i = 0, len = rules.length; i < len; i += 1) {
    var rule = rules[i];

    // recursive case
    if (Array.isArray(rule) && !isStaticRules(rule)) {
      return false;
    } else if (typeof rule === 'function' && !isStyledComponent(rule)) {
      // functions are allowed to be static if they're just being
      // used to get the classname of a nested styled component
      return false;
    }
  }

  if (attrs !== undefined) {
    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (var key in attrs) {
      if (typeof attrs[key] === 'function') {
        return false;
      }
    }
  }

  return true;
};

var isHMREnabled = typeof module !== 'undefined' && module.hot && "production" !== 'production';

/*
 ComponentStyle is all the CSS-specific stuff, not
 the React-specific stuff.
 */
var _ComponentStyle = (function (nameGenerator, flatten, stringifyRules) {
  /* combines hashStr (murmurhash) and nameGenerator for convenience */
  var generateRuleHash = function generateRuleHash(str) {
    return nameGenerator(murmurhash(str));
  };

  var ComponentStyle = function () {
    function ComponentStyle(rules, attrs, componentId) {
      classCallCheck(this, ComponentStyle);

      this.rules = rules;
      this.isStatic = !isHMREnabled && isStaticRules(rules, attrs);
      this.componentId = componentId;

      if (!StyleSheet.master.hasId(componentId)) {
        var placeholder =  false ? ['.' + componentId + ' {}'] : [];

        StyleSheet.master.deferredInject(componentId, placeholder);
      }
    }

    /*
     * Flattens a rule set into valid CSS
     * Hashes it, wraps the whole chunk in a .hash1234 {}
     * Returns the hash to be injected on render()
     * */


    ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
      var isStatic = this.isStatic,
          componentId = this.componentId,
          lastClassName = this.lastClassName;

      if (areStylesCacheable && isStatic && lastClassName !== undefined && styleSheet.hasNameForId(componentId, lastClassName)) {
        return lastClassName;
      }

      var flatCSS = flatten(this.rules, executionContext);
      var name = generateRuleHash(this.componentId + flatCSS.join(''));

      if (!styleSheet.hasNameForId(componentId, name)) {
        styleSheet.inject(this.componentId, stringifyRules(flatCSS, '.' + name), name);
      }

      this.lastClassName = name;
      return name;
    };

    ComponentStyle.generateName = function generateName(str) {
      return generateRuleHash(str);
    };

    return ComponentStyle;
  }();

  return ComponentStyle;
});

// 
// Thanks to ReactDOMFactories for this handy list!

var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',

// SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

// 

var _styled = (function (styledComponent, constructWithOptions) {
  var styled = function styled(tag) {
    return constructWithOptions(styledComponent, tag);
  };

  // Shorthands for all valid HTML Elements
  domElements.forEach(function (domElement) {
    styled[domElement] = styled(domElement);
  });

  return styled;
});

// 

var replaceWhitespace = function replaceWhitespace(str) {
  return str.replace(/\s|\\n/g, '');
};

var _keyframes = (function (nameGenerator, stringifyRules, css) {
  return function () {
    var styleSheet = StyleSheet.master;
    var rules = css.apply(undefined, arguments);
    var name = nameGenerator(murmurhash(replaceWhitespace(JSON.stringify(rules))));
    var id = 'sc-keyframes-' + name;

    if (!styleSheet.hasNameForId(id, name)) {
      styleSheet.inject(id, stringifyRules(rules, name, '@keyframes'), name);
    }

    return name;
  };
});

// 

var _injectGlobal = (function (stringifyRules, css) {
  var injectGlobal = function injectGlobal() {
    var styleSheet = StyleSheet.master;
    var rules = css.apply(undefined, arguments);
    var hash = murmurhash(JSON.stringify(rules));
    var id = 'sc-global-' + hash;

    if (!styleSheet.hasId(id)) {
      styleSheet.inject(id, stringifyRules(rules));
    }
  };

  return injectGlobal;
});

// 

var _constructWithOptions = (function (css) {
  var constructWithOptions = function constructWithOptions(componentConstructor, tag) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;

    if (!Object(__WEBPACK_IMPORTED_MODULE_6_react_is__["isValidElementType"])(tag)) {
      throw new StyledComponentsError(1, String(tag));
    }

    /* This is callable directly as a template function */
    // $FlowFixMe: Not typed to avoid destructuring arguments
    var templateFunction = function templateFunction() {
      return componentConstructor(tag, options, css.apply(undefined, arguments));
    };

    /* If config methods are called, wrap up a new template function and merge options */
    templateFunction.withConfig = function (config) {
      return constructWithOptions(componentConstructor, tag, _extends({}, options, config));
    };
    templateFunction.attrs = function (attrs) {
      return constructWithOptions(componentConstructor, tag, _extends({}, options, {
        attrs: _extends({}, options.attrs || EMPTY_OBJECT, attrs)
      }));
    };

    return templateFunction;
  };

  return constructWithOptions;
});

// 

var withTheme = (function (Component$$1) {
  var isStatelessFunctionalComponent = typeof Component$$1 === 'function' &&
  // $FlowFixMe TODO: flow for prototype
  !(Component$$1.prototype && 'isReactComponent' in Component$$1.prototype);

  // NOTE: We can't pass a ref to a stateless functional component
  var shouldSetInnerRef = isStyledComponent(Component$$1) || isStatelessFunctionalComponent;

  var WithTheme = function (_React$Component) {
    inherits(WithTheme, _React$Component);

    function WithTheme() {
      var _temp, _this, _ret;

      classCallCheck(this, WithTheme);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = EMPTY_OBJECT, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
    }

    // NOTE: This is so that isStyledComponent passes for the innerRef unwrapping


    WithTheme.prototype.componentWillMount = function componentWillMount() {
      var _this2 = this;

      var defaultProps = this.constructor.defaultProps;

      var styledContext = this.context[CHANNEL_NEXT];
      var themeProp = determineTheme(this.props, undefined, defaultProps);
      if (styledContext === undefined && themeProp === undefined && "production" !== 'production') {
        // eslint-disable-next-line no-console
        console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps');
      } else if (styledContext === undefined && themeProp !== undefined) {
        this.setState({ theme: themeProp });
      } else {
        var subscribe = styledContext.subscribe;

        this.unsubscribeId = subscribe(function (nextTheme) {
          var theme = determineTheme(_this2.props, nextTheme, defaultProps);
          _this2.setState({ theme: theme });
        });
      }
    };

    WithTheme.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var defaultProps = this.constructor.defaultProps;

      this.setState(function (oldState) {
        var theme = determineTheme(nextProps, oldState.theme, defaultProps);

        return { theme: theme };
      });
    };

    WithTheme.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.unsubscribeId !== -1) {
        this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
      }
    };

    WithTheme.prototype.render = function render() {
      var props = _extends({
        theme: this.state.theme
      }, this.props);

      if (!shouldSetInnerRef) {
        props.ref = props.innerRef;
        delete props.innerRef;
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Component$$1, props);
    };

    return WithTheme;
  }(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

  WithTheme.contextTypes = contextShape;
  WithTheme.displayName = 'WithTheme(' + getComponentName(Component$$1) + ')';
  WithTheme.styledComponentId = 'withTheme';


  return __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(WithTheme, Component$$1);
});

// 

/* eslint-disable */
var __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS = {
  StyleSheet: StyleSheet
};

// 

/* Warning if you've imported this file on React Native */
if (false) {
  // eslint-disable-next-line no-console
  console.warn("It looks like you've imported 'styled-components' on React Native.\n" + "Perhaps you're looking to import 'styled-components/native'?\n" + 'Read more about this at https://www.styled-components.com/docs/basics#react-native');
}

/* Warning if there are several instances of styled-components */
if (false) {
  window['__styled-components-init__'] = window['__styled-components-init__'] || 0;

  if (window['__styled-components-init__'] === 1) {
    // eslint-disable-next-line no-console
    console.warn("It looks like there are several instances of 'styled-components' initialized in this application. " + 'This may cause dynamic styles not rendering properly, errors happening during rehydration process ' + 'and makes your application bigger without a good reason.\n\n' + 'See https://s-c.sh/2BAXzed for more info.');
  }

  window['__styled-components-init__'] += 1;
}

/* Instantiate singletons */
var ComponentStyle = _ComponentStyle(generateAlphabeticName, flatten, stringifyRules);
var constructWithOptions = _constructWithOptions(css);
var StyledComponent = _StyledComponent(ComponentStyle, constructWithOptions);

/* Instantiate exported singletons */
var keyframes = _keyframes(generateAlphabeticName, stringifyRules, css);
var injectGlobal = _injectGlobal(stringifyRules, css);
var styled = _styled(StyledComponent, constructWithOptions);

/* harmony default export */ __webpack_exports__["default"] = (styled);

//# sourceMappingURL=styled-components.browser.esm.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(215), __webpack_require__(438)(module)))

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(205);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(381), __esModule: true };

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(17);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(402);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(406);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(17);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperties = __webpack_require__(432);

var _defineProperties2 = _interopRequireDefault(_defineProperties);

var _freeze = __webpack_require__(435);

var _freeze2 = _interopRequireDefault(_freeze);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (strings, raw) {
  return (0, _freeze2.default)((0, _defineProperties2.default)(strings, {
    raw: {
      value: (0, _freeze2.default)(raw)
    }
  }));
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(45);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(346)();
}


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return gridSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return layout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return globalItemSizes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return containerTitleBottomMargin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return containerTitleHorizontalPadding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return containerTitleIconSpacing; });
/* unused harmony export drawerOffset */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return drawerContainerHeaderAnimationSpeed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return globalOpenWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return containerClosedWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return containerOpenWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return standardOpenWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return resizeClosedBreakpoint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return drawerIconOffset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return animationTimeUnitless; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return animationTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return resizeAnimationTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return zIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return unthemedColors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return scrollBarSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return scrollHintHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return scrollHintSpacing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return globalPrimaryActions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return globalSecondaryActions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return resizerClickableWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return resizerVisibleWidth; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_util_shared_styles__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_util_shared_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__atlaskit_util_shared_styles__);



/**
 * NOTE: changing the width of the Navigation is considered a breaking change
 */

var gridSize = Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["d" /* gridSize */])();

var defaultClosedWidth = gridSize * 8;

// Not using grid units here because this is a macOS-specific value and is not
// related to the ADG 3 grid.
var extraElectronGlobalNavWidth = 4;

var layout = {
  padding: {
    top: gridSize * 2,
    bottom: gridSize * 2,
    side: gridSize
  },
  width: {
    closed: {
      default: defaultClosedWidth,
      electron: defaultClosedWidth + extraElectronGlobalNavWidth
    }
  }
};

var globalItemSizes = {
  small: gridSize * 4,
  medium: gridSize * 5,
  large: gridSize * 6
};

var containerTitleBottomMargin = gridSize;
var containerTitleHorizontalPadding = gridSize / 2;
var containerTitleIconSpacing = gridSize;

var drawerOffset = gridSize * 2;
var drawerContainerHeaderAnimationSpeed = '220ms';
var globalOpenWidth = function globalOpenWidth() {
  var isElectron = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return layout.width.closed[isElectron ? 'electron' : 'default'];
};
var containerClosedWidth = function containerClosedWidth() {
  var isElectron = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return globalOpenWidth(isElectron);
};
var containerOpenWidth = 240;
var standardOpenWidth = function standardOpenWidth() {
  var isElectron = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return globalOpenWidth(isElectron) + containerOpenWidth;
};
var resizeClosedBreakpoint = function resizeClosedBreakpoint() {
  var isElectron = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return globalOpenWidth(isElectron) + containerOpenWidth / 2;
};
var drawerIconOffset = 80;
var animationTimeUnitless = 200;
var animationTime = animationTimeUnitless + 'ms';
var resizeAnimationTime = animationTime;
var zIndex = {
  base: __WEBPACK_IMPORTED_MODULE_1__atlaskit_util_shared_styles__["akZIndexNavigation"],
  // needs to sit on top of navigation and the drawer
  drawer: __WEBPACK_IMPORTED_MODULE_1__atlaskit_util_shared_styles__["akZIndexBlanket"] + 1
};

// these are colors that are currently not controllable via theming
var unthemedColors = {
  resizer: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["a" /* colors */].B100, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["a" /* colors */].B100 }),
  presenceIconBg: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["a" /* colors */].N0
};

var scrollBarSize = gridSize;

var scrollHintHeight = 2;
var scrollHintSpacing = gridSize * 2;

var globalPrimaryActions = function () {
  var itemSizes = {
    medium: gridSize * 5
  };

  var margin = {
    bottom: gridSize * 2
  };

  var height = function height(actionCount) {
    var innerHeight = itemSizes.medium * (actionCount + 1) + gridSize * 2;
    return {
      inner: innerHeight,
      outer: gridSize + margin.bottom + innerHeight
    };
  };

  return {
    height: height,
    margin: margin,
    itemSizes: itemSizes
  };
}();

var globalSecondaryActions = function () {
  var itemSizes = {
    medium: gridSize * 5
  };

  var margin = {
    bottom: gridSize * 2
  };

  var height = function height(actionCount) {
    var innerHeight = itemSizes.medium * actionCount;
    return {
      inner: innerHeight,
      outer: margin.bottom + innerHeight
    };
  };

  return {
    height: height,
    margin: margin,
    itemSizes: itemSizes
  };
}();

var resizerClickableWidth = gridSize * 2;
var resizerVisibleWidth = 2;

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export prefix */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return rootKey; });
/* unused harmony export groupKey */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isDropdownOverflowKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return isElectronMacKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return electronMacTopPadding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return isElectronMac; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getProvided; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isCollapsed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return isInOverflowDropdown; });
/* unused harmony export isInCompactGroup */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return whenCollapsed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return whenNotCollapsed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return whenNotInOverflowDropdown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return whenCollapsedAndNotInOverflowDropdown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getProvidedScrollbar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defaultContainerTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return defaultGlobalTheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_has_own_property__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__presets__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__with_root_theme__ = __webpack_require__(579);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__with_root_theme__["a"]; });


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ';\n'], ['\n  ', ';\n']);







var prefix = function prefix(key) {
  return '@atlaskit-private-theme-do-not-use/navigation:' + key;
};
var rootKey = prefix('root');
var groupKey = prefix('group');
var isDropdownOverflowKey = prefix('isDropdownOverflow');
var isElectronMacKey = prefix('isElectronMac');
var electronMacTopPadding = 14;

var isElectronMac = function isElectronMac(map) {
  return map !== undefined && Object(__WEBPACK_IMPORTED_MODULE_2__utils_has_own_property__["a" /* default */])(map, isElectronMacKey) && map[isElectronMacKey];
};

var getProvided = function getProvided(map) {
  if (map !== undefined && Object(__WEBPACK_IMPORTED_MODULE_2__utils_has_own_property__["a" /* default */])(map, rootKey) && map[rootKey]) {
    return map[rootKey].provided;
  }
  return __WEBPACK_IMPORTED_MODULE_3__presets__["a" /* container */];
};
var isCollapsed = function isCollapsed(map) {
  return map[rootKey] && map[rootKey].isCollapsed;
};

var isInOverflowDropdown = function isInOverflowDropdown(map) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__utils_has_own_property__["a" /* default */])(map, isDropdownOverflowKey);
};

var isInCompactGroup = function isInCompactGroup(map) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__utils_has_own_property__["a" /* default */])(map, groupKey)) {
    return false;
  }
  return map[groupKey].isCompact;
};

var whenCollapsed = function whenCollapsed() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject, function (_ref) {
    var theme = _ref.theme;
    return isCollapsed(theme) ? __WEBPACK_IMPORTED_MODULE_1_styled_components__["css"].apply(undefined, args) : '';
  });
};

var whenNotCollapsed = function whenNotCollapsed() {
  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject, function (_ref2) {
    var theme = _ref2.theme;
    return !isCollapsed(theme) ? __WEBPACK_IMPORTED_MODULE_1_styled_components__["css"].apply(undefined, args) : '';
  });
};

var whenNotInOverflowDropdown = function whenNotInOverflowDropdown() {
  for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject, function (_ref3) {
    var theme = _ref3.theme;
    return !isInOverflowDropdown(theme) ? __WEBPACK_IMPORTED_MODULE_1_styled_components__["css"].apply(undefined, args) : '';
  });
};

var whenCollapsedAndNotInOverflowDropdown = function whenCollapsedAndNotInOverflowDropdown() {
  for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    args[_key4] = arguments[_key4];
  }

  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject, function (_ref4) {
    var theme = _ref4.theme;
    return isCollapsed(theme) && !isInOverflowDropdown(theme) ? __WEBPACK_IMPORTED_MODULE_1_styled_components__["css"].apply(undefined, args) : '';
  });
};

var getProvidedScrollbar = function getProvidedScrollbar(map) {
  if (map !== undefined && Object(__WEBPACK_IMPORTED_MODULE_2__utils_has_own_property__["a" /* default */])(map, rootKey) && map[rootKey] && map[rootKey].provided.scrollBar) {
    return map[rootKey].provided.scrollBar;
  }
  return __WEBPACK_IMPORTED_MODULE_3__presets__["a" /* container */].scrollBar;
};

// NOTE: Dark mode is a user preference that takes precedence over provided themes
var defaultContainerTheme = function defaultContainerTheme(containerTheme, mode) {
  if (containerTheme && containerTheme.hasDarkmode) {
    return containerTheme;
  }
  if (mode === 'dark') {
    return __WEBPACK_IMPORTED_MODULE_3__presets__["b" /* dark */];
  }
  return containerTheme || __WEBPACK_IMPORTED_MODULE_3__presets__["a" /* container */];
};
var defaultGlobalTheme = function defaultGlobalTheme(globalTheme, mode) {
  if (globalTheme && globalTheme.hasDarkmode) return globalTheme;
  if (mode === 'dark') {
    return __WEBPACK_IMPORTED_MODULE_3__presets__["b" /* dark */];
  }
  return globalTheme || __WEBPACK_IMPORTED_MODULE_3__presets__["c" /* global */];
};



/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(205);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(424), __esModule: true };

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Skeleton = exports.size = undefined;

var _Skeleton = __webpack_require__(430);

Object.defineProperty(exports, 'Skeleton', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Skeleton).default;
  }
});

var _Icon = __webpack_require__(445);

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Icon2.default;
exports.size = _Icon.size;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(410);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(385);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(393);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 18 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.7' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AtlasKitThemeProvider */
/* unused harmony export borderRadius */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return gridSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fontSize; });
/* unused harmony export fontFamily */
/* unused harmony export codeFontFamily */
/* unused harmony export layers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elevation__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__typography__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_math__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_getTheme__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_themed__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AtlaskitThemeProvider__ = __webpack_require__(571);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__colors__; });
/* unused harmony reexport elevation */
/* unused harmony reexport typography */
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__utils_math__; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__utils_getTheme__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__utils_themed__["a"]; });
/* unused harmony reexport AtlaskitThemeProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Appearance__ = __webpack_require__(572);
/* unused harmony reexport Appearance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Context__ = __webpack_require__(93);
/* unused harmony reexport Consumer */
/* unused harmony reexport Provider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Reset__ = __webpack_require__(573);
/* unused harmony reexport Reset */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Theme__ = __webpack_require__(574);
/* unused harmony reexport Theme */











// backwards-compatible export with old Atlaskit case
var AtlasKitThemeProvider = __WEBPACK_IMPORTED_MODULE_6__components_AtlaskitThemeProvider__["a" /* default */];

/*
  These theme values are expressed as functions so that if we decide to make
  them dependent on props in the future, it wouldn't require a significant
  refactor everywhere they are being used.
*/
var borderRadius = function borderRadius() {
  return 3;
};
var gridSize = function gridSize() {
  return 8;
};
var fontSize = function fontSize() {
  return 14;
};
var fontFamily = function fontFamily() {
  return '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif';
};
var codeFontFamily = function codeFontFamily() {
  return '"SFMono-Medium", "SF Mono", "Segoe UI Mono", "Roboto Mono", "Ubuntu Mono", Menlo, Consolas, Courier, monospace';
};

var layers = {
  card: function card() {
    return 100;
  },
  dialog: function dialog() {
    return 200;
  },
  navigation: function navigation() {
    return 300;
  },
  layer: function layer() {
    return 400;
  },
  blanket: function blanket() {
    return 500;
  },
  modal: function modal() {
    return 510;
  },
  flag: function flag() {
    return 600;
  },
  spotlight: function spotlight() {
    return 700;
  },
  tooltip: function tooltip() {
    return 800;
  }
};

// New API




/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AnalyticsEvent__ = __webpack_require__(135);
/* unused harmony reexport AnalyticsEvent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UIAnalyticsEvent__ = __webpack_require__(79);
/* unused harmony reexport UIAnalyticsEvent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AnalyticsListener__ = __webpack_require__(422);
/* unused harmony reexport AnalyticsListener */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AnalyticsContext__ = __webpack_require__(213);
/* unused harmony reexport AnalyticsContext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__withAnalyticsContext__ = __webpack_require__(423);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__withAnalyticsContext__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__withAnalyticsEvents__ = __webpack_require__(214);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__withAnalyticsEvents__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__createAndFireEvent__ = __webpack_require__(426);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_6__createAndFireEvent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cleanProps__ = __webpack_require__(428);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_7__cleanProps__["a"]; });


// Analytics event classes




// AnalyticsListener component


// AnalyticsContext component and HOC



// createAnalyticsEvent HOC


// Helper functions



/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Item__ = __webpack_require__(580);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Item__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ItemGroup__ = __webpack_require__(590);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__components_ItemGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_hoc_withItemClick__ = __webpack_require__(593);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__components_hoc_withItemClick__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_hoc_withItemFocus__ = __webpack_require__(594);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__components_hoc_withItemFocus__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_theme__ = __webpack_require__(96);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__util_theme__["f"]; });







/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(126)('wks');
var uid = __webpack_require__(76);
var Symbol = __webpack_require__(31).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(0);
var factory = __webpack_require__(349);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(31);
var core = __webpack_require__(18);
var ctx = __webpack_require__(120);
var hide = __webpack_require__(46);
var has = __webpack_require__(37);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AtlasKitThemeProvider */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return borderRadius; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return gridSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fontSize; });
/* unused harmony export fontFamily */
/* unused harmony export codeFontFamily */
/* unused harmony export layers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elevation__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__typography__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_math__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_getTheme__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_themed__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AtlaskitThemeProvider__ = __webpack_require__(747);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__colors__; });
/* unused harmony reexport elevation */
/* unused harmony reexport typography */
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__utils_math__; });
/* unused harmony reexport getTheme */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__utils_themed__["a"]; });
/* unused harmony reexport AtlaskitThemeProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Appearance__ = __webpack_require__(748);
/* unused harmony reexport Appearance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Context__ = __webpack_require__(104);
/* unused harmony reexport Consumer */
/* unused harmony reexport Provider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Reset__ = __webpack_require__(749);
/* unused harmony reexport Reset */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Theme__ = __webpack_require__(750);
/* unused harmony reexport Theme */











// backwards-compatible export with old Atlaskit case
var AtlasKitThemeProvider = __WEBPACK_IMPORTED_MODULE_6__components_AtlaskitThemeProvider__["a" /* default */];

/*
  These theme values are expressed as functions so that if we decide to make
  them dependent on props in the future, it wouldn't require a significant
  refactor everywhere they are being used.
*/
var borderRadius = function borderRadius() {
  return 3;
};
var gridSize = function gridSize() {
  return 8;
};
var fontSize = function fontSize() {
  return 14;
};
var fontFamily = function fontFamily() {
  return '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif';
};
var codeFontFamily = function codeFontFamily() {
  return '"SFMono-Medium", "SF Mono", "Segoe UI Mono", "Roboto Mono", "Ubuntu Mono", Menlo, Consolas, Courier, monospace';
};

var layers = {
  card: function card() {
    return 100;
  },
  dialog: function dialog() {
    return 200;
  },
  navigation: function navigation() {
    return 300;
  },
  layer: function layer() {
    return 400;
  },
  blanket: function blanket() {
    return 500;
  },
  modal: function modal() {
    return 510;
  },
  flag: function flag() {
    return 600;
  },
  spotlight: function spotlight() {
    return 700;
  },
  tooltip: function tooltip() {
    return 800;
  }
};

// New API




/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(338);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = isReactChildren;
/* harmony export (immutable) */ __webpack_exports__["a"] = createRouteFromReactElement;
/* unused harmony export createRoutesFromReactChildren */
/* harmony export (immutable) */ __webpack_exports__["b"] = createRoutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function isValidChild(object) {
  return object == null || __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(object);
}

function isReactChildren(object) {
  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
}

function createRoute(defaultProps, props) {
  return _extends({}, defaultProps, props);
}

function createRouteFromReactElement(element) {
  var type = element.type;
  var route = createRoute(type.defaultProps, element.props);

  if (route.children) {
    var childRoutes = createRoutesFromReactChildren(route.children, route);

    if (childRoutes.length) route.childRoutes = childRoutes;

    delete route.children;
  }

  return route;
}

/**
 * Creates and returns a routes object from the given ReactChildren. JSX
 * provides a convenient way to visualize how routes in the hierarchy are
 * nested.
 *
 *   import { Route, createRoutesFromReactChildren } from 'react-router'
 *
 *   const routes = createRoutesFromReactChildren(
 *     <Route component={App}>
 *       <Route path="home" component={Dashboard}/>
 *       <Route path="news" component={NewsFeed}/>
 *     </Route>
 *   )
 *
 * Note: This method is automatically used when you provide <Route> children
 * to a <Router> component.
 */
function createRoutesFromReactChildren(children, parentRoute) {
  var routes = [];

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
    if (__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
      // Component classes may have a static create* method.
      if (element.type.createRouteFromReactElement) {
        var route = element.type.createRouteFromReactElement(element, parentRoute);

        if (route) routes.push(route);
      } else {
        routes.push(createRouteFromReactElement(element));
      }
    }
  });

  return routes;
}

/**
 * Creates and returns an array of routes from the given object which
 * may be a JSX route, a plain object route, or an array of either.
 */
function createRoutes(routes) {
  if (isReactChildren(routes)) {
    routes = createRoutesFromReactChildren(routes);
  } else if (routes && !Array.isArray(routes)) {
    routes = [routes];
  }

  return routes;
}

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;

var _warning = __webpack_require__(28);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
  var _parsePath = parsePath(path),
      pathname = _parsePath.pathname,
      search = _parsePath.search,
      hash = _parsePath.hash;

  return createPath({
    pathname: pathname,
    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
    hash: hash
  });
};

var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
  var _parsePath2 = parsePath(path),
      pathname = _parsePath2.pathname,
      search = _parsePath2.search,
      hash = _parsePath2.hash;

  return createPath({
    pathname: pathname,
    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
      return prefix === '?' ? prefix : suffix;
    }),
    hash: hash
  });
};

var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
  var _parsePath3 = parsePath(path),
      search = _parsePath3.search;

  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
  return match && match[1];
};

var extractPath = function extractPath(string) {
  var match = string.match(/^(https?:)?\/\/[^\/]*/);
  return match == null ? string : string.substring(match[0].length);
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = extractPath(path);
  var search = '';
  var hash = '';

   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substring(hashIndex);
    pathname = pathname.substring(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substring(searchIndex);
    pathname = pathname.substring(0, searchIndex);
  }

  if (pathname === '') pathname = '/';

  return {
    pathname: pathname,
    search: search,
    hash: hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  if (location == null || typeof location === 'string') return location;

  var basename = location.basename,
      pathname = location.pathname,
      search = location.search,
      hash = location.hash;

  var path = (basename || '') + pathname;

  if (search && search !== '?') path += search;

  if (hash) path += hash;

  return path;
};

/***/ }),
/* 31 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(35);
var IE8_DOM_DEFINE = __webpack_require__(199);
var toPrimitive = __webpack_require__(121);
var dP = Object.defineProperty;

exports.f = __webpack_require__(33) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(47)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export R50 */
/* unused harmony export R75 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return R100; });
/* unused harmony export R200 */
/* unused harmony export R300 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return R400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return R500; });
/* unused harmony export Y50 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return Y75; });
/* unused harmony export Y100 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return Y200; });
/* unused harmony export Y300 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return Y400; });
/* unused harmony export Y500 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return G50; });
/* unused harmony export G75 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return G100; });
/* unused harmony export G200 */
/* unused harmony export G300 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return G400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return G500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return B50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return B75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return B100; });
/* unused harmony export B200 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return B300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return B400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return B500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return P50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return P75; });
/* unused harmony export P100 */
/* unused harmony export P200 */
/* unused harmony export P300 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return P400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return P500; });
/* unused harmony export T50 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return T75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return T100; });
/* unused harmony export T200 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return T300; });
/* unused harmony export T400 */
/* unused harmony export T500 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return N0; });
/* unused harmony export N10 */
/* unused harmony export N20 */
/* unused harmony export N30 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return N40; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return N50; });
/* unused harmony export N60 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return N70; });
/* unused harmony export N80 */
/* unused harmony export N90 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return N100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return N200; });
/* unused harmony export N300 */
/* unused harmony export N400 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return N500; });
/* unused harmony export N600 */
/* unused harmony export N700 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return N800; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return N900; });
/* unused harmony export N10A */
/* unused harmony export N20A */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return N30A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return N40A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return N50A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return N60A; });
/* unused harmony export N70A */
/* unused harmony export N80A */
/* unused harmony export N90A */
/* unused harmony export N100A */
/* unused harmony export N200A */
/* unused harmony export N300A */
/* unused harmony export N400A */
/* unused harmony export N500A */
/* unused harmony export N600A */
/* unused harmony export N700A */
/* unused harmony export N800A */
/* unused harmony export DN900 */
/* unused harmony export DN800 */
/* unused harmony export DN700 */
/* unused harmony export DN600 */
/* unused harmony export DN500 */
/* unused harmony export DN400 */
/* unused harmony export DN300 */
/* unused harmony export DN200 */
/* unused harmony export DN100 */
/* unused harmony export DN90 */
/* unused harmony export DN80 */
/* unused harmony export DN70 */
/* unused harmony export DN60 */
/* unused harmony export DN50 */
/* unused harmony export DN40 */
/* unused harmony export DN30 */
/* unused harmony export DN20 */
/* unused harmony export DN10 */
/* unused harmony export DN0 */
/* unused harmony export DN800A */
/* unused harmony export DN700A */
/* unused harmony export DN600A */
/* unused harmony export DN500A */
/* unused harmony export DN400A */
/* unused harmony export DN300A */
/* unused harmony export DN200A */
/* unused harmony export DN100A */
/* unused harmony export DN90A */
/* unused harmony export DN80A */
/* unused harmony export DN70A */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DN60A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DN50A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DN40A; });
/* unused harmony export DN30A */
/* unused harmony export DN20A */
/* unused harmony export DN10A */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return background; });
/* unused harmony export backgroundActive */
/* unused harmony export backgroundHover */
/* unused harmony export backgroundOnLayer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return text; });
/* unused harmony export textHover */
/* unused harmony export textActive */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return subtleText; });
/* unused harmony export placeholderText */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return heading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return subtleHeading; });
/* unused harmony export codeBlock */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return link; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return linkHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return linkActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return linkOutline; });
/* unused harmony export primary */
/* unused harmony export blue */
/* unused harmony export teal */
/* unused harmony export purple */
/* unused harmony export red */
/* unused harmony export yellow */
/* unused harmony export green */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return skeleton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_themed__ = __webpack_require__(157);
 // Reds

var R50 = '#FFEBE6';
var R75 = '#FFBDAD';
var R100 = '#FF8F73';
var R200 = '#FF7452';
var R300 = '#FF5630';
var R400 = '#DE350B';
var R500 = '#BF2600'; // Yellows

var Y50 = '#FFFAE6';
var Y75 = '#FFF0B3';
var Y100 = '#FFE380';
var Y200 = '#FFC400';
var Y300 = '#FFAB00';
var Y400 = '#FF991F';
var Y500 = '#FF8B00'; // Greens

var G50 = '#E3FCEF';
var G75 = '#ABF5D1';
var G100 = '#79F2C0';
var G200 = '#57D9A3';
var G300 = '#36B37E';
var G400 = '#00875A';
var G500 = '#006644'; // Blues

var B50 = '#DEEBFF';
var B75 = '#B3D4FF';
var B100 = '#4C9AFF';
var B200 = '#2684FF';
var B300 = '#0065FF';
var B400 = '#0052CC';
var B500 = '#0747A6'; // Purples

var P50 = '#EAE6FF';
var P75 = '#C0B6F2';
var P100 = '#998DD9';
var P200 = '#8777D9';
var P300 = '#6554C0';
var P400 = '#5243AA';
var P500 = '#403294'; // Teals

var T50 = '#E6FCFF';
var T75 = '#B3F5FF';
var T100 = '#79E2F2';
var T200 = '#00C7E6';
var T300 = '#00B8D9';
var T400 = '#00A3BF';
var T500 = '#008DA6'; // Neutrals

var N0 = '#FFFFFF';
var N10 = '#FAFBFC';
var N20 = '#F4F5F7';
var N30 = '#EBECF0';
var N40 = '#DFE1E6';
var N50 = '#C1C7D0';
var N60 = '#B3BAC5';
var N70 = '#A5ADBA';
var N80 = '#97A0AF';
var N90 = '#8993A4';
var N100 = '#7A869A';
var N200 = '#6B778C';
var N300 = '#5E6C84';
var N400 = '#505F79';
var N500 = '#42526E';
var N600 = '#344563';
var N700 = '#253858';
var N800 = '#172B4D'; // ATTENTION: update the tints if you update this

var N900 = '#091E42'; // Each tint is made of N900 and an alpha channel

var N10A = 'rgba(9, 30, 66, 0.02)';
var N20A = 'rgba(9, 30, 66, 0.04)';
var N30A = 'rgba(9, 30, 66, 0.08)';
var N40A = 'rgba(9, 30, 66, 0.13)';
var N50A = 'rgba(9, 30, 66, 0.25)';
var N60A = 'rgba(9, 30, 66, 0.31)';
var N70A = 'rgba(9, 30, 66, 0.36)';
var N80A = 'rgba(9, 30, 66, 0.42)';
var N90A = 'rgba(9, 30, 66, 0.48)';
var N100A = 'rgba(9, 30, 66, 0.54)';
var N200A = 'rgba(9, 30, 66, 0.60)';
var N300A = 'rgba(9, 30, 66, 0.66)';
var N400A = 'rgba(9, 30, 66, 0.71)';
var N500A = 'rgba(9, 30, 66, 0.77)';
var N600A = 'rgba(9, 30, 66, 0.82)';
var N700A = 'rgba(9, 30, 66, 0.89)';
var N800A = 'rgba(9, 30, 66, 0.95)'; // Dark Mode Neutrals

var DN900 = '#E6EDFA';
var DN800 = '#DCE5F5';
var DN700 = '#CED9EB';
var DN600 = '#B8C7E0';
var DN500 = '#ABBBD6';
var DN400 = '#9FB0CC';
var DN300 = '#8C9CB8';
var DN200 = '#7988A3';
var DN100 = '#67758F';
var DN90 = '#56637A';
var DN80 = '#455166';
var DN70 = '#3B475C';
var DN60 = '#313D52';
var DN50 = '#283447';
var DN40 = '#202B3D';
var DN30 = '#1B2638';
var DN20 = '#121A29';
var DN10 = '#0E1624'; // ATTENTION: update the tints if you update this

var DN0 = '#0D1424'; // Each dark tint is made of DN0 and an alpha channel

var DN800A = 'rgba(13, 20, 36, 0.06)';
var DN700A = 'rgba(13, 20, 36, 0.14)';
var DN600A = 'rgba(13, 20, 36, 0.18)';
var DN500A = 'rgba(13, 20, 36, 0.29)';
var DN400A = 'rgba(13, 20, 36, 0.36)';
var DN300A = 'rgba(13, 20, 36, 0.40)';
var DN200A = 'rgba(13, 20, 36, 0.47)';
var DN100A = 'rgba(13, 20, 36, 0.53)';
var DN90A = 'rgba(13, 20, 36, 0.63)';
var DN80A = 'rgba(13, 20, 36, 0.73)';
var DN70A = 'rgba(13, 20, 36, 0.78)';
var DN60A = 'rgba(13, 20, 36, 0.81)';
var DN50A = 'rgba(13, 20, 36, 0.85)';
var DN40A = 'rgba(13, 20, 36, 0.89)';
var DN30A = 'rgba(13, 20, 36, 0.92)';
var DN20A = 'rgba(13, 20, 36, 0.95)';
var DN10A = 'rgba(13, 20, 36, 0.97)'; // Themed colors

var background = Object(__WEBPACK_IMPORTED_MODULE_0__utils_themed__["a" /* default */])({
  light: N0,
  dark: DN30
});
var backgroundActive = Object(__WEBPACK_IMPORTED_MODULE_0__utils_themed__["a" /* default */])({
  light: B50,
  dark: B75
});
var backgroundHover = Object(__WEBPACK_IMPORTED_MODULE_0__utils_themed__["a" /* default */])({
  light: N30,
  dark: DN70
});
var backgroundOnLayer = Object(__WEBPACK_IMPORTED_MODULE_0__utils_themed__["a" /* default */])({
  light: N0,
  dark: DN50
});
var text = Object(__WEBPACK_IMPORTED_MODULE_0__utils_themed__["a" /* default */])({
  light: N900,
  dark: DN600
});
var textHover = Object(__WEBPACK_IMPORTED_MODULE_0__utils_themed__["a" /* default */])({
  light: N800,
  dark: DN600
});
var textActive = Object(__WEBPACK_IMPORTED_MODULE_0__utils_themed__["a" /* default */])({
  light: B400,
  dark: B400
});
var subtleText = Object(__WEBPACK_IMPORTED_MODULE_0__utils_themed__["a" /* default */])({
  light: N200,
  dark: DN300
});
var placeholderText = Object(__WEBPACK_IMPORTED_MODULE_0__utils_themed__["a" /* default */])({
  light: N100,
  dark: DN200
});
var heading = Object(__WEBPACK_IMPORTED_MODULE_0__utils_themed__["a" /* default */])({
  light: N800,
  dark: DN600
});
var subtleHeading = Object(__WEBPACK_IMPORTED_MODULE_0__utils_themed__["a" /* default */])({
  light: N200,
  dark: DN300
});
var codeBlock = Object(__WEBPACK_IMPORTED_MODULE_0__utils_themed__["a" /* default */])({
  light: N20,
  dark: DN50
});
var link = Object(__WEBPACK_IMPORTED_MODULE_0__utils_themed__["a" /* default */])({
  light: B400,
  dark: B100
});
var linkHover = Object(__WEBPACK_IMPORTED_MODULE_0__utils_themed__["a" /* default */])({
  light: B300,
  dark: B200
});
var linkActive = Object(__WEBPACK_IMPORTED_MODULE_0__utils_themed__["a" /* default */])({
  light: B500,
  dark: B100
});
var linkOutline = Object(__WEBPACK_IMPORTED_MODULE_0__utils_themed__["a" /* default */])({
  light: B100,
  dark: B200
});
var primary = Object(__WEBPACK_IMPORTED_MODULE_0__utils_themed__["a" /* default */])({
  light: B400,
  dark: B100
});
var blue = Object(__WEBPACK_IMPORTED_MODULE_0__utils_themed__["a" /* default */])({
  light: B400,
  dark: B100
});
var teal = Object(__WEBPACK_IMPORTED_MODULE_0__utils_themed__["a" /* default */])({
  light: T300,
  dark: T200
});
var purple = Object(__WEBPACK_IMPORTED_MODULE_0__utils_themed__["a" /* default */])({
  light: P300,
  dark: P100
});
var red = Object(__WEBPACK_IMPORTED_MODULE_0__utils_themed__["a" /* default */])({
  light: R300,
  dark: R300
});
var yellow = Object(__WEBPACK_IMPORTED_MODULE_0__utils_themed__["a" /* default */])({
  light: Y300,
  dark: Y300
});
var green = Object(__WEBPACK_IMPORTED_MODULE_0__utils_themed__["a" /* default */])({
  light: G300,
  dark: G300
});
var skeleton = function skeleton() {
  return N20A;
};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(36);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 36 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 37 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(202);
var defined = __webpack_require__(123);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AtlasKitThemeProvider */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return borderRadius; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return gridSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fontSize; });
/* unused harmony export fontFamily */
/* unused harmony export codeFontFamily */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return layers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elevation__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__typography__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_math__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_getTheme__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_themed__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AtlaskitThemeProvider__ = __webpack_require__(460);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__colors__; });
/* unused harmony reexport elevation */
/* unused harmony reexport typography */
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__utils_math__; });
/* unused harmony reexport getTheme */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_5__utils_themed__["a"]; });
/* unused harmony reexport AtlaskitThemeProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Appearance__ = __webpack_require__(461);
/* unused harmony reexport Appearance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Context__ = __webpack_require__(81);
/* unused harmony reexport Consumer */
/* unused harmony reexport Provider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Reset__ = __webpack_require__(462);
/* unused harmony reexport Reset */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Theme__ = __webpack_require__(463);
/* unused harmony reexport Theme */











// backwards-compatible export with old Atlaskit case
var AtlasKitThemeProvider = __WEBPACK_IMPORTED_MODULE_6__components_AtlaskitThemeProvider__["a" /* default */];

/*
  These theme values are expressed as functions so that if we decide to make
  them dependent on props in the future, it wouldn't require a significant
  refactor everywhere they are being used.
*/
var borderRadius = function borderRadius() {
  return 3;
};
var gridSize = function gridSize() {
  return 8;
};
var fontSize = function fontSize() {
  return 14;
};
var fontFamily = function fontFamily() {
  return '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif';
};
var codeFontFamily = function codeFontFamily() {
  return '"SFMono-Medium", "SF Mono", "Segoe UI Mono", "Roboto Mono", "Ubuntu Mono", Menlo, Consolas, Courier, monospace';
};

var layers = {
  card: function card() {
    return 100;
  },
  dialog: function dialog() {
    return 200;
  },
  navigation: function navigation() {
    return 300;
  },
  layer: function layer() {
    return 400;
  },
  blanket: function blanket() {
    return 500;
  },
  modal: function modal() {
    return 510;
  },
  flag: function flag() {
    return 600;
  },
  spotlight: function spotlight() {
    return 700;
  },
  tooltip: function tooltip() {
    return 800;
  }
};

// New API




/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _CSSTransition = __webpack_require__(470);

var _CSSTransition2 = _interopRequireDefault(_CSSTransition);

var _ReplaceTransition = __webpack_require__(474);

var _ReplaceTransition2 = _interopRequireDefault(_ReplaceTransition);

var _TransitionGroup = __webpack_require__(82);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _Transition = __webpack_require__(225);

var _Transition2 = _interopRequireDefault(_Transition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  Transition: _Transition2.default,
  TransitionGroup: _TransitionGroup2.default,
  ReplaceTransition: _ReplaceTransition2.default,
  CSSTransition: _CSSTransition2.default
};

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AtlasKitThemeProvider */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return borderRadius; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return gridSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fontSize; });
/* unused harmony export fontFamily */
/* unused harmony export codeFontFamily */
/* unused harmony export layers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elevation__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__typography__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_math__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_getTheme__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_themed__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AtlaskitThemeProvider__ = __webpack_require__(650);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__colors__; });
/* unused harmony reexport elevation */
/* unused harmony reexport typography */
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__utils_math__; });
/* unused harmony reexport getTheme */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__utils_themed__["a"]; });
/* unused harmony reexport AtlaskitThemeProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Appearance__ = __webpack_require__(651);
/* unused harmony reexport Appearance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Context__ = __webpack_require__(99);
/* unused harmony reexport Consumer */
/* unused harmony reexport Provider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Reset__ = __webpack_require__(652);
/* unused harmony reexport Reset */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Theme__ = __webpack_require__(653);
/* unused harmony reexport Theme */











// backwards-compatible export with old Atlaskit case
var AtlasKitThemeProvider = __WEBPACK_IMPORTED_MODULE_6__components_AtlaskitThemeProvider__["a" /* default */];

/*
  These theme values are expressed as functions so that if we decide to make
  them dependent on props in the future, it wouldn't require a significant
  refactor everywhere they are being used.
*/
var borderRadius = function borderRadius() {
  return 3;
};
var gridSize = function gridSize() {
  return 8;
};
var fontSize = function fontSize() {
  return 14;
};
var fontFamily = function fontFamily() {
  return '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif';
};
var codeFontFamily = function codeFontFamily() {
  return '"SFMono-Medium", "SF Mono", "Segoe UI Mono", "Roboto Mono", "Ubuntu Mono", Menlo, Consolas, Courier, monospace';
};

var layers = {
  card: function card() {
    return 100;
  },
  dialog: function dialog() {
    return 200;
  },
  navigation: function navigation() {
    return 300;
  },
  layer: function layer() {
    return 400;
  },
  blanket: function blanket() {
    return 500;
  },
  modal: function modal() {
    return 510;
  },
  flag: function flag() {
    return 600;
  },
  spotlight: function spotlight() {
    return 700;
  },
  tooltip: function tooltip() {
    return 800;
  }
};

// New API




/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* unused harmony export _resetWarned */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var warned = {};

function routerWarning(falseToWarn, message) {
  // Only issue deprecation warnings once.
  if (message.indexOf('deprecated') !== -1) {
    if (warned[message]) {
      return;
    }

    warned[message] = true;
  }

  message = '[react-router] ' + message;

  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  __WEBPACK_IMPORTED_MODULE_0_warning___default.a.apply(undefined, [falseToWarn, message].concat(args));
}

function _resetWarned() {
  warned = {};
}

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export compilePattern */
/* harmony export (immutable) */ __webpack_exports__["c"] = matchPattern;
/* harmony export (immutable) */ __webpack_exports__["b"] = getParamNames;
/* unused harmony export getParams */
/* harmony export (immutable) */ __webpack_exports__["a"] = formatPattern;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);


function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function _compilePattern(pattern) {
  var regexpSource = '';
  var paramNames = [];
  var tokens = [];

  var match = void 0,
      lastIndex = 0,
      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
  while (match = matcher.exec(pattern)) {
    if (match.index !== lastIndex) {
      tokens.push(pattern.slice(lastIndex, match.index));
      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
    }

    if (match[1]) {
      regexpSource += '([^/]+)';
      paramNames.push(match[1]);
    } else if (match[0] === '**') {
      regexpSource += '(.*)';
      paramNames.push('splat');
    } else if (match[0] === '*') {
      regexpSource += '(.*?)';
      paramNames.push('splat');
    } else if (match[0] === '(') {
      regexpSource += '(?:';
    } else if (match[0] === ')') {
      regexpSource += ')?';
    } else if (match[0] === '\\(') {
      regexpSource += '\\(';
    } else if (match[0] === '\\)') {
      regexpSource += '\\)';
    }

    tokens.push(match[0]);

    lastIndex = matcher.lastIndex;
  }

  if (lastIndex !== pattern.length) {
    tokens.push(pattern.slice(lastIndex, pattern.length));
    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
  }

  return {
    pattern: pattern,
    regexpSource: regexpSource,
    paramNames: paramNames,
    tokens: tokens
  };
}

var CompiledPatternsCache = Object.create(null);

function compilePattern(pattern) {
  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);

  return CompiledPatternsCache[pattern];
}

/**
 * Attempts to match a pattern on the given pathname. Patterns may use
 * the following special characters:
 *
 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
 *                  captured string is considered a "param"
 * - ()             Wraps a segment of the URL that is optional
 * - *              Consumes (non-greedy) all characters up to the next
 *                  character in the pattern, or to the end of the URL if
 *                  there is none
 * - **             Consumes (greedy) all characters up to the next character
 *                  in the pattern, or to the end of the URL if there is none
 *
 *  The function calls callback(error, matched) when finished.
 * The return value is an object with the following properties:
 *
 * - remainingPathname
 * - paramNames
 * - paramValues
 */
function matchPattern(pattern, pathname) {
  // Ensure pattern starts with leading slash for consistency with pathname.
  if (pattern.charAt(0) !== '/') {
    pattern = '/' + pattern;
  }

  var _compilePattern2 = compilePattern(pattern),
      regexpSource = _compilePattern2.regexpSource,
      paramNames = _compilePattern2.paramNames,
      tokens = _compilePattern2.tokens;

  if (pattern.charAt(pattern.length - 1) !== '/') {
    regexpSource += '/?'; // Allow optional path separator at end.
  }

  // Special-case patterns like '*' for catch-all routes.
  if (tokens[tokens.length - 1] === '*') {
    regexpSource += '$';
  }

  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
  if (match == null) {
    return null;
  }

  var matchedPath = match[0];
  var remainingPathname = pathname.substr(matchedPath.length);

  if (remainingPathname) {
    // Require that the match ends at a path separator, if we didn't match
    // the full path, so any remaining pathname is a new path segment.
    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
      return null;
    }

    // If there is a remaining pathname, treat the path separator as part of
    // the remaining pathname for properly continuing the match.
    remainingPathname = '/' + remainingPathname;
  }

  return {
    remainingPathname: remainingPathname,
    paramNames: paramNames,
    paramValues: match.slice(1).map(function (v) {
      return v && decodeURIComponent(v);
    })
  };
}

function getParamNames(pattern) {
  return compilePattern(pattern).paramNames;
}

function getParams(pattern, pathname) {
  var match = matchPattern(pattern, pathname);
  if (!match) {
    return null;
  }

  var paramNames = match.paramNames,
      paramValues = match.paramValues;

  var params = {};

  paramNames.forEach(function (paramName, index) {
    params[paramName] = paramValues[index];
  });

  return params;
}

/**
 * Returns a version of the given pattern with params interpolated. Throws
 * if there is a dynamic segment of the pattern for which there is no param.
 */
function formatPattern(pattern, params) {
  params = params || {};

  var _compilePattern3 = compilePattern(pattern),
      tokens = _compilePattern3.tokens;

  var parenCount = 0,
      pathname = '',
      splatIndex = 0,
      parenHistory = [];

  var token = void 0,
      paramName = void 0,
      paramValue = void 0;
  for (var i = 0, len = tokens.length; i < len; ++i) {
    token = tokens[i];

    if (token === '*' || token === '**') {
      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;

      !(paramValue != null || parenCount > 0) ?  false ? invariant(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      if (paramValue != null) pathname += encodeURI(paramValue);
    } else if (token === '(') {
      parenHistory[parenCount] = '';
      parenCount += 1;
    } else if (token === ')') {
      var parenText = parenHistory.pop();
      parenCount -= 1;

      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
    } else if (token === '\\(') {
      pathname += '(';
    } else if (token === '\\)') {
      pathname += ')';
    } else if (token.charAt(0) === ':') {
      paramName = token.substring(1);
      paramValue = params[paramName];

      !(paramValue != null || parenCount > 0) ?  false ? invariant(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      if (paramValue == null) {
        if (parenCount) {
          parenHistory[parenCount - 1] = '';

          var curTokenIdx = tokens.indexOf(token);
          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
          var nextParenIdx = -1;

          for (var _i = 0; _i < tokensSubset.length; _i++) {
            if (tokensSubset[_i] == ')') {
              nextParenIdx = _i;
              break;
            }
          }

          !(nextParenIdx > 0) ?  false ? invariant(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

          // jump to ending paren
          i = curTokenIdx + nextParenIdx - 1;
        }
      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
    } else {
      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
    }
  }

  !(parenCount <= 0) ?  false ? invariant(false, 'Path "%s" is missing end paren', pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

  return pathname.replace(/\/+/g, '/');
}

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(19);

var _invariant2 = _interopRequireDefault(_invariant);

var _warning = __webpack_require__(28);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(30);

var _Actions = __webpack_require__(73);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createQuery = exports.createQuery = function createQuery(props) {
  return _extends(Object.create(null), props);
};

var createLocation = exports.createLocation = function createLocation() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Actions.POP;
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;

   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;

  var pathname = object.pathname || '/';
  var search = object.search || '';
  var hash = object.hash || '';
  var state = object.state;

  return {
    pathname: pathname,
    search: search,
    hash: hash,
    state: state,
    action: action,
    key: key
  };
};

var isDate = function isDate(object) {
  return Object.prototype.toString.call(object) === '[object Date]';
};

var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
  if (a === b) return true;

  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (typeofA !== typeofB) return false;

  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;

  // Not the same object, but same type.
  if (typeofA === 'object') {
    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;

    if (!Array.isArray(a)) {
      var keysofA = Object.keys(a);
      var keysofB = Object.keys(b);
      return keysofA.length === keysofB.length && keysofA.every(function (key) {
        return statesAreEqual(a[key], b[key]);
      });
    }

    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return statesAreEqual(item, b[index]);
    });
  }

  // All other serializable types (string, number, boolean)
  // should be strict equal.
  return false;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.key === b.key &&
  // a.action === b.action && // Different action !== location change.
  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
};

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(375), __esModule: true };

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(32);
var createDesc = __webpack_require__(52);
module.exports = __webpack_require__(33) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 47 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return container; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return dark; });
/* unused harmony export settings */
/* unused harmony export siteSettings */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return global; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chromatism__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(20);




// the following colors have been added at request of Venn. These should either
// be added to theme.colors or moved to specific AK colors. They are using a new
// method to generate colors dynamically based on the background color.
var darkDrawerItemHoverBackground = '#313F57';
var darkDrawerItemActiveBackground = '#2B374D';

var darkItemHoverBackground = '#253247';
var darkItemActiveBackground = '#202B3D';
var darkItemSelectedBackground = '#202B3D';

var derivedGlobalHoverBackground = '#192238';
var derivedGlobalActiveBackground = '#202B3D';
var derivedGlobalSelectedBackground = '#1D2842';

// Currently shared by all the themes - but need not be
var focus = {
  outline: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].B100, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].B75 })
};

function lightenColor(color, alpha) {
  var _chromatism$convert$r = __WEBPACK_IMPORTED_MODULE_1_chromatism__["a" /* default */].convert(color).rgb,
      red = _chromatism$convert$r.r,
      green = _chromatism$convert$r.g,
      blue = _chromatism$convert$r.b;

  return 'rgba(' + red + ', ' + green + ', ' + blue + ', 0.' + alpha + ')';
}

var container = function () {
  var primaryBackground = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].codeBlock;
  var item = {
    default: {
      background: 'transparent'
    },
    hover: {
      background: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* themed */])({
        light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].N20A,
        dark: darkDrawerItemHoverBackground
      })
    },
    active: {
      background: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* themed */])({
        light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].B50,
        dark: darkDrawerItemActiveBackground
      })
    },
    selected: {
      background: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].N20A,
      text: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].B400
    },
    focus: focus,
    dragging: {
      // similar to hover - but without opacity
      background: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].N30, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].DN30 })
    }
  };

  var scrollBar = {
    default: {
      background: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* themed */])({
        light: lightenColor(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].N500, 36),
        dark: lightenColor(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].DN600, 36)
      })
    },
    hover: {
      background: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* themed */])({
        light: lightenColor(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].N500, 56),
        dark: lightenColor(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].DN600, 56)
      })
    }
  };

  var dropdown = {
    default: {
      background: item.hover.background
    },
    hover: {
      background: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].N30A, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].DN30A })
    },
    active: item.active,
    selected: item.selected,
    focus: item.focus,
    dragging: item.dragging
  };

  var theme = {
    background: {
      primary: primaryBackground,
      secondary: primaryBackground,
      tertiary: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].N0, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].DN30 })
    },
    text: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].N500, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].DN600 }),
    subText: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].subtleText,
    keyline: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].N30A, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].DN30A }),
    item: item,
    dropdown: dropdown,
    scrollBar: scrollBar
  };

  return theme;
}();

var dark = function () {
  var item = {
    default: {
      background: 'transparent'
    },
    hover: {
      background: darkItemHoverBackground
    },
    active: {
      // Currently there is no ramp for white opacity
      background: darkItemActiveBackground,
      text: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].B100
    },
    selected: {
      background: darkItemSelectedBackground,
      text: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].DN900
    },
    focus: focus,
    dragging: {
      // Similar to active colour - but without opacity
      background: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].DN50
    }
  };
  var scrollBar = {
    default: {
      background: lightenColor(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].DN400, 36)
    },
    hover: {
      background: lightenColor(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].DN400, 26)
    }
  };

  var dropdown = {
    default: {
      background: item.hover.background
    },
    hover: {
      // Going lighter to be different from hover
      background: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].DN60
    },
    active: item.active,
    selected: item.selected,
    focus: item.focus,
    dragging: item.dragging
  };

  var theme = {
    background: {
      primary: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].DN0,
      secondary: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].DN20,
      tertiary: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].DN30
    },
    text: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].DN400,
    subText: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].DN100,
    keyline: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].DN50,
    item: item,
    dropdown: dropdown,
    scrollBar: scrollBar
  };

  return theme;
}();

var settings = function () {
  var primaryBackground = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].N800;

  var item = {
    default: {
      background: 'transparent'
    },
    hover: {
      background: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].N700A
    },
    active: {
      // Currently there is no ramp for white opacity
      background: 'rgba(255, 255, 255, 0.08)',
      text: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].B100
    },
    selected: {
      background: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].N700A
    },
    focus: focus,
    dragging: {
      // Similar to active colour - but without opacity
      background: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].N600
    }
  };

  var scrollBar = {
    default: {
      background: lightenColor(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].N0, 36)
    },
    hover: {
      background: lightenColor(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].N0, 26)
    }
  };

  var dropdown = {
    default: {
      background: item.hover.background
    },
    hover: {
      // Going lighter to be different from hover
      background: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].N90A
    },
    active: item.active,
    selected: item.selected,
    focus: item.focus,
    dragging: item.dragging
  };

  var theme = {
    background: {
      primary: primaryBackground,
      secondary: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].N700,
      tertiary: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].N700
    },
    text: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].N0,
    subText: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].N70,
    keyline: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].N900,
    item: item,
    dropdown: dropdown,
    scrollBar: scrollBar
  };

  return theme;
}();

var siteSettings = function () {
  // deep copy settings and re-assign some colors
  var theme = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(settings));
  theme.background.secondary = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].N800;
  theme.item.active.text = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].B100;
  return theme;
}();

var global = function () {
  var primaryBackground = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].B500;
  var activeBackground = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].B200;
  var item = {
    default: {
      background: primaryBackground
    },
    hover: {
      background: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* themed */])({
        light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].N80A,
        dark: derivedGlobalHoverBackground
      })
    },
    active: {
      background: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* themed */])({
        light: activeBackground,
        dark: derivedGlobalActiveBackground
      }),
      text: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].B50, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].B100 })
    },
    selected: {
      background: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* themed */])({
        light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].N50A,
        dark: derivedGlobalSelectedBackground
      }),
      text: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].B50
    },
    focus: focus,
    dragging: {
      // using active colour for this preset
      background: activeBackground
    }
  };

  var scrollBar = {
    default: {
      background: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* themed */])({
        light: lightenColor(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].B50, 36),
        dark: lightenColor(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].DN400, 36)
      })
    },
    hover: {
      background: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* themed */])({
        light: lightenColor(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].B50, 56),
        dark: lightenColor(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].DN400, 56)
      })
    }
  };

  var dropdown = {
    default: {
      background: item.hover.background
    },
    hover: {
      // going darker than standard hover
      background: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].N90A
    },
    active: item.active,
    selected: item.selected,
    focus: item.focus,
    dragging: item.dragging
  };

  var theme = {
    background: {
      primary: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* themed */])({ light: primaryBackground, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].DN0 }),
      secondary: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* themed */])({ light: primaryBackground, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].DN0 }),
      tertiary: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* themed */])({ light: primaryBackground, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].DN0 })
    },
    hasDarkmode: true,
    text: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].B50, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].DN400 }),
    subText: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].B75, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].DN100 }),
    keyline: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].N80A, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].DN50 }),
    item: item,
    dropdown: dropdown,
    scrollBar: scrollBar
  };

  return theme;
}();

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return TRANSITION_DURATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AVATAR_SIZES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AVATAR_RADIUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BORDER_WIDTH; });
/* unused harmony export EXCESS_INDICATOR_FONT_SIZE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ICON_SIZES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ICON_OFFSET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SQUARE_ICON_OFFSET; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__ = __webpack_require__(26);


var TRANSITION_DURATION = '200ms';

var gridSizeValue = Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["d" /* gridSize */])();

var AVATAR_SIZES = {
  xsmall: gridSizeValue * 2,
  small: gridSizeValue * 3,
  medium: gridSizeValue * 4,
  large: gridSizeValue * 5,
  xlarge: gridSizeValue * 12,
  xxlarge: gridSizeValue * 16
};

// border radius only applies to "square" avatars
var AVATAR_RADIUS = {
  xsmall: 2,
  small: 2,
  medium: 3,
  large: 3,
  xlarge: 6,
  xxlarge: 12
};

var BORDER_WIDTH = {
  xsmall: 2,
  small: 2,
  medium: 2,
  large: 2,
  xlarge: 2,
  xxlarge: 2
};

// NOTE: sizes xsmall & xxlarge DO NOT support
// - groups
// - presence
// - status

var EXCESS_INDICATOR_FONT_SIZE = {
  small: 10,
  medium: 11,
  large: 12,
  xlarge: 16
};

var ICON_SIZES = {
  small: 12,
  medium: 14,
  large: 15,
  xlarge: 18
};

var ICON_OFFSET = {
  small: 0,
  medium: 0,
  large: 1,
  xlarge: 7
};

var SQUARE_ICON_OFFSET = {
  small: 0,
  medium: 0,
  large: 0,
  xlarge: 1
};

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = falsy;
/* unused harmony export history */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return component; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return components; });
/* unused harmony export route */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return routes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


function falsy(props, propName, componentName) {
  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
}

var history = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  listen: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  push: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  replace: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  go: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goBack: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goForward: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired
});

var component = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["func"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]]);
var components = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([component, __WEBPACK_IMPORTED_MODULE_0_prop_types__["object"]]);
var route = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["object"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["element"]]);
var routes = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([route, Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["arrayOf"])(route)]);

/***/ }),
/* 52 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(201);
var enumBugKeys = __webpack_require__(127);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(123);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 55 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R50", function() { return R50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R75", function() { return R75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R100", function() { return R100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R200", function() { return R200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R300", function() { return R300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R400", function() { return R400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R500", function() { return R500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y50", function() { return Y50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y75", function() { return Y75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y100", function() { return Y100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y200", function() { return Y200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y300", function() { return Y300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y400", function() { return Y400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y500", function() { return Y500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G50", function() { return G50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G75", function() { return G75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G100", function() { return G100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G200", function() { return G200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G300", function() { return G300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G400", function() { return G400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G500", function() { return G500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B50", function() { return B50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B75", function() { return B75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B100", function() { return B100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B200", function() { return B200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B300", function() { return B300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B400", function() { return B400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B500", function() { return B500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P50", function() { return P50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P75", function() { return P75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P100", function() { return P100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P200", function() { return P200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P300", function() { return P300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P400", function() { return P400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P500", function() { return P500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T50", function() { return T50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T75", function() { return T75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T100", function() { return T100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T200", function() { return T200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T300", function() { return T300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T400", function() { return T400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T500", function() { return T500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N0", function() { return N0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N10", function() { return N10; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N20", function() { return N20; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N30", function() { return N30; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N40", function() { return N40; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N50", function() { return N50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N60", function() { return N60; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N70", function() { return N70; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N80", function() { return N80; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N90", function() { return N90; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N100", function() { return N100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N200", function() { return N200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N300", function() { return N300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N400", function() { return N400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N500", function() { return N500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N600", function() { return N600; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N700", function() { return N700; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N800", function() { return N800; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N900", function() { return N900; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N10A", function() { return N10A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N20A", function() { return N20A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N30A", function() { return N30A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N40A", function() { return N40A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N50A", function() { return N50A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N60A", function() { return N60A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N70A", function() { return N70A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N80A", function() { return N80A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N90A", function() { return N90A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N100A", function() { return N100A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N200A", function() { return N200A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N300A", function() { return N300A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N400A", function() { return N400A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N500A", function() { return N500A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N600A", function() { return N600A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N700A", function() { return N700A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N800A", function() { return N800A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN900", function() { return DN900; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN800", function() { return DN800; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN700", function() { return DN700; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN600", function() { return DN600; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN500", function() { return DN500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN400", function() { return DN400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN300", function() { return DN300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN200", function() { return DN200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN100", function() { return DN100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN90", function() { return DN90; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN80", function() { return DN80; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN70", function() { return DN70; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN60", function() { return DN60; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN50", function() { return DN50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN40", function() { return DN40; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN30", function() { return DN30; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN20", function() { return DN20; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN10", function() { return DN10; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN0", function() { return DN0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN800A", function() { return DN800A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN700A", function() { return DN700A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN600A", function() { return DN600A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN500A", function() { return DN500A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN400A", function() { return DN400A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN300A", function() { return DN300A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN200A", function() { return DN200A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN100A", function() { return DN100A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN90A", function() { return DN90A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN80A", function() { return DN80A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN70A", function() { return DN70A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN60A", function() { return DN60A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN50A", function() { return DN50A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN40A", function() { return DN40A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN30A", function() { return DN30A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN20A", function() { return DN20A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN10A", function() { return DN10A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "background", function() { return background; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundActive", function() { return backgroundActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundHover", function() { return backgroundHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundOnLayer", function() { return backgroundOnLayer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "text", function() { return text; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "textHover", function() { return textHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "textActive", function() { return textActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subtleText", function() { return subtleText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "placeholderText", function() { return placeholderText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "heading", function() { return heading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subtleHeading", function() { return subtleHeading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "codeBlock", function() { return codeBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "link", function() { return link; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linkHover", function() { return linkHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linkActive", function() { return linkActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linkOutline", function() { return linkOutline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "primary", function() { return primary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "blue", function() { return blue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "teal", function() { return teal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "purple", function() { return purple; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "red", function() { return red; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "yellow", function() { return yellow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "green", function() { return green; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette8", function() { return colorPalette8; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette16", function() { return colorPalette16; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette24", function() { return colorPalette24; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette", function() { return colorPalette; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_themed__ = __webpack_require__(140);




// Reds
var R50 = '#FFEBE6';
var R75 = '#FFBDAD';
var R100 = '#FF8F73';
var R200 = '#FF7452';
var R300 = '#FF5630';
var R400 = '#DE350B';
var R500 = '#BF2600';

// Yellows
var Y50 = '#FFFAE6';
var Y75 = '#FFF0B3';
var Y100 = '#FFE380';
var Y200 = '#FFC400';
var Y300 = '#FFAB00';
var Y400 = '#FF991F';
var Y500 = '#FF8B00';

// Greens
var G50 = '#E3FCEF';
var G75 = '#ABF5D1';
var G100 = '#79F2C0';
var G200 = '#57D9A3';
var G300 = '#36B37E';
var G400 = '#00875A';
var G500 = '#006644';

// Blues
var B50 = '#DEEBFF';
var B75 = '#B3D4FF';
var B100 = '#4C9AFF';
var B200 = '#2684FF';
var B300 = '#0065FF';
var B400 = '#0052CC';
var B500 = '#0747A6';

// Purples
var P50 = '#EAE6FF';
var P75 = '#C0B6F2';
var P100 = '#998DD9';
var P200 = '#8777D9';
var P300 = '#6554C0';
var P400 = '#5243AA';
var P500 = '#403294';

// Teals
var T50 = '#E6FCFF';
var T75 = '#B3F5FF';
var T100 = '#79E2F2';
var T200 = '#00C7E6';
var T300 = '#00B8D9';
var T400 = '#00A3BF';
var T500 = '#008DA6';

// Neutrals
var N0 = '#FFFFFF';
var N10 = '#FAFBFC';
var N20 = '#F4F5F7';
var N30 = '#EBECF0';
var N40 = '#DFE1E6';
var N50 = '#C1C7D0';
var N60 = '#B3BAC5';
var N70 = '#A5ADBA';
var N80 = '#97A0AF';
var N90 = '#8993A4';
var N100 = '#7A869A';
var N200 = '#6B778C';
var N300 = '#5E6C84';
var N400 = '#505F79';
var N500 = '#42526E';
var N600 = '#344563';
var N700 = '#253858';
var N800 = '#172B4D';

// ATTENTION: update the tints if you update this
var N900 = '#091E42';

// Each tint is made of N900 and an alpha channel
var N10A = 'rgba(9, 30, 66, 0.02)';
var N20A = 'rgba(9, 30, 66, 0.04)';
var N30A = 'rgba(9, 30, 66, 0.08)';
var N40A = 'rgba(9, 30, 66, 0.13)';
var N50A = 'rgba(9, 30, 66, 0.25)';
var N60A = 'rgba(9, 30, 66, 0.31)';
var N70A = 'rgba(9, 30, 66, 0.36)';
var N80A = 'rgba(9, 30, 66, 0.42)';
var N90A = 'rgba(9, 30, 66, 0.48)';
var N100A = 'rgba(9, 30, 66, 0.54)';
var N200A = 'rgba(9, 30, 66, 0.60)';
var N300A = 'rgba(9, 30, 66, 0.66)';
var N400A = 'rgba(9, 30, 66, 0.71)';
var N500A = 'rgba(9, 30, 66, 0.77)';
var N600A = 'rgba(9, 30, 66, 0.82)';
var N700A = 'rgba(9, 30, 66, 0.89)';
var N800A = 'rgba(9, 30, 66, 0.95)';

// Dark Mode Neutrals
var DN900 = '#E6EDFA';
var DN800 = '#DCE5F5';
var DN700 = '#CED9EB';
var DN600 = '#B8C7E0';
var DN500 = '#ABBBD6';
var DN400 = '#9FB0CC';
var DN300 = '#8C9CB8';
var DN200 = '#7988A3';
var DN100 = '#67758F';
var DN90 = '#56637A';
var DN80 = '#455166';
var DN70 = '#3B475C';
var DN60 = '#313D52';
var DN50 = '#283447';
var DN40 = '#202B3D';
var DN30 = '#1B2638';
var DN20 = '#121A29';
var DN10 = '#0E1624';

// ATTENTION: update the tints if you update this
var DN0 = '#0D1424';

// Each dark tint is made of DN0 and an alpha channel
var DN800A = 'rgba(13, 20, 36, 0.06)';
var DN700A = 'rgba(13, 20, 36, 0.14)';
var DN600A = 'rgba(13, 20, 36, 0.18)';
var DN500A = 'rgba(13, 20, 36, 0.29)';
var DN400A = 'rgba(13, 20, 36, 0.36)';
var DN300A = 'rgba(13, 20, 36, 0.40)';
var DN200A = 'rgba(13, 20, 36, 0.47)';
var DN100A = 'rgba(13, 20, 36, 0.53)';
var DN90A = 'rgba(13, 20, 36, 0.63)';
var DN80A = 'rgba(13, 20, 36, 0.73)';
var DN70A = 'rgba(13, 20, 36, 0.78)';
var DN60A = 'rgba(13, 20, 36, 0.81)';
var DN50A = 'rgba(13, 20, 36, 0.85)';
var DN40A = 'rgba(13, 20, 36, 0.89)';
var DN30A = 'rgba(13, 20, 36, 0.92)';
var DN20A = 'rgba(13, 20, 36, 0.95)';
var DN10A = 'rgba(13, 20, 36, 0.97)';

// Themed colors
var background = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N0, dark: DN30 });
var backgroundActive = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B50, dark: B75 });
var backgroundHover = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N30, dark: DN70 });
var backgroundOnLayer = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N0, dark: DN50 });
var text = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N900, dark: DN600 });
var textHover = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N800, dark: DN600 });
var textActive = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B400, dark: B400 });
var subtleText = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N200, dark: DN300 });
var placeholderText = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N100, dark: DN200 });
var heading = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N800, dark: DN600 });
var subtleHeading = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N200, dark: DN300 });
var codeBlock = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N20, dark: DN50 });
var link = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B400, dark: B100 });
var linkHover = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B300, dark: B200 });
var linkActive = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B500, dark: B100 });
var linkOutline = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B100, dark: B200 });
var primary = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B400, dark: B100 });
var blue = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B400, dark: B100 });
var teal = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: T300, dark: T200 });
var purple = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: P300, dark: P100 });
var red = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: R300, dark: R300 });
var yellow = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: Y300, dark: Y300 });
var green = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: G300, dark: G300 });

// Jira Portfolio
var colorPalette8 = [{ background: N800, text: N0 }, { background: R400, text: N0 }, { background: P400, text: P50 }, { background: B400, text: B75 }, { background: T300, text: N800 }, { background: G400, text: N0 }, { background: Y400, text: N800 }, { background: N70, text: N800 }];

var colorPalette16 = [].concat(colorPalette8, [{ background: N500, text: N0 }, { background: R100, text: N800 }, { background: P75, text: N800 }, { background: B100, text: N800 }, { background: T100, text: N800 }, { background: G100, text: G500 }, { background: Y200, text: N800 }, { background: N0, text: N800 }]);

var colorPalette24 = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(colorPalette16), [{ background: N100, text: N0 }, { background: N40, text: N800 }, { background: N50, text: R500 }, { background: P50, text: P500 }, { background: B50, text: B500 }, { background: T75, text: N800 }, { background: G50, text: G500 }, { background: Y75, text: N800 }]);

var colorPalette = function colorPalette() {
  var palette = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '8';

  switch (palette) {
    case '8':
      return colorPalette8;
    case '16':
      return colorPalette16;
    case '24':
      return colorPalette24;
    default:
      throw new Error('The only available color palette is 8, 16, 24');
  }
};

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R50", function() { return R50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R75", function() { return R75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R100", function() { return R100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R200", function() { return R200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R300", function() { return R300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R400", function() { return R400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R500", function() { return R500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y50", function() { return Y50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y75", function() { return Y75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y100", function() { return Y100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y200", function() { return Y200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y300", function() { return Y300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y400", function() { return Y400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y500", function() { return Y500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G50", function() { return G50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G75", function() { return G75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G100", function() { return G100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G200", function() { return G200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G300", function() { return G300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G400", function() { return G400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G500", function() { return G500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B50", function() { return B50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B75", function() { return B75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B100", function() { return B100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B200", function() { return B200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B300", function() { return B300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B400", function() { return B400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B500", function() { return B500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P50", function() { return P50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P75", function() { return P75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P100", function() { return P100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P200", function() { return P200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P300", function() { return P300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P400", function() { return P400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P500", function() { return P500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T50", function() { return T50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T75", function() { return T75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T100", function() { return T100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T200", function() { return T200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T300", function() { return T300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T400", function() { return T400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T500", function() { return T500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N0", function() { return N0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N10", function() { return N10; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N20", function() { return N20; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N30", function() { return N30; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N40", function() { return N40; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N50", function() { return N50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N60", function() { return N60; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N70", function() { return N70; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N80", function() { return N80; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N90", function() { return N90; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N100", function() { return N100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N200", function() { return N200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N300", function() { return N300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N400", function() { return N400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N500", function() { return N500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N600", function() { return N600; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N700", function() { return N700; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N800", function() { return N800; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N900", function() { return N900; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N10A", function() { return N10A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N20A", function() { return N20A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N30A", function() { return N30A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N40A", function() { return N40A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N50A", function() { return N50A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N60A", function() { return N60A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N70A", function() { return N70A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N80A", function() { return N80A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N90A", function() { return N90A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N100A", function() { return N100A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N200A", function() { return N200A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N300A", function() { return N300A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N400A", function() { return N400A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N500A", function() { return N500A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N600A", function() { return N600A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N700A", function() { return N700A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N800A", function() { return N800A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN900", function() { return DN900; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN800", function() { return DN800; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN700", function() { return DN700; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN600", function() { return DN600; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN500", function() { return DN500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN400", function() { return DN400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN300", function() { return DN300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN200", function() { return DN200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN100", function() { return DN100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN90", function() { return DN90; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN80", function() { return DN80; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN70", function() { return DN70; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN60", function() { return DN60; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN50", function() { return DN50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN40", function() { return DN40; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN30", function() { return DN30; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN20", function() { return DN20; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN10", function() { return DN10; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN0", function() { return DN0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN800A", function() { return DN800A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN700A", function() { return DN700A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN600A", function() { return DN600A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN500A", function() { return DN500A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN400A", function() { return DN400A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN300A", function() { return DN300A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN200A", function() { return DN200A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN100A", function() { return DN100A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN90A", function() { return DN90A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN80A", function() { return DN80A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN70A", function() { return DN70A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN60A", function() { return DN60A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN50A", function() { return DN50A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN40A", function() { return DN40A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN30A", function() { return DN30A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN20A", function() { return DN20A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN10A", function() { return DN10A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "background", function() { return background; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundActive", function() { return backgroundActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundHover", function() { return backgroundHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundOnLayer", function() { return backgroundOnLayer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "text", function() { return text; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "textHover", function() { return textHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "textActive", function() { return textActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subtleText", function() { return subtleText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "placeholderText", function() { return placeholderText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "heading", function() { return heading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subtleHeading", function() { return subtleHeading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "codeBlock", function() { return codeBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "link", function() { return link; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linkHover", function() { return linkHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linkActive", function() { return linkActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linkOutline", function() { return linkOutline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "primary", function() { return primary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "blue", function() { return blue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "teal", function() { return teal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "purple", function() { return purple; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "red", function() { return red; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "yellow", function() { return yellow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "green", function() { return green; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette8", function() { return colorPalette8; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette16", function() { return colorPalette16; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette24", function() { return colorPalette24; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette", function() { return colorPalette; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_themed__ = __webpack_require__(142);




// Reds
var R50 = '#FFEBE6';
var R75 = '#FFBDAD';
var R100 = '#FF8F73';
var R200 = '#FF7452';
var R300 = '#FF5630';
var R400 = '#DE350B';
var R500 = '#BF2600';

// Yellows
var Y50 = '#FFFAE6';
var Y75 = '#FFF0B3';
var Y100 = '#FFE380';
var Y200 = '#FFC400';
var Y300 = '#FFAB00';
var Y400 = '#FF991F';
var Y500 = '#FF8B00';

// Greens
var G50 = '#E3FCEF';
var G75 = '#ABF5D1';
var G100 = '#79F2C0';
var G200 = '#57D9A3';
var G300 = '#36B37E';
var G400 = '#00875A';
var G500 = '#006644';

// Blues
var B50 = '#DEEBFF';
var B75 = '#B3D4FF';
var B100 = '#4C9AFF';
var B200 = '#2684FF';
var B300 = '#0065FF';
var B400 = '#0052CC';
var B500 = '#0747A6';

// Purples
var P50 = '#EAE6FF';
var P75 = '#C0B6F2';
var P100 = '#998DD9';
var P200 = '#8777D9';
var P300 = '#6554C0';
var P400 = '#5243AA';
var P500 = '#403294';

// Teals
var T50 = '#E6FCFF';
var T75 = '#B3F5FF';
var T100 = '#79E2F2';
var T200 = '#00C7E6';
var T300 = '#00B8D9';
var T400 = '#00A3BF';
var T500 = '#008DA6';

// Neutrals
var N0 = '#FFFFFF';
var N10 = '#FAFBFC';
var N20 = '#F4F5F7';
var N30 = '#EBECF0';
var N40 = '#DFE1E6';
var N50 = '#C1C7D0';
var N60 = '#B3BAC5';
var N70 = '#A5ADBA';
var N80 = '#97A0AF';
var N90 = '#8993A4';
var N100 = '#7A869A';
var N200 = '#6B778C';
var N300 = '#5E6C84';
var N400 = '#505F79';
var N500 = '#42526E';
var N600 = '#344563';
var N700 = '#253858';
var N800 = '#172B4D';

// ATTENTION: update the tints if you update this
var N900 = '#091E42';

// Each tint is made of N900 and an alpha channel
var N10A = 'rgba(9, 30, 66, 0.02)';
var N20A = 'rgba(9, 30, 66, 0.04)';
var N30A = 'rgba(9, 30, 66, 0.08)';
var N40A = 'rgba(9, 30, 66, 0.13)';
var N50A = 'rgba(9, 30, 66, 0.25)';
var N60A = 'rgba(9, 30, 66, 0.31)';
var N70A = 'rgba(9, 30, 66, 0.36)';
var N80A = 'rgba(9, 30, 66, 0.42)';
var N90A = 'rgba(9, 30, 66, 0.48)';
var N100A = 'rgba(9, 30, 66, 0.54)';
var N200A = 'rgba(9, 30, 66, 0.60)';
var N300A = 'rgba(9, 30, 66, 0.66)';
var N400A = 'rgba(9, 30, 66, 0.71)';
var N500A = 'rgba(9, 30, 66, 0.77)';
var N600A = 'rgba(9, 30, 66, 0.82)';
var N700A = 'rgba(9, 30, 66, 0.89)';
var N800A = 'rgba(9, 30, 66, 0.95)';

// Dark Mode Neutrals
var DN900 = '#E6EDFA';
var DN800 = '#DCE5F5';
var DN700 = '#CED9EB';
var DN600 = '#B8C7E0';
var DN500 = '#ABBBD6';
var DN400 = '#9FB0CC';
var DN300 = '#8C9CB8';
var DN200 = '#7988A3';
var DN100 = '#67758F';
var DN90 = '#56637A';
var DN80 = '#455166';
var DN70 = '#3B475C';
var DN60 = '#313D52';
var DN50 = '#283447';
var DN40 = '#202B3D';
var DN30 = '#1B2638';
var DN20 = '#121A29';
var DN10 = '#0E1624';

// ATTENTION: update the tints if you update this
var DN0 = '#0D1424';

// Each dark tint is made of DN0 and an alpha channel
var DN800A = 'rgba(13, 20, 36, 0.06)';
var DN700A = 'rgba(13, 20, 36, 0.14)';
var DN600A = 'rgba(13, 20, 36, 0.18)';
var DN500A = 'rgba(13, 20, 36, 0.29)';
var DN400A = 'rgba(13, 20, 36, 0.36)';
var DN300A = 'rgba(13, 20, 36, 0.40)';
var DN200A = 'rgba(13, 20, 36, 0.47)';
var DN100A = 'rgba(13, 20, 36, 0.53)';
var DN90A = 'rgba(13, 20, 36, 0.63)';
var DN80A = 'rgba(13, 20, 36, 0.73)';
var DN70A = 'rgba(13, 20, 36, 0.78)';
var DN60A = 'rgba(13, 20, 36, 0.81)';
var DN50A = 'rgba(13, 20, 36, 0.85)';
var DN40A = 'rgba(13, 20, 36, 0.89)';
var DN30A = 'rgba(13, 20, 36, 0.92)';
var DN20A = 'rgba(13, 20, 36, 0.95)';
var DN10A = 'rgba(13, 20, 36, 0.97)';

// Themed colors
var background = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N0, dark: DN30 });
var backgroundActive = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B50, dark: B75 });
var backgroundHover = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N30, dark: DN70 });
var backgroundOnLayer = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N0, dark: DN50 });
var text = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N900, dark: DN600 });
var textHover = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N800, dark: DN600 });
var textActive = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B400, dark: B400 });
var subtleText = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N200, dark: DN300 });
var placeholderText = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N100, dark: DN200 });
var heading = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N800, dark: DN600 });
var subtleHeading = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N200, dark: DN300 });
var codeBlock = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N20, dark: DN50 });
var link = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B400, dark: B100 });
var linkHover = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B300, dark: B200 });
var linkActive = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B500, dark: B100 });
var linkOutline = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B100, dark: B200 });
var primary = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B400, dark: B100 });
var blue = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B400, dark: B100 });
var teal = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: T300, dark: T200 });
var purple = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: P300, dark: P100 });
var red = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: R300, dark: R300 });
var yellow = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: Y300, dark: Y300 });
var green = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: G300, dark: G300 });

// Jira Portfolio
var colorPalette8 = [{ background: N800, text: N0 }, { background: R400, text: N0 }, { background: P400, text: P50 }, { background: B400, text: B75 }, { background: T300, text: N800 }, { background: G400, text: N0 }, { background: Y400, text: N800 }, { background: N70, text: N800 }];

var colorPalette16 = [].concat(colorPalette8, [{ background: N500, text: N0 }, { background: R100, text: N800 }, { background: P75, text: N800 }, { background: B100, text: N800 }, { background: T100, text: N800 }, { background: G100, text: G500 }, { background: Y200, text: N800 }, { background: N0, text: N800 }]);

var colorPalette24 = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(colorPalette16), [{ background: N100, text: N0 }, { background: N40, text: N800 }, { background: N50, text: R500 }, { background: P50, text: P500 }, { background: B50, text: B500 }, { background: T75, text: N800 }, { background: G50, text: G500 }, { background: Y75, text: N800 }]);

var colorPalette = function colorPalette() {
  var palette = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '8';

  switch (palette) {
    case '8':
      return colorPalette8;
    case '16':
      return colorPalette16;
    case '24':
      return colorPalette24;
    default:
      throw new Error('The only available color palette is 8, 16, 24');
  }
};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var toArray = exports.toArray = function toArray(a) {
  var ret = Array(a.length);
  for (var i = 0; i < a.length; i++) {
    ret[i] = a[i];
  }
  return ret;
};

var arrayFind = exports.arrayFind = function arrayFind(array, search) {
  return array.filter(function (a) {
    return a === search;
  })[0];
};

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R50", function() { return R50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R75", function() { return R75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R100", function() { return R100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R200", function() { return R200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R300", function() { return R300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R400", function() { return R400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R500", function() { return R500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y50", function() { return Y50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y75", function() { return Y75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y100", function() { return Y100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y200", function() { return Y200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y300", function() { return Y300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y400", function() { return Y400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y500", function() { return Y500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G50", function() { return G50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G75", function() { return G75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G100", function() { return G100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G200", function() { return G200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G300", function() { return G300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G400", function() { return G400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G500", function() { return G500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B50", function() { return B50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B75", function() { return B75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B100", function() { return B100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B200", function() { return B200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B300", function() { return B300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B400", function() { return B400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B500", function() { return B500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P50", function() { return P50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P75", function() { return P75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P100", function() { return P100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P200", function() { return P200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P300", function() { return P300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P400", function() { return P400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P500", function() { return P500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T50", function() { return T50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T75", function() { return T75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T100", function() { return T100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T200", function() { return T200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T300", function() { return T300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T400", function() { return T400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T500", function() { return T500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N0", function() { return N0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N10", function() { return N10; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N20", function() { return N20; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N30", function() { return N30; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N40", function() { return N40; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N50", function() { return N50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N60", function() { return N60; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N70", function() { return N70; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N80", function() { return N80; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N90", function() { return N90; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N100", function() { return N100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N200", function() { return N200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N300", function() { return N300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N400", function() { return N400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N500", function() { return N500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N600", function() { return N600; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N700", function() { return N700; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N800", function() { return N800; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N900", function() { return N900; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N10A", function() { return N10A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N20A", function() { return N20A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N30A", function() { return N30A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N40A", function() { return N40A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N50A", function() { return N50A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N60A", function() { return N60A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N70A", function() { return N70A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N80A", function() { return N80A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N90A", function() { return N90A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N100A", function() { return N100A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N200A", function() { return N200A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N300A", function() { return N300A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N400A", function() { return N400A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N500A", function() { return N500A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N600A", function() { return N600A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N700A", function() { return N700A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N800A", function() { return N800A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN900", function() { return DN900; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN800", function() { return DN800; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN700", function() { return DN700; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN600", function() { return DN600; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN500", function() { return DN500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN400", function() { return DN400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN300", function() { return DN300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN200", function() { return DN200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN100", function() { return DN100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN90", function() { return DN90; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN80", function() { return DN80; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN70", function() { return DN70; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN60", function() { return DN60; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN50", function() { return DN50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN40", function() { return DN40; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN30", function() { return DN30; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN20", function() { return DN20; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN10", function() { return DN10; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN0", function() { return DN0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN800A", function() { return DN800A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN700A", function() { return DN700A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN600A", function() { return DN600A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN500A", function() { return DN500A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN400A", function() { return DN400A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN300A", function() { return DN300A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN200A", function() { return DN200A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN100A", function() { return DN100A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN90A", function() { return DN90A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN80A", function() { return DN80A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN70A", function() { return DN70A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN60A", function() { return DN60A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN50A", function() { return DN50A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN40A", function() { return DN40A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN30A", function() { return DN30A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN20A", function() { return DN20A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN10A", function() { return DN10A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "background", function() { return background; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundActive", function() { return backgroundActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundHover", function() { return backgroundHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundOnLayer", function() { return backgroundOnLayer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "text", function() { return text; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "textHover", function() { return textHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "textActive", function() { return textActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subtleText", function() { return subtleText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "placeholderText", function() { return placeholderText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "heading", function() { return heading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subtleHeading", function() { return subtleHeading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "codeBlock", function() { return codeBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "link", function() { return link; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linkHover", function() { return linkHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linkActive", function() { return linkActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linkOutline", function() { return linkOutline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "primary", function() { return primary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "blue", function() { return blue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "teal", function() { return teal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "purple", function() { return purple; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "red", function() { return red; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "yellow", function() { return yellow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "green", function() { return green; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette8", function() { return colorPalette8; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette16", function() { return colorPalette16; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette24", function() { return colorPalette24; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette", function() { return colorPalette; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_themed__ = __webpack_require__(150);




// Reds
var R50 = '#FFEBE6';
var R75 = '#FFBDAD';
var R100 = '#FF8F73';
var R200 = '#FF7452';
var R300 = '#FF5630';
var R400 = '#DE350B';
var R500 = '#BF2600';

// Yellows
var Y50 = '#FFFAE6';
var Y75 = '#FFF0B3';
var Y100 = '#FFE380';
var Y200 = '#FFC400';
var Y300 = '#FFAB00';
var Y400 = '#FF991F';
var Y500 = '#FF8B00';

// Greens
var G50 = '#E3FCEF';
var G75 = '#ABF5D1';
var G100 = '#79F2C0';
var G200 = '#57D9A3';
var G300 = '#36B37E';
var G400 = '#00875A';
var G500 = '#006644';

// Blues
var B50 = '#DEEBFF';
var B75 = '#B3D4FF';
var B100 = '#4C9AFF';
var B200 = '#2684FF';
var B300 = '#0065FF';
var B400 = '#0052CC';
var B500 = '#0747A6';

// Purples
var P50 = '#EAE6FF';
var P75 = '#C0B6F2';
var P100 = '#998DD9';
var P200 = '#8777D9';
var P300 = '#6554C0';
var P400 = '#5243AA';
var P500 = '#403294';

// Teals
var T50 = '#E6FCFF';
var T75 = '#B3F5FF';
var T100 = '#79E2F2';
var T200 = '#00C7E6';
var T300 = '#00B8D9';
var T400 = '#00A3BF';
var T500 = '#008DA6';

// Neutrals
var N0 = '#FFFFFF';
var N10 = '#FAFBFC';
var N20 = '#F4F5F7';
var N30 = '#EBECF0';
var N40 = '#DFE1E6';
var N50 = '#C1C7D0';
var N60 = '#B3BAC5';
var N70 = '#A5ADBA';
var N80 = '#97A0AF';
var N90 = '#8993A4';
var N100 = '#7A869A';
var N200 = '#6B778C';
var N300 = '#5E6C84';
var N400 = '#505F79';
var N500 = '#42526E';
var N600 = '#344563';
var N700 = '#253858';
var N800 = '#172B4D';

// ATTENTION: update the tints if you update this
var N900 = '#091E42';

// Each tint is made of N900 and an alpha channel
var N10A = 'rgba(9, 30, 66, 0.02)';
var N20A = 'rgba(9, 30, 66, 0.04)';
var N30A = 'rgba(9, 30, 66, 0.08)';
var N40A = 'rgba(9, 30, 66, 0.13)';
var N50A = 'rgba(9, 30, 66, 0.25)';
var N60A = 'rgba(9, 30, 66, 0.31)';
var N70A = 'rgba(9, 30, 66, 0.36)';
var N80A = 'rgba(9, 30, 66, 0.42)';
var N90A = 'rgba(9, 30, 66, 0.48)';
var N100A = 'rgba(9, 30, 66, 0.54)';
var N200A = 'rgba(9, 30, 66, 0.60)';
var N300A = 'rgba(9, 30, 66, 0.66)';
var N400A = 'rgba(9, 30, 66, 0.71)';
var N500A = 'rgba(9, 30, 66, 0.77)';
var N600A = 'rgba(9, 30, 66, 0.82)';
var N700A = 'rgba(9, 30, 66, 0.89)';
var N800A = 'rgba(9, 30, 66, 0.95)';

// Dark Mode Neutrals
var DN900 = '#E6EDFA';
var DN800 = '#DCE5F5';
var DN700 = '#CED9EB';
var DN600 = '#B8C7E0';
var DN500 = '#ABBBD6';
var DN400 = '#9FB0CC';
var DN300 = '#8C9CB8';
var DN200 = '#7988A3';
var DN100 = '#67758F';
var DN90 = '#56637A';
var DN80 = '#455166';
var DN70 = '#3B475C';
var DN60 = '#313D52';
var DN50 = '#283447';
var DN40 = '#202B3D';
var DN30 = '#1B2638';
var DN20 = '#121A29';
var DN10 = '#0E1624';

// ATTENTION: update the tints if you update this
var DN0 = '#0D1424';

// Each dark tint is made of DN0 and an alpha channel
var DN800A = 'rgba(13, 20, 36, 0.06)';
var DN700A = 'rgba(13, 20, 36, 0.14)';
var DN600A = 'rgba(13, 20, 36, 0.18)';
var DN500A = 'rgba(13, 20, 36, 0.29)';
var DN400A = 'rgba(13, 20, 36, 0.36)';
var DN300A = 'rgba(13, 20, 36, 0.40)';
var DN200A = 'rgba(13, 20, 36, 0.47)';
var DN100A = 'rgba(13, 20, 36, 0.53)';
var DN90A = 'rgba(13, 20, 36, 0.63)';
var DN80A = 'rgba(13, 20, 36, 0.73)';
var DN70A = 'rgba(13, 20, 36, 0.78)';
var DN60A = 'rgba(13, 20, 36, 0.81)';
var DN50A = 'rgba(13, 20, 36, 0.85)';
var DN40A = 'rgba(13, 20, 36, 0.89)';
var DN30A = 'rgba(13, 20, 36, 0.92)';
var DN20A = 'rgba(13, 20, 36, 0.95)';
var DN10A = 'rgba(13, 20, 36, 0.97)';

// Themed colors
var background = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N0, dark: DN30 });
var backgroundActive = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B50, dark: B75 });
var backgroundHover = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N30, dark: DN70 });
var backgroundOnLayer = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N0, dark: DN50 });
var text = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N900, dark: DN600 });
var textHover = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N800, dark: DN600 });
var textActive = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B400, dark: B400 });
var subtleText = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N200, dark: DN300 });
var placeholderText = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N100, dark: DN200 });
var heading = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N800, dark: DN600 });
var subtleHeading = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N200, dark: DN300 });
var codeBlock = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N20, dark: DN50 });
var link = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B400, dark: B100 });
var linkHover = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B300, dark: B200 });
var linkActive = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B500, dark: B100 });
var linkOutline = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B100, dark: B200 });
var primary = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B400, dark: B100 });
var blue = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B400, dark: B100 });
var teal = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: T300, dark: T200 });
var purple = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: P300, dark: P100 });
var red = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: R300, dark: R300 });
var yellow = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: Y300, dark: Y300 });
var green = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: G300, dark: G300 });

// Jira Portfolio
var colorPalette8 = [{ background: N800, text: N0 }, { background: R400, text: N0 }, { background: P400, text: P50 }, { background: B400, text: B75 }, { background: T300, text: N800 }, { background: G400, text: N0 }, { background: Y400, text: N800 }, { background: N70, text: N800 }];

var colorPalette16 = [].concat(colorPalette8, [{ background: N500, text: N0 }, { background: R100, text: N800 }, { background: P75, text: N800 }, { background: B100, text: N800 }, { background: T100, text: N800 }, { background: G100, text: G500 }, { background: Y200, text: N800 }, { background: N0, text: N800 }]);

var colorPalette24 = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(colorPalette16), [{ background: N100, text: N0 }, { background: N40, text: N800 }, { background: N50, text: R500 }, { background: P50, text: P500 }, { background: B50, text: B500 }, { background: T75, text: N800 }, { background: G50, text: G500 }, { background: Y75, text: N800 }]);

var colorPalette = function colorPalette() {
  var palette = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '8';

  switch (palette) {
    case '8':
      return colorPalette8;
    case '16':
      return colorPalette16;
    case '24':
      return colorPalette24;
    default:
      throw new Error('The only available color palette is 8, 16, 24');
  }
};

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R50", function() { return R50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R75", function() { return R75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R100", function() { return R100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R200", function() { return R200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R300", function() { return R300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R400", function() { return R400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R500", function() { return R500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y50", function() { return Y50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y75", function() { return Y75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y100", function() { return Y100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y200", function() { return Y200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y300", function() { return Y300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y400", function() { return Y400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y500", function() { return Y500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G50", function() { return G50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G75", function() { return G75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G100", function() { return G100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G200", function() { return G200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G300", function() { return G300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G400", function() { return G400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G500", function() { return G500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B50", function() { return B50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B75", function() { return B75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B100", function() { return B100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B200", function() { return B200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B300", function() { return B300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B400", function() { return B400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B500", function() { return B500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P50", function() { return P50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P75", function() { return P75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P100", function() { return P100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P200", function() { return P200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P300", function() { return P300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P400", function() { return P400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P500", function() { return P500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T50", function() { return T50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T75", function() { return T75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T100", function() { return T100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T200", function() { return T200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T300", function() { return T300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T400", function() { return T400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T500", function() { return T500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N0", function() { return N0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N10", function() { return N10; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N20", function() { return N20; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N30", function() { return N30; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N40", function() { return N40; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N50", function() { return N50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N60", function() { return N60; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N70", function() { return N70; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N80", function() { return N80; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N90", function() { return N90; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N100", function() { return N100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N200", function() { return N200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N300", function() { return N300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N400", function() { return N400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N500", function() { return N500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N600", function() { return N600; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N700", function() { return N700; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N800", function() { return N800; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N900", function() { return N900; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N10A", function() { return N10A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N20A", function() { return N20A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N30A", function() { return N30A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N40A", function() { return N40A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N50A", function() { return N50A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N60A", function() { return N60A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N70A", function() { return N70A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N80A", function() { return N80A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N90A", function() { return N90A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N100A", function() { return N100A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N200A", function() { return N200A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N300A", function() { return N300A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N400A", function() { return N400A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N500A", function() { return N500A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N600A", function() { return N600A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N700A", function() { return N700A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N800A", function() { return N800A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN900", function() { return DN900; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN800", function() { return DN800; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN700", function() { return DN700; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN600", function() { return DN600; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN500", function() { return DN500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN400", function() { return DN400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN300", function() { return DN300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN200", function() { return DN200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN100", function() { return DN100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN90", function() { return DN90; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN80", function() { return DN80; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN70", function() { return DN70; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN60", function() { return DN60; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN50", function() { return DN50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN40", function() { return DN40; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN30", function() { return DN30; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN20", function() { return DN20; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN10", function() { return DN10; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN0", function() { return DN0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN800A", function() { return DN800A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN700A", function() { return DN700A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN600A", function() { return DN600A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN500A", function() { return DN500A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN400A", function() { return DN400A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN300A", function() { return DN300A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN200A", function() { return DN200A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN100A", function() { return DN100A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN90A", function() { return DN90A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN80A", function() { return DN80A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN70A", function() { return DN70A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN60A", function() { return DN60A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN50A", function() { return DN50A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN40A", function() { return DN40A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN30A", function() { return DN30A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN20A", function() { return DN20A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN10A", function() { return DN10A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "background", function() { return background; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundActive", function() { return backgroundActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundHover", function() { return backgroundHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundOnLayer", function() { return backgroundOnLayer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "text", function() { return text; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "textHover", function() { return textHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "textActive", function() { return textActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subtleText", function() { return subtleText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "placeholderText", function() { return placeholderText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "heading", function() { return heading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subtleHeading", function() { return subtleHeading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "codeBlock", function() { return codeBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "link", function() { return link; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linkHover", function() { return linkHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linkActive", function() { return linkActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linkOutline", function() { return linkOutline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "primary", function() { return primary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "blue", function() { return blue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "teal", function() { return teal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "purple", function() { return purple; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "red", function() { return red; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "yellow", function() { return yellow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "green", function() { return green; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette8", function() { return colorPalette8; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette16", function() { return colorPalette16; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette24", function() { return colorPalette24; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette", function() { return colorPalette; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_themed__ = __webpack_require__(153);




// Reds
var R50 = '#FFEBE6';
var R75 = '#FFBDAD';
var R100 = '#FF8F73';
var R200 = '#FF7452';
var R300 = '#FF5630';
var R400 = '#DE350B';
var R500 = '#BF2600';

// Yellows
var Y50 = '#FFFAE6';
var Y75 = '#FFF0B3';
var Y100 = '#FFE380';
var Y200 = '#FFC400';
var Y300 = '#FFAB00';
var Y400 = '#FF991F';
var Y500 = '#FF8B00';

// Greens
var G50 = '#E3FCEF';
var G75 = '#ABF5D1';
var G100 = '#79F2C0';
var G200 = '#57D9A3';
var G300 = '#36B37E';
var G400 = '#00875A';
var G500 = '#006644';

// Blues
var B50 = '#DEEBFF';
var B75 = '#B3D4FF';
var B100 = '#4C9AFF';
var B200 = '#2684FF';
var B300 = '#0065FF';
var B400 = '#0052CC';
var B500 = '#0747A6';

// Purples
var P50 = '#EAE6FF';
var P75 = '#C0B6F2';
var P100 = '#998DD9';
var P200 = '#8777D9';
var P300 = '#6554C0';
var P400 = '#5243AA';
var P500 = '#403294';

// Teals
var T50 = '#E6FCFF';
var T75 = '#B3F5FF';
var T100 = '#79E2F2';
var T200 = '#00C7E6';
var T300 = '#00B8D9';
var T400 = '#00A3BF';
var T500 = '#008DA6';

// Neutrals
var N0 = '#FFFFFF';
var N10 = '#FAFBFC';
var N20 = '#F4F5F7';
var N30 = '#EBECF0';
var N40 = '#DFE1E6';
var N50 = '#C1C7D0';
var N60 = '#B3BAC5';
var N70 = '#A5ADBA';
var N80 = '#97A0AF';
var N90 = '#8993A4';
var N100 = '#7A869A';
var N200 = '#6B778C';
var N300 = '#5E6C84';
var N400 = '#505F79';
var N500 = '#42526E';
var N600 = '#344563';
var N700 = '#253858';
var N800 = '#172B4D';

// ATTENTION: update the tints if you update this
var N900 = '#091E42';

// Each tint is made of N900 and an alpha channel
var N10A = 'rgba(9, 30, 66, 0.02)';
var N20A = 'rgba(9, 30, 66, 0.04)';
var N30A = 'rgba(9, 30, 66, 0.08)';
var N40A = 'rgba(9, 30, 66, 0.13)';
var N50A = 'rgba(9, 30, 66, 0.25)';
var N60A = 'rgba(9, 30, 66, 0.31)';
var N70A = 'rgba(9, 30, 66, 0.36)';
var N80A = 'rgba(9, 30, 66, 0.42)';
var N90A = 'rgba(9, 30, 66, 0.48)';
var N100A = 'rgba(9, 30, 66, 0.54)';
var N200A = 'rgba(9, 30, 66, 0.60)';
var N300A = 'rgba(9, 30, 66, 0.66)';
var N400A = 'rgba(9, 30, 66, 0.71)';
var N500A = 'rgba(9, 30, 66, 0.77)';
var N600A = 'rgba(9, 30, 66, 0.82)';
var N700A = 'rgba(9, 30, 66, 0.89)';
var N800A = 'rgba(9, 30, 66, 0.95)';

// Dark Mode Neutrals
var DN900 = '#E6EDFA';
var DN800 = '#DCE5F5';
var DN700 = '#CED9EB';
var DN600 = '#B8C7E0';
var DN500 = '#ABBBD6';
var DN400 = '#9FB0CC';
var DN300 = '#8C9CB8';
var DN200 = '#7988A3';
var DN100 = '#67758F';
var DN90 = '#56637A';
var DN80 = '#455166';
var DN70 = '#3B475C';
var DN60 = '#313D52';
var DN50 = '#283447';
var DN40 = '#202B3D';
var DN30 = '#1B2638';
var DN20 = '#121A29';
var DN10 = '#0E1624';

// ATTENTION: update the tints if you update this
var DN0 = '#0D1424';

// Each dark tint is made of DN0 and an alpha channel
var DN800A = 'rgba(13, 20, 36, 0.06)';
var DN700A = 'rgba(13, 20, 36, 0.14)';
var DN600A = 'rgba(13, 20, 36, 0.18)';
var DN500A = 'rgba(13, 20, 36, 0.29)';
var DN400A = 'rgba(13, 20, 36, 0.36)';
var DN300A = 'rgba(13, 20, 36, 0.40)';
var DN200A = 'rgba(13, 20, 36, 0.47)';
var DN100A = 'rgba(13, 20, 36, 0.53)';
var DN90A = 'rgba(13, 20, 36, 0.63)';
var DN80A = 'rgba(13, 20, 36, 0.73)';
var DN70A = 'rgba(13, 20, 36, 0.78)';
var DN60A = 'rgba(13, 20, 36, 0.81)';
var DN50A = 'rgba(13, 20, 36, 0.85)';
var DN40A = 'rgba(13, 20, 36, 0.89)';
var DN30A = 'rgba(13, 20, 36, 0.92)';
var DN20A = 'rgba(13, 20, 36, 0.95)';
var DN10A = 'rgba(13, 20, 36, 0.97)';

// Themed colors
var background = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N0, dark: DN30 });
var backgroundActive = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B50, dark: B75 });
var backgroundHover = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N30, dark: DN70 });
var backgroundOnLayer = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N0, dark: DN50 });
var text = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N900, dark: DN600 });
var textHover = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N800, dark: DN600 });
var textActive = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B400, dark: B400 });
var subtleText = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N200, dark: DN300 });
var placeholderText = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N100, dark: DN200 });
var heading = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N800, dark: DN600 });
var subtleHeading = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N200, dark: DN300 });
var codeBlock = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N20, dark: DN50 });
var link = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B400, dark: B100 });
var linkHover = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B300, dark: B200 });
var linkActive = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B500, dark: B100 });
var linkOutline = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B100, dark: B200 });
var primary = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B400, dark: B100 });
var blue = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B400, dark: B100 });
var teal = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: T300, dark: T200 });
var purple = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: P300, dark: P100 });
var red = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: R300, dark: R300 });
var yellow = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: Y300, dark: Y300 });
var green = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: G300, dark: G300 });

// Jira Portfolio
var colorPalette8 = [{ background: N800, text: N0 }, { background: R400, text: N0 }, { background: P400, text: P50 }, { background: B400, text: B75 }, { background: T300, text: N800 }, { background: G400, text: N0 }, { background: Y400, text: N800 }, { background: N70, text: N800 }];

var colorPalette16 = [].concat(colorPalette8, [{ background: N500, text: N0 }, { background: R100, text: N800 }, { background: P75, text: N800 }, { background: B100, text: N800 }, { background: T100, text: N800 }, { background: G100, text: G500 }, { background: Y200, text: N800 }, { background: N0, text: N800 }]);

var colorPalette24 = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(colorPalette16), [{ background: N100, text: N0 }, { background: N40, text: N800 }, { background: N50, text: R500 }, { background: P50, text: P500 }, { background: B50, text: B500 }, { background: T75, text: N800 }, { background: G50, text: G500 }, { background: Y75, text: N800 }]);

var colorPalette = function colorPalette() {
  var palette = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '8';

  switch (palette) {
    case '8':
      return colorPalette8;
    case '16':
      return colorPalette16;
    case '24':
      return colorPalette24;
    default:
      throw new Error('The only available color palette is 8, 16, 24');
  }
};

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = (function (fn) {
  var lastArgs = [];
  var frameId = null;

  var wrapperFn = function wrapperFn() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    lastArgs = args;

    if (frameId) {
      return frameId;
    }

    frameId = requestAnimationFrame(function () {
      frameId = null;
      fn.apply(undefined, lastArgs);
    });

    return frameId;
  };

  wrapperFn.cancel = function () {
    if (!frameId) {
      return;
    }

    cancelAnimationFrame(frameId);
    frameId = null;
  };

  var resultFn = wrapperFn;

  return resultFn;
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AtlasKitThemeProvider */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return borderRadius; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return gridSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fontSize; });
/* unused harmony export fontFamily */
/* unused harmony export codeFontFamily */
/* unused harmony export layers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elevation__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__typography__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_math__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_getTheme__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_themed__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AtlaskitThemeProvider__ = __webpack_require__(536);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__colors__; });
/* unused harmony reexport elevation */
/* unused harmony reexport typography */
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__utils_math__; });
/* unused harmony reexport getTheme */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__utils_themed__["a"]; });
/* unused harmony reexport AtlaskitThemeProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Appearance__ = __webpack_require__(537);
/* unused harmony reexport Appearance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Context__ = __webpack_require__(88);
/* unused harmony reexport Consumer */
/* unused harmony reexport Provider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Reset__ = __webpack_require__(538);
/* unused harmony reexport Reset */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Theme__ = __webpack_require__(539);
/* unused harmony reexport Theme */











// backwards-compatible export with old Atlaskit case
var AtlasKitThemeProvider = __WEBPACK_IMPORTED_MODULE_6__components_AtlaskitThemeProvider__["a" /* default */];

/*
  These theme values are expressed as functions so that if we decide to make
  them dependent on props in the future, it wouldn't require a significant
  refactor everywhere they are being used.
*/
var borderRadius = function borderRadius() {
  return 3;
};
var gridSize = function gridSize() {
  return 8;
};
var fontSize = function fontSize() {
  return 14;
};
var fontFamily = function fontFamily() {
  return '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif';
};
var codeFontFamily = function codeFontFamily() {
  return '"SFMono-Medium", "SF Mono", "Segoe UI Mono", "Roboto Mono", "Ubuntu Mono", Menlo, Consolas, Courier, monospace';
};

var layers = {
  card: function card() {
    return 100;
  },
  dialog: function dialog() {
    return 200;
  },
  navigation: function navigation() {
    return 300;
  },
  layer: function layer() {
    return 400;
  },
  blanket: function blanket() {
    return 500;
  },
  modal: function modal() {
    return 510;
  },
  flag: function flag() {
    return 600;
  },
  spotlight: function spotlight() {
    return 700;
  },
  tooltip: function tooltip() {
    return 800;
  }
};

// New API




/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R50", function() { return R50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R75", function() { return R75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R100", function() { return R100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R200", function() { return R200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R300", function() { return R300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R400", function() { return R400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R500", function() { return R500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y50", function() { return Y50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y75", function() { return Y75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y100", function() { return Y100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y200", function() { return Y200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y300", function() { return Y300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y400", function() { return Y400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y500", function() { return Y500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G50", function() { return G50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G75", function() { return G75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G100", function() { return G100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G200", function() { return G200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G300", function() { return G300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G400", function() { return G400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G500", function() { return G500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B50", function() { return B50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B75", function() { return B75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B100", function() { return B100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B200", function() { return B200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B300", function() { return B300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B400", function() { return B400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B500", function() { return B500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P50", function() { return P50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P75", function() { return P75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P100", function() { return P100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P200", function() { return P200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P300", function() { return P300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P400", function() { return P400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P500", function() { return P500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T50", function() { return T50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T75", function() { return T75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T100", function() { return T100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T200", function() { return T200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T300", function() { return T300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T400", function() { return T400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T500", function() { return T500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N0", function() { return N0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N10", function() { return N10; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N20", function() { return N20; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N30", function() { return N30; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N40", function() { return N40; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N50", function() { return N50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N60", function() { return N60; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N70", function() { return N70; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N80", function() { return N80; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N90", function() { return N90; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N100", function() { return N100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N200", function() { return N200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N300", function() { return N300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N400", function() { return N400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N500", function() { return N500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N600", function() { return N600; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N700", function() { return N700; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N800", function() { return N800; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N900", function() { return N900; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N10A", function() { return N10A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N20A", function() { return N20A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N30A", function() { return N30A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N40A", function() { return N40A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N50A", function() { return N50A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N60A", function() { return N60A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N70A", function() { return N70A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N80A", function() { return N80A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N90A", function() { return N90A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N100A", function() { return N100A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N200A", function() { return N200A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N300A", function() { return N300A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N400A", function() { return N400A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N500A", function() { return N500A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N600A", function() { return N600A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N700A", function() { return N700A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N800A", function() { return N800A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN900", function() { return DN900; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN800", function() { return DN800; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN700", function() { return DN700; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN600", function() { return DN600; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN500", function() { return DN500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN400", function() { return DN400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN300", function() { return DN300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN200", function() { return DN200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN100", function() { return DN100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN90", function() { return DN90; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN80", function() { return DN80; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN70", function() { return DN70; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN60", function() { return DN60; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN50", function() { return DN50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN40", function() { return DN40; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN30", function() { return DN30; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN20", function() { return DN20; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN10", function() { return DN10; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN0", function() { return DN0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN800A", function() { return DN800A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN700A", function() { return DN700A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN600A", function() { return DN600A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN500A", function() { return DN500A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN400A", function() { return DN400A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN300A", function() { return DN300A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN200A", function() { return DN200A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN100A", function() { return DN100A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN90A", function() { return DN90A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN80A", function() { return DN80A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN70A", function() { return DN70A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN60A", function() { return DN60A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN50A", function() { return DN50A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN40A", function() { return DN40A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN30A", function() { return DN30A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN20A", function() { return DN20A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN10A", function() { return DN10A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "background", function() { return background; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundActive", function() { return backgroundActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundHover", function() { return backgroundHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundOnLayer", function() { return backgroundOnLayer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "text", function() { return text; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "textHover", function() { return textHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "textActive", function() { return textActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subtleText", function() { return subtleText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "placeholderText", function() { return placeholderText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "heading", function() { return heading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subtleHeading", function() { return subtleHeading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "codeBlock", function() { return codeBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "link", function() { return link; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linkHover", function() { return linkHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linkActive", function() { return linkActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linkOutline", function() { return linkOutline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "primary", function() { return primary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "blue", function() { return blue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "teal", function() { return teal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "purple", function() { return purple; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "red", function() { return red; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "yellow", function() { return yellow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "green", function() { return green; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette8", function() { return colorPalette8; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette16", function() { return colorPalette16; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette24", function() { return colorPalette24; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette", function() { return colorPalette; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_themed__ = __webpack_require__(155);




// Reds
var R50 = '#FFEBE6';
var R75 = '#FFBDAD';
var R100 = '#FF8F73';
var R200 = '#FF7452';
var R300 = '#FF5630';
var R400 = '#DE350B';
var R500 = '#BF2600';

// Yellows
var Y50 = '#FFFAE6';
var Y75 = '#FFF0B3';
var Y100 = '#FFE380';
var Y200 = '#FFC400';
var Y300 = '#FFAB00';
var Y400 = '#FF991F';
var Y500 = '#FF8B00';

// Greens
var G50 = '#E3FCEF';
var G75 = '#ABF5D1';
var G100 = '#79F2C0';
var G200 = '#57D9A3';
var G300 = '#36B37E';
var G400 = '#00875A';
var G500 = '#006644';

// Blues
var B50 = '#DEEBFF';
var B75 = '#B3D4FF';
var B100 = '#4C9AFF';
var B200 = '#2684FF';
var B300 = '#0065FF';
var B400 = '#0052CC';
var B500 = '#0747A6';

// Purples
var P50 = '#EAE6FF';
var P75 = '#C0B6F2';
var P100 = '#998DD9';
var P200 = '#8777D9';
var P300 = '#6554C0';
var P400 = '#5243AA';
var P500 = '#403294';

// Teals
var T50 = '#E6FCFF';
var T75 = '#B3F5FF';
var T100 = '#79E2F2';
var T200 = '#00C7E6';
var T300 = '#00B8D9';
var T400 = '#00A3BF';
var T500 = '#008DA6';

// Neutrals
var N0 = '#FFFFFF';
var N10 = '#FAFBFC';
var N20 = '#F4F5F7';
var N30 = '#EBECF0';
var N40 = '#DFE1E6';
var N50 = '#C1C7D0';
var N60 = '#B3BAC5';
var N70 = '#A5ADBA';
var N80 = '#97A0AF';
var N90 = '#8993A4';
var N100 = '#7A869A';
var N200 = '#6B778C';
var N300 = '#5E6C84';
var N400 = '#505F79';
var N500 = '#42526E';
var N600 = '#344563';
var N700 = '#253858';
var N800 = '#172B4D';

// ATTENTION: update the tints if you update this
var N900 = '#091E42';

// Each tint is made of N900 and an alpha channel
var N10A = 'rgba(9, 30, 66, 0.02)';
var N20A = 'rgba(9, 30, 66, 0.04)';
var N30A = 'rgba(9, 30, 66, 0.08)';
var N40A = 'rgba(9, 30, 66, 0.13)';
var N50A = 'rgba(9, 30, 66, 0.25)';
var N60A = 'rgba(9, 30, 66, 0.31)';
var N70A = 'rgba(9, 30, 66, 0.36)';
var N80A = 'rgba(9, 30, 66, 0.42)';
var N90A = 'rgba(9, 30, 66, 0.48)';
var N100A = 'rgba(9, 30, 66, 0.54)';
var N200A = 'rgba(9, 30, 66, 0.60)';
var N300A = 'rgba(9, 30, 66, 0.66)';
var N400A = 'rgba(9, 30, 66, 0.71)';
var N500A = 'rgba(9, 30, 66, 0.77)';
var N600A = 'rgba(9, 30, 66, 0.82)';
var N700A = 'rgba(9, 30, 66, 0.89)';
var N800A = 'rgba(9, 30, 66, 0.95)';

// Dark Mode Neutrals
var DN900 = '#E6EDFA';
var DN800 = '#DCE5F5';
var DN700 = '#CED9EB';
var DN600 = '#B8C7E0';
var DN500 = '#ABBBD6';
var DN400 = '#9FB0CC';
var DN300 = '#8C9CB8';
var DN200 = '#7988A3';
var DN100 = '#67758F';
var DN90 = '#56637A';
var DN80 = '#455166';
var DN70 = '#3B475C';
var DN60 = '#313D52';
var DN50 = '#283447';
var DN40 = '#202B3D';
var DN30 = '#1B2638';
var DN20 = '#121A29';
var DN10 = '#0E1624';

// ATTENTION: update the tints if you update this
var DN0 = '#0D1424';

// Each dark tint is made of DN0 and an alpha channel
var DN800A = 'rgba(13, 20, 36, 0.06)';
var DN700A = 'rgba(13, 20, 36, 0.14)';
var DN600A = 'rgba(13, 20, 36, 0.18)';
var DN500A = 'rgba(13, 20, 36, 0.29)';
var DN400A = 'rgba(13, 20, 36, 0.36)';
var DN300A = 'rgba(13, 20, 36, 0.40)';
var DN200A = 'rgba(13, 20, 36, 0.47)';
var DN100A = 'rgba(13, 20, 36, 0.53)';
var DN90A = 'rgba(13, 20, 36, 0.63)';
var DN80A = 'rgba(13, 20, 36, 0.73)';
var DN70A = 'rgba(13, 20, 36, 0.78)';
var DN60A = 'rgba(13, 20, 36, 0.81)';
var DN50A = 'rgba(13, 20, 36, 0.85)';
var DN40A = 'rgba(13, 20, 36, 0.89)';
var DN30A = 'rgba(13, 20, 36, 0.92)';
var DN20A = 'rgba(13, 20, 36, 0.95)';
var DN10A = 'rgba(13, 20, 36, 0.97)';

// Themed colors
var background = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N0, dark: DN30 });
var backgroundActive = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B50, dark: B75 });
var backgroundHover = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N30, dark: DN70 });
var backgroundOnLayer = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N0, dark: DN50 });
var text = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N900, dark: DN600 });
var textHover = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N800, dark: DN600 });
var textActive = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B400, dark: B400 });
var subtleText = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N200, dark: DN300 });
var placeholderText = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N100, dark: DN200 });
var heading = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N800, dark: DN600 });
var subtleHeading = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N200, dark: DN300 });
var codeBlock = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N20, dark: DN50 });
var link = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B400, dark: B100 });
var linkHover = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B300, dark: B200 });
var linkActive = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B500, dark: B100 });
var linkOutline = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B100, dark: B200 });
var primary = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B400, dark: B100 });
var blue = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B400, dark: B100 });
var teal = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: T300, dark: T200 });
var purple = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: P300, dark: P100 });
var red = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: R300, dark: R300 });
var yellow = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: Y300, dark: Y300 });
var green = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: G300, dark: G300 });

// Jira Portfolio
var colorPalette8 = [{ background: N800, text: N0 }, { background: R400, text: N0 }, { background: P400, text: P50 }, { background: B400, text: B75 }, { background: T300, text: N800 }, { background: G400, text: N0 }, { background: Y400, text: N800 }, { background: N70, text: N800 }];

var colorPalette16 = [].concat(colorPalette8, [{ background: N500, text: N0 }, { background: R100, text: N800 }, { background: P75, text: N800 }, { background: B100, text: N800 }, { background: T100, text: N800 }, { background: G100, text: G500 }, { background: Y200, text: N800 }, { background: N0, text: N800 }]);

var colorPalette24 = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(colorPalette16), [{ background: N100, text: N0 }, { background: N40, text: N800 }, { background: N50, text: R500 }, { background: P50, text: P500 }, { background: B50, text: B500 }, { background: T75, text: N800 }, { background: G50, text: G500 }, { background: Y75, text: N800 }]);

var colorPalette = function colorPalette() {
  var palette = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '8';

  switch (palette) {
    case '8':
      return colorPalette8;
    case '16':
      return colorPalette16;
    case '24':
      return colorPalette24;
    default:
      throw new Error('The only available color palette is 8, 16, 24');
  }
};

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R50", function() { return R50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R75", function() { return R75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R100", function() { return R100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R200", function() { return R200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R300", function() { return R300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R400", function() { return R400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R500", function() { return R500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y50", function() { return Y50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y75", function() { return Y75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y100", function() { return Y100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y200", function() { return Y200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y300", function() { return Y300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y400", function() { return Y400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y500", function() { return Y500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G50", function() { return G50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G75", function() { return G75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G100", function() { return G100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G200", function() { return G200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G300", function() { return G300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G400", function() { return G400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G500", function() { return G500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B50", function() { return B50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B75", function() { return B75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B100", function() { return B100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B200", function() { return B200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B300", function() { return B300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B400", function() { return B400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B500", function() { return B500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P50", function() { return P50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P75", function() { return P75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P100", function() { return P100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P200", function() { return P200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P300", function() { return P300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P400", function() { return P400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P500", function() { return P500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T50", function() { return T50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T75", function() { return T75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T100", function() { return T100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T200", function() { return T200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T300", function() { return T300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T400", function() { return T400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T500", function() { return T500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N0", function() { return N0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N10", function() { return N10; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N20", function() { return N20; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N30", function() { return N30; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N40", function() { return N40; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N50", function() { return N50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N60", function() { return N60; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N70", function() { return N70; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N80", function() { return N80; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N90", function() { return N90; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N100", function() { return N100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N200", function() { return N200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N300", function() { return N300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N400", function() { return N400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N500", function() { return N500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N600", function() { return N600; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N700", function() { return N700; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N800", function() { return N800; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N900", function() { return N900; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N10A", function() { return N10A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N20A", function() { return N20A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N30A", function() { return N30A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N40A", function() { return N40A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N50A", function() { return N50A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N60A", function() { return N60A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N70A", function() { return N70A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N80A", function() { return N80A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N90A", function() { return N90A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N100A", function() { return N100A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N200A", function() { return N200A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N300A", function() { return N300A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N400A", function() { return N400A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N500A", function() { return N500A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N600A", function() { return N600A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N700A", function() { return N700A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N800A", function() { return N800A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN900", function() { return DN900; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN800", function() { return DN800; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN700", function() { return DN700; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN600", function() { return DN600; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN500", function() { return DN500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN400", function() { return DN400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN300", function() { return DN300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN200", function() { return DN200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN100", function() { return DN100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN90", function() { return DN90; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN80", function() { return DN80; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN70", function() { return DN70; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN60", function() { return DN60; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN50", function() { return DN50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN40", function() { return DN40; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN30", function() { return DN30; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN20", function() { return DN20; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN10", function() { return DN10; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN0", function() { return DN0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN800A", function() { return DN800A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN700A", function() { return DN700A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN600A", function() { return DN600A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN500A", function() { return DN500A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN400A", function() { return DN400A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN300A", function() { return DN300A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN200A", function() { return DN200A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN100A", function() { return DN100A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN90A", function() { return DN90A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN80A", function() { return DN80A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN70A", function() { return DN70A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN60A", function() { return DN60A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN50A", function() { return DN50A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN40A", function() { return DN40A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN30A", function() { return DN30A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN20A", function() { return DN20A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN10A", function() { return DN10A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "background", function() { return background; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundActive", function() { return backgroundActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundHover", function() { return backgroundHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundOnLayer", function() { return backgroundOnLayer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "text", function() { return text; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "textHover", function() { return textHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "textActive", function() { return textActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subtleText", function() { return subtleText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "placeholderText", function() { return placeholderText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "heading", function() { return heading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subtleHeading", function() { return subtleHeading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "codeBlock", function() { return codeBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "link", function() { return link; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linkHover", function() { return linkHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linkActive", function() { return linkActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linkOutline", function() { return linkOutline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "primary", function() { return primary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "blue", function() { return blue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "teal", function() { return teal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "purple", function() { return purple; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "red", function() { return red; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "yellow", function() { return yellow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "green", function() { return green; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette8", function() { return colorPalette8; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette16", function() { return colorPalette16; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette24", function() { return colorPalette24; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette", function() { return colorPalette; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_themed__ = __webpack_require__(156);




// Reds
var R50 = '#FFEBE6';
var R75 = '#FFBDAD';
var R100 = '#FF8F73';
var R200 = '#FF7452';
var R300 = '#FF5630';
var R400 = '#DE350B';
var R500 = '#BF2600';

// Yellows
var Y50 = '#FFFAE6';
var Y75 = '#FFF0B3';
var Y100 = '#FFE380';
var Y200 = '#FFC400';
var Y300 = '#FFAB00';
var Y400 = '#FF991F';
var Y500 = '#FF8B00';

// Greens
var G50 = '#E3FCEF';
var G75 = '#ABF5D1';
var G100 = '#79F2C0';
var G200 = '#57D9A3';
var G300 = '#36B37E';
var G400 = '#00875A';
var G500 = '#006644';

// Blues
var B50 = '#DEEBFF';
var B75 = '#B3D4FF';
var B100 = '#4C9AFF';
var B200 = '#2684FF';
var B300 = '#0065FF';
var B400 = '#0052CC';
var B500 = '#0747A6';

// Purples
var P50 = '#EAE6FF';
var P75 = '#C0B6F2';
var P100 = '#998DD9';
var P200 = '#8777D9';
var P300 = '#6554C0';
var P400 = '#5243AA';
var P500 = '#403294';

// Teals
var T50 = '#E6FCFF';
var T75 = '#B3F5FF';
var T100 = '#79E2F2';
var T200 = '#00C7E6';
var T300 = '#00B8D9';
var T400 = '#00A3BF';
var T500 = '#008DA6';

// Neutrals
var N0 = '#FFFFFF';
var N10 = '#FAFBFC';
var N20 = '#F4F5F7';
var N30 = '#EBECF0';
var N40 = '#DFE1E6';
var N50 = '#C1C7D0';
var N60 = '#B3BAC5';
var N70 = '#A5ADBA';
var N80 = '#97A0AF';
var N90 = '#8993A4';
var N100 = '#7A869A';
var N200 = '#6B778C';
var N300 = '#5E6C84';
var N400 = '#505F79';
var N500 = '#42526E';
var N600 = '#344563';
var N700 = '#253858';
var N800 = '#172B4D';

// ATTENTION: update the tints if you update this
var N900 = '#091E42';

// Each tint is made of N900 and an alpha channel
var N10A = 'rgba(9, 30, 66, 0.02)';
var N20A = 'rgba(9, 30, 66, 0.04)';
var N30A = 'rgba(9, 30, 66, 0.08)';
var N40A = 'rgba(9, 30, 66, 0.13)';
var N50A = 'rgba(9, 30, 66, 0.25)';
var N60A = 'rgba(9, 30, 66, 0.31)';
var N70A = 'rgba(9, 30, 66, 0.36)';
var N80A = 'rgba(9, 30, 66, 0.42)';
var N90A = 'rgba(9, 30, 66, 0.48)';
var N100A = 'rgba(9, 30, 66, 0.54)';
var N200A = 'rgba(9, 30, 66, 0.60)';
var N300A = 'rgba(9, 30, 66, 0.66)';
var N400A = 'rgba(9, 30, 66, 0.71)';
var N500A = 'rgba(9, 30, 66, 0.77)';
var N600A = 'rgba(9, 30, 66, 0.82)';
var N700A = 'rgba(9, 30, 66, 0.89)';
var N800A = 'rgba(9, 30, 66, 0.95)';

// Dark Mode Neutrals
var DN900 = '#E6EDFA';
var DN800 = '#DCE5F5';
var DN700 = '#CED9EB';
var DN600 = '#B8C7E0';
var DN500 = '#ABBBD6';
var DN400 = '#9FB0CC';
var DN300 = '#8C9CB8';
var DN200 = '#7988A3';
var DN100 = '#67758F';
var DN90 = '#56637A';
var DN80 = '#455166';
var DN70 = '#3B475C';
var DN60 = '#313D52';
var DN50 = '#283447';
var DN40 = '#202B3D';
var DN30 = '#1B2638';
var DN20 = '#121A29';
var DN10 = '#0E1624';

// ATTENTION: update the tints if you update this
var DN0 = '#0D1424';

// Each dark tint is made of DN0 and an alpha channel
var DN800A = 'rgba(13, 20, 36, 0.06)';
var DN700A = 'rgba(13, 20, 36, 0.14)';
var DN600A = 'rgba(13, 20, 36, 0.18)';
var DN500A = 'rgba(13, 20, 36, 0.29)';
var DN400A = 'rgba(13, 20, 36, 0.36)';
var DN300A = 'rgba(13, 20, 36, 0.40)';
var DN200A = 'rgba(13, 20, 36, 0.47)';
var DN100A = 'rgba(13, 20, 36, 0.53)';
var DN90A = 'rgba(13, 20, 36, 0.63)';
var DN80A = 'rgba(13, 20, 36, 0.73)';
var DN70A = 'rgba(13, 20, 36, 0.78)';
var DN60A = 'rgba(13, 20, 36, 0.81)';
var DN50A = 'rgba(13, 20, 36, 0.85)';
var DN40A = 'rgba(13, 20, 36, 0.89)';
var DN30A = 'rgba(13, 20, 36, 0.92)';
var DN20A = 'rgba(13, 20, 36, 0.95)';
var DN10A = 'rgba(13, 20, 36, 0.97)';

// Themed colors
var background = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N0, dark: DN30 });
var backgroundActive = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B50, dark: B75 });
var backgroundHover = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N30, dark: DN70 });
var backgroundOnLayer = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N0, dark: DN50 });
var text = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N900, dark: DN600 });
var textHover = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N800, dark: DN600 });
var textActive = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B400, dark: B400 });
var subtleText = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N200, dark: DN300 });
var placeholderText = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N100, dark: DN200 });
var heading = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N800, dark: DN600 });
var subtleHeading = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N200, dark: DN300 });
var codeBlock = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N20, dark: DN50 });
var link = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B400, dark: B100 });
var linkHover = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B300, dark: B200 });
var linkActive = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B500, dark: B100 });
var linkOutline = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B100, dark: B200 });
var primary = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B400, dark: B100 });
var blue = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B400, dark: B100 });
var teal = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: T300, dark: T200 });
var purple = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: P300, dark: P100 });
var red = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: R300, dark: R300 });
var yellow = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: Y300, dark: Y300 });
var green = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: G300, dark: G300 });

// Jira Portfolio
var colorPalette8 = [{ background: N800, text: N0 }, { background: R400, text: N0 }, { background: P400, text: P50 }, { background: B400, text: B75 }, { background: T300, text: N800 }, { background: G400, text: N0 }, { background: Y400, text: N800 }, { background: N70, text: N800 }];

var colorPalette16 = [].concat(colorPalette8, [{ background: N500, text: N0 }, { background: R100, text: N800 }, { background: P75, text: N800 }, { background: B100, text: N800 }, { background: T100, text: N800 }, { background: G100, text: G500 }, { background: Y200, text: N800 }, { background: N0, text: N800 }]);

var colorPalette24 = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(colorPalette16), [{ background: N100, text: N0 }, { background: N40, text: N800 }, { background: N50, text: R500 }, { background: P50, text: P500 }, { background: B50, text: B500 }, { background: T75, text: N800 }, { background: G50, text: G500 }, { background: Y75, text: N800 }]);

var colorPalette = function colorPalette() {
  var palette = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '8';

  switch (palette) {
    case '8':
      return colorPalette8;
    case '16':
      return colorPalette16;
    case '24':
      return colorPalette24;
    default:
      throw new Error('The only available color palette is 8, 16, 24');
  }
};

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R50", function() { return R50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R75", function() { return R75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R100", function() { return R100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R200", function() { return R200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R300", function() { return R300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R400", function() { return R400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R500", function() { return R500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y50", function() { return Y50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y75", function() { return Y75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y100", function() { return Y100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y200", function() { return Y200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y300", function() { return Y300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y400", function() { return Y400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y500", function() { return Y500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G50", function() { return G50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G75", function() { return G75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G100", function() { return G100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G200", function() { return G200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G300", function() { return G300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G400", function() { return G400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G500", function() { return G500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B50", function() { return B50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B75", function() { return B75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B100", function() { return B100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B200", function() { return B200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B300", function() { return B300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B400", function() { return B400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B500", function() { return B500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P50", function() { return P50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P75", function() { return P75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P100", function() { return P100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P200", function() { return P200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P300", function() { return P300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P400", function() { return P400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P500", function() { return P500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T50", function() { return T50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T75", function() { return T75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T100", function() { return T100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T200", function() { return T200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T300", function() { return T300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T400", function() { return T400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T500", function() { return T500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N0", function() { return N0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N10", function() { return N10; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N20", function() { return N20; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N30", function() { return N30; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N40", function() { return N40; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N50", function() { return N50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N60", function() { return N60; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N70", function() { return N70; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N80", function() { return N80; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N90", function() { return N90; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N100", function() { return N100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N200", function() { return N200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N300", function() { return N300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N400", function() { return N400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N500", function() { return N500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N600", function() { return N600; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N700", function() { return N700; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N800", function() { return N800; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N900", function() { return N900; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N10A", function() { return N10A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N20A", function() { return N20A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N30A", function() { return N30A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N40A", function() { return N40A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N50A", function() { return N50A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N60A", function() { return N60A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N70A", function() { return N70A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N80A", function() { return N80A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N90A", function() { return N90A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N100A", function() { return N100A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N200A", function() { return N200A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N300A", function() { return N300A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N400A", function() { return N400A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N500A", function() { return N500A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N600A", function() { return N600A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N700A", function() { return N700A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N800A", function() { return N800A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN900", function() { return DN900; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN800", function() { return DN800; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN700", function() { return DN700; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN600", function() { return DN600; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN500", function() { return DN500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN400", function() { return DN400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN300", function() { return DN300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN200", function() { return DN200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN100", function() { return DN100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN90", function() { return DN90; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN80", function() { return DN80; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN70", function() { return DN70; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN60", function() { return DN60; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN50", function() { return DN50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN40", function() { return DN40; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN30", function() { return DN30; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN20", function() { return DN20; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN10", function() { return DN10; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN0", function() { return DN0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN800A", function() { return DN800A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN700A", function() { return DN700A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN600A", function() { return DN600A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN500A", function() { return DN500A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN400A", function() { return DN400A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN300A", function() { return DN300A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN200A", function() { return DN200A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN100A", function() { return DN100A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN90A", function() { return DN90A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN80A", function() { return DN80A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN70A", function() { return DN70A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN60A", function() { return DN60A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN50A", function() { return DN50A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN40A", function() { return DN40A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN30A", function() { return DN30A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN20A", function() { return DN20A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN10A", function() { return DN10A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "background", function() { return background; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundActive", function() { return backgroundActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundHover", function() { return backgroundHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundOnLayer", function() { return backgroundOnLayer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "text", function() { return text; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "textHover", function() { return textHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "textActive", function() { return textActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subtleText", function() { return subtleText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "placeholderText", function() { return placeholderText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "heading", function() { return heading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subtleHeading", function() { return subtleHeading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "codeBlock", function() { return codeBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "link", function() { return link; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linkHover", function() { return linkHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linkActive", function() { return linkActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linkOutline", function() { return linkOutline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "primary", function() { return primary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "blue", function() { return blue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "teal", function() { return teal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "purple", function() { return purple; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "red", function() { return red; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "yellow", function() { return yellow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "green", function() { return green; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette8", function() { return colorPalette8; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette16", function() { return colorPalette16; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette24", function() { return colorPalette24; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette", function() { return colorPalette; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_themed__ = __webpack_require__(158);




// Reds
var R50 = '#FFEBE6';
var R75 = '#FFBDAD';
var R100 = '#FF8F73';
var R200 = '#FF7452';
var R300 = '#FF5630';
var R400 = '#DE350B';
var R500 = '#BF2600';

// Yellows
var Y50 = '#FFFAE6';
var Y75 = '#FFF0B3';
var Y100 = '#FFE380';
var Y200 = '#FFC400';
var Y300 = '#FFAB00';
var Y400 = '#FF991F';
var Y500 = '#FF8B00';

// Greens
var G50 = '#E3FCEF';
var G75 = '#ABF5D1';
var G100 = '#79F2C0';
var G200 = '#57D9A3';
var G300 = '#36B37E';
var G400 = '#00875A';
var G500 = '#006644';

// Blues
var B50 = '#DEEBFF';
var B75 = '#B3D4FF';
var B100 = '#4C9AFF';
var B200 = '#2684FF';
var B300 = '#0065FF';
var B400 = '#0052CC';
var B500 = '#0747A6';

// Purples
var P50 = '#EAE6FF';
var P75 = '#C0B6F2';
var P100 = '#998DD9';
var P200 = '#8777D9';
var P300 = '#6554C0';
var P400 = '#5243AA';
var P500 = '#403294';

// Teals
var T50 = '#E6FCFF';
var T75 = '#B3F5FF';
var T100 = '#79E2F2';
var T200 = '#00C7E6';
var T300 = '#00B8D9';
var T400 = '#00A3BF';
var T500 = '#008DA6';

// Neutrals
var N0 = '#FFFFFF';
var N10 = '#FAFBFC';
var N20 = '#F4F5F7';
var N30 = '#EBECF0';
var N40 = '#DFE1E6';
var N50 = '#C1C7D0';
var N60 = '#B3BAC5';
var N70 = '#A5ADBA';
var N80 = '#97A0AF';
var N90 = '#8993A4';
var N100 = '#7A869A';
var N200 = '#6B778C';
var N300 = '#5E6C84';
var N400 = '#505F79';
var N500 = '#42526E';
var N600 = '#344563';
var N700 = '#253858';
var N800 = '#172B4D';

// ATTENTION: update the tints if you update this
var N900 = '#091E42';

// Each tint is made of N900 and an alpha channel
var N10A = 'rgba(9, 30, 66, 0.02)';
var N20A = 'rgba(9, 30, 66, 0.04)';
var N30A = 'rgba(9, 30, 66, 0.08)';
var N40A = 'rgba(9, 30, 66, 0.13)';
var N50A = 'rgba(9, 30, 66, 0.25)';
var N60A = 'rgba(9, 30, 66, 0.31)';
var N70A = 'rgba(9, 30, 66, 0.36)';
var N80A = 'rgba(9, 30, 66, 0.42)';
var N90A = 'rgba(9, 30, 66, 0.48)';
var N100A = 'rgba(9, 30, 66, 0.54)';
var N200A = 'rgba(9, 30, 66, 0.60)';
var N300A = 'rgba(9, 30, 66, 0.66)';
var N400A = 'rgba(9, 30, 66, 0.71)';
var N500A = 'rgba(9, 30, 66, 0.77)';
var N600A = 'rgba(9, 30, 66, 0.82)';
var N700A = 'rgba(9, 30, 66, 0.89)';
var N800A = 'rgba(9, 30, 66, 0.95)';

// Dark Mode Neutrals
var DN900 = '#E6EDFA';
var DN800 = '#DCE5F5';
var DN700 = '#CED9EB';
var DN600 = '#B8C7E0';
var DN500 = '#ABBBD6';
var DN400 = '#9FB0CC';
var DN300 = '#8C9CB8';
var DN200 = '#7988A3';
var DN100 = '#67758F';
var DN90 = '#56637A';
var DN80 = '#455166';
var DN70 = '#3B475C';
var DN60 = '#313D52';
var DN50 = '#283447';
var DN40 = '#202B3D';
var DN30 = '#1B2638';
var DN20 = '#121A29';
var DN10 = '#0E1624';

// ATTENTION: update the tints if you update this
var DN0 = '#0D1424';

// Each dark tint is made of DN0 and an alpha channel
var DN800A = 'rgba(13, 20, 36, 0.06)';
var DN700A = 'rgba(13, 20, 36, 0.14)';
var DN600A = 'rgba(13, 20, 36, 0.18)';
var DN500A = 'rgba(13, 20, 36, 0.29)';
var DN400A = 'rgba(13, 20, 36, 0.36)';
var DN300A = 'rgba(13, 20, 36, 0.40)';
var DN200A = 'rgba(13, 20, 36, 0.47)';
var DN100A = 'rgba(13, 20, 36, 0.53)';
var DN90A = 'rgba(13, 20, 36, 0.63)';
var DN80A = 'rgba(13, 20, 36, 0.73)';
var DN70A = 'rgba(13, 20, 36, 0.78)';
var DN60A = 'rgba(13, 20, 36, 0.81)';
var DN50A = 'rgba(13, 20, 36, 0.85)';
var DN40A = 'rgba(13, 20, 36, 0.89)';
var DN30A = 'rgba(13, 20, 36, 0.92)';
var DN20A = 'rgba(13, 20, 36, 0.95)';
var DN10A = 'rgba(13, 20, 36, 0.97)';

// Themed colors
var background = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N0, dark: DN30 });
var backgroundActive = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B50, dark: B75 });
var backgroundHover = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N30, dark: DN70 });
var backgroundOnLayer = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N0, dark: DN50 });
var text = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N900, dark: DN600 });
var textHover = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N800, dark: DN600 });
var textActive = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B400, dark: B400 });
var subtleText = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N200, dark: DN300 });
var placeholderText = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N100, dark: DN200 });
var heading = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N800, dark: DN600 });
var subtleHeading = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N200, dark: DN300 });
var codeBlock = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N20, dark: DN50 });
var link = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B400, dark: B100 });
var linkHover = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B300, dark: B200 });
var linkActive = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B500, dark: B100 });
var linkOutline = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B100, dark: B200 });
var primary = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B400, dark: B100 });
var blue = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B400, dark: B100 });
var teal = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: T300, dark: T200 });
var purple = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: P300, dark: P100 });
var red = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: R300, dark: R300 });
var yellow = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: Y300, dark: Y300 });
var green = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: G300, dark: G300 });

// Jira Portfolio
var colorPalette8 = [{ background: N800, text: N0 }, { background: R400, text: N0 }, { background: P400, text: P50 }, { background: B400, text: B75 }, { background: T300, text: N800 }, { background: G400, text: N0 }, { background: Y400, text: N800 }, { background: N70, text: N800 }];

var colorPalette16 = [].concat(colorPalette8, [{ background: N500, text: N0 }, { background: R100, text: N800 }, { background: P75, text: N800 }, { background: B100, text: N800 }, { background: T100, text: N800 }, { background: G100, text: G500 }, { background: Y200, text: N800 }, { background: N0, text: N800 }]);

var colorPalette24 = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(colorPalette16), [{ background: N100, text: N0 }, { background: N40, text: N800 }, { background: N50, text: R500 }, { background: P50, text: P500 }, { background: B50, text: B500 }, { background: T75, text: N800 }, { background: G50, text: G500 }, { background: Y75, text: N800 }]);

var colorPalette = function colorPalette() {
  var palette = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '8';

  switch (palette) {
    case '8':
      return colorPalette8;
    case '16':
      return colorPalette16;
    case '24':
      return colorPalette24;
    default:
      throw new Error('The only available color palette is 8, 16, 24');
  }
};

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R50", function() { return R50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R75", function() { return R75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R100", function() { return R100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R200", function() { return R200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R300", function() { return R300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R400", function() { return R400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R500", function() { return R500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y50", function() { return Y50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y75", function() { return Y75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y100", function() { return Y100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y200", function() { return Y200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y300", function() { return Y300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y400", function() { return Y400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y500", function() { return Y500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G50", function() { return G50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G75", function() { return G75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G100", function() { return G100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G200", function() { return G200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G300", function() { return G300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G400", function() { return G400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G500", function() { return G500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B50", function() { return B50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B75", function() { return B75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B100", function() { return B100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B200", function() { return B200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B300", function() { return B300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B400", function() { return B400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B500", function() { return B500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P50", function() { return P50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P75", function() { return P75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P100", function() { return P100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P200", function() { return P200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P300", function() { return P300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P400", function() { return P400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P500", function() { return P500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T50", function() { return T50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T75", function() { return T75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T100", function() { return T100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T200", function() { return T200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T300", function() { return T300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T400", function() { return T400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T500", function() { return T500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N0", function() { return N0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N10", function() { return N10; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N20", function() { return N20; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N30", function() { return N30; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N40", function() { return N40; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N50", function() { return N50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N60", function() { return N60; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N70", function() { return N70; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N80", function() { return N80; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N90", function() { return N90; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N100", function() { return N100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N200", function() { return N200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N300", function() { return N300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N400", function() { return N400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N500", function() { return N500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N600", function() { return N600; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N700", function() { return N700; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N800", function() { return N800; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N900", function() { return N900; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N10A", function() { return N10A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N20A", function() { return N20A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N30A", function() { return N30A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N40A", function() { return N40A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N50A", function() { return N50A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N60A", function() { return N60A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N70A", function() { return N70A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N80A", function() { return N80A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N90A", function() { return N90A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N100A", function() { return N100A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N200A", function() { return N200A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N300A", function() { return N300A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N400A", function() { return N400A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N500A", function() { return N500A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N600A", function() { return N600A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N700A", function() { return N700A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N800A", function() { return N800A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN900", function() { return DN900; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN800", function() { return DN800; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN700", function() { return DN700; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN600", function() { return DN600; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN500", function() { return DN500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN400", function() { return DN400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN300", function() { return DN300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN200", function() { return DN200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN100", function() { return DN100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN90", function() { return DN90; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN80", function() { return DN80; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN70", function() { return DN70; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN60", function() { return DN60; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN50", function() { return DN50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN40", function() { return DN40; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN30", function() { return DN30; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN20", function() { return DN20; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN10", function() { return DN10; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN0", function() { return DN0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN800A", function() { return DN800A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN700A", function() { return DN700A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN600A", function() { return DN600A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN500A", function() { return DN500A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN400A", function() { return DN400A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN300A", function() { return DN300A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN200A", function() { return DN200A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN100A", function() { return DN100A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN90A", function() { return DN90A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN80A", function() { return DN80A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN70A", function() { return DN70A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN60A", function() { return DN60A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN50A", function() { return DN50A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN40A", function() { return DN40A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN30A", function() { return DN30A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN20A", function() { return DN20A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN10A", function() { return DN10A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "background", function() { return background; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundActive", function() { return backgroundActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundHover", function() { return backgroundHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundOnLayer", function() { return backgroundOnLayer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "text", function() { return text; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "textHover", function() { return textHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "textActive", function() { return textActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subtleText", function() { return subtleText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "placeholderText", function() { return placeholderText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "heading", function() { return heading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subtleHeading", function() { return subtleHeading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "codeBlock", function() { return codeBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "link", function() { return link; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linkHover", function() { return linkHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linkActive", function() { return linkActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linkOutline", function() { return linkOutline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "primary", function() { return primary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "blue", function() { return blue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "teal", function() { return teal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "purple", function() { return purple; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "red", function() { return red; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "yellow", function() { return yellow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "green", function() { return green; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette8", function() { return colorPalette8; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette16", function() { return colorPalette16; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette24", function() { return colorPalette24; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette", function() { return colorPalette; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_themed__ = __webpack_require__(159);




// Reds
var R50 = '#FFEBE6';
var R75 = '#FFBDAD';
var R100 = '#FF8F73';
var R200 = '#FF7452';
var R300 = '#FF5630';
var R400 = '#DE350B';
var R500 = '#BF2600';

// Yellows
var Y50 = '#FFFAE6';
var Y75 = '#FFF0B3';
var Y100 = '#FFE380';
var Y200 = '#FFC400';
var Y300 = '#FFAB00';
var Y400 = '#FF991F';
var Y500 = '#FF8B00';

// Greens
var G50 = '#E3FCEF';
var G75 = '#ABF5D1';
var G100 = '#79F2C0';
var G200 = '#57D9A3';
var G300 = '#36B37E';
var G400 = '#00875A';
var G500 = '#006644';

// Blues
var B50 = '#DEEBFF';
var B75 = '#B3D4FF';
var B100 = '#4C9AFF';
var B200 = '#2684FF';
var B300 = '#0065FF';
var B400 = '#0052CC';
var B500 = '#0747A6';

// Purples
var P50 = '#EAE6FF';
var P75 = '#C0B6F2';
var P100 = '#998DD9';
var P200 = '#8777D9';
var P300 = '#6554C0';
var P400 = '#5243AA';
var P500 = '#403294';

// Teals
var T50 = '#E6FCFF';
var T75 = '#B3F5FF';
var T100 = '#79E2F2';
var T200 = '#00C7E6';
var T300 = '#00B8D9';
var T400 = '#00A3BF';
var T500 = '#008DA6';

// Neutrals
var N0 = '#FFFFFF';
var N10 = '#FAFBFC';
var N20 = '#F4F5F7';
var N30 = '#EBECF0';
var N40 = '#DFE1E6';
var N50 = '#C1C7D0';
var N60 = '#B3BAC5';
var N70 = '#A5ADBA';
var N80 = '#97A0AF';
var N90 = '#8993A4';
var N100 = '#7A869A';
var N200 = '#6B778C';
var N300 = '#5E6C84';
var N400 = '#505F79';
var N500 = '#42526E';
var N600 = '#344563';
var N700 = '#253858';
var N800 = '#172B4D';

// ATTENTION: update the tints if you update this
var N900 = '#091E42';

// Each tint is made of N900 and an alpha channel
var N10A = 'rgba(9, 30, 66, 0.02)';
var N20A = 'rgba(9, 30, 66, 0.04)';
var N30A = 'rgba(9, 30, 66, 0.08)';
var N40A = 'rgba(9, 30, 66, 0.13)';
var N50A = 'rgba(9, 30, 66, 0.25)';
var N60A = 'rgba(9, 30, 66, 0.31)';
var N70A = 'rgba(9, 30, 66, 0.36)';
var N80A = 'rgba(9, 30, 66, 0.42)';
var N90A = 'rgba(9, 30, 66, 0.48)';
var N100A = 'rgba(9, 30, 66, 0.54)';
var N200A = 'rgba(9, 30, 66, 0.60)';
var N300A = 'rgba(9, 30, 66, 0.66)';
var N400A = 'rgba(9, 30, 66, 0.71)';
var N500A = 'rgba(9, 30, 66, 0.77)';
var N600A = 'rgba(9, 30, 66, 0.82)';
var N700A = 'rgba(9, 30, 66, 0.89)';
var N800A = 'rgba(9, 30, 66, 0.95)';

// Dark Mode Neutrals
var DN900 = '#E6EDFA';
var DN800 = '#DCE5F5';
var DN700 = '#CED9EB';
var DN600 = '#B8C7E0';
var DN500 = '#ABBBD6';
var DN400 = '#9FB0CC';
var DN300 = '#8C9CB8';
var DN200 = '#7988A3';
var DN100 = '#67758F';
var DN90 = '#56637A';
var DN80 = '#455166';
var DN70 = '#3B475C';
var DN60 = '#313D52';
var DN50 = '#283447';
var DN40 = '#202B3D';
var DN30 = '#1B2638';
var DN20 = '#121A29';
var DN10 = '#0E1624';

// ATTENTION: update the tints if you update this
var DN0 = '#0D1424';

// Each dark tint is made of DN0 and an alpha channel
var DN800A = 'rgba(13, 20, 36, 0.06)';
var DN700A = 'rgba(13, 20, 36, 0.14)';
var DN600A = 'rgba(13, 20, 36, 0.18)';
var DN500A = 'rgba(13, 20, 36, 0.29)';
var DN400A = 'rgba(13, 20, 36, 0.36)';
var DN300A = 'rgba(13, 20, 36, 0.40)';
var DN200A = 'rgba(13, 20, 36, 0.47)';
var DN100A = 'rgba(13, 20, 36, 0.53)';
var DN90A = 'rgba(13, 20, 36, 0.63)';
var DN80A = 'rgba(13, 20, 36, 0.73)';
var DN70A = 'rgba(13, 20, 36, 0.78)';
var DN60A = 'rgba(13, 20, 36, 0.81)';
var DN50A = 'rgba(13, 20, 36, 0.85)';
var DN40A = 'rgba(13, 20, 36, 0.89)';
var DN30A = 'rgba(13, 20, 36, 0.92)';
var DN20A = 'rgba(13, 20, 36, 0.95)';
var DN10A = 'rgba(13, 20, 36, 0.97)';

// Themed colors
var background = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N0, dark: DN30 });
var backgroundActive = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B50, dark: B75 });
var backgroundHover = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N30, dark: DN70 });
var backgroundOnLayer = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N0, dark: DN50 });
var text = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N900, dark: DN600 });
var textHover = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N800, dark: DN600 });
var textActive = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B400, dark: B400 });
var subtleText = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N200, dark: DN300 });
var placeholderText = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N100, dark: DN200 });
var heading = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N800, dark: DN600 });
var subtleHeading = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N200, dark: DN300 });
var codeBlock = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N20, dark: DN50 });
var link = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B400, dark: B100 });
var linkHover = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B300, dark: B200 });
var linkActive = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B500, dark: B100 });
var linkOutline = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B100, dark: B200 });
var primary = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B400, dark: B100 });
var blue = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B400, dark: B100 });
var teal = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: T300, dark: T200 });
var purple = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: P300, dark: P100 });
var red = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: R300, dark: R300 });
var yellow = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: Y300, dark: Y300 });
var green = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: G300, dark: G300 });

// Jira Portfolio
var colorPalette8 = [{ background: N800, text: N0 }, { background: R400, text: N0 }, { background: P400, text: P50 }, { background: B400, text: B75 }, { background: T300, text: N800 }, { background: G400, text: N0 }, { background: Y400, text: N800 }, { background: N70, text: N800 }];

var colorPalette16 = [].concat(colorPalette8, [{ background: N500, text: N0 }, { background: R100, text: N800 }, { background: P75, text: N800 }, { background: B100, text: N800 }, { background: T100, text: N800 }, { background: G100, text: G500 }, { background: Y200, text: N800 }, { background: N0, text: N800 }]);

var colorPalette24 = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(colorPalette16), [{ background: N100, text: N0 }, { background: N40, text: N800 }, { background: N50, text: R500 }, { background: P50, text: P500 }, { background: B50, text: B500 }, { background: T75, text: N800 }, { background: G50, text: G500 }, { background: Y75, text: N800 }]);

var colorPalette = function colorPalette() {
  var palette = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '8';

  switch (palette) {
    case '8':
      return colorPalette8;
    case '16':
      return colorPalette16;
    case '24':
      return colorPalette24;
    default:
      throw new Error('The only available color palette is 8, 16, 24');
  }
};

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R50", function() { return R50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R75", function() { return R75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R100", function() { return R100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R200", function() { return R200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R300", function() { return R300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R400", function() { return R400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R500", function() { return R500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y50", function() { return Y50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y75", function() { return Y75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y100", function() { return Y100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y200", function() { return Y200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y300", function() { return Y300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y400", function() { return Y400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y500", function() { return Y500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G50", function() { return G50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G75", function() { return G75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G100", function() { return G100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G200", function() { return G200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G300", function() { return G300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G400", function() { return G400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G500", function() { return G500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B50", function() { return B50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B75", function() { return B75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B100", function() { return B100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B200", function() { return B200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B300", function() { return B300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B400", function() { return B400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B500", function() { return B500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P50", function() { return P50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P75", function() { return P75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P100", function() { return P100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P200", function() { return P200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P300", function() { return P300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P400", function() { return P400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P500", function() { return P500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T50", function() { return T50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T75", function() { return T75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T100", function() { return T100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T200", function() { return T200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T300", function() { return T300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T400", function() { return T400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T500", function() { return T500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N0", function() { return N0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N10", function() { return N10; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N20", function() { return N20; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N30", function() { return N30; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N40", function() { return N40; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N50", function() { return N50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N60", function() { return N60; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N70", function() { return N70; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N80", function() { return N80; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N90", function() { return N90; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N100", function() { return N100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N200", function() { return N200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N300", function() { return N300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N400", function() { return N400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N500", function() { return N500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N600", function() { return N600; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N700", function() { return N700; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N800", function() { return N800; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N900", function() { return N900; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N10A", function() { return N10A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N20A", function() { return N20A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N30A", function() { return N30A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N40A", function() { return N40A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N50A", function() { return N50A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N60A", function() { return N60A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N70A", function() { return N70A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N80A", function() { return N80A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N90A", function() { return N90A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N100A", function() { return N100A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N200A", function() { return N200A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N300A", function() { return N300A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N400A", function() { return N400A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N500A", function() { return N500A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N600A", function() { return N600A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N700A", function() { return N700A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N800A", function() { return N800A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN900", function() { return DN900; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN800", function() { return DN800; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN700", function() { return DN700; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN600", function() { return DN600; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN500", function() { return DN500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN400", function() { return DN400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN300", function() { return DN300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN200", function() { return DN200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN100", function() { return DN100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN90", function() { return DN90; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN80", function() { return DN80; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN70", function() { return DN70; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN60", function() { return DN60; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN50", function() { return DN50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN40", function() { return DN40; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN30", function() { return DN30; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN20", function() { return DN20; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN10", function() { return DN10; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN0", function() { return DN0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN800A", function() { return DN800A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN700A", function() { return DN700A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN600A", function() { return DN600A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN500A", function() { return DN500A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN400A", function() { return DN400A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN300A", function() { return DN300A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN200A", function() { return DN200A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN100A", function() { return DN100A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN90A", function() { return DN90A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN80A", function() { return DN80A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN70A", function() { return DN70A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN60A", function() { return DN60A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN50A", function() { return DN50A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN40A", function() { return DN40A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN30A", function() { return DN30A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN20A", function() { return DN20A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN10A", function() { return DN10A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "background", function() { return background; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundActive", function() { return backgroundActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundHover", function() { return backgroundHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundOnLayer", function() { return backgroundOnLayer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "text", function() { return text; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "textHover", function() { return textHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "textActive", function() { return textActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subtleText", function() { return subtleText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "placeholderText", function() { return placeholderText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "heading", function() { return heading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subtleHeading", function() { return subtleHeading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "codeBlock", function() { return codeBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "link", function() { return link; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linkHover", function() { return linkHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linkActive", function() { return linkActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linkOutline", function() { return linkOutline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "primary", function() { return primary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "blue", function() { return blue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "teal", function() { return teal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "purple", function() { return purple; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "red", function() { return red; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "yellow", function() { return yellow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "green", function() { return green; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette8", function() { return colorPalette8; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette16", function() { return colorPalette16; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette24", function() { return colorPalette24; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette", function() { return colorPalette; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_themed__ = __webpack_require__(163);




// Reds
var R50 = '#FFEBE6';
var R75 = '#FFBDAD';
var R100 = '#FF8F73';
var R200 = '#FF7452';
var R300 = '#FF5630';
var R400 = '#DE350B';
var R500 = '#BF2600';

// Yellows
var Y50 = '#FFFAE6';
var Y75 = '#FFF0B3';
var Y100 = '#FFE380';
var Y200 = '#FFC400';
var Y300 = '#FFAB00';
var Y400 = '#FF991F';
var Y500 = '#FF8B00';

// Greens
var G50 = '#E3FCEF';
var G75 = '#ABF5D1';
var G100 = '#79F2C0';
var G200 = '#57D9A3';
var G300 = '#36B37E';
var G400 = '#00875A';
var G500 = '#006644';

// Blues
var B50 = '#DEEBFF';
var B75 = '#B3D4FF';
var B100 = '#4C9AFF';
var B200 = '#2684FF';
var B300 = '#0065FF';
var B400 = '#0052CC';
var B500 = '#0747A6';

// Purples
var P50 = '#EAE6FF';
var P75 = '#C0B6F2';
var P100 = '#998DD9';
var P200 = '#8777D9';
var P300 = '#6554C0';
var P400 = '#5243AA';
var P500 = '#403294';

// Teals
var T50 = '#E6FCFF';
var T75 = '#B3F5FF';
var T100 = '#79E2F2';
var T200 = '#00C7E6';
var T300 = '#00B8D9';
var T400 = '#00A3BF';
var T500 = '#008DA6';

// Neutrals
var N0 = '#FFFFFF';
var N10 = '#FAFBFC';
var N20 = '#F4F5F7';
var N30 = '#EBECF0';
var N40 = '#DFE1E6';
var N50 = '#C1C7D0';
var N60 = '#B3BAC5';
var N70 = '#A5ADBA';
var N80 = '#97A0AF';
var N90 = '#8993A4';
var N100 = '#7A869A';
var N200 = '#6B778C';
var N300 = '#5E6C84';
var N400 = '#505F79';
var N500 = '#42526E';
var N600 = '#344563';
var N700 = '#253858';
var N800 = '#172B4D';

// ATTENTION: update the tints if you update this
var N900 = '#091E42';

// Each tint is made of N900 and an alpha channel
var N10A = 'rgba(9, 30, 66, 0.02)';
var N20A = 'rgba(9, 30, 66, 0.04)';
var N30A = 'rgba(9, 30, 66, 0.08)';
var N40A = 'rgba(9, 30, 66, 0.13)';
var N50A = 'rgba(9, 30, 66, 0.25)';
var N60A = 'rgba(9, 30, 66, 0.31)';
var N70A = 'rgba(9, 30, 66, 0.36)';
var N80A = 'rgba(9, 30, 66, 0.42)';
var N90A = 'rgba(9, 30, 66, 0.48)';
var N100A = 'rgba(9, 30, 66, 0.54)';
var N200A = 'rgba(9, 30, 66, 0.60)';
var N300A = 'rgba(9, 30, 66, 0.66)';
var N400A = 'rgba(9, 30, 66, 0.71)';
var N500A = 'rgba(9, 30, 66, 0.77)';
var N600A = 'rgba(9, 30, 66, 0.82)';
var N700A = 'rgba(9, 30, 66, 0.89)';
var N800A = 'rgba(9, 30, 66, 0.95)';

// Dark Mode Neutrals
var DN900 = '#E6EDFA';
var DN800 = '#DCE5F5';
var DN700 = '#CED9EB';
var DN600 = '#B8C7E0';
var DN500 = '#ABBBD6';
var DN400 = '#9FB0CC';
var DN300 = '#8C9CB8';
var DN200 = '#7988A3';
var DN100 = '#67758F';
var DN90 = '#56637A';
var DN80 = '#455166';
var DN70 = '#3B475C';
var DN60 = '#313D52';
var DN50 = '#283447';
var DN40 = '#202B3D';
var DN30 = '#1B2638';
var DN20 = '#121A29';
var DN10 = '#0E1624';

// ATTENTION: update the tints if you update this
var DN0 = '#0D1424';

// Each dark tint is made of DN0 and an alpha channel
var DN800A = 'rgba(13, 20, 36, 0.06)';
var DN700A = 'rgba(13, 20, 36, 0.14)';
var DN600A = 'rgba(13, 20, 36, 0.18)';
var DN500A = 'rgba(13, 20, 36, 0.29)';
var DN400A = 'rgba(13, 20, 36, 0.36)';
var DN300A = 'rgba(13, 20, 36, 0.40)';
var DN200A = 'rgba(13, 20, 36, 0.47)';
var DN100A = 'rgba(13, 20, 36, 0.53)';
var DN90A = 'rgba(13, 20, 36, 0.63)';
var DN80A = 'rgba(13, 20, 36, 0.73)';
var DN70A = 'rgba(13, 20, 36, 0.78)';
var DN60A = 'rgba(13, 20, 36, 0.81)';
var DN50A = 'rgba(13, 20, 36, 0.85)';
var DN40A = 'rgba(13, 20, 36, 0.89)';
var DN30A = 'rgba(13, 20, 36, 0.92)';
var DN20A = 'rgba(13, 20, 36, 0.95)';
var DN10A = 'rgba(13, 20, 36, 0.97)';

// Themed colors
var background = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N0, dark: DN30 });
var backgroundActive = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B50, dark: B75 });
var backgroundHover = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N30, dark: DN70 });
var backgroundOnLayer = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N0, dark: DN50 });
var text = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N900, dark: DN600 });
var textHover = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N800, dark: DN600 });
var textActive = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B400, dark: B400 });
var subtleText = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N200, dark: DN300 });
var placeholderText = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N100, dark: DN200 });
var heading = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N800, dark: DN600 });
var subtleHeading = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N200, dark: DN300 });
var codeBlock = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N20, dark: DN50 });
var link = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B400, dark: B100 });
var linkHover = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B300, dark: B200 });
var linkActive = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B500, dark: B100 });
var linkOutline = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B100, dark: B200 });
var primary = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B400, dark: B100 });
var blue = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B400, dark: B100 });
var teal = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: T300, dark: T200 });
var purple = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: P300, dark: P100 });
var red = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: R300, dark: R300 });
var yellow = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: Y300, dark: Y300 });
var green = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: G300, dark: G300 });

// Jira Portfolio
var colorPalette8 = [{ background: N800, text: N0 }, { background: R400, text: N0 }, { background: P400, text: P50 }, { background: B400, text: B75 }, { background: T300, text: N800 }, { background: G400, text: N0 }, { background: Y400, text: N800 }, { background: N70, text: N800 }];

var colorPalette16 = [].concat(colorPalette8, [{ background: N500, text: N0 }, { background: R100, text: N800 }, { background: P75, text: N800 }, { background: B100, text: N800 }, { background: T100, text: N800 }, { background: G100, text: G500 }, { background: Y200, text: N800 }, { background: N0, text: N800 }]);

var colorPalette24 = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(colorPalette16), [{ background: N100, text: N0 }, { background: N40, text: N800 }, { background: N50, text: R500 }, { background: P50, text: P500 }, { background: B50, text: B500 }, { background: T75, text: N800 }, { background: G50, text: G500 }, { background: Y75, text: N800 }]);

var colorPalette = function colorPalette() {
  var palette = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '8';

  switch (palette) {
    case '8':
      return colorPalette8;
    case '16':
      return colorPalette16;
    case '24':
      return colorPalette24;
    default:
      throw new Error('The only available color palette is 8, 16, 24');
  }
};

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R50", function() { return R50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R75", function() { return R75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R100", function() { return R100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R200", function() { return R200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R300", function() { return R300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R400", function() { return R400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R500", function() { return R500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y50", function() { return Y50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y75", function() { return Y75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y100", function() { return Y100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y200", function() { return Y200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y300", function() { return Y300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y400", function() { return Y400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y500", function() { return Y500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G50", function() { return G50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G75", function() { return G75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G100", function() { return G100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G200", function() { return G200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G300", function() { return G300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G400", function() { return G400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G500", function() { return G500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B50", function() { return B50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B75", function() { return B75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B100", function() { return B100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B200", function() { return B200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B300", function() { return B300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B400", function() { return B400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B500", function() { return B500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P50", function() { return P50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P75", function() { return P75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P100", function() { return P100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P200", function() { return P200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P300", function() { return P300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P400", function() { return P400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P500", function() { return P500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T50", function() { return T50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T75", function() { return T75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T100", function() { return T100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T200", function() { return T200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T300", function() { return T300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T400", function() { return T400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T500", function() { return T500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N0", function() { return N0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N10", function() { return N10; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N20", function() { return N20; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N30", function() { return N30; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N40", function() { return N40; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N50", function() { return N50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N60", function() { return N60; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N70", function() { return N70; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N80", function() { return N80; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N90", function() { return N90; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N100", function() { return N100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N200", function() { return N200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N300", function() { return N300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N400", function() { return N400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N500", function() { return N500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N600", function() { return N600; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N700", function() { return N700; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N800", function() { return N800; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N900", function() { return N900; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N10A", function() { return N10A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N20A", function() { return N20A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N30A", function() { return N30A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N40A", function() { return N40A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N50A", function() { return N50A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N60A", function() { return N60A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N70A", function() { return N70A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N80A", function() { return N80A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N90A", function() { return N90A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N100A", function() { return N100A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N200A", function() { return N200A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N300A", function() { return N300A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N400A", function() { return N400A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N500A", function() { return N500A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N600A", function() { return N600A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N700A", function() { return N700A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N800A", function() { return N800A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN900", function() { return DN900; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN800", function() { return DN800; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN700", function() { return DN700; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN600", function() { return DN600; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN500", function() { return DN500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN400", function() { return DN400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN300", function() { return DN300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN200", function() { return DN200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN100", function() { return DN100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN90", function() { return DN90; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN80", function() { return DN80; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN70", function() { return DN70; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN60", function() { return DN60; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN50", function() { return DN50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN40", function() { return DN40; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN30", function() { return DN30; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN20", function() { return DN20; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN10", function() { return DN10; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN0", function() { return DN0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN800A", function() { return DN800A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN700A", function() { return DN700A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN600A", function() { return DN600A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN500A", function() { return DN500A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN400A", function() { return DN400A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN300A", function() { return DN300A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN200A", function() { return DN200A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN100A", function() { return DN100A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN90A", function() { return DN90A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN80A", function() { return DN80A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN70A", function() { return DN70A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN60A", function() { return DN60A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN50A", function() { return DN50A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN40A", function() { return DN40A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN30A", function() { return DN30A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN20A", function() { return DN20A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN10A", function() { return DN10A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "background", function() { return background; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundActive", function() { return backgroundActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundHover", function() { return backgroundHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundOnLayer", function() { return backgroundOnLayer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "text", function() { return text; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "textHover", function() { return textHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "textActive", function() { return textActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subtleText", function() { return subtleText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "placeholderText", function() { return placeholderText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "heading", function() { return heading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subtleHeading", function() { return subtleHeading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "codeBlock", function() { return codeBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "link", function() { return link; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linkHover", function() { return linkHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linkActive", function() { return linkActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linkOutline", function() { return linkOutline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "primary", function() { return primary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "blue", function() { return blue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "teal", function() { return teal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "purple", function() { return purple; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "red", function() { return red; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "yellow", function() { return yellow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "green", function() { return green; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette8", function() { return colorPalette8; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette16", function() { return colorPalette16; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette24", function() { return colorPalette24; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette", function() { return colorPalette; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_themed__ = __webpack_require__(166);




// Reds
var R50 = '#FFEBE6';
var R75 = '#FFBDAD';
var R100 = '#FF8F73';
var R200 = '#FF7452';
var R300 = '#FF5630';
var R400 = '#DE350B';
var R500 = '#BF2600';

// Yellows
var Y50 = '#FFFAE6';
var Y75 = '#FFF0B3';
var Y100 = '#FFE380';
var Y200 = '#FFC400';
var Y300 = '#FFAB00';
var Y400 = '#FF991F';
var Y500 = '#FF8B00';

// Greens
var G50 = '#E3FCEF';
var G75 = '#ABF5D1';
var G100 = '#79F2C0';
var G200 = '#57D9A3';
var G300 = '#36B37E';
var G400 = '#00875A';
var G500 = '#006644';

// Blues
var B50 = '#DEEBFF';
var B75 = '#B3D4FF';
var B100 = '#4C9AFF';
var B200 = '#2684FF';
var B300 = '#0065FF';
var B400 = '#0052CC';
var B500 = '#0747A6';

// Purples
var P50 = '#EAE6FF';
var P75 = '#C0B6F2';
var P100 = '#998DD9';
var P200 = '#8777D9';
var P300 = '#6554C0';
var P400 = '#5243AA';
var P500 = '#403294';

// Teals
var T50 = '#E6FCFF';
var T75 = '#B3F5FF';
var T100 = '#79E2F2';
var T200 = '#00C7E6';
var T300 = '#00B8D9';
var T400 = '#00A3BF';
var T500 = '#008DA6';

// Neutrals
var N0 = '#FFFFFF';
var N10 = '#FAFBFC';
var N20 = '#F4F5F7';
var N30 = '#EBECF0';
var N40 = '#DFE1E6';
var N50 = '#C1C7D0';
var N60 = '#B3BAC5';
var N70 = '#A5ADBA';
var N80 = '#97A0AF';
var N90 = '#8993A4';
var N100 = '#7A869A';
var N200 = '#6B778C';
var N300 = '#5E6C84';
var N400 = '#505F79';
var N500 = '#42526E';
var N600 = '#344563';
var N700 = '#253858';
var N800 = '#172B4D';

// ATTENTION: update the tints if you update this
var N900 = '#091E42';

// Each tint is made of N900 and an alpha channel
var N10A = 'rgba(9, 30, 66, 0.02)';
var N20A = 'rgba(9, 30, 66, 0.04)';
var N30A = 'rgba(9, 30, 66, 0.08)';
var N40A = 'rgba(9, 30, 66, 0.13)';
var N50A = 'rgba(9, 30, 66, 0.25)';
var N60A = 'rgba(9, 30, 66, 0.31)';
var N70A = 'rgba(9, 30, 66, 0.36)';
var N80A = 'rgba(9, 30, 66, 0.42)';
var N90A = 'rgba(9, 30, 66, 0.48)';
var N100A = 'rgba(9, 30, 66, 0.54)';
var N200A = 'rgba(9, 30, 66, 0.60)';
var N300A = 'rgba(9, 30, 66, 0.66)';
var N400A = 'rgba(9, 30, 66, 0.71)';
var N500A = 'rgba(9, 30, 66, 0.77)';
var N600A = 'rgba(9, 30, 66, 0.82)';
var N700A = 'rgba(9, 30, 66, 0.89)';
var N800A = 'rgba(9, 30, 66, 0.95)';

// Dark Mode Neutrals
var DN900 = '#E6EDFA';
var DN800 = '#DCE5F5';
var DN700 = '#CED9EB';
var DN600 = '#B8C7E0';
var DN500 = '#ABBBD6';
var DN400 = '#9FB0CC';
var DN300 = '#8C9CB8';
var DN200 = '#7988A3';
var DN100 = '#67758F';
var DN90 = '#56637A';
var DN80 = '#455166';
var DN70 = '#3B475C';
var DN60 = '#313D52';
var DN50 = '#283447';
var DN40 = '#202B3D';
var DN30 = '#1B2638';
var DN20 = '#121A29';
var DN10 = '#0E1624';

// ATTENTION: update the tints if you update this
var DN0 = '#0D1424';

// Each dark tint is made of DN0 and an alpha channel
var DN800A = 'rgba(13, 20, 36, 0.06)';
var DN700A = 'rgba(13, 20, 36, 0.14)';
var DN600A = 'rgba(13, 20, 36, 0.18)';
var DN500A = 'rgba(13, 20, 36, 0.29)';
var DN400A = 'rgba(13, 20, 36, 0.36)';
var DN300A = 'rgba(13, 20, 36, 0.40)';
var DN200A = 'rgba(13, 20, 36, 0.47)';
var DN100A = 'rgba(13, 20, 36, 0.53)';
var DN90A = 'rgba(13, 20, 36, 0.63)';
var DN80A = 'rgba(13, 20, 36, 0.73)';
var DN70A = 'rgba(13, 20, 36, 0.78)';
var DN60A = 'rgba(13, 20, 36, 0.81)';
var DN50A = 'rgba(13, 20, 36, 0.85)';
var DN40A = 'rgba(13, 20, 36, 0.89)';
var DN30A = 'rgba(13, 20, 36, 0.92)';
var DN20A = 'rgba(13, 20, 36, 0.95)';
var DN10A = 'rgba(13, 20, 36, 0.97)';

// Themed colors
var background = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N0, dark: DN30 });
var backgroundActive = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B50, dark: B75 });
var backgroundHover = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N30, dark: DN70 });
var backgroundOnLayer = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N0, dark: DN50 });
var text = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N900, dark: DN600 });
var textHover = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N800, dark: DN600 });
var textActive = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B400, dark: B400 });
var subtleText = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N200, dark: DN300 });
var placeholderText = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N100, dark: DN200 });
var heading = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N800, dark: DN600 });
var subtleHeading = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N200, dark: DN300 });
var codeBlock = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N20, dark: DN50 });
var link = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B400, dark: B100 });
var linkHover = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B300, dark: B200 });
var linkActive = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B500, dark: B100 });
var linkOutline = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B100, dark: B200 });
var primary = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B400, dark: B100 });
var blue = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B400, dark: B100 });
var teal = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: T300, dark: T200 });
var purple = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: P300, dark: P100 });
var red = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: R300, dark: R300 });
var yellow = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: Y300, dark: Y300 });
var green = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: G300, dark: G300 });

// Jira Portfolio
var colorPalette8 = [{ background: N800, text: N0 }, { background: R400, text: N0 }, { background: P400, text: P50 }, { background: B400, text: B75 }, { background: T300, text: N800 }, { background: G400, text: N0 }, { background: Y400, text: N800 }, { background: N70, text: N800 }];

var colorPalette16 = [].concat(colorPalette8, [{ background: N500, text: N0 }, { background: R100, text: N800 }, { background: P75, text: N800 }, { background: B100, text: N800 }, { background: T100, text: N800 }, { background: G100, text: G500 }, { background: Y200, text: N800 }, { background: N0, text: N800 }]);

var colorPalette24 = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(colorPalette16), [{ background: N100, text: N0 }, { background: N40, text: N800 }, { background: N50, text: R500 }, { background: P50, text: P500 }, { background: B50, text: B500 }, { background: T75, text: N800 }, { background: G50, text: G500 }, { background: Y75, text: N800 }]);

var colorPalette = function colorPalette() {
  var palette = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '8';

  switch (palette) {
    case '8':
      return colorPalette8;
    case '16':
      return colorPalette16;
    case '24':
      return colorPalette24;
    default:
      throw new Error('The only available color palette is 8, 16, 24');
  }
};

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return focusManagerContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectionCacheContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectionManagerContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clickManagerContext; });
var prefix = function prefix(key) {
  return '@atlaskit-private-do-not-use/dropdown-menu:' + key;
};

var focusManagerContext = prefix('focus-manager');
var selectionCacheContext = prefix('selection-cache');
var selectionManagerContext = prefix('selection-manager');
var clickManagerContext = prefix('click-manager');

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R50", function() { return R50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R75", function() { return R75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R100", function() { return R100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R200", function() { return R200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R300", function() { return R300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R400", function() { return R400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R500", function() { return R500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y50", function() { return Y50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y75", function() { return Y75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y100", function() { return Y100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y200", function() { return Y200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y300", function() { return Y300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y400", function() { return Y400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y500", function() { return Y500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G50", function() { return G50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G75", function() { return G75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G100", function() { return G100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G200", function() { return G200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G300", function() { return G300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G400", function() { return G400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G500", function() { return G500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B50", function() { return B50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B75", function() { return B75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B100", function() { return B100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B200", function() { return B200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B300", function() { return B300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B400", function() { return B400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B500", function() { return B500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P50", function() { return P50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P75", function() { return P75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P100", function() { return P100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P200", function() { return P200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P300", function() { return P300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P400", function() { return P400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P500", function() { return P500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T50", function() { return T50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T75", function() { return T75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T100", function() { return T100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T200", function() { return T200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T300", function() { return T300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T400", function() { return T400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T500", function() { return T500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N0", function() { return N0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N10", function() { return N10; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N20", function() { return N20; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N30", function() { return N30; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N40", function() { return N40; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N50", function() { return N50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N60", function() { return N60; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N70", function() { return N70; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N80", function() { return N80; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N90", function() { return N90; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N100", function() { return N100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N200", function() { return N200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N300", function() { return N300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N400", function() { return N400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N500", function() { return N500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N600", function() { return N600; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N700", function() { return N700; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N800", function() { return N800; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N900", function() { return N900; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N10A", function() { return N10A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N20A", function() { return N20A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N30A", function() { return N30A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N40A", function() { return N40A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N50A", function() { return N50A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N60A", function() { return N60A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N70A", function() { return N70A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N80A", function() { return N80A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N90A", function() { return N90A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N100A", function() { return N100A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N200A", function() { return N200A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N300A", function() { return N300A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N400A", function() { return N400A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N500A", function() { return N500A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N600A", function() { return N600A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N700A", function() { return N700A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N800A", function() { return N800A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN900", function() { return DN900; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN800", function() { return DN800; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN700", function() { return DN700; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN600", function() { return DN600; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN500", function() { return DN500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN400", function() { return DN400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN300", function() { return DN300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN200", function() { return DN200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN100", function() { return DN100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN90", function() { return DN90; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN80", function() { return DN80; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN70", function() { return DN70; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN60", function() { return DN60; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN50", function() { return DN50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN40", function() { return DN40; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN30", function() { return DN30; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN20", function() { return DN20; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN10", function() { return DN10; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN0", function() { return DN0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN800A", function() { return DN800A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN700A", function() { return DN700A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN600A", function() { return DN600A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN500A", function() { return DN500A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN400A", function() { return DN400A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN300A", function() { return DN300A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN200A", function() { return DN200A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN100A", function() { return DN100A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN90A", function() { return DN90A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN80A", function() { return DN80A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN70A", function() { return DN70A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN60A", function() { return DN60A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN50A", function() { return DN50A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN40A", function() { return DN40A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN30A", function() { return DN30A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN20A", function() { return DN20A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN10A", function() { return DN10A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "background", function() { return background; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundActive", function() { return backgroundActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundHover", function() { return backgroundHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundOnLayer", function() { return backgroundOnLayer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "text", function() { return text; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "textHover", function() { return textHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "textActive", function() { return textActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subtleText", function() { return subtleText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "placeholderText", function() { return placeholderText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "heading", function() { return heading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subtleHeading", function() { return subtleHeading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "codeBlock", function() { return codeBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "link", function() { return link; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linkHover", function() { return linkHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linkActive", function() { return linkActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linkOutline", function() { return linkOutline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "primary", function() { return primary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "blue", function() { return blue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "teal", function() { return teal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "purple", function() { return purple; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "red", function() { return red; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "yellow", function() { return yellow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "green", function() { return green; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette8", function() { return colorPalette8; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette16", function() { return colorPalette16; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette24", function() { return colorPalette24; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette", function() { return colorPalette; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_themed__ = __webpack_require__(169);




// Reds
var R50 = '#FFEBE6';
var R75 = '#FFBDAD';
var R100 = '#FF8F73';
var R200 = '#FF7452';
var R300 = '#FF5630';
var R400 = '#DE350B';
var R500 = '#BF2600';

// Yellows
var Y50 = '#FFFAE6';
var Y75 = '#FFF0B3';
var Y100 = '#FFE380';
var Y200 = '#FFC400';
var Y300 = '#FFAB00';
var Y400 = '#FF991F';
var Y500 = '#FF8B00';

// Greens
var G50 = '#E3FCEF';
var G75 = '#ABF5D1';
var G100 = '#79F2C0';
var G200 = '#57D9A3';
var G300 = '#36B37E';
var G400 = '#00875A';
var G500 = '#006644';

// Blues
var B50 = '#DEEBFF';
var B75 = '#B3D4FF';
var B100 = '#4C9AFF';
var B200 = '#2684FF';
var B300 = '#0065FF';
var B400 = '#0052CC';
var B500 = '#0747A6';

// Purples
var P50 = '#EAE6FF';
var P75 = '#C0B6F2';
var P100 = '#998DD9';
var P200 = '#8777D9';
var P300 = '#6554C0';
var P400 = '#5243AA';
var P500 = '#403294';

// Teals
var T50 = '#E6FCFF';
var T75 = '#B3F5FF';
var T100 = '#79E2F2';
var T200 = '#00C7E6';
var T300 = '#00B8D9';
var T400 = '#00A3BF';
var T500 = '#008DA6';

// Neutrals
var N0 = '#FFFFFF';
var N10 = '#FAFBFC';
var N20 = '#F4F5F7';
var N30 = '#EBECF0';
var N40 = '#DFE1E6';
var N50 = '#C1C7D0';
var N60 = '#B3BAC5';
var N70 = '#A5ADBA';
var N80 = '#97A0AF';
var N90 = '#8993A4';
var N100 = '#7A869A';
var N200 = '#6B778C';
var N300 = '#5E6C84';
var N400 = '#505F79';
var N500 = '#42526E';
var N600 = '#344563';
var N700 = '#253858';
var N800 = '#172B4D';

// ATTENTION: update the tints if you update this
var N900 = '#091E42';

// Each tint is made of N900 and an alpha channel
var N10A = 'rgba(9, 30, 66, 0.02)';
var N20A = 'rgba(9, 30, 66, 0.04)';
var N30A = 'rgba(9, 30, 66, 0.08)';
var N40A = 'rgba(9, 30, 66, 0.13)';
var N50A = 'rgba(9, 30, 66, 0.25)';
var N60A = 'rgba(9, 30, 66, 0.31)';
var N70A = 'rgba(9, 30, 66, 0.36)';
var N80A = 'rgba(9, 30, 66, 0.42)';
var N90A = 'rgba(9, 30, 66, 0.48)';
var N100A = 'rgba(9, 30, 66, 0.54)';
var N200A = 'rgba(9, 30, 66, 0.60)';
var N300A = 'rgba(9, 30, 66, 0.66)';
var N400A = 'rgba(9, 30, 66, 0.71)';
var N500A = 'rgba(9, 30, 66, 0.77)';
var N600A = 'rgba(9, 30, 66, 0.82)';
var N700A = 'rgba(9, 30, 66, 0.89)';
var N800A = 'rgba(9, 30, 66, 0.95)';

// Dark Mode Neutrals
var DN900 = '#E6EDFA';
var DN800 = '#DCE5F5';
var DN700 = '#CED9EB';
var DN600 = '#B8C7E0';
var DN500 = '#ABBBD6';
var DN400 = '#9FB0CC';
var DN300 = '#8C9CB8';
var DN200 = '#7988A3';
var DN100 = '#67758F';
var DN90 = '#56637A';
var DN80 = '#455166';
var DN70 = '#3B475C';
var DN60 = '#313D52';
var DN50 = '#283447';
var DN40 = '#202B3D';
var DN30 = '#1B2638';
var DN20 = '#121A29';
var DN10 = '#0E1624';

// ATTENTION: update the tints if you update this
var DN0 = '#0D1424';

// Each dark tint is made of DN0 and an alpha channel
var DN800A = 'rgba(13, 20, 36, 0.06)';
var DN700A = 'rgba(13, 20, 36, 0.14)';
var DN600A = 'rgba(13, 20, 36, 0.18)';
var DN500A = 'rgba(13, 20, 36, 0.29)';
var DN400A = 'rgba(13, 20, 36, 0.36)';
var DN300A = 'rgba(13, 20, 36, 0.40)';
var DN200A = 'rgba(13, 20, 36, 0.47)';
var DN100A = 'rgba(13, 20, 36, 0.53)';
var DN90A = 'rgba(13, 20, 36, 0.63)';
var DN80A = 'rgba(13, 20, 36, 0.73)';
var DN70A = 'rgba(13, 20, 36, 0.78)';
var DN60A = 'rgba(13, 20, 36, 0.81)';
var DN50A = 'rgba(13, 20, 36, 0.85)';
var DN40A = 'rgba(13, 20, 36, 0.89)';
var DN30A = 'rgba(13, 20, 36, 0.92)';
var DN20A = 'rgba(13, 20, 36, 0.95)';
var DN10A = 'rgba(13, 20, 36, 0.97)';

// Themed colors
var background = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N0, dark: DN30 });
var backgroundActive = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B50, dark: B75 });
var backgroundHover = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N30, dark: DN70 });
var backgroundOnLayer = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N0, dark: DN50 });
var text = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N900, dark: DN600 });
var textHover = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N800, dark: DN600 });
var textActive = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B400, dark: B400 });
var subtleText = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N200, dark: DN300 });
var placeholderText = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N100, dark: DN200 });
var heading = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N800, dark: DN600 });
var subtleHeading = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N200, dark: DN300 });
var codeBlock = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N20, dark: DN50 });
var link = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B400, dark: B100 });
var linkHover = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B300, dark: B200 });
var linkActive = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B500, dark: B100 });
var linkOutline = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B100, dark: B200 });
var primary = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B400, dark: B100 });
var blue = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B400, dark: B100 });
var teal = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: T300, dark: T200 });
var purple = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: P300, dark: P100 });
var red = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: R300, dark: R300 });
var yellow = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: Y300, dark: Y300 });
var green = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: G300, dark: G300 });

// Jira Portfolio
var colorPalette8 = [{ background: N800, text: N0 }, { background: R400, text: N0 }, { background: P400, text: P50 }, { background: B400, text: B75 }, { background: T300, text: N800 }, { background: G400, text: N0 }, { background: Y400, text: N800 }, { background: N70, text: N800 }];

var colorPalette16 = [].concat(colorPalette8, [{ background: N500, text: N0 }, { background: R100, text: N800 }, { background: P75, text: N800 }, { background: B100, text: N800 }, { background: T100, text: N800 }, { background: G100, text: G500 }, { background: Y200, text: N800 }, { background: N0, text: N800 }]);

var colorPalette24 = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(colorPalette16), [{ background: N100, text: N0 }, { background: N40, text: N800 }, { background: N50, text: R500 }, { background: P50, text: P500 }, { background: B50, text: B500 }, { background: T75, text: N800 }, { background: G50, text: G500 }, { background: Y75, text: N800 }]);

var colorPalette = function colorPalette() {
  var palette = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '8';

  switch (palette) {
    case '8':
      return colorPalette8;
    case '16':
      return colorPalette16;
    case '24':
      return colorPalette24;
    default:
      throw new Error('The only available color palette is 8, 16, 24');
  }
};

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R50", function() { return R50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R75", function() { return R75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R100", function() { return R100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R200", function() { return R200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R300", function() { return R300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R400", function() { return R400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R500", function() { return R500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y50", function() { return Y50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y75", function() { return Y75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y100", function() { return Y100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y200", function() { return Y200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y300", function() { return Y300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y400", function() { return Y400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y500", function() { return Y500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G50", function() { return G50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G75", function() { return G75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G100", function() { return G100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G200", function() { return G200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G300", function() { return G300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G400", function() { return G400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G500", function() { return G500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B50", function() { return B50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B75", function() { return B75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B100", function() { return B100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B200", function() { return B200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B300", function() { return B300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B400", function() { return B400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B500", function() { return B500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P50", function() { return P50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P75", function() { return P75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P100", function() { return P100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P200", function() { return P200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P300", function() { return P300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P400", function() { return P400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P500", function() { return P500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T50", function() { return T50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T75", function() { return T75; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T100", function() { return T100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T200", function() { return T200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T300", function() { return T300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T400", function() { return T400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T500", function() { return T500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N0", function() { return N0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N10", function() { return N10; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N20", function() { return N20; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N30", function() { return N30; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N40", function() { return N40; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N50", function() { return N50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N60", function() { return N60; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N70", function() { return N70; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N80", function() { return N80; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N90", function() { return N90; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N100", function() { return N100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N200", function() { return N200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N300", function() { return N300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N400", function() { return N400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N500", function() { return N500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N600", function() { return N600; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N700", function() { return N700; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N800", function() { return N800; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N900", function() { return N900; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N10A", function() { return N10A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N20A", function() { return N20A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N30A", function() { return N30A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N40A", function() { return N40A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N50A", function() { return N50A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N60A", function() { return N60A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N70A", function() { return N70A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N80A", function() { return N80A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N90A", function() { return N90A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N100A", function() { return N100A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N200A", function() { return N200A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N300A", function() { return N300A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N400A", function() { return N400A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N500A", function() { return N500A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N600A", function() { return N600A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N700A", function() { return N700A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N800A", function() { return N800A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN900", function() { return DN900; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN800", function() { return DN800; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN700", function() { return DN700; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN600", function() { return DN600; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN500", function() { return DN500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN400", function() { return DN400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN300", function() { return DN300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN200", function() { return DN200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN100", function() { return DN100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN90", function() { return DN90; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN80", function() { return DN80; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN70", function() { return DN70; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN60", function() { return DN60; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN50", function() { return DN50; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN40", function() { return DN40; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN30", function() { return DN30; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN20", function() { return DN20; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN10", function() { return DN10; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN0", function() { return DN0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN800A", function() { return DN800A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN700A", function() { return DN700A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN600A", function() { return DN600A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN500A", function() { return DN500A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN400A", function() { return DN400A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN300A", function() { return DN300A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN200A", function() { return DN200A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN100A", function() { return DN100A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN90A", function() { return DN90A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN80A", function() { return DN80A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN70A", function() { return DN70A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN60A", function() { return DN60A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN50A", function() { return DN50A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN40A", function() { return DN40A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN30A", function() { return DN30A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN20A", function() { return DN20A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DN10A", function() { return DN10A; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "background", function() { return background; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundActive", function() { return backgroundActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundHover", function() { return backgroundHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundOnLayer", function() { return backgroundOnLayer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "text", function() { return text; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "textHover", function() { return textHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "textActive", function() { return textActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subtleText", function() { return subtleText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "placeholderText", function() { return placeholderText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "heading", function() { return heading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subtleHeading", function() { return subtleHeading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "codeBlock", function() { return codeBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "link", function() { return link; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linkHover", function() { return linkHover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linkActive", function() { return linkActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linkOutline", function() { return linkOutline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "primary", function() { return primary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "blue", function() { return blue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "teal", function() { return teal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "purple", function() { return purple; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "red", function() { return red; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "yellow", function() { return yellow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "green", function() { return green; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette8", function() { return colorPalette8; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette16", function() { return colorPalette16; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette24", function() { return colorPalette24; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorPalette", function() { return colorPalette; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_themed__ = __webpack_require__(178);




// Reds
var R50 = '#FFEBE6';
var R75 = '#FFBDAD';
var R100 = '#FF8F73';
var R200 = '#FF7452';
var R300 = '#FF5630';
var R400 = '#DE350B';
var R500 = '#BF2600';

// Yellows
var Y50 = '#FFFAE6';
var Y75 = '#FFF0B3';
var Y100 = '#FFE380';
var Y200 = '#FFC400';
var Y300 = '#FFAB00';
var Y400 = '#FF991F';
var Y500 = '#FF8B00';

// Greens
var G50 = '#E3FCEF';
var G75 = '#ABF5D1';
var G100 = '#79F2C0';
var G200 = '#57D9A3';
var G300 = '#36B37E';
var G400 = '#00875A';
var G500 = '#006644';

// Blues
var B50 = '#DEEBFF';
var B75 = '#B3D4FF';
var B100 = '#4C9AFF';
var B200 = '#2684FF';
var B300 = '#0065FF';
var B400 = '#0052CC';
var B500 = '#0747A6';

// Purples
var P50 = '#EAE6FF';
var P75 = '#C0B6F2';
var P100 = '#998DD9';
var P200 = '#8777D9';
var P300 = '#6554C0';
var P400 = '#5243AA';
var P500 = '#403294';

// Teals
var T50 = '#E6FCFF';
var T75 = '#B3F5FF';
var T100 = '#79E2F2';
var T200 = '#00C7E6';
var T300 = '#00B8D9';
var T400 = '#00A3BF';
var T500 = '#008DA6';

// Neutrals
var N0 = '#FFFFFF';
var N10 = '#FAFBFC';
var N20 = '#F4F5F7';
var N30 = '#EBECF0';
var N40 = '#DFE1E6';
var N50 = '#C1C7D0';
var N60 = '#B3BAC5';
var N70 = '#A5ADBA';
var N80 = '#97A0AF';
var N90 = '#8993A4';
var N100 = '#7A869A';
var N200 = '#6B778C';
var N300 = '#5E6C84';
var N400 = '#505F79';
var N500 = '#42526E';
var N600 = '#344563';
var N700 = '#253858';
var N800 = '#172B4D';

// ATTENTION: update the tints if you update this
var N900 = '#091E42';

// Each tint is made of N900 and an alpha channel
var N10A = 'rgba(9, 30, 66, 0.02)';
var N20A = 'rgba(9, 30, 66, 0.04)';
var N30A = 'rgba(9, 30, 66, 0.08)';
var N40A = 'rgba(9, 30, 66, 0.13)';
var N50A = 'rgba(9, 30, 66, 0.25)';
var N60A = 'rgba(9, 30, 66, 0.31)';
var N70A = 'rgba(9, 30, 66, 0.36)';
var N80A = 'rgba(9, 30, 66, 0.42)';
var N90A = 'rgba(9, 30, 66, 0.48)';
var N100A = 'rgba(9, 30, 66, 0.54)';
var N200A = 'rgba(9, 30, 66, 0.60)';
var N300A = 'rgba(9, 30, 66, 0.66)';
var N400A = 'rgba(9, 30, 66, 0.71)';
var N500A = 'rgba(9, 30, 66, 0.77)';
var N600A = 'rgba(9, 30, 66, 0.82)';
var N700A = 'rgba(9, 30, 66, 0.89)';
var N800A = 'rgba(9, 30, 66, 0.95)';

// Dark Mode Neutrals
var DN900 = '#E6EDFA';
var DN800 = '#DCE5F5';
var DN700 = '#CED9EB';
var DN600 = '#B8C7E0';
var DN500 = '#ABBBD6';
var DN400 = '#9FB0CC';
var DN300 = '#8C9CB8';
var DN200 = '#7988A3';
var DN100 = '#67758F';
var DN90 = '#56637A';
var DN80 = '#455166';
var DN70 = '#3B475C';
var DN60 = '#313D52';
var DN50 = '#283447';
var DN40 = '#202B3D';
var DN30 = '#1B2638';
var DN20 = '#121A29';
var DN10 = '#0E1624';

// ATTENTION: update the tints if you update this
var DN0 = '#0D1424';

// Each dark tint is made of DN0 and an alpha channel
var DN800A = 'rgba(13, 20, 36, 0.06)';
var DN700A = 'rgba(13, 20, 36, 0.14)';
var DN600A = 'rgba(13, 20, 36, 0.18)';
var DN500A = 'rgba(13, 20, 36, 0.29)';
var DN400A = 'rgba(13, 20, 36, 0.36)';
var DN300A = 'rgba(13, 20, 36, 0.40)';
var DN200A = 'rgba(13, 20, 36, 0.47)';
var DN100A = 'rgba(13, 20, 36, 0.53)';
var DN90A = 'rgba(13, 20, 36, 0.63)';
var DN80A = 'rgba(13, 20, 36, 0.73)';
var DN70A = 'rgba(13, 20, 36, 0.78)';
var DN60A = 'rgba(13, 20, 36, 0.81)';
var DN50A = 'rgba(13, 20, 36, 0.85)';
var DN40A = 'rgba(13, 20, 36, 0.89)';
var DN30A = 'rgba(13, 20, 36, 0.92)';
var DN20A = 'rgba(13, 20, 36, 0.95)';
var DN10A = 'rgba(13, 20, 36, 0.97)';

// Themed colors
var background = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N0, dark: DN30 });
var backgroundActive = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B50, dark: B75 });
var backgroundHover = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N30, dark: DN70 });
var backgroundOnLayer = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N0, dark: DN50 });
var text = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N900, dark: DN600 });
var textHover = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N800, dark: DN600 });
var textActive = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B400, dark: B400 });
var subtleText = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N200, dark: DN300 });
var placeholderText = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N100, dark: DN200 });
var heading = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N800, dark: DN600 });
var subtleHeading = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N200, dark: DN300 });
var codeBlock = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: N20, dark: DN50 });
var link = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B400, dark: B100 });
var linkHover = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B300, dark: B200 });
var linkActive = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B500, dark: B100 });
var linkOutline = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B100, dark: B200 });
var primary = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B400, dark: B100 });
var blue = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: B400, dark: B100 });
var teal = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: T300, dark: T200 });
var purple = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: P300, dark: P100 });
var red = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: R300, dark: R300 });
var yellow = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: Y300, dark: Y300 });
var green = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({ light: G300, dark: G300 });

// Jira Portfolio
var colorPalette8 = [{ background: N800, text: N0 }, { background: R400, text: N0 }, { background: P400, text: P50 }, { background: B400, text: B75 }, { background: T300, text: N800 }, { background: G400, text: N0 }, { background: Y400, text: N800 }, { background: N70, text: N800 }];

var colorPalette16 = [].concat(colorPalette8, [{ background: N500, text: N0 }, { background: R100, text: N800 }, { background: P75, text: N800 }, { background: B100, text: N800 }, { background: T100, text: N800 }, { background: G100, text: G500 }, { background: Y200, text: N800 }, { background: N0, text: N800 }]);

var colorPalette24 = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(colorPalette16), [{ background: N100, text: N0 }, { background: N40, text: N800 }, { background: N50, text: R500 }, { background: P50, text: P500 }, { background: B50, text: B500 }, { background: T75, text: N800 }, { background: G50, text: G500 }, { background: Y75, text: N800 }]);

var colorPalette = function colorPalette() {
  var palette = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '8';

  switch (palette) {
    case '8':
      return colorPalette8;
    case '16':
      return colorPalette16;
    case '24':
      return colorPalette24;
    default:
      throw new Error('The only available color palette is 8, 16, 24');
  }
};

/***/ }),
/* 72 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/**
 * Indicates that navigation was caused by a call to history.push.
 */
var PUSH = exports.PUSH = 'PUSH';

/**
 * Indicates that navigation was caused by a call to history.replace.
 */
var REPLACE = exports.REPLACE = 'REPLACE';

/**
 * Indicates that navigation was caused by some other action such
 * as using a browser's back/forward buttons and/or manually manipulating
 * the URL in a browser's location bar. This is the default.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
 * for more information.
 */
var POP = exports.POP = 'POP';

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 76 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 77 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(25);
var core = __webpack_require__(18);
var fails = __webpack_require__(47);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AnalyticsEvent__ = __webpack_require__(135);









var _console = console,
    warn = _console.warn;

var UIAnalyticsEvent = function (_AnalyticsEvent) {
  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(UIAnalyticsEvent, _AnalyticsEvent);

  function UIAnalyticsEvent(props) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, UIAnalyticsEvent);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (UIAnalyticsEvent.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(UIAnalyticsEvent)).call(this, props));

    _this.clone = function () {
      if (_this.hasFired) {
        warn("Cannot clone an event after it's been fired.");
        return null;
      }
      var context = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(_this.context));
      var handlers = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(_this.handlers));

      // We stringify and parse here to get a hacky "deep clone" of the object.
      // This has some limitations in that it wont support functions, regexs, Maps, Sets, etc,
      // but none of those need to be represented in our payload, so we consider this fine
      var payload = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this.payload));

      return new UIAnalyticsEvent({ context: context, handlers: handlers, payload: payload });
    };

    _this.fire = function (channel) {
      if (_this.hasFired) {
        warn('Cannot fire an event twice.');
        return;
      }
      _this.handlers.forEach(function (handler) {
        handler(_this, channel);
      });
      _this.hasFired = true;
    };

    _this.context = props.context || [];
    _this.handlers = props.handlers || [];
    _this.hasFired = false;
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(UIAnalyticsEvent, [{
    key: 'update',
    value: function update(updater) {
      if (this.hasFired) {
        warn("Cannot update an event after it's been fired.");
        return this;
      }
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get___default()(UIAnalyticsEvent.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(UIAnalyticsEvent.prototype), 'update', this).call(this, updater);
    }
  }]);

  return UIAnalyticsEvent;
}(__WEBPACK_IMPORTED_MODULE_8__AnalyticsEvent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (UIAnalyticsEvent);

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Consumer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Provider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var _createContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])({}),
    Consumer = _createContext.Consumer,
    Provider = _createContext.Provider;



/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Consumer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Provider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var _createContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])({}),
    Consumer = _createContext.Consumer,
    Provider = _createContext.Provider;



/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactLifecyclesCompat = __webpack_require__(226);

var _ChildMapping = __webpack_require__(475);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var propTypes = {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: _propTypes2.default.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   */
  children: _propTypes2.default.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes2.default.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes2.default.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: _propTypes2.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes2.default.func
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }

  /**
   * The `<TransitionGroup>` component manages a set of `<Transition>` components
   * in a list. Like with the `<Transition>` component, `<TransitionGroup>`, is a
   * state machine for managing the mounting and unmounting of components over
   * time.
   *
   * Consider the example below using the `Fade` CSS transition from before.
   * As items are removed or added to the TodoList the `in` prop is toggled
   * automatically by the `<TransitionGroup>`. You can use _any_ `<Transition>`
   * component in a `<TransitionGroup>`, not just css.
   *
   * ## Example
   *
   * <iframe src="https://codesandbox.io/embed/00rqyo26kn?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
   *
   * Note that `<TransitionGroup>`  does not define any animation behavior!
   * Exactly _how_ a list item animates is up to the individual `<Transition>`
   * components. This means you can mix and match animations across different
   * list items.
   */
};
var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    var handleExited = _this.handleExited.bind(_this);

    // Initial children should all be entering, dependent on appear
    _this.state = {
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  TransitionGroup.prototype.getChildContext = function getChildContext() {
    return {
      transitionGroup: { isMounting: !this.appeared }
    };
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    this.appeared = true;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;

    return {
      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };

  TransitionGroup.prototype.handleExited = function handleExited(child, node) {
    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);

    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    this.setState(function (state) {
      var children = _extends({}, state.children);

      delete children[child.key];
      return { children: children };
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _props = this.props,
        Component = _props.component,
        childFactory = _props.childFactory,
        props = _objectWithoutProperties(_props, ['component', 'childFactory']);

    var children = values(this.state.children).map(childFactory);

    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return children;
    }
    return _react2.default.createElement(
      Component,
      props,
      children
    );
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes2.default.object.isRequired
};


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);
module.exports = exports['default'];

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__withContextFromProps__ = __webpack_require__(145);








var contextTypes = {
  blockChildGatewayRender: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool
};

var ContextProvider = Object(__WEBPACK_IMPORTED_MODULE_5__withContextFromProps__["a" /* default */])(contextTypes, null);

var GatewayRegistry = function () {
  function GatewayRegistry() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, GatewayRegistry);

    this.containers = {};
    this.children = {};
    this.currentId = 0;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(GatewayRegistry, [{
    key: 'renderContainer',
    // Unique key for children of a gateway

    /**
     *   NOTE: this is where we deviate from cloudflare/react-gateway
     *   https://github.com/cloudflare/react-gateway/blob/master/src/GatewayRegistry.js#L10
     *
     *   Rather than passing children through directly, they're cloned with:
     *   - stackIndex
     *   - stackTotal
     */
    value: function renderContainer(name, addedGateway) {
      var _this = this;

      if (!this.containers[name] || !this.children[name]) {
        return;
      }

      var childrenKeys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.children[name]).sort();
      var stackTotal = childrenKeys.length;
      var addedGatewayIndex = childrenKeys.indexOf(addedGateway);

      this.containers[name].setState({
        children: childrenKeys.map(function (key, i) {
          var stackIndex = stackTotal - (i + 1);
          var element = Object(__WEBPACK_IMPORTED_MODULE_3_react__["cloneElement"])(_this.children[name][key].child, {
            stackIndex: stackIndex,
            stackTotal: stackTotal
          });
          // Do not re-render nested gateways when a gateway is added to prevent an infinite loop
          // caused by an added gateway triggering a re-render of its parent and then itself.
          var blockChildGatewayRender = addedGateway != null && i < addedGatewayIndex;

          return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            ContextProvider,
            {
              blockChildGatewayRender: blockChildGatewayRender,
              key: key
            },
            element
          );
        })
      });
    }
  }, {
    key: 'addContainer',
    value: function addContainer(name, container) {
      this.containers[name] = container;
      this.renderContainer(name);
    }
  }, {
    key: 'removeContainer',
    value: function removeContainer(name) {
      this.containers[name] = null;
    }
  }, {
    key: 'addChild',
    value: function addChild(name, gatewayId, child) {
      this.children[name][gatewayId] = {
        child: child
      };
      this.renderContainer(name, gatewayId);
    }
  }, {
    key: 'clearChild',
    value: function clearChild(name, gatewayId) {
      delete this.children[name][gatewayId];
    }
  }, {
    key: 'register',
    value: function register(name, child) {
      this.children[name] = this.children[name] || {};

      var gatewayId = name + '_' + this.currentId;
      this.children[name][gatewayId] = {
        child: child
      };
      this.currentId += 1;

      return gatewayId;
    }
  }, {
    key: 'unregister',
    value: function unregister(name, gatewayId) {
      this.clearChild(name, gatewayId);
      this.renderContainer(name);
    }
  }]);

  return GatewayRegistry;
}();

/* harmony default export */ __webpack_exports__["a"] = (GatewayRegistry);

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ScrollLock = __webpack_require__(504);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ScrollLock).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return ExecutionEnvironment;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Consumer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Provider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var _createContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])({}),
    Consumer = _createContext.Consumer,
    Provider = _createContext.Provider;



/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Consumer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Provider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var _createContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])({}),
    Consumer = _createContext.Consumer,
    Provider = _createContext.Provider;



/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Consumer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Provider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var _createContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])({}),
    Consumer = _createContext.Consumer,
    Provider = _createContext.Provider;



/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Consumer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Provider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var _createContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])({}),
    Consumer = _createContext.Consumer,
    Provider = _createContext.Provider;



/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return keylineHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Header; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Title; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return TitleText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return TitleIconWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Body; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Footer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Actions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_flex_max_height_ie_fix__ = __webpack_require__(243);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  ', ';\n'], ['\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  ', ';\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  align-items: center;\n  display: flex;\n  flex: 0 0 auto;\n  justify-content: space-between;\n  transition: box-shadow 200ms;\n'], ['\n  align-items: center;\n  display: flex;\n  flex: 0 0 auto;\n  justify-content: space-between;\n  transition: box-shadow 200ms;\n']),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  padding: ', 'px ', 'px ', 'px;\n  box-shadow: ', ';\n'], ['\n  padding: ', 'px ', 'px ', 'px;\n  box-shadow: ', ';\n']),
    _templateObject4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n'], ['\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n']),
    _templateObject5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  align-items: center;\n  display: flex;\n  font-size: 20px;\n  font-style: inherit;\n  font-weight: 500;\n  letter-spacing: -0.008em;\n  line-height: 1;\n  margin: 0;\n  min-width: 0;\n'], ['\n  align-items: center;\n  display: flex;\n  font-size: 20px;\n  font-style: inherit;\n  font-weight: 500;\n  letter-spacing: -0.008em;\n  line-height: 1;\n  margin: 0;\n  min-width: 0;\n']),
    _templateObject6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  flex: 1 1 auto;\n  min-width: 0;\n  word-wrap: break-word;\n  width: 100%;\n  ', ';\n'], ['\n  flex: 1 1 auto;\n  min-width: 0;\n  word-wrap: break-word;\n  width: 100%;\n  ', ';\n']),
    _templateObject7 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: ', ';\n  margin-right: ', 'px;\n  flex: 0 0 auto;\n'], ['\n  color: ', ';\n  margin-right: ', 'px;\n  flex: 0 0 auto;\n']),
    _templateObject8 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  flex: 1 1 auto;\n  ', ';\n'], ['\n  flex: 1 1 auto;\n  ', ';\n']),
    _templateObject9 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: inline-flex;\n  margin: 0 -', 'px;\n'], ['\n  display: inline-flex;\n  margin: 0 -', 'px;\n']),
    _templateObject10 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  flex: 1 0 auto;\n  margin: 0 ', 'px;\n'], ['\n  flex: 1 0 auto;\n  margin: 0 ', 'px;\n']);






// Constants
// ==============================
var innerGutter = 16;
var outerGutter = 20;
var keylineColor = Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["g" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].N30, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].DN30 });
var keylineHeight = 2;

// Wrapper
// ==============================
var Wrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, __WEBPACK_IMPORTED_MODULE_3__utils_flex_max_height_ie_fix__["b" /* flexMaxHeightIEFix */]);

// Header
// ==============================
var HeaderOrFooter = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject2);

// $FlowFixMe: Passed in type incompatible with expected type of React.Component (quite sure this is an issue with styled component flow types)
var Header = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(HeaderOrFooter)(_templateObject3, outerGutter, outerGutter, innerGutter - keylineHeight, function (p) {
  return p.showKeyline ? ' 0 ' + keylineHeight + 'px 0 0 ' + keylineColor(p) : 'none';
});

// Title
var oneLineTitleText = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject4);

var Title = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].h4(_templateObject5);

var TitleText = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(_templateObject6, function (_ref) {
  var isHeadingMultiline = _ref.isHeadingMultiline;
  return !isHeadingMultiline && oneLineTitleText;
});
var iconColor = {
  danger: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].R400,
  warning: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].Y400
};
var TitleIconWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(_templateObject7, function (p) {
  return iconColor[p.appearance];
}, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */]);

// Body
// ==============================

/**
  Adding the padding here avoids cropping box shadow on first/last
  children. The combined vertical spacing is maintained by subtracting the
  keyline height from header and footer.
*/
var Body = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject8, function (p) {
  return p.shouldScroll ? '\n          overflow-y: auto;\n          overflow-x: hidden;\n          padding: ' + keylineHeight + 'px ' + outerGutter + 'px;\n        ' : '\n          padding: 0 ' + outerGutter + 'px;\n        ';
});

// Footer
// ==============================

// $FlowFixMe: Passed in type incompatible with expected type of React.Component (quite sure this is an issue with styled component flow types)
var Footer = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(HeaderOrFooter)(_templateObject3, innerGutter - keylineHeight, outerGutter, outerGutter, function (p) {
  return p.showKeyline ? '0 -' + keylineHeight + 'px 0 0 ' + keylineColor(p) : 'none';
});

var Actions = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject9, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* math */].divide(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */], 2));
var ActionItem = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject10, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* math */].divide(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */], 2));

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultGridSize */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defaultGridColumns; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultGridColumnWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return spacing; });
/* unused harmony export layout */
var defaultGridSize = 8;

var defaultGridColumns = 12;

var defaultGridColumnWidth = defaultGridSize * 10;

var spacing = {
  comfortable: defaultGridSize * 5,
  cosy: defaultGridSize * 2,
  compact: defaultGridSize * 0.5
};

var layout = ['fixed', 'fluid'];

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__theme_presets__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_js_NavigationWithTheme__ = __webpack_require__(575);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_1__components_js_NavigationWithTheme__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_js_NavigationItemGroup__ = __webpack_require__(621);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__components_js_NavigationItemGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_js_ContainerLogo__ = __webpack_require__(626);
/* unused harmony reexport AkContainerLogo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_js_ContainerTitle__ = __webpack_require__(628);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__components_js_ContainerTitle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_js_ContainerTitleDropdown__ = __webpack_require__(637);
/* unused harmony reexport AkContainerTitleDropdown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_js_ContainerNavigation__ = __webpack_require__(276);
/* unused harmony reexport AkContainerNavigation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_js_nested_ContainerNavigationNested__ = __webpack_require__(696);
/* unused harmony reexport AkContainerNavigationNested */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_js_overflow_OverflowHandler__ = __webpack_require__(699);
/* unused harmony reexport AkCollapseOverflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_js_overflow_OverflowItem__ = __webpack_require__(707);
/* unused harmony reexport AkCollapseOverflowItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_js_overflow_OverflowItemGroup__ = __webpack_require__(708);
/* unused harmony reexport AkCollapseOverflowItemGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_js_drawers_CreateDrawer__ = __webpack_require__(709);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_11__components_js_drawers_CreateDrawer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_js_drawers_CustomDrawer__ = __webpack_require__(725);
/* unused harmony reexport AkCustomDrawer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_js_drawers_SearchDrawer__ = __webpack_require__(726);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_13__components_js_drawers_SearchDrawer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_js_NavigationItem__ = __webpack_require__(162);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_14__components_js_NavigationItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_js_GlobalNavigation__ = __webpack_require__(264);
/* unused harmony reexport AkGlobalNavigation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_js_GlobalItem__ = __webpack_require__(160);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_16__components_js_GlobalItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__theme_create_provided_theme__ = __webpack_require__(727);
/* unused harmony reexport createGlobalTheme */
/* unused harmony reexport presetThemes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_js_skeleton__ = __webpack_require__(728);
/* unused harmony reexport Skeleton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_js_skeleton_SkeletonDefaultContainerHeader__ = __webpack_require__(177);
/* unused harmony reexport SkeletonDefaultContainerHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_js_skeleton_SkeletonContainerItems__ = __webpack_require__(308);
/* unused harmony reexport SkeletonContainerItems */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_js_skeleton_SkeletonContainerItem__ = __webpack_require__(309);
/* unused harmony reexport SkeletonContainerItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_js_skeleton_SkeletonGlobalNavigation__ = __webpack_require__(303);
/* unused harmony reexport SkeletonGlobalNavigation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_js_skeleton_SkeletonGlobalTopItems__ = __webpack_require__(173);
/* unused harmony reexport SkeletonGlobalTopItems */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_js_skeleton_SkeletonGlobalBottomItems__ = __webpack_require__(176);
/* unused harmony reexport SkeletonGlobalBottomItems */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_js_skeleton_SkeletonContainerNavigation__ = __webpack_require__(307);
/* unused harmony reexport SkeletonContainerNavigation */







































/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Consumer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Provider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var _createContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])({}),
    Consumer = _createContext.Consumer,
    Provider = _createContext.Provider;



/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AtlasKitThemeProvider */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return borderRadius; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return gridSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fontSize; });
/* unused harmony export fontFamily */
/* unused harmony export codeFontFamily */
/* unused harmony export layers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elevation__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__typography__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_math__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_getTheme__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_themed__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AtlaskitThemeProvider__ = __webpack_require__(585);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__colors__; });
/* unused harmony reexport elevation */
/* unused harmony reexport typography */
/* unused harmony reexport math */
/* unused harmony reexport getTheme */
/* unused harmony reexport themed */
/* unused harmony reexport AtlaskitThemeProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Appearance__ = __webpack_require__(586);
/* unused harmony reexport Appearance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Context__ = __webpack_require__(95);
/* unused harmony reexport Consumer */
/* unused harmony reexport Provider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Reset__ = __webpack_require__(587);
/* unused harmony reexport Reset */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Theme__ = __webpack_require__(588);
/* unused harmony reexport Theme */











// backwards-compatible export with old Atlaskit case
var AtlasKitThemeProvider = __WEBPACK_IMPORTED_MODULE_6__components_AtlaskitThemeProvider__["a" /* default */];

/*
  These theme values are expressed as functions so that if we decide to make
  them dependent on props in the future, it wouldn't require a significant
  refactor everywhere they are being used.
*/
var borderRadius = function borderRadius() {
  return 3;
};
var gridSize = function gridSize() {
  return 8;
};
var fontSize = function fontSize() {
  return 14;
};
var fontFamily = function fontFamily() {
  return '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif';
};
var codeFontFamily = function codeFontFamily() {
  return '"SFMono-Medium", "SF Mono", "Segoe UI Mono", "Roboto Mono", "Ubuntu Mono", Menlo, Consolas, Courier, monospace';
};

var layers = {
  card: function card() {
    return 100;
  },
  dialog: function dialog() {
    return 200;
  },
  navigation: function navigation() {
    return 300;
  },
  layer: function layer() {
    return 400;
  },
  blanket: function blanket() {
    return 500;
  },
  modal: function modal() {
    return 510;
  },
  flag: function flag() {
    return 600;
  },
  spotlight: function spotlight() {
    return 700;
  },
  tooltip: function tooltip() {
    return 800;
  }
};

// New API




/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Consumer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Provider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var _createContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])({}),
    Consumer = _createContext.Consumer,
    Provider = _createContext.Provider;



/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return themeNamespace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return smallFontSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return compactSmallFontSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return compactLineHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return gridSize; });
/* unused harmony export defaultTheme */
/* unused harmony export themeWithKeys */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getThemeStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__ = __webpack_require__(94);


var themeNamespace = '@atlaskit-shared-theme/item';

// Used for Group titles and Item descriptions
var smallFontSize = 12;
var compactSmallFontSize = 10;
var compactLineHeight = 1.2;
var gridSize = Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["d" /* gridSize */])();

var defaultTheme = {
  afterItemSpacing: {
    compact: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["d" /* gridSize */])(),
    default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["d" /* gridSize */])()
  },
  beforeItemSpacing: {
    compact: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["d" /* gridSize */])(),
    default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["d" /* gridSize */])()
  },
  borderRadius: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["a" /* borderRadius */])(),
  focus: {
    outline: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].B100
  },
  height: {
    compact: 0,
    default: 0
  },
  padding: {
    default: {
      bottom: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["d" /* gridSize */])() / 2,
      left: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["d" /* gridSize */])() / 2,
      right: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["d" /* gridSize */])() / 2,
      top: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["d" /* gridSize */])() / 2
    },
    compact: {
      bottom: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["d" /* gridSize */])(),
      left: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["d" /* gridSize */])(),
      right: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["d" /* gridSize */])(),
      top: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["d" /* gridSize */])()
    }
  },
  default: {
    background: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].background,
    text: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].text,
    secondaryText: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N200
  },
  selected: {
    background: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N0,
    text: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N500,
    secondaryText: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N200
  },
  active: {
    background: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].backgroundActive,
    text: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].textActive,
    secondaryText: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N200
  },
  hover: {
    background: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].backgroundHover,
    text: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].textHover,
    secondaryText: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N200
  },
  disabled: {
    background: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N0,
    text: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N200,
    secondaryText: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N200
  },
  // same as hover in this case
  dragging: {
    background: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N20,
    text: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N800,
    secondaryText: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N200
  }
};

var isValidCssValue = function isValidCssValue(value) {
  return value !== undefined && value !== null && value !== '';
};

// Returns the theme that contains the requested theme key(s), preferring the user-supplied
// theme if it is provided.
var themeWithKeys = function themeWithKeys(maybeTheme, key, parentKey) {
  if (parentKey) {
    return maybeTheme && maybeTheme[parentKey] && isValidCssValue(maybeTheme[parentKey][key]) ? maybeTheme : defaultTheme;
  }
  return maybeTheme && isValidCssValue(maybeTheme[key]) ? maybeTheme : defaultTheme;
};

// Returns the theme value for the requested key(s), falling back to the default theme if the
// user-supplied theme doesn't exist or doesn't contain the requested key(s)
var getThemeStyle = function getThemeStyle(maybeTheme, key, parentKey) {
  var theme = themeWithKeys(maybeTheme, key, parentKey);
  return parentKey ? theme[parentKey][key] : theme[key];
};

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var simpleIsEqual = function simpleIsEqual(a, b) {
  return a === b;
};

/* harmony default export */ __webpack_exports__["a"] = (function (resultFn) {
  var isEqual = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : simpleIsEqual;

  var lastThis = void 0;
  var lastArgs = [];
  var lastResult = void 0;
  var calledOnce = false;

  var isNewArgEqualToLast = function isNewArgEqualToLast(newArg, index) {
    return isEqual(newArg, lastArgs[index]);
  };

  var result = function result() {
    for (var _len = arguments.length, newArgs = Array(_len), _key = 0; _key < _len; _key++) {
      newArgs[_key] = arguments[_key];
    }

    if (calledOnce && lastThis === this && newArgs.length === lastArgs.length && newArgs.every(isNewArgEqualToLast)) {
      return lastResult;
    }

    calledOnce = true;
    lastThis = this;
    lastArgs = newArgs;
    lastResult = resultFn.apply(this, newArgs);
    return lastResult;
  };

  return result;
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_DropdownMenu__ = __webpack_require__(638);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_DropdownMenu__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DropdownMenuStateless__ = __webpack_require__(282);
/* unused harmony reexport DropdownMenuStateless */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_item_DropdownItem__ = __webpack_require__(682);
/* unused harmony reexport DropdownItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_item_DropdownItemRadio__ = __webpack_require__(683);
/* unused harmony reexport DropdownItemRadio */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_item_DropdownItemCheckbox__ = __webpack_require__(692);
/* unused harmony reexport DropdownItemCheckbox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_group_DropdownItemGroup__ = __webpack_require__(170);
/* unused harmony reexport DropdownItemGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_group_DropdownItemGroupRadio__ = __webpack_require__(693);
/* unused harmony reexport DropdownItemGroupRadio */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_group_DropdownItemGroupCheckbox__ = __webpack_require__(695);
/* unused harmony reexport DropdownItemGroupCheckbox */


// menu exports



// Item exports




// ItemGroup exports




/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Consumer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Provider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var _createContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])({}),
    Consumer = _createContext.Consumer,
    Provider = _createContext.Provider;



/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Consumer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Provider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var _createContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])({}),
    Consumer = _createContext.Consumer,
    Provider = _createContext.Provider;



/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Consumer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Provider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var _createContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])({}),
    Consumer = _createContext.Consumer,
    Provider = _createContext.Provider;



/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return shouldReportItemHeight; });
/* unused harmony export reportItemHeightToGroup */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return overflowManagerNamespace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return overflowGroupNamespace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dropdownHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return reservedGapHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isArrayFilled; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_variables__ = __webpack_require__(10);


var prefix = function prefix(name) {
  return '__ak_nav_collapsed_overflow_' + name;
};
var shouldReportItemHeight = prefix('shouldReportItemHeight');
var reportItemHeightToGroup = prefix('reportItemHeight');

var overflowManagerNamespace = prefix('manager_ns');
var overflowGroupNamespace = prefix('group_ns');

var dropdownHeight = __WEBPACK_IMPORTED_MODULE_0__shared_variables__["n" /* gridSize */] * 5;
var reservedGapHeight = __WEBPACK_IMPORTED_MODULE_0__shared_variables__["n" /* gridSize */] * 4;

var isArrayFilled = function isArrayFilled(testArray) {
  // Note: we can't use a simple testArray.length check here because it is a set-length
  // array; We also can't use .filter(Boolean).length because that skips any undefined items.
  for (var i = 0; i < testArray.length; i++) {
    if (typeof testArray[i] === 'undefined') {
      return false;
    }
  }
  return true;
};

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ShownWhenCollapsed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HiddenWhenCollapsed; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var ShownWhenCollapsed = function ShownWhenCollapsed(_ref) {
  var _ref$isCollapsed = _ref.isCollapsed,
      isCollapsed = _ref$isCollapsed === undefined ? false : _ref$isCollapsed,
      children = _ref.children;

  return isCollapsed ? children : null;
};

var HiddenWhenCollapsed = function HiddenWhenCollapsed(_ref2) {
  var _ref2$isCollapsed = _ref2.isCollapsed,
      isCollapsed = _ref2$isCollapsed === undefined ? false : _ref2$isCollapsed,
      children = _ref2.children;

  return isCollapsed ? null : children;
};

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Consumer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Provider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var _createContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])({}),
    Consumer = _createContext.Consumer,
    Provider = _createContext.Provider;



/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getBorderRadius;
/* unused harmony export getSize */
/* harmony export (immutable) */ __webpack_exports__["a"] = getAvatarDimensions;
/* harmony export (immutable) */ __webpack_exports__["c"] = getInnerStyles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(49);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    ', ';\n    align-items: stretch;\n    background-color: ', ';\n    border: 0;\n    border-radius: ', ';\n    padding: ', ';\n    box-sizing: ', ';\n    cursor: ', ';\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    outline: ', ';\n    overflow: hidden;\n    pointer-events: ', ';\n    position: ', ';\n    transform: ', ';\n    transition: background-color ', ' ease-out;\n\n    a &,\n    button & {\n      cursor: pointer;\n    }\n\n    &::after {\n      background-color: ', ';\n      border-radius: ', ';\n      bottom: ', ';\n      content: \' \';\n      left: ', ';\n      opacity: ', ';\n      pointer-events: none;\n      position: absolute;\n      right: ', ';\n      top: ', ';\n      transition: opacity ', ';\n    }\n\n    &::-moz-focus-inner {\n      border: 0;\n      margin: 0;\n      padding: 0;\n    }\n  '], ['\n    ', ';\n    align-items: stretch;\n    background-color: ', ';\n    border: 0;\n    border-radius: ', ';\n    padding: ', ';\n    box-sizing: ', ';\n    cursor: ', ';\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    outline: ', ';\n    overflow: hidden;\n    pointer-events: ', ';\n    position: ', ';\n    transform: ', ';\n    transition: background-color ', ' ease-out;\n\n    a &,\n    button & {\n      cursor: pointer;\n    }\n\n    &::after {\n      background-color: ', ';\n      border-radius: ', ';\n      bottom: ', ';\n      content: \' \';\n      left: ', ';\n      opacity: ', ';\n      pointer-events: none;\n      position: absolute;\n      right: ', ';\n      top: ', ';\n      transition: opacity ', ';\n    }\n\n    &::-moz-focus-inner {\n      border: 0;\n      margin: 0;\n      padding: 0;\n    }\n  ']);






var backgroundColorFocus = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].B200;
var overlayColorDefault = 'transparent';
var overlayColorHover = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].N70A;
var overlayColorSelected = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].N200A;
var overlayColorDisabled = Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* themed */])({
  light: 'rgba(255, 255, 255, 0.7)',
  dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].DN80A
});

// "square" avatars are explicit
function getBorderRadius(props) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { includeBorderWidth: false };

  var borderWidth = config.includeBorderWidth ? __WEBPACK_IMPORTED_MODULE_3__constants__["c" /* BORDER_WIDTH */][props.size] : 0;
  return props.appearance === 'circle' ? '50%' : __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* AVATAR_RADIUS */][props.size] + borderWidth + 'px';
}

var getSize = function getSize(props) {
  return __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* AVATAR_SIZES */][props.size];
}; // for testing
function getAvatarDimensions(props) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    includeBorderWidth: false,
    sizeOnly: false
  };

  var borderWidth = config.includeBorderWidth ? __WEBPACK_IMPORTED_MODULE_3__constants__["c" /* BORDER_WIDTH */][props.size] * 2 : 0;
  var size = __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* AVATAR_SIZES */][props.size] + borderWidth;

  return config.sizeOnly ? size : '\n    height: ' + size + 'px;\n    width: ' + size + 'px;\n  ';
}

// expose here for use with multiple element types
function getInnerStyles(props) {
  var boxSizing = 'content-box';
  var borderWidth = __WEBPACK_IMPORTED_MODULE_3__constants__["c" /* BORDER_WIDTH */][props.size] + 'px';
  var isInteractive = Boolean(props.isInteractive || props.href || props.onClick);
  // We make the distinction between isInteractive and isClickable as supplying a tooltip
  // makes the avatar interactive but not clickable
  var isClickable = Boolean(props.href || props.onClick);

  var backgroundColor = props.borderColor || __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].background;
  // Inherit cursor styles so we don't cancel out pointer cursors in places like avatar group more dropdown
  var cursor = 'inherit';
  var outline = 'none';
  var overlayShade = overlayColorDefault;
  var overlayOpacity = 0;
  var pointerEvents = 'auto';
  var position = 'static';
  var transform = 'translateZ(0)';
  var transitionDuration = '0s';

  // Interaction: Hover
  if (isInteractive && (props.isActive || props.isHover)) {
    overlayShade = overlayColorHover;
    overlayOpacity = 1;
  }

  // Interaction: Active
  if (isClickable && props.isActive) {
    transform = 'scale(0.9)';
  }

  // Interaction: Focus
  if (isInteractive && props.isFocus && !props.isActive) {
    outline = 'none';
    backgroundColor = backgroundColorFocus;
    transitionDuration = __WEBPACK_IMPORTED_MODULE_3__constants__["g" /* TRANSITION_DURATION */];
  }

  // Disabled
  if (props.isDisabled) {
    cursor = 'not-allowed';
    overlayShade = overlayColorDisabled;
    overlayOpacity = 1;
    pointerEvents = 'none';
  }

  // Clickable
  if (isClickable) {
    cursor = 'pointer';
  }

  // Loading
  if (props.isSelected) {
    overlayShade = overlayColorSelected;
    overlayOpacity = 1;
  }

  // Stack
  if (props.stackIndex) {
    position = 'relative';
  }

  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject, getAvatarDimensions, backgroundColor, function (p) {
    return getBorderRadius(p, { includeBorderWidth: true });
  }, borderWidth, boxSizing, cursor, outline, pointerEvents, position, transform, transitionDuration, overlayShade, getBorderRadius, borderWidth, borderWidth, overlayOpacity, borderWidth, borderWidth, __WEBPACK_IMPORTED_MODULE_3__constants__["g" /* TRANSITION_DURATION */]);
}

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = omit;
/* harmony export (immutable) */ __webpack_exports__["a"] = getDisplayName;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);




function omit(obj) {
  var newObj = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, obj);

  for (var _len = arguments.length, keysToOmit = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    keysToOmit[_key - 1] = arguments[_key];
  }

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(keysToOmit), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var key = _step.value;

      delete newObj[key];
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return newObj;
}

function getDisplayName(prefix, Component) {
  var componentName = Component.displayName || Component.name;

  return componentName ? prefix + '(' + componentName + ')' : prefix;
}

/***/ }),
/* 107 */
/***/ (function(module, exports) {

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

module.exports = _taggedTemplateLiteral;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Router__ = __webpack_require__(348);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Link__ = __webpack_require__(190);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IndexLink__ = __webpack_require__(356);
/* unused harmony reexport IndexLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__withRouter__ = __webpack_require__(357);
/* unused harmony reexport withRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IndexRedirect__ = __webpack_require__(358);
/* unused harmony reexport IndexRedirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IndexRoute__ = __webpack_require__(359);
/* unused harmony reexport IndexRoute */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(192);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(360);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RouteUtils__ = __webpack_require__(29);
/* unused harmony reexport createRoutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RouterContext__ = __webpack_require__(112);
/* unused harmony reexport RouterContext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PropTypes__ = __webpack_require__(114);
/* unused harmony reexport locationShape */
/* unused harmony reexport routerShape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__match__ = __webpack_require__(361);
/* unused harmony reexport match */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__useRouterHistory__ = __webpack_require__(196);
/* unused harmony reexport useRouterHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PatternUtils__ = __webpack_require__(43);
/* unused harmony reexport formatPattern */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__applyRouterMiddleware__ = __webpack_require__(366);
/* unused harmony reexport applyRouterMiddleware */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__browserHistory__ = __webpack_require__(367);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_15__browserHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__hashHistory__ = __webpack_require__(370);
/* unused harmony reexport hashHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__createMemoryHistory__ = __webpack_require__(193);
/* unused harmony reexport createMemoryHistory */
/* components */









/* components (configuration) */










/* utils */















/* histories */








/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = loopAsync;
/* harmony export (immutable) */ __webpack_exports__["b"] = mapAsync;
function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var sync = false,
      hasNext = false,
      doneArgs = void 0;

  function done() {
    isDone = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      doneArgs = [].concat(Array.prototype.slice.call(arguments));
      return;
    }

    callback.apply(this, arguments);
  }

  function next() {
    if (isDone) {
      return;
    }

    hasNext = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      return;
    }

    sync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work.call(this, currentTurn++, next, done);
    }

    sync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(this, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  }

  next();
}

function mapAsync(array, work, callback) {
  var length = array.length;
  var values = [];

  if (length === 0) return callback(null, values);

  var isDone = false,
      doneCount = 0;

  function done(index, error, value) {
    if (isDone) return;

    if (error) {
      isDone = true;
      callback(error);
    } else {
      values[index] = value;

      isDone = ++doneCount === length;

      if (isDone) callback(null, values);
    }
  }

  array.forEach(function (item, index) {
    work(item, index, function (error, value) {
      done(index, error, value);
    });
  });
}

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getRouteParams__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContextUtils__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RouteUtils__ = __webpack_require__(29);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };










/**
 * A <RouterContext> renders the component tree for a given router state
 * and sets the history object and the current location in context.
 */
var RouterContext = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'RouterContext',

  mixins: [Object(__WEBPACK_IMPORTED_MODULE_5__ContextUtils__["a" /* ContextProvider */])('router')],

  propTypes: {
    router: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired,
    location: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired,
    routes: __WEBPACK_IMPORTED_MODULE_3_prop_types__["array"].isRequired,
    params: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired,
    components: __WEBPACK_IMPORTED_MODULE_3_prop_types__["array"].isRequired,
    createElement: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"].isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      createElement: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement
    };
  },


  childContextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired
  },

  getChildContext: function getChildContext() {
    return {
      router: this.props.router
    };
  },
  createElement: function createElement(component, props) {
    return component == null ? null : this.props.createElement(component, props);
  },
  render: function render() {
    var _this = this;

    var _props = this.props,
        location = _props.location,
        routes = _props.routes,
        params = _props.params,
        components = _props.components,
        router = _props.router;

    var element = null;

    if (components) {
      element = components.reduceRight(function (element, components, index) {
        if (components == null) return element; // Don't create new children; use the grandchildren.

        var route = routes[index];
        var routeParams = Object(__WEBPACK_IMPORTED_MODULE_4__getRouteParams__["a" /* default */])(route, params);
        var props = {
          location: location,
          params: params,
          route: route,
          router: router,
          routeParams: routeParams,
          routes: routes
        };

        if (Object(__WEBPACK_IMPORTED_MODULE_6__RouteUtils__["c" /* isReactChildren */])(element)) {
          props.children = element;
        } else if (element) {
          for (var prop in element) {
            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
          }
        }

        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
          var elements = {};

          for (var key in components) {
            if (Object.prototype.hasOwnProperty.call(components, key)) {
              // Pass through the key as a prop to createElement to allow
              // custom createElement functions to know which named component
              // they're rendering, for e.g. matching up to fetched data.
              elements[key] = _this.createElement(components[key], _extends({
                key: key }, props));
            }
          }

          return elements;
        }

        return _this.createElement(components, props);
      }, element);
    }

    !(element === null || element === false || __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(element)) ?  false ? invariant(false, 'The root route must render a single element') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

    return element;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (RouterContext);

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ContextProvider;
/* harmony export (immutable) */ __webpack_exports__["b"] = ContextSubscriber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


// Works around issues with context updates failing to propagate.
// Caveat: the context value is expected to never change its identity.
// https://github.com/facebook/react/issues/2517
// https://github.com/reactjs/react-router/issues/470

var contextProviderShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  eventIndex: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired
});

function makeContextName(name) {
  return '@@contextSubscriber/' + name;
}

function ContextProvider(name) {
  var _childContextTypes, _ref2;

  var contextName = makeContextName(name);
  var listenersKey = contextName + '/listeners';
  var eventIndexKey = contextName + '/eventIndex';
  var subscribeKey = contextName + '/subscribe';

  return _ref2 = {
    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),

    getChildContext: function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextName] = {
        eventIndex: this[eventIndexKey],
        subscribe: this[subscribeKey]
      }, _ref;
    },
    componentWillMount: function componentWillMount() {
      this[listenersKey] = [];
      this[eventIndexKey] = 0;
    },
    componentWillReceiveProps: function componentWillReceiveProps() {
      this[eventIndexKey]++;
    },
    componentDidUpdate: function componentDidUpdate() {
      var _this = this;

      this[listenersKey].forEach(function (listener) {
        return listener(_this[eventIndexKey]);
      });
    }
  }, _ref2[subscribeKey] = function (listener) {
    var _this2 = this;

    // No need to immediately call listener here.
    this[listenersKey].push(listener);

    return function () {
      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
        return item !== listener;
      });
    };
  }, _ref2;
}

function ContextSubscriber(name) {
  var _contextTypes, _ref4;

  var contextName = makeContextName(name);
  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
  var handleContextUpdateKey = contextName + '/handleContextUpdate';
  var unsubscribeKey = contextName + '/unsubscribe';

  return _ref4 = {
    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),

    getInitialState: function getInitialState() {
      var _ref3;

      if (!this.context[contextName]) {
        return {};
      }

      return _ref3 = {}, _ref3[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref3;
    },
    componentDidMount: function componentDidMount() {
      if (!this.context[contextName]) {
        return;
      }

      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
    },
    componentWillReceiveProps: function componentWillReceiveProps() {
      var _setState;

      if (!this.context[contextName]) {
        return;
      }

      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
    },
    componentWillUnmount: function componentWillUnmount() {
      if (!this[unsubscribeKey]) {
        return;
      }

      this[unsubscribeKey]();
      this[unsubscribeKey] = null;
    }
  }, _ref4[handleContextUpdateKey] = function (eventIndex) {
    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
      var _setState2;

      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
    }
  }, _ref4;
}

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return routerShape; });
/* unused harmony export locationShape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var routerShape = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  push: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  replace: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  go: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goBack: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goForward: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  setRouteLeaveHook: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  isActive: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired
});

var locationShape = Object(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  pathname: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  search: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  state: __WEBPACK_IMPORTED_MODULE_0_prop_types__["object"],
  action: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  key: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]
});

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(28);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var runTransitionHook = function runTransitionHook(hook, location, callback) {
  var result = hook(location, callback);

  if (hook.length < 2) {
    // Assume the hook runs synchronously and automatically
    // call the callback with the return value.
    callback(result);
  } else {
     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
  }
};

exports.default = runTransitionHook;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _AsyncUtils = __webpack_require__(365);

var _PathUtils = __webpack_require__(30);

var _runTransitionHook = __webpack_require__(115);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _Actions = __webpack_require__(73);

var _LocationUtils = __webpack_require__(44);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createHistory = function createHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getCurrentLocation = options.getCurrentLocation,
      getUserConfirmation = options.getUserConfirmation,
      pushLocation = options.pushLocation,
      replaceLocation = options.replaceLocation,
      go = options.go,
      keyLength = options.keyLength;


  var currentLocation = void 0;
  var pendingLocation = void 0;
  var beforeListeners = [];
  var listeners = [];
  var allKeys = [];

  var getCurrentIndex = function getCurrentIndex() {
    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);

    if (currentLocation) return allKeys.indexOf(currentLocation.key);

    return -1;
  };

  var updateLocation = function updateLocation(nextLocation) {
    var currentIndex = getCurrentIndex();

    currentLocation = nextLocation;

    if (currentLocation.action === _Actions.PUSH) {
      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
    } else if (currentLocation.action === _Actions.REPLACE) {
      allKeys[currentIndex] = currentLocation.key;
    }

    listeners.forEach(function (listener) {
      return listener(currentLocation);
    });
  };

  var listenBefore = function listenBefore(listener) {
    beforeListeners.push(listener);

    return function () {
      return beforeListeners = beforeListeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var listen = function listen(listener) {
    listeners.push(listener);

    return function () {
      return listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
        return result != null ? done(result) : next();
      });
    }, function (message) {
      if (getUserConfirmation && typeof message === 'string') {
        getUserConfirmation(message, function (ok) {
          return callback(ok !== false);
        });
      } else {
        callback(message !== false);
      }
    });
  };

  var transitionTo = function transitionTo(nextLocation) {
    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do

    pendingLocation = nextLocation;

    confirmTransitionTo(nextLocation, function (ok) {
      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation

      pendingLocation = null;

      if (ok) {
        // Treat PUSH to same path like REPLACE to be consistent with browsers
        if (nextLocation.action === _Actions.PUSH) {
          var prevPath = (0, _PathUtils.createPath)(currentLocation);
          var nextPath = (0, _PathUtils.createPath)(nextLocation);

          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
        }

        if (nextLocation.action === _Actions.POP) {
          updateLocation(nextLocation);
        } else if (nextLocation.action === _Actions.PUSH) {
          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
        } else if (nextLocation.action === _Actions.REPLACE) {
          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
        }
      } else if (currentLocation && nextLocation.action === _Actions.POP) {
        var prevIndex = allKeys.indexOf(currentLocation.key);
        var nextIndex = allKeys.indexOf(nextLocation.key);

        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
      }
    });
  };

  var push = function push(input) {
    return transitionTo(createLocation(input, _Actions.PUSH));
  };

  var replace = function replace(input) {
    return transitionTo(createLocation(input, _Actions.REPLACE));
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength || 6);
  };

  var createHref = function createHref(location) {
    return (0, _PathUtils.createPath)(location);
  };

  var createLocation = function createLocation(location, action) {
    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createKey();
    return (0, _LocationUtils.createLocation)(location, action, key);
  };

  return {
    getCurrentLocation: getCurrentLocation,
    listenBefore: listenBefore,
    listen: listen,
    transitionTo: transitionTo,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    createKey: createKey,
    createPath: _PathUtils.createPath,
    createHref: createHref,
    createLocation: createLocation
  };
};

exports.default = createHistory;

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;

var _LocationUtils = __webpack_require__(44);

var _DOMUtils = __webpack_require__(74);

var _DOMStateStorage = __webpack_require__(197);

var _PathUtils = __webpack_require__(30);

var _ExecutionEnvironment = __webpack_require__(117);

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();

var _createLocation = function _createLocation(historyState) {
  var key = historyState && historyState.key;

  return (0, _LocationUtils.createLocation)({
    pathname: window.location.pathname,
    search: window.location.search,
    hash: window.location.hash,
    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
  }, undefined, key);
};

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
  var historyState = void 0;
  try {
    historyState = window.history.state || {};
  } catch (error) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    historyState = {};
  }

  return _createLocation(historyState);
};

var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

var startListener = exports.startListener = function startListener(listener) {
  var handlePopState = function handlePopState(event) {
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) // Ignore extraneous popstate events in WebKit
      return;
    listener(_createLocation(event.state));
  };

  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
    return listener(getCurrentLocation());
  };

  if (needsHashchangeListener) {
    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
  }

  return function () {
    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

    if (needsHashchangeListener) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
    }
  };
};

var updateLocation = function updateLocation(location, updateState) {
  var state = location.state,
      key = location.key;


  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);

  updateState({ key: key }, (0, _PathUtils.createPath)(location));
};

var pushLocation = exports.pushLocation = function pushLocation(location) {
  return updateLocation(location, function (state, path) {
    return window.history.pushState(state, null, path);
  });
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
  return updateLocation(location, function (state, path) {
    return window.history.replaceState(state, null, path);
  });
};

var go = exports.go = function go(n) {
  if (n) window.history.go(n);
};

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_APPEARANCE; });
/* unused harmony export FlagWithoutAnalytics */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_analytics_next__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_cross__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_cross___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_cross__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__atlaskit_icon_glyph_chevron_up__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__atlaskit_icon_glyph_chevron_up___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__atlaskit_icon_glyph_chevron_up__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__atlaskit_icon_glyph_chevron_down__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__atlaskit_icon_glyph_chevron_down___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__atlaskit_icon_glyph_chevron_down__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__package_json__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styledFlag__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Expander__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__FlagActions__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__theme__ = __webpack_require__(143);


















var DEFAULT_APPEARANCE = 'normal';

var Flag = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Flag, _Component);

  function Flag() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Flag);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Flag.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Flag)).call.apply(_ref, [this].concat(args))), _this), _this.state = { isExpanded: false }, _this.dismissFlag = function () {
      if (_this.props.isDismissAllowed && _this.props.onDismissed) {
        _this.props.onDismissed(_this.props.id);
      }
    }, _this.isBold = function () {
      return _this.props.appearance !== DEFAULT_APPEARANCE;
    }, _this.toggleExpand = function () {
      _this.setState({ isExpanded: !_this.state.isExpanded });
    }, _this.renderToggleOrDismissButton = function () {
      var _this$props = _this.props,
          appearance = _this$props.appearance,
          description = _this$props.description,
          actions = _this$props.actions,
          isDismissAllowed = _this$props.isDismissAllowed,
          onDismissed = _this$props.onDismissed;

      var isBold = _this.isBold();
      if (!isDismissAllowed || !isBold && !onDismissed || isBold && !description && (!actions || !actions.length)) {
        return null;
      }

      var ChevronIcon = _this.state.isExpanded ? __WEBPACK_IMPORTED_MODULE_9__atlaskit_icon_glyph_chevron_up___default.a : __WEBPACK_IMPORTED_MODULE_10__atlaskit_icon_glyph_chevron_down___default.a;
      var ButtonIcon = isBold ? ChevronIcon : __WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_cross___default.a;
      var buttonLabel = isBold ? 'Toggle flag body' : 'Dismiss flag';
      var buttonAction = isBold ? _this.toggleExpand : _this.dismissFlag;
      var size = ButtonIcon === ChevronIcon ? 'large' : 'small';

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_12__styledFlag__["c" /* DismissButton */],
        {
          appearance: appearance,
          'aria-expanded': _this.state.isExpanded
          // $FlowFixMe - theme is not found in props
          , focusRingColor: Object(__WEBPACK_IMPORTED_MODULE_15__theme__["e" /* flagFocusRingColor */])(_this.props),
          onClick: buttonAction,
          type: 'button'
        },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ButtonIcon, { label: buttonLabel, size: size })
      );
    }, _this.renderBody = function () {
      var _this$props2 = _this.props,
          actions = _this$props2.actions,
          appearance = _this$props2.appearance,
          description = _this$props2.description;

      var isExpanded = !_this.isBold() || _this.state.isExpanded;

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_13__Expander__["a" /* default */],
        { isExpanded: isExpanded },
        description && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12__styledFlag__["b" /* Description */],
          { appearance: appearance },
          description
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__FlagActions__["a" /* default */], { actions: actions, appearance: appearance })
      );
    }, _this.handleMouseDown = function (e) {
      e.preventDefault();
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  } // eslint-disable-line react/sort-comp

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Flag, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var actions = nextProps.actions,
          description = nextProps.description;

      if (this.isBold() && this.state.isExpanded && !description && (!actions || !actions.length)) {
        this.toggleExpand();
      }
    }

    // We prevent default on mouse down to avoid focus ring when the flag is clicked,
    // while still allowing it to be focused with the keyboard.

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          appearance = _props.appearance,
          icon = _props.icon,
          title = _props.title,
          onMouseOver = _props.onMouseOver,
          onFocus = _props.onFocus,
          onMouseOut = _props.onMouseOut,
          onBlur = _props.onBlur;

      var autoDismissProps = { onMouseOver: onMouseOver, onFocus: onFocus, onMouseOut: onMouseOut, onBlur: onBlur };
      var OptionalDismissButton = this.renderToggleOrDismissButton;
      var Body = this.renderBody;

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_12__styledFlag__["g" /* default */],
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          appearance: appearance,
          role: 'alert',
          tabIndex: '0',
          onMouseDown: this.handleMouseDown
        }, autoDismissProps),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12__styledFlag__["d" /* Header */],
          null,
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_12__styledFlag__["e" /* Icon */],
            null,
            icon
          ),
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_12__styledFlag__["f" /* Title */],
            { appearance: appearance },
            title
          ),
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(OptionalDismissButton, null)
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12__styledFlag__["a" /* Content */],
          null,
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Body, null)
        )
      );
    }
  }]);

  return Flag;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

Flag.defaultProps = {
  actions: [],
  appearance: DEFAULT_APPEARANCE,
  isDismissAllowed: false
};



var createAndFireEventOnAtlaskit = Object(__WEBPACK_IMPORTED_MODULE_7__atlaskit_analytics_next__["b" /* createAndFireEvent */])('atlaskit');

/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_7__atlaskit_analytics_next__["c" /* withAnalyticsContext */])({
  componentName: 'flag',
  packageName: __WEBPACK_IMPORTED_MODULE_11__package_json__["name"],
  packageVersion: __WEBPACK_IMPORTED_MODULE_11__package_json__["version"]
})(Object(__WEBPACK_IMPORTED_MODULE_7__atlaskit_analytics_next__["d" /* withAnalyticsEvents */])({
  onBlur: createAndFireEventOnAtlaskit({
    action: 'blurred',
    actionSubject: 'flag',

    attributes: {
      componentName: 'flag',
      packageName: __WEBPACK_IMPORTED_MODULE_11__package_json__["name"],
      packageVersion: __WEBPACK_IMPORTED_MODULE_11__package_json__["version"]
    }
  }),

  onDismissed: createAndFireEventOnAtlaskit({
    action: 'dismissed',
    actionSubject: 'flag',

    attributes: {
      componentName: 'flag',
      packageName: __WEBPACK_IMPORTED_MODULE_11__package_json__["name"],
      packageVersion: __WEBPACK_IMPORTED_MODULE_11__package_json__["version"]
    }
  }),

  onFocus: createAndFireEventOnAtlaskit({
    action: 'focused',
    actionSubject: 'flag',

    attributes: {
      componentName: 'flag',
      packageName: __WEBPACK_IMPORTED_MODULE_11__package_json__["name"],
      packageVersion: __WEBPACK_IMPORTED_MODULE_11__package_json__["version"]
    }
  })
})(Flag)));

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(377);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(36);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 122 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 123 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 124 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(126)('keys');
var uid = __webpack_require__(76);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(18);
var global = __webpack_require__(31);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(75) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 127 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 128 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(387)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(206)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(35);
var dPs = __webpack_require__(208);
var enumBugKeys = __webpack_require__(127);
var IE_PROTO = __webpack_require__(125)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(200)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(389).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(32).f;
var has = __webpack_require__(37);
var TAG = __webpack_require__(23)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(23);


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(31);
var core = __webpack_require__(18);
var LIBRARY = __webpack_require__(75);
var wksExt = __webpack_require__(132);
var defineProperty = __webpack_require__(32).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(77);
var createDesc = __webpack_require__(52);
var toIObject = __webpack_require__(38);
var toPrimitive = __webpack_require__(121);
var has = __webpack_require__(37);
var IE8_DOM_DEFINE = __webpack_require__(199);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(33) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);






var AnalyticsEvent = function () {
  function AnalyticsEvent(props) {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, AnalyticsEvent);

    this.clone = function () {
      // We stringify and parse here to get a hacky "deep clone" of the object.
      // This has some limitations in that it wont support functions, regexs, Maps, Sets, etc,
      // but none of those need to be represented in our payload, so we consider this fine
      var payload = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this.payload));

      return new AnalyticsEvent({ payload: payload });
    };

    this.payload = props.payload;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(AnalyticsEvent, [{
    key: 'update',
    value: function update(updater) {
      if (typeof updater === 'function') {
        this.payload = updater(this.payload);
      } else if ((typeof updater === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(updater)) === 'object') {
        this.payload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.payload, updater);
      }

      return this;
    }
  }]);

  return AnalyticsEvent;
}();

/* harmony default export */ __webpack_exports__["a"] = (AnalyticsEvent);

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(409), __esModule: true };

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

var v1 = __webpack_require__(138);
var v4 = __webpack_require__(446);

var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;

module.exports = uuid;


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(217);
var bytesToUuid = __webpack_require__(218);

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

var _nodeId;
var _clockseq;

// Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0;

// See https://github.com/broofa/node-uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189
  if (node == null || clockseq == null) {
    var seedBytes = rng();
    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [
        seedBytes[0] | 0x01,
        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
      ];
    }
    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  }

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : bytesToUuid(b);
}

module.exports = v1;


/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AtlasKitThemeProvider", function() { return AtlasKitThemeProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "borderRadius", function() { return borderRadius; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gridSize", function() { return gridSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fontSize", function() { return fontSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fontFamily", function() { return fontFamily; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "codeFontFamily", function() { return codeFontFamily; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "layers", function() { return layers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elevation__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__typography__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_math__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_getTheme__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_themed__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AtlaskitThemeProvider__ = __webpack_require__(450);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "colors", function() { return __WEBPACK_IMPORTED_MODULE_0__colors__; });
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "elevation", function() { return __WEBPACK_IMPORTED_MODULE_1__elevation__; });
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "typography", function() { return __WEBPACK_IMPORTED_MODULE_2__typography__; });
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "math", function() { return __WEBPACK_IMPORTED_MODULE_3__utils_math__; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getTheme", function() { return __WEBPACK_IMPORTED_MODULE_4__utils_getTheme__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "themed", function() { return __WEBPACK_IMPORTED_MODULE_5__utils_themed__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AtlaskitThemeProvider", function() { return __WEBPACK_IMPORTED_MODULE_6__components_AtlaskitThemeProvider__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Appearance__ = __webpack_require__(451);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Appearance", function() { return __WEBPACK_IMPORTED_MODULE_7__components_Appearance__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Context__ = __webpack_require__(80);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Consumer", function() { return __WEBPACK_IMPORTED_MODULE_8__components_Context__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return __WEBPACK_IMPORTED_MODULE_8__components_Context__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Reset__ = __webpack_require__(452);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Reset", function() { return __WEBPACK_IMPORTED_MODULE_9__components_Reset__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Theme__ = __webpack_require__(453);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Theme", function() { return __WEBPACK_IMPORTED_MODULE_10__components_Theme__["a"]; });











// backwards-compatible export with old Atlaskit case
var AtlasKitThemeProvider = __WEBPACK_IMPORTED_MODULE_6__components_AtlaskitThemeProvider__["a" /* default */];

/*
  These theme values are expressed as functions so that if we decide to make
  them dependent on props in the future, it wouldn't require a significant
  refactor everywhere they are being used.
*/
var borderRadius = function borderRadius() {
  return 3;
};
var gridSize = function gridSize() {
  return 8;
};
var fontSize = function fontSize() {
  return 14;
};
var fontFamily = function fontFamily() {
  return '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif';
};
var codeFontFamily = function codeFontFamily() {
  return '"SFMono-Medium", "SF Mono", "Segoe UI Mono", "Roboto Mono", "Ubuntu Mono", Menlo, Consolas, Courier, monospace';
};

var layers = {
  card: function card() {
    return 100;
  },
  dialog: function dialog() {
    return 200;
  },
  navigation: function navigation() {
    return 300;
  },
  layer: function layer() {
    return 400;
  },
  blanket: function blanket() {
    return 500;
  },
  modal: function modal() {
    return 510;
  },
  flag: function flag() {
    return 600;
  },
  spotlight: function spotlight() {
    return 700;
  },
  tooltip: function tooltip() {
    return 800;
  }
};

// New API




/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = themed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getTheme__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__types__);

/* eslint-disable prefer-rest-params */




function themedVariants(variantProp, variants) {
  return function (props) {
    var theme = Object(__WEBPACK_IMPORTED_MODULE_0__getTheme__["a" /* default */])(props);
    if (props && props[variantProp] && variants) {
      var modes = variants[props[variantProp]];
      if (modes) {
        return modes[theme.mode];
      }
    }
    return '';
  };
}

function themed(modesOrVariant, variantModes) {
  if (typeof modesOrVariant === 'string') {
    return themedVariants(modesOrVariant, variantModes);
  }
  var modes = modesOrVariant;
  return function (props) {
    var theme = Object(__WEBPACK_IMPORTED_MODULE_0__getTheme__["a" /* default */])(props);
    return modes[theme.mode];
  };
}

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(15);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChevronDownIcon = function ChevronDownIcon(props) {
  return _react2.default.createElement(_index2.default, _extends({ dangerouslySetGlyph: '<svg width="24" height="24" viewBox="0 0 24 24" focusable="false" role="presentation"><path d="M8.292 10.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0z" fill="currentColor" fill-rule="evenodd"/></svg>' }, props));
};
exports.default = ChevronDownIcon;

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = themed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getTheme__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__types__);

/* eslint-disable prefer-rest-params */




function themedVariants(variantProp, variants) {
  return function (props) {
    var theme = Object(__WEBPACK_IMPORTED_MODULE_0__getTheme__["a" /* default */])(props);
    if (props && props[variantProp] && variants) {
      var modes = variants[props[variantProp]];
      if (modes) {
        return modes[theme.mode];
      }
    }
    return '';
  };
}

function themed(modesOrVariant, variantModes) {
  if (typeof modesOrVariant === 'string') {
    return themedVariants(modesOrVariant, variantModes);
  }
  var modes = modesOrVariant;
  return function (props) {
    var theme = Object(__WEBPACK_IMPORTED_MODULE_0__getTheme__["a" /* default */])(props);
    return modes[theme.mode];
  };
}

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return flagBackgroundColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return flagBorderColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return flagTextColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return flagShadowColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return flagFocusRingColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buttonBackgroundColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return buttonTextColor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__ = __webpack_require__(39);


var lightButtonBackground = 'rgba(255, 255, 255, 0.08)';

var flagBackgroundColor = Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["g" /* themed */])('appearance', {
  error: { light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].R400, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].R300 },
  info: { light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N500, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N500 },
  normal: { light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N0, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].DN50 },
  success: { light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].G400, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].G300 },
  warning: { light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].Y200, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].Y300 }
});

var flagBorderColor = Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["g" /* themed */])('appearance', {
  // $FlowFixMe - theme is not found in props
  normal: { light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N60A }
});

var flagTextColor = Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["g" /* themed */])('appearance', {
  error: { light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N0, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].DN40 },
  info: { light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N0, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].DN600 },
  normal: { light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N500, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].DN600 },
  success: { light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N0, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].DN40 },
  warning: { light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N700, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].DN40 }
});

var flagShadowColor = Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["g" /* themed */])('appearance', {
  error: { light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N50A, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N50A },
  info: { light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N50A, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N50A },
  normal: { light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N50A, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N50A },
  success: { light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N50A, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N50A },
  warning: { light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N50A, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N50A }
});
// $FlowFixMe - theme is not found in props
var flagFocusRingColor = Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["g" /* themed */])('appearance', {
  error: { light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N40, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N40 },
  info: { light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N40, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N40 },
  normal: { light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].B100, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].link },
  success: { light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N40, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N40 },
  warning: { light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N200, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N200 }
});

var buttonBackgroundColor = Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["g" /* themed */])('appearance', {
  error: { light: lightButtonBackground, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N30A },
  info: { light: lightButtonBackground, dark: lightButtonBackground },
  normal: { light: 'none', dark: 'none' },
  success: { light: lightButtonBackground, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N30A },
  warning: { light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N30A, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N30A }
});
// $FlowFixMe - theme is not found in props
var buttonTextColor = Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["g" /* themed */])('appearance', {
  error: { light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N0, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].DN40 },
  info: { light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N0, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].DN600 },
  normal: { light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].link, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].link },
  success: { light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N0, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].DN40 },
  warning: { light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N700, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].DN40 }
});

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Gateway__ = __webpack_require__(485);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Gateway__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_GatewayDest__ = __webpack_require__(486);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__components_GatewayDest__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_GatewayProvider__ = __webpack_require__(487);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__components_GatewayProvider__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_GatewayRegistry__ = __webpack_require__(83);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__components_GatewayRegistry__["a"]; });

/*
  Fork of React Gateway
  https://github.com/cloudflare/react-gateway

  Licensed under the BSD 3-clause "New" or "Revised" License
  Copyright (c) 2016, CloudFlare, Inc.
  All rights reserved.
*/






/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);









var DefaultBaseComponent = function DefaultBaseComponent(props) {
  return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', props);
};

var withContextFromProps = function withContextFromProps(propTypes) {
  var BaseComponent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DefaultBaseComponent;

  var ContextProps = function (_Component) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(ContextProps, _Component);

    function ContextProps() {
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ContextProps);

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ContextProps.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(ContextProps)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(ContextProps, [{
      key: 'getChildContext',
      value: function getChildContext() {
        var _this2 = this;

        var props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(propTypes).reduce(function (result, key) {
          // eslint-disable-next-line no-param-reassign
          if (key !== 'children') result[key] = _this2.props[key];

          return result;
        }, {});

        return props;
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            children = _props.children,
            props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['children']);

        if (BaseComponent !== null) {
          return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            BaseComponent,
            null,
            this.props.children
          );
        } else if (__WEBPACK_IMPORTED_MODULE_7_react___default.a.Children.count(children) === 1) {
          var onlyChild = children;
          // Hacky fix to work with TransitionGroup in withRenderTarget
          return __WEBPACK_IMPORTED_MODULE_7_react___default.a.Children.only(__WEBPACK_IMPORTED_MODULE_7_react___default.a.cloneElement(onlyChild, props));
        }
        throw Error('Only one child should exist when base component is null');
      }
    }]);

    return ContextProps;
  }(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

  ContextProps.displayName = 'withContextFromProps';
  ContextProps.childContextTypes = propTypes;

  return ContextProps;
};

/* harmony default export */ __webpack_exports__["a"] = (withContextFromProps);

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAllAffectedNodes = exports.constants = exports.focusMerge = exports.focusInside = exports.tabHook = undefined;

var _tabHook = __webpack_require__(492);

var _tabHook2 = _interopRequireDefault(_tabHook);

var _focusMerge = __webpack_require__(147);

var _focusMerge2 = _interopRequireDefault(_focusMerge);

var _focusInside = __webpack_require__(496);

var _focusInside2 = _interopRequireDefault(_focusInside);

var _setFocus = __webpack_require__(230);

var _setFocus2 = _interopRequireDefault(_setFocus);

var _constants = __webpack_require__(233);

var constants = _interopRequireWildcard(_constants);

var _allAffected = __webpack_require__(148);

var _allAffected2 = _interopRequireDefault(_allAffected);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.tabHook = _tabHook2.default;
exports.focusInside = _focusInside2.default;
exports.focusMerge = _focusMerge2.default;
exports.constants = constants;
exports.getAllAffectedNodes = _allAffected2.default;
exports.default = _setFocus2.default;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.newFocus = undefined;

var _tabOrder = __webpack_require__(231);

var _DOMutils = __webpack_require__(493);

var _tabUtils = __webpack_require__(232);

var _firstFocus = __webpack_require__(495);

var _firstFocus2 = _interopRequireDefault(_firstFocus);

var _allAffected = __webpack_require__(148);

var _allAffected2 = _interopRequireDefault(_allAffected);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var findAutoFocused = function findAutoFocused(autoFocusables) {
  return function (node) {
    return !!node.autofocus || node.dataset && !!node.dataset.autofocus || autoFocusables.indexOf(node) >= 0;
  };
};

var newFocus = exports.newFocus = function newFocus(innerNodes, outerNodes, activeElement, lastNode, autoFocused) {
  var cnt = innerNodes.length;
  var firstFocus = innerNodes[0];
  var lastFocus = innerNodes[cnt - 1];

  // focus is inside
  if (innerNodes.indexOf(activeElement) >= 0) {
    return undefined;
  }

  var activeIndex = outerNodes.indexOf(activeElement);
  var lastIndex = outerNodes.indexOf(lastNode || activeIndex);
  var lastNodeInside = innerNodes.indexOf(lastNode);
  var indexDiff = activeIndex - lastIndex;
  var firstNodeIndex = outerNodes.indexOf(firstFocus);
  var lastNodeIndex = outerNodes.indexOf(lastFocus);

  // new focus
  if (activeIndex === -1 || lastNodeInside === -1) {
    return innerNodes.indexOf(autoFocused.length ? (0, _firstFocus2.default)(autoFocused) : (0, _firstFocus2.default)(innerNodes));
  }
  // old focus
  if (!indexDiff && lastNodeInside >= 0) {
    return lastNodeInside;
  }
  // jump out
  if (indexDiff && Math.abs(indexDiff) > 1) {
    return lastNodeInside;
  }
  // focus above lock
  if (activeIndex <= firstNodeIndex) {
    return cnt - 1;
  }
  // focus below lock
  if (activeIndex > lastNodeIndex) {
    return 0;
  }
  // index is inside tab order, but outside Lock
  if (indexDiff) {
    if (Math.abs(indexDiff) > 1) {
      return lastNodeInside;
    }
    return (cnt + lastNodeInside + indexDiff) % cnt;
  }
  // do nothing
  return undefined;
};

var getTopCommonParent = function getTopCommonParent(activeElement, entry, entries) {
  var topCommon = entry;
  entries.forEach(function (subEntry) {
    var common = (0, _DOMutils.getCommonParent)(activeElement, subEntry);
    if (common) {
      if (common.contains(topCommon)) {
        topCommon = common;
      } else {
        topCommon = (0, _DOMutils.getCommonParent)(common, topCommon);
      }
    }
  });
  return topCommon;
};

var allParentAutofocusables = function allParentAutofocusables(entries) {
  return entries.reduce(function (acc, node) {
    return acc.concat((0, _DOMutils.parentAutofocusables)(node));
  }, []);
};

var getFocusMerge = function getFocusMerge(topNode, lastNode) {
  var activeElement = document.activeElement;
  var entries = (0, _allAffected2.default)(topNode);

  var commonParent = getTopCommonParent(activeElement || topNode, topNode, entries);

  var innerElements = (0, _DOMutils.getTabbableNodes)(entries);
  if (!innerElements[0]) {
    return undefined;
  }

  var innerNodes = innerElements.map(function (_ref) {
    var node = _ref.node;
    return node;
  });

  var outerNodes = (0, _tabOrder.orderByTabIndex)((0, _tabUtils.getFocusables)([commonParent])).map(function (_ref2) {
    var node = _ref2.node;
    return node;
  });

  var newId = newFocus(innerNodes, outerNodes, activeElement, lastNode, innerNodes.filter(findAutoFocused(allParentAutofocusables(entries))));

  if (newId === undefined) {
    return newId;
  }
  return innerElements[newId];
};

exports.default = getFocusMerge;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _constants = __webpack_require__(233);

var _array = __webpack_require__(58);

var filterNested = function filterNested(nodes) {
  var l = nodes.length;
  for (var i = 0; i < l; i += 1) {
    var _loop = function _loop(j) {
      if (i !== j) {
        if (nodes[i].contains(nodes[j])) {
          return {
            v: filterNested(nodes.filter(function (x) {
              return x !== nodes[j];
            }))
          };
        }
      }
    };

    for (var j = 0; j < l; j += 1) {
      var _ret = _loop(j);

      if ((typeof _ret === "undefined" ? "undefined" : _typeof(_ret)) === "object") return _ret.v;
    }
  }
  return nodes;
};

var getTopParent = function getTopParent(node) {
  return node.parentNode ? getTopParent(node.parentNode) : node;
};

var getAllAffectedNodes = function getAllAffectedNodes(node) {
  var group = node.getAttribute(_constants.FOCUS_GROUP);
  if (group) {
    return filterNested((0, _array.toArray)(getTopParent(node).querySelectorAll("[" + _constants.FOCUS_GROUP + "=\"" + group + "\"]:not([" + _constants.FOCUS_DISABLED + "=\"disabled\"])")));
  }
  return [node];
};

exports.default = getAllAffectedNodes;

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.preventTouchMove = preventTouchMove;
exports.allowTouchMove = allowTouchMove;
exports.preventInertiaScroll = preventInertiaScroll;
exports.isTouchDevice = isTouchDevice;
exports.getPadding = getPadding;
exports.camelToKebab = camelToKebab;
exports.getWindowHeight = getWindowHeight;
exports.getDocumentHeight = getDocumentHeight;
exports.parse = parse;
exports.makeStyleTag = makeStyleTag;
exports.injectStyles = injectStyles;
exports.insertStyleTag = insertStyleTag;
function preventTouchMove(e) {
  e.preventDefault();
}

function allowTouchMove(e) {
  e.stopPropagation();
}

function preventInertiaScroll() {
  var top = this.scrollTop;
  var totalScroll = this.scrollHeight;
  var currentScroll = top + this.offsetHeight;

  if (top === 0) {
    this.scrollTop = 1;
  } else if (currentScroll === totalScroll) {
    this.scrollTop = top - 1;
  }
}

// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function isTouchDevice() {
  if (!window) return false;
  return 'ontouchstart' in window || navigator.maxTouchPoints;
}

function getPadding() {
  if (!document || !window) return 0;

  var currentPadding = parseInt(document.body.paddingRight, 10) || 0;
  var clientWidth = document.body ? document.body.clientWidth : 0;
  var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;

  return adjustedPadding;
}

function camelToKebab(str) {
  return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}

function getWindowHeight() {
  var multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

  if (window && window.innerHeight) {
    return window.innerHeight * multiplier;
  }
}

function getDocumentHeight() {
  if (document && document.body) {
    return document.body.clientHeight;
  }
}

function parse(val) {
  return isNaN(val) ? val : val + 'px';
}

// ==============================
// Style Sheets
// ==============================

function makeStyleTag(id) {
  var tag = document.createElement('style');
  tag.type = 'text/css';
  tag.setAttribute('data-react-scrolllock', '');

  return tag;
}
function injectStyles(tag, css) {
  if (tag.styleSheet) {
    tag.styleSheet.cssText = css;
  } else {
    tag.appendChild(document.createTextNode(css));
  }
}
function insertStyleTag(tag) {
  var head = document.head || document.getElementsByTagName('head')[0];
  head.appendChild(tag);
}

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = themed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getTheme__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__types__);

/* eslint-disable prefer-rest-params */




function themedVariants(variantProp, variants) {
  return function (props) {
    var theme = Object(__WEBPACK_IMPORTED_MODULE_0__getTheme__["a" /* default */])(props);
    if (props && props[variantProp] && variants) {
      var modes = variants[props[variantProp]];
      if (modes) {
        return modes[theme.mode];
      }
    }
    return '';
  };
}

function themed(modesOrVariant, variantModes) {
  if (typeof modesOrVariant === 'string') {
    return themedVariants(modesOrVariant, variantModes);
  }
  var modes = modesOrVariant;
  return function (props) {
    var theme = Object(__WEBPACK_IMPORTED_MODULE_0__getTheme__["a" /* default */])(props);
    return modes[theme.mode];
  };
}

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WIDTH_ENUM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return gutter; });

// eslint-disable-next-line import/prefer-default-export
var WIDTH_ENUM = {
  values: ['small', 'medium', 'large', 'x-large'],
  widths: {
    small: 400,
    medium: 600,
    large: 800,
    'x-large': 968
  },
  defaultValue: 'medium'
};
var gutter = 60;

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AtlasKitThemeProvider */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return borderRadius; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return gridSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fontSize; });
/* unused harmony export fontFamily */
/* unused harmony export codeFontFamily */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return layers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elevation__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__typography__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_math__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_getTheme__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_themed__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AtlaskitThemeProvider__ = __webpack_require__(522);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__colors__; });
/* unused harmony reexport elevation */
/* unused harmony reexport typography */
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__utils_math__; });
/* unused harmony reexport getTheme */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_5__utils_themed__["a"]; });
/* unused harmony reexport AtlaskitThemeProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Appearance__ = __webpack_require__(523);
/* unused harmony reexport Appearance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Context__ = __webpack_require__(87);
/* unused harmony reexport Consumer */
/* unused harmony reexport Provider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Reset__ = __webpack_require__(524);
/* unused harmony reexport Reset */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Theme__ = __webpack_require__(525);
/* unused harmony reexport Theme */











// backwards-compatible export with old Atlaskit case
var AtlasKitThemeProvider = __WEBPACK_IMPORTED_MODULE_6__components_AtlaskitThemeProvider__["a" /* default */];

/*
  These theme values are expressed as functions so that if we decide to make
  them dependent on props in the future, it wouldn't require a significant
  refactor everywhere they are being used.
*/
var borderRadius = function borderRadius() {
  return 3;
};
var gridSize = function gridSize() {
  return 8;
};
var fontSize = function fontSize() {
  return 14;
};
var fontFamily = function fontFamily() {
  return '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif';
};
var codeFontFamily = function codeFontFamily() {
  return '"SFMono-Medium", "SF Mono", "Segoe UI Mono", "Roboto Mono", "Ubuntu Mono", Menlo, Consolas, Courier, monospace';
};

var layers = {
  card: function card() {
    return 100;
  },
  dialog: function dialog() {
    return 200;
  },
  navigation: function navigation() {
    return 300;
  },
  layer: function layer() {
    return 400;
  },
  blanket: function blanket() {
    return 500;
  },
  modal: function modal() {
    return 510;
  },
  flag: function flag() {
    return 600;
  },
  spotlight: function spotlight() {
    return 700;
  },
  tooltip: function tooltip() {
    return 800;
  }
};

// New API




/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = themed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getTheme__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__types__);

/* eslint-disable prefer-rest-params */




function themedVariants(variantProp, variants) {
  return function (props) {
    var theme = Object(__WEBPACK_IMPORTED_MODULE_0__getTheme__["a" /* default */])(props);
    if (props && props[variantProp] && variants) {
      var modes = variants[props[variantProp]];
      if (modes) {
        return modes[theme.mode];
      }
    }
    return '';
  };
}

function themed(modesOrVariant, variantModes) {
  if (typeof modesOrVariant === 'string') {
    return themedVariants(modesOrVariant, variantModes);
  }
  var modes = modesOrVariant;
  return function (props) {
    var theme = Object(__WEBPACK_IMPORTED_MODULE_0__getTheme__["a" /* default */])(props);
    return modes[theme.mode];
  };
}

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Button__ = __webpack_require__(244);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Button__["a"]; });
/* unused harmony reexport defaultProps */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ButtonGroup__ = __webpack_require__(555);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__components_ButtonGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__theme__ = __webpack_require__(249);
/* unused harmony reexport themeNamespace */





/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = themed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getTheme__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__types__);

/* eslint-disable prefer-rest-params */




function themedVariants(variantProp, variants) {
  return function (props) {
    var theme = Object(__WEBPACK_IMPORTED_MODULE_0__getTheme__["a" /* default */])(props);
    if (props && props[variantProp] && variants) {
      var modes = variants[props[variantProp]];
      if (modes) {
        return modes[theme.mode];
      }
    }
    return '';
  };
}

function themed(modesOrVariant, variantModes) {
  if (typeof modesOrVariant === 'string') {
    return themedVariants(modesOrVariant, variantModes);
  }
  var modes = modesOrVariant;
  return function (props) {
    var theme = Object(__WEBPACK_IMPORTED_MODULE_0__getTheme__["a" /* default */])(props);
    return modes[theme.mode];
  };
}

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = themed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getTheme__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__types__);

/* eslint-disable prefer-rest-params */




function themedVariants(variantProp, variants) {
  return function (props) {
    var theme = Object(__WEBPACK_IMPORTED_MODULE_0__getTheme__["a" /* default */])(props);
    if (props && props[variantProp] && variants) {
      var modes = variants[props[variantProp]];
      if (modes) {
        return modes[theme.mode];
      }
    }
    return '';
  };
}

function themed(modesOrVariant, variantModes) {
  if (typeof modesOrVariant === 'string') {
    return themedVariants(modesOrVariant, variantModes);
  }
  var modes = modesOrVariant;
  return function (props) {
    var theme = Object(__WEBPACK_IMPORTED_MODULE_0__getTheme__["a" /* default */])(props);
    return modes[theme.mode];
  };
}

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = themed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getTheme__ = __webpack_require__(258);
/* eslint-disable prefer-rest-params */


// Unpack custom variants, and get correct value for the current theme
function themedVariants(variantProp, variants) {
  return function (props) {
    var theme = Object(__WEBPACK_IMPORTED_MODULE_0__getTheme__["a" /* default */])(props);

    if (props && props[variantProp] && variants) {
      var modes = variants[props[variantProp]];

      if (modes && modes[theme.mode]) {
        var value = modes[theme.mode];

        if (value) {
          return value;
        } // TS believes value can be undefined

      }
    }

    return '';
  };
}

function themed(modesOrVariant, variantModes) {
  if (typeof modesOrVariant === 'string') {
    return themedVariants(modesOrVariant, variantModes);
  }

  var modes = modesOrVariant;
  return function (props) {
    // Get theme from the user's props
    var theme = Object(__WEBPACK_IMPORTED_MODULE_0__getTheme__["a" /* default */])(props); // User isn't required to provide both light and dark values

    if (theme.mode in modes) {
      var value = modes[theme.mode]; // TS believes value can be undefined

      if (value) {
        return value;
      }
    }

    return '';
  };
}

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = themed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getTheme__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__types__);

/* eslint-disable prefer-rest-params */




function themedVariants(variantProp, variants) {
  return function (props) {
    var theme = Object(__WEBPACK_IMPORTED_MODULE_0__getTheme__["a" /* default */])(props);
    if (props && props[variantProp] && variants) {
      var modes = variants[props[variantProp]];
      if (modes) {
        return modes[theme.mode];
      }
    }
    return '';
  };
}

function themed(modesOrVariant, variantModes) {
  if (typeof modesOrVariant === 'string') {
    return themedVariants(modesOrVariant, variantModes);
  }
  var modes = modesOrVariant;
  return function (props) {
    var theme = Object(__WEBPACK_IMPORTED_MODULE_0__getTheme__["a" /* default */])(props);
    return modes[theme.mode];
  };
}

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = themed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getTheme__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__types__);

/* eslint-disable prefer-rest-params */




function themedVariants(variantProp, variants) {
  return function (props) {
    var theme = Object(__WEBPACK_IMPORTED_MODULE_0__getTheme__["a" /* default */])(props);
    if (props && props[variantProp] && variants) {
      var modes = variants[props[variantProp]];
      if (modes) {
        return modes[theme.mode];
      }
    }
    return '';
  };
}

function themed(modesOrVariant, variantModes) {
  if (typeof modesOrVariant === 'string') {
    return themedVariants(modesOrVariant, variantModes);
  }
  var modes = modesOrVariant;
  return function (props) {
    var theme = Object(__WEBPACK_IMPORTED_MODULE_0__getTheme__["a" /* default */])(props);
    return modes[theme.mode];
  };
}

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styled_GlobalItemInner__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DefaultLinkComponent__ = __webpack_require__(272);








var _templateObject = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n        ', ';\n        ', ';\n      '], ['\n        ', ';\n        ', ';\n      ']);






var GlobalItem = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(GlobalItem, _PureComponent);

  function GlobalItem() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, GlobalItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = GlobalItem.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(GlobalItem)).call.apply(_ref, [this].concat(args))), _this), _this.handleKeyDown = function (event) {
      if (event.key === 'Enter' && _this.props.onClick) {
        _this.props.onClick(event);
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(GlobalItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          href = _props.href,
          CustomComponent = _props.linkComponent,
          isSelected = _props.isSelected,
          size = _props.size,
          ariaHasPopup = _props['aria-haspopup'],
          onClick = _props.onClick,
          providedMouseDown = _props.onMouseDown,
          role = _props.role,
          appearance = _props.appearance;


      var allyAndEventProps = {
        'aria-haspopup': ariaHasPopup,
        onClick: onClick,
        role: role,
        onKeyDown: this.handleKeyDown
      };

      var hoverOverrideStyles = href ? '&:hover { color: inherit; }' : '';

      if (CustomComponent) {
        var StyledComponent = Object(__WEBPACK_IMPORTED_MODULE_8_styled_components__["default"])(CustomComponent)(_templateObject, __WEBPACK_IMPORTED_MODULE_9__styled_GlobalItemInner__["b" /* globalItemStyles */], hoverOverrideStyles);
        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          StyledComponent,
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            appearance: appearance,
            href: href,
            isSelected: isSelected,
            onMouseDown: providedMouseDown,
            size: size
          }, allyAndEventProps),
          children
        );
      }
      if (href) {
        var StyledLink = Object(__WEBPACK_IMPORTED_MODULE_8_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_10__DefaultLinkComponent__["a" /* default */])(_templateObject, __WEBPACK_IMPORTED_MODULE_9__styled_GlobalItemInner__["b" /* globalItemStyles */], hoverOverrideStyles);
        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          StyledLink,
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            href: href,
            size: size,
            onMouseDown: providedMouseDown,
            appearance: appearance
          }, allyAndEventProps),
          children
        );
      }

      var onMouseDown = function onMouseDown(e) {
        providedMouseDown(e);
        e.preventDefault();
      };

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__styled_GlobalItemInner__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          type: 'button',
          isSelected: isSelected,
          onMouseDown: onMouseDown,
          size: size,
          appearance: appearance
        }, allyAndEventProps),
        children
      );
    }
  }]);

  return GlobalItem;
}(__WEBPACK_IMPORTED_MODULE_7_react__["PureComponent"]);

GlobalItem.defaultProps = {
  onMouseDown: function onMouseDown() {},
  size: 'small',
  appearance: 'round'
};
/* harmony default export */ __webpack_exports__["a"] = (GlobalItem);

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return truncate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return focusOutline; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  width: ', ';\n'], ['\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  width: ', ';\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  outline: none;\n  box-shadow: 0 0 0 2px ', ';\n'], ['\n  outline: none;\n  box-shadow: 0 0 0 2px ', ';\n']);




var truncate = function truncate() {
  var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '100%';
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject, width);
};

var focusOutline = function focusOutline(color) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject2, color || '');
};

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NavigationItemWithoutAnalytics */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__atlaskit_analytics_next__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__atlaskit_item__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__package_json__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styled_NavigationItemAction__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styled_NavigationItemAfter__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styled_NavigationItemCaption__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styled_NavigationItemIcon__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styled_NavigationItemTextAfter__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styled_NavigationItemAfterWrapper__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__theme_util__ = __webpack_require__(11);





















var Item = Object(__WEBPACK_IMPORTED_MODULE_9__atlaskit_item__["d" /* withItemClick */])(Object(__WEBPACK_IMPORTED_MODULE_9__atlaskit_item__["e" /* withItemFocus */])(__WEBPACK_IMPORTED_MODULE_9__atlaskit_item__["b" /* default */]));

var NavigationItem = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(NavigationItem, _PureComponent);

  function NavigationItem() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, NavigationItem);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (NavigationItem.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(NavigationItem)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(NavigationItem, [{
    key: 'render',
    value: function render() {
      var icon = this.props.icon ? __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_14__styled_NavigationItemIcon__["a" /* default */],
        null,
        this.props.icon
      ) : null;

      var dropIcon = this.props.dropIcon && this.props.isDropdownTrigger ? __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_14__styled_NavigationItemIcon__["a" /* default */],
        { isDropdownTrigger: true },
        this.props.dropIcon
      ) : null;

      var textAfter = this.props.textAfter ? __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_15__styled_NavigationItemTextAfter__["a" /* default */],
        null,
        this.props.textAfter
      ) : null;

      var action = this.props.action ? __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11__styled_NavigationItemAction__["a" /* default */],
        null,
        this.props.action
      ) : null;

      var after = this.props.textAfter ? __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_12__styled_NavigationItemAfter__["a" /* default */],
        {
          shouldTakeSpace: this.props.action || this.props.textAfter,
          isDropdownTrigger: this.props.isDropdownTrigger
        },
        textAfter
      ) : null;

      // There are various 'after' elements which are all optional. If any of them are present we
      // render those inside a shared wrapper.
      var allAfter = after || dropIcon || action ? __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_16__styled_NavigationItemAfterWrapper__["a" /* default */],
        null,
        after,
        dropIcon,
        action
      ) : null;

      var wrappedCaption = this.props.caption ? __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_13__styled_NavigationItemCaption__["a" /* default */],
        null,
        this.props.caption
      ) : null;

      var interactiveWrapperProps = {
        onClick: this.props.onClick,
        onKeyDown: this.props.onKeyDown,
        onMouseEnter: this.props.onMouseEnter,
        onMouseLeave: this.props.onMouseLeave,
        href: this.props.href,
        linkComponent: this.props.linkComponent
      };

      // Theme prop is provided via withTheme(...) and is not public API
      /* eslint-disable react/prop-types */
      // $FlowFixMe
      var role = Object(__WEBPACK_IMPORTED_MODULE_17__theme_util__["k" /* isInOverflowDropdown */])(this.props.theme) ? 'menuitem' : null;
      /* eslint-enable react/prop-types */

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        Item,
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          elemBefore: icon,
          elemAfter: allAfter,
          description: this.props.subText,
          isSelected: this.props.isSelected,
          isDragging: this.props.isDragging,
          isDropdown: this.props.isDropdownTrigger,
          isCompact: this.props.isCompact,
          dnd: this.props.dnd,
          autoFocus: this.props.autoFocus,
          target: this.props.target,
          role: role
        }, interactiveWrapperProps),
        this.props.text,
        wrappedCaption
      );
    }
  }]);

  return NavigationItem;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

NavigationItem.defaultProps = {
  isSelected: false,
  isDropdownTrigger: false,
  autoFocus: false
};


var NavigationItemWithoutAnalytics = Object(__WEBPACK_IMPORTED_MODULE_7_styled_components__["withTheme"])(NavigationItem);
var createAndFireEventOnAtlaskit = Object(__WEBPACK_IMPORTED_MODULE_8__atlaskit_analytics_next__["b" /* createAndFireEvent */])('atlaskit');

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__atlaskit_analytics_next__["c" /* withAnalyticsContext */])({
  componentName: 'navigationItem',
  packageName: __WEBPACK_IMPORTED_MODULE_10__package_json__["name"],
  packageVersion: __WEBPACK_IMPORTED_MODULE_10__package_json__["version"]
})(Object(__WEBPACK_IMPORTED_MODULE_8__atlaskit_analytics_next__["d" /* withAnalyticsEvents */])({
  onClick: createAndFireEventOnAtlaskit({
    action: 'clicked',
    actionSubject: 'navigationItem',

    attributes: {
      componentName: 'navigationItem',
      packageName: __WEBPACK_IMPORTED_MODULE_10__package_json__["name"],
      packageVersion: __WEBPACK_IMPORTED_MODULE_10__package_json__["version"]
    }
  })
})(NavigationItemWithoutAnalytics)));

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = themed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getTheme__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__types__);

/* eslint-disable prefer-rest-params */




function themedVariants(variantProp, variants) {
  return function (props) {
    var theme = Object(__WEBPACK_IMPORTED_MODULE_0__getTheme__["a" /* default */])(props);
    if (props && props[variantProp] && variants) {
      var modes = variants[props[variantProp]];
      if (modes) {
        return modes[theme.mode];
      }
    }
    return '';
  };
}

function themed(modesOrVariant, variantModes) {
  if (typeof modesOrVariant === 'string') {
    return themedVariants(modesOrVariant, variantModes);
  }
  var modes = modesOrVariant;
  return function (props) {
    var theme = Object(__WEBPACK_IMPORTED_MODULE_0__getTheme__["a" /* default */])(props);
    return modes[theme.mode];
  };
}

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Tooltip__ = __webpack_require__(657);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Tooltip__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styled__ = __webpack_require__(293);
/* unused harmony reexport TooltipPrimitive */



/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AtlasKitThemeProvider */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return borderRadius; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return gridSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fontSize; });
/* unused harmony export fontFamily */
/* unused harmony export codeFontFamily */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return layers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elevation__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__typography__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_math__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_getTheme__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_themed__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AtlaskitThemeProvider__ = __webpack_require__(664);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__colors__; });
/* unused harmony reexport elevation */
/* unused harmony reexport typography */
/* unused harmony reexport math */
/* unused harmony reexport getTheme */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__utils_themed__["a"]; });
/* unused harmony reexport AtlaskitThemeProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Appearance__ = __webpack_require__(665);
/* unused harmony reexport Appearance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Context__ = __webpack_require__(100);
/* unused harmony reexport Consumer */
/* unused harmony reexport Provider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Reset__ = __webpack_require__(666);
/* unused harmony reexport Reset */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Theme__ = __webpack_require__(667);
/* unused harmony reexport Theme */











// backwards-compatible export with old Atlaskit case
var AtlasKitThemeProvider = __WEBPACK_IMPORTED_MODULE_6__components_AtlaskitThemeProvider__["a" /* default */];

/*
  These theme values are expressed as functions so that if we decide to make
  them dependent on props in the future, it wouldn't require a significant
  refactor everywhere they are being used.
*/
var borderRadius = function borderRadius() {
  return 3;
};
var gridSize = function gridSize() {
  return 8;
};
var fontSize = function fontSize() {
  return 14;
};
var fontFamily = function fontFamily() {
  return '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif';
};
var codeFontFamily = function codeFontFamily() {
  return '"SFMono-Medium", "SF Mono", "Segoe UI Mono", "Roboto Mono", "Ubuntu Mono", Menlo, Consolas, Courier, monospace';
};

var layers = {
  card: function card() {
    return 100;
  },
  dialog: function dialog() {
    return 200;
  },
  navigation: function navigation() {
    return 300;
  },
  layer: function layer() {
    return 400;
  },
  blanket: function blanket() {
    return 500;
  },
  modal: function modal() {
    return 510;
  },
  flag: function flag() {
    return 600;
  },
  spotlight: function spotlight() {
    return 700;
  },
  tooltip: function tooltip() {
    return 800;
  }
};

// New API




/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = themed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getTheme__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__types__);

/* eslint-disable prefer-rest-params */




function themedVariants(variantProp, variants) {
  return function (props) {
    var theme = Object(__WEBPACK_IMPORTED_MODULE_0__getTheme__["a" /* default */])(props);
    if (props && props[variantProp] && variants) {
      var modes = variants[props[variantProp]];
      if (modes) {
        return modes[theme.mode];
      }
    }
    return '';
  };
}

function themed(modesOrVariant, variantModes) {
  if (typeof modesOrVariant === 'string') {
    return themedVariants(modesOrVariant, variantModes);
  }
  var modes = modesOrVariant;
  return function (props) {
    var theme = Object(__WEBPACK_IMPORTED_MODULE_0__getTheme__["a" /* default */])(props);
    return modes[theme.mode];
  };
}

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Anchor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return Span; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return InputWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Before; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return After; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ContentWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Content; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Description; });
/* unused harmony export SecondaryText */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(41);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  box-shadow: 0 0 0 2px ', '\n    inset;\n  outline: none;\n  outline-offset: 0;\n  position: relative; /* prevents bgcolor of a hovered element from obfuscating focus ring of a focused sibling element */\n'], ['\n  box-shadow: 0 0 0 2px ', '\n    inset;\n  outline: none;\n  outline-offset: 0;\n  position: relative; /* prevents bgcolor of a hovered element from obfuscating focus ring of a focused sibling element */\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  &,\n  &:hover {\n    background-color: ', ';\n    color: ', ';\n  }\n'], ['\n  &,\n  &:hover {\n    background-color: ', ';\n    color: ', ';\n  }\n']),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: ', ';\n'], ['\n  color: ', ';\n']),
    _templateObject4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  align-items: center;\n  box-sizing: border-box;\n  color: ', ';\n  cursor: ', ';\n  display: ', ';\n  flex-wrap: nowrap;\n  font-size: ', 'px;\n  font-weight: normal;\n  padding: 0 ', 'px;\n  text-decoration: none;\n\n  &:hover {\n    background-color: ', ';\n    color: ', ';\n    text-decoration: none;\n\n    ', ';\n  }\n  &:active {\n    background-color: ', ';\n    color: ', ';\n\n    ', ';\n  }\n  &:focus {\n    ', ';\n  }\n\n  ', ' ', ' ', ';\n'], ['\n  align-items: center;\n  box-sizing: border-box;\n  color: ', ';\n  cursor: ', ';\n  display: ', ';\n  flex-wrap: nowrap;\n  font-size: ', 'px;\n  font-weight: normal;\n  padding: 0 ', 'px;\n  text-decoration: none;\n\n  &:hover {\n    background-color: ', ';\n    color: ', ';\n    text-decoration: none;\n\n    ', ';\n  }\n  &:active {\n    background-color: ', ';\n    color: ', ';\n\n    ', ';\n  }\n  &:focus {\n    ', ';\n  }\n\n  ', ' ', ' ', ';\n']),
    _templateObject5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ';\n'], ['\n  ', ';\n']),
    _templateObject6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  margin: 0 2px;\n'], ['\n  display: flex;\n  margin: 0 2px;\n']),
    _templateObject7 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n'], ['\n  display: flex;\n']),
    _templateObject8 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  align-items: center;\n  display: flex;\n'], ['\n  align-items: center;\n  display: flex;\n']),
    _templateObject9 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  margin: 0 ', 'px;\n  padding: ', 'px 0;\n  overflow: hidden;\n\n  &:first-child {\n    margin: 0;\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  margin: 0 ', 'px;\n  padding: ', 'px 0;\n  overflow: hidden;\n\n  &:first-child {\n    margin: 0;\n  }\n']),
    _templateObject10 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  flex: 1 1 auto;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  ', ';\n'], ['\n  flex: 1 1 auto;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  ', ';\n']),
    _templateObject11 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n      white-space: normal;\n    '], ['\n      white-space: normal;\n    ']),
    _templateObject12 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: ', ';\n  flex: 1 1 auto;\n  font-size: 12px;\n  line-height: 16 / 12;\n  margin-top: ', 'px;\n'], ['\n  color: ', ';\n  flex: 1 1 auto;\n  font-size: 12px;\n  line-height: 16 / 12;\n  margin-top: ', 'px;\n']);




var activeBackgroundColor = Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].B75, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].DN30 });
var hoverBackgroundColor = Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].N20, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].DN60 });
var selectedBackgroundColor = Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].N0, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].DN30 });

var activePrimaryTextColor = Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* themed */])({
  light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].N800,
  dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].DN300
});
var defaultPrimaryTextColor = Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* themed */])({
  light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].N800,
  dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].DN600
});
var disabledPrimaryTextColor = Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* themed */])({
  light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].N70,
  dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].DN70
});
var primaryPrimaryTextColor = Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* themed */])({
  light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].B400,
  dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].B400
});
var selectedPrimaryTextColor = Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* themed */])({
  light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].N800,
  dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].N800
});

var focusedStyles = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject, Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].B100, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].B75 }));

var activeStyles = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject2, selectedBackgroundColor, selectedPrimaryTextColor);
var primaryStyles = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject3, primaryPrimaryTextColor);

var sharedStyles = function sharedStyles(props) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject4, props.isDisabled ? disabledPrimaryTextColor : defaultPrimaryTextColor, props.isDisabled ? 'not-allowed' : 'pointer', props.isHidden ? 'none' : 'flex', __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["c" /* fontSize */], __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["e" /* math */].multiply(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */], 1.5), !props.isDisabled && hoverBackgroundColor, props.isDisabled ? disabledPrimaryTextColor : defaultPrimaryTextColor, props.isPrimary && primaryStyles, !props.isDisabled && activeBackgroundColor, !props.isDisabled && activePrimaryTextColor, props.isPrimary && primaryStyles, focusedStyles, props.isFocused && focusedStyles, props.isActive && activeStyles, props.isPrimary && primaryStyles);
};

var Anchor = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].a(_templateObject5, function (props) {
  return sharedStyles(props);
});
var Span = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(_templateObject5, function (props) {
  return sharedStyles(props);
});

// Checkbox/Radio wrapper -- sits left of the children
var InputWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(_templateObject6);

// Elements injected before/after the children
var Before = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(_templateObject7);
var After = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(_templateObject8);

// Alignment and layout for the children
var ContentWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(_templateObject9, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */], __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */]);
var Content = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(_templateObject10, function (props) {
  return props.allowMultiline && Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject11);
});

// Description is a block element below the children, like a subtitle
var Description = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(_templateObject12, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].subtleText, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["e" /* math */].divide(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */], 2));

// NOTE: Exposed as a named export for this package
var SecondaryText = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(_templateObject3, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].subtleText);

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return KEY_UP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KEY_DOWN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return KEY_SPACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return KEY_ENTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return KEY_TAB; });
/* unused harmony export KEY_ESC */
var KEY_UP = 'ArrowUp';
var KEY_DOWN = 'ArrowDown';
var KEY_SPACE = ' ';
var KEY_ENTER = 'Enter';
var KEY_TAB = 'Tab';
var KEY_ESC = 'Escape';

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = themed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getTheme__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__types__);

/* eslint-disable prefer-rest-params */




function themedVariants(variantProp, variants) {
  return function (props) {
    var theme = Object(__WEBPACK_IMPORTED_MODULE_0__getTheme__["a" /* default */])(props);
    if (props && props[variantProp] && variants) {
      var modes = variants[props[variantProp]];
      if (modes) {
        return modes[theme.mode];
      }
    }
    return '';
  };
}

function themed(modesOrVariant, variantModes) {
  if (typeof modesOrVariant === 'string') {
    return themedVariants(modesOrVariant, variantModes);
  }
  var modes = modesOrVariant;
  return function (props) {
    var theme = Object(__WEBPACK_IMPORTED_MODULE_0__getTheme__["a" /* default */])(props);
    return modes[theme.mode];
  };
}

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_item__ = __webpack_require__(22);








var DropdownItemGroup = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(DropdownItemGroup, _Component);

  function DropdownItemGroup() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DropdownItemGroup);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (DropdownItemGroup.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(DropdownItemGroup)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(DropdownItemGroup, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          elemAfter = _props.elemAfter,
          title = _props.title;

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__atlaskit_item__["a" /* ItemGroup */],
        { elemAfter: elemAfter, title: title, role: 'menu' },
        children
      );
    }
  }]);

  return DropdownItemGroup;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (DropdownItemGroup);

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export analyticsNamespace */
/* unused harmony export DrawerImpl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_blanket__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_analytics__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_scrolllock__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_scrolllock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_scrolllock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DrawerTrigger__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DrawerBackIcon__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ContainerHeader__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styled_DrawerSide__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styled_DrawerInner__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styled_DrawerPrimaryIcon__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styled_DrawerMain__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styled_DrawerContent__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styled_DrawerBackIconWrapper__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__theme_util__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__theme_presets__ = __webpack_require__(48);





















var escKeyCode = 27;
var analyticsNamespace = 'atlaskit.navigation.drawer';

var DrawerImpl = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(DrawerImpl, _PureComponent);

  function DrawerImpl() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DrawerImpl);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = DrawerImpl.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(DrawerImpl)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isAnimating: false
    }, _this.createBackButtonHandler = function (method) {
      return function (e) {
        if (_this.props.isOpen) {
          _this.props.onBackButton(e);
          _this.props.fireAnalyticsEvent('close', { method: method });
        }
      };
    }, _this.onBackButtonByBackButton = _this.createBackButtonHandler('back-btn'), _this.onBackButtonByBlanket = _this.createBackButtonHandler('blanket'), _this.onBackButtonByEscKey = _this.createBackButtonHandler('esc-key'), _this.handleKeyDown = function (event) {
      // The reason we have onKeyDown living together with onBackButton is because
      // some apps living in Focused task need the ability to handle on key down by itself.
      // However, some other apps don't really care about it
      // and leave it to the Focused task to handle.
      // Calling onKeyDown first can either supplement or override onBackButton.
      var onKeyDown = _this.props.onKeyDown;

      if (onKeyDown) {
        onKeyDown(event);
      }
      if (!event.defaultPrevented && event.keyCode === escKeyCode) {
        _this.onBackButtonByEscKey(event);
      }
    }, _this.handleAnimationEnd = function () {
      return _this.setState({ isAnimating: false });
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(DrawerImpl, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.isOpen !== this.props.isOpen) {
        this.setState({ isAnimating: true });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      // Fire analytics event upon drawer opening
      if (!prevProps.isOpen && this.props.isOpen) {
        this.props.fireAnalyticsEvent('open');
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('keydown', this.handleKeyDown);
    }

    // eslint-disable-next-line react/sort-comp

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          backIcon = _props.backIcon,
          header = _props.header,
          isOpen = _props.isOpen,
          primaryIcon = _props.primaryIcon,
          width = _props.width,
          iconOffset = _props.iconOffset;


      var actualFullWidth = width === 'full';

      var sidebar = isOpen ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_12__styled_DrawerSide__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_14__styled_DrawerPrimaryIcon__["a" /* default */],
          null,
          primaryIcon
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_17__styled_DrawerBackIconWrapper__["a" /* default */],
          { iconOffset: iconOffset },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__DrawerTrigger__["a" /* default */],
            { onActivate: this.onBackButtonByBackButton },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10__DrawerBackIcon__["a" /* default */],
              { isVisible: isOpen },
              backIcon
            )
          )
        )
      ) : null;

      var content = isOpen ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_15__styled_DrawerMain__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11__ContainerHeader__["a" /* default */],
          {
            isInDrawer: true,
            iconOffset: iconOffset,
            isFullWidth: actualFullWidth
          },
          width !== 'full' ? header : __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_scrolllock___default.a, null)
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_16__styled_DrawerContent__["a" /* default */],
          null,
          this.props.children
        )
      ) : null;

      // Note: even though we are using WithRootTheme here, the Drawer appearance is not able
      // to be customised via a preset or custom theme.
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_18__theme_util__["a" /* WithRootTheme */],
        { provided: __WEBPACK_IMPORTED_MODULE_19__theme_presets__["a" /* container */] },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__atlaskit_blanket__["a" /* default */], {
            isTinted: isOpen,
            canClickThrough: !isOpen,
            onBlanketClicked: this.onBackButtonByBlanket
          }),
          (this.state.isAnimating || isOpen) && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_13__styled_DrawerInner__["a" /* default */],
            {
              isOpen: isOpen,
              width: width,
              isAnimating: this.state.isAnimating,
              onAnimationEnd: this.handleAnimationEnd
            },
            sidebar,
            content
          )
        )
      );
    }
  }]);

  return DrawerImpl;
}(__WEBPACK_IMPORTED_MODULE_5_react__["PureComponent"]);

DrawerImpl.defaultProps = {
  iconOffset: 0,
  isOpen: false,
  onBackButton: function onBackButton() {},
  primaryIcon: null,
  width: 'narrow'
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__atlaskit_analytics__["a" /* withAnalytics */])(DrawerImpl, {}, { analyticsId: analyticsNamespace }));

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export boxShadowSpread */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return animationSpeed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return animationTiming; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return widthTransition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return drawerBackIconSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return widths; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_variables__ = __webpack_require__(10);


var fullWidth = '100vw';
var narrowWidth = 45 * __WEBPACK_IMPORTED_MODULE_0__shared_variables__["n" /* gridSize */];
var wideWidth = 75 * __WEBPACK_IMPORTED_MODULE_0__shared_variables__["n" /* gridSize */];

var boxShadowSpread = __WEBPACK_IMPORTED_MODULE_0__shared_variables__["n" /* gridSize */] * 4;
var animationSpeed = '220ms';
var animationTiming = 'cubic-bezier(0.15, 1, 0.3, 1)';
var widthTransition = 'width ' + animationSpeed + ' ' + animationTiming;
var drawerBackIconSize = __WEBPACK_IMPORTED_MODULE_0__shared_variables__["n" /* gridSize */] * 5;

var widths = {
  narrow: {
    width: narrowWidth + 'px',
    offScreenTranslateX: -narrowWidth - boxShadowSpread + 'px'
  },
  wide: {
    width: wideWidth + 'px',
    offScreenTranslateX: -wideWidth - boxShadowSpread + 'px'
  },
  full: {
    width: fullWidth,
    offScreenTranslateX: 'calc(-' + fullWidth + ' - ' + boxShadowSpread + 'px)'
  }
};

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_icon__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styled_SkeletonNavigationItems__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styled_SkeletonGlobalPrimaryIconOuter__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styled_SkeletonGlobalIconOuter__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styled_SkeletonGlobalTopItemsInner__ = __webpack_require__(735);









var SkeletonGlobalTopItems = function SkeletonGlobalTopItems() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__styled_SkeletonGlobalTopItemsInner__["a" /* default */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__styled_SkeletonNavigationItems__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__styled_SkeletonGlobalPrimaryIconOuter__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__atlaskit_icon__["a" /* Skeleton */], { size: 'xlarge', weight: 'strong' })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__styled_SkeletonGlobalIconOuter__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__atlaskit_icon__["a" /* Skeleton */], { size: 'large' })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__styled_SkeletonGlobalIconOuter__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__atlaskit_icon__["a" /* Skeleton */], { size: 'large' })
      )
    )
  );
};

SkeletonGlobalTopItems.displayName = 'SkeletonGlobalTopItems';
/* harmony default export */ __webpack_exports__["a"] = (SkeletonGlobalTopItems);

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon__ = __webpack_require__(731);
/* unused harmony reexport size */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Skeleton__ = __webpack_require__(732);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__components_Skeleton__["a"]; });


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__components_Icon__["a" /* default */]);



/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n'], ['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n']);



var SkeletonNavigationItems = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject);

SkeletonNavigationItems.displayName = 'SkeletonNavigationItems';
/* harmony default export */ __webpack_exports__["a"] = (SkeletonNavigationItems);

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_icon__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styled_SkeletonNavigationItems__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styled_SkeletonGlobalIconOuter__ = __webpack_require__(305);







var SkeletonGlobalBottomItems = function SkeletonGlobalBottomItems() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__styled_SkeletonNavigationItems__["a" /* default */],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__styled_SkeletonGlobalIconOuter__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__atlaskit_icon__["a" /* Skeleton */], { size: 'medium' })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__styled_SkeletonGlobalIconOuter__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__atlaskit_icon__["a" /* Skeleton */], { size: 'large', weight: 'strong' })
    )
  );
};

SkeletonGlobalBottomItems.displayName = 'SkeletonGlobalBottomItems';
/* harmony default export */ __webpack_exports__["a"] = (SkeletonGlobalBottomItems);

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_avatar__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ToggleWhenCollapsed__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styled_SkeletonContainerHeaderText__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styled_SkeletonDefaultContainerHeaderInner__ = __webpack_require__(767);














var SkeletonDefaultContainerHeader = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(SkeletonDefaultContainerHeader, _Component);

  function SkeletonDefaultContainerHeader() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SkeletonDefaultContainerHeader);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SkeletonDefaultContainerHeader.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(SkeletonDefaultContainerHeader)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(SkeletonDefaultContainerHeader, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__styled_SkeletonDefaultContainerHeaderInner__["a" /* default */],
        {
          isAvatarHidden: this.props.isAvatarHidden
        },
        !this.props.isAvatarHidden && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__atlaskit_avatar__["a" /* Skeleton */], { appearance: 'square', size: 'large', weight: 'strong' }),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__ToggleWhenCollapsed__["a" /* HiddenWhenCollapsed */],
          { isCollapsed: this.props.isCollapsed },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styled_SkeletonContainerHeaderText__["a" /* default */], {
            isAvatarHidden: this.props.isAvatarHidden
          })
        )
      );
    }
  }]);

  return SkeletonDefaultContainerHeader;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

SkeletonDefaultContainerHeader.defaultProps = {
  isCollapsed: false,
  isAvatarHidden: false
};
/* harmony default export */ __webpack_exports__["a"] = (SkeletonDefaultContainerHeader);

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = themed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getTheme__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__types__);

/* eslint-disable prefer-rest-params */




function themedVariants(variantProp, variants) {
  return function (props) {
    var theme = Object(__WEBPACK_IMPORTED_MODULE_0__getTheme__["a" /* default */])(props);
    if (props && props[variantProp] && variants) {
      var modes = variants[props[variantProp]];
      if (modes) {
        return modes[theme.mode];
      }
    }
    return '';
  };
}

function themed(modesOrVariant, variantModes) {
  if (typeof modesOrVariant === 'string') {
    return themedVariants(modesOrVariant, variantModes);
  }
  var modes = modesOrVariant;
  return function (props) {
    var theme = Object(__WEBPACK_IMPORTED_MODULE_0__getTheme__["a" /* default */])(props);
    return modes[theme.mode];
  };
}

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getPresenceSVG__ = __webpack_require__(317);
/* unused harmony reexport getPresenceSVG */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getProps__ = __webpack_require__(757);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__getProps__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getStatusSVG__ = __webpack_require__(319);
/* unused harmony reexport getStatusSVG */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getStyledAvatar__ = __webpack_require__(758);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__getStyledAvatar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getStyledAvatarItem__ = __webpack_require__(760);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__getStyledAvatarItem__["a"]; });






/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mapProps__ = __webpack_require__(761);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__mapProps__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__withPseudoState__ = __webpack_require__(762);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__withPseudoState__["a"]; });



/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FLATTENED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANNEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_THEME_MODE; });
/* unused harmony export THEME_MODES */
/* unused harmony export borderRadius */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return gridSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fontSize; });
/* unused harmony export fontSizeSmall */
/* unused harmony export fontFamily */
/* unused harmony export codeFontFamily */
/* unused harmony export focusRing */
/* unused harmony export noFocusRing */
/* unused harmony export layers */
/* unused harmony export visuallyHidden */
/* unused harmony export assistive */
/* unused harmony export skeletonShimmer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__colors__ = __webpack_require__(34);


function _templateObject() {
  var data = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_taggedTemplateLiteral___default()(["\n  border: 0 !important;\n  clip: rect(1px, 1px, 1px, 1px) !important;\n  height: 1px !important;\n  overflow: hidden !important;\n  padding: 0 !important;\n  position: absolute !important;\n  width: 1px !important;\n  white-space: nowrap !important;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}



var FLATTENED = '__FLATTENED__';
var CHANNEL = '__ATLASKIT_THEME__';
var DEFAULT_THEME_MODE = 'light';
var THEME_MODES = ['light', 'dark'];
/*
  These theme values are expressed as functions so that if we decide to make
  them dependent on props in the future, it wouldn't require a significant
  refactor everywhere they are being used.
*/

var borderRadius = function borderRadius() {
  return 3;
};
var gridSize = function gridSize() {
  return 8;
};
var fontSize = function fontSize() {
  return 14;
};
var fontSizeSmall = function fontSizeSmall() {
  return 11;
};
var fontFamily = function fontFamily() {
  return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var codeFontFamily = function codeFontFamily() {
  return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var focusRing = function focusRing() {
  var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_2__colors__["a" /* B100 */];
  var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : gridSize() / 4;
  return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var noFocusRing = function noFocusRing() {
  return "\n  box-shadow: none;\n";
};
var layers = {
  card: function card() {
    return 100;
  },
  dialog: function dialog() {
    return 300;
  },
  navigation: function navigation() {
    return 200;
  },
  layer: function layer() {
    return 400;
  },
  blanket: function blanket() {
    return 500;
  },
  modal: function modal() {
    return 510;
  },
  flag: function flag() {
    return 600;
  },
  spotlight: function spotlight() {
    return 700;
  },
  tooltip: function tooltip() {
    return 800;
  }
};
var visuallyHidden = function visuallyHidden() {
  return {
    border: '0 !important',
    clip: 'rect(1px, 1px, 1px, 1px) !important',
    height: '1px !important',
    overflow: 'hidden !important',
    padding: '0 !important',
    position: 'absolute !important',
    width: '1px !important',
    whiteSpace: 'nowrap !important'
  };
};
/**
 * Deprecated Styled Components mixin.
 * Use visuallyHidden instead.
 * @deprecated
 */

var assistive = function assistive() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject());
};
var skeletonShimmer = function skeletonShimmer() {
  return {
    css: {
      backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_2__colors__["T" /* skeleton */])(),
      animationDuration: '1.5s',
      animationIterationCount: 'infinite',
      animationTimingFunction: 'linear',
      animationDirection: 'alternate'
    },
    keyframes: {
      from: {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_2__colors__["T" /* skeleton */])()
      },
      to: {
        backgroundColor: __WEBPACK_IMPORTED_MODULE_2__colors__["q" /* N30A */]
      }
    }
  };
};

/***/ }),
/* 182 */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_createTheme__ = __webpack_require__(184);

// Create default global light theme
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__utils_createTheme__["a" /* createTheme */])(function () {
  return {
    mode: 'light'
  };
}));

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTheme;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);



/*
createTheme is used to create a set of Providers and Consumers for theming components.
- Takes a default theme function; this theme function gets a set of props, and returns tokens
   based on those props. An example of this default theme function is one that produces the standard
   appearance of the component
- Returns two things - a Provider that allow for additional themes to be applied, and a Consumer
   that can get the current theme and fetch it.
*/
function createTheme(defaultGetTokens) {
  var emptyThemeFn = function emptyThemeFn(getTokens, props) {
    return getTokens(props);
  };
  /* Internally, Theme uses React Context, with internal providers and consumers.
     The React Context passes only a function that gets props, and turns them into tokens. This
        function gets mixed as more Providers with their own themes are added. This mixed function
        is ultimately picked up by Consumers, which implement a context consumer internally to fetch
        the theme. */


  var ThemeContext = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["createContext"])(defaultGetTokens); // The Theme Consumer takes a function as its child - this function takes tokens, and the
  // return value is generally a set of nodes with the tokens applied appropriately.

  function Consumer(props) {
    var children = props.children,
        themeProps = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default()(props, ["children"]);

    var theme = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(ThemeContext);
    var themeFn = theme || emptyThemeFn; // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
    // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)

    var tokens = themeFn(themeProps); // We add a fragment to ensure we don't break people upgrading.
    // Previously they may have been able to pass in undefined without things blowing up.

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment, null, children(tokens));
  }
  /* The Theme Provider takes regular nodes as its child, but also takes a *theme function*
     - The theme function takes a set of props, as well as a function (getTokens) that can
        turn props into tokens.
     - The getTokens function isn't called immediately - instead the props are passed
        through a mix of parent theming functions
     Children of this provider will receive this mixed theme
  */


  function Provider(props) {
    var themeFn = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(ThemeContext);
    var valueFn = props.value || emptyThemeFn;
    var mixedFn = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useCallback"])(function (themeProps) {
      return valueFn(themeFn, themeProps);
    }, [themeFn, valueFn]);
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ThemeContext.Provider, {
      value: mixedFn
    }, props.children);
  }

  return {
    Consumer: Consumer,
    Provider: Provider
  };
}

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(333);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTransitionManager;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routerWarning__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TransitionUtils__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isActive__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getComponents__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__matchRoutes__ = __webpack_require__(354);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function hasAnyProperties(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
  }return false;
}

function createTransitionManager(history, routes) {
  var state = {};

  var _getTransitionUtils = Object(__WEBPACK_IMPORTED_MODULE_2__TransitionUtils__["a" /* default */])(),
      runEnterHooks = _getTransitionUtils.runEnterHooks,
      runChangeHooks = _getTransitionUtils.runChangeHooks,
      runLeaveHooks = _getTransitionUtils.runLeaveHooks;

  // Signature should be (location, indexOnly), but needs to support (path,
  // query, indexOnly)


  function isActive(location, indexOnly) {
    location = history.createLocation(location);

    return Object(__WEBPACK_IMPORTED_MODULE_3__isActive__["a" /* default */])(location, indexOnly, state.location, state.routes, state.params);
  }

  var partialNextState = void 0;

  function match(location, callback) {
    if (partialNextState && partialNextState.location === location) {
      // Continue from where we left off.
      finishMatch(partialNextState, callback);
    } else {
      Object(__WEBPACK_IMPORTED_MODULE_5__matchRoutes__["a" /* default */])(routes, location, function (error, nextState) {
        if (error) {
          callback(error);
        } else if (nextState) {
          finishMatch(_extends({}, nextState, { location: location }), callback);
        } else {
          callback();
        }
      });
    }
  }

  function finishMatch(nextState, callback) {
    var _computeChangedRoutes = Object(__WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__["a" /* default */])(state, nextState),
        leaveRoutes = _computeChangedRoutes.leaveRoutes,
        changeRoutes = _computeChangedRoutes.changeRoutes,
        enterRoutes = _computeChangedRoutes.enterRoutes;

    runLeaveHooks(leaveRoutes, state);

    // Tear down confirmation hooks for left routes
    leaveRoutes.filter(function (route) {
      return enterRoutes.indexOf(route) === -1;
    }).forEach(removeListenBeforeHooksForRoute);

    // change and enter hooks are run in series
    runChangeHooks(changeRoutes, state, nextState, function (error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      runEnterHooks(enterRoutes, nextState, finishEnterHooks);
    });

    function finishEnterHooks(error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      // TODO: Fetch components after state is updated.
      Object(__WEBPACK_IMPORTED_MODULE_4__getComponents__["a" /* default */])(nextState, function (error, components) {
        if (error) {
          callback(error);
        } else {
          // TODO: Make match a pure function and have some other API
          // for "match and update state".
          callback(null, null, state = _extends({}, nextState, { components: components }));
        }
      });
    }

    function handleErrorOrRedirect(error, redirectInfo) {
      if (error) callback(error);else callback(null, redirectInfo);
    }
  }

  var RouteGuid = 1;

  function getRouteID(route) {
    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return route.__id__ || create && (route.__id__ = RouteGuid++);
  }

  var RouteHooks = Object.create(null);

  function getRouteHooksForRoutes(routes) {
    return routes.map(function (route) {
      return RouteHooks[getRouteID(route)];
    }).filter(function (hook) {
      return hook;
    });
  }

  function transitionHook(location, callback) {
    Object(__WEBPACK_IMPORTED_MODULE_5__matchRoutes__["a" /* default */])(routes, location, function (error, nextState) {
      if (nextState == null) {
        // TODO: We didn't actually match anything, but hang
        // onto error/nextState so we don't have to matchRoutes
        // again in the listen callback.
        callback();
        return;
      }

      // Cache some state here so we don't have to
      // matchRoutes() again in the listen callback.
      partialNextState = _extends({}, nextState, { location: location });

      var hooks = getRouteHooksForRoutes(Object(__WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__["a" /* default */])(state, partialNextState).leaveRoutes);

      var result = void 0;
      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
        // Passing the location arg here indicates to
        // the user that this is a transition hook.
        result = hooks[i](location);
      }

      callback(result);
    });
  }

  /* istanbul ignore next: untestable with Karma */
  function beforeUnloadHook() {
    // Synchronously check to see if any route hooks want
    // to prevent the current window/tab from closing.
    if (state.routes) {
      var hooks = getRouteHooksForRoutes(state.routes);

      var message = void 0;
      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
        // Passing no args indicates to the user that this is a
        // beforeunload hook. We don't know the next location.
        message = hooks[i]();
      }

      return message;
    }
  }

  var unlistenBefore = void 0,
      unlistenBeforeUnload = void 0;

  function removeListenBeforeHooksForRoute(route) {
    var routeID = getRouteID(route);
    if (!routeID) {
      return;
    }

    delete RouteHooks[routeID];

    if (!hasAnyProperties(RouteHooks)) {
      // teardown transition & beforeunload hooks
      if (unlistenBefore) {
        unlistenBefore();
        unlistenBefore = null;
      }

      if (unlistenBeforeUnload) {
        unlistenBeforeUnload();
        unlistenBeforeUnload = null;
      }
    }
  }

  /**
   * Registers the given hook function to run before leaving the given route.
   *
   * During a normal transition, the hook function receives the next location
   * as its only argument and can return either a prompt message (string) to show the user,
   * to make sure they want to leave the page; or `false`, to prevent the transition.
   * Any other return value will have no effect.
   *
   * During the beforeunload event (in browsers) the hook receives no arguments.
   * In this case it must return a prompt message to prevent the transition.
   *
   * Returns a function that may be used to unbind the listener.
   */
  function listenBeforeLeavingRoute(route, hook) {
    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
    var routeID = getRouteID(route, true);

    RouteHooks[routeID] = hook;

    if (thereWereNoRouteHooks) {
      // setup transition & beforeunload hooks
      unlistenBefore = history.listenBefore(transitionHook);

      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
    }

    return function () {
      removeListenBeforeHooksForRoute(route);
    };
  }

  /**
   * This is the API for stateful environments. As the location
   * changes, we update state and call the listener. We can also
   * gracefully handle errors and redirects.
   */
  function listen(listener) {
    function historyListener(location) {
      if (state.location === location) {
        listener(null, state);
      } else {
        match(location, function (error, redirectLocation, nextState) {
          if (error) {
            listener(error);
          } else if (redirectLocation) {
            history.replace(redirectLocation);
          } else if (nextState) {
            listener(null, nextState);
          } else {
             false ? warning(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
          }
        });
      }
    }

    // TODO: Only use a single history listener. Otherwise we'll end up with
    // multiple concurrent calls to match.

    // Set up the history listener first in case the initial match redirects.
    var unsubscribe = history.listen(historyListener);

    if (state.location) {
      // Picking up on a matchContext.
      listener(null, state);
    } else {
      historyListener(history.getCurrentLocation());
    }

    return unsubscribe;
  }

  return {
    isActive: isActive,
    match: match,
    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
    listen: listen
  };
}

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPromise;
function isPromise(obj) {
  return obj && typeof obj.then === 'function';
}

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = createRouterObject;
/* harmony export (immutable) */ __webpack_exports__["a"] = assignRouterState;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function createRouterObject(history, transitionManager, state) {
  var router = _extends({}, history, {
    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
    isActive: transitionManager.isActive
  });

  return assignRouterState(router, state);
}

function assignRouterState(router, _ref) {
  var location = _ref.location,
      params = _ref.params,
      routes = _ref.routes;

  router.location = location;
  router.params = params;
  router.routes = routes;

  return router;
}

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PropTypes__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContextUtils__ = __webpack_require__(113);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
function isEmptyObject(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
  }return true;
}

function resolveToLocation(to, router) {
  return typeof to === 'function' ? to(router.location) : to;
}

/**
 * A <Link> is used to create an <a> element that links to a route.
 * When that route is active, the link gets the value of its
 * activeClassName prop.
 *
 * For example, assuming you have the following route:
 *
 *   <Route path="/posts/:postID" component={Post} />
 *
 * You could use the following component to link to that route:
 *
 *   <Link to={`/posts/${post.id}`} />
 */
var Link = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'Link',

  mixins: [Object(__WEBPACK_IMPORTED_MODULE_5__ContextUtils__["b" /* ContextSubscriber */])('router')],

  contextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_4__PropTypes__["a" /* routerShape */]
  },

  propTypes: {
    to: Object(__WEBPACK_IMPORTED_MODULE_2_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_2_prop_types__["string"], __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"], __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"]]),
    activeStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"],
    activeClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"],
    onlyActiveOnIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types__["bool"].isRequired,
    onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"],
    target: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"]
  },

  getDefaultProps: function getDefaultProps() {
    return {
      onlyActiveOnIndex: false,
      style: {}
    };
  },
  handleClick: function handleClick(event) {
    if (this.props.onClick) this.props.onClick(event);

    if (event.defaultPrevented) return;

    var router = this.context.router;

    !router ?  false ? invariant(false, '<Link>s rendered outside of a router context cannot navigate.') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;

    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;

    // If target prop is set (e.g. to "_blank"), let browser handle link.
    /* istanbul ignore if: untestable with Karma */
    if (this.props.target) return;

    event.preventDefault();

    router.push(resolveToLocation(this.props.to, router));
  },
  render: function render() {
    var _props = this.props,
        to = _props.to,
        activeClassName = _props.activeClassName,
        activeStyle = _props.activeStyle,
        onlyActiveOnIndex = _props.onlyActiveOnIndex,
        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);

    // Ignore if rendered outside the context of router to simplify unit testing.


    var router = this.context.router;


    if (router) {
      // If user does not specify a `to` prop, return an empty anchor tag.
      if (!to) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', props);
      }

      var toLocation = resolveToLocation(to, router);
      props.href = router.createHref(toLocation);

      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
        if (router.isActive(toLocation, onlyActiveOnIndex)) {
          if (activeClassName) {
            if (props.className) {
              props.className += ' ' + activeClassName;
            } else {
              props.className = activeClassName;
            }
          }

          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
        }
      }
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RouteUtils__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PatternUtils__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(51);







/**
 * A <Redirect> is used to declare another URL path a client should
 * be sent to when they request a given URL.
 *
 * Redirects are placed alongside routes in the route configuration
 * and are traversed in the same manner.
 */
/* eslint-disable react/require-render-return */
var Redirect = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'Redirect',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element) {
      var route = Object(__WEBPACK_IMPORTED_MODULE_3__RouteUtils__["a" /* createRouteFromReactElement */])(element);

      if (route.from) route.path = route.from;

      route.onEnter = function (nextState, replace) {
        var location = nextState.location,
            params = nextState.params;


        var pathname = void 0;
        if (route.to.charAt(0) === '/') {
          pathname = Object(__WEBPACK_IMPORTED_MODULE_4__PatternUtils__["a" /* formatPattern */])(route.to, params);
        } else if (!route.to) {
          pathname = location.pathname;
        } else {
          var routeIndex = nextState.routes.indexOf(route);
          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
          pathname = Object(__WEBPACK_IMPORTED_MODULE_4__PatternUtils__["a" /* formatPattern */])(pattern, params);
        }

        replace({
          pathname: pathname,
          query: route.query || location.query,
          state: route.state || location.state
        });
      };

      return route;
    },
    getRoutePattern: function getRoutePattern(routes, routeIndex) {
      var parentPattern = '';

      for (var i = routeIndex; i >= 0; i--) {
        var route = routes[i];
        var pattern = route.path || '';

        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;

        if (pattern.indexOf('/') === 0) break;
      }

      return '/' + parentPattern;
    }
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
    from: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"], // Alias for path
    to: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"].isRequired,
    query: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    state: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    onEnter: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<Redirect> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createMemoryHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory__);




function createMemoryHistory(options) {
  // signatures and type checking differ between `useQueries` and
  // `createMemoryHistory`, have to create `memoryHistory` first because
  // `useQueries` doesn't understand the signature
  var memoryHistory = __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory___default()(options);
  var createHistory = function createHistory() {
    return memoryHistory;
  };
  var history = __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default()(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default()(createHistory))(options);
  return history;
}

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _queryString = __webpack_require__(362);

var _runTransitionHook = __webpack_require__(115);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _LocationUtils = __webpack_require__(44);

var _PathUtils = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStringifyQuery = function defaultStringifyQuery(query) {
  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
};

var defaultParseQueryString = _queryString.parse;

/**
 * Returns a new createHistory function that may be used to create
 * history objects that know how to handle URL queries.
 */
var useQueries = function useQueries(createHistory) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var history = createHistory(options);
    var stringifyQuery = options.stringifyQuery,
        parseQueryString = options.parseQueryString;


    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;

    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;

    var decodeQuery = function decodeQuery(location) {
      if (!location) return location;

      if (location.query == null) location.query = parseQueryString(location.search.substring(1));

      return location;
    };

    var encodeQuery = function encodeQuery(location, query) {
      if (query == null) return location;

      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
      var queryString = stringifyQuery(query);
      var search = queryString ? '?' + queryString : '';

      return _extends({}, object, {
        search: search
      });
    };

    // Override all read methods with query-aware versions.
    var getCurrentLocation = function getCurrentLocation() {
      return decodeQuery(history.getCurrentLocation());
    };

    var listenBefore = function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
      });
    };

    var listen = function listen(listener) {
      return history.listen(function (location) {
        return listener(decodeQuery(location));
      });
    };

    // Override all write methods with query-aware versions.
    var push = function push(location) {
      return history.push(encodeQuery(location, location.query));
    };

    var replace = function replace(location) {
      return history.replace(encodeQuery(location, location.query));
    };

    var createPath = function createPath(location) {
      return history.createPath(encodeQuery(location, location.query));
    };

    var createHref = function createHref(location) {
      return history.createHref(encodeQuery(location, location.query));
    };

    var createLocation = function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));

      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);

      return decodeQuery(newLocation);
    };

    return _extends({}, history, {
      getCurrentLocation: getCurrentLocation,
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation
    });
  };
};

exports.default = useQueries;

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _runTransitionHook = __webpack_require__(115);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _PathUtils = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useBasename = function useBasename(createHistory) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var history = createHistory(options);
    var basename = options.basename;


    var addBasename = function addBasename(location) {
      if (!location) return location;

      if (basename && location.basename == null) {
        if (location.pathname.toLowerCase().indexOf(basename.toLowerCase()) === 0) {
          location.pathname = location.pathname.substring(basename.length);
          location.basename = basename;

          if (location.pathname === '') location.pathname = '/';
        } else {
          location.basename = '';
        }
      }

      return location;
    };

    var prependBasename = function prependBasename(location) {
      if (!basename) return location;

      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
      var pname = object.pathname;
      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
      var pathname = normalizedBasename + normalizedPathname;

      return _extends({}, object, {
        pathname: pathname
      });
    };

    // Override all read methods with basename-aware versions.
    var getCurrentLocation = function getCurrentLocation() {
      return addBasename(history.getCurrentLocation());
    };

    var listenBefore = function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
      });
    };

    var listen = function listen(listener) {
      return history.listen(function (location) {
        return listener(addBasename(location));
      });
    };

    // Override all write methods with basename-aware versions.
    var push = function push(location) {
      return history.push(prependBasename(location));
    };

    var replace = function replace(location) {
      return history.replace(prependBasename(location));
    };

    var createPath = function createPath(location) {
      return history.createPath(prependBasename(location));
    };

    var createHref = function createHref(location) {
      return history.createHref(prependBasename(location));
    };

    var createLocation = function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
    };

    return _extends({}, history, {
      getCurrentLocation: getCurrentLocation,
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation
    });
  };
};

exports.default = useBasename;

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useRouterHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__);



function useRouterHistory(createHistory) {
  return function (options) {
    var history = __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default()(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default()(createHistory))(options);
    return history;
  };
}

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.readState = exports.saveState = undefined;

var _warning = __webpack_require__(28);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuotaExceededErrors = {
  QuotaExceededError: true,
  QUOTA_EXCEEDED_ERR: true
};

var SecurityErrors = {
  SecurityError: true
};

var KeyPrefix = '@@History/';

var createKey = function createKey(key) {
  return KeyPrefix + key;
};

var saveState = exports.saveState = function saveState(key, state) {
  if (!window.sessionStorage) {
    // Session storage is not available or hidden.
    // sessionStorage is undefined in Internet Explorer when served via file protocol.
     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;

    return;
  }

  try {
    if (state == null) {
      window.sessionStorage.removeItem(createKey(key));
    } else {
      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
    }
  } catch (error) {
    if (SecurityErrors[error.name]) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;

      return;
    }

    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
      // Safari "private mode" throws QuotaExceededError.
       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;

      return;
    }

    throw error;
  }
};

var readState = exports.readState = function readState(key) {
  var json = void 0;
  try {
    json = window.sessionStorage.getItem(createKey(key));
  } catch (error) {
    if (SecurityErrors[error.name]) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;

      return undefined;
    }
  }

  if (json) {
    try {
      return JSON.parse(json);
    } catch (error) {
      // Ignore invalid JSON.
    }
  }

  return undefined;
};

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createRouterHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__useRouterHistory__ = __webpack_require__(196);


var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

function createRouterHistory(createHistory) {
  var history = void 0;
  if (canUseDOM) history = Object(__WEBPACK_IMPORTED_MODULE_0__useRouterHistory__["a" /* default */])(createHistory)();
  return history;
}

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(33) && !__webpack_require__(47)(function () {
  return Object.defineProperty(__webpack_require__(200)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(36);
var document = __webpack_require__(31).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(37);
var toIObject = __webpack_require__(38);
var arrayIndexOf = __webpack_require__(379)(false);
var IE_PROTO = __webpack_require__(125)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(122);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(124);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(37);
var toObject = __webpack_require__(54);
var IE_PROTO = __webpack_require__(125)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(383), __esModule: true };

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(75);
var $export = __webpack_require__(25);
var redefine = __webpack_require__(207);
var hide = __webpack_require__(46);
var Iterators = __webpack_require__(55);
var $iterCreate = __webpack_require__(388);
var setToStringTag = __webpack_require__(131);
var getPrototypeOf = __webpack_require__(204);
var ITERATOR = __webpack_require__(23)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(46);


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(32);
var anObject = __webpack_require__(35);
var getKeys = __webpack_require__(53);

module.exports = __webpack_require__(33) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(390);
var global = __webpack_require__(31);
var hide = __webpack_require__(46);
var Iterators = __webpack_require__(55);
var TO_STRING_TAG = __webpack_require__(23)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(76)('meta');
var isObject = __webpack_require__(36);
var has = __webpack_require__(37);
var setDesc = __webpack_require__(32).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(47)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(201);
var hiddenKeys = __webpack_require__(127).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(416);
var ITERATOR = __webpack_require__(23)('iterator');
var Iterators = __webpack_require__(55);
module.exports = __webpack_require__(18).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);









var ContextTypes = {
  getAtlaskitAnalyticsContext: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};

var AnalyticsContext = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(AnalyticsContext, _Component);

  function AnalyticsContext() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, AnalyticsContext);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = AnalyticsContext.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(AnalyticsContext)).call.apply(_ref, [this].concat(args))), _this), _this.getChildContext = function () {
      return {
        getAtlaskitAnalyticsContext: _this.getAnalyticsContext
      };
    }, _this.getAnalyticsContext = function () {
      var data = _this.props.data;
      var getAtlaskitAnalyticsContext = _this.context.getAtlaskitAnalyticsContext;

      var ancestorData = typeof getAtlaskitAnalyticsContext === 'function' && getAtlaskitAnalyticsContext() || [];
      return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(ancestorData), [data]);
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(AnalyticsContext, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_6_react__["Children"].only(this.props.children);
    }
  }]);

  return AnalyticsContext;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

AnalyticsContext.contextTypes = ContextTypes;
AnalyticsContext.childContextTypes = ContextTypes;
/* harmony default export */ __webpack_exports__["a"] = (AnalyticsContext);

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withAnalyticsEvents;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__UIAnalyticsEvent__ = __webpack_require__(79);













// This component is used to grab the analytics functions off context.
// It uses legacy context, but provides an API similar to 16.3 context.
// This makes it easier to use with the forward ref API.
var AnalyticsContextConsumer = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(AnalyticsContextConsumer, _Component);

  function AnalyticsContextConsumer() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, AnalyticsContextConsumer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = AnalyticsContextConsumer.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(AnalyticsContextConsumer)).call.apply(_ref, [this].concat(args))), _this), _this.createAnalyticsEvent = function (payload) {
      var _this$context = _this.context,
          getAtlaskitAnalyticsEventHandlers = _this$context.getAtlaskitAnalyticsEventHandlers,
          getAtlaskitAnalyticsContext = _this$context.getAtlaskitAnalyticsContext;

      var context = typeof getAtlaskitAnalyticsContext === 'function' && getAtlaskitAnalyticsContext() || [];
      var handlers = typeof getAtlaskitAnalyticsEventHandlers === 'function' && getAtlaskitAnalyticsEventHandlers() || [];
      return new __WEBPACK_IMPORTED_MODULE_10__UIAnalyticsEvent__["a" /* default */]({ context: context, handlers: handlers, payload: payload });
    }, _temp), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(AnalyticsContextConsumer, [{
    key: 'render',
    value: function render() {
      return this.props.children(this.createAnalyticsEvent);
    }
  }]);

  return AnalyticsContextConsumer;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

// patch the callback so it provides analytics information.


AnalyticsContextConsumer.contextTypes = {
  getAtlaskitAnalyticsEventHandlers: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  getAtlaskitAnalyticsContext: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func
};
var modifyCallbackProp = function modifyCallbackProp(propName, eventMapEntry, props, createAnalyticsEvent) {
  return function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var event = typeof eventMapEntry === 'function' ? eventMapEntry(createAnalyticsEvent, props) : createAnalyticsEvent(eventMapEntry);
    var providedCallback = props[propName];
    if (providedCallback) {
      providedCallback.apply(undefined, args.concat([event]));
    }
  };
};

// helper that provides an easy way to map an object's values
// ({ string: A }, (string, A) => B) => { string: B }
var vmap = function vmap(obj, fn) {
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(obj).reduce(function (curr, k) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, curr, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, k, fn(k, obj[k])));
  }, {});
};

function withAnalyticsEvents() {
  var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function (WrappedComponent) {
    // $FlowFixMe - flow 0.67 doesn't know about forwardRef
    var WithAnalyticsEvents = __WEBPACK_IMPORTED_MODULE_8_react___default.a.forwardRef(function (props, ref) {
      return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
        AnalyticsContextConsumer,
        null,
        function (createAnalyticsEvent) {
          var modifiedProps = vmap(createEventMap, function (propName, entry) {
            return modifyCallbackProp(propName, entry, props, createAnalyticsEvent);
          });
          return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(WrappedComponent, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, props, modifiedProps, {
            createAnalyticsEvent: createAnalyticsEvent,
            ref: ref
          }));
        }
      );
    });

    WithAnalyticsEvents.displayName = 'WithAnalyticsEvents(' + (WrappedComponent.displayName || WrappedComponent.name) + ')';

    return WithAnalyticsEvents;
  };
}

/***/ }),
/* 215 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var sizes = exports.sizes = {
  small: '16px',
  medium: '24px',
  large: '32px',
  xlarge: '48px'
};

/***/ }),
/* 217 */
/***/ (function(module, exports) {

// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection

// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));

if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  module.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  module.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}


/***/ }),
/* 218 */
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
  return ([bth[buf[i++]], bth[buf[i++]], 
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]],
	bth[buf[i++]], bth[buf[i++]],
	bth[buf[i++]], bth[buf[i++]]]).join('');
}

module.exports = bytesToUuid;


/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTheme;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__types__);

/* eslint-disable no-nested-ternary */




var defaultTheme = { mode: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* DEFAULT_THEME_MODE */] };

function getTheme(props) {
  return props && props.theme && props.theme[__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CHANNEL */]] ? props.theme[__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CHANNEL */]] : defaultTheme;
}

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FLATTENED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANNEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_THEME_MODE; });
/* unused harmony export THEME_MODES */
var FLATTENED = '__FLATTENED__';
var CHANNEL = '__ATLASKIT_THEME__';
var DEFAULT_THEME_MODE = 'light';
var THEME_MODES = ['light', 'dark'];

/***/ }),
/* 221 */
/***/ (function(module, exports) {



/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTheme;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__types__);

/* eslint-disable no-nested-ternary */




var defaultTheme = { mode: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* DEFAULT_THEME_MODE */] };

function getTheme(props) {
  return props && props.theme && props.theme[__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CHANNEL */]] ? props.theme[__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CHANNEL */]] : defaultTheme;
}

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FLATTENED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANNEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_THEME_MODE; });
/* unused harmony export THEME_MODES */
var FLATTENED = '__FLATTENED__';
var CHANNEL = '__ATLASKIT_THEME__';
var DEFAULT_THEME_MODE = 'light';
var THEME_MODES = ['light', 'dark'];

/***/ }),
/* 224 */
/***/ (function(module, exports) {



/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;

var _propTypes = __webpack_require__(9);

var PropTypes = _interopRequireWildcard(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(27);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactLifecyclesCompat = __webpack_require__(226);

var _PropTypes = __webpack_require__(227);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UNMOUNTED = exports.UNMOUNTED = 'unmounted';
var EXITED = exports.EXITED = 'exited';
var ENTERING = exports.ENTERING = 'entering';
var ENTERED = exports.ENTERED = 'entered';
var EXITING = exports.EXITING = 'exiting';

/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the components.
 * It's up to you to give meaning and effect to those states. For example we can
 * add styles to a component when it enters or exits:
 *
 * ```jsx
 * import Transition from 'react-transition-group/Transition';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {(state) => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
 * What it does do is track transition states over time so you can update the
 * component (such as by adding styles or classes) when it changes states.
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component begins the
 * "Enter" stage. During this stage, the component will shift from its current transition state,
 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
 * it's complete. Let's take the following example:
 *
 * ```jsx
 * state = { in: false };
 *
 * toggleEnterState = () => {
 *   this.setState({ in: true });
 * }
 *
 * render() {
 *   return (
 *     <div>
 *       <Transition in={this.state.in} timeout={500} />
 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state and
 * stay there for 500ms (the value of `timeout`) before it finally switches to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
 *
 * ## Timing
 *
 * Timing is often the trickiest part of animation, mistakes can result in slight delays
 * that are hard to pin down. A common example is when you want to add an exit transition,
 * you should set the desired final styles when the state is `'exiting'`. That's when the
 * transition to those styles will start and, if you matched the `timeout` prop with the
 * CSS Transition duration, it will end exactly when the state changes to `'exited'`.
 *
 * > **Note**: For simpler transitions the `Transition` component might be enough, but
 * > take into account that it's platform-agnostic, while the `CSSTransition` component
 * > [forces reflows](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * > in order to make more complex transitions more predictable. For example, even though
 * > classes `example-enter` and `example-enter-active` are applied immediately one after
 * > another, you can still transition from one to the other because of the forced reflow
 * > (read [this issue](https://github.com/reactjs/react-transition-group/issues/159#issuecomment-322761171)
 * > for more info). Take this into account when choosing between `Transition` and
 * > `CSSTransition`.
 *
 * ## Example
 *
 * <iframe src="https://codesandbox.io/embed/741op4mmj0?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
 *
 */

var Transition = function (_React$Component) {
  _inherits(Transition, _React$Component);

  function Transition(props, context) {
    _classCallCheck(this, Transition);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    var parentGroup = context.transitionGroup;
    // In the context of a TransitionGroup all enters are really appears
    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;

    var initialStatus = void 0;

    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = { status: initialStatus };

    _this.nextCallback = null;
    return _this;
  }

  Transition.prototype.getChildContext = function getChildContext() {
    return { transitionGroup: null // allows for nested Transitions
    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return { status: EXITED };
    }
    return null;
  };

  // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null

  //   if (prevProps !== this.props) {
  //     const { status } = this.state

  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }

  //   return { nextStatus }
  // }

  Transition.prototype.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  Transition.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;
    if (prevProps !== this.props) {
      var status = this.state.status;


      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }
    this.updateStatus(false, nextStatus);
  };

  Transition.prototype.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  Transition.prototype.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;

    var exit = void 0,
        enter = void 0,
        appear = void 0;

    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter;
      appear = timeout.appear;
    }
    return { exit: exit, enter: enter, appear: appear };
  };

  Transition.prototype.updateStatus = function updateStatus() {
    var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var nextStatus = arguments[1];

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();
      var node = _reactDom2.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({ status: UNMOUNTED });
    }
  };

  Transition.prototype.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;

    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;

    var timeouts = this.getTimeouts();

    // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set
    if (!mounting && !enter) {
      this.safeSetState({ status: ENTERED }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);

    this.safeSetState({ status: ENTERING }, function () {
      _this2.props.onEntering(node, appearing);

      // FIXME: appear timeout?
      _this2.onTransitionEnd(node, timeouts.enter, function () {
        _this2.safeSetState({ status: ENTERED }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  Transition.prototype.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;

    var timeouts = this.getTimeouts();

    // no exit animation skip right to EXITED
    if (!exit) {
      this.safeSetState({ status: EXITED }, function () {
        _this3.props.onExited(node);
      });
      return;
    }
    this.props.onExit(node);

    this.safeSetState({ status: EXITING }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({ status: EXITED }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  Transition.prototype.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  Transition.prototype.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;

        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  Transition.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);

    if (node) {
      if (this.props.addEndListener) {
        this.props.addEndListener(node, this.nextCallback);
      }
      if (timeout != null) {
        setTimeout(this.nextCallback, timeout);
      }
    } else {
      setTimeout(this.nextCallback, 0);
    }
  };

  Transition.prototype.render = function render() {
    var status = this.state.status;
    if (status === UNMOUNTED) {
      return null;
    }

    var _props = this.props,
        children = _props.children,
        childProps = _objectWithoutProperties(_props, ['children']);
    // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react2.default.Children.only(children);
    return _react2.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react2.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};


Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element.
   * This function is called with the current transition status
   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can be used
   * to apply context specific props to a component.
   *
   * ```jsx
   * <Transition timeout={150}>
   *   {(status) => (
   *     <MyComponent className={`fade fade-${status}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided
   *
   * You may specify a single timeout for all transitions like: `timeout={500}`,
   * or individually like:
   *
   * ```jsx
   * timeout={{
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * @type {number | { enter?: number, exit?: number }}
   */
  timeout: function timeout(props) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;
    return pt.apply(undefined, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func

  // Name the function so it is clearer in the documentation
} : {};function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,

  onEnter: noop,
  onEntering: noop,
  onEntered: noop,

  onExit: noop,
  onExiting: noop,
  onExited: noop
};

Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

exports.default = (0, _reactLifecyclesCompat.polyfill)(Transition);

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var timeoutsShape = exports.timeoutsShape = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
  enter: _propTypes2.default.number,
  exit: _propTypes2.default.number
}).isRequired]);

var classNamesShape = exports.classNamesShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterDone: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  exitDone: _propTypes2.default.string,
  exitActive: _propTypes2.default.string
})]);

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Portal__ = __webpack_require__(476);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Portal__["a"]; });


/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PortalWithThemeProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_transition_group__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_transition_group__);










var FirstChild = function FirstChild(_ref) {
  var children = _ref.children;
  return __WEBPACK_IMPORTED_MODULE_5_react__["Children"].toArray(children)[0] || null;
};

var Portal = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Portal, _Component);

  function Portal() {
    var _ref2;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Portal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref2 = Portal.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Portal)).call.apply(_ref2, [this].concat(args))), _this), _this.portalElement = null, _this.mountTimeout = null, _this.renderChildren = function (children) {
      var _this$props = _this.props,
          theme = _this$props.theme,
          withTransitionGroup = _this$props.withTransitionGroup;


      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_styled_components__["ThemeProvider"],
        { theme: theme },
        withTransitionGroup ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_transition_group__["TransitionGroup"],
          { component: FirstChild },
          children
        ) : children
      );
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Portal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var node = document.createElement('span');
      if (document.body) {
        document.body.appendChild(node);
        this.portalElement = node;

        // mounting components in portals can have side effects (e.g. modals
        // applying scroll / focus locks). Because the unmounting of other portals
        // happens asynchronously, we wait for a moment before mounting new
        // portals to avoid race conditions in unmount handlers
        this.mountTimeout = setTimeout(function () {
          return _this2.componentDidUpdate();
        }, 1);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var children = this.props.children;

      if (this.portalElement) {
        var portal = this.portalElement;
        Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["render"])(this.renderChildren(children), portal);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // re-render an empty react tree into the portal element so that any
      // mounted components get cleaned up and have a chance to complete their
      // lifecycle before the portal is removed from the dom entirely
      if (this.mountTimeout) {
        clearTimeout(this.mountTimeout);
      }
      if (this.portalElement) {
        var portal = this.portalElement;
        Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["render"])(this.renderChildren(), portal, function () {
          // allow time for transitions to complete before the dom is cleaned up
          // five seconds is an arbitary number, but is more than any of our
          // animations need to complete
          setTimeout(function () {
            var target = document.body;
            if (!target) return;
            Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["unmountComponentAtNode"])(portal);
            target.removeChild(portal);
          }, 5000);
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return Portal;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

// Pass theme through to be consumed
// TODO: @thejameskyle - Fix Styled Components for Flow 53+


var PortalWithTheme = Object(__WEBPACK_IMPORTED_MODULE_7_styled_components__["withTheme"])(Portal);

// Wrap the default export in a ThemeProvider component so that withTheme
// doesn't freak out if the app doesn't have one already
function PortalWithThemeProvider(props) {
  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_7_styled_components__["ThemeProvider"],
    { theme: {} },
    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(PortalWithTheme, props)
  );
}

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.focusOn = undefined;

var _focusMerge = __webpack_require__(147);

var _focusMerge2 = _interopRequireDefault(_focusMerge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusOn = exports.focusOn = function focusOn(target) {
  target.focus();
  if (target.contentWindow) {
    target.contentWindow.focus();
  }
};

exports.default = function (topNode, lastNode) {
  var focusable = (0, _focusMerge2.default)(topNode, lastNode);

  if (focusable) {
    focusOn(focusable.node);
  }
};

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.orderByTabIndex = exports.tabSort = undefined;

var _array = __webpack_require__(58);

var tabSort = exports.tabSort = function tabSort(a, b) {
  var tabDiff = a.tabIndex - b.tabIndex;
  var indexDiff = a.index - b.index;

  if (tabDiff) {
    if (!a.tabIndex) return 1;
    if (!b.tabIndex) return -1;
  }

  return tabDiff || indexDiff;
};

var orderByTabIndex = exports.orderByTabIndex = function orderByTabIndex(nodes) {
  return (0, _array.toArray)(nodes).map(function (node, index) {
    return {
      node: node,
      index: index,
      tabIndex: node.tabIndex
    };
  }).filter(function (data) {
    return data.tabIndex >= 0;
  }).sort(tabSort);
};

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getParentAutofocusables = exports.getFocusables = undefined;

var _tabbables = __webpack_require__(494);

var _tabbables2 = _interopRequireDefault(_tabbables);

var _array = __webpack_require__(58);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getFocusables = exports.getFocusables = function getFocusables(parents) {
  return parents.reduce(function (acc, parent) {
    return acc.concat((0, _array.toArray)(parent.querySelectorAll(_tabbables2.default.join(','))));
  }, []);
};

var getParentAutofocusables = exports.getParentAutofocusables = function getParentAutofocusables(parent) {
  var parentFocus = parent.querySelectorAll('[data-autofocus-inside]');
  return (0, _array.toArray)(parentFocus).map(function (node) {
    return getFocusables([node]);
  }).reduce(function (acc, nodes) {
    return acc.concat(nodes);
  }, []);
};

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var FOCUS_GROUP = 'data-focus-lock';
var FOCUS_DISABLED = 'data-focus-lock-disabled';

exports.FOCUS_DISABLED = FOCUS_DISABLED;
exports.FOCUS_GROUP = FOCUS_GROUP;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(setImmediate) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deferAction = deferAction;
function deferAction(action) {
  if (typeof setImmediate !== 'undefined') {
    setImmediate(action);
  } else {
    setTimeout(action, 1);
  }
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(500).setImmediate))

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Blanket__ = __webpack_require__(507);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Blanket__["a"]; });


/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AtlasKitThemeProvider */
/* unused harmony export borderRadius */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return gridSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fontSize; });
/* unused harmony export fontFamily */
/* unused harmony export codeFontFamily */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return layers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elevation__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__typography__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_math__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_getTheme__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_themed__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AtlaskitThemeProvider__ = __webpack_require__(513);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__colors__; });
/* unused harmony reexport elevation */
/* unused harmony reexport typography */
/* unused harmony reexport math */
/* unused harmony reexport getTheme */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_5__utils_themed__["a"]; });
/* unused harmony reexport AtlaskitThemeProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Appearance__ = __webpack_require__(514);
/* unused harmony reexport Appearance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Context__ = __webpack_require__(86);
/* unused harmony reexport Consumer */
/* unused harmony reexport Provider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Reset__ = __webpack_require__(515);
/* unused harmony reexport Reset */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Theme__ = __webpack_require__(516);
/* unused harmony reexport Theme */











// backwards-compatible export with old Atlaskit case
var AtlasKitThemeProvider = __WEBPACK_IMPORTED_MODULE_6__components_AtlaskitThemeProvider__["a" /* default */];

/*
  These theme values are expressed as functions so that if we decide to make
  them dependent on props in the future, it wouldn't require a significant
  refactor everywhere they are being used.
*/
var borderRadius = function borderRadius() {
  return 3;
};
var gridSize = function gridSize() {
  return 8;
};
var fontSize = function fontSize() {
  return 14;
};
var fontFamily = function fontFamily() {
  return '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif';
};
var codeFontFamily = function codeFontFamily() {
  return '"SFMono-Medium", "SF Mono", "Segoe UI Mono", "Roboto Mono", "Ubuntu Mono", Menlo, Consolas, Courier, monospace';
};

var layers = {
  card: function card() {
    return 100;
  },
  dialog: function dialog() {
    return 200;
  },
  navigation: function navigation() {
    return 300;
  },
  layer: function layer() {
    return 400;
  },
  blanket: function blanket() {
    return 500;
  },
  modal: function modal() {
    return 510;
  },
  flag: function flag() {
    return 600;
  },
  spotlight: function spotlight() {
    return 700;
  },
  tooltip: function tooltip() {
    return 800;
  }
};

// New API




/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTheme;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__types__);

/* eslint-disable no-nested-ternary */




var defaultTheme = { mode: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* DEFAULT_THEME_MODE */] };

function getTheme(props) {
  return props && props.theme && props.theme[__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CHANNEL */]] ? props.theme[__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CHANNEL */]] : defaultTheme;
}

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FLATTENED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANNEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_THEME_MODE; });
/* unused harmony export THEME_MODES */
var FLATTENED = '__FLATTENED__';
var CHANNEL = '__ATLASKIT_THEME__';
var DEFAULT_THEME_MODE = 'light';
var THEME_MODES = ['light', 'dark'];

/***/ }),
/* 239 */
/***/ (function(module, exports) {



/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTheme;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__types__);

/* eslint-disable no-nested-ternary */




var defaultTheme = { mode: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* DEFAULT_THEME_MODE */] };

function getTheme(props) {
  return props && props.theme && props.theme[__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CHANNEL */]] ? props.theme[__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CHANNEL */]] : defaultTheme;
}

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FLATTENED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANNEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_THEME_MODE; });
/* unused harmony export THEME_MODES */
var FLATTENED = '__FLATTENED__';
var CHANNEL = '__ATLASKIT_THEME__';
var DEFAULT_THEME_MODE = 'light';
var THEME_MODES = ['light', 'dark'];

/***/ }),
/* 242 */
/***/ (function(module, exports) {



/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IEMaxHeightCalcPx; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return flexMaxHeightIEFix; });

/* Used to adjust flex parent height to account for the subtraction in children below */
var IEMaxHeightCalcPx = 1;

/* A bug exists in IE where flex column children overflow the height of their parents.
 * The workaround is to set a pixel max-height on the flex children.
 * For more information see https://github.com/philipwalton/flexbugs/issues/216
 */
var flexMaxHeightIEFix = "\n  max-height: calc(100% - " + IEMaxHeightCalcPx + "px);\n";

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultProps */
/* unused harmony export ButtonBase */
/* unused harmony export ButtonWithoutAnalytics */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__atlaskit_analytics_next__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__package_json__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__withDeprecationWarnings__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__getButtonProps__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CustomComponentProxy__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styled_getButtonStyles__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styled_ButtonContent__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styled_ButtonWrapper__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styled_IconWrapper__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styled_LoadingSpinner__ = __webpack_require__(544);








var _templateObject = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ';\n'], ['\n  ', ';\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  a& {\n    ', ';\n  }\n'], ['\n  a& {\n    ', ';\n  }\n']),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral___default()(['&,a&,&:hover,&:active,&:focus{', '}'], ['&,a&,&:hover,&:active,&:focus{', '}']);














var StyledButton = __WEBPACK_IMPORTED_MODULE_8_styled_components__["default"].button(_templateObject, __WEBPACK_IMPORTED_MODULE_14__styled_getButtonStyles__["a" /* default */]);
StyledButton.displayName = 'StyledButton';

// Target the <a> here to override a:hover specificity.
var StyledLink = __WEBPACK_IMPORTED_MODULE_8_styled_components__["default"].a(_templateObject2, __WEBPACK_IMPORTED_MODULE_14__styled_getButtonStyles__["a" /* default */]);
StyledLink.displayName = 'StyledLink';

var StyledSpan = __WEBPACK_IMPORTED_MODULE_8_styled_components__["default"].span(_templateObject, __WEBPACK_IMPORTED_MODULE_14__styled_getButtonStyles__["a" /* default */]);
StyledSpan.displayName = 'StyledSpan';

var createStyledComponent = function createStyledComponent() {
  // Override pseudo-state specificity.
  // This is necessary because we don't know what DOM element the custom component will render.
  var component = Object(__WEBPACK_IMPORTED_MODULE_8_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_13__CustomComponentProxy__["a" /* default */])(_templateObject3, __WEBPACK_IMPORTED_MODULE_14__styled_getButtonStyles__["a" /* default */]);
  component.displayName = 'StyledCustomComponent';
  return component;
};

var defaultProps = {
  appearance: 'default',
  isDisabled: false,
  isSelected: false,
  isLoading: false,
  spacing: 'default',
  type: 'button',
  shouldFitContainer: false,
  autoFocus: false
};

var Button = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Button, _Component);

  function Button() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Button);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Button.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Button)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isActive: false,
      isFocus: false,
      isHover: false
    }, _this.customComponent = null, _this.isInteractive = function () {
      return !_this.props.isDisabled && !_this.props.isLoading;
    }, _this.onMouseEnter = function () {
      _this.setState({ isHover: true });
    }, _this.onMouseLeave = function () {
      return _this.setState({ isHover: false, isActive: false });
    }, _this.onMouseDown = function (e) {
      e.preventDefault();
      _this.setState({ isActive: true });
    }, _this.onMouseUp = function () {
      return _this.setState({ isActive: false });
    }, _this.onFocus = function (event) {
      _this.setState({ isFocus: true });
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
    }, _this.onBlur = function (event) {
      _this.setState({ isFocus: false });
      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
    }, _this.onInnerClick = function (e) {
      if (!_this.isInteractive()) {
        e.stopPropagation();
      }
      return true;
    }, _this.getInnerRef = function (ref) {
      _this.button = ref;

      if (_this.props.innerRef) _this.props.innerRef(ref);
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Button, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.component !== nextProps.component) {
        delete this.customComponent;
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.autoFocus && this.button) {
        this.button.focus();
      }
    }

    /* Swallow click events when the button is disabled to prevent inner child clicks bubbling up */

  }, {
    key: 'getStyledComponent',
    value: function getStyledComponent() {
      if (this.props.component) {
        if (!this.customComponent) {
          this.customComponent = createStyledComponent();
        }
        return this.customComponent;
      }

      if (this.props.href) {
        return this.props.isDisabled ? StyledSpan : StyledLink;
      }

      return StyledButton;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          iconBefore = _props.iconBefore,
          iconAfter = _props.iconAfter,
          isLoading = _props.isLoading,
          shouldFitContainer = _props.shouldFitContainer,
          spacing = _props.spacing,
          appearance = _props.appearance,
          isSelected = _props.isSelected,
          isDisabled = _props.isDisabled;
      // $FlowFixMe - Cannot call `getButtonProps` with `this` bound to `component` because `Button` [1] is incompatible with `Button` [2].

      var buttonProps = Object(__WEBPACK_IMPORTED_MODULE_12__getButtonProps__["a" /* default */])(this);
      var StyledComponent = this.getStyledComponent();

      var iconIsOnlyChild = !!(iconBefore && !iconAfter && !children || iconAfter && !iconBefore && !children);
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        StyledComponent,
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ innerRef: this.getInnerRef }, buttonProps),
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_16__styled_ButtonWrapper__["a" /* default */],
          { onClick: this.onInnerClick, fit: !!shouldFitContainer },
          isLoading ? __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__styled_LoadingSpinner__["a" /* default */], {
            spacing: spacing,
            appearance: appearance,
            isSelected: isSelected,
            isDisabled: isDisabled
          }) : null,
          iconBefore ? __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_17__styled_IconWrapper__["a" /* default */],
            {
              isLoading: isLoading,
              spacing: buttonProps.spacing,
              isOnlyChild: iconIsOnlyChild
            },
            iconBefore
          ) : null,
          children ? __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_15__styled_ButtonContent__["a" /* default */],
            {
              isLoading: isLoading,
              followsIcon: !!iconBefore,
              spacing: buttonProps.spacing
            },
            children
          ) : null,
          iconAfter ? __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_17__styled_IconWrapper__["a" /* default */],
            {
              isLoading: isLoading,
              spacing: buttonProps.spacing,
              isOnlyChild: iconIsOnlyChild
            },
            iconAfter
          ) : null
        )
      );
    }
  }]);

  return Button;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

Button.defaultProps = defaultProps;

var ButtonBase = Button;

var ButtonWithoutAnalytics = Object(__WEBPACK_IMPORTED_MODULE_11__withDeprecationWarnings__["a" /* default */])(Button);
var createAndFireEventOnAtlaskit = Object(__WEBPACK_IMPORTED_MODULE_9__atlaskit_analytics_next__["b" /* createAndFireEvent */])('atlaskit');

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__atlaskit_analytics_next__["c" /* withAnalyticsContext */])({
  componentName: 'button',
  packageName: __WEBPACK_IMPORTED_MODULE_10__package_json__["name"],
  packageVersion: __WEBPACK_IMPORTED_MODULE_10__package_json__["version"]
})(Object(__WEBPACK_IMPORTED_MODULE_9__atlaskit_analytics_next__["d" /* withAnalyticsEvents */])({
  onClick: createAndFireEventOnAtlaskit({
    action: 'clicked',
    actionSubject: 'button',

    attributes: {
      componentName: 'button',
      packageName: __WEBPACK_IMPORTED_MODULE_10__package_json__["name"],
      packageVersion: __WEBPACK_IMPORTED_MODULE_10__package_json__["version"]
    }
  })
})(ButtonWithoutAnalytics)));

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withDeprecationWarnings;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);








var getComponentName = function getComponentName(target) {
  if (target.displayName && typeof target.displayName === 'string') {
    return target.displayName;
  }

  return target.name || 'Component';
};

var warnIfDeprecatedAppearance = function warnIfDeprecatedAppearance(appearance) {
  var deprecatedAppearances = ['help'];
  if (appearance && deprecatedAppearances.includes(appearance)) {
    // eslint-disable-next-line no-console
    console.warn('Atlaskit: The Button appearance "' + appearance + '" is deprecated. Please use styled-components\' ThemeProvider to provide a custom theme for Button instead.');
  }
};

function withDeprecationWarnings(WrappedComponent) {
  var _class, _temp;

  return _temp = _class = function (_Component) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(WithDeprecationWarnings, _Component);

    function WithDeprecationWarnings() {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, WithDeprecationWarnings);

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (WithDeprecationWarnings.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(WithDeprecationWarnings)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(WithDeprecationWarnings, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        warnIfDeprecatedAppearance(this.props.appearance);
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(newProps) {
        if (newProps.appearance !== this.props.appearance) {
          warnIfDeprecatedAppearance(newProps.appearance);
        }
      }
    }, {
      key: 'render',
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(WrappedComponent, this.props);
      }
    }]);

    return WithDeprecationWarnings;
  }(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]), _class.displayName = 'WithDeprecationWarnings(' + getComponentName(WrappedComponent) + ')', _temp;
}

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTheme;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__types__);

/* eslint-disable no-nested-ternary */




var defaultTheme = { mode: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* DEFAULT_THEME_MODE */] };

function getTheme(props) {
  return props && props.theme && props.theme[__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CHANNEL */]] ? props.theme[__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CHANNEL */]] : defaultTheme;
}

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FLATTENED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANNEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_THEME_MODE; });
/* unused harmony export THEME_MODES */
var FLATTENED = '__FLATTENED__';
var CHANNEL = '__ATLASKIT_THEME__';
var DEFAULT_THEME_MODE = 'light';
var THEME_MODES = ['light', 'dark'];

/***/ }),
/* 248 */
/***/ (function(module, exports) {



/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return themeNamespace; });
var themeNamespace = '@atlaskit-shared-theme/button';

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isLoadingStyle */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLoadingStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  transition: opacity 0.3s;\n  opacity: ', ';\n'], ['\n  transition: opacity 0.3s;\n  opacity: ', ';\n']);



var isLoadingStyle = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject, function (_ref) {
  var isLoading = _ref.isLoading;
  return isLoading ? 0 : 1;
});

var getLoadingStyle = function getLoadingStyle(_ref2) {
  var isLoading = _ref2.isLoading;
  return {
    transition: 'opacity 0.3s',
    opacity: isLoading ? 0 : 1
  };
};



/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Spinner__ = __webpack_require__(545);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Spinner__["a"]; });


/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SIZES_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_SIZE; });
var SIZES_MAP = {
  xsmall: 8,
  small: 16,
  medium: 24,
  large: 48,
  xlarge: 96
};
var DEFAULT_SIZE = SIZES_MAP.small;

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AtlasKitThemeProvider */
/* unused harmony export borderRadius */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return gridSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fontSize; });
/* unused harmony export fontFamily */
/* unused harmony export codeFontFamily */
/* unused harmony export layers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elevation__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__typography__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_math__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_getTheme__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_themed__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AtlaskitThemeProvider__ = __webpack_require__(551);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__colors__; });
/* unused harmony reexport elevation */
/* unused harmony reexport typography */
/* unused harmony reexport math */
/* unused harmony reexport getTheme */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__utils_themed__["a"]; });
/* unused harmony reexport AtlaskitThemeProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Appearance__ = __webpack_require__(552);
/* unused harmony reexport Appearance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Context__ = __webpack_require__(89);
/* unused harmony reexport Consumer */
/* unused harmony reexport Provider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Reset__ = __webpack_require__(553);
/* unused harmony reexport Reset */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Theme__ = __webpack_require__(554);
/* unused harmony reexport Theme */











// backwards-compatible export with old Atlaskit case
var AtlasKitThemeProvider = __WEBPACK_IMPORTED_MODULE_6__components_AtlaskitThemeProvider__["a" /* default */];

/*
  These theme values are expressed as functions so that if we decide to make
  them dependent on props in the future, it wouldn't require a significant
  refactor everywhere they are being used.
*/
var borderRadius = function borderRadius() {
  return 3;
};
var gridSize = function gridSize() {
  return 8;
};
var fontSize = function fontSize() {
  return 14;
};
var fontFamily = function fontFamily() {
  return '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif';
};
var codeFontFamily = function codeFontFamily() {
  return '"SFMono-Medium", "SF Mono", "Segoe UI Mono", "Roboto Mono", "Ubuntu Mono", Menlo, Consolas, Courier, monospace';
};

var layers = {
  card: function card() {
    return 100;
  },
  dialog: function dialog() {
    return 200;
  },
  navigation: function navigation() {
    return 300;
  },
  layer: function layer() {
    return 400;
  },
  blanket: function blanket() {
    return 500;
  },
  modal: function modal() {
    return 510;
  },
  flag: function flag() {
    return 600;
  },
  spotlight: function spotlight() {
    return 700;
  },
  tooltip: function tooltip() {
    return 800;
  }
};

// New API




/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTheme;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__types__);

/* eslint-disable no-nested-ternary */




var defaultTheme = { mode: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* DEFAULT_THEME_MODE */] };

function getTheme(props) {
  return props && props.theme && props.theme[__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CHANNEL */]] ? props.theme[__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CHANNEL */]] : defaultTheme;
}

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FLATTENED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANNEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_THEME_MODE; });
/* unused harmony export THEME_MODES */
var FLATTENED = '__FLATTENED__';
var CHANNEL = '__ATLASKIT_THEME__';
var DEFAULT_THEME_MODE = 'light';
var THEME_MODES = ['light', 'dark'];

/***/ }),
/* 256 */
/***/ (function(module, exports) {



/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Page__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Grid__ = __webpack_require__(561);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__Grid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GridColumn__ = __webpack_require__(563);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__GridColumn__["a"]; });


/* harmony default export */ __webpack_exports__["c"] = (__WEBPACK_IMPORTED_MODULE_0__Page__["a" /* default */]);



/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTheme;
// ideally this would be fetched from ../constants but that causes a
// circular dep loop. This will be refactored as part of a breaking
// change in the future.
var DEFAULT_THEME_MODE = 'light';
var THEME_MODES = ['light', 'dark']; // Resolves the different types of theme objects in the current API

function getTheme(props) {
  if (props && props.theme) {
    // Theme is the global Atlaskit theme
    if ('__ATLASKIT_THEME__' in props.theme) {
      return props.theme.__ATLASKIT_THEME__;
    } // User has provided alternative modes
    else if ('mode' in props.theme && THEME_MODES.includes(props.theme.mode)) {
        return props.theme;
      }
  } // If format not supported (or no theme provided), return standard theme


  return {
    mode: DEFAULT_THEME_MODE
  };
}

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function fromHex(r,e,n){var t=r.conversions,o=r.operations,s=r.helpers;n=n.replace("#","").match(/.{2}/g);for(var a=0;a<n.length;a++)n[a]=parseInt(n[a],16);switch(e){case"rgb":return{r:n[0],g:n[1],b:n[2]};default:return o.convert({conversions:t,operations:o,helpers:s},e,{r:n[0],g:n[1],b:n[2]})}}function fromRgb(r,e,n){var t=r.conversions,o=r.operations,s=r.helpers;switch(e){case"hex":return 1==(g=Math.round(n.r).toString(16)).length&&(g="0"+g),1==(y=Math.round(n.g).toString(16)).length&&(y="0"+y),1==(_=Math.round(n.b).toString(16)).length&&(_="0"+_),"#"+g+y+_;case"cssrgb":return"rgb("+Math.round(n.r)+","+Math.round(n.g)+","+Math.round(n.b)+")";case"hsl":var a=[g=n.r/255,y=n.g/255,_=n.b/255].sort(),i=(a[0]+a[2])/2*100;return a[0]==a[2]?(b=0,d=0):(b=i>=50?(a[2]-a[0])/(2-a[2]-a[0])*100:(a[2]-a[0])/(a[2]+a[0])*100,(d=a[2]==g?(y-_)/(a[2]-a[0])*60:a[2]==y?60*(2+(_-g)/(a[2]-a[0])):60*(4+(g-y)/(a[2]-a[0])))<0?d+=360:d>360&&(d%=360)),{h:d,s:b,l:i};case"csshsl":var c=o.convert({conversions:t,helpers:s},"hsl",n);return"hsl("+Math.round(c.h)+","+Math.round(c.s)+"%,"+Math.round(c.l)+"%)";case"cmyk":var u=n.r/255,l=n.g/255,h=n.b/255,v=1-Math.max(u,l,h);if(1!=v)var p=(1-u-v)/(1-v),f=(1-l-v)/(1-v),m=(1-h-v)/(1-v);else var p=0,f=0,m=0;return{c:p,m:f,y:m,k:v};case"hsv":var d,b,g=n.r/255,y=n.g/255,_=n.b/255,M=Math.min(g,y,_),Y=Math.max(g,y,_),L=Y-M,X=Y;if(0==L)d=0,b=0;else{b=L/Y;var Z=((Y-g)/6+L/2)/L,R=((Y-y)/6+L/2)/L,w=((Y-_)/6+L/2)/L;g==Y?d=w-R:y==Y?d=1/3+Z-w:_==Y&&(d=2/3+R-Z),d<0&&(d+=1),d>1&&(d-=1)}return{h:360*d,s:100*b,v:100*X};case"yiq":var m=n.r/255*.299+n.g/255*.587+n.b/255*.114,C=n.r/255*.596+n.g/255*-.274+n.b/255*-.322,x=n.r/255*.211+n.g/255*-.523+n.b/255*.312;return C=s.bounded(C,[-.5957,.5957]),x=s.bounded(x,[-.5226,.5226]),{y:m,i:C,q:x};case"XYZ":var A=[n.r,n.g,n.b].map(function(r){return r/255}).map(function(r){return r<=.04045?r/12.92:Math.pow((r+.055)/1.055,2.4)}),S=s.getTransform("SRGB_XYZ").map(function(r){return A.reduce(function(e,n,t){return r[t]*n+e},0)}).map(function(r){return 100*r}),O=slicedToArray(S,3);return{X:O[0],Y:O[1],Z:O[2]};case"lms":case"cielab":case"cieluv":case"xyY":var I=o.convert({conversions:t,operations:o,helpers:s},"XYZ",n);return o.convert({conversions:t,operations:o,helpers:s},e,I);case"cielch":var j=o.convert({conversions:t,operations:o,helpers:s},"cieluv",n);return o.convert({conversions:t,operations:o,helpers:s},e,j);case"hsluv":var D=o.convert({conversions:t,operations:o,helpers:s},"cielch",n);return o.convert({conversions:t,operations:o,helpers:s},e,D)}}function fromCssRgb(r,e,n){var t=r.conversions,o=r.operations,s=r.helpers;n=n.replace(/((rgb\(|\))|[\s]*)/g,"").split(",");for(var a=0;a<n.length;a++)n[a]=parseInt(n[a]);switch(e){case"rgb":return{r:n[0],g:n[1],b:n[2]};default:return o.convert({conversions:t,operations:o,helpers:s},e,{r:n[0],g:n[1],b:n[2]})}}function fromHsl(r,e,n){var t=r.conversions,o=r.operations,s=r.helpers;switch(e){case"rgb":if(0==n.s){var a=n.l/100*255;return{r:a,g:a,b:a}}var i,c,u;i=n.l>=50?n.l/100+n.s/100-n.l/100*(n.s/100):n.l/100*(1+n.s/100),c=n.l/100*2-i;var l,h,v,p=((u=n.h/360)+.333)%1,f=u,m=s.negMod(u-.333,1);return l=6*p<1?c+6*(i-c)*p:2*p<1?i:3*p<2?c+6*(.666-p)*(i-c):c,h=6*f<1?c+6*(i-c)*f:2*f<1?i:3*f<2?c+6*(.666-f)*(i-c):c,v=6*m<1?c+6*(i-c)*m:2*m<1?i:3*m<2?c+6*(.666-m)*(i-c):c,l<0&&(l=0),h<0&&(h=0),v<0&&(v=0),{r:255*l,g:255*h,b:255*v};case"csshsl":return"hsl("+Math.round(n.h)+","+Math.round(n.s)+"%,"+Math.round(n.l)+"%)";case"hsv":n.s=n.s/100,n.l=n.l/100;var d=n.s*(n.l<.5?n.l:1-n.l);return{h:n.h,s:100*(2*d/(n.l+d)),v:100*(n.l+d)};default:var b=o.convert({conversions:t,operations:o,helpers:s},"rgb",n);return o.convert({conversions:t,operations:o,helpers:s},e,b)}}function fromCssHsl(r,e,n){var t=r.conversions,o=r.operations,s=r.helpers;n=n.replace(/(hsl\(|\)|%|[\s]*)/g,"").split(",");for(var a=0;a<n.length;a++)n[a]=parseInt(n[a]);switch(e){case"hsl":return{h:n[0],s:n[1],l:n[2]};default:return o.convert({conversions:t,operations:o,helpers:s},e,{h:n[0],s:n[1],l:n[2]})}}function fromHsv(r,e,n){var t=r.conversions,o=r.operations,s=r.helpers;switch(e){case"rgb":var a,i,c;n.h=n.h/360,n.s=n.s/100,n.v=n.v/100;var u=6*n.h;6==u&&(u=0);var l,h,v,p=Math.round(u),f=n.v*(1-n.s),m=n.v*(1-n.s*(u-p)),d=n.v*(1-n.s*(1-(u-p)));return 0==p?(l=n.v,h=d,v=f):1==p?(l=m,h=n.v,v=f):2==p?(l=f,h=n.v,v=d):3==p?(l=f,h=m,v=n.v):4==p?(l=d,h=f,v=n.v):(l=n.v,h=f,v=m),a=255*l,i=255*h,c=255*v,{r:a,g:i,b:c};case"hsl":n.h=n.h/360,n.s=n.s/100,n.v=n.v/100;return{h:360*n.h,s:100*((2-n.s)*n.v<1?n.s*n.v/((2-n.s)*n.v):n.s*n.v/(2-(2-n.s)*n.v)),l:100*((2-n.s)*n.v/2)};default:var b=o.convert({conversions:t,operations:o,helpers:s},"rgb",n);return o.convert({conversions:t,operations:o,helpers:s},e,b)}}function fromCmyk(r,e,n){var t=r.conversions,o=r.operations,s=r.helpers;switch(e){case"rgb":return{r:a=255*(1-n.c)*(1-n.k),g:i=255*(1-n.m)*(1-n.k),b:c=255*(1-n.y)*(1-n.k)};case"cssrgb":var a=255*(1-n.c)*(1-n.k),i=255*(1-n.m)*(1-n.k),c=255*(1-n.y)*(1-n.k);return"rgb("+Math.round(a)+","+Math.round(i)+","+Math.round(c)+")";default:var u=o.convert({conversions:t,operations:o,helpers:s},"rgb",n);return o.convert({conversions:t,operations:o,helpers:s},e,u)}}function fromYiq(r,e,n){var t=r.conversions,o=r.operations,s=r.helpers;switch(n.i=s.bounded(n.i,[-.5957,.5957]),n.q=s.bounded(n.q,[-.5226,.5226]),e){case"rgb":var a=255*(n.y+.956*n.i+.621*n.q),i=255*(n.y+-.272*n.i+-.647*n.q),c=255*(n.y+-1.106*n.i+-1.703*n.q);return a=s.bounded(a,[0,255]),i=s.bounded(i,[0,255]),c=s.bounded(c,[0,255]),{r:a,g:i,b:c};default:var u=o.convert({conversions:t,operations:o,helpers:s},"rgb",n);return o.convert({conversions:t,operations:o,helpers:s},e,u)}}function fromXYZ(r,e,n){var t=r.conversions,o=r.operations,s=r.helpers,a=s.getIlluminant("D65");switch(e){case"rgb":var i=[n.X,n.Y,n.Z].map(function(r){return r/100}),c=s.getTransform("INVERSE_SRGB_XYZ").map(function(r){return i.reduce(function(e,n,t){return r[t]*n+e},0)}).map(function(r){return r<=.0031308?12.92*r:1.055*Math.pow(r,1/2.4)-.055}).map(function(r){return 255*r}),u=slicedToArray(c,3),l=u[0],h=u[1],v=u[2];return s.boundedRgb({r:l,g:h,b:v});case"lms":var p=[n.X,n.Y,n.Z].map(function(r){return r/100}),f=s.getTransform("BRADFORD").map(function(r){return p.reduce(function(e,n,t){return r[t]*n+e},0)});return{rho:f[0],gamma:f[1],beta:f[2]};case"cielab":var m=n.X/a.X,d=n.Y/a.Y,b=n.Z/a.Z,g=function(r){return r>.008856?s.cbrt(r):(903.3*r+16)/116},y=g(m),_=g(d);return{L:116*_-16,a:500*(y-_),b:200*(_-g(b))};case"cieluv":var M=n.Y/a.Y,Y=M>.008856?116*s.cbrt(M)-16:903.3*M,L=function(r){return 4*r.X/(r.X+15*r.Y+3*r.Z)},X=function(r){return 9*r.Y/(r.X+15*r.Y+3*r.Z)};return{L:Y,u:13*Y*(L(n)-L(a)),v:13*Y*(X(n)-X(a))};case"xyY":return{x:n.X/(n.X+n.Y+n.Z),y:n.Y/(n.X+n.Y+n.Z),Y:n.Y};default:var Z=s.boundedRgb(o.convert({conversions:t,operations:o,helpers:s},"rgb",n));return o.convert({conversions:t,operations:o,helpers:s},e,Z)}}function fromxyY(r,e,n){var t=r.conversions,o=r.operations,s=r.helpers;switch(e){case"XYZ":var a=n.Y/n.y*n.x,i=n.Y/n.y*(1-n.x-n.y);return{X:a,Y:n.Y,Z:i};default:var c=o.convert({conversions:t,operations:o,helpers:s},"XYZ",n);return o.convert({conversions:t,operations:o,helpers:s},e,c)}}function fromLms(r,e,n){var t=r.conversions,o=r.operations,s=r.helpers;switch(e){case"XYZ":var a=[n.rho,n.gamma,n.beta],i=s.getTransform("INVERSE_BRADFORD").map(function(r){return a.reduce(function(e,n,t){return r[t]*n+e},0)});return{X:100*i[0],Y:100*i[1],Z:100*i[2]};default:var c=o.convert({conversions:t,operations:o,helpers:s},"XYZ",n);return o.convert({conversions:t,operations:o,helpers:s},e,c)}}function fromCieLab(r,e,n){var t=r.conversions,o=r.operations,s=r.helpers;switch(e){case"XYZ":var a=s.getIlluminant("D65"),i=(n.L+16)/116,c=n.a/500+i,u=i-n.b/200,l=function(r){return Math.pow(r,3)>.008856?Math.pow(r,3):(116*r-16)/903.3},h=l(c),v=l(u),p=n.L>903.3*.008856?Math.pow(i,3):n.L/903.3;return{X:h*a.X,Y:p*a.Y,Z:v*a.Z};default:var f=o.convert({conversions:t,operations:o,helpers:s},"XYZ",n);return o.convert({conversions:t,operations:o,helpers:s},e,f)}}function fromCieLuv(r,e,n){var t=r.conversions,o=r.operations,s=r.helpers;switch(e){case"XYZ":var a=s.getIlluminant("D65"),i=function(r){return 4*r.X/(r.X+15*r.Y+3*r.Z)}(a),c=function(r){return 9*r.Y/(r.X+15*r.Y+3*r.Z)}(a),u=1/3*(52*n.L/(n.u+13*n.L*i)-1),l=n.L>903.3*.008856?Math.pow((n.L+16)/116,3):n.L/903.3,h=-5*l,v=(l*(39*n.L/(n.v+13*n.L*c)-5)-h)/(u- -1/3);return{X:100*v,Y:100*l,Z:100*(v*u+h)};case"cielch":var p=Math.sqrt(Math.pow(n.u,2)+Math.pow(n.v,2)),f=Math.atan2(n.v,n.u);return f<0&&(f+=2*Math.PI),f=s.toDeg(f),{L:n.L,C:p,h:f};default:var m=o.convert({conversions:t,operations:o,helpers:s},"XYZ",n);return o.convert({conversions:t,operations:o,helpers:s},e,m)}}function fromCieLch(r,e,n){var t=r.conversions,o=r.operations,s=r.helpers;switch(e){case"cieluv":var a=s.toRad(n.h),i=n.C*Math.cos(a),c=n.C*Math.sin(a);return{L:n.L,u:i,v:c};case"hsluv":if(n.L>99.9999999)return{hu:n.h,s:0,l:100};if(n.L<1e-8)return{hu:n.h,s:0,l:0};for(var u=(n.L+16)/1560896,l=u>.008856?u:n.L/903.3,h=s.getTransform("INVERSE_SRGB_XYZ"),v=[],p=0;p<3;p++)for(var f=h[p][0],m=h[p][1],d=h[p][2],b=0;b<2;b++){var g=(284517*f-94839*d)*l,y=(838422*d+769860*m+731718*f)*n.L*l-769860*b*n.L,_=(632260*d-126452*m)*l+126452*b;v.push({m:g/_,b:y/_})}var M=Number.MAX_VALUE,Y=s.toRad(n.h);v.forEach(function(r){var e=r.b/(Math.sin(Y)-r.m*Math.cos(Y));e>=0&&(M=Math.min(M,e))});var L=M;return{hu:n.h,s:n.C/L*100,l:n.L};default:var X=o.convert({conversions:t,operations:o,helpers:s},"cieluv",n);return o.convert({conversions:t,operations:o,helpers:s},e,X)}}function fromCieLch$1(r,e,n){var t=r.conversions,o=r.operations,s=r.helpers;switch(e){case"cielch":if(n.L>99.9999999)return{L:100,C:0,h:n.hu};if(n.L<1e-8)return{L:0,C:0,h:n.hu};for(var a=(n.l+16)/1560896,i=a>.008856?a:n.l/903.3,c=s.getTransform("INVERSE_SRGB_XYZ"),u=[],l=0;l<3;l++)for(var h=c[l][0],v=c[l][1],p=c[l][2],f=0;f<2;f++){var m=(284517*h-94839*p)*i,d=(838422*p+769860*v+731718*h)*n.l*i-769860*f*n.l,b=(632260*p-126452*v)*i+126452*f;u.push({m:m/b,b:d/b})}var g=Number.MAX_VALUE,y=s.toRad(n.hu);u.forEach(function(r){var e=r.b/(Math.sin(y)-r.m*Math.cos(y));e>=0&&(g=Math.min(g,e))});var _=g;return{L:n.l,C:_/100*n.s,h:n.hu};default:var M=o.convert({conversions:t,operations:o,helpers:s},"cielch",n);return o.convert({conversions:t,operations:o,helpers:s},e,M)}}function contains(r,e){return Object.keys(r).every(function(r){return-1!==e.indexOf(r)})}function adapt(r,e,n,t){var o=r.operations.convert(r,"XYZ",e),s=r.operations.convert(r,"lms",n);if(t)a=r.operations.convert(r,"lms",t);else var a=r.operations.convert(r,"lms",r.helpers.getIlluminant("D65"));var i=r.helpers.getTransform("BRADFORD"),c=r.helpers.getTransform("INVERSE_BRADFORD"),u=[[s.rho/a.rho,0,0],[0,s.gamma/a.gamma,0],[0,0,s.beta/a.beta]],l=r.helpers.matrixMultiply(c,u),h=r.helpers.matrixMultiply(l,i),v=[[o.X],[o.Y],[o.Z]],p=r.helpers.matrixMultiply(h,v),f={X:p[0][0],Y:p[1][0],Z:p[2][0]};return r.helpers.ready(r,f)}function adjacent(r,e,n,t){for(var o=r.operations.convert(r,"hsl",t),s=[{h:o.h,s:o.s,l:o.l}],a=0;a<n-1;a++)o.h=r.helpers.negMod(o.h+e,360),s.push({h:o.h,s:o.s,l:o.l});return r.helpers.ready(r,s)}function brightness(r,e,n){var t=r.operations.convert(r,"hsl",n);return t.l+=e,t.l<0?t.l=0:t.l>100&&(t.l=100),r.helpers.ready(r,t)}function complementary(r,e){var n=r.operations.convert(r,"hsl",e);return n.h=(n.h+180)%360,r.helpers.ready(r,n)}function contrast(r,e,n){var t=r.operations.convert(r,"rgb",n);return t.r=255*((t.r/255-.5)*e+.5),t.r<0?t.r=0:t.r>255&&(t.r=255),t.g=255*((t.g/255-.5)*e+.5),t.g<0?t.g=0:t.g>255&&(t.g=255),t.b=255*((t.b/255-.5)*e+.5),t.b<0?t.b=0:t.b>255&&(t.b=255),r.helpers.ready(r,t)}function contrastRatio(r,e){var n=r.operations.convert(r,"rgb",e);return n=(299*n.r+587*n.g+114*n.b)/1e3>=128?{r:0,g:0,b:0}:{r:255,g:255,b:255},r.helpers.ready(r,n)}function convert(r,e,n){if(Object.keys(r.conversions).indexOf(e)>-1){n.colour?n=n.colour:n.colours&&(n=n.colours);var t=r.helpers.determineMode(n);return t!=e?r.conversions[t].convert(r,e,n):n}return r.helpers.ready(r,e)}function difference(r,e,n,t,o){t=t||1,o=o||1;var s=r.operations.convert(r,"cielab",e),a=r.operations.convert(r,"cielab",n),i=Math.sqrt(Math.pow(s.a,2)+Math.pow(s.b,2)),c=i-Math.sqrt(Math.pow(a.a,2)+Math.pow(a.b,2)),u=s.L-a.L,l=s.a-a.a,h=s.b-a.b,v=Math.sqrt(Math.pow(l,2)+Math.pow(h,2)-Math.pow(c,2)),p=s.L<16?.511:.040975*s.L/(1.01765*s.L),f=.0638*i/(1.0131*i),m=Math.atan2(s.b,s.a),d=m>=0?m:m+360,b=164<=d&&d<=345?.56+Math.abs(.2*Math.cos(r.helpers.toRad(d+168))):.36+Math.abs(.4*Math.cos(r.helpers.toRad(d+35))),g=Math.pow(i,4)/(Math.pow(i,4)+1900),y=f*(g*b+1-g),_=Math.pow(u/(t*p),2);Math.pow(c/(o*f),2),Math.pow(v/y,2);return Math.sqrt(_+_+_)}function fade(r,e,n,t){var o=r.operations.convert(r,"rgb",n),s=r.operations.convert(r,"rgb",t),a=[o];e-=1;for(var i=(s.r-o.r)/e,c=(s.g-o.g)/e,u=(s.b-o.b)/e,l={r:o.r,g:o.g,b:o.b},h=0;h<e-1;h++)l.r=r.helpers.slopeMod(l.r+i,255),l.g=r.helpers.slopeMod(l.g+c,255),l.b=r.helpers.slopeMod(l.b+u,255),a.push({r:l.r,g:l.g,b:l.b});return a.push(s),r.helpers.ready(r,a)}function greyscale(r,e){var n=r.operations.convert(r,"rgb",e),t=(n.r+n.g+n.b)/3;return n={r:t,g:t,b:t},r.helpers.ready(r,n)}function hue(r,e,n){var t=r.operations.convert(r,"hsl",n);return t.h=r.helpers.negMod(t.h+e,360),r.helpers.ready(r,t)}function invert(r,e){var n=r.operations.convert(r,"rgb",e);return n.r=r.helpers.negMod(255-n.r,255),n.g=r.helpers.negMod(255-n.g,255),n.b=r.helpers.negMod(255-n.b,255),r.helpers.ready(r,n)}function invertLightness(r,e){var n=r.operations.convert(r,"hsl",e);return n.l=100-n.l,r.helpers.ready(r,n)}function mid(r,e,n){var t=r.operations.convert(r,"hsl",e),o=r.operations.convert(r,"hsl",n),s={h:(t.h+o.h)/2,s:(t.s+o.s)/2,l:(t.l+o.l)/2};return r.helpers.ready(r,s)}function multiply(r,e,n){var t=r.operations.convert(r,"hsl",e),o=r.operations.convert(r,"hsl",n),s={h:t.h,s:t.s,l:t.l/100*(o.l/100)*100};return s.l=s.l>100?100:s.l,s.l=s.l<0?0:s.l,r.helpers.ready(r,s)}function saturation(r,e,n){var t=r.operations.convert(r,"hsl",n);return t.s+=e,t.s<0?t.s=0:t.s>100&&(t.s=100),r.helpers.ready(r,t)}function sepia(r,e){var n=r.operations.convert(r,"rgb",e),t={};return t.r=.393*n.r+.769*n.g+.189*n.b,t.g=.349*n.r+.686*n.g+.168*n.b,t.b=.272*n.r+.534*n.g+.131*n.b,r.helpers.ready(r,t)}function shade(r,e,n){var t=r.operations.convert(r,"hsv",n);return t.v+=e,t.v<0?t.v=0:t.v>100&&(t.v=100),r.helpers.ready(r,t)}function temperature(r,e){var n=r.operations.convert(r,"xyY",e),t=(n.x-.332)/(n.y-.1858);return-449*Math.pow(t,3)+3525*Math.pow(t,2)-6823.3*t+5520.33}function tetrad(r,e){for(var n=r.operations.convert(r,"hsl",e),t=[{h:n.h,s:n.s,l:n.l}],o=0;o<3;o++)n.h=(n.h+90)%360,t.push({h:n.h,s:n.s,l:n.l});return r.helpers.ready(r,t)}function triad(r,e){for(var n=r.operations.convert(r,"hsl",e),t=[{h:n.h,s:n.s,l:n.l}],o=0;o<2;o++)n.h=(n.h+120)%360,t.push({h:n.h,s:n.s,l:n.l});return r.helpers.ready(r,t)}var fromHex_1=fromHex,_typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(r){return typeof r}:function(r){return r&&"function"==typeof Symbol&&r.constructor===Symbol&&r!==Symbol.prototype?"symbol":typeof r},slicedToArray=function(){function r(r,e){var n=[],t=!0,o=!1,s=void 0;try{for(var a,i=r[Symbol.iterator]();!(t=(a=i.next()).done)&&(n.push(a.value),!e||n.length!==e);t=!0);}catch(r){o=!0,s=r}finally{try{!t&&i.return&&i.return()}finally{if(o)throw s}}return n}return function(e,n){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return r(e,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),toConsumableArray=function(r){if(Array.isArray(r)){for(var e=0,n=Array(r.length);e<r.length;e++)n[e]=r[e];return n}return Array.from(r)},fromRgb_1=fromRgb,fromCssRgb_1=fromCssRgb,fromHsl_1=fromHsl,fromCssHsl_1=fromCssHsl,fromHsv_1=fromHsv,fromCmyk_1=fromCmyk,fromYiq_1=fromYiq,fromXYZ_1=fromXYZ,fromxyY_1=fromxyY,fromLms_1=fromLms,fromCieLab_1=fromCieLab,fromCieLuv_1=fromCieLuv,fromCieLch_1=fromCieLch,fromHsluv=fromCieLch$1,index={hex:{test:function(r){return"string"==typeof r&&"#"===r.slice(0,1)},convert:fromHex_1},rgb:{test:function(r){return contains(r,["r","g","b"])},convert:fromRgb_1},cssrgb:{test:function(r){return"string"==typeof r&&"rgb("===r.slice(0,4)},convert:fromCssRgb_1},hsl:{test:function(r){return contains(r,["h","s","l"])},convert:fromHsl_1},csshsl:{test:function(r){return"string"==typeof r&&"hsl("===r.slice(0,4)},convert:fromCssHsl_1},hsv:{test:function(r){return contains(r,["h","s","v"])},convert:fromHsv_1},cmyk:{test:function(r){return contains(r,["c","m","y","k"])},convert:fromCmyk_1},yiq:{test:function(r){return contains(r,["y","i","q"])},convert:fromYiq_1},XYZ:{test:function(r){return contains(r,["X","Y","Z"])},convert:fromXYZ_1},xyY:{test:function(r){return contains(r,["x","y","Y"])},convert:fromxyY_1},lms:{test:function(r){return contains(r,["rho","gamma","beta"])},convert:fromLms_1},cielab:{test:function(r){return contains(r,["L","a","b"])},convert:fromCieLab_1},cieluv:{test:function(r){return contains(r,["L","u","v"])},convert:fromCieLuv_1},cielch:{test:function(r){return contains(r,["L","C","h"])},convert:fromCieLch_1},hsluv:{test:function(r){return contains(r,["hu","s","l"])},convert:fromHsluv}},adapt_1=adapt,adjacent_1=adjacent,brightness_1=brightness,complementary_1=complementary,contrast_1=contrast,contrastRatio_1=contrastRatio,convert_1=convert,difference_1=difference,fade_1=fade,greyscale_1=greyscale,hue_1=hue,invert_1=invert,invertLightness_1=invertLightness,mid_1=mid,multiply_1=multiply,saturation_1=saturation,sepia_1=sepia,shade_1=shade,temperature_1=temperature,tetrad_1=tetrad,triad_1=triad,index$2={adapt:adapt_1,adjacent:adjacent_1,brightness:brightness_1,complementary:complementary_1,contrast:contrast_1,contrastRatio:contrastRatio_1,convert:convert_1,difference:difference_1,fade:fade_1,greyscale:greyscale_1,hue:hue_1,invert:invert_1,invertLightness:invertLightness_1,mid:mid_1,multiply:multiply_1,saturation:saturation_1,sepia:sepia_1,shade:shade_1,temperature:temperature_1,tetrad:tetrad_1,triad:triad_1},constants={ILLUMINANTS:{A:{X:1.0985*100,Y:100,Z:35.585},B:{X:99.072,Y:100,Z:85.223},C:{X:98.074,Y:100,Z:118.232},D50:{X:96.422,Y:100,Z:82.521},D55:{X:95.682,Y:100,Z:92.149},D65:{X:95.047,Y:100,Z:108.883},D75:{X:94.972,Y:100,Z:122.638},E:{X:100,Y:100,Z:100},F2:{X:.99186*100,Y:100,Z:67.393},F7:{X:95.041,Y:100,Z:108.747},F11:{X:1.00962*100,Y:100,Z:64.35}},TRANSFORMS:{BRADFORD:[[.8951,.2664,-.1614],[-.7502,1.7135,.0367],[.0389,-.0685,1.0296]],INVERSE_BRADFORD:[[.9869929,-.1470543,.1599627],[.4323053,.5183603,.0492912],[-.0085287,.0400428,.9684867]],SRGB_XYZ:[[.4124,.3576,.1805],[.2126,.7152,.0722],[.0193,.1192,.9505]],INVERSE_SRGB_XYZ:[[3.2406,-1.5372,-.4986],[-.9689,1.8758,.0415],[.0557,-.204,1.057]]}},api=function(r,e,n){var t=Object.keys(r.operations).reduce(function(e,t){var o=r.operations[t];return e[t]=function(){for(var e=arguments.length,t=Array(e),s=0;s<e;s++)t[s]=arguments[s];var a=t.slice(0).map(function(r){return"object"===(void 0===r?"undefined":_typeof(r))?Object.assign({},r):r});if(n&&n.colours){return function e(n){var t=n.map(function(n){if(Array.isArray(n)){var t=e(n);return t.colours||t.colour}var s=o.apply(void 0,[r].concat(toConsumableArray(a),[n]));return"object"===(void 0===s?"undefined":_typeof(s))?s.colours||s.colour:s});return"number"!=typeof t[0]?r.helpers.ready(r,t):t}(n.colours)}return o.apply(void 0,[r].concat(toConsumableArray(a),[n?n.colour:void 0]))},e},{});return n||(t=Object.assign(t,e)),t},api_1=api,helpers={getIlluminant:function(r){return constants.ILLUMINANTS[r]},getTransform:function(r){return constants.TRANSFORMS[r]},matrixMultiply:function(r,e){for(var n=[],t=0;t<r.length;t++){n[t]=[];for(var o=0;o<e[0].length;o++){for(var s=0,a=0;a<r[0].length;a++)s+=r[t][a]*e[a][o];n[t][o]=s}}return n},cbrt:function(r){if(Math.cbrt)return Math.cbrt(r);var e=Math.pow(Math.abs(r),1/3);return r<0?-e:e},toRad:function(r){return r*(Math.PI/180)},toDeg:function(r){return r*(180/Math.PI)},negMod:function(r,e){return(r%e+e)%e},slopeMod:function(r){function e(e,n){return r.apply(this,arguments)}return e.toString=function(){return r.toString()},e}(function(r,e){return r>2*e?slopeMod(r-2*e,e):r>e?2*e-r:r<0?slopeMod(r+2*e,e):r}),bounded:function(r,e){return r<e[0]?r=e[0]:r>e[1]&&(r=e[1]),r},boundedRgb:function(r){var e=this,n=function(r){return e.bounded(r,[0,255])};return{r:n(r.r),g:n(r.g),b:n(r.b)}},determineMode:function(r){for(var e in index)if(index.hasOwnProperty(e)&&index[e].test(r))return e;return null},ready:function(r,e){var n=r.conversions,t=r.operations,o=r.helpers,s={};switch(Object.prototype.toString.call(e)){case"[object Object]":case"[object String]":s.colour=e;for(var a in n)n.hasOwnProperty(a)&&function(r){Object.defineProperty(s,r,{get:function(){o.determineMode(e);return t.convert({conversions:n,operations:t,helpers:o},r,e)},enumerable:!0})}(a);return s=Object.assign(s,api_1({conversions:n,operations:t,helpers:o},constants,s));case"[object Array]":s.colours=e;for(var i in n)n.hasOwnProperty(i)&&function(r){Object.defineProperty(s,r,{get:function(){return function e(s){return s.map(function(s){return Array.isArray(s)?e(s):t.convert({conversions:n,operations:t,helpers:o},r,s)})}(e)},enumerable:!0})}(i);return s=Object.assign(s,api_1({conversions:n,operations:t,helpers:o},constants,s));default:return null}}},helpers_1=helpers,dependencies={conversions:index,operations:index$2,helpers:helpers_1},entry=api_1(dependencies,constants);/* harmony default export */ __webpack_exports__["a"] = (entry);


/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTheme;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__types__);

/* eslint-disable no-nested-ternary */




var defaultTheme = { mode: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* DEFAULT_THEME_MODE */] };

function getTheme(props) {
  return props && props.theme && props.theme[__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CHANNEL */]] ? props.theme[__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CHANNEL */]] : defaultTheme;
}

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FLATTENED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANNEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_THEME_MODE; });
/* unused harmony export THEME_MODES */
var FLATTENED = '__FLATTENED__';
var CHANNEL = '__ATLASKIT_THEME__';
var DEFAULT_THEME_MODE = 'light';
var THEME_MODES = ['light', 'dark'];

/***/ }),
/* 262 */
/***/ (function(module, exports) {



/***/ }),
/* 263 */
/***/ (function(module, exports) {

module.exports = {"name":"@atlaskit/navigation","version":"33.1.6"}

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__theme_util__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__GlobalPrimaryActions__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__GlobalSecondaryActions__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styled_GlobalNavigationInner__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styled_GlobalNavigationPrimaryContainer__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styled_GlobalNavigationSecondaryContainer__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__theme_presets__ = __webpack_require__(48);














var GlobalNavigation = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(GlobalNavigation, _PureComponent);

  function GlobalNavigation() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, GlobalNavigation);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (GlobalNavigation.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(GlobalNavigation)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(GlobalNavigation, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          createIcon = _props.createIcon,
          linkComponent = _props.linkComponent,
          onCreateActivate = _props.onCreateActivate,
          onSearchActivate = _props.onSearchActivate,
          primaryActions = _props.primaryActions,
          primaryIcon = _props.primaryIcon,
          primaryIconAppearance = _props.primaryIconAppearance,
          primaryItemHref = _props.primaryItemHref,
          searchIcon = _props.searchIcon,
          secondaryActions = _props.secondaryActions,
          theme = _props.theme;


      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__theme_util__["a" /* WithRootTheme */],
        { provided: theme },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__styled_GlobalNavigationInner__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10__styled_GlobalNavigationPrimaryContainer__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__GlobalPrimaryActions__["a" /* default */], {
              actions: primaryActions,
              createIcon: createIcon,
              linkComponent: linkComponent,
              onCreateActivate: onCreateActivate,
              onSearchActivate: onSearchActivate,
              primaryIcon: primaryIcon,
              primaryIconAppearance: primaryIconAppearance,
              primaryItemHref: primaryItemHref,
              searchIcon: searchIcon
            })
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_11__styled_GlobalNavigationSecondaryContainer__["a" /* default */],
            null,
            secondaryActions.length ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__GlobalSecondaryActions__["a" /* default */], { actions: secondaryActions }) : null
          )
        )
      );
    }
  }]);

  return GlobalNavigation;
}(__WEBPACK_IMPORTED_MODULE_5_react__["PureComponent"]);

GlobalNavigation.defaultProps = {
  primaryIconAppearance: 'round',
  secondaryActions: [],
  theme: __WEBPACK_IMPORTED_MODULE_12__theme_presets__["c" /* global */]
};
/* harmony default export */ __webpack_exports__["a"] = (GlobalNavigation);

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTheme;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__types__);

/* eslint-disable no-nested-ternary */




var defaultTheme = { mode: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* DEFAULT_THEME_MODE */] };

function getTheme(props) {
  return props && props.theme && props.theme[__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CHANNEL */]] ? props.theme[__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CHANNEL */]] : defaultTheme;
}

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FLATTENED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANNEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_THEME_MODE; });
/* unused harmony export THEME_MODES */
var FLATTENED = '__FLATTENED__';
var CHANNEL = '__ATLASKIT_THEME__';
var DEFAULT_THEME_MODE = 'light';
var THEME_MODES = ['light', 'dark'];

/***/ }),
/* 267 */
/***/ (function(module, exports) {



/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// from https://facebook.github.io/react/docs/higher-order-components.html

var getDisplayName = function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};

/* harmony default export */ __webpack_exports__["a"] = (getDisplayName);

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// There are cases where the context is not available, such as when a dropdown item is used
// inside @atlaskit/navigation. For this reason we have this helper function which safely calls
// the context functions if they are available.
/* harmony default export */ __webpack_exports__["a"] = (function (instance, contextKey) {
  return function (fnToCall) {
    var _instance$context$con;

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (!instance.context[contextKey]) {
      return null;
    }

    return (_instance$context$con = instance.context[contextKey])[fnToCall].apply(_instance$context$con, args);
  };
});

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return focusManagerContext; });
/* unused harmony export selectionCacheContext */
/* unused harmony export selectionManagerContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clickManagerContext; });
var prefix = function prefix(key) {
  return '@atlaskit-private-do-not-use/dropdown-menu:' + key;
};

var focusManagerContext = prefix('focus-manager');
var selectionCacheContext = prefix('selection-cache');
var selectionManagerContext = prefix('selection-manager');
var clickManagerContext = prefix('click-manager');

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__GlobalItem__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DrawerTrigger__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__GlobalPrimaryActionsList__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styled_GlobalPrimaryActionsInner__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styled_GlobalPrimaryActionsPrimaryItem__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styled_GlobalPrimaryActionsItemsWrapper__ = __webpack_require__(602);













var GlobalPrimaryActions = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(GlobalPrimaryActions, _PureComponent);

  function GlobalPrimaryActions() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, GlobalPrimaryActions);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (GlobalPrimaryActions.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(GlobalPrimaryActions)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(GlobalPrimaryActions, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          actions = _props.actions,
          createIcon = _props.createIcon,
          linkComponent = _props.linkComponent,
          onCreateActivate = _props.onCreateActivate,
          onSearchActivate = _props.onSearchActivate,
          primaryIcon = _props.primaryIcon,
          primaryIconAppearance = _props.primaryIconAppearance,
          primaryItemHref = _props.primaryItemHref,
          searchIcon = _props.searchIcon;

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__styled_GlobalPrimaryActionsInner__["a" /* default */],
        null,
        primaryIcon ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10__styled_GlobalPrimaryActionsPrimaryItem__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__GlobalItem__["a" /* default */],
            {
              href: primaryItemHref,
              linkComponent: linkComponent,
              size: 'medium',
              appearance: primaryIconAppearance
            },
            primaryIcon
          )
        ) : null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11__styled_GlobalPrimaryActionsItemsWrapper__["a" /* default */],
          null,
          actions ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__GlobalPrimaryActionsList__["a" /* default */], { actions: actions }) : __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'div',
            null,
            searchIcon ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7__DrawerTrigger__["a" /* default */],
              { onActivate: onSearchActivate },
              searchIcon
            ) : null,
            createIcon ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7__DrawerTrigger__["a" /* default */],
              { onActivate: onCreateActivate },
              createIcon
            ) : null
          )
        )
      );
    }
  }]);

  return GlobalPrimaryActions;
}(__WEBPACK_IMPORTED_MODULE_5_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (GlobalPrimaryActions);

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);









var DefaultLinkComponent = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(DefaultLinkComponent, _PureComponent);

  function DefaultLinkComponent() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, DefaultLinkComponent);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (DefaultLinkComponent.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(DefaultLinkComponent)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(DefaultLinkComponent, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          href = _props.href,
          onClick = _props.onClick,
          onMouseDown = _props.onMouseDown,
          onMouseEnter = _props.onMouseEnter,
          onMouseLeave = _props.onMouseLeave,
          tabIndex = _props.tabIndex,
          appearance = _props.appearance,
          isSelected = _props.isSelected,
          otherProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['children', 'className', 'href', 'onClick', 'onMouseDown', 'onMouseEnter', 'onMouseLeave', 'tabIndex', 'appearance', 'isSelected']);

      return href ? __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'a',
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          className: className,
          href: href,
          onClick: onClick,
          onMouseDown: onMouseDown,
          onMouseEnter: onMouseEnter,
          onMouseLeave: onMouseLeave,
          tabIndex: tabIndex
        }, otherProps),
        children
      ) : children;
    }
  }]);

  return DefaultLinkComponent;
}(__WEBPACK_IMPORTED_MODULE_7_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (DefaultLinkComponent);

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__GlobalItem__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styled_DrawerTriggerInner__ = __webpack_require__(598);









var DrawerTrigger = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(DrawerTrigger, _PureComponent);

  function DrawerTrigger() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DrawerTrigger);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (DrawerTrigger.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(DrawerTrigger)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(DrawerTrigger, [{
    key: 'render',
    value: function render() {
      if (this.props.children == null) return null;
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__styled_DrawerTriggerInner__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__GlobalItem__["a" /* default */],
          {
            role: 'button',
            'aria-haspopup': 'true',
            onClick: this.props.onActivate,
            onMouseDown: function onMouseDown(e) {
              return e.preventDefault();
            },
            size: 'medium'
          },
          this.props.children
        )
      );
    }
  }]);

  return DrawerTrigger;
}(__WEBPACK_IMPORTED_MODULE_5_react__["PureComponent"]);

DrawerTrigger.defaultProps = {
  onActivate: function onActivate() {}
};
/* harmony default export */ __webpack_exports__["a"] = (DrawerTrigger);

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export maxSecondaryItems */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);







var maxSecondaryItems = 5;

function checkIfTooManySecondaryActions() {
  var actions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  if (actions.length > maxSecondaryItems) {
    // eslint-disable-next-line no-console
    console.warn('AkGlobalNavigation will only render up to ' + maxSecondaryItems + ' secondary actions.');
  }
}

var GlobalSecondaryActions = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(GlobalSecondaryActions, _PureComponent);

  function GlobalSecondaryActions(props, context) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, GlobalSecondaryActions);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (GlobalSecondaryActions.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(GlobalSecondaryActions)).call(this, props, context));

    checkIfTooManySecondaryActions(props.actions);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(GlobalSecondaryActions, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      checkIfTooManySecondaryActions(nextProps.actions);
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        null,
        this.props.actions.map(function (action, index) {
          return (
            // eslint-disable-next-line react/no-array-index-key
            index < maxSecondaryItems ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              'div',
              { key: index },
              action
            ) : null
          );
        })
      );
    }
  }]);

  return GlobalSecondaryActions;
}(__WEBPACK_IMPORTED_MODULE_5_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (GlobalSecondaryActions);

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_variables__ = __webpack_require__(10);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  /* align-self: center is used to horizontally align the global secondary nav items\n     to the center of the container nav when the nav items are shown in a\n     collapsed container nav */\n  align-self: center;\n  /* required to keep the secondary actions at the bottom */\n  flex-grow: 0;\n\n  /* Required to fix dropdowns in Safari. Won\'t be needed once layering is changed */\n  width: ', 'px;\n'], ['\n  /* align-self: center is used to horizontally align the global secondary nav items\n     to the center of the container nav when the nav items are shown in a\n     collapsed container nav */\n  align-self: center;\n  /* required to keep the secondary actions at the bottom */\n  flex-grow: 0;\n\n  /* Required to fix dropdowns in Safari. Won\'t be needed once layering is changed */\n  width: ', 'px;\n']);




var GlobalNavigationSecondaryContainer = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, __WEBPACK_IMPORTED_MODULE_2__shared_variables__["j" /* globalItemSizes */].small);

GlobalNavigationSecondaryContainer.displayName = 'GlobalNavigationSecondaryContainer';
/* harmony default export */ __webpack_exports__["a"] = (GlobalNavigationSecondaryContainer);

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__theme_util__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ContainerHeader__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ContainerNavigationChildren__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DefaultLinkComponent__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__GlobalPrimaryActions__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__GlobalSecondaryActions__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Reveal__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styled_ContainerNavigationInner__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styled_GlobalNavigationSecondaryContainer__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__shared_variables__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__theme_presets__ = __webpack_require__(48);


















var ContainerNavigation = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ContainerNavigation, _Component);

  function ContainerNavigation(props, context) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ContainerNavigation);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ContainerNavigation.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ContainerNavigation)).call(this, props, context));

    _this.state = {
      isInitiallyRendered: false
    };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ContainerNavigation, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      // After any update we are going to start animating.
      // Not doing this in componentDidMount to prevent an
      // unneeded second render on mount.
      if (!this.state.isInitiallyRendered) {
        this.setState({
          isInitiallyRendered: true
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          scrollRef = _props.scrollRef,
          showGlobalActions = _props.showGlobalActions,
          globalPrimaryActions = _props.globalPrimaryActions,
          globalSecondaryActions = _props.globalSecondaryActions,
          children = _props.children,
          globalCreateIcon = _props.globalCreateIcon,
          globalPrimaryIcon = _props.globalPrimaryIcon,
          globalPrimaryItemHref = _props.globalPrimaryItemHref,
          globalSearchIcon = _props.globalSearchIcon,
          hasScrollHintTop = _props.hasScrollHintTop,
          headerComponent = _props.headerComponent,
          linkComponent = _props.linkComponent,
          onGlobalCreateActivate = _props.onGlobalCreateActivate,
          onGlobalSearchActivate = _props.onGlobalSearchActivate,
          isCollapsed = _props.isCollapsed,
          theme = _props.theme;

      // Only animating the revealing of GlobalPrimaryActions and GlobalSecondaryActions
      // after the first render. Before that it is rendered without animation.

      var isInitiallyRendered = this.state.isInitiallyRendered;


      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__theme_util__["a" /* WithRootTheme */],
        { provided: theme, isCollapsed: isCollapsed },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_13__styled_ContainerNavigationInner__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_12__Reveal__["a" /* default */],
            {
              shouldAnimate: isInitiallyRendered,
              isOpen: showGlobalActions,
              openHeight: __WEBPACK_IMPORTED_MODULE_15__shared_variables__["l" /* globalPrimaryActions */].height(globalPrimaryActions ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.count(globalPrimaryActions) : 2).outer
            },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__GlobalPrimaryActions__["a" /* default */], {
              actions: globalPrimaryActions,
              createIcon: globalCreateIcon,
              linkComponent: linkComponent,
              onCreateActivate: onGlobalCreateActivate,
              onSearchActivate: onGlobalSearchActivate,
              primaryIcon: globalPrimaryIcon,
              primaryItemHref: globalPrimaryItemHref,
              searchIcon: globalSearchIcon
            })
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__ContainerHeader__["a" /* default */],
            null,
            headerComponent ? headerComponent({ isCollapsed: isCollapsed }) : undefined
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8__ContainerNavigationChildren__["a" /* default */],
            {
              hasScrollHintTop: hasScrollHintTop,
              scrollRef: scrollRef
            },
            children
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_14__styled_GlobalNavigationSecondaryContainer__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_12__Reveal__["a" /* default */],
              {
                shouldAnimate: isInitiallyRendered,
                isOpen: showGlobalActions,
                openHeight: __WEBPACK_IMPORTED_MODULE_15__shared_variables__["m" /* globalSecondaryActions */].height(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.count(globalSecondaryActions)).outer
              },
              showGlobalActions && globalSecondaryActions.length ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__GlobalSecondaryActions__["a" /* default */], { actions: globalSecondaryActions }) : null
            )
          )
        )
      );
    }
  }]);

  return ContainerNavigation;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

ContainerNavigation.defaultProps = {
  showGlobalActions: false,
  globalSecondaryActions: [],
  isCollapsed: false,
  linkComponent: __WEBPACK_IMPORTED_MODULE_9__DefaultLinkComponent__["a" /* default */],
  theme: __WEBPACK_IMPORTED_MODULE_16__theme_presets__["a" /* container */]
};
/* harmony default export */ __webpack_exports__["a"] = (ContainerNavigation);

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styled_ContainerHeaderWrapper__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_variables__ = __webpack_require__(10);









var ContainerHeader = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ContainerHeader, _PureComponent);

  function ContainerHeader() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ContainerHeader);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ContainerHeader.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ContainerHeader)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ContainerHeader, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          iconOffset = _props.iconOffset,
          isFullWidth = _props.isFullWidth,
          isInDrawer = _props.isInDrawer;

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__styled_ContainerHeaderWrapper__["a" /* default */],
        {
          isInDrawer: isInDrawer,
          iconOffset: iconOffset,
          isFullWidth: isFullWidth
        },
        this.props.children
      );
    }
  }]);

  return ContainerHeader;
}(__WEBPACK_IMPORTED_MODULE_5_react__["PureComponent"]);

ContainerHeader.defaultProps = {
  iconOffset: __WEBPACK_IMPORTED_MODULE_7__shared_variables__["j" /* globalItemSizes */].medium,
  isInDrawer: false
};
/* harmony default export */ __webpack_exports__["a"] = (ContainerHeader);

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_variables__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__theme_util__ = __webpack_require__(11);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  /* Flex-basis must be set to auto and width set to 100% instead to prevent box-sizing issues\n   * in IE11.\n   * See https://github.com/philipwalton/flexbugs#7-flex-basis-doesnt-account-for-box-sizingborder-box\n   */\n  flex: 1 1 auto;\n  width: 100%;\n  height: 100%;\n  justify-content: flex-start;\n  transition: padding ', ';\n  padding: 0 ', 'px ', 'px ', 'px;\n\n  ', ' ', ';\n'], ['\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  /* Flex-basis must be set to auto and width set to 100% instead to prevent box-sizing issues\n   * in IE11.\n   * See https://github.com/philipwalton/flexbugs#7-flex-basis-doesnt-account-for-box-sizingborder-box\n   */\n  flex: 1 1 auto;\n  width: 100%;\n  height: 100%;\n  justify-content: flex-start;\n  transition: padding ', ';\n  padding: 0 ', 'px ', 'px ', 'px;\n\n  ', ' ', ';\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    overflow-x: hidden;\n    padding: 0 ', 'px;\n  '], ['\n    overflow-x: hidden;\n    padding: 0 ', 'px;\n  ']),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    overflow-y: auto;\n\n    &:before,\n    &:after {\n      background: ', ';\n      content: \'\';\n      display: block;\n      flex: 0;\n      min-height: ', 'px;\n      position: relative;\n      z-index: 5;\n    }\n\n    &:after {\n      top: ', 'px;\n    }\n\n    /* The following styles are to style scrollbars when there is long/wide content */\n    -ms-overflow-style: -ms-autohiding-scrollbar;\n    &::-webkit-scrollbar {\n      height: ', 'px;\n      width: ', 'px;\n    }\n    &::-webkit-scrollbar-corner {\n      display: none;\n    }\n    &::-webkit-scrollbar-thumb {\n      background-color: rgba(0, 0, 0, 0);\n    }\n    &:hover::-webkit-scrollbar-thumb {\n      background-color: ', ';\n      border-radius: ', 'px;\n    }\n    &::-webkit-scrollbar-thumb:hover {\n      background-color: ', ';\n    }\n  '], ['\n    overflow-y: auto;\n\n    &:before,\n    &:after {\n      background: ', ';\n      content: \'\';\n      display: block;\n      flex: 0;\n      min-height: ', 'px;\n      position: relative;\n      z-index: 5;\n    }\n\n    &:after {\n      top: ', 'px;\n    }\n\n    /* The following styles are to style scrollbars when there is long/wide content */\n    -ms-overflow-style: -ms-autohiding-scrollbar;\n    &::-webkit-scrollbar {\n      height: ', 'px;\n      width: ', 'px;\n    }\n    &::-webkit-scrollbar-corner {\n      display: none;\n    }\n    &::-webkit-scrollbar-thumb {\n      background-color: rgba(0, 0, 0, 0);\n    }\n    &:hover::-webkit-scrollbar-thumb {\n      background-color: ', ';\n      border-radius: ', 'px;\n    }\n    &::-webkit-scrollbar-thumb:hover {\n      background-color: ', ';\n    }\n  ']);





var bottomPadding = __WEBPACK_IMPORTED_MODULE_2__shared_variables__["n" /* gridSize */];

var ScrollHintScrollContainer = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, __WEBPACK_IMPORTED_MODULE_2__shared_variables__["h" /* drawerContainerHeaderAnimationSpeed */], __WEBPACK_IMPORTED_MODULE_2__shared_variables__["v" /* scrollHintSpacing */], bottomPadding, __WEBPACK_IMPORTED_MODULE_2__shared_variables__["v" /* scrollHintSpacing */], Object(__WEBPACK_IMPORTED_MODULE_3__theme_util__["m" /* whenCollapsed */])(_templateObject2, __WEBPACK_IMPORTED_MODULE_2__shared_variables__["n" /* gridSize */]), Object(__WEBPACK_IMPORTED_MODULE_3__theme_util__["o" /* whenNotCollapsed */])(_templateObject3, function (_ref) {
  var theme = _ref.theme;
  return Object(__WEBPACK_IMPORTED_MODULE_3__theme_util__["e" /* getProvided */])(theme).background.secondary || Object(__WEBPACK_IMPORTED_MODULE_3__theme_util__["e" /* getProvided */])(theme).background.primary;
}, __WEBPACK_IMPORTED_MODULE_2__shared_variables__["u" /* scrollHintHeight */], bottomPadding, __WEBPACK_IMPORTED_MODULE_2__shared_variables__["t" /* scrollBarSize */], __WEBPACK_IMPORTED_MODULE_2__shared_variables__["t" /* scrollBarSize */], function (_ref2) {
  var theme = _ref2.theme;
  return Object(__WEBPACK_IMPORTED_MODULE_3__theme_util__["f" /* getProvidedScrollbar */])(theme).default.background;
}, __WEBPACK_IMPORTED_MODULE_2__shared_variables__["t" /* scrollBarSize */], function (_ref3) {
  var theme = _ref3.theme;
  return Object(__WEBPACK_IMPORTED_MODULE_3__theme_util__["f" /* getProvidedScrollbar */])(theme).hover.background;
}));
ScrollHintScrollContainer.displayName = 'ScrollHintScrollContainer';
/* harmony default export */ __webpack_exports__["a"] = (ScrollHintScrollContainer);

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_variables__ = __webpack_require__(10);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  align-items: center;\n  display: flex;\n  height: ', 'px;\n  justify-content: center;\n  width: ', 'px;\n\n  /* We need to ensure that any image passed in as a child (<img/>, <svg/>\n  etc.) receives the correct width, height and border radius. We don\'t\n  currently assume that the image passed in is the correct dimensions, or has\n  width / height 100% */\n  & > img {\n    border-radius: ', 'px;\n    height: ', 'px;\n    width: ', 'px;\n  }\n'], ['\n  align-items: center;\n  display: flex;\n  height: ', 'px;\n  justify-content: center;\n  width: ', 'px;\n\n  /* We need to ensure that any image passed in as a child (<img/>, <svg/>\n  etc.) receives the correct width, height and border radius. We don\'t\n  currently assume that the image passed in is the correct dimensions, or has\n  width / height 100% */\n  & > img {\n    border-radius: ', 'px;\n    height: ', 'px;\n    width: ', 'px;\n  }\n']);




var size = __WEBPACK_IMPORTED_MODULE_2__shared_variables__["n" /* gridSize */] * 5;
var borderRadius = 4;

var ContainerTitleIcon = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, size, size, borderRadius, size, size);

ContainerTitleIcon.displayName = 'ContainerTitleIcon';
/* harmony default export */ __webpack_exports__["a"] = (ContainerTitleIcon);

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  font-weight: 500;\n'], ['\n  font-weight: 500;\n']);



var ContainerTitleText = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(_templateObject);

ContainerTitleText.displayName = 'ContainerTitleText';
/* harmony default export */ __webpack_exports__["a"] = (ContainerTitleText);

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_clonedeep__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_clonedeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_clonedeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_variables__ = __webpack_require__(10);






var overrideItemTheme = function overrideItemTheme(outerTheme, key) {
  var original = outerTheme[key];

  if (!original || !original.padding) {
    // eslint-disable-next-line no-console
    console.error('Could not find theme with key \'' + key + '\' to modifiy it for title');
    return outerTheme;
  }

  // TODO: deep modification while respecting types
  var newTheme = __WEBPACK_IMPORTED_MODULE_2_lodash_clonedeep___default()(original);

  newTheme.padding.default.left = __WEBPACK_IMPORTED_MODULE_3__shared_variables__["f" /* containerTitleHorizontalPadding */];
  newTheme.padding.default.right = __WEBPACK_IMPORTED_MODULE_3__shared_variables__["f" /* containerTitleHorizontalPadding */];
  newTheme.height.default = 0;
  newTheme.beforeItemSpacing.default = __WEBPACK_IMPORTED_MODULE_3__shared_variables__["g" /* containerTitleIconSpacing */];

  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, outerTheme, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, key, newTheme));
};

/* harmony default export */ __webpack_exports__["a"] = (overrideItemTheme);

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DropdownMenuStatelessWithoutAnalytics */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uuid_v1__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uuid_v1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_uuid_v1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__atlaskit_analytics_next__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__atlaskit_button__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__atlaskit_droplist__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__atlaskit_icon_glyph_chevron_down__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__atlaskit_icon_glyph_chevron_down___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__atlaskit_icon_glyph_chevron_down__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__package_json__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__context_DropdownItemFocusManager__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__context_DropdownItemClickManager__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__context_DropdownItemSelectionCache__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styled_WidthConstrainer__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__util_keys__ = __webpack_require__(168);







/* eslint-disable react/no-array-index-key */
















var DropdownMenuStateless = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(DropdownMenuStateless, _Component);

  function DropdownMenuStateless() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, DropdownMenuStateless);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = DropdownMenuStateless.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(DropdownMenuStateless)).call.apply(_ref, [this].concat(args))), _this), _this.dropdownListPositioned = false, _this.state = {
      id: __WEBPACK_IMPORTED_MODULE_8_uuid_v1___default()(),
      autoFocusDropdownItems: false
    }, _this.componentDidMount = function () {
      if (_this.isUsingDeprecatedAPI()) {
        if (false) {
          // eslint-disable-next-line no-console
          console.log('DropdownMenu.items is deprecated. Please switch to the declarative API.');
        }

        if (_this.domItemsList) {
          _this.focusFirstItem();
        }
      }
    }, _this.componentDidUpdate = function (prevProp) {
      if (_this.isUsingDeprecatedAPI() && _this.props.isOpen && !prevProp.isOpen) {
        _this.focusFirstItem();
      }
    }, _this.getNextFocusable = function (indexItem, available) {
      if (!_this.domItemsList) {
        return null;
      }

      var currentItem = typeof indexItem !== 'number' ? -1 : indexItem;
      var latestAvailable = typeof available !== 'number' ? currentItem : available;

      if (currentItem < _this.domItemsList.length - 1) {
        currentItem++;

        if (_this.domItemsList[currentItem].getAttribute('aria-hidden') !== 'true') {
          return currentItem;
        }

        return _this.getNextFocusable(currentItem, latestAvailable);
      }

      return latestAvailable;
    }, _this.getPrevFocusable = function (indexItem, available) {
      if (!_this.domItemsList) {
        return null;
      }

      var currentItem = typeof indexItem !== 'number' ? -1 : indexItem;
      var latestAvailable = typeof available !== 'number' ? currentItem : available;

      if (currentItem && currentItem > 0) {
        currentItem--;

        if (_this.domItemsList[currentItem].getAttribute('aria-hidden') !== 'true') {
          return currentItem;
        }

        return _this.getPrevFocusable(currentItem, latestAvailable);
      }

      return latestAvailable || currentItem;
    }, _this.focusFirstItem = function () {
      if (_this.sourceOfIsOpen === 'keydown') {
        _this.focusItem(_this.getNextFocusable());
      }
    }, _this.focusNextItem = function () {
      _this.focusItem(_this.getNextFocusable(_this.focusedItem));
    }, _this.focusPreviousItem = function () {
      _this.focusItem(_this.getPrevFocusable(_this.focusedItem));
    }, _this.focusItem = function (index) {
      if (!_this.domItemsList || !index) {
        return;
      }

      _this.focusedItem = index;
      _this.domItemsList[_this.focusedItem].focus();
    }, _this.isTargetChildItem = function (target) {
      if (!target) return false;

      var isDroplistItem = target.getAttribute('data-role') === 'droplistItem';

      // eslint-disable-next-line react/no-find-dom-node
      var thisDom = Object(__WEBPACK_IMPORTED_MODULE_7_react_dom__["findDOMNode"])(_this);
      return isDroplistItem && thisDom ? thisDom.contains(target) : false;
    }, _this.handleKeyboardInteractionForClosed = function (event) {
      if (_this.props.isOpen) {
        return;
      }

      switch (event.key) {
        case __WEBPACK_IMPORTED_MODULE_18__util_keys__["a" /* KEY_DOWN */]:
        case __WEBPACK_IMPORTED_MODULE_18__util_keys__["c" /* KEY_SPACE */]:
        case __WEBPACK_IMPORTED_MODULE_18__util_keys__["b" /* KEY_ENTER */]:
          event.preventDefault();
          _this.open({ event: event, source: 'keydown' });
          break;
        default:
          break;
      }
    }, _this.handleKeyboardInteractionsDeprecated = function (event) {
      // KeyboardEvent.target is typed as an EventTarget but we need to access methods on it which
      // are specific to Element. Due limitations of the HTML spec flow doesn't know that an
      // EventTarget can have these methods, so we cast it to Element through Object. This is the
      // safest thing we can do in this situation.
      var target = event.target;
      if (_this.props.isOpen) {
        if (_this.isTargetChildItem(target)) {
          switch (event.key) {
            case 'ArrowUp':
              event.preventDefault();
              _this.focusPreviousItem();
              break;
            case 'ArrowDown':
              event.preventDefault();
              _this.focusNextItem();
              break;
            case 'Tab':
              event.preventDefault();
              _this.close({ event: event });
              break;
            default:
              break;
          }
        } else if (event.key === 'ArrowDown') {
          _this.sourceOfIsOpen = 'keydown';
          _this.focusFirstItem();
        } else if (event.key === 'Tab') {
          _this.close({ event: event });
        }
      } else {
        switch (event.key) {
          case __WEBPACK_IMPORTED_MODULE_18__util_keys__["a" /* KEY_DOWN */]:
          case __WEBPACK_IMPORTED_MODULE_18__util_keys__["c" /* KEY_SPACE */]:
          case __WEBPACK_IMPORTED_MODULE_18__util_keys__["b" /* KEY_ENTER */]:
            event.preventDefault();
            _this.open({ event: event, source: 'keydown' });
            break;
          default:
            break;
        }
      }
    }, _this.handleClickDeprecated = function (event) {
      var menuContainer = _this.domMenuContainer;
      // Casting target to Element. See comment in `handleKeyboardInteractionsDeprecated`.
      var target = event.target;
      if (!menuContainer || menuContainer && !menuContainer.contains(target)) {
        _this.toggle({ source: 'click', event: event });
      }
    }, _this.isUsingDeprecatedAPI = function () {
      return Boolean(_this.props.items.length);
    }, _this.handleClick = function (event) {
      // For any clicks we don't want autofocus
      _this.setState({ autoFocusDropdownItems: false });
      if (_this.isUsingDeprecatedAPI()) {
        _this.handleClickDeprecated(event);
        return;
      }

      var _this2 = _this,
          triggerContainer = _this2.triggerContainer;
      // Casting target to Element. See comment in `handleKeyboardInteractionsDeprecated`.

      var target = event.target;
      if (triggerContainer && triggerContainer.contains(target) &&
      // $FlowFixMe - disabled is not in Element
      target.disabled !== true) {
        var isOpen = _this.props.isOpen;

        _this.sourceOfIsOpen = 'mouse';
        _this.props.onOpenChange({ isOpen: !isOpen, event: event });
      }
    }, _this.triggerContent = function () {
      var _this$props = _this.props,
          children = _this$props.children,
          trigger = _this$props.trigger,
          isOpen = _this$props.isOpen,
          triggerButtonProps = _this$props.triggerButtonProps,
          triggerType = _this$props.triggerType;

      var insideTriggerContent = _this.isUsingDeprecatedAPI() ? children : trigger;

      if (triggerType !== 'button') {
        return insideTriggerContent;
      }

      var triggerProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, triggerButtonProps);
      var defaultButtonProps = {
        ariaControls: _this.state.id,
        ariaExpanded: isOpen,
        ariaHaspopup: true,
        isSelected: isOpen
      };
      if (!triggerProps.iconAfter && !triggerProps.iconBefore) {
        triggerProps.iconAfter = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__atlaskit_icon_glyph_chevron_down___default.a, { size: 'medium', label: '' });
      }
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10__atlaskit_button__["b" /* default */],
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, defaultButtonProps, triggerProps),
        insideTriggerContent
      );
    }, _this.open = function (attrs) {
      _this.sourceOfIsOpen = attrs.source;
      _this.props.onOpenChange({ isOpen: true, event: attrs.event });
      // Dropdown opened via keyboard gets auto focussed
      _this.setState({
        autoFocusDropdownItems: _this.sourceOfIsOpen === 'keydown'
      });
    }, _this.close = function (attrs) {
      _this.sourceOfIsOpen = null;
      _this.props.onOpenChange({ isOpen: false, event: attrs.event });
    }, _this.toggle = function (attrs) {
      if (attrs.source === 'keydown') return;

      if (_this.props.isOpen) {
        _this.close(attrs);
      } else {
        _this.open(attrs);
      }
    }, _this.handleItemClicked = function (event) {
      _this.props.onOpenChange({ isOpen: false, event: event });
    }, _this.renderTrigger = function () {
      var triggerContent = _this.triggerContent();
      return _this.isUsingDeprecatedAPI() ? triggerContent : __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        {
          ref: function ref(_ref2) {
            _this.triggerContainer = _ref2;
          }
        },
        triggerContent
      );
    }, _this.renderItems = function (items) {
      return items.map(function (item, itemIndex) {
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11__atlaskit_droplist__["b" /* Item */],
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, {
            key: itemIndex,
            onActivate: function onActivate(_ref3) {
              var event = _ref3.event;

              _this.props.onItemActivated({ item: item, event: event });
            }
          }),
          item.content
        );
      });
    }, _this.renderGroups = function (groups) {
      return groups.map(function (group, groupIndex) {
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11__atlaskit_droplist__["a" /* Group */],
          {
            heading: group.heading,
            elemAfter: group.elemAfter,
            key: groupIndex
          },
          _this.renderItems(group.items)
        );
      });
    }, _this.renderDeprecated = function () {
      var _this$props2 = _this.props,
          items = _this$props2.items,
          shouldFitContainer = _this$props2.shouldFitContainer;
      var id = _this.state.id;


      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        {
          id: id,
          ref: function ref(_ref4) {
            _this.domMenuContainer = _ref4;
            _this.domItemsList = _ref4 ? _ref4.querySelectorAll('[data-role="droplistItem"]') : null;
          },
          role: 'menu',
          style: shouldFitContainer ? null : { maxWidth: 300 }
        },
        _this.renderGroups(items)
      );
    }, _this.onDroplistPositioned = function () {
      _this.dropdownListPositioned = true;
      // Trigger render so item focus manager can auto focus for keyboard trigger
      _this.setState({
        autoFocusDropdownItems: _this.sourceOfIsOpen === 'keydown'
      });

      if (_this.props.onPositioned) _this.props.onPositioned();
    }, _this.renderDropdownItems = function () {
      if (_this.dropdownListPositioned) {
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_15__context_DropdownItemClickManager__["a" /* default */],
          { onItemClicked: _this.handleItemClicked },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_14__context_DropdownItemFocusManager__["a" /* default */],
            {
              autoFocus: _this.state.autoFocusDropdownItems,
              close: _this.close
            },
            _this.props.children
          )
        );
      }
      return null;
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  /** Ensure droplist is positioned before focussing to avoid container scrolling to top */


  /** Render items only after droplist has been positioned */


  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(DropdownMenuStateless, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          appearance = _props.appearance,
          boundariesElement = _props.boundariesElement,
          isLoading = _props.isLoading,
          isOpen = _props.isOpen,
          onOpenChange = _props.onOpenChange,
          position = _props.position,
          isMenuFixed = _props.isMenuFixed,
          shouldAllowMultilineItems = _props.shouldAllowMultilineItems,
          shouldFitContainer = _props.shouldFitContainer,
          shouldFlip = _props.shouldFlip;
      var id = this.state.id;

      var isDeprecated = this.isUsingDeprecatedAPI();

      var deprecatedProps = isDeprecated ? {
        onKeyDown: this.handleKeyboardInteractionsDeprecated,
        shouldAllowMultilineItems: shouldAllowMultilineItems
      } : {
        onKeyDown: this.handleKeyboardInteractionForClosed
      };
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_16__context_DropdownItemSelectionCache__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11__atlaskit_droplist__["c" /* default */],
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            appearance: appearance,
            boundariesElement: boundariesElement,
            isLoading: isLoading,
            isOpen: isOpen,
            onClick: this.handleClick,
            onOpenChange: onOpenChange,
            position: position,
            isMenuFixed: isMenuFixed,
            shouldFitContainer: shouldFitContainer,
            shouldFlip: shouldFlip,
            trigger: this.renderTrigger(),
            onPositioned: this.onDroplistPositioned
          }, deprecatedProps, {
            analyticsContext: {
              componentName: 'dropdownMenu',
              packageName: __WEBPACK_IMPORTED_MODULE_13__package_json__["name"],
              packageVersion: __WEBPACK_IMPORTED_MODULE_13__package_json__["version"]
            }
          }),
          isDeprecated ? this.renderDeprecated() : __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_17__styled_WidthConstrainer__["a" /* default */],
            {
              id: id,
              role: 'menu',
              shouldFitContainer: shouldFitContainer
            },
            this.renderDropdownItems()
          )
        )
      );
    }
  }]);

  return DropdownMenuStateless;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

DropdownMenuStateless.defaultProps = {
  appearance: 'default',
  boundariesElement: 'viewport',
  isLoading: false,
  isOpen: false,
  items: [],
  onItemActivated: function onItemActivated() {},
  onOpenChange: function onOpenChange() {},
  position: 'bottom left',
  isMenuFixed: false,
  shouldAllowMultilineItems: false,
  shouldFitContainer: false,
  shouldFlip: true,
  triggerType: 'default',
  onPositioned: function onPositioned() {}
};



var createAndFireEventOnAtlaskit = Object(__WEBPACK_IMPORTED_MODULE_9__atlaskit_analytics_next__["b" /* createAndFireEvent */])('atlaskit');

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__atlaskit_analytics_next__["d" /* withAnalyticsEvents */])({
  onOpenChange: createAndFireEventOnAtlaskit({
    action: 'toggled',
    actionSubject: 'dropdownMenu',

    attributes: {
      componentName: 'dropdownMenu',
      packageName: __WEBPACK_IMPORTED_MODULE_13__package_json__["name"],
      packageVersion: __WEBPACK_IMPORTED_MODULE_13__package_json__["version"]
    }
  })
})(DropdownMenuStateless));

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTheme;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__types__);

/* eslint-disable no-nested-ternary */




var defaultTheme = { mode: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* DEFAULT_THEME_MODE */] };

function getTheme(props) {
  return props && props.theme && props.theme[__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CHANNEL */]] ? props.theme[__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CHANNEL */]] : defaultTheme;
}

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FLATTENED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANNEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_THEME_MODE; });
/* unused harmony export THEME_MODES */
var FLATTENED = '__FLATTENED__';
var CHANNEL = '__ATLASKIT_THEME__';
var DEFAULT_THEME_MODE = 'light';
var THEME_MODES = ['light', 'dark'];

/***/ }),
/* 285 */
/***/ (function(module, exports) {



/***/ }),
/* 286 */
/***/ (function(module, exports) {

module.exports = {"name":"@atlaskit/droplist","version":"7.0.7"}

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(15);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RadioIcon = function RadioIcon(props) {
  return _react2.default.createElement(_index2.default, _extends({ dangerouslySetGlyph: '<svg width="24" height="24" viewBox="0 0 24 24" focusable="false" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" cx="12" cy="12" r="6"/><circle fill="inherit" cx="12" cy="12" r="2"/></g></svg>' }, props));
};
exports.default = RadioIcon;

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(15);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CheckboxIcon = function CheckboxIcon(props) {
  return _react2.default.createElement(_index2.default, _extends({ dangerouslySetGlyph: '<svg width="24" height="24" viewBox="0 0 24 24" focusable="false" role="presentation"><g fill-rule="evenodd"><rect fill="currentColor" x="6" y="6" width="12" height="12" rx="2"/><path d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z" fill="inherit"/></g></svg>' }, props));
};
exports.default = CheckboxIcon;

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTheme;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__types__);

/* eslint-disable no-nested-ternary */




var defaultTheme = { mode: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* DEFAULT_THEME_MODE */] };

function getTheme(props) {
  return props && props.theme && props.theme[__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CHANNEL */]] ? props.theme[__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CHANNEL */]] : defaultTheme;
}

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FLATTENED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANNEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_THEME_MODE; });
/* unused harmony export THEME_MODES */
var FLATTENED = '__FLATTENED__';
var CHANNEL = '__ATLASKIT_THEME__';
var DEFAULT_THEME_MODE = 'light';
var THEME_MODES = ['light', 'dark'];

/***/ }),
/* 291 */
/***/ (function(module, exports) {



/***/ }),
/* 292 */
/***/ (function(module, exports) {

module.exports = {"name":"@atlaskit/tooltip","version":"12.0.10"}

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TooltipPrimitive */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tooltip; });
/* unused harmony export Target */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(165);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n        max-width: 420px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n      '], ['\n        max-width: 420px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n      ']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  z-index: ', ';\n  pointer-events: none;\n  position: fixed;\n'], ['\n  z-index: ', ';\n  pointer-events: none;\n  position: fixed;\n']),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  background-color: ', ';\n  border-radius: ', 'px;\n  box-sizing: border-box;\n  color: ', ';\n  font-size: 12px;\n  left: 0;\n  line-height: 1.3;\n  max-width: 240px;\n  padding: 2px 6px;\n  top: 0;\n  /* Edge does not support overflow-wrap */\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  ', ';\n'], ['\n  background-color: ', ';\n  border-radius: ', 'px;\n  box-sizing: border-box;\n  color: ', ';\n  font-size: 12px;\n  left: 0;\n  line-height: 1.3;\n  max-width: 240px;\n  padding: 2px 6px;\n  top: 0;\n  /* Edge does not support overflow-wrap */\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  ', ';\n']),
    _templateObject4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: inline-block;\n'], ['\n  display: inline-block;\n']);




var backgroundColor = Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* themed */])({
  light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].N800,
  dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].DN0
});
var textColor = Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* themed */])({
  light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].N0,
  dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].DN600
});

var truncate = function truncate(p) {
  return p.truncate ? Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject) : '';
};

var TooltipPrimitive = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject2, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["e" /* layers */].tooltip);

var Tooltip = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(TooltipPrimitive)(_templateObject3, backgroundColor, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* borderRadius */], textColor, truncate);

// The inline-block here is needed to keep the tooltip appearing in the correct position
// when nested inside a wider parent (see position: relative example).
var Target = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject4);

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__atlaskit_theme__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_getDisplayName__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_safeContextCall__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_contextNamespace__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_keys__ = __webpack_require__(168);


















// HOC that typically wraps @atlaskit/item
var withToggleInteraction = function withToggleInteraction(WrappedComponent, SelectionIcon, getAriaRole) {
  var WithToggleInteraction = function (_Component) {
    __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(WithToggleInteraction, _Component);

    function WithToggleInteraction() {
      var _ref;

      var _temp, _this, _ret;

      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, WithToggleInteraction);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = WithToggleInteraction.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(WithToggleInteraction)).call.apply(_ref, [this].concat(args))), _this), _this.getIconColors = function () {
        var isSelected = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        if (isSelected) {
          return { primary: __WEBPACK_IMPORTED_MODULE_9__atlaskit_theme__["a" /* colors */].B400, secondary: __WEBPACK_IMPORTED_MODULE_9__atlaskit_theme__["a" /* colors */].N40 };
        }
        return { primary: __WEBPACK_IMPORTED_MODULE_9__atlaskit_theme__["a" /* colors */].N40, secondary: __WEBPACK_IMPORTED_MODULE_9__atlaskit_theme__["a" /* colors */].N40 };
      }, _this.warnIfUseControlledAndUncontrolledState = function () {
        if (false) {
          if (_this.props.defaultSelected && _this.props.isSelected) {
            // eslint-disable-next-line no-console
            console.warn('DropdownItem defaultSelected and isSelected props should not be used at the same time.');
          }
        }
      }, _this.callContextFn = Object(__WEBPACK_IMPORTED_MODULE_12__util_safeContextCall__["a" /* default */])(_this, __WEBPACK_IMPORTED_MODULE_13__util_contextNamespace__["d" /* selectionManagerContext */]), _this.handleKeyboard = function (event) {
        var key = event.key;

        if (key === __WEBPACK_IMPORTED_MODULE_14__util_keys__["b" /* KEY_ENTER */] || key === __WEBPACK_IMPORTED_MODULE_14__util_keys__["c" /* KEY_SPACE */]) {
          // We prevent default here to avoid page scroll
          event.preventDefault();

          _this.handleItemActivated(event);
        }
      }, _this.handleItemActivated = function (event) {
        if (_this.props.onClick) {
          _this.props.onClick(event);
        }
        _this.callContextFn('itemClicked', _this.props.id);
      }, _this.isSelectedInDropdown = function () {
        return _this.callContextFn('isItemSelected', _this.props.id);
      }, _temp), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(WithToggleInteraction, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _props = this.props,
            defaultSelected = _props.defaultSelected,
            isSelected = _props.isSelected,
            id = _props.id;

        this.warnIfUseControlledAndUncontrolledState();

        this.callContextFn('setItemSelected', id, isSelected, defaultSelected);
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var id = nextProps.id,
            defaultSelected = nextProps.defaultSelected,
            isSelected = nextProps.isSelected;

        if (this.props.isSelected !== isSelected) {
          this.callContextFn('setItemSelected', id, isSelected, defaultSelected);
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _props2 = this.props,
            children = _props2.children,
            otherProps = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['children']);

        var isSelected = this.isSelectedInDropdown();
        var iconColors = this.getIconColors(isSelected);
        var ariaRole = getAriaRole();

        return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
          WrappedComponent,
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, otherProps, {
            role: ariaRole,
            'aria-checked': isSelected,
            isSelected: isSelected,
            onClick: this.handleItemActivated,
            onKeyDown: this.handleKeyboard,
            elemBefore: __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(SelectionIcon, {
              primaryColor: iconColors.primary,
              secondaryColor: iconColors.secondary,
              size: 'medium',
              label: ''
            })
          }),
          children
        );
      }
    }]);

    return WithToggleInteraction;
  }(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

  WithToggleInteraction.defaultProps = {
    onClick: function onClick() {}
  };
  WithToggleInteraction.contextTypes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_13__util_contextNamespace__["d" /* selectionManagerContext */], __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.object.isRequired);

  WithToggleInteraction.displayName = 'WithToggleInteraction(' + Object(__WEBPACK_IMPORTED_MODULE_11__util_getDisplayName__["a" /* default */])(WrappedComponent) + ')';
  return WithToggleInteraction;
};

/* harmony default export */ __webpack_exports__["a"] = (withToggleInteraction);

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AtlasKitThemeProvider */
/* unused harmony export borderRadius */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return gridSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fontSize; });
/* unused harmony export fontFamily */
/* unused harmony export codeFontFamily */
/* unused harmony export layers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elevation__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__typography__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_math__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_getTheme__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_themed__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AtlaskitThemeProvider__ = __webpack_require__(687);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__colors__; });
/* unused harmony reexport elevation */
/* unused harmony reexport typography */
/* unused harmony reexport math */
/* unused harmony reexport getTheme */
/* unused harmony reexport themed */
/* unused harmony reexport AtlaskitThemeProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Appearance__ = __webpack_require__(688);
/* unused harmony reexport Appearance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Context__ = __webpack_require__(101);
/* unused harmony reexport Consumer */
/* unused harmony reexport Provider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Reset__ = __webpack_require__(689);
/* unused harmony reexport Reset */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Theme__ = __webpack_require__(690);
/* unused harmony reexport Theme */











// backwards-compatible export with old Atlaskit case
var AtlasKitThemeProvider = __WEBPACK_IMPORTED_MODULE_6__components_AtlaskitThemeProvider__["a" /* default */];

/*
  These theme values are expressed as functions so that if we decide to make
  them dependent on props in the future, it wouldn't require a significant
  refactor everywhere they are being used.
*/
var borderRadius = function borderRadius() {
  return 3;
};
var gridSize = function gridSize() {
  return 8;
};
var fontSize = function fontSize() {
  return 14;
};
var fontFamily = function fontFamily() {
  return '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif';
};
var codeFontFamily = function codeFontFamily() {
  return '"SFMono-Medium", "SF Mono", "Segoe UI Mono", "Roboto Mono", "Ubuntu Mono", Menlo, Consolas, Courier, monospace';
};

var layers = {
  card: function card() {
    return 100;
  },
  dialog: function dialog() {
    return 200;
  },
  navigation: function navigation() {
    return 300;
  },
  layer: function layer() {
    return 400;
  },
  blanket: function blanket() {
    return 500;
  },
  modal: function modal() {
    return 510;
  },
  flag: function flag() {
    return 600;
  },
  spotlight: function spotlight() {
    return 700;
  },
  tooltip: function tooltip() {
    return 800;
  }
};

// New API




/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTheme;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__types__);

/* eslint-disable no-nested-ternary */




var defaultTheme = { mode: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* DEFAULT_THEME_MODE */] };

function getTheme(props) {
  return props && props.theme && props.theme[__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CHANNEL */]] ? props.theme[__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CHANNEL */]] : defaultTheme;
}

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FLATTENED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANNEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_THEME_MODE; });
/* unused harmony export THEME_MODES */
var FLATTENED = '__FLATTENED__';
var CHANNEL = '__ATLASKIT_THEME__';
var DEFAULT_THEME_MODE = 'light';
var THEME_MODES = ['light', 'dark'];

/***/ }),
/* 298 */
/***/ (function(module, exports) {



/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// from https://facebook.github.io/react/docs/higher-order-components.html

var getDisplayName = function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};

/* harmony default export */ __webpack_exports__["a"] = (getDisplayName);

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var supportsVoiceOver = function supportsVoiceOver() {
  return (/Mac OS X/.test(navigator.userAgent)
  );
};

/* harmony default export */ __webpack_exports__["a"] = (supportsVoiceOver);

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_getDisplayName__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__context_DropdownItemSelectionManager__ = __webpack_require__(694);











// HOC that typically wraps @atlaskit/item/ItemGroup
var withDropdownItemSelectionManager = function withDropdownItemSelectionManager(WrappedComponent, selectionBehavior) {
  var _class, _temp;

  return _temp = _class = function (_Component) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(WithDropdownItemSelectionManager, _Component);

    function WithDropdownItemSelectionManager() {
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, WithDropdownItemSelectionManager);

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (WithDropdownItemSelectionManager.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(WithDropdownItemSelectionManager)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(WithDropdownItemSelectionManager, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            children = _props.children,
            id = _props.id,
            otherProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['children', 'id']);

        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          WrappedComponent,
          otherProps,
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8__context_DropdownItemSelectionManager__["a" /* default */],
            {
              groupId: id,
              behavior: selectionBehavior
            },
            children
          )
        );
      }
    }]);

    return WithDropdownItemSelectionManager;
  }(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]), _class.displayName = 'WithDropdownItemSelectionManager(' + Object(__WEBPACK_IMPORTED_MODULE_7__util_getDisplayName__["a" /* default */])(WrappedComponent) + ')', _temp;
};

/* harmony default export */ __webpack_exports__["a"] = (withDropdownItemSelectionManager);

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var ENDS_WITH_DOT = /\.$/;

/*
The matchEvent method is responsible for deciding whether a Decorator or
Listener should take action based on the event name and the `match` prop.
*/

function matchEvent(matcher, name) {
  if (matcher === '*' || name === undefined) {
    return true;
  }
  if (typeof matcher === 'string') {
    if (ENDS_WITH_DOT.test(matcher)) {
      return name.substr(0, matcher.length) === matcher;
    }
    return name === matcher;
  }
  if (typeof matcher === 'function') {
    return matcher(name);
  }
  if (matcher instanceof RegExp) {
    return matcher.test(name);
  }
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (matchEvent);

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__theme_util__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SkeletonGlobalTopItems__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SkeletonGlobalBottomItems__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styled_SkeletonGlobalNavigationInner__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styled_SkeletonNavigationContentOuter__ = __webpack_require__(306);















var SkeletonGlobalNavigation = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(SkeletonGlobalNavigation, _Component);

  function SkeletonGlobalNavigation() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SkeletonGlobalNavigation);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SkeletonGlobalNavigation.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(SkeletonGlobalNavigation)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(SkeletonGlobalNavigation, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__theme_util__["a" /* WithRootTheme */],
        {
          provided: this.props.theme,
          isCollapsed: this.props.isCollapsed
        },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__styled_SkeletonGlobalNavigationInner__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10__styled_SkeletonNavigationContentOuter__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__SkeletonGlobalTopItems__["a" /* default */], null),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__SkeletonGlobalBottomItems__["a" /* default */], null)
          )
        )
      );
    }
  }]);

  return SkeletonGlobalNavigation;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

SkeletonGlobalNavigation.defaultProps = {
  isCollapsed: false
};
/* harmony default export */ __webpack_exports__["a"] = (SkeletonGlobalNavigation);

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sizes; });
var sizes = {
  small: '16px',
  medium: '24px',
  large: '32px',
  xlarge: '48px'
};

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(20);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  margin-bottom: ', 'px;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n'], ['\n  margin-bottom: ', 'px;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n']);





var SkeletonGlobalIconOuter = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["e" /* math */].divide(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */], 2));

SkeletonGlobalIconOuter.displayName = 'SkeletonGlobalIconOuter';
/* harmony default export */ __webpack_exports__["a"] = (SkeletonGlobalIconOuter);

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(20);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  height: 100%;\n  padding-top: ', 'px;\n  padding-bottom: ', 'px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n'], ['\n  height: 100%;\n  padding-top: ', 'px;\n  padding-bottom: ', 'px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n']);





var SkeletonNavigationContentOuter = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */])() * 3, Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */])() * 2);

SkeletonNavigationContentOuter.displayName = 'SkeletonNavigationContentOuter';
/* harmony default export */ __webpack_exports__["a"] = (SkeletonNavigationContentOuter);

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__theme_util__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SkeletonGlobalTopItems__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SkeletonGlobalBottomItems__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SkeletonContainerItems__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ToggleWhenCollapsed__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styled_SkeletonContainerNavigationInner__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styled_SkeletonNavigationContentOuter__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styled_SkeletonContainerHeaderWrapper__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SkeletonDefaultContainerHeader__ = __webpack_require__(177);



















var SkeletonContainerNavigation = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(SkeletonContainerNavigation, _Component);

  function SkeletonContainerNavigation() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SkeletonContainerNavigation);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SkeletonContainerNavigation.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(SkeletonContainerNavigation)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(SkeletonContainerNavigation, [{
    key: 'render',
    value: function render() {
      var ContainerHeaderComponent = this.props.containerHeaderComponent;
      var _props = this.props,
          theme = _props.theme,
          isCollapsed = _props.isCollapsed;

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__theme_util__["a" /* WithRootTheme */],
        { provided: theme, isCollapsed: isCollapsed },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11__styled_SkeletonContainerNavigationInner__["a" /* default */],
          { isCollapsed: isCollapsed },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_12__styled_SkeletonNavigationContentOuter__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10__ToggleWhenCollapsed__["b" /* ShownWhenCollapsed */],
                { isCollapsed: isCollapsed },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__SkeletonGlobalTopItems__["a" /* default */], null)
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_13__styled_SkeletonContainerHeaderWrapper__["a" /* default */],
                null,
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ContainerHeaderComponent, { isCollapsed: isCollapsed })
              ),
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__SkeletonContainerItems__["a" /* default */], { isCollapsed: isCollapsed })
            ),
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10__ToggleWhenCollapsed__["b" /* ShownWhenCollapsed */],
              { isCollapsed: isCollapsed },
              __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__SkeletonGlobalBottomItems__["a" /* default */], null)
            )
          )
        )
      );
    }
  }]);

  return SkeletonContainerNavigation;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

SkeletonContainerNavigation.defaultProps = {
  isCollapsed: false
};
/* harmony default export */ __webpack_exports__["a"] = (SkeletonContainerNavigation);

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SkeletonContainerItem__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styled_SkeletonNavigationItems__ = __webpack_require__(175);











var SkeletonContainerItems = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(SkeletonContainerItems, _Component);

  function SkeletonContainerItems() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SkeletonContainerItems);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SkeletonContainerItems.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(SkeletonContainerItems)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(SkeletonContainerItems, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isCollapsed = _props.isCollapsed,
          itemTextWidth = _props.itemTextWidth;

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__styled_SkeletonNavigationItems__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__SkeletonContainerItem__["a" /* default */], {
          isCollapsed: isCollapsed,
          itemTextWidth: itemTextWidth
        }),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__SkeletonContainerItem__["a" /* default */], {
          isCollapsed: isCollapsed,
          itemTextWidth: itemTextWidth
        }),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__SkeletonContainerItem__["a" /* default */], {
          isCollapsed: isCollapsed,
          itemTextWidth: itemTextWidth
        }),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__SkeletonContainerItem__["a" /* default */], {
          isCollapsed: isCollapsed,
          itemTextWidth: itemTextWidth
        }),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__SkeletonContainerItem__["a" /* default */], {
          isCollapsed: isCollapsed,
          itemTextWidth: itemTextWidth
        })
      );
    }
  }]);

  return SkeletonContainerItems;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

SkeletonContainerItems.defaultProps = {
  isCollapsed: false
};
/* harmony default export */ __webpack_exports__["a"] = (SkeletonContainerItems);

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_icon__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ToggleWhenCollapsed__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styled_SkeletonContainerItemWrapper__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styled_SkeletonContainerItemText__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styled_SkeletonIconWrapper__ = __webpack_require__(739);















var SkeletonContainerItem = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(SkeletonContainerItem, _Component);

  function SkeletonContainerItem() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SkeletonContainerItem);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SkeletonContainerItem.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(SkeletonContainerItem)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(SkeletonContainerItem, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__styled_SkeletonContainerItemWrapper__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10__styled_SkeletonIconWrapper__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__atlaskit_icon__["a" /* Skeleton */], null)
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__ToggleWhenCollapsed__["a" /* HiddenWhenCollapsed */],
          { isCollapsed: this.props.isCollapsed },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styled_SkeletonContainerItemText__["a" /* default */], { textWidth: this.props.itemTextWidth })
        )
      );
    }
  }]);

  return SkeletonContainerItem;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

SkeletonContainerItem.defaultProps = {
  isCollapsed: false
};
/* harmony default export */ __webpack_exports__["a"] = (SkeletonContainerItem);

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Avatar__ = __webpack_require__(742);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Avatar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AvatarItem__ = __webpack_require__(763);
/* unused harmony reexport AvatarItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Presence__ = __webpack_require__(315);
/* unused harmony reexport Presence */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Status__ = __webpack_require__(318);
/* unused harmony reexport Status */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Skeleton__ = __webpack_require__(764);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__components_Skeleton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styled_constants__ = __webpack_require__(49);
/* unused harmony reexport AVATAR_SIZES */
/* unused harmony reexport BORDER_WIDTH */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hoc__ = __webpack_require__(180);
/* unused harmony reexport withPseudoState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers__ = __webpack_require__(179);
/* unused harmony reexport getProps */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styled_utils__ = __webpack_require__(105);
/* unused harmony reexport getBorderRadius */
/* unused harmony reexport getInnerStyles */






// The below are exposed for use by avatarGroup







/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return validIconSizes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return propsOmittedFromClickData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styled_constants__ = __webpack_require__(49);



var validIconSizes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_1__styled_constants__["e" /* ICON_SIZES */]);

var propsOmittedFromClickData = ['onBlur', 'onClick', 'onFocus', 'onKeyDown', 'onKeyUp', 'onMouseDown', 'onMouseEnter', 'onMouseLeave', 'onMouseUp'];

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTheme;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__types__);

/* eslint-disable no-nested-ternary */




var defaultTheme = { mode: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* DEFAULT_THEME_MODE */] };

function getTheme(props) {
  return props && props.theme && props.theme[__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CHANNEL */]] ? props.theme[__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CHANNEL */]] : defaultTheme;
}

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FLATTENED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANNEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_THEME_MODE; });
/* unused harmony export THEME_MODES */
var FLATTENED = '__FLATTENED__';
var CHANNEL = '__ATLASKIT_THEME__';
var DEFAULT_THEME_MODE = 'light';
var THEME_MODES = ['light', 'dark'];

/***/ }),
/* 314 */
/***/ (function(module, exports) {



/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styled_Icon__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_getPresenceSVG__ = __webpack_require__(317);









var Presence = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Presence, _Component);

  function Presence() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Presence);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Presence.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Presence)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Presence, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          borderColor = _props.borderColor,
          children = _props.children,
          presence = _props.presence,
          size = _props.size;


      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__styled_Icon__["b" /* Outer */],
        { size: size, bgColor: borderColor },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__styled_Icon__["a" /* Inner */],
          null,
          children || presence && Object(__WEBPACK_IMPORTED_MODULE_7__helpers_getPresenceSVG__["a" /* default */])(presence)
        )
      );
    }
  }]);

  return Presence;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Presence);

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Outer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Inner; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(49);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  align-content: center;\n  align-items: center;\n  background-color: ', ';\n  border-radius: 50%;\n  box-sizing: border-box;\n  display: flex;\n  height: 100%;\n  overflow: hidden;\n  padding: ', 'px;\n  width: 100%;\n'], ['\n  align-content: center;\n  align-items: center;\n  background-color: ', ';\n  border-radius: 50%;\n  box-sizing: border-box;\n  display: flex;\n  height: 100%;\n  overflow: hidden;\n  padding: ', 'px;\n  width: 100%;\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  align-items: center;\n  border-radius: 50%;\n  display: flex;\n  height: 100%;\n  overflow: hidden;\n  width: 100%;\n'], ['\n  align-items: center;\n  border-radius: 50%;\n  display: flex;\n  height: 100%;\n  overflow: hidden;\n  width: 100%;\n']);





// set fallbacks for border color/width to protect consumers from invalid values
var Outer = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(_templateObject, function (props) {
  return props.bgColor || __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].background;
}, function (_ref) {
  var size = _ref.size;
  return __WEBPACK_IMPORTED_MODULE_3__constants__["c" /* BORDER_WIDTH */][size] || __WEBPACK_IMPORTED_MODULE_3__constants__["c" /* BORDER_WIDTH */].medium;
});

var Inner = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(_templateObject2);

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getPresenceSvg;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__ = __webpack_require__(26);



var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  fill: ', ';\n'], ['\n  fill: ', ';\n']);






var Svg = function Svg(props) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('svg', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    height: '100%',
    version: '1.1',
    viewBox: '0 0 8 8',
    width: '100%',
    xmlns: 'http://www.w3.org/2000/svg'
  }, props));
};

var BusyCircle = __WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].circle(_templateObject, Object(__WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["b" /* colors */].R300, dark: __WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["b" /* colors */].R200 }));
var BusyPath = __WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].path(_templateObject, __WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["b" /* colors */].background);
var FocusPath = __WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].path(_templateObject, __WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["b" /* colors */].purple);
var OfflineOuter = __WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].path(_templateObject, Object(__WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["b" /* colors */].N200, dark: __WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["b" /* colors */].DN100 }));
var OfflineInner = __WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].path(_templateObject, Object(__WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["b" /* colors */].N40, dark: __WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["b" /* colors */].DN500 }));
var OnlineCircle = __WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].circle(_templateObject, Object(__WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["b" /* colors */].G300, dark: __WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["b" /* colors */].G200 }));

function getPresenceSvg(presence) {
  switch (presence) {
    case 'busy':
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        Svg,
        null,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(BusyCircle, { cx: '4', cy: '4', r: '4' }),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(BusyPath, { d: 'M3.3,1.9l2.8,2.8c0.2,0.2,0.2,0.5,0,0.7L5.4,6.1c-0.2,0.2-0.5,0.2-0.7,0L1.9,3.3c-0.2-0.2-0.2-0.5,0-0.7l0.7-0.7C2.8,1.7,3.1,1.7,3.3,1.9z' })
      );
    case 'focus':
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        Svg,
        null,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(FocusPath, { d: 'M4,8 C1.790861,8 0,6.209139 0,4 C0,1.790861 1.790861,0 4,0 C6.209139,0 8,1.790861 8,4 C8,6.209139 6.209139,8 4,8 Z M4,6.66666667 C5.47275933,6.66666667 6.66666667,5.47275933 6.66666667,4 C6.66666667,2.52724067 5.47275933,1.33333333 4,1.33333333 C2.52724067,1.33333333 1.33333333,2.52724067 1.33333333,4 C1.33333333,5.47275933 2.52724067,6.66666667 4,6.66666667 Z M4,5.33333333 C3.26362033,5.33333333 2.66666667,4.73637967 2.66666667,4 C2.66666667,3.26362033 3.26362033,2.66666667 4,2.66666667 C4.73637967,2.66666667 5.33333333,3.26362033 5.33333333,4 C5.33333333,4.73637967 4.73637967,5.33333333 4,5.33333333 Z' })
      );
    case 'offline':
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        Svg,
        null,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(OfflineOuter, { d: 'M4,8 C6.209139,8 8,6.209139 8,4 C8,1.790861 6.209139,0 4,0 C1.790861,0 0,1.790861 0,4 C0,6.209139 1.790861,8 4,8 Z M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z' }),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(OfflineInner, { d: 'M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z' })
      );
    case 'online':
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        Svg,
        null,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(OnlineCircle, { cx: '4', cy: '4', r: '4' })
      );
    default:
      return null;
  }
}

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styled_Icon__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_getStatusSVG__ = __webpack_require__(319);









var Status = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Status, _Component);

  function Status() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Status);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Status.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Status)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Status, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          borderColor = _props.borderColor,
          children = _props.children,
          status = _props.status,
          size = _props.size;


      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__styled_Icon__["b" /* Outer */],
        { size: size, bgColor: borderColor },
        children || status && Object(__WEBPACK_IMPORTED_MODULE_7__helpers_getStatusSVG__["a" /* default */])(status)
      );
    }
  }]);

  return Status;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Status);

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getStatusSvg;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__ = __webpack_require__(26);



var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  fill: ', ';\n'], ['\n  fill: ', ';\n']);





var Svg = function Svg(props) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('svg', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    height: '100%',
    version: '1.1',
    viewBox: '0 0 8 8',
    width: '100%',
    xmlns: 'http://www.w3.org/2000/svg'
  }, props));
};

var ApprovedCircle = __WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].circle(_templateObject, Object(__WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["b" /* colors */].G400, dark: __WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["b" /* colors */].G300 }));
var ApprovedPath = __WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].path(_templateObject, __WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["b" /* colors */].background);
var DeclinedCircle = __WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].circle(_templateObject, Object(__WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["b" /* colors */].R400, dark: __WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["b" /* colors */].R300 }));
var DeclinedPath = __WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].path(_templateObject, __WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["b" /* colors */].background);
var LockedCircle = __WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].circle(_templateObject, Object(__WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["b" /* colors */].N40, dark: __WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["b" /* colors */].DN800 }));
var LockedPath = __WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].path(_templateObject, Object(__WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["b" /* colors */].N500, dark: __WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["b" /* colors */].DN30 }));

function getStatusSvg(status) {
  switch (status) {
    case 'approved':
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        Svg,
        null,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ApprovedCircle, { cx: '4', cy: '4', r: '4' }),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ApprovedPath, { d: 'M2.47140452,3.52859548 C2.21105499,3.26824595 1.78894501,3.26824595 1.52859548,3.52859548 C1.26824595,3.78894501 1.26824595,4.21105499 1.52859548,4.47140452 L2.86192881,5.80473785 C3.12227834,6.06508738 3.54438833,6.06508738 3.80473785,5.80473785 L6.47140452,3.13807119 C6.73175405,2.87772166 6.73175405,2.45561167 6.47140452,2.19526215 C6.21105499,1.93491262 5.78894501,1.93491262 5.52859548,2.19526215 L3.33333333,4.39052429 L2.47140452,3.52859548 Z' })
      );
    case 'declined':
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        Svg,
        null,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(DeclinedCircle, { cx: '4', cy: '4', r: '4' }),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(DeclinedPath, { d: 'M4.890661,4.0088336 L5.81806461,3.07802178 C6.06167933,2.83351177 6.06048933,2.43826992 5.81540668,2.19522442 C5.57032402,1.95217891 5.17415651,1.95336612 4.93054179,2.19787613 L4.00765946,3.12415007 L3.06906871,2.18377143 C2.82523777,1.93947602 2.42906937,1.93863765 2.18420182,2.18189887 C1.93933427,2.42516008 1.93849394,2.82040282 2.18232488,3.06469822 L3.12544091,4.00961077 L2.20275024,4.93569234 C1.95913552,5.18020236 1.96032551,5.5754442 2.20540817,5.81848971 C2.45049083,6.06153521 2.84665833,6.060348 3.09027306,5.81583799 L4.00844245,4.89429431 L4.9092123,5.79678001 C5.15304324,6.04107541 5.54921164,6.04191379 5.79407919,5.79865257 C6.03894674,5.55539135 6.03978708,5.16014862 5.79595614,4.91585321 L4.890661,4.0088336 Z' })
      );
    case 'locked':
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        Svg,
        null,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(LockedCircle, { cx: '4', cy: '4', r: '4' }),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(LockedPath, { d: 'M4.13074827,1.21766493 L4.10368158,1.21766493 C3.36340745,1.21766493 2.76388015,1.80793503 2.76388015,2.5367787 L2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,2.54344089 C3.44054754,2.17901906 3.74031119,1.88388401 4.11044825,1.88388401 L4.1239816,1.88388401 C4.49411866,1.88388401 4.79388232,2.17901906 4.79388232,2.54344089 L4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,2.5367787 C5.47054971,1.80793503 4.8710224,1.21766493 4.13074827,1.21766493 M2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,3.88254123 L2.76388015,3.88254123 L2.76388015,3.21632216 Z M4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,3.88254123 L4.79388232,3.88254123 L4.79388232,3.21632216 Z M4.79401765,3.88254123 L3.44068287,3.88254123 L2.76401548,3.88254123 C2.39049508,3.88254123 2.08734809,4.18100738 2.08734809,4.54876031 L2.08734809,5.54808892 C2.08734809,6.10000287 2.53735205,6.54741753 3.09094491,6.54741753 L5.14375561,6.54741753 C5.69802683,6.54741753 6.14735243,6.10385072 6.14735243,5.54808892 L6.14735243,4.54876031 C6.14735243,4.18100738 5.84420544,3.88254123 5.47068504,3.88254123 L4.79401765,3.88254123 Z' })
      );
    default:
      return null;
  }
}

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CustomComponentProxy__ = __webpack_require__(759);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['&,&:hover,&:active,&:focus{', '}'], ['&,&:hover,&:active,&:focus{', '}']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    ', ';\n  '], ['\n    ', ';\n  ']),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    a& {\n      ', ';\n    }\n  '], ['\n    a& {\n      ', ';\n    }\n  ']);





// This is necessary because we don't know what DOM element the custom component will render.
/* harmony default export */ __webpack_exports__["a"] = (function (styles) {
  var StyledCustomComponent = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_3__components_CustomComponentProxy__["a" /* default */])(_templateObject, styles);
  var StyledButton = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].button(_templateObject2, styles);
  var StyledLink = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].a(_templateObject3, styles);
  var StyledSpan = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(_templateObject2, styles);

  return function getStyled(_ref) {
    var component = _ref.component,
        href = _ref.href,
        onClick = _ref.onClick;

    if (component) {
      return StyledCustomComponent;
    } else if (href) {
      return StyledLink;
    } else if (onClick) {
      return StyledButton;
    }
    return StyledSpan;
  };
});

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = getBackgroundColor;
/* harmony export (immutable) */ __webpack_exports__["e"] = getStyles;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Content; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PrimaryText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SecondaryText; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(26);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    align-items: center;\n    background-color: ', ';\n    border-radius: ', 'px;\n    border: 2px solid ', ';\n    box-sizing: content-box;\n    color: inherit;\n    cursor: ', ';\n    display: flex;\n    font-size: inherit;\n    font-style: normal;\n    font-weight: normal;\n    line-height: 1;\n    opacity: ', ';\n    outline: ', ';\n    margin: 0;\n    padding: ', 'px;\n    pointer-events: ', ';\n    text-align: left;\n    text-decoration: none;\n    width: 100%;\n  '], ['\n    align-items: center;\n    background-color: ', ';\n    border-radius: ', 'px;\n    border: 2px solid ', ';\n    box-sizing: content-box;\n    color: inherit;\n    cursor: ', ';\n    display: flex;\n    font-size: inherit;\n    font-style: normal;\n    font-weight: normal;\n    line-height: 1;\n    opacity: ', ';\n    outline: ', ';\n    margin: 0;\n    padding: ', 'px;\n    pointer-events: ', ';\n    text-align: left;\n    text-decoration: none;\n    width: 100%;\n  ']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    overflow-x: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  '], ['\n    overflow-x: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  ']),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    max-width: 100%;\n    min-width: 0;\n  '], ['\n    max-width: 100%;\n    min-width: 0;\n  ']),
    _templateObject4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' flex: 1 1 100%;\n  line-height: 1.4;\n  padding-left: ', 'px;\n'], ['\n  ', ' flex: 1 1 100%;\n  line-height: 1.4;\n  padding-left: ', 'px;\n']),
    _templateObject5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n'], ['\n  ', ' color: ', ';\n']),
    _templateObject6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-size: 0.85em;\n'], ['\n  ', ' color: ', ';\n  font-size: 0.85em;\n']);





var activeBackgroundColor = Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* themed */])({
  light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].B50,
  dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].DN40
});
var hoverBackgroundColor = Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* themed */])({
  light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].N30,
  dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].DN50
});
var focusBorderColor = Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* themed */])({
  light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].B200,
  dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].B75
});

function getBackgroundColor(_ref) {
  var backgroundColor = _ref.backgroundColor,
      href = _ref.href,
      isActive = _ref.isActive,
      isHover = _ref.isHover,
      isSelected = _ref.isSelected,
      onClick = _ref.onClick;

  var isInteractive = href || onClick;

  var themedBackgroundColor = backgroundColor || __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].background;

  // Interaction: Hover
  if (isInteractive && (isHover || isSelected)) {
    themedBackgroundColor = hoverBackgroundColor;
  }

  // Interaction: Active
  if (isInteractive && isActive) {
    themedBackgroundColor = activeBackgroundColor;
  }

  return themedBackgroundColor;
}

function getStyles(_ref2) {
  var href = _ref2.href,
      isActive = _ref2.isActive,
      isDisabled = _ref2.isDisabled,
      isFocus = _ref2.isFocus,
      onClick = _ref2.onClick;

  var isInteractive = href || onClick;

  var borderColor = 'transparent';
  var cursor = 'auto';
  var opacity = 1;
  var outline = 'none';
  var pointerEvents = 'auto';

  // Interaction: Focus
  if (isInteractive && isFocus && !isActive) {
    outline = 'none';
    borderColor = focusBorderColor;
  }

  // Disabled
  if (isDisabled) {
    cursor = 'not-allowed';
    opacity = 0.75;
    pointerEvents = 'none';
  }

  // Interactive
  if (isInteractive) {
    cursor = 'pointer';
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject, getBackgroundColor, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* borderRadius */], borderColor, cursor, opacity, outline, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["e" /* math */].divide(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */], 2), pointerEvents);
}

var truncateText = function truncateText(p) {
  return p.truncate && Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject2);
};
var truncateTextFlexParent = function truncateTextFlexParent(p) {
  return p.truncate && Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject3);
};

var Content = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject4, truncateTextFlexParent, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */]);
var PrimaryText = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject5, truncateText, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].text);
var SecondaryText = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject6, truncateText, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].subtleText);

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{style:{marginBottom:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'This application is bootstrapped using ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://github.com/facebook/create-react-app'},'create-react-app'),' and ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://atlaskit.atlassian.com/'},'Atlaskit'),'.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'This gives a working navigation component you can start hacking on, see /src/components/StarterNavigation.js.'));});

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_page__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__ = __webpack_require__(324);
var _templateObject=_taggedTemplateLiteral(['\n  margin: ','px ','px;\n  padding-bottom: ','px;\n'],['\n  margin: ','px ','px;\n  padding-bottom: ','px;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Padding=__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject,Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["a" /* gridSize */])()*4,Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["a" /* gridSize */])()*8,Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["a" /* gridSize */])()*3);/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__atlaskit_page__["a" /* Grid */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__atlaskit_page__["b" /* GridColumn */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Padding,null,children)));});

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AtlasKitThemeProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color_palettes__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elevation__ = __webpack_require__(794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__typography__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_math__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_getTheme__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_themed__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_AtlaskitThemeProvider__ = __webpack_require__(797);
/* unused harmony reexport colors */
/* unused harmony reexport colorPalettes */
/* unused harmony reexport elevation */
/* unused harmony reexport typography */
/* unused harmony reexport math */
/* unused harmony reexport getTheme */
/* unused harmony reexport themed */
/* unused harmony reexport AtlaskitThemeProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Appearance__ = __webpack_require__(806);
/* unused harmony reexport Appearance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(181);
/* unused harmony reexport CHANNEL */
/* unused harmony reexport DEFAULT_THEME_MODE */
/* unused harmony reexport FLATTENED */
/* unused harmony reexport THEME_MODES */
/* unused harmony reexport assistive */
/* unused harmony reexport borderRadius */
/* unused harmony reexport codeFontFamily */
/* unused harmony reexport focusRing */
/* unused harmony reexport fontFamily */
/* unused harmony reexport fontSize */
/* unused harmony reexport fontSizeSmall */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_9__constants__["d"]; });
/* unused harmony reexport layers */
/* unused harmony reexport noFocusRing */
/* unused harmony reexport skeletonShimmer */
/* unused harmony reexport visuallyHidden */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Reset__ = __webpack_require__(807);
/* unused harmony reexport Reset */
/* unused harmony reexport ResetTheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Theme__ = __webpack_require__(183);
/* unused harmony reexport default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__hoc__ = __webpack_require__(808);
/* unused harmony reexport withTheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_createTheme__ = __webpack_require__(184);
/* unused harmony reexport createTheme */









 // backwards-compatible export with old Atlaskit case

var AtlasKitThemeProvider = __WEBPACK_IMPORTED_MODULE_7__components_AtlaskitThemeProvider__["a" /* default */];






/***/ }),
/* 325 */
/***/ (function(module, exports) {

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

module.exports = _arrayLikeToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 326 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 327 */
/***/ (function(module, exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  }

  return _typeof(obj);
}

module.exports = _typeof;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 328 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  module.exports["default"] = module.exports, module.exports.__esModule = true;
  return _extends.apply(this, arguments);
}

module.exports = _extends;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__ = __webpack_require__(324);
var _templateObject=_taggedTemplateLiteral(['\n  margin-bottom: ','px;\n'],['\n  margin-bottom: ','px;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var PageTitle=__WEBPACK_IMPORTED_MODULE_0_styled_components__["default"].h1(_templateObject,Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_theme__["a" /* gridSize */])()*2);/* harmony default export */ __webpack_exports__["a"] = (PageTitle);

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(331);
module.exports = __webpack_require__(336);


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(332).enable();
  window.Promise = __webpack_require__(334);
}

// fetch() polyfill for making API calls.
__webpack_require__(335);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(50);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(185);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(72)))

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(185);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 335 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_MainRouter__ = __webpack_require__(345);
// eslint-disable-next-line no-undef
__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__modules_MainRouter__["a" /* default */],null),document.getElementById('app-root'));

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.4.2
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var k=__webpack_require__(50),n=__webpack_require__(108),p=__webpack_require__(109),q=__webpack_require__(186),r="function"===typeof Symbol&&Symbol.for,t=r?Symbol.for("react.element"):60103,u=r?Symbol.for("react.portal"):60106,v=r?Symbol.for("react.fragment"):60107,w=r?Symbol.for("react.strict_mode"):60108,x=r?Symbol.for("react.profiler"):60114,y=r?Symbol.for("react.provider"):60109,z=r?Symbol.for("react.context"):60110,A=r?Symbol.for("react.async_mode"):60111,B=
r?Symbol.for("react.forward_ref"):60112;r&&Symbol.for("react.timeout");var C="function"===typeof Symbol&&Symbol.iterator;function D(a){for(var b=arguments.length-1,e="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)e+="&args[]="+encodeURIComponent(arguments[c+1]);n(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",e)}
var E={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function F(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||E}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?D("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function G(){}
G.prototype=F.prototype;function H(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||E}var I=H.prototype=new G;I.constructor=H;k(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,e){var c=void 0,d={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];d.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:t,type:a,key:g,ref:h,props:d,_owner:J.current}}
function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===t}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,e,c){if(P.length){var d=P.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case t:case u:g=!0}}if(g)return e(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){d=a[h];var f=b+T(d,h);g+=S(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=C&&a[C]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),
h=0;!(d=a.next()).done;)d=d.value,f=b+T(d,h++),g+=S(d,f,e,c);else"object"===d&&(e=""+a,D("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function U(a,b){a.func.call(a.context,b,a.count++)}
function V(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?W(a,c,e,q.thatReturnsArgument):null!=a&&(N(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+e,a={$$typeof:t,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function W(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(O,"$&/")+"/");b=Q(b,g,c,d);null==a||S(a,"",V,b);R(b)}
var X={Children:{map:function(a,b,e){if(null==a)return a;var c=[];W(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=Q(null,null,b,e);null==a||S(a,"",U,b);R(b)},count:function(a){return null==a?0:S(a,"",q.thatReturnsNull,null)},toArray:function(a){var b=[];W(a,b,null,q.thatReturnsArgument);return b},only:function(a){N(a)?void 0:D("143");return a}},createRef:function(){return{current:null}},Component:F,PureComponent:H,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:z,
_calculateChangedBits:b,_defaultValue:a,_currentValue:a,_currentValue2:a,_changedBits:0,_changedBits2:0,Provider:null,Consumer:null};a.Provider={$$typeof:y,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:B,render:a}},Fragment:v,StrictMode:w,unstable_AsyncMode:A,unstable_Profiler:x,createElement:M,cloneElement:function(a,b,e){null===a||void 0===a?D("267",a):void 0;var c=void 0,d=k({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(h=b.ref,f=J.current);void 0!==
b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(d[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)d.children=e;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];d.children=l}return{$$typeof:t,type:a.type,key:g,ref:h,props:d,_owner:f}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.4.2",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:J,
assign:k}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default?Z.default:Z;


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.4.2
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(108),ba=__webpack_require__(0),m=__webpack_require__(339),p=__webpack_require__(50),v=__webpack_require__(186),da=__webpack_require__(340),ea=__webpack_require__(341),fa=__webpack_require__(342),ha=__webpack_require__(109);
function A(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);aa(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}ba?void 0:A("227");
function ia(a,b,c,d,e,f,g,h,k){this._hasCaughtError=!1;this._caughtError=null;var n=Array.prototype.slice.call(arguments,3);try{b.apply(c,n)}catch(r){this._caughtError=r,this._hasCaughtError=!0}}
var B={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,invokeGuardedCallback:function(a,b,c,d,e,f,g,h,k){ia.apply(B,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,g,h,k){B.invokeGuardedCallback.apply(this,arguments);if(B.hasCaughtError()){var n=B.clearCaughtError();B._hasRethrowError||(B._hasRethrowError=!0,B._rethrowError=n)}},rethrowCaughtError:function(){return ka.apply(B,arguments)},hasCaughtError:function(){return B._hasCaughtError},clearCaughtError:function(){if(B._hasCaughtError){var a=
B._caughtError;B._caughtError=null;B._hasCaughtError=!1;return a}A("198")}};function ka(){if(B._hasRethrowError){var a=B._rethrowError;B._rethrowError=null;B._hasRethrowError=!1;throw a;}}var la=null,ma={};
function na(){if(la)for(var a in ma){var b=ma[a],c=la.indexOf(a);-1<c?void 0:A("96",a);if(!oa[c]){b.extractEvents?void 0:A("97",a);oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;pa.hasOwnProperty(h)?A("99",h):void 0;pa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&qa(k[e],g,h);e=!0}else f.registrationName?(qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:A("98",d,a)}}}}
function qa(a,b,c){ra[a]?A("100",a):void 0;ra[a]=b;sa[a]=b.eventTypes[c].dependencies}var oa=[],pa={},ra={},sa={};function ta(a){la?A("101"):void 0;la=Array.prototype.slice.call(a);na()}function ua(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];ma.hasOwnProperty(c)&&ma[c]===d||(ma[c]?A("102",c):void 0,ma[c]=d,b=!0)}b&&na()}
var va={plugins:oa,eventNameDispatchConfigs:pa,registrationNameModules:ra,registrationNameDependencies:sa,possibleRegistrationNames:null,injectEventPluginOrder:ta,injectEventPluginsByName:ua},wa=null,xa=null,ya=null;function za(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=ya(d);B.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
function Aa(a,b){null==b?A("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function Ba(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Ca=null;
function Da(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)za(a,b,c[e],d[e]);else c&&za(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Ea(a){return Da(a,!0)}function Fa(a){return Da(a,!1)}var Ga={injectEventPluginOrder:ta,injectEventPluginsByName:ua};
function Ha(a,b){var c=a.stateNode;if(!c)return null;var d=wa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?A("231",b,typeof c):void 0;
return c}function Ia(a,b){null!==a&&(Ca=Aa(Ca,a));a=Ca;Ca=null;a&&(b?Ba(a,Ea):Ba(a,Fa),Ca?A("95"):void 0,B.rethrowCaughtError())}function Ja(a,b,c,d){for(var e=null,f=0;f<oa.length;f++){var g=oa[f];g&&(g=g.extractEvents(a,b,c,d))&&(e=Aa(e,g))}Ia(e,!1)}var Ka={injection:Ga,getListener:Ha,runEventsInBatch:Ia,runExtractedEventsInBatch:Ja},La=Math.random().toString(36).slice(2),C="__reactInternalInstance$"+La,Ma="__reactEventHandlers$"+La;
function Na(a){if(a[C])return a[C];for(;!a[C];)if(a.parentNode)a=a.parentNode;else return null;a=a[C];return 5===a.tag||6===a.tag?a:null}function Oa(a){if(5===a.tag||6===a.tag)return a.stateNode;A("33")}function Pa(a){return a[Ma]||null}var Qa={precacheFiberNode:function(a,b){b[C]=a},getClosestInstanceFromNode:Na,getInstanceFromNode:function(a){a=a[C];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:Oa,getFiberCurrentPropsFromNode:Pa,updateFiberProps:function(a,b){a[Ma]=b}};
function F(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Ra(a,b,c){for(var d=[];a;)d.push(a),a=F(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}function Sa(a,b,c){if(b=Ha(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=Aa(c._dispatchListeners,b),c._dispatchInstances=Aa(c._dispatchInstances,a)}function Ta(a){a&&a.dispatchConfig.phasedRegistrationNames&&Ra(a._targetInst,Sa,a)}
function Ua(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?F(b):null;Ra(b,Sa,a)}}function Va(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Ha(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=Aa(c._dispatchListeners,b),c._dispatchInstances=Aa(c._dispatchInstances,a))}function Xa(a){a&&a.dispatchConfig.registrationName&&Va(a._targetInst,null,a)}function Ya(a){Ba(a,Ta)}
function Za(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,g=0,h=e;h;h=F(h))g++;h=0;for(var k=f;k;k=F(k))h++;for(;0<g-h;)e=F(e),g--;for(;0<h-g;)f=F(f),h--;for(;g--;){if(e===f||e===f.alternate)break a;e=F(e);f=F(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){g=c.alternate;if(null!==g&&g===f)break;e.push(c);c=F(c)}for(c=[];d&&d!==f;){g=d.alternate;if(null!==g&&g===f)break;c.push(d);d=F(d)}for(d=0;d<e.length;d++)Va(e[d],"bubbled",a);for(a=c.length;0<a--;)Va(c[a],"captured",b)}
var $a={accumulateTwoPhaseDispatches:Ya,accumulateTwoPhaseDispatchesSkipTarget:function(a){Ba(a,Ua)},accumulateEnterLeaveDispatches:Za,accumulateDirectDispatches:function(a){Ba(a,Xa)}};function ab(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var bb={animationend:ab("Animation","AnimationEnd"),animationiteration:ab("Animation","AnimationIteration"),animationstart:ab("Animation","AnimationStart"),transitionend:ab("Transition","TransitionEnd")},cb={},db={};m.canUseDOM&&(db=document.createElement("div").style,"AnimationEvent"in window||(delete bb.animationend.animation,delete bb.animationiteration.animation,delete bb.animationstart.animation),"TransitionEvent"in window||delete bb.transitionend.transition);
function eb(a){if(cb[a])return cb[a];if(!bb[a])return a;var b=bb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in db)return cb[a]=b[c];return a}var fb=eb("animationend"),gb=eb("animationiteration"),hb=eb("animationstart"),ib=eb("transitionend"),jb="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),kb=null;
function lb(){!kb&&m.canUseDOM&&(kb="textContent"in document.documentElement?"textContent":"innerText");return kb}var G={_root:null,_startText:null,_fallbackText:null};function mb(){if(G._fallbackText)return G._fallbackText;var a,b=G._startText,c=b.length,d,e=nb(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);G._fallbackText=e.slice(a,1<d?1-d:void 0);return G._fallbackText}function nb(){return"value"in G._root?G._root.value:G._root[lb()]}
var ob="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),pb={type:null,target:null,currentTarget:v.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function H(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?v.thatReturnsTrue:v.thatReturnsFalse;this.isPropagationStopped=v.thatReturnsFalse;return this}
p(H.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=v.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=v.thatReturnsTrue)},persist:function(){this.isPersistent=v.thatReturnsTrue},isPersistent:v.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<ob.length;a++)this[ob[a]]=null}});H.Interface=pb;H.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;p(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=p({},d.Interface,a);c.extend=d.extend;qb(c);return c};qb(H);
function rb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function sb(a){a instanceof this?void 0:A("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function qb(a){a.eventPool=[];a.getPooled=rb;a.release=sb}var tb=H.extend({data:null}),ub=H.extend({data:null}),vb=[9,13,27,32],wb=m.canUseDOM&&"CompositionEvent"in window,xb=null;m.canUseDOM&&"documentMode"in document&&(xb=document.documentMode);
var yb=m.canUseDOM&&"TextEvent"in window&&!xb,zb=m.canUseDOM&&(!wb||xb&&8<xb&&11>=xb),Ab=String.fromCharCode(32),Bb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},Cb=!1;
function Db(a,b){switch(a){case "keyup":return-1!==vb.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function Eb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Fb=!1;function Gb(a,b){switch(a){case "compositionend":return Eb(b);case "keypress":if(32!==b.which)return null;Cb=!0;return Ab;case "textInput":return a=b.data,a===Ab&&Cb?null:a;default:return null}}
function Hb(a,b){if(Fb)return"compositionend"===a||!wb&&Db(a,b)?(a=mb(),G._root=null,G._startText=null,G._fallbackText=null,Fb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return zb?null:b.data;default:return null}}
var Ib={eventTypes:Bb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(wb)b:{switch(a){case "compositionstart":e=Bb.compositionStart;break b;case "compositionend":e=Bb.compositionEnd;break b;case "compositionupdate":e=Bb.compositionUpdate;break b}e=void 0}else Fb?Db(a,c)&&(e=Bb.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=Bb.compositionStart);e?(zb&&(Fb||e!==Bb.compositionStart?e===Bb.compositionEnd&&Fb&&(f=mb()):(G._root=d,G._startText=nb(),Fb=!0)),e=tb.getPooled(e,b,c,d),f?e.data=
f:(f=Eb(c),null!==f&&(e.data=f)),Ya(e),f=e):f=null;(a=yb?Gb(a,c):Hb(a,c))?(b=ub.getPooled(Bb.beforeInput,b,c,d),b.data=a,Ya(b)):b=null;return null===f?b:null===b?f:[f,b]}},Jb=null,Kb={injectFiberControlledHostComponent:function(a){Jb=a}},Lb=null,Mb=null;function Nb(a){if(a=xa(a)){Jb&&"function"===typeof Jb.restoreControlledState?void 0:A("194");var b=wa(a.stateNode);Jb.restoreControlledState(a.stateNode,a.type,b)}}function Ob(a){Lb?Mb?Mb.push(a):Mb=[a]:Lb=a}
function Pb(){return null!==Lb||null!==Mb}function Qb(){if(Lb){var a=Lb,b=Mb;Mb=Lb=null;Nb(a);if(b)for(a=0;a<b.length;a++)Nb(b[a])}}var Rb={injection:Kb,enqueueStateRestore:Ob,needsStateRestore:Pb,restoreStateIfNeeded:Qb};function Sb(a,b){return a(b)}function Tb(a,b,c){return a(b,c)}function Ub(){}var Vb=!1;function Wb(a,b){if(Vb)return a(b);Vb=!0;try{return Sb(a,b)}finally{Vb=!1,Pb()&&(Ub(),Qb())}}
var Xb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Yb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Xb[a.type]:"textarea"===b?!0:!1}function Zb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}
function $b(a,b){if(!m.canUseDOM||b&&!("addEventListener"in document))return!1;a="on"+a;b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function ac(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function bc(a){var b=ac(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function cc(a){a._valueTracker||(a._valueTracker=bc(a))}function dc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=ac(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}
var ec=ba.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,fc="function"===typeof Symbol&&Symbol.for,gc=fc?Symbol.for("react.element"):60103,hc=fc?Symbol.for("react.portal"):60106,ic=fc?Symbol.for("react.fragment"):60107,jc=fc?Symbol.for("react.strict_mode"):60108,kc=fc?Symbol.for("react.profiler"):60114,lc=fc?Symbol.for("react.provider"):60109,mc=fc?Symbol.for("react.context"):60110,pc=fc?Symbol.for("react.async_mode"):60111,qc=fc?Symbol.for("react.forward_ref"):60112,rc=fc?Symbol.for("react.timeout"):
60113,sc="function"===typeof Symbol&&Symbol.iterator;function tc(a){if(null===a||"undefined"===typeof a)return null;a=sc&&a[sc]||a["@@iterator"];return"function"===typeof a?a:null}
function uc(a){var b=a.type;if("function"===typeof b)return b.displayName||b.name;if("string"===typeof b)return b;switch(b){case pc:return"AsyncMode";case mc:return"Context.Consumer";case ic:return"ReactFragment";case hc:return"ReactPortal";case kc:return"Profiler("+a.pendingProps.id+")";case lc:return"Context.Provider";case jc:return"StrictMode";case rc:return"Timeout"}if("object"===typeof b&&null!==b)switch(b.$$typeof){case qc:return a=b.render.displayName||b.render.name||"",""!==a?"ForwardRef("+
a+")":"ForwardRef"}return null}function vc(a){var b="";do{a:switch(a.tag){case 0:case 1:case 2:case 5:var c=a._debugOwner,d=a._debugSource;var e=uc(a);var f=null;c&&(f=uc(c));c=d;e="\n    in "+(e||"Unknown")+(c?" (at "+c.fileName.replace(/^.*[\\\/]/,"")+":"+c.lineNumber+")":f?" (created by "+f+")":"");break a;default:e=""}b+=e;a=a.return}while(a);return b}
var wc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,xc=Object.prototype.hasOwnProperty,zc={},Ac={};
function Bc(a){if(xc.call(Ac,a))return!0;if(xc.call(zc,a))return!1;if(wc.test(a))return Ac[a]=!0;zc[a]=!0;return!1}function Cc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Dc(a,b,c,d){if(null===b||"undefined"===typeof b||Cc(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function I(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var J={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){J[a]=new I(a,0,!1,a,null)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];J[b]=new I(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){J[a]=new I(a,2,!1,a.toLowerCase(),null)});
["autoReverse","externalResourcesRequired","preserveAlpha"].forEach(function(a){J[a]=new I(a,2,!1,a,null)});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){J[a]=new I(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){J[a]=new I(a,3,!0,a.toLowerCase(),null)});
["capture","download"].forEach(function(a){J[a]=new I(a,4,!1,a.toLowerCase(),null)});["cols","rows","size","span"].forEach(function(a){J[a]=new I(a,6,!1,a.toLowerCase(),null)});["rowSpan","start"].forEach(function(a){J[a]=new I(a,5,!1,a.toLowerCase(),null)});var Ec=/[\-:]([a-z])/g;function Fc(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ec,
Fc);J[b]=new I(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ec,Fc);J[b]=new I(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ec,Fc);J[b]=new I(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});J.tabIndex=new I("tabIndex",1,!1,"tabindex",null);
function Gc(a,b,c,d){var e=J.hasOwnProperty(b)?J[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Dc(b,c,e,d)&&(c=null),d||null===e?Bc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function Hc(a,b){var c=b.checked;return p({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}function Ic(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Jc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Kc(a,b){b=b.checked;null!=b&&Gc(a,"checked",b,!1)}
function Lc(a,b){Kc(a,b);var c=Jc(b.value);if(null!=c)if("number"===b.type){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);b.hasOwnProperty("value")?Mc(a,b.type,c):b.hasOwnProperty("defaultValue")&&Mc(a,b.type,Jc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Nc(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){b=""+a._wrapperState.initialValue;var d=a.value;c||b===d||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==c&&(a.name=c)}function Mc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}
function Jc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}var Oc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Pc(a,b,c){a=H.getPooled(Oc.change,a,b,c);a.type="change";Ob(c);Ya(a);return a}var Qc=null,Rc=null;function Sc(a){Ia(a,!1)}function Tc(a){var b=Oa(a);if(dc(b))return a}
function Uc(a,b){if("change"===a)return b}var Vc=!1;m.canUseDOM&&(Vc=$b("input")&&(!document.documentMode||9<document.documentMode));function Wc(){Qc&&(Qc.detachEvent("onpropertychange",Xc),Rc=Qc=null)}function Xc(a){"value"===a.propertyName&&Tc(Rc)&&(a=Pc(Rc,a,Zb(a)),Wb(Sc,a))}function Yc(a,b,c){"focus"===a?(Wc(),Qc=b,Rc=c,Qc.attachEvent("onpropertychange",Xc)):"blur"===a&&Wc()}function Zc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Tc(Rc)}
function $c(a,b){if("click"===a)return Tc(b)}function ad(a,b){if("input"===a||"change"===a)return Tc(b)}
var bd={eventTypes:Oc,_isInputEventSupported:Vc,extractEvents:function(a,b,c,d){var e=b?Oa(b):window,f=void 0,g=void 0,h=e.nodeName&&e.nodeName.toLowerCase();"select"===h||"input"===h&&"file"===e.type?f=Uc:Yb(e)?Vc?f=ad:(f=Zc,g=Yc):(h=e.nodeName)&&"input"===h.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=$c);if(f&&(f=f(a,b)))return Pc(f,c,d);g&&g(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Mc(e,"number",e.value)}},cd=H.extend({view:null,detail:null}),dd={Alt:"altKey",
Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function ed(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=dd[a])?!!b[a]:!1}function fd(){return ed}
var gd=cd.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:fd,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}}),hd=gd.extend({pointerId:null,width:null,height:null,pressure:null,tiltX:null,tiltY:null,pointerType:null,isPrimary:null}),id={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},
mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",dependencies:["pointerout","pointerover"]}},jd={eventTypes:id,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||
e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Na(b):null):f=null;if(f===b)return null;var g=void 0,h=void 0,k=void 0,n=void 0;if("mouseout"===a||"mouseover"===a)g=gd,h=id.mouseLeave,k=id.mouseEnter,n="mouse";else if("pointerout"===a||"pointerover"===a)g=hd,h=id.pointerLeave,k=id.pointerEnter,n="pointer";a=null==f?e:Oa(f);e=null==b?e:Oa(b);h=g.getPooled(h,f,c,d);h.type=n+"leave";h.target=a;h.relatedTarget=e;c=g.getPooled(k,b,c,d);c.type=n+"enter";c.target=e;c.relatedTarget=a;Za(h,
c,f,b);return[h,c]}};function kd(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function ld(a){2!==kd(a)?A("188"):void 0}
function md(a){var b=a.alternate;if(!b)return b=kd(a),3===b?A("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return ld(e),a;if(g===d)return ld(e),b;g=g.sibling}A("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:A("189")}}c.alternate!==d?A("190"):void 0}3!==c.tag?A("188"):void 0;return c.stateNode.current===c?a:b}function nd(a){a=md(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function od(a){a=md(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}var pd=H.extend({animationName:null,elapsedTime:null,pseudoElement:null}),qd=H.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),rd=cd.extend({relatedTarget:null});
function sd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var td={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},ud={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},vd=cd.extend({key:function(a){if(a.key){var b=td[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=sd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?ud[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:fd,charCode:function(a){return"keypress"===
a.type?sd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?sd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),wd=gd.extend({dataTransfer:null}),xd=cd.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:fd}),yd=H.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),zd=gd.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),Ad=[["abort","abort"],[fb,"animationEnd"],[gb,"animationIteration"],[hb,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[ib,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],Bd={},Cd={};function Dd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};Bd[a]=b;Cd[c]=b}
[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],["pointerdown","pointerDown"],
["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){Dd(a,!0)});Ad.forEach(function(a){Dd(a,!1)});
var Ed={eventTypes:Bd,isInteractiveTopLevelEventType:function(a){a=Cd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=Cd[a];if(!e)return null;switch(a){case "keypress":if(0===sd(c))return null;case "keydown":case "keyup":a=vd;break;case "blur":case "focus":a=rd;break;case "click":if(2===c.button)return null;case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=gd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
wd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=xd;break;case fb:case gb:case hb:a=pd;break;case ib:a=yd;break;case "scroll":a=cd;break;case "wheel":a=zd;break;case "copy":case "cut":case "paste":a=qd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=hd;break;default:a=H}b=a.getPooled(e,b,c,d);Ya(b);return b}},Fd=Ed.isInteractiveTopLevelEventType,
Gd=[];function Hd(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c.return;)c=c.return;c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=Na(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],Ja(a.topLevelType,b,a.nativeEvent,Zb(a.nativeEvent))}var Id=!0;function Kd(a){Id=!!a}function K(a,b){if(!b)return null;var c=(Fd(a)?Ld:Md).bind(null,a);b.addEventListener(a,c,!1)}
function Nd(a,b){if(!b)return null;var c=(Fd(a)?Ld:Md).bind(null,a);b.addEventListener(a,c,!0)}function Ld(a,b){Tb(Md,a,b)}function Md(a,b){if(Id){var c=Zb(b);c=Na(c);null===c||"number"!==typeof c.tag||2===kd(c)||(c=null);if(Gd.length){var d=Gd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{Wb(Hd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Gd.length&&Gd.push(a)}}}
var Od={get _enabled(){return Id},setEnabled:Kd,isEnabled:function(){return Id},trapBubbledEvent:K,trapCapturedEvent:Nd,dispatchEvent:Md},Pd={},Qd=0,Rd="_reactListenersID"+(""+Math.random()).slice(2);function Sd(a){Object.prototype.hasOwnProperty.call(a,Rd)||(a[Rd]=Qd++,Pd[a[Rd]]={});return Pd[a[Rd]]}function Td(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Ud(a,b){var c=Td(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Td(c)}}function Vd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
var Wd=m.canUseDOM&&"documentMode"in document&&11>=document.documentMode,Xd={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Yd=null,Zd=null,$d=null,ae=!1;
function be(a,b){if(ae||null==Yd||Yd!==da())return null;var c=Yd;"selectionStart"in c&&Vd(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return $d&&ea($d,c)?null:($d=c,a=H.getPooled(Xd.select,Zd,a,b),a.type="select",a.target=Yd,Ya(a),a)}
var ce={eventTypes:Xd,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Sd(e);f=sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Oa(b):window;switch(a){case "focus":if(Yb(e)||"true"===e.contentEditable)Yd=e,Zd=b,$d=null;break;case "blur":$d=Zd=Yd=null;break;case "mousedown":ae=!0;break;case "contextmenu":case "mouseup":return ae=!1,be(c,d);case "selectionchange":if(Wd)break;
case "keydown":case "keyup":return be(c,d)}return null}};Ga.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));wa=Qa.getFiberCurrentPropsFromNode;xa=Qa.getInstanceFromNode;ya=Qa.getNodeFromInstance;Ga.injectEventPluginsByName({SimpleEventPlugin:Ed,EnterLeaveEventPlugin:jd,ChangeEventPlugin:bd,SelectEventPlugin:ce,BeforeInputEventPlugin:Ib});
var de="function"===typeof requestAnimationFrame?requestAnimationFrame:void 0,ee=Date,fe=setTimeout,ge=clearTimeout,he=void 0;if("object"===typeof performance&&"function"===typeof performance.now){var ie=performance;he=function(){return ie.now()}}else he=function(){return ee.now()};var je=void 0,ke=void 0;
if(m.canUseDOM){var le="function"===typeof de?de:function(){A("276")},L=null,me=null,ne=-1,oe=!1,pe=!1,qe=0,re=33,se=33,te={didTimeout:!1,timeRemaining:function(){var a=qe-he();return 0<a?a:0}},ve=function(a,b){var c=a.scheduledCallback,d=!1;try{c(b),d=!0}finally{ke(a),d||(oe=!0,window.postMessage(ue,"*"))}},ue="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===ue&&(oe=!1,null!==L)){if(null!==L){var b=he();if(!(-1===
ne||ne>b)){a=-1;for(var c=[],d=L;null!==d;){var e=d.timeoutTime;-1!==e&&e<=b?c.push(d):-1!==e&&(-1===a||e<a)&&(a=e);d=d.next}if(0<c.length)for(te.didTimeout=!0,b=0,d=c.length;b<d;b++)ve(c[b],te);ne=a}}for(a=he();0<qe-a&&null!==L;)a=L,te.didTimeout=!1,ve(a,te),a=he();null===L||pe||(pe=!0,le(we))}},!1);var we=function(a){pe=!1;var b=a-qe+se;b<se&&re<se?(8>b&&(b=8),se=b<re?re:b):re=b;qe=a+se;oe||(oe=!0,window.postMessage(ue,"*"))};je=function(a,b){var c=-1;null!=b&&"number"===typeof b.timeout&&(c=he()+
b.timeout);if(-1===ne||-1!==c&&c<ne)ne=c;a={scheduledCallback:a,timeoutTime:c,prev:null,next:null};null===L?L=a:(b=a.prev=me,null!==b&&(b.next=a));me=a;pe||(pe=!0,le(we));return a};ke=function(a){if(null!==a.prev||L===a){var b=a.next,c=a.prev;a.next=null;a.prev=null;null!==b?null!==c?(c.next=b,b.prev=c):(b.prev=null,L=b):null!==c?(c.next=null,me=c):me=L=null}}}else{var xe=new Map;je=function(a){var b={scheduledCallback:a,timeoutTime:0,next:null,prev:null},c=fe(function(){a({timeRemaining:function(){return Infinity},
didTimeout:!1})});xe.set(a,c);return b};ke=function(a){var b=xe.get(a.scheduledCallback);xe.delete(a);ge(b)}}function ye(a){var b="";ba.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}function ze(a,b){a=p({children:void 0},b);if(b=ye(b.children))a.children=b;return a}
function Ae(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Be(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function Ce(a,b){null!=b.dangerouslySetInnerHTML?A("91"):void 0;return p({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function De(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?A("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:A("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
function Ee(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Fe(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Ge={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function He(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ie(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?He(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Je=void 0,Ke=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Ge.svg||"innerHTML"in a)a.innerHTML=b;else{Je=Je||document.createElement("div");Je.innerHTML="<svg>"+b+"</svg>";for(b=Je.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Le(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var Me={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Ne=["Webkit","ms","Moz","O"];Object.keys(Me).forEach(function(a){Ne.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Me[b]=Me[a]})});
function Oe(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||Me.hasOwnProperty(e)&&Me[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Pe=p({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function Qe(a,b,c){b&&(Pe[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?A("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?A("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:A("61")),null!=b.style&&"object"!==typeof b.style?A("62",c()):void 0)}
function Re(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var Se=v.thatReturns("");
function Te(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Sd(a);b=sa[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":Nd("scroll",a);break;case "focus":case "blur":Nd("focus",a);Nd("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":$b(e,!0)&&Nd(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===jb.indexOf(e)&&K(e,a)}c[e]=!0}}}
function Ue(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===Ge.html&&(d=He(a));d===Ge.html?"script"===a?(a=c.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function Ve(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
function We(a,b,c,d){var e=Re(b,c);switch(b){case "iframe":case "object":K("load",a);var f=c;break;case "video":case "audio":for(f=0;f<jb.length;f++)K(jb[f],a);f=c;break;case "source":K("error",a);f=c;break;case "img":case "image":case "link":K("error",a);K("load",a);f=c;break;case "form":K("reset",a);K("submit",a);f=c;break;case "details":K("toggle",a);f=c;break;case "input":Ic(a,c);f=Hc(a,c);K("invalid",a);Te(d,"onChange");break;case "option":f=ze(a,c);break;case "select":Be(a,c);f=p({},c,{value:void 0});
K("invalid",a);Te(d,"onChange");break;case "textarea":De(a,c);f=Ce(a,c);K("invalid",a);Te(d,"onChange");break;default:f=c}Qe(b,f,Se);var g=f,h;for(h in g)if(g.hasOwnProperty(h)){var k=g[h];"style"===h?Oe(a,k,Se):"dangerouslySetInnerHTML"===h?(k=k?k.__html:void 0,null!=k&&Ke(a,k)):"children"===h?"string"===typeof k?("textarea"!==b||""!==k)&&Le(a,k):"number"===typeof k&&Le(a,""+k):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ra.hasOwnProperty(h)?null!=k&&Te(d,
h):null!=k&&Gc(a,h,k,e))}switch(b){case "input":cc(a);Nc(a,c,!1);break;case "textarea":cc(a);Fe(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?Ae(a,!!c.multiple,b,!1):null!=c.defaultValue&&Ae(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=v)}}
function Xe(a,b,c,d,e){var f=null;switch(b){case "input":c=Hc(a,c);d=Hc(a,d);f=[];break;case "option":c=ze(a,c);d=ze(a,d);f=[];break;case "select":c=p({},c,{value:void 0});d=p({},d,{value:void 0});f=[];break;case "textarea":c=Ce(a,c);d=Ce(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=v)}Qe(b,d,Se);b=a=void 0;var g=null;for(a in c)if(!d.hasOwnProperty(a)&&c.hasOwnProperty(a)&&null!=c[a])if("style"===a){var h=c[a];for(b in h)h.hasOwnProperty(b)&&(g||
(g={}),g[b]="")}else"dangerouslySetInnerHTML"!==a&&"children"!==a&&"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&"autoFocus"!==a&&(ra.hasOwnProperty(a)?f||(f=[]):(f=f||[]).push(a,null));for(a in d){var k=d[a];h=null!=c?c[a]:void 0;if(d.hasOwnProperty(a)&&k!==h&&(null!=k||null!=h))if("style"===a)if(h){for(b in h)!h.hasOwnProperty(b)||k&&k.hasOwnProperty(b)||(g||(g={}),g[b]="");for(b in k)k.hasOwnProperty(b)&&h[b]!==k[b]&&(g||(g={}),g[b]=k[b])}else g||(f||(f=[]),f.push(a,g)),
g=k;else"dangerouslySetInnerHTML"===a?(k=k?k.__html:void 0,h=h?h.__html:void 0,null!=k&&h!==k&&(f=f||[]).push(a,""+k)):"children"===a?h===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(a,""+k):"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&(ra.hasOwnProperty(a)?(null!=k&&Te(e,a),f||h===k||(f=[])):(f=f||[]).push(a,k))}g&&(f=f||[]).push("style",g);return f}
function Ye(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Kc(a,e);Re(c,d);d=Re(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?Oe(a,h,Se):"dangerouslySetInnerHTML"===g?Ke(a,h):"children"===g?Le(a,h):Gc(a,g,h,d)}switch(c){case "input":Lc(a,e);break;case "textarea":Ee(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?Ae(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?
Ae(a,!!e.multiple,e.defaultValue,!0):Ae(a,!!e.multiple,e.multiple?[]:"",!1))}}
function Ze(a,b,c,d,e){switch(b){case "iframe":case "object":K("load",a);break;case "video":case "audio":for(d=0;d<jb.length;d++)K(jb[d],a);break;case "source":K("error",a);break;case "img":case "image":case "link":K("error",a);K("load",a);break;case "form":K("reset",a);K("submit",a);break;case "details":K("toggle",a);break;case "input":Ic(a,c);K("invalid",a);Te(e,"onChange");break;case "select":Be(a,c);K("invalid",a);Te(e,"onChange");break;case "textarea":De(a,c),K("invalid",a),Te(e,"onChange")}Qe(b,
c,Se);d=null;for(var f in c)if(c.hasOwnProperty(f)){var g=c[f];"children"===f?"string"===typeof g?a.textContent!==g&&(d=["children",g]):"number"===typeof g&&a.textContent!==""+g&&(d=["children",""+g]):ra.hasOwnProperty(f)&&null!=g&&Te(e,f)}switch(b){case "input":cc(a);Nc(a,c,!0);break;case "textarea":cc(a);Fe(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&(a.onclick=v)}return d}function $e(a,b){return a.nodeValue!==b}
var af={createElement:Ue,createTextNode:Ve,setInitialProperties:We,diffProperties:Xe,updateProperties:Ye,diffHydratedProperties:Ze,diffHydratedText:$e,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Lc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;
c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Pa(d);e?void 0:A("90");dc(d);Lc(d,e)}}}break;case "textarea":Ee(a,c);break;case "select":b=c.value,null!=b&&Ae(a,!!c.multiple,b,!1)}}},bf=null,cf=null;function df(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function ef(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===typeof b.dangerouslySetInnerHTML.__html}var ff=he,gf=je,hf=ke;function jf(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}function kf(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var lf=[],mf=-1;function nf(a){return{current:a}}
function M(a){0>mf||(a.current=lf[mf],lf[mf]=null,mf--)}function N(a,b){mf++;lf[mf]=a.current;a.current=b}var of=nf(ha),O=nf(!1),pf=ha;function qf(a){return rf(a)?pf:of.current}
function sf(a,b){var c=a.type.contextTypes;if(!c)return ha;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function rf(a){return 2===a.tag&&null!=a.type.childContextTypes}function tf(a){rf(a)&&(M(O,a),M(of,a))}function uf(a){M(O,a);M(of,a)}
function vf(a,b,c){of.current!==ha?A("168"):void 0;N(of,b,a);N(O,c,a)}function wf(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:A("108",uc(a)||"Unknown",e);return p({},b,c)}function xf(a){if(!rf(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||ha;pf=of.current;N(of,b,a);N(O,O.current,a);return!0}
function yf(a,b){var c=a.stateNode;c?void 0:A("169");if(b){var d=wf(a,pf);c.__reactInternalMemoizedMergedChildContext=d;M(O,a);M(of,a);N(of,d,a)}else M(O,a);N(O,b,a)}
function zf(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=null;this.index=0;this.ref=null;this.pendingProps=b;this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
function Af(a,b,c){var d=a.alternate;null===d?(d=new zf(a.tag,b,a.key,a.mode),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.pendingProps=b,d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
function Bf(a,b,c){var d=a.type,e=a.key;a=a.props;if("function"===typeof d)var f=d.prototype&&d.prototype.isReactComponent?2:0;else if("string"===typeof d)f=5;else switch(d){case ic:return Cf(a.children,b,c,e);case pc:f=11;b|=3;break;case jc:f=11;b|=2;break;case kc:return d=new zf(15,a,e,b|4),d.type=kc,d.expirationTime=c,d;case rc:f=16;b|=2;break;default:a:{switch("object"===typeof d&&null!==d?d.$$typeof:null){case lc:f=13;break a;case mc:f=12;break a;case qc:f=14;break a;default:A("130",null==d?
d:typeof d,"")}f=void 0}}b=new zf(f,a,e,b);b.type=d;b.expirationTime=c;return b}function Cf(a,b,c,d){a=new zf(10,a,d,b);a.expirationTime=c;return a}function Df(a,b,c){a=new zf(6,a,null,b);a.expirationTime=c;return a}function Ef(a,b,c){b=new zf(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function Ff(a,b,c){b=new zf(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,pendingCommitExpirationTime:0,finishedWork:null,context:null,pendingContext:null,hydrate:c,remainingExpirationTime:0,firstBatch:null,nextScheduledRoot:null};return b.stateNode=a}var Gf=null,Hf=null;function If(a){return function(b){try{return a(b)}catch(c){}}}
function Jf(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Gf=If(function(a){return b.onCommitFiberRoot(c,a)});Hf=If(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function Kf(a){"function"===typeof Gf&&Gf(a)}function Lf(a){"function"===typeof Hf&&Hf(a)}var Mf=!1;
function Nf(a){return{expirationTime:0,baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function Of(a){return{expirationTime:a.expirationTime,baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function Pf(a){return{expirationTime:a,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function Qf(a,b,c){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b);if(0===a.expirationTime||a.expirationTime>c)a.expirationTime=c}
function Rf(a,b,c){var d=a.alternate;if(null===d){var e=a.updateQueue;var f=null;null===e&&(e=a.updateQueue=Nf(a.memoizedState))}else e=a.updateQueue,f=d.updateQueue,null===e?null===f?(e=a.updateQueue=Nf(a.memoizedState),f=d.updateQueue=Nf(d.memoizedState)):e=a.updateQueue=Of(f):null===f&&(f=d.updateQueue=Of(e));null===f||e===f?Qf(e,b,c):null===e.lastUpdate||null===f.lastUpdate?(Qf(e,b,c),Qf(f,b,c)):(Qf(e,b,c),f.lastUpdate=b)}
function Sf(a,b,c){var d=a.updateQueue;d=null===d?a.updateQueue=Nf(a.memoizedState):Tf(a,d);null===d.lastCapturedUpdate?d.firstCapturedUpdate=d.lastCapturedUpdate=b:(d.lastCapturedUpdate.next=b,d.lastCapturedUpdate=b);if(0===d.expirationTime||d.expirationTime>c)d.expirationTime=c}function Tf(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=Of(b));return b}
function Uf(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-1025|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return p({},d,e);case 2:Mf=!0}return d}
function Vf(a,b,c,d,e){Mf=!1;if(!(0===b.expirationTime||b.expirationTime>e)){b=Tf(a,b);for(var f=b.baseState,g=null,h=0,k=b.firstUpdate,n=f;null!==k;){var r=k.expirationTime;if(r>e){if(null===g&&(g=k,f=n),0===h||h>r)h=r}else n=Uf(a,b,k,n,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k));k=k.next}r=null;for(k=b.firstCapturedUpdate;null!==k;){var w=k.expirationTime;if(w>e){if(null===r&&(r=k,null===
g&&(f=n)),0===h||h>w)h=w}else n=Uf(a,b,k,n,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k));k=k.next}null===g&&(b.lastUpdate=null);null===r?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===r&&(f=n);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=r;b.expirationTime=h;a.memoizedState=n}}
function Wf(a,b){"function"!==typeof a?A("191",a):void 0;a.call(b)}
function Xf(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);a=b.firstEffect;for(b.firstEffect=b.lastEffect=null;null!==a;){var d=a.callback;null!==d&&(a.callback=null,Wf(d,c));a=a.nextEffect}a=b.firstCapturedEffect;for(b.firstCapturedEffect=b.lastCapturedEffect=null;null!==a;)b=a.callback,null!==b&&(a.callback=null,Wf(b,c)),a=a.nextEffect}
function Yf(a,b){return{value:a,source:b,stack:vc(b)}}var Zf=nf(null),$f=nf(null),ag=nf(0);function bg(a){var b=a.type._context;N(ag,b._changedBits,a);N($f,b._currentValue,a);N(Zf,a,a);b._currentValue=a.pendingProps.value;b._changedBits=a.stateNode}function cg(a){var b=ag.current,c=$f.current;M(Zf,a);M($f,a);M(ag,a);a=a.type._context;a._currentValue=c;a._changedBits=b}var dg={},eg=nf(dg),fg=nf(dg),gg=nf(dg);function hg(a){a===dg?A("174"):void 0;return a}
function jg(a,b){N(gg,b,a);N(fg,a,a);N(eg,dg,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ie(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=Ie(b,c)}M(eg,a);N(eg,b,a)}function kg(a){M(eg,a);M(fg,a);M(gg,a)}function lg(a){fg.current===a&&(M(eg,a),M(fg,a))}function mg(a,b,c){var d=a.memoizedState;b=b(c,d);d=null===b||void 0===b?d:p({},d,b);a.memoizedState=d;a=a.updateQueue;null!==a&&0===a.expirationTime&&(a.baseState=d)}
var qg={isMounted:function(a){return(a=a._reactInternalFiber)?2===kd(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=ng();d=og(d,a);var e=Pf(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Rf(a,e,d);pg(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=ng();d=og(d,a);var e=Pf(d);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Rf(a,e,d);pg(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=ng();c=og(c,a);var d=Pf(c);d.tag=2;void 0!==
b&&null!==b&&(d.callback=b);Rf(a,d,c);pg(a,c)}};function rg(a,b,c,d,e,f){var g=a.stateNode;a=a.type;return"function"===typeof g.shouldComponentUpdate?g.shouldComponentUpdate(c,e,f):a.prototype&&a.prototype.isPureReactComponent?!ea(b,c)||!ea(d,e):!0}
function sg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&qg.enqueueReplaceState(b,b.state,null)}
function tg(a,b){var c=a.type,d=a.stateNode,e=a.pendingProps,f=qf(a);d.props=e;d.state=a.memoizedState;d.refs=ha;d.context=sf(a,f);f=a.updateQueue;null!==f&&(Vf(a,f,e,d,b),d.state=a.memoizedState);f=a.type.getDerivedStateFromProps;"function"===typeof f&&(mg(a,f,e),d.state=a.memoizedState);"function"===typeof c.getDerivedStateFromProps||"function"===typeof d.getSnapshotBeforeUpdate||"function"!==typeof d.UNSAFE_componentWillMount&&"function"!==typeof d.componentWillMount||(c=d.state,"function"===typeof d.componentWillMount&&
d.componentWillMount(),"function"===typeof d.UNSAFE_componentWillMount&&d.UNSAFE_componentWillMount(),c!==d.state&&qg.enqueueReplaceState(d,d.state,null),f=a.updateQueue,null!==f&&(Vf(a,f,e,d,b),d.state=a.memoizedState));"function"===typeof d.componentDidMount&&(a.effectTag|=4)}var ug=Array.isArray;
function vg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(2!==c.tag?A("110"):void 0,d=c.stateNode);d?void 0:A("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs===ha?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?A("148"):void 0;c._owner?void 0:A("254",a)}return a}
function wg(a,b){"textarea"!==a.type&&A("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function xg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=Af(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Df(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=vg(a,b,c),d.return=a,d;d=Bf(c,a.mode,d);d.ref=vg(a,b,c);d.return=a;return d}function n(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=
Ef(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function r(a,b,c,d,f){if(null===b||10!==b.tag)return b=Cf(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function w(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Df(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case gc:return c=Bf(b,a.mode,c),c.ref=vg(a,null,b),c.return=a,c;case hc:return b=Ef(b,a.mode,c),b.return=a,b}if(ug(b)||tc(b))return b=Cf(b,a.mode,c,null),b.return=
a,b;wg(a,b)}return null}function P(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case gc:return c.key===e?c.type===ic?r(a,b,c.props.children,d,e):k(a,b,c,d):null;case hc:return c.key===e?n(a,b,c,d):null}if(ug(c)||tc(c))return null!==e?null:r(a,b,c,d,null);wg(a,c)}return null}function nc(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,h(b,a,""+d,e);
if("object"===typeof d&&null!==d){switch(d.$$typeof){case gc:return a=a.get(null===d.key?c:d.key)||null,d.type===ic?r(b,a,d.props.children,e,d.key):k(b,a,d,e);case hc:return a=a.get(null===d.key?c:d.key)||null,n(b,a,d,e)}if(ug(d)||tc(d))return a=a.get(c)||null,r(b,a,d,e,null);wg(b,d)}return null}function Jd(e,g,h,k){for(var u=null,x=null,t=g,q=g=0,n=null;null!==t&&q<h.length;q++){t.index>q?(n=t,t=null):n=t.sibling;var l=P(e,t,h[q],k);if(null===l){null===t&&(t=n);break}a&&t&&null===l.alternate&&b(e,
t);g=f(l,g,q);null===x?u=l:x.sibling=l;x=l;t=n}if(q===h.length)return c(e,t),u;if(null===t){for(;q<h.length;q++)if(t=w(e,h[q],k))g=f(t,g,q),null===x?u=t:x.sibling=t,x=t;return u}for(t=d(e,t);q<h.length;q++)if(n=nc(t,e,q,h[q],k))a&&null!==n.alternate&&t.delete(null===n.key?q:n.key),g=f(n,g,q),null===x?u=n:x.sibling=n,x=n;a&&t.forEach(function(a){return b(e,a)});return u}function E(e,g,h,k){var u=tc(h);"function"!==typeof u?A("150"):void 0;h=u.call(h);null==h?A("151"):void 0;for(var t=u=null,n=g,x=
g=0,y=null,l=h.next();null!==n&&!l.done;x++,l=h.next()){n.index>x?(y=n,n=null):y=n.sibling;var r=P(e,n,l.value,k);if(null===r){n||(n=y);break}a&&n&&null===r.alternate&&b(e,n);g=f(r,g,x);null===t?u=r:t.sibling=r;t=r;n=y}if(l.done)return c(e,n),u;if(null===n){for(;!l.done;x++,l=h.next())l=w(e,l.value,k),null!==l&&(g=f(l,g,x),null===t?u=l:t.sibling=l,t=l);return u}for(n=d(e,n);!l.done;x++,l=h.next())l=nc(n,e,x,l.value,k),null!==l&&(a&&null!==l.alternate&&n.delete(null===l.key?x:l.key),g=f(l,g,x),null===
t?u=l:t.sibling=l,t=l);a&&n.forEach(function(a){return b(e,a)});return u}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ic&&null===f.key;k&&(f=f.props.children);var n="object"===typeof f&&null!==f;if(n)switch(f.$$typeof){case gc:a:{n=f.key;for(k=d;null!==k;){if(k.key===n)if(10===k.tag?f.type===ic:k.type===f.type){c(a,k.sibling);d=e(k,f.type===ic?f.props.children:f.props,h);d.ref=vg(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=k.sibling}f.type===ic?(d=Cf(f.props.children,
a.mode,h,f.key),d.return=a,a=d):(h=Bf(f,a.mode,h),h.ref=vg(a,d,f),h.return=a,a=h)}return g(a);case hc:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=Ef(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=
a,a=d):(c(a,d),d=Df(f,a.mode,h),d.return=a,a=d),g(a);if(ug(f))return Jd(a,d,f,h);if(tc(f))return E(a,d,f,h);n&&wg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 2:case 1:h=a.type,A("152",h.displayName||h.name||"Component")}return c(a,d)}}var yg=xg(!0),zg=xg(!1),Ag=null,Bg=null,Cg=!1;function Dg(a,b){var c=new zf(5,null,null,0);c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Eg(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;default:return!1}}function Fg(a){if(Cg){var b=Bg;if(b){var c=b;if(!Eg(a,b)){b=jf(c);if(!b||!Eg(a,b)){a.effectTag|=2;Cg=!1;Ag=a;return}Dg(Ag,c)}Ag=a;Bg=kf(b)}else a.effectTag|=2,Cg=!1,Ag=a}}
function Gg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag;)a=a.return;Ag=a}function Hg(a){if(a!==Ag)return!1;if(!Cg)return Gg(a),Cg=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!ef(b,a.memoizedProps))for(b=Bg;b;)Dg(a,b),b=jf(b);Gg(a);Bg=Ag?jf(a.stateNode):null;return!0}function Ig(){Bg=Ag=null;Cg=!1}function Q(a,b,c){Jg(a,b,c,b.expirationTime)}function Jg(a,b,c,d){b.child=null===a?zg(b,null,c,d):yg(b,a.child,c,d)}
function Kg(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function Lg(a,b,c,d,e){Kg(a,b);var f=0!==(b.effectTag&64);if(!c&&!f)return d&&yf(b,!1),R(a,b);c=b.stateNode;ec.current=b;var g=f?null:c.render();b.effectTag|=1;f&&(Jg(a,b,null,e),b.child=null);Jg(a,b,g,e);b.memoizedState=c.state;b.memoizedProps=c.props;d&&yf(b,!0);return b.child}
function Mg(a){var b=a.stateNode;b.pendingContext?vf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&vf(a,b.context,!1);jg(a,b.containerInfo)}
function Ng(a,b,c,d){var e=a.child;null!==e&&(e.return=a);for(;null!==e;){switch(e.tag){case 12:var f=e.stateNode|0;if(e.type===b&&0!==(f&c)){for(f=e;null!==f;){var g=f.alternate;if(0===f.expirationTime||f.expirationTime>d)f.expirationTime=d,null!==g&&(0===g.expirationTime||g.expirationTime>d)&&(g.expirationTime=d);else if(null!==g&&(0===g.expirationTime||g.expirationTime>d))g.expirationTime=d;else break;f=f.return}f=null}else f=e.child;break;case 13:f=e.type===a.type?null:e.child;break;default:f=
e.child}if(null!==f)f.return=e;else for(f=e;null!==f;){if(f===a){f=null;break}e=f.sibling;if(null!==e){e.return=f.return;f=e;break}f=f.return}e=f}}
function Rg(a,b,c){var d=b.type._context,e=b.pendingProps,f=b.memoizedProps,g=!0;if(O.current)g=!1;else if(f===e)return b.stateNode=0,bg(b),R(a,b);var h=e.value;b.memoizedProps=e;if(null===f)h=1073741823;else if(f.value===e.value){if(f.children===e.children&&g)return b.stateNode=0,bg(b),R(a,b);h=0}else{var k=f.value;if(k===h&&(0!==k||1/k===1/h)||k!==k&&h!==h){if(f.children===e.children&&g)return b.stateNode=0,bg(b),R(a,b);h=0}else if(h="function"===typeof d._calculateChangedBits?d._calculateChangedBits(k,
h):1073741823,h|=0,0===h){if(f.children===e.children&&g)return b.stateNode=0,bg(b),R(a,b)}else Ng(b,d,h,c)}b.stateNode=h;bg(b);Q(a,b,e.children);return b.child}function R(a,b){null!==a&&b.child!==a.child?A("153"):void 0;if(null!==b.child){a=b.child;var c=Af(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Af(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
function Sg(a,b,c){if(0===b.expirationTime||b.expirationTime>c){switch(b.tag){case 3:Mg(b);break;case 2:xf(b);break;case 4:jg(b,b.stateNode.containerInfo);break;case 13:bg(b)}return null}switch(b.tag){case 0:null!==a?A("155"):void 0;var d=b.type,e=b.pendingProps,f=qf(b);f=sf(b,f);d=d(e,f);b.effectTag|=1;"object"===typeof d&&null!==d&&"function"===typeof d.render&&void 0===d.$$typeof?(f=b.type,b.tag=2,b.memoizedState=null!==d.state&&void 0!==d.state?d.state:null,f=f.getDerivedStateFromProps,"function"===
typeof f&&mg(b,f,e),e=xf(b),d.updater=qg,b.stateNode=d,d._reactInternalFiber=b,tg(b,c),a=Lg(a,b,!0,e,c)):(b.tag=1,Q(a,b,d),b.memoizedProps=e,a=b.child);return a;case 1:return e=b.type,c=b.pendingProps,O.current||b.memoizedProps!==c?(d=qf(b),d=sf(b,d),e=e(c,d),b.effectTag|=1,Q(a,b,e),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 2:e=xf(b);if(null===a)if(null===b.stateNode){var g=b.pendingProps,h=b.type;d=qf(b);var k=2===b.tag&&null!=b.type.contextTypes;f=k?sf(b,d):ha;g=new h(g,f);b.memoizedState=null!==
g.state&&void 0!==g.state?g.state:null;g.updater=qg;b.stateNode=g;g._reactInternalFiber=b;k&&(k=b.stateNode,k.__reactInternalMemoizedUnmaskedChildContext=d,k.__reactInternalMemoizedMaskedChildContext=f);tg(b,c);d=!0}else{h=b.type;d=b.stateNode;k=b.memoizedProps;f=b.pendingProps;d.props=k;var n=d.context;g=qf(b);g=sf(b,g);var r=h.getDerivedStateFromProps;(h="function"===typeof r||"function"===typeof d.getSnapshotBeforeUpdate)||"function"!==typeof d.UNSAFE_componentWillReceiveProps&&"function"!==typeof d.componentWillReceiveProps||
(k!==f||n!==g)&&sg(b,d,f,g);Mf=!1;var w=b.memoizedState;n=d.state=w;var P=b.updateQueue;null!==P&&(Vf(b,P,f,d,c),n=b.memoizedState);k!==f||w!==n||O.current||Mf?("function"===typeof r&&(mg(b,r,f),n=b.memoizedState),(k=Mf||rg(b,k,f,w,n,g))?(h||"function"!==typeof d.UNSAFE_componentWillMount&&"function"!==typeof d.componentWillMount||("function"===typeof d.componentWillMount&&d.componentWillMount(),"function"===typeof d.UNSAFE_componentWillMount&&d.UNSAFE_componentWillMount()),"function"===typeof d.componentDidMount&&
(b.effectTag|=4)):("function"===typeof d.componentDidMount&&(b.effectTag|=4),b.memoizedProps=f,b.memoizedState=n),d.props=f,d.state=n,d.context=g,d=k):("function"===typeof d.componentDidMount&&(b.effectTag|=4),d=!1)}else h=b.type,d=b.stateNode,f=b.memoizedProps,k=b.pendingProps,d.props=f,n=d.context,g=qf(b),g=sf(b,g),r=h.getDerivedStateFromProps,(h="function"===typeof r||"function"===typeof d.getSnapshotBeforeUpdate)||"function"!==typeof d.UNSAFE_componentWillReceiveProps&&"function"!==typeof d.componentWillReceiveProps||
(f!==k||n!==g)&&sg(b,d,k,g),Mf=!1,n=b.memoizedState,w=d.state=n,P=b.updateQueue,null!==P&&(Vf(b,P,k,d,c),w=b.memoizedState),f!==k||n!==w||O.current||Mf?("function"===typeof r&&(mg(b,r,k),w=b.memoizedState),(r=Mf||rg(b,f,k,n,w,g))?(h||"function"!==typeof d.UNSAFE_componentWillUpdate&&"function"!==typeof d.componentWillUpdate||("function"===typeof d.componentWillUpdate&&d.componentWillUpdate(k,w,g),"function"===typeof d.UNSAFE_componentWillUpdate&&d.UNSAFE_componentWillUpdate(k,w,g)),"function"===typeof d.componentDidUpdate&&
(b.effectTag|=4),"function"===typeof d.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof d.componentDidUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=4),"function"!==typeof d.getSnapshotBeforeUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=256),b.memoizedProps=k,b.memoizedState=w),d.props=k,d.state=w,d.context=g,d=r):("function"!==typeof d.componentDidUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=4),"function"!==typeof d.getSnapshotBeforeUpdate||
f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=256),d=!1);return Lg(a,b,d,e,c);case 3:Mg(b);e=b.updateQueue;if(null!==e)if(d=b.memoizedState,d=null!==d?d.element:null,Vf(b,e,b.pendingProps,null,c),e=b.memoizedState.element,e===d)Ig(),a=R(a,b);else{d=b.stateNode;if(d=(null===a||null===a.child)&&d.hydrate)Bg=kf(b.stateNode.containerInfo),Ag=b,d=Cg=!0;d?(b.effectTag|=2,b.child=zg(b,null,e,c)):(Ig(),Q(a,b,e));a=b.child}else Ig(),a=R(a,b);return a;case 5:a:{hg(gg.current);e=hg(eg.current);d=Ie(e,
b.type);e!==d&&(N(fg,b,b),N(eg,d,b));null===a&&Fg(b);e=b.type;k=b.memoizedProps;d=b.pendingProps;f=null!==a?a.memoizedProps:null;if(!O.current&&k===d){if(k=b.mode&1&&!!d.hidden)b.expirationTime=1073741823;if(!k||1073741823!==c){a=R(a,b);break a}}k=d.children;ef(e,d)?k=null:f&&ef(e,f)&&(b.effectTag|=16);Kg(a,b);1073741823!==c&&b.mode&1&&d.hidden?(b.expirationTime=1073741823,b.memoizedProps=d,a=null):(Q(a,b,k),b.memoizedProps=d,a=b.child)}return a;case 6:return null===a&&Fg(b),b.memoizedProps=b.pendingProps,
null;case 16:return null;case 4:return jg(b,b.stateNode.containerInfo),e=b.pendingProps,O.current||b.memoizedProps!==e?(null===a?b.child=yg(b,null,e,c):Q(a,b,e),b.memoizedProps=e,a=b.child):a=R(a,b),a;case 14:return e=b.type.render,c=b.pendingProps,d=b.ref,O.current||b.memoizedProps!==c||d!==(null!==a?a.ref:null)?(e=e(c,d),Q(a,b,e),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 10:return c=b.pendingProps,O.current||b.memoizedProps!==c?(Q(a,b,c),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 11:return c=
b.pendingProps.children,O.current||null!==c&&b.memoizedProps!==c?(Q(a,b,c),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 15:return c=b.pendingProps,b.memoizedProps===c?a=R(a,b):(Q(a,b,c.children),b.memoizedProps=c,a=b.child),a;case 13:return Rg(a,b,c);case 12:a:if(d=b.type,f=b.pendingProps,k=b.memoizedProps,e=d._currentValue,g=d._changedBits,O.current||0!==g||k!==f){b.memoizedProps=f;h=f.unstable_observedBits;if(void 0===h||null===h)h=1073741823;b.stateNode=h;if(0!==(g&h))Ng(b,d,g,c);else if(k===f){a=
R(a,b);break a}c=f.children;c=c(e);b.effectTag|=1;Q(a,b,c);a=b.child}else a=R(a,b);return a;default:A("156")}}function Tg(a){a.effectTag|=4}var Ug=void 0,Vg=void 0,Wg=void 0;Ug=function(){};Vg=function(a,b,c){(b.updateQueue=c)&&Tg(b)};Wg=function(a,b,c,d){c!==d&&Tg(b)};
function Xg(a,b){var c=b.pendingProps;switch(b.tag){case 1:return null;case 2:return tf(b),null;case 3:kg(b);uf(b);var d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===a||null===a.child)Hg(b),b.effectTag&=-3;Ug(b);return null;case 5:lg(b);d=hg(gg.current);var e=b.type;if(null!==a&&null!=b.stateNode){var f=a.memoizedProps,g=b.stateNode,h=hg(eg.current);g=Xe(g,e,f,c,d);Vg(a,b,g,e,f,c,d,h);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!c)return null===b.stateNode?
A("166"):void 0,null;a=hg(eg.current);if(Hg(b))c=b.stateNode,e=b.type,f=b.memoizedProps,c[C]=b,c[Ma]=f,d=Ze(c,e,f,a,d),b.updateQueue=d,null!==d&&Tg(b);else{a=Ue(e,c,d,a);a[C]=b;a[Ma]=c;a:for(f=b.child;null!==f;){if(5===f.tag||6===f.tag)a.appendChild(f.stateNode);else if(4!==f.tag&&null!==f.child){f.child.return=f;f=f.child;continue}if(f===b)break;for(;null===f.sibling;){if(null===f.return||f.return===b)break a;f=f.return}f.sibling.return=f.return;f=f.sibling}We(a,e,c,d);df(e,c)&&Tg(b);b.stateNode=
a}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)Wg(a,b,a.memoizedProps,c);else{if("string"!==typeof c)return null===b.stateNode?A("166"):void 0,null;d=hg(gg.current);hg(eg.current);Hg(b)?(d=b.stateNode,c=b.memoizedProps,d[C]=b,$e(d,c)&&Tg(b)):(d=Ve(c,d),d[C]=b,b.stateNode=d)}return null;case 14:return null;case 16:return null;case 10:return null;case 11:return null;case 15:return null;case 4:return kg(b),Ug(b),null;case 13:return cg(b),null;case 12:return null;case 0:A("167");
default:A("156")}}function Yg(a,b){var c=b.source;null===b.stack&&null!==c&&vc(c);null!==c&&uc(c);b=b.value;null!==a&&2===a.tag&&uc(a);try{b&&b.suppressReactErrorLogging||console.error(b)}catch(d){d&&d.suppressReactErrorLogging||console.error(d)}}function Zg(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){$g(a,c)}else b.current=null}
function ah(a){"function"===typeof Lf&&Lf(a);switch(a.tag){case 2:Zg(a);var b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){$g(a,c)}break;case 5:Zg(a);break;case 4:bh(a)}}function ch(a){return 5===a.tag||3===a.tag||4===a.tag}
function dh(a){a:{for(var b=a.return;null!==b;){if(ch(b)){var c=b;break a}b=b.return}A("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:A("161")}c.effectTag&16&&(Le(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||ch(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)if(c)if(d){var f=b,g=e.stateNode,h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(e.stateNode,c);else d?(f=b,g=e.stateNode,8===f.nodeType?f.parentNode.insertBefore(g,f):f.appendChild(g)):b.appendChild(e.stateNode);else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===
e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function bh(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?A("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag){a:for(var f=b,g=f;;)if(ah(g),null!==g.child&&4!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(4===b.tag?d=b.stateNode.containerInfo:ah(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;4===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
function eh(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&(c[Ma]=d,Ye(c,f,e,a,d))}break;case 6:null===b.stateNode?A("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 15:break;case 16:break;default:A("163")}}function fh(a,b,c){c=Pf(c);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){gh(d);Yg(a,b)};return c}
function hh(a,b,c){c=Pf(c);c.tag=3;var d=a.stateNode;null!==d&&"function"===typeof d.componentDidCatch&&(c.callback=function(){null===ih?ih=new Set([this]):ih.add(this);var c=b.value,d=b.stack;Yg(a,b);this.componentDidCatch(c,{componentStack:null!==d?d:""})});return c}
function jh(a,b,c,d,e,f){c.effectTag|=512;c.firstEffect=c.lastEffect=null;d=Yf(d,c);a=b;do{switch(a.tag){case 3:a.effectTag|=1024;d=fh(a,d,f);Sf(a,d,f);return;case 2:if(b=d,c=a.stateNode,0===(a.effectTag&64)&&null!==c&&"function"===typeof c.componentDidCatch&&(null===ih||!ih.has(c))){a.effectTag|=1024;d=hh(a,b,f);Sf(a,d,f);return}}a=a.return}while(null!==a)}
function kh(a){switch(a.tag){case 2:tf(a);var b=a.effectTag;return b&1024?(a.effectTag=b&-1025|64,a):null;case 3:return kg(a),uf(a),b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 5:return lg(a),null;case 16:return b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 4:return kg(a),null;case 13:return cg(a),null;default:return null}}var lh=ff(),mh=2,nh=lh,oh=0,ph=0,qh=!1,S=null,rh=null,T=0,sh=-1,th=!1,U=null,uh=!1,vh=!1,ih=null;
function wh(){if(null!==S)for(var a=S.return;null!==a;){var b=a;switch(b.tag){case 2:tf(b);break;case 3:kg(b);uf(b);break;case 5:lg(b);break;case 4:kg(b);break;case 13:cg(b)}a=a.return}rh=null;T=0;sh=-1;th=!1;S=null;vh=!1}
function xh(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&512)){b=Xg(b,a,T);var e=a;if(1073741823===T||1073741823!==e.expirationTime){var f=0;switch(e.tag){case 3:case 2:var g=e.updateQueue;null!==g&&(f=g.expirationTime)}for(g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&0===(c.effectTag&512)&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&
(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;if(null!==c)a=c;else{vh=!0;break}}else{a=kh(a,th,T);if(null!==a)return a.effectTag&=511,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=512);if(null!==d)return d;if(null!==c)a=c;else break}}return null}
function yh(a){var b=Sg(a.alternate,a,T);null===b&&(b=xh(a));ec.current=null;return b}
function zh(a,b,c){qh?A("243"):void 0;qh=!0;if(b!==T||a!==rh||null===S)wh(),rh=a,T=b,sh=-1,S=Af(rh.current,null,T),a.pendingCommitExpirationTime=0;var d=!1;th=!c||T<=mh;do{try{if(c)for(;null!==S&&!Ah();)S=yh(S);else for(;null!==S;)S=yh(S)}catch(f){if(null===S)d=!0,gh(f);else{null===S?A("271"):void 0;c=S;var e=c.return;if(null===e){d=!0;gh(f);break}jh(a,e,c,f,th,T,nh);S=xh(c)}}break}while(1);qh=!1;if(d)return null;if(null===S){if(vh)return a.pendingCommitExpirationTime=b,a.current.alternate;th?A("262"):
void 0;0<=sh&&setTimeout(function(){var b=a.current.expirationTime;0!==b&&(0===a.remainingExpirationTime||a.remainingExpirationTime<b)&&Bh(a,b)},sh);Ch(a.current.expirationTime)}return null}
function $g(a,b){var c;a:{qh&&!uh?A("263"):void 0;for(c=a.return;null!==c;){switch(c.tag){case 2:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromCatch||"function"===typeof d.componentDidCatch&&(null===ih||!ih.has(d))){a=Yf(b,a);a=hh(c,a,1);Rf(c,a,1);pg(c,1);c=void 0;break a}break;case 3:a=Yf(b,a);a=fh(c,a,1);Rf(c,a,1);pg(c,1);c=void 0;break a}c=c.return}3===a.tag&&(c=Yf(b,a),c=fh(a,c,1),Rf(a,c,1),pg(a,1));c=void 0}return c}
function Dh(){var a=2+25*(((ng()-2+500)/25|0)+1);a<=oh&&(a=oh+1);return oh=a}function og(a,b){a=0!==ph?ph:qh?uh?1:T:b.mode&1?Eh?2+10*(((a-2+15)/10|0)+1):2+25*(((a-2+500)/25|0)+1):1;Eh&&(0===Fh||a>Fh)&&(Fh=a);return a}
function pg(a,b){for(;null!==a;){if(0===a.expirationTime||a.expirationTime>b)a.expirationTime=b;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>b)&&(a.alternate.expirationTime=b);if(null===a.return)if(3===a.tag){var c=a.stateNode;!qh&&0!==T&&b<T&&wh();var d=c.current.expirationTime;qh&&!uh&&rh===c||Bh(c,d);Gh>Hh&&A("185")}else break;a=a.return}}function ng(){nh=ff()-lh;return mh=(nh/10|0)+2}
function Ih(a){var b=ph;ph=2+25*(((ng()-2+500)/25|0)+1);try{return a()}finally{ph=b}}function Jh(a,b,c,d,e){var f=ph;ph=1;try{return a(b,c,d,e)}finally{ph=f}}var Kh=null,V=null,Lh=0,Mh=void 0,W=!1,X=null,Y=0,Fh=0,Nh=!1,Oh=!1,Ph=null,Qh=null,Z=!1,Rh=!1,Eh=!1,Sh=null,Hh=1E3,Gh=0,Th=1;function Uh(a){if(0!==Lh){if(a>Lh)return;null!==Mh&&hf(Mh)}var b=ff()-lh;Lh=a;Mh=gf(Vh,{timeout:10*(a-2)-b})}
function Bh(a,b){if(null===a.nextScheduledRoot)a.remainingExpirationTime=b,null===V?(Kh=V=a,a.nextScheduledRoot=a):(V=V.nextScheduledRoot=a,V.nextScheduledRoot=Kh);else{var c=a.remainingExpirationTime;if(0===c||b<c)a.remainingExpirationTime=b}W||(Z?Rh&&(X=a,Y=1,Wh(a,1,!1)):1===b?Xh():Uh(b))}
function Yh(){var a=0,b=null;if(null!==V)for(var c=V,d=Kh;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===V?A("244"):void 0;if(d===d.nextScheduledRoot){Kh=V=d.nextScheduledRoot=null;break}else if(d===Kh)Kh=e=d.nextScheduledRoot,V.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===V){V=c;V.nextScheduledRoot=Kh;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===V)break;
c=d;d=d.nextScheduledRoot}}c=X;null!==c&&c===b&&1===a?Gh++:Gh=0;X=b;Y=a}function Vh(a){Zh(0,!0,a)}function Xh(){Zh(1,!1,null)}function Zh(a,b,c){Qh=c;Yh();if(b)for(;null!==X&&0!==Y&&(0===a||a>=Y)&&(!Nh||ng()>=Y);)ng(),Wh(X,Y,!Nh),Yh();else for(;null!==X&&0!==Y&&(0===a||a>=Y);)Wh(X,Y,!1),Yh();null!==Qh&&(Lh=0,Mh=null);0!==Y&&Uh(Y);Qh=null;Nh=!1;$h()}function ai(a,b){W?A("253"):void 0;X=a;Y=b;Wh(a,b,!1);Xh();$h()}
function $h(){Gh=0;if(null!==Sh){var a=Sh;Sh=null;for(var b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){Oh||(Oh=!0,Ph=d)}}}if(Oh)throw a=Ph,Ph=null,Oh=!1,a;}function Wh(a,b,c){W?A("245"):void 0;W=!0;c?(c=a.finishedWork,null!==c?bi(a,c,b):(c=zh(a,b,!0),null!==c&&(Ah()?a.finishedWork=c:bi(a,c,b)))):(c=a.finishedWork,null!==c?bi(a,c,b):(c=zh(a,b,!1),null!==c&&bi(a,c,b)));W=!1}
function bi(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime<=c&&(null===Sh?Sh=[d]:Sh.push(d),d._defer)){a.finishedWork=b;a.remainingExpirationTime=0;return}a.finishedWork=null;uh=qh=!0;c=b.stateNode;c.current===b?A("177"):void 0;d=c.pendingCommitExpirationTime;0===d?A("261"):void 0;c.pendingCommitExpirationTime=0;ng();ec.current=null;if(1<b.effectTag)if(null!==b.lastEffect){b.lastEffect.nextEffect=b;var e=b.firstEffect}else e=b;else e=b.firstEffect;bf=Id;var f=da();if(Vd(f)){if("selectionStart"in
f)var g={start:f.selectionStart,end:f.selectionEnd};else a:{var h=window.getSelection&&window.getSelection();if(h&&0!==h.rangeCount){g=h.anchorNode;var k=h.anchorOffset,n=h.focusNode;h=h.focusOffset;try{g.nodeType,n.nodeType}catch(Wa){g=null;break a}var r=0,w=-1,P=-1,nc=0,Jd=0,E=f,t=null;b:for(;;){for(var x;;){E!==g||0!==k&&3!==E.nodeType||(w=r+k);E!==n||0!==h&&3!==E.nodeType||(P=r+h);3===E.nodeType&&(r+=E.nodeValue.length);if(null===(x=E.firstChild))break;t=E;E=x}for(;;){if(E===f)break b;t===g&&
++nc===k&&(w=r);t===n&&++Jd===h&&(P=r);if(null!==(x=E.nextSibling))break;E=t;t=E.parentNode}E=x}g=-1===w||-1===P?null:{start:w,end:P}}else g=null}g=g||{start:0,end:0}}else g=null;cf={focusedElem:f,selectionRange:g};Kd(!1);for(U=e;null!==U;){f=!1;g=void 0;try{for(;null!==U;){if(U.effectTag&256){var u=U.alternate;k=U;switch(k.tag){case 2:if(k.effectTag&256&&null!==u){var y=u.memoizedProps,D=u.memoizedState,ja=k.stateNode;ja.props=k.memoizedProps;ja.state=k.memoizedState;var ni=ja.getSnapshotBeforeUpdate(y,
D);ja.__reactInternalSnapshotBeforeUpdate=ni}break;case 3:case 5:case 6:case 4:break;default:A("163")}}U=U.nextEffect}}catch(Wa){f=!0,g=Wa}f&&(null===U?A("178"):void 0,$g(U,g),null!==U&&(U=U.nextEffect))}for(U=e;null!==U;){u=!1;y=void 0;try{for(;null!==U;){var q=U.effectTag;q&16&&Le(U.stateNode,"");if(q&128){var z=U.alternate;if(null!==z){var l=z.ref;null!==l&&("function"===typeof l?l(null):l.current=null)}}switch(q&14){case 2:dh(U);U.effectTag&=-3;break;case 6:dh(U);U.effectTag&=-3;eh(U.alternate,
U);break;case 4:eh(U.alternate,U);break;case 8:D=U,bh(D),D.return=null,D.child=null,D.alternate&&(D.alternate.child=null,D.alternate.return=null)}U=U.nextEffect}}catch(Wa){u=!0,y=Wa}u&&(null===U?A("178"):void 0,$g(U,y),null!==U&&(U=U.nextEffect))}l=cf;z=da();q=l.focusedElem;u=l.selectionRange;if(z!==q&&fa(document.documentElement,q)){null!==u&&Vd(q)&&(z=u.start,l=u.end,void 0===l&&(l=z),"selectionStart"in q?(q.selectionStart=z,q.selectionEnd=Math.min(l,q.value.length)):window.getSelection&&(z=window.getSelection(),
y=q[lb()].length,l=Math.min(u.start,y),u=void 0===u.end?l:Math.min(u.end,y),!z.extend&&l>u&&(y=u,u=l,l=y),y=Ud(q,l),D=Ud(q,u),y&&D&&(1!==z.rangeCount||z.anchorNode!==y.node||z.anchorOffset!==y.offset||z.focusNode!==D.node||z.focusOffset!==D.offset)&&(ja=document.createRange(),ja.setStart(y.node,y.offset),z.removeAllRanges(),l>u?(z.addRange(ja),z.extend(D.node,D.offset)):(ja.setEnd(D.node,D.offset),z.addRange(ja)))));z=[];for(l=q;l=l.parentNode;)1===l.nodeType&&z.push({element:l,left:l.scrollLeft,
top:l.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<z.length;q++)l=z[q],l.element.scrollLeft=l.left,l.element.scrollTop=l.top}cf=null;Kd(bf);bf=null;c.current=b;for(U=e;null!==U;){e=!1;q=void 0;try{for(z=d;null!==U;){var ig=U.effectTag;if(ig&36){var oc=U.alternate;l=U;u=z;switch(l.tag){case 2:var ca=l.stateNode;if(l.effectTag&4)if(null===oc)ca.props=l.memoizedProps,ca.state=l.memoizedState,ca.componentDidMount();else{var xi=oc.memoizedProps,yi=oc.memoizedState;ca.props=l.memoizedProps;
ca.state=l.memoizedState;ca.componentDidUpdate(xi,yi,ca.__reactInternalSnapshotBeforeUpdate)}var Og=l.updateQueue;null!==Og&&(ca.props=l.memoizedProps,ca.state=l.memoizedState,Xf(l,Og,ca,u));break;case 3:var Pg=l.updateQueue;if(null!==Pg){y=null;if(null!==l.child)switch(l.child.tag){case 5:y=l.child.stateNode;break;case 2:y=l.child.stateNode}Xf(l,Pg,y,u)}break;case 5:var zi=l.stateNode;null===oc&&l.effectTag&4&&df(l.type,l.memoizedProps)&&zi.focus();break;case 6:break;case 4:break;case 15:break;case 16:break;
default:A("163")}}if(ig&128){l=void 0;var yc=U.ref;if(null!==yc){var Qg=U.stateNode;switch(U.tag){case 5:l=Qg;break;default:l=Qg}"function"===typeof yc?yc(l):yc.current=l}}var Ai=U.nextEffect;U.nextEffect=null;U=Ai}}catch(Wa){e=!0,q=Wa}e&&(null===U?A("178"):void 0,$g(U,q),null!==U&&(U=U.nextEffect))}qh=uh=!1;"function"===typeof Kf&&Kf(b.stateNode);b=c.current.expirationTime;0===b&&(ih=null);a.remainingExpirationTime=b}function Ah(){return null===Qh||Qh.timeRemaining()>Th?!1:Nh=!0}
function gh(a){null===X?A("246"):void 0;X.remainingExpirationTime=0;Oh||(Oh=!0,Ph=a)}function Ch(a){null===X?A("246"):void 0;X.remainingExpirationTime=a}function ci(a,b){var c=Z;Z=!0;try{return a(b)}finally{(Z=c)||W||Xh()}}function di(a,b){if(Z&&!Rh){Rh=!0;try{return a(b)}finally{Rh=!1}}return a(b)}function ei(a,b){W?A("187"):void 0;var c=Z;Z=!0;try{return Jh(a,b)}finally{Z=c,Xh()}}
function fi(a,b,c){if(Eh)return a(b,c);Z||W||0===Fh||(Zh(Fh,!1,null),Fh=0);var d=Eh,e=Z;Z=Eh=!0;try{return a(b,c)}finally{Eh=d,(Z=e)||W||Xh()}}function gi(a){var b=Z;Z=!0;try{Jh(a)}finally{(Z=b)||W||Zh(1,!1,null)}}
function hi(a,b,c,d,e){var f=b.current;if(c){c=c._reactInternalFiber;var g;b:{2===kd(c)&&2===c.tag?void 0:A("170");for(g=c;3!==g.tag;){if(rf(g)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}(g=g.return)?void 0:A("171")}g=g.stateNode.context}c=rf(c)?wf(c,g):g}else c=ha;null===b.context?b.context=c:b.pendingContext=c;b=e;e=Pf(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);Rf(f,e,d);pg(f,d);return d}
function ii(a){var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?A("188"):A("268",Object.keys(a)));a=nd(b);return null===a?null:a.stateNode}function ji(a,b,c,d){var e=b.current,f=ng();e=og(f,e);return hi(a,b,c,e,d)}function ki(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}
function li(a){var b=a.findFiberByHostInstance;return Jf(p({},a,{findHostInstanceByFiber:function(a){a=nd(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))}
var mi={updateContainerAtExpirationTime:hi,createContainer:function(a,b,c){return Ff(a,b,c)},updateContainer:ji,flushRoot:ai,requestWork:Bh,computeUniqueAsyncExpiration:Dh,batchedUpdates:ci,unbatchedUpdates:di,deferredUpdates:Ih,syncUpdates:Jh,interactiveUpdates:fi,flushInteractiveUpdates:function(){W||0===Fh||(Zh(Fh,!1,null),Fh=0)},flushControlled:gi,flushSync:ei,getPublicRootInstance:ki,findHostInstance:ii,findHostInstanceWithNoPortals:function(a){a=od(a);return null===a?null:a.stateNode},injectIntoDevTools:li};
function oi(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:hc,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}Kb.injectFiberControlledHostComponent(af);function pi(a){this._expirationTime=Dh();this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}
pi.prototype.render=function(a){this._defer?void 0:A("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new qi;hi(a,b,null,c,d._onCommit);return d};pi.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
pi.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:A("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?A("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;ai(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
null,this._defer=!1};pi.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function qi(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}qi.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
qi.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?A("191",c):void 0;c()}}};function ri(a,b,c){this._internalRoot=Ff(a,b,c)}ri.prototype.render=function(a,b){var c=this._internalRoot,d=new qi;b=void 0===b?null:b;null!==b&&d.then(b);ji(a,c,null,d._onCommit);return d};
ri.prototype.unmount=function(a){var b=this._internalRoot,c=new qi;a=void 0===a?null:a;null!==a&&c.then(a);ji(null,b,null,c._onCommit);return c};ri.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new qi;c=void 0===c?null:c;null!==c&&e.then(c);ji(b,d,a,e._onCommit);return e};
ri.prototype.createBatch=function(){var a=new pi(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime<=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function si(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Sb=mi.batchedUpdates;Tb=mi.interactiveUpdates;Ub=mi.flushInteractiveUpdates;
function ti(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new ri(a,!1,b)}
function ui(a,b,c,d,e){si(c)?void 0:A("200");var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=ki(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=ti(c,d);if("function"===typeof e){var h=e;e=function(){var a=ki(f._internalRoot);h.call(a)}}di(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return ki(f._internalRoot)}
function vi(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;si(b)?void 0:A("200");return oi(a,b,null,c)}
var wi={createPortal:vi,findDOMNode:function(a){return null==a?null:1===a.nodeType?a:ii(a)},hydrate:function(a,b,c){return ui(null,a,b,!0,c)},render:function(a,b,c){return ui(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?A("38"):void 0;return ui(a,b,c,!1,d)},unmountComponentAtNode:function(a){si(a)?void 0:A("40");return a._reactRootContainer?(di(function(){ui(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return vi.apply(void 0,
arguments)},unstable_batchedUpdates:ci,unstable_deferredUpdates:Ih,unstable_interactiveUpdates:fi,flushSync:ei,unstable_flushControlled:gi,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:Ka,EventPluginRegistry:va,EventPropagators:$a,ReactControlledComponent:Rb,ReactDOMComponentTree:Qa,ReactDOMEventListener:Od},unstable_createRoot:function(a,b){return new ri(a,!0,null!=b&&!0===b.hydrate)}};li({findFiberByHostInstance:Na,bundleType:0,version:"16.4.2",rendererPackageName:"react-dom"});
var Bi={default:wi},Ci=Bi&&wi||Bi;module.exports=Ci.default?Ci.default:Ci;


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(343);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(344);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_HomePage__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_SettingsPage__ = __webpack_require__(809);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MainRouter=function(_Component){_inherits(MainRouter,_Component);function MainRouter(){_classCallCheck(this,MainRouter);var _this=_possibleConstructorReturn(this,(MainRouter.__proto__||Object.getPrototypeOf(MainRouter)).call(this));_this.appWithPersistentNav=function(){return function(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */],Object.assign({onNavResize:_this.onNavResize},props));};};_this.onNavResize=function(navOpenState){_this.setState({navOpenState:navOpenState});};_this.state={navOpenState:{isOpen:true,width:304}};return _this;}_createClass(MainRouter,[{key:'getChildContext',value:function getChildContext(){return{navOpenState:this.state.navOpenState};}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["c" /* Router */],{history:__WEBPACK_IMPORTED_MODULE_2_react_router__["d" /* browserHistory */]},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["b" /* Route */],{component:this.appWithPersistentNav()},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["b" /* Route */],{path:'/',component:__WEBPACK_IMPORTED_MODULE_4__pages_HomePage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["b" /* Route */],{path:'/settings',component:__WEBPACK_IMPORTED_MODULE_5__pages_SettingsPage__["a" /* default */]})));}}]);return MainRouter;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (MainRouter);MainRouter.childContextTypes={navOpenState:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object};

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(347);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RouterContext__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RouteUtils__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RouterUtils__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__routerWarning__ = __webpack_require__(42);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }













var propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"],
  children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["d" /* routes */],
  routes: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["d" /* routes */], // alias for children
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  createElement: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onError: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onUpdate: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],

  // PRIVATE: For client-side rehydration of server match.
  matchContext: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"]

  /**
   * A <Router> is a high-level API for automatically setting up
   * a router that renders a <RouterContext> with all the props
   * it needs each time the URL changes.
   */
};var Router = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'Router',

  propTypes: propTypes,

  getDefaultProps: function getDefaultProps() {
    return {
      render: function render(props) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__RouterContext__["a" /* default */], props);
      }
    };
  },
  getInitialState: function getInitialState() {
    return {
      location: null,
      routes: null,
      params: null,
      components: null
    };
  },
  handleError: function handleError(error) {
    if (this.props.onError) {
      this.props.onError.call(this, error);
    } else {
      // Throw errors by default so we don't silently swallow them!
      throw error; // This error probably occurred in getChildRoutes or getComponents.
    }
  },
  createRouterObject: function createRouterObject(state) {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext.router;
    }

    var history = this.props.history;

    return Object(__WEBPACK_IMPORTED_MODULE_8__RouterUtils__["b" /* createRouterObject */])(history, this.transitionManager, state);
  },
  createTransitionManager: function createTransitionManager() {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext.transitionManager;
    }

    var history = this.props.history;
    var _props = this.props,
        routes = _props.routes,
        children = _props.children;


    !history.getCurrentLocation ?  false ? invariant(false, 'You have provided a history object created with history v4.x or v2.x ' + 'and earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please change to history v3.x.') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

    return Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])(history, Object(__WEBPACK_IMPORTED_MODULE_7__RouteUtils__["b" /* createRoutes */])(routes || children));
  },
  componentWillMount: function componentWillMount() {
    var _this = this;

    this.transitionManager = this.createTransitionManager();
    this.router = this.createRouterObject(this.state);

    this._unlisten = this.transitionManager.listen(function (error, state) {
      if (error) {
        _this.handleError(error);
      } else {
        // Keep the identity of this.router because of a caveat in ContextUtils:
        // they only work if the object identity is preserved.
        Object(__WEBPACK_IMPORTED_MODULE_8__RouterUtils__["a" /* assignRouterState */])(_this.router, state);
        _this.setState(state, _this.props.onUpdate);
      }
    });
  },


  /* istanbul ignore next: sanity check */
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
     false ? warning(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;

     false ? warning((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
  },
  componentWillUnmount: function componentWillUnmount() {
    if (this._unlisten) this._unlisten();
  },
  render: function render() {
    var _state = this.state,
        location = _state.location,
        routes = _state.routes,
        params = _state.params,
        components = _state.components;

    var _props2 = this.props,
        createElement = _props2.createElement,
        render = _props2.render,
        props = _objectWithoutProperties(_props2, ['createElement', 'render']);

    if (location == null) return null; // Async match

    // Only forward non-Router-specific props to routing context, as those are
    // the only ones that might be custom routing context props.
    Object.keys(propTypes).forEach(function (propType) {
      return delete props[propType];
    });

    return render(_extends({}, props, {
      router: this.router,
      location: location,
      routes: routes,
      params: params,
      components: components,
      createElement: createElement
    }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(50);

var emptyObject = __webpack_require__(109);
var _invariant = __webpack_require__(108);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(43);


function routeParamsChanged(route, prevState, nextState) {
  if (!route.path) return false;

  var paramNames = Object(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["b" /* getParamNames */])(route.path);

  return paramNames.some(function (paramName) {
    return prevState.params[paramName] !== nextState.params[paramName];
  });
}

/**
 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
 * the change from prevState to nextState. We leave routes if either
 * 1) they are not in the next state or 2) they are in the next state
 * but their params have changed (i.e. /users/123 => /users/456).
 *
 * leaveRoutes are ordered starting at the leaf route of the tree
 * we're leaving up to the common parent route. enterRoutes are ordered
 * from the top of the tree we're entering down to the leaf route.
 *
 * changeRoutes are any routes that didn't leave or enter during
 * the transition.
 */
function computeChangedRoutes(prevState, nextState) {
  var prevRoutes = prevState && prevState.routes;
  var nextRoutes = nextState.routes;

  var leaveRoutes = void 0,
      changeRoutes = void 0,
      enterRoutes = void 0;
  if (prevRoutes) {
    var parentIsLeaving = false;
    leaveRoutes = prevRoutes.filter(function (route) {
      if (parentIsLeaving) {
        return true;
      } else {
        var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
        if (isLeaving) parentIsLeaving = true;
        return isLeaving;
      }
    });

    // onLeave hooks start at the leaf route.
    leaveRoutes.reverse();

    enterRoutes = [];
    changeRoutes = [];

    nextRoutes.forEach(function (route) {
      var isNew = prevRoutes.indexOf(route) === -1;
      var paramsChanged = leaveRoutes.indexOf(route) !== -1;

      if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
    });
  } else {
    leaveRoutes = [];
    changeRoutes = [];
    enterRoutes = nextRoutes;
  }

  return {
    leaveRoutes: leaveRoutes,
    changeRoutes: changeRoutes,
    enterRoutes: enterRoutes
  };
}

/* harmony default export */ __webpack_exports__["a"] = (computeChangedRoutes);

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTransitionUtils;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(111);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var PendingHooks = function PendingHooks() {
  var _this = this;

  _classCallCheck(this, PendingHooks);

  this.hooks = [];

  this.add = function (hook) {
    return _this.hooks.push(hook);
  };

  this.remove = function (hook) {
    return _this.hooks = _this.hooks.filter(function (h) {
      return h !== hook;
    });
  };

  this.has = function (hook) {
    return _this.hooks.indexOf(hook) !== -1;
  };

  this.clear = function () {
    return _this.hooks = [];
  };
};

function getTransitionUtils() {
  var enterHooks = new PendingHooks();
  var changeHooks = new PendingHooks();

  function createTransitionHook(hook, route, asyncArity, pendingHooks) {
    var isSync = hook.length < asyncArity;

    var transitionHook = function transitionHook() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      hook.apply(route, args);

      if (isSync) {
        var callback = args[args.length - 1];
        // Assume hook executes synchronously and
        // automatically call the callback.
        callback();
      }
    };

    pendingHooks.add(transitionHook);

    return transitionHook;
  }

  function getEnterHooks(routes) {
    return routes.reduce(function (hooks, route) {
      if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
      return hooks;
    }, []);
  }

  function getChangeHooks(routes) {
    return routes.reduce(function (hooks, route) {
      if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
      return hooks;
    }, []);
  }

  function runTransitionHooks(length, iter, callback) {
    if (!length) {
      callback();
      return;
    }

    var redirectInfo = void 0;
    function replace(location) {
      redirectInfo = location;
    }

    Object(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["a" /* loopAsync */])(length, function (index, next, done) {
      iter(index, replace, function (error) {
        if (error || redirectInfo) {
          done(error, redirectInfo); // No need to continue.
        } else {
          next();
        }
      });
    }, callback);
  }

  /**
   * Runs all onEnter hooks in the given array of routes in order
   * with onEnter(nextState, replace, callback) and calls
   * callback(error, redirectInfo) when finished. The first hook
   * to use replace short-circuits the loop.
   *
   * If a hook needs to run asynchronously, it may use the callback
   * function. However, doing so will cause the transition to pause,
   * which could lead to a non-responsive UI if the hook is slow.
   */
  function runEnterHooks(routes, nextState, callback) {
    enterHooks.clear();
    var hooks = getEnterHooks(routes);
    return runTransitionHooks(hooks.length, function (index, replace, next) {
      var wrappedNext = function wrappedNext() {
        if (enterHooks.has(hooks[index])) {
          next.apply(undefined, arguments);
          enterHooks.remove(hooks[index]);
        }
      };
      hooks[index](nextState, replace, wrappedNext);
    }, callback);
  }

  /**
   * Runs all onChange hooks in the given array of routes in order
   * with onChange(prevState, nextState, replace, callback) and calls
   * callback(error, redirectInfo) when finished. The first hook
   * to use replace short-circuits the loop.
   *
   * If a hook needs to run asynchronously, it may use the callback
   * function. However, doing so will cause the transition to pause,
   * which could lead to a non-responsive UI if the hook is slow.
   */
  function runChangeHooks(routes, state, nextState, callback) {
    changeHooks.clear();
    var hooks = getChangeHooks(routes);
    return runTransitionHooks(hooks.length, function (index, replace, next) {
      var wrappedNext = function wrappedNext() {
        if (changeHooks.has(hooks[index])) {
          next.apply(undefined, arguments);
          changeHooks.remove(hooks[index]);
        }
      };
      hooks[index](state, nextState, replace, wrappedNext);
    }, callback);
  }

  /**
   * Runs all onLeave hooks in the given array of routes in order.
   */
  function runLeaveHooks(routes, prevState) {
    for (var i = 0, len = routes.length; i < len; ++i) {
      if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
    }
  }

  return {
    runEnterHooks: runEnterHooks,
    runChangeHooks: runChangeHooks,
    runLeaveHooks: runLeaveHooks
  };
}

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isActive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(43);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



function deepEqual(a, b) {
  if (a == b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return deepEqual(item, b[index]);
    });
  }

  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
    for (var p in a) {
      if (!Object.prototype.hasOwnProperty.call(a, p)) {
        continue;
      }

      if (a[p] === undefined) {
        if (b[p] !== undefined) {
          return false;
        }
      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
        return false;
      } else if (!deepEqual(a[p], b[p])) {
        return false;
      }
    }

    return true;
  }

  return String(a) === String(b);
}

/**
 * Returns true if the current pathname matches the supplied one, net of
 * leading and trailing slash normalization. This is sufficient for an
 * indexOnly route match.
 */
function pathIsActive(pathname, currentPathname) {
  // Normalize leading slash for consistency. Leading slash on pathname has
  // already been normalized in isActive. See caveat there.
  if (currentPathname.charAt(0) !== '/') {
    currentPathname = '/' + currentPathname;
  }

  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
  // `/foo` as active, but in this case, we would already have failed the
  // match.
  if (pathname.charAt(pathname.length - 1) !== '/') {
    pathname += '/';
  }
  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
    currentPathname += '/';
  }

  return currentPathname === pathname;
}

/**
 * Returns true if the given pathname matches the active routes and params.
 */
function routeIsActive(pathname, routes, params) {
  var remainingPathname = pathname,
      paramNames = [],
      paramValues = [];

  // for...of would work here but it's probably slower post-transpilation.
  for (var i = 0, len = routes.length; i < len; ++i) {
    var route = routes[i];
    var pattern = route.path || '';

    if (pattern.charAt(0) === '/') {
      remainingPathname = pathname;
      paramNames = [];
      paramValues = [];
    }

    if (remainingPathname !== null && pattern) {
      var matched = Object(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["c" /* matchPattern */])(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }

      if (remainingPathname === '') {
        // We have an exact match on the route. Just check that all the params
        // match.
        // FIXME: This doesn't work on repeated params.
        return paramNames.every(function (paramName, index) {
          return String(paramValues[index]) === String(params[paramName]);
        });
      }
    }
  }

  return false;
}

/**
 * Returns true if all key/value pairs in the given query are
 * currently active.
 */
function queryIsActive(query, activeQuery) {
  if (activeQuery == null) return query == null;

  if (query == null) return true;

  return deepEqual(query, activeQuery);
}

/**
 * Returns true if a <Link> to the given pathname/query combination is
 * currently active.
 */
function isActive(_ref, indexOnly, currentLocation, routes, params) {
  var pathname = _ref.pathname,
      query = _ref.query;

  if (currentLocation == null) return false;

  // TODO: This is a bit ugly. It keeps around support for treating pathnames
  // without preceding slashes as absolute paths, but possibly also works
  // around the same quirks with basenames as in matchRoutes.
  if (pathname.charAt(0) !== '/') {
    pathname = '/' + pathname;
  }

  if (!pathIsActive(pathname, currentLocation.pathname)) {
    // The path check is necessary and sufficient for indexOnly, but otherwise
    // we still need to check the routes.
    if (indexOnly || !routeIsActive(pathname, routes, params)) {
      return false;
    }
  }

  return queryIsActive(query, currentLocation.query);
}

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PromiseUtils__ = __webpack_require__(188);



function getComponentsForRoute(nextState, route, callback) {
  if (route.component || route.components) {
    callback(null, route.component || route.components);
    return;
  }

  var getComponent = route.getComponent || route.getComponents;
  if (getComponent) {
    var componentReturn = getComponent.call(route, nextState, callback);
    if (Object(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(componentReturn)) componentReturn.then(function (component) {
      return callback(null, component);
    }, callback);
  } else {
    callback();
  }
}

/**
 * Asynchronously fetches all components needed for the given router
 * state and calls callback(error, components) when finished.
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getComponents method.
 */
function getComponents(nextState, callback) {
  Object(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["b" /* mapAsync */])(nextState.routes, function (route, index, callback) {
    getComponentsForRoute(nextState, route, callback);
  }, callback);
}

/* harmony default export */ __webpack_exports__["a"] = (getComponents);

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = matchRoutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PromiseUtils__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PatternUtils__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routerWarning__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(29);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







function getChildRoutes(route, location, paramNames, paramValues, callback) {
  if (route.childRoutes) {
    return [null, route.childRoutes];
  }
  if (!route.getChildRoutes) {
    return [];
  }

  var sync = true,
      result = void 0;

  var partialNextState = {
    location: location,
    params: createParams(paramNames, paramValues)
  };

  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
    childRoutes = !error && Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(childRoutes);
    if (sync) {
      result = [error, childRoutes];
      return;
    }

    callback(error, childRoutes);
  });

  if (Object(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
    return callback(null, Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(childRoutes));
  }, callback);

  sync = false;
  return result; // Might be undefined.
}

function getIndexRoute(route, location, paramNames, paramValues, callback) {
  if (route.indexRoute) {
    callback(null, route.indexRoute);
  } else if (route.getIndexRoute) {
    var partialNextState = {
      location: location,
      params: createParams(paramNames, paramValues)
    };

    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
      callback(error, !error && Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(indexRoute)[0]);
    });

    if (Object(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
      return callback(null, Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(indexRoute)[0]);
    }, callback);
  } else if (route.childRoutes || route.getChildRoutes) {
    var onChildRoutes = function onChildRoutes(error, childRoutes) {
      if (error) {
        callback(error);
        return;
      }

      var pathless = childRoutes.filter(function (childRoute) {
        return !childRoute.path;
      });

      Object(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["a" /* loopAsync */])(pathless.length, function (index, next, done) {
        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
          if (error || indexRoute) {
            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
            done(error, routes);
          } else {
            next();
          }
        });
      }, function (err, routes) {
        callback(null, routes);
      });
    };

    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
    if (result) {
      onChildRoutes.apply(undefined, result);
    }
  } else {
    callback();
  }
}

function assignParams(params, paramNames, paramValues) {
  return paramNames.reduce(function (params, paramName, index) {
    var paramValue = paramValues && paramValues[index];

    if (Array.isArray(params[paramName])) {
      params[paramName].push(paramValue);
    } else if (paramName in params) {
      params[paramName] = [params[paramName], paramValue];
    } else {
      params[paramName] = paramValue;
    }

    return params;
  }, params);
}

function createParams(paramNames, paramValues) {
  return assignParams({}, paramNames, paramValues);
}

function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
  var pattern = route.path || '';

  if (pattern.charAt(0) === '/') {
    remainingPathname = location.pathname;
    paramNames = [];
    paramValues = [];
  }

  // Only try to match the path if the route actually has a pattern, and if
  // we're not just searching for potential nested absolute paths.
  if (remainingPathname !== null && pattern) {
    try {
      var matched = Object(__WEBPACK_IMPORTED_MODULE_2__PatternUtils__["c" /* matchPattern */])(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }
    } catch (error) {
      callback(error);
    }

    // By assumption, pattern is non-empty here, which is the prerequisite for
    // actually terminating a match.
    if (remainingPathname === '') {
      var match = {
        routes: [route],
        params: createParams(paramNames, paramValues)
      };

      getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
        if (error) {
          callback(error);
        } else {
          if (Array.isArray(indexRoute)) {
            var _match$routes;

             false ? warning(indexRoute.every(function (route) {
              return !route.path;
            }), 'Index routes should not have paths') : void 0;
            (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
          } else if (indexRoute) {
             false ? warning(!indexRoute.path, 'Index routes should not have paths') : void 0;
            match.routes.push(indexRoute);
          }

          callback(null, match);
        }
      });

      return;
    }
  }

  if (remainingPathname != null || route.childRoutes) {
    // Either a) this route matched at least some of the path or b)
    // we don't have to load this route's children asynchronously. In
    // either case continue checking for matches in the subtree.
    var onChildRoutes = function onChildRoutes(error, childRoutes) {
      if (error) {
        callback(error);
      } else if (childRoutes) {
        // Check the child routes to see if any of them match.
        matchRoutes(childRoutes, location, function (error, match) {
          if (error) {
            callback(error);
          } else if (match) {
            // A child route matched! Augment the match and pass it up the stack.
            match.routes.unshift(route);
            callback(null, match);
          } else {
            callback();
          }
        }, remainingPathname, paramNames, paramValues);
      } else {
        callback();
      }
    };

    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
    if (result) {
      onChildRoutes.apply(undefined, result);
    }
  } else {
    callback();
  }
}

/**
 * Asynchronously matches the given location to a set of routes and calls
 * callback(error, state) when finished. The state object will have the
 * following properties:
 *
 * - routes       An array of routes that matched, in hierarchical order
 * - params       An object of URL parameters
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getChildRoutes method.
 */
function matchRoutes(routes, location, callback, remainingPathname) {
  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];

  if (remainingPathname === undefined) {
    // TODO: This is a little bit ugly, but it works around a quirk in history
    // that strips the leading slash from pathnames when using basenames with
    // trailing slashes.
    if (location.pathname.charAt(0) !== '/') {
      location = _extends({}, location, {
        pathname: '/' + location.pathname
      });
    }
    remainingPathname = location.pathname;
  }

  Object(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["a" /* loopAsync */])(routes.length, function (index, next, done) {
    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
      if (error || match) {
        done(error, match);
      } else {
        next();
      }
    });
  }, callback);
}

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(43);


/**
 * Extracts an object of params the given route cares about from
 * the given params object.
 */
function getRouteParams(route, params) {
  var routeParams = {};

  if (!route.path) return routeParams;

  Object(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["b" /* getParamNames */])(route.path).forEach(function (p) {
    if (Object.prototype.hasOwnProperty.call(params, p)) {
      routeParams[p] = params[p];
    }
  });

  return routeParams;
}

/* harmony default export */ __webpack_exports__["a"] = (getRouteParams);

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(190);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/**
 * An <IndexLink> is used to link to an <IndexRoute>.
 */
var IndexLink = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'IndexLink',

  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Link__["a" /* default */], _extends({}, this.props, { onlyActiveOnIndex: true }));
  }
});

/* unused harmony default export */ var _unused_webpack_default_export = (IndexLink);

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContextUtils__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PropTypes__ = __webpack_require__(114);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function withRouter(WrappedComponent, options) {
  var withRef = options && options.withRef;

  var WithRouter = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
    displayName: 'WithRouter',

    mixins: [Object(__WEBPACK_IMPORTED_MODULE_4__ContextUtils__["b" /* ContextSubscriber */])('router')],

    contextTypes: { router: __WEBPACK_IMPORTED_MODULE_5__PropTypes__["a" /* routerShape */] },
    propTypes: { router: __WEBPACK_IMPORTED_MODULE_5__PropTypes__["a" /* routerShape */] },

    getWrappedInstance: function getWrappedInstance() {
      !withRef ?  false ? invariant(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      return this.wrappedInstance;
    },
    render: function render() {
      var _this = this;

      var router = this.props.router || this.context.router;
      if (!router) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, this.props);
      }

      var params = router.params,
          location = router.location,
          routes = router.routes;

      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });

      if (withRef) {
        props.ref = function (c) {
          _this.wrappedInstance = c;
        };
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, props);
    }
  });

  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
  WithRouter.WrappedComponent = WrappedComponent;

  return __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default()(WithRouter, WrappedComponent);
}

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redirect__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(51);







/**
 * An <IndexRedirect> is used to redirect from an indexRoute.
 */
/* eslint-disable react/require-render-return */
var IndexRedirect = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'IndexRedirect',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = __WEBPACK_IMPORTED_MODULE_4__Redirect__["a" /* default */].createRouteFromReactElement(element);
      } else {
         false ? warning(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    to: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"].isRequired,
    query: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    state: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    onEnter: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;
  }
});

/* unused harmony default export */ var _unused_webpack_default_export = (IndexRedirect);

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(51);







/**
 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
 * a JSX route config.
 */
/* eslint-disable react/require-render-return */
var IndexRoute = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'IndexRoute',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["a" /* createRouteFromReactElement */])(element);
      } else {
         false ? warning(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    component: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["a" /* component */],
    components: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["b" /* components */],
    getComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
    getComponents: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;
  }
});

/* unused harmony default export */ var _unused_webpack_default_export = (IndexRoute);

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RouteUtils__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__ = __webpack_require__(51);






/**
 * A <Route> is used to declare which components are rendered to the
 * page when the URL matches a given pattern.
 *
 * Routes are arranged in a nested tree structure. When a new URL is
 * requested, the tree is searched depth-first to find a route whose
 * path matches the URL.  When one is found, all routes in the tree
 * that lead to it are considered "active" and their components are
 * rendered into the DOM, nested in the same order as in the tree.
 */
/* eslint-disable react/require-render-return */
var Route = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'Route',

  statics: {
    createRouteFromReactElement: __WEBPACK_IMPORTED_MODULE_3__RouteUtils__["a" /* createRouteFromReactElement */]
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
    component: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["a" /* component */],
    components: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["b" /* components */],
    getComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
    getComponents: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<Route> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RouterUtils__ = __webpack_require__(189);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









/**
 * A high-level API to be used for server-side rendering.
 *
 * This function matches a location to a set of routes and calls
 * callback(error, redirectLocation, renderProps) when finished.
 *
 * Note: You probably don't want to use this in a browser unless you're using
 * server-side rendering with async routes.
 */
function match(_ref, callback) {
  var history = _ref.history,
      routes = _ref.routes,
      location = _ref.location,
      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);

  !(history || location) ?  false ? invariant(false, 'match needs a history or a location') : __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false) : void 0;

  history = history ? history : Object(__WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__["a" /* default */])(options);
  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])(history, Object(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(routes));

  if (location) {
    // Allow match({ location: '/the/path', ... })
    location = history.createLocation(location);
  } else {
    location = history.getCurrentLocation();
  }

  transitionManager.match(location, function (error, redirectLocation, nextState) {
    var renderProps = void 0;

    if (nextState) {
      var router = Object(__WEBPACK_IMPORTED_MODULE_5__RouterUtils__["b" /* createRouterObject */])(history, transitionManager, nextState);
      renderProps = _extends({}, nextState, {
        router: router,
        matchContext: { transitionManager: transitionManager, router: router }
      });
    }

    callback(error, redirectLocation && history.createLocation(redirectLocation, __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__["REPLACE"]), renderProps);
  });
}

/* unused harmony default export */ var _unused_webpack_default_export = (match);

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(363);
var objectAssign = __webpack_require__(50);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(28);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(19);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(44);

var _PathUtils = __webpack_require__(30);

var _createHistory = __webpack_require__(116);

var _createHistory2 = _interopRequireDefault(_createHistory);

var _Actions = __webpack_require__(73);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createStateStorage = function createStateStorage(entries) {
  return entries.filter(function (entry) {
    return entry.state;
  }).reduce(function (memo, entry) {
    memo[entry.key] = entry.state;
    return memo;
  }, {});
};

var createMemoryHistory = function createMemoryHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (Array.isArray(options)) {
    options = { entries: options };
  } else if (typeof options === 'string') {
    options = { entries: [options] };
  }

  var getCurrentLocation = function getCurrentLocation() {
    var entry = entries[current];
    var path = (0, _PathUtils.createPath)(entry);

    var key = void 0,
        state = void 0;
    if (entry.key) {
      key = entry.key;
      state = readState(key);
    }

    var init = (0, _PathUtils.parsePath)(path);

    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
  };

  var canGo = function canGo(n) {
    var index = current + n;
    return index >= 0 && index < entries.length;
  };

  var go = function go(n) {
    if (!n) return;

    if (!canGo(n)) {
       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;

      return;
    }

    current += n;
    var currentLocation = getCurrentLocation();

    // Change action to POP
    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
  };

  var pushLocation = function pushLocation(location) {
    current += 1;

    if (current < entries.length) entries.splice(current);

    entries.push(location);

    saveState(location.key, location.state);
  };

  var replaceLocation = function replaceLocation(location) {
    entries[current] = location;
    saveState(location.key, location.state);
  };

  var history = (0, _createHistory2.default)(_extends({}, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: go
  }));

  var _options = options,
      entries = _options.entries,
      current = _options.current;


  if (typeof entries === 'string') {
    entries = [entries];
  } else if (!Array.isArray(entries)) {
    entries = ['/'];
  }

  entries = entries.map(function (entry) {
    return (0, _LocationUtils.createLocation)(entry);
  });

  if (current == null) {
    current = entries.length - 1;
  } else {
    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
  }

  var storage = createStateStorage(entries);

  var saveState = function saveState(key, state) {
    return storage[key] = state;
  };

  var readState = function readState(key) {
    return storage[key];
  };

  return _extends({}, history, {
    canGo: canGo
  });
};

exports.default = createMemoryHistory;

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var isSync = false,
      hasNext = false,
      doneArgs = void 0;

  var done = function done() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    isDone = true;

    if (isSync) {
      // Iterate instead of recursing if possible.
      doneArgs = args;
      return;
    }

    callback.apply(undefined, args);
  };

  var next = function next() {
    if (isDone) return;

    hasNext = true;

    if (isSync) return; // Iterate instead of recursing if possible.

    isSync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work(currentTurn++, next, done);
    }

    isSync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(undefined, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  };

  next();
};

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RouterContext__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(42);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/* unused harmony default export */ var _unused_webpack_default_export = (function () {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  if (false) {
    middlewares.forEach(function (middleware, index) {
      process.env.NODE_ENV !== 'production' ? warning(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
    });
  }

  var withContext = middlewares.map(function (middleware) {
    return middleware.renderRouterContext;
  }).filter(Boolean);
  var withComponent = middlewares.map(function (middleware) {
    return middleware.renderRouteComponent;
  }).filter(Boolean);

  var makeCreateElement = function makeCreateElement() {
    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"];
    return function (Component, props) {
      return withComponent.reduceRight(function (previous, renderRouteComponent) {
        return renderRouteComponent(previous, props);
      }, baseCreateElement(Component, props));
    };
  };

  return function (renderProps) {
    return withContext.reduceRight(function (previous, renderRouterContext) {
      return renderRouterContext(previous, renderProps);
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__RouterContext__["a" /* default */], _extends({}, renderProps, {
      createElement: makeCreateElement(renderProps.createElement)
    })));
  };
});

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createRouterHistory__ = __webpack_require__(198);


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__createRouterHistory__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory___default.a));

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(19);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(117);

var _BrowserProtocol = __webpack_require__(118);

var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);

var _RefreshProtocol = __webpack_require__(369);

var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);

var _DOMUtils = __webpack_require__(74);

var _createHistory = __webpack_require__(116);

var _createHistory2 = _interopRequireDefault(_createHistory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates and returns a history object that uses HTML5's history API
 * (pushState, replaceState, and the popstate event) to manage history.
 * This is the recommended method of managing history in browsers because
 * it provides the cleanest URLs.
 *
 * Note: In browsers that do not support the HTML5 history API full
 * page reloads will be used to preserve clean URLs. You can force this
 * behavior using { forceRefresh: true } in options.
 */
var createBrowserHistory = function createBrowserHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;

  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;

  var getUserConfirmation = Protocol.getUserConfirmation,
      getCurrentLocation = Protocol.getCurrentLocation,
      pushLocation = Protocol.pushLocation,
      replaceLocation = Protocol.replaceLocation,
      go = Protocol.go;


  var history = (0, _createHistory2.default)(_extends({
    getUserConfirmation: getUserConfirmation }, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: go
  }));

  var listenerCount = 0,
      stopListener = void 0;

  var startListener = function startListener(listener, before) {
    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);

    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopListener();
    };
  };

  var listenBefore = function listenBefore(listener) {
    return startListener(listener, true);
  };

  var listen = function listen(listener) {
    return startListener(listener, false);
  };

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen
  });
};

exports.default = createBrowserHistory;

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;

var _BrowserProtocol = __webpack_require__(118);

Object.defineProperty(exports, 'getUserConfirmation', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.getUserConfirmation;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.go;
  }
});

var _LocationUtils = __webpack_require__(44);

var _PathUtils = __webpack_require__(30);

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
  return (0, _LocationUtils.createLocation)(window.location);
};

var pushLocation = exports.pushLocation = function pushLocation(location) {
  window.location.href = (0, _PathUtils.createPath)(location);
  return false; // Don't update location
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
  window.location.replace((0, _PathUtils.createPath)(location));
  return false; // Don't update location
};

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createRouterHistory__ = __webpack_require__(198);


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__createRouterHistory__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory___default.a));

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(28);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(19);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(117);

var _DOMUtils = __webpack_require__(74);

var _HashProtocol = __webpack_require__(372);

var HashProtocol = _interopRequireWildcard(_HashProtocol);

var _createHistory = __webpack_require__(116);

var _createHistory2 = _interopRequireDefault(_createHistory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DefaultQueryKey = '_k';

var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!' + path;
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substring(1) : path;
    }
  },
  noslash: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '/' ? path.substring(1) : path;
    },
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

var createHashHistory = function createHashHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;

  var queryKey = options.queryKey,
      hashType = options.hashType;


   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;

  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;

  if (hashType == null) hashType = 'slash';

  if (!(hashType in HashPathCoders)) {
     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;

    hashType = 'slash';
  }

  var pathCoder = HashPathCoders[hashType];

  var getUserConfirmation = HashProtocol.getUserConfirmation;


  var getCurrentLocation = function getCurrentLocation() {
    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
  };

  var pushLocation = function pushLocation(location) {
    return HashProtocol.pushLocation(location, pathCoder, queryKey);
  };

  var replaceLocation = function replaceLocation(location) {
    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
  };

  var history = (0, _createHistory2.default)(_extends({
    getUserConfirmation: getUserConfirmation }, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: HashProtocol.go
  }));

  var listenerCount = 0,
      stopListener = void 0;

  var startListener = function startListener(listener, before) {
    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);

    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopListener();
    };
  };

  var listenBefore = function listenBefore(listener) {
    return startListener(listener, true);
  };

  var listen = function listen(listener) {
    return startListener(listener, false);
  };

  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var go = function go(n) {
     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;

    history.go(n);
  };

  var createHref = function createHref(path) {
    return '#' + pathCoder.encodePath(history.createHref(path));
  };

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen,
    go: go,
    createHref: createHref
  });
};

exports.default = createHashHistory;

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;

var _BrowserProtocol = __webpack_require__(118);

Object.defineProperty(exports, 'getUserConfirmation', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.getUserConfirmation;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.go;
  }
});

var _warning = __webpack_require__(28);

var _warning2 = _interopRequireDefault(_warning);

var _LocationUtils = __webpack_require__(44);

var _DOMUtils = __webpack_require__(74);

var _DOMStateStorage = __webpack_require__(197);

var _PathUtils = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
  var path = pathCoder.decodePath(getHashPath());
  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);

  var state = void 0;
  if (key) {
    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
    state = (0, _DOMStateStorage.readState)(key);
  }

  var init = (0, _PathUtils.parsePath)(path);
  init.state = state;

  return (0, _LocationUtils.createLocation)(init, undefined, key);
};

var prevLocation = void 0;

var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = pathCoder.encodePath(path);

    if (path !== encodedPath) {
      // Always be sure we have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var currentLocation = getCurrentLocation(pathCoder, queryKey);

      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events

      prevLocation = currentLocation;

      listener(currentLocation);
    }
  };

  // Ensure the hash is encoded properly.
  var path = getHashPath();
  var encodedPath = pathCoder.encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);

  return function () {
    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
  };
};

var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
  var state = location.state,
      key = location.key;


  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));

  if (state !== undefined) {
    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
    (0, _DOMStateStorage.saveState)(key, state);
  }

  prevLocation = location;

  updateHash(path);
};

var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
  return updateLocation(location, pathCoder, queryKey, function (path) {
    if (getHashPath() !== path) {
      pushHashPath(path);
    } else {
       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
    }
  });
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
  return updateLocation(location, pathCoder, queryKey, function (path) {
    if (getHashPath() !== path) replaceHashPath(path);
  });
};

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_flag__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_modal_dialog__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_page__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_css_reset__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_css_reset___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__atlaskit_css_reset__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_check_circle__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_check_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_check_circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_theme_colors__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_StarterNavigation__ = __webpack_require__(567);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var App=function(_Component){_inherits(App,_Component);function App(){var _ref;var _temp,_this,_ret;_classCallCheck(this,App);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=App.__proto__||Object.getPrototypeOf(App)).call.apply(_ref,[this].concat(args))),_this),_this.state={flags:[],isModalOpen:false},_this.showModal=function(){_this.setState({isModalOpen:true});},_this.hideModal=function(){_this.setState({isModalOpen:false});},_this.addFlag=function(){_this.setState({flags:[{id:Date.now()}].concat(_this.state.flags)});},_this.onFlagDismissed=function(dismissedFlagId){_this.setState({flags:_this.state.flags.filter(function(flag){return flag.id!==dismissedFlagId;})});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(App,[{key:'getChildContext',value:function getChildContext(){return{showModal:this.showModal,addFlag:this.addFlag};}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__atlaskit_page__["c" /* default */],{navigationWidth:this.context.navOpenState.width,navigation:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_StarterNavigation__["a" /* default */],null)},this.props.children),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__atlaskit_flag__["a" /* FlagGroup */],{onDismissed:this.onFlagDismissed},this.state.flags.map(function(flag){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__atlaskit_flag__["b" /* default */],{appearance:'success',icon:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_check_circle___default.a,{label:'Success',secondaryColor:__WEBPACK_IMPORTED_MODULE_7__atlaskit_theme_colors__["k" /* G400 */]}),id:flag.id,key:flag.id,title:'Welcome to the room',description:'You\u2019re now part of \u201CCoffee Club\u201D.',onBlur:setTimeout(function(){this.onFlagDismissed(flag.id);}.bind(_this2),5000),actions:[{content:'Join the conversation',onClick:function onClick(){_this2.onFlagDismissed(flag.id);}}]});})),this.state.isModalOpen&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__atlaskit_modal_dialog__["a" /* default */],{heading:'Candy bar',actions:[{text:'Exit candy bar',onClick:this.hideModal}],onClose:this.hideModal},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{style:{textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'http://i.giphy.com/yidUztgRB2w2gtDwL6.gif',alt:'Moar cupcakes'})))));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);App.contextTypes={navOpenState:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,router:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object};App.propTypes={navOpenState:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,onNavResize:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func};App.childContextTypes={showModal:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,addFlag:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Flag__ = __webpack_require__(119);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Flag__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AutoDismissFlag__ = __webpack_require__(468);
/* unused harmony reexport AutoDismissFlag */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FlagGroup__ = __webpack_require__(469);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__components_FlagGroup__["a"]; });




/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(376);
module.exports = __webpack_require__(18).Object.assign;


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(25);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(378) });


/***/ }),
/* 377 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(53);
var gOPS = __webpack_require__(128);
var pIE = __webpack_require__(77);
var toObject = __webpack_require__(54);
var IObject = __webpack_require__(202);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(47)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(38);
var toLength = __webpack_require__(203);
var toAbsoluteIndex = __webpack_require__(380);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(124);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(382);
module.exports = __webpack_require__(18).Object.getPrototypeOf;


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(54);
var $getPrototypeOf = __webpack_require__(204);

__webpack_require__(78)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(384);
var $Object = __webpack_require__(18).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(25);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(33), 'Object', { defineProperty: __webpack_require__(32).f });


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(386), __esModule: true };

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(129);
__webpack_require__(209);
module.exports = __webpack_require__(132).f('iterator');


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(124);
var defined = __webpack_require__(123);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(130);
var descriptor = __webpack_require__(52);
var setToStringTag = __webpack_require__(131);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(46)(IteratorPrototype, __webpack_require__(23)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(31).document;
module.exports = document && document.documentElement;


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(391);
var step = __webpack_require__(392);
var Iterators = __webpack_require__(55);
var toIObject = __webpack_require__(38);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(206)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 391 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 392 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(394), __esModule: true };

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(395);
__webpack_require__(399);
__webpack_require__(400);
__webpack_require__(401);
module.exports = __webpack_require__(18).Symbol;


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(31);
var has = __webpack_require__(37);
var DESCRIPTORS = __webpack_require__(33);
var $export = __webpack_require__(25);
var redefine = __webpack_require__(207);
var META = __webpack_require__(210).KEY;
var $fails = __webpack_require__(47);
var shared = __webpack_require__(126);
var setToStringTag = __webpack_require__(131);
var uid = __webpack_require__(76);
var wks = __webpack_require__(23);
var wksExt = __webpack_require__(132);
var wksDefine = __webpack_require__(133);
var enumKeys = __webpack_require__(396);
var isArray = __webpack_require__(397);
var anObject = __webpack_require__(35);
var isObject = __webpack_require__(36);
var toIObject = __webpack_require__(38);
var toPrimitive = __webpack_require__(121);
var createDesc = __webpack_require__(52);
var _create = __webpack_require__(130);
var gOPNExt = __webpack_require__(398);
var $GOPD = __webpack_require__(134);
var $DP = __webpack_require__(32);
var $keys = __webpack_require__(53);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(211).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(77).f = $propertyIsEnumerable;
  __webpack_require__(128).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(75)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(46)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(53);
var gOPS = __webpack_require__(128);
var pIE = __webpack_require__(77);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(122);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(38);
var gOPN = __webpack_require__(211).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 399 */
/***/ (function(module, exports) {



/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(133)('asyncIterator');


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(133)('observable');


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(403), __esModule: true };

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(404);
module.exports = __webpack_require__(18).Object.setPrototypeOf;


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(25);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(405).set });


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(36);
var anObject = __webpack_require__(35);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(120)(Function.call, __webpack_require__(134).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(407), __esModule: true };

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(408);
var $Object = __webpack_require__(18).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(25);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(130) });


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(18);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(411), __esModule: true };

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(129);
__webpack_require__(412);
module.exports = __webpack_require__(18).Array.from;


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(120);
var $export = __webpack_require__(25);
var toObject = __webpack_require__(54);
var call = __webpack_require__(413);
var isArrayIter = __webpack_require__(414);
var toLength = __webpack_require__(203);
var createProperty = __webpack_require__(415);
var getIterFn = __webpack_require__(212);

$export($export.S + $export.F * !__webpack_require__(417)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(35);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(55);
var ITERATOR = __webpack_require__(23)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(32);
var createDesc = __webpack_require__(52);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(122);
var TAG = __webpack_require__(23)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(23)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _getOwnPropertyDescriptor = __webpack_require__(419);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);

  if (desc === undefined) {
    var parent = (0, _getPrototypeOf2.default)(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(420), __esModule: true };

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(421);
var $Object = __webpack_require__(18).Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
  return $Object.getOwnPropertyDescriptor(it, key);
};


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(38);
var $getOwnPropertyDescriptor = __webpack_require__(134).f;

__webpack_require__(78)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__UIAnalyticsEvent__ = __webpack_require__(79);











var ContextTypes = {
  getAtlaskitAnalyticsEventHandlers: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};

var AnalyticsListener = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(AnalyticsListener, _Component);

  function AnalyticsListener() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, AnalyticsListener);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = AnalyticsListener.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(AnalyticsListener)).call.apply(_ref, [this].concat(args))), _this), _this.getChildContext = function () {
      return {
        getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
      };
    }, _this.getAnalyticsEventHandlers = function () {
      var _this$props = _this.props,
          channel = _this$props.channel,
          onEvent = _this$props.onEvent;
      var getAtlaskitAnalyticsEventHandlers = _this.context.getAtlaskitAnalyticsEventHandlers;

      var parentEventHandlers = typeof getAtlaskitAnalyticsEventHandlers === 'function' && getAtlaskitAnalyticsEventHandlers() || [];
      var handler = function handler(event, eventChannel) {
        if (channel === '*' || channel === eventChannel) {
          onEvent(event, eventChannel);
        }
      };
      return [handler].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(parentEventHandlers));
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(AnalyticsListener, [{
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return AnalyticsListener;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

AnalyticsListener.contextTypes = ContextTypes;
AnalyticsListener.childContextTypes = ContextTypes;
/* unused harmony default export */ var _unused_webpack_default_export = (AnalyticsListener);

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withAnalyticsContext;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AnalyticsContext__ = __webpack_require__(213);






function withAnalyticsContext() {
  var defaultData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function (WrappedComponent) {
    // $FlowFixMe - flow 0.67 doesn't know about forwardRef
    var WithAnalyticsContext = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function (props, ref) {
      var _props$analyticsConte = props.analyticsContext,
          analyticsContext = _props$analyticsConte === undefined ? {} : _props$analyticsConte,
          others = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(props, ['analyticsContext']);

      var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, defaultData, analyticsContext);
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__AnalyticsContext__["a" /* default */],
        { data: data },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(WrappedComponent, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, others, { ref: ref }))
      );
    });

    WithAnalyticsContext.displayName = 'WithAnalyticsContext(' + (WrappedComponent.displayName || WrappedComponent.name) + ')';

    return WithAnalyticsContext;
  };
}

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(425);
module.exports = __webpack_require__(18).Object.keys;


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(54);
var $keys = __webpack_require__(53);

__webpack_require__(78)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__withAnalyticsEvents__ = __webpack_require__(214);



/* harmony default export */ __webpack_exports__["a"] = (function (channel) {
  return function (payload) {
    return function (createAnalyticsEvent) {
      var consumerEvent = createAnalyticsEvent(payload);
      consumerEvent.clone().fire(channel);
      return consumerEvent;
    };
  };
});

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AnalyticsEvent__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UIAnalyticsEvent__ = __webpack_require__(79);



// Basic events


// UI events

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cleanProps;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);



/*
cleanProps removes props added by the withAnalyticsEvents HOC from an object
*/
function cleanProps(props) {
  /* eslint-disable no-unused-vars */
  var createAnalyticsEvent = props.createAnalyticsEvent,
      cleanedProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(props, ["createAnalyticsEvent"]);
  /* eslint-enable no-unused-vars */


  return cleanedProps;
}

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(15);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CrossIcon = function CrossIcon(props) {
  return _react2.default.createElement(_index2.default, _extends({ dangerouslySetGlyph: '<svg width="24" height="24" viewBox="0 0 24 24" focusable="false" role="presentation"><path d="M12 10.586L6.707 5.293a1 1 0 0 0-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 0 0 1.414 1.414L12 13.414l5.293 5.293a1 1 0 0 0 1.414-1.414L13.414 12l5.293-5.293a1 1 0 1 0-1.414-1.414L12 10.586z" fill="currentColor"/></svg>' }, props));
};
exports.default = CrossIcon;

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Skeleton = __webpack_require__(431);

var _Skeleton2 = _interopRequireDefault(_Skeleton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Skeleton = function (_Component) {
  (0, _inherits3.default)(Skeleton, _Component);

  function Skeleton() {
    (0, _classCallCheck3.default)(this, Skeleton);
    return (0, _possibleConstructorReturn3.default)(this, (Skeleton.__proto__ || (0, _getPrototypeOf2.default)(Skeleton)).apply(this, arguments));
  }

  (0, _createClass3.default)(Skeleton, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_Skeleton2.default, this.props);
    }
  }]);
  return Skeleton;
}(_react.Component);

Skeleton.defaultProps = {
  size: 'medium',
  weight: 'normal'
};
exports.default = Skeleton;

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = __webpack_require__(7);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  width: ', ';\n  height: ', ';\n  display: inline-block;\n  border-radius: 50%;\n  background-color: ', ';\n  opacity: ', ';\n'], ['\n  width: ', ';\n  height: ', ';\n  display: inline-block;\n  border-radius: 50%;\n  background-color: ', ';\n  opacity: ', ';\n']);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _constants = __webpack_require__(216);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _styledComponents2.default.div(_templateObject, function (props) {
  return _constants.sizes[props.size];
}, function (props) {
  return _constants.sizes[props.size];
}, function (_ref) {
  var color = _ref.color;
  return color || 'currentColor';
}, function (_ref2) {
  var weight = _ref2.weight;
  return weight === 'strong' ? 0.3 : 0.15;
});

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(433), __esModule: true };

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(434);
var $Object = __webpack_require__(18).Object;
module.exports = function defineProperties(T, D) {
  return $Object.defineProperties(T, D);
};


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(25);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(33), 'Object', { defineProperties: __webpack_require__(208) });


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(436), __esModule: true };

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(437);
module.exports = __webpack_require__(18).Object.freeze;


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(36);
var meta = __webpack_require__(210).onFreeze;

__webpack_require__(78)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 438 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(440);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

/*
 *          __        ___
 *    _____/ /___  __/ (_)____
 *   / ___/ __/ / / / / / ___/
 *  (__  ) /_/ /_/ / / (__  )
 * /____/\__/\__, /_/_/____/
 *          /____/
 *
 * light - weight css preprocessor @licence MIT
 */
(function (factory) {/* eslint-disable */
	 true ? (module['exports'] = factory(null)) :
		typeof define === 'function' && define['amd'] ? define(factory(null)) :
			(window['stylis'] = factory(null))
}(/** @param {*=} options */function factory (options) {/* eslint-disable */

	'use strict'

	/**
	 * Notes
	 *
	 * The ['<method name>'] pattern is used to support closure compiler
	 * the jsdoc signatures are also used to the same effect
	 *
	 * ----
	 *
	 * int + int + int === n4 [faster]
	 *
	 * vs
	 *
	 * int === n1 && int === n2 && int === n3
	 *
	 * ----
	 *
	 * switch (int) { case ints...} [faster]
	 *
	 * vs
	 *
	 * if (int == 1 && int === 2 ...)
	 *
	 * ----
	 *
	 * The (first*n1 + second*n2 + third*n3) format used in the property parser
	 * is a simple way to hash the sequence of characters
	 * taking into account the index they occur in
	 * since any number of 3 character sequences could produce duplicates.
	 *
	 * On the other hand sequences that are directly tied to the index of the character
	 * resolve a far more accurate measure, it's also faster
	 * to evaluate one condition in a switch statement
	 * than three in an if statement regardless of the added math.
	 *
	 * This allows the vendor prefixer to be both small and fast.
	 */

	var nullptn = /^\0+/g /* matches leading null characters */
	var formatptn = /[\0\r\f]/g /* matches new line, null and formfeed characters */
	var colonptn = /: */g /* splits animation rules */
	var cursorptn = /zoo|gra/ /* assert cursor varient */
	var transformptn = /([,: ])(transform)/g /* vendor prefix transform, older webkit */
	var animationptn = /,+\s*(?![^(]*[)])/g /* splits multiple shorthand notation animations */
	var propertiesptn = / +\s*(?![^(]*[)])/g /* animation properties */
	var elementptn = / *[\0] */g /* selector elements */
	var selectorptn = /,\r+?/g /* splits selectors */
	var andptn = /([\t\r\n ])*\f?&/g /* match & */
	var escapeptn = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g /* matches :global(.*) */
	var invalidptn = /\W+/g /* removes invalid characters from keyframes */
	var keyframeptn = /@(k\w+)\s*(\S*)\s*/ /* matches @keyframes $1 */
	var plcholdrptn = /::(place)/g /* match ::placeholder varient */
	var readonlyptn = /:(read-only)/g /* match :read-only varient */
	var beforeptn = /\s+(?=[{\];=:>])/g /* matches \s before ] ; = : */
	var afterptn = /([[}=:>])\s+/g /* matches \s after characters [ } = : */
	var tailptn = /(\{[^{]+?);(?=\})/g /* matches tail semi-colons ;} */
	var whiteptn = /\s{2,}/g /* matches repeating whitespace */
	var pseudoptn = /([^\(])(:+) */g /* pseudo element */
	var writingptn = /[svh]\w+-[tblr]{2}/ /* match writing mode property values */
	var gradientptn = /([\w-]+t\()/g /* match *gradient property */
	var supportsptn = /\(\s*(.*)\s*\)/g /* match supports (groups) */
	var propertyptn = /([\s\S]*?);/g /* match properties leading semicolon */
	var selfptn = /-self|flex-/g /* match flex- and -self in align-self: flex-*; */
	var pseudofmt = /[^]*?(:[rp][el]a[\w-]+)[^]*/ /* extrats :readonly or :placholder from selector */
	var trimptn = /[ \t]+$/ /* match tail whitspace */
	var dimensionptn = /stretch|:\s*\w+\-(?:conte|avail)/ /* match max/min/fit-content, fill-available */
	var imgsrcptn = /([^-])(image-set\()/

	/* vendors */
	var webkit = '-webkit-'
	var moz = '-moz-'
	var ms = '-ms-'

	/* character codes */
	var SEMICOLON = 59 /* ; */
	var CLOSEBRACES = 125 /* } */
	var OPENBRACES = 123 /* { */
	var OPENPARENTHESES = 40 /* ( */
	var CLOSEPARENTHESES = 41 /* ) */
	var OPENBRACKET = 91 /* [ */
	var CLOSEBRACKET = 93 /* ] */
	var NEWLINE = 10 /* \n */
	var CARRIAGE = 13 /* \r */
	var TAB = 9 /* \t */
	var AT = 64 /* @ */
	var SPACE = 32 /*   */
	var AND = 38 /* & */
	var DASH = 45 /* - */
	var UNDERSCORE = 95 /* _ */
	var STAR = 42 /* * */
	var COMMA = 44 /* , */
	var COLON = 58 /* : */
	var SINGLEQUOTE = 39 /* ' */
	var DOUBLEQUOTE = 34 /* " */
	var FOWARDSLASH = 47 /* / */
	var GREATERTHAN = 62 /* > */
	var PLUS = 43 /* + */
	var TILDE = 126 /* ~ */
	var NULL = 0 /* \0 */
	var FORMFEED = 12 /* \f */
	var VERTICALTAB = 11 /* \v */

	/* special identifiers */
	var KEYFRAME = 107 /* k */
	var MEDIA = 109 /* m */
	var SUPPORTS = 115 /* s */
	var PLACEHOLDER = 112 /* p */
	var READONLY = 111 /* o */
	var IMPORT = 105 /* <at>i */
	var CHARSET = 99 /* <at>c */
	var DOCUMENT = 100 /* <at>d */
	var PAGE = 112 /* <at>p */

	var column = 1 /* current column */
	var line = 1 /* current line numebr */
	var pattern = 0 /* :pattern */

	var cascade = 1 /* #id h1 h2 vs h1#id h2#id  */
	var prefix = 1 /* vendor prefix */
	var escape = 1 /* escape :global() pattern */
	var compress = 0 /* compress output */
	var semicolon = 0 /* no/semicolon option */
	var preserve = 0 /* preserve empty selectors */

	/* empty reference */
	var array = []

	/* plugins */
	var plugins = []
	var plugged = 0
	var should = null

	/* plugin context */
	var POSTS = -2
	var PREPS = -1
	var UNKWN = 0
	var PROPS = 1
	var BLCKS = 2
	var ATRUL = 3

	/* plugin newline context */
	var unkwn = 0

	/* keyframe animation */
	var keyed = 1
	var key = ''

	/* selector namespace */
	var nscopealt = ''
	var nscope = ''

	/**
	 * Compile
	 *
	 * @param {Array<string>} parent
	 * @param {Array<string>} current
	 * @param {string} body
	 * @param {number} id
	 * @param {number} depth
	 * @return {string}
	 */
	function compile (parent, current, body, id, depth) {
		var bracket = 0 /* brackets [] */
		var comment = 0 /* comments /* // or /* */
		var parentheses = 0 /* functions () */
		var quote = 0 /* quotes '', "" */

		var first = 0 /* first character code */
		var second = 0 /* second character code */
		var code = 0 /* current character code */
		var tail = 0 /* previous character code */
		var trail = 0 /* character before previous code */
		var peak = 0 /* previous non-whitespace code */

		var counter = 0 /* count sequence termination */
		var context = 0 /* track current context */
		var atrule = 0 /* track @at-rule context */
		var pseudo = 0 /* track pseudo token index */
		var caret = 0 /* current character index */
		var format = 0 /* control character formating context */
		var insert = 0 /* auto semicolon insertion */
		var invert = 0 /* inverted selector pattern */
		var length = 0 /* generic length address */
		var eof = body.length /* end of file(length) */
		var eol = eof - 1 /* end of file(characters) */

		var char = '' /* current character */
		var chars = '' /* current buffer of characters */
		var child = '' /* next buffer of characters */
		var out = '' /* compiled body */
		var children = '' /* compiled children */
		var flat = '' /* compiled leafs */
		var selector /* generic selector address */
		var result /* generic address */

		// ...build body
		while (caret < eof) {
			code = body.charCodeAt(caret)

			// eof varient
			if (caret === eol) {
				// last character + noop context, add synthetic padding for noop context to terminate
				if (comment + quote + parentheses + bracket !== 0) {
					if (comment !== 0) {
						code = comment === FOWARDSLASH ? NEWLINE : FOWARDSLASH
					}

					quote = parentheses = bracket = 0
					eof++
					eol++
				}
			}

			if (comment + quote + parentheses + bracket === 0) {
				// eof varient
				if (caret === eol) {
					if (format > 0) {
						chars = chars.replace(formatptn, '')
					}

					if (chars.trim().length > 0) {
						switch (code) {
							case SPACE:
							case TAB:
							case SEMICOLON:
							case CARRIAGE:
							case NEWLINE: {
								break
							}
							default: {
								chars += body.charAt(caret)
							}
						}

						code = SEMICOLON
					}
				}

				// auto semicolon insertion
				if (insert === 1) {
					switch (code) {
						// false flags
						case OPENBRACES:
						case CLOSEBRACES:
						case SEMICOLON:
						case DOUBLEQUOTE:
						case SINGLEQUOTE:
						case OPENPARENTHESES:
						case CLOSEPARENTHESES:
						case COMMA: {
							insert = 0
						}
						// ignore
						case TAB:
						case CARRIAGE:
						case NEWLINE:
						case SPACE: {
							break
						}
						// valid
						default: {
							insert = 0
							length = caret
							first = code
							caret--
							code = SEMICOLON

							while (length < eof) {
								switch (body.charCodeAt(length++)) {
									case NEWLINE:
									case CARRIAGE:
									case SEMICOLON: {
										++caret
										code = first
										length = eof
										break
									}
									case COLON: {
										if (format > 0) {
											++caret
											code = first
										}
									}
									case OPENBRACES: {
										length = eof
									}
								}
							}
						}
					}
				}

				// token varient
				switch (code) {
					case OPENBRACES: {
						chars = chars.trim()
						first = chars.charCodeAt(0)
						counter = 1
						length = ++caret

						while (caret < eof) {
							switch (code = body.charCodeAt(caret)) {
								case OPENBRACES: {
									counter++
									break
								}
								case CLOSEBRACES: {
									counter--
									break
								}
								case FOWARDSLASH: {
									switch (second = body.charCodeAt(caret + 1)) {
										// /*, //
										case STAR:
										case FOWARDSLASH: {
											caret = delimited(second, caret, eol, body)
										}
									}
									break
								}
								// given "[" === 91 & "]" === 93 hence forth 91 + 1 + 1 === 93
								case OPENBRACKET: {
									code++
								}
								// given "(" === 40 & ")" === 41 hence forth 40 + 1 === 41
								case OPENPARENTHESES: {
									code++
								}
								// quote tail delimiter is identical to the head delimiter hence noop,
								// fallthrough clauses have been shited to the correct tail delimiter
								case DOUBLEQUOTE:
								case SINGLEQUOTE: {
									while (caret++ < eol) {
										if (body.charCodeAt(caret) === code) {
											break
										}
									}
								}
							}

							if (counter === 0) {
								break
							}

							caret++
						}

						child = body.substring(length, caret)

						if (first === NULL) {
							first = (chars = chars.replace(nullptn, '').trim()).charCodeAt(0)
						}

						switch (first) {
							// @at-rule
							case AT: {
								if (format > 0) {
									chars = chars.replace(formatptn, '')
								}

								second = chars.charCodeAt(1)

								switch (second) {
									case DOCUMENT:
									case MEDIA:
									case SUPPORTS:
									case DASH: {
										selector = current
										break
									}
									default: {
										selector = array
									}
								}

								child = compile(current, selector, child, second, depth+1)
								length = child.length

								// preserve empty @at-rule
								if (preserve > 0 && length === 0) {
									length = chars.length
								}

								// execute plugins, @at-rule context
								if (plugged > 0) {
									selector = select(array, chars, invert)
									result = proxy(ATRUL, child, selector, current, line, column, length, second, depth, id)
									chars = selector.join('')

									if (result !== void 0) {
										if ((length = (child = result.trim()).length) === 0) {
											second = 0
											child = ''
										}
									}
								}

								if (length > 0) {
									switch (second) {
										case SUPPORTS: {
											chars = chars.replace(supportsptn, supports)
										}
										case DOCUMENT:
										case MEDIA:
										case DASH: {
											child = chars + '{' + child + '}'
											break
										}
										case KEYFRAME: {
											chars = chars.replace(keyframeptn, '$1 $2' + (keyed > 0 ? key : ''))
											child = chars + '{' + child + '}'

											if (prefix === 1 || (prefix === 2 && vendor('@'+child, 3))) {
												child = '@' + webkit + child + '@' + child
											} else {
												child = '@' + child
											}
											break
										}
										default: {
											child = chars + child

											if (id === PAGE) {
												child = (out += child, '')
											}
										}
									}
								} else {
									child = ''
								}

								break
							}
							// selector
							default: {
								child = compile(current, select(current, chars, invert), child, id, depth+1)
							}
						}

						children += child

						// reset
						context = 0
						insert = 0
						pseudo = 0
						format = 0
						invert = 0
						atrule = 0
						chars = ''
						child = ''
						code = body.charCodeAt(++caret)
						break
					}
					case CLOSEBRACES:
					case SEMICOLON: {
						chars = (format > 0 ? chars.replace(formatptn, '') : chars).trim()

						if ((length = chars.length) > 1) {
							// monkey-patch missing colon
							if (pseudo === 0) {
								first = chars.charCodeAt(0)

								// first character is a letter or dash, buffer has a space character
								if ((first === DASH || first > 96 && first < 123)) {
									length = (chars = chars.replace(' ', ':')).length
								}
							}

							// execute plugins, property context
							if (plugged > 0) {
								if ((result = proxy(PROPS, chars, current, parent, line, column, out.length, id, depth, id)) !== void 0) {
									if ((length = (chars = result.trim()).length) === 0) {
										chars = '\0\0'
									}
								}
							}

							first = chars.charCodeAt(0)
							second = chars.charCodeAt(1)

							switch (first) {
								case NULL: {
									break
								}
								case AT: {
									if (second === IMPORT || second === CHARSET) {
										flat += chars + body.charAt(caret)
										break
									}
								}
								default: {
									if (chars.charCodeAt(length-1) === COLON) {
										break
									}

									out += property(chars, first, second, chars.charCodeAt(2))
								}
							}
						}

						// reset
						context = 0
						insert = 0
						pseudo = 0
						format = 0
						invert = 0
						chars = ''
						code = body.charCodeAt(++caret)
						break
					}
				}
			}

			// parse characters
			switch (code) {
				case CARRIAGE:
				case NEWLINE: {
					// auto insert semicolon
					if (comment + quote + parentheses + bracket + semicolon === 0) {
						// valid non-whitespace characters that
						// may precede a newline
						switch (peak) {
							case CLOSEPARENTHESES:
							case SINGLEQUOTE:
							case DOUBLEQUOTE:
							case AT:
							case TILDE:
							case GREATERTHAN:
							case STAR:
							case PLUS:
							case FOWARDSLASH:
							case DASH:
							case COLON:
							case COMMA:
							case SEMICOLON:
							case OPENBRACES:
							case CLOSEBRACES: {
								break
							}
							default: {
								// current buffer has a colon
								if (pseudo > 0) {
									insert = 1
								}
							}
						}
					}

					// terminate line comment
					if (comment === FOWARDSLASH) {
						comment = 0
					} else if (cascade + context === 0 && id !== KEYFRAME && chars.length > 0) {
						format = 1
						chars += '\0'
					}

					// execute plugins, newline context
					if (plugged * unkwn > 0) {
						proxy(UNKWN, chars, current, parent, line, column, out.length, id, depth, id)
					}

					// next line, reset column position
					column = 1
					line++
					break
				}
				case SEMICOLON:
				case CLOSEBRACES: {
					if (comment + quote + parentheses + bracket === 0) {
						column++
						break
					}
				}
				default: {
					// increment column position
					column++

					// current character
					char = body.charAt(caret)

					// remove comments, escape functions, strings, attributes and prepare selectors
					switch (code) {
						case TAB:
						case SPACE: {
							if (quote + bracket + comment === 0) {
								switch (tail) {
									case COMMA:
									case COLON:
									case TAB:
									case SPACE: {
										char = ''
										break
									}
									default: {
										if (code !== SPACE) {
											char = ' '
										}
									}
								}
							}
							break
						}
						// escape breaking control characters
						case NULL: {
							char = '\\0'
							break
						}
						case FORMFEED: {
							char = '\\f'
							break
						}
						case VERTICALTAB: {
							char = '\\v'
							break
						}
						// &
						case AND: {
							// inverted selector pattern i.e html &
							if (quote + comment + bracket === 0 && cascade > 0) {
								invert = 1
								format = 1
								char = '\f' + char
							}
							break
						}
						// ::p<l>aceholder, l
						// :read-on<l>y, l
						case 108: {
							if (quote + comment + bracket + pattern === 0 && pseudo > 0) {
								switch (caret - pseudo) {
									// ::placeholder
									case 2: {
										if (tail === PLACEHOLDER && body.charCodeAt(caret-3) === COLON) {
											pattern = tail
										}
									}
									// :read-only
									case 8: {
										if (trail === READONLY) {
											pattern = trail
										}
									}
								}
							}
							break
						}
						// :<pattern>
						case COLON: {
							if (quote + comment + bracket === 0) {
								pseudo = caret
							}
							break
						}
						// selectors
						case COMMA: {
							if (comment + parentheses + quote + bracket === 0) {
								format = 1
								char += '\r'
							}
							break
						}
						// quotes
						case DOUBLEQUOTE: {
							if (comment === 0) {
								quote = quote === code ? 0 : (quote === 0 ? code : quote)
							}
							break
						}
						case SINGLEQUOTE: {
							if (comment === 0) {
								quote = quote === code ? 0 : (quote === 0 ? code : quote)
							}
							break
						}
						// attributes
						case OPENBRACKET: {
							if (quote + comment + parentheses === 0) {
								bracket++
							}
							break
						}
						case CLOSEBRACKET: {
							if (quote + comment + parentheses === 0) {
								bracket--
							}
							break
						}
						// functions
						case CLOSEPARENTHESES: {
							if (quote + comment + bracket === 0) {
								parentheses--
							}
							break
						}
						case OPENPARENTHESES: {
							if (quote + comment + bracket === 0) {
								if (context === 0) {
									switch (tail*2 + trail*3) {
										// :matches
										case 533: {
											break
										}
										// :global, :not, :nth-child etc...
										default: {
											counter = 0
											context = 1
										}
									}
								}

								parentheses++
							}
							break
						}
						case AT: {
							if (comment + parentheses + quote + bracket + pseudo + atrule === 0) {
								atrule = 1
							}
							break
						}
						// block/line comments
						case STAR:
						case FOWARDSLASH: {
							if (quote + bracket + parentheses > 0) {
								break
							}

							switch (comment) {
								// initialize line/block comment context
								case 0: {
									switch (code*2 + body.charCodeAt(caret+1)*3) {
										// //
										case 235: {
											comment = FOWARDSLASH
											break
										}
										// /*
										case 220: {
											length = caret
											comment = STAR
											break
										}
									}
									break
								}
								// end block comment context
								case STAR: {
									if (code === FOWARDSLASH && tail === STAR && length + 2 !== caret) {
										// /*<!> ... */, !
										if (body.charCodeAt(length+2) === 33) {
											out += body.substring(length, caret+1)
										}
										char = ''
										comment = 0
									}
								}
							}
						}
					}

					// ignore comment blocks
					if (comment === 0) {
						// aggressive isolation mode, divide each individual selector
						// including selectors in :not function but excluding selectors in :global function
						if (cascade + quote + bracket + atrule === 0 && id !== KEYFRAME && code !== SEMICOLON) {
							switch (code) {
								case COMMA:
								case TILDE:
								case GREATERTHAN:
								case PLUS:
								case CLOSEPARENTHESES:
								case OPENPARENTHESES: {
									if (context === 0) {
										// outside of an isolated context i.e nth-child(<...>)
										switch (tail) {
											case TAB:
											case SPACE:
											case NEWLINE:
											case CARRIAGE: {
												char = char + '\0'
												break
											}
											default: {
												char = '\0' + char + (code === COMMA ? '' : '\0')
											}
										}
										format = 1
									} else {
										// within an isolated context, sleep untill it's terminated
										switch (code) {
											case OPENPARENTHESES: {
												// :globa<l>(
												if (pseudo + 7 === caret && tail === 108) {
													pseudo = 0
												}
												context = ++counter
												break
											}
											case CLOSEPARENTHESES: {
												if ((context = --counter) === 0) {
													format = 1
													char += '\0'
												}
												break
											}
										}
									}
									break
								}
								case TAB:
								case SPACE: {
									switch (tail) {
										case NULL:
										case OPENBRACES:
										case CLOSEBRACES:
										case SEMICOLON:
										case COMMA:
										case FORMFEED:
										case TAB:
										case SPACE:
										case NEWLINE:
										case CARRIAGE: {
											break
										}
										default: {
											// ignore in isolated contexts
											if (context === 0) {
												format = 1
												char += '\0'
											}
										}
									}
								}
							}
						}

						// concat buffer of characters
						chars += char

						// previous non-whitespace character code
						if (code !== SPACE && code !== TAB) {
							peak = code
						}
					}
				}
			}

			// tail character codes
			trail = tail
			tail = code

			// visit every character
			caret++
		}

		length = out.length

		// preserve empty selector
 		if (preserve > 0) {
 			if (length === 0 && children.length === 0 && (current[0].length === 0) === false) {
 				if (id !== MEDIA || (current.length === 1 && (cascade > 0 ? nscopealt : nscope) === current[0])) {
					length = current.join(',').length + 2
 				}
 			}
		}

		if (length > 0) {
			// cascade isolation mode?
			selector = cascade === 0 && id !== KEYFRAME ? isolate(current) : current

			// execute plugins, block context
			if (plugged > 0) {
				result = proxy(BLCKS, out, selector, parent, line, column, length, id, depth, id)

				if (result !== void 0 && (out = result).length === 0) {
					return flat + out + children
				}
			}

			out = selector.join(',') + '{' + out + '}'

			if (prefix*pattern !== 0) {
				if (prefix === 2 && !vendor(out, 2))
					pattern = 0

				switch (pattern) {
					// ::read-only
					case READONLY: {
						out = out.replace(readonlyptn, ':'+moz+'$1')+out
						break
					}
					// ::placeholder
					case PLACEHOLDER: {
						out = (
							out.replace(plcholdrptn, '::' + webkit + 'input-$1') +
							out.replace(plcholdrptn, '::' + moz + '$1') +
							out.replace(plcholdrptn, ':' + ms + 'input-$1') + out
						)
						break
					}
				}

				pattern = 0
			}
		}

		return flat + out + children
	}

	/**
	 * Select
	 *
	 * @param {Array<string>} parent
	 * @param {string} current
	 * @param {number} invert
	 * @return {Array<string>}
	 */
	function select (parent, current, invert) {
		var selectors = current.trim().split(selectorptn)
		var out = selectors

		var length = selectors.length
		var l = parent.length

		switch (l) {
			// 0-1 parent selectors
			case 0:
			case 1: {
				for (var i = 0, selector = l === 0 ? '' : parent[0] + ' '; i < length; ++i) {
					out[i] = scope(selector, out[i], invert, l).trim()
				}
				break
			}
			// >2 parent selectors, nested
			default: {
				for (var i = 0, j = 0, out = []; i < length; ++i) {
					for (var k = 0; k < l; ++k) {
						out[j++] = scope(parent[k] + ' ', selectors[i], invert, l).trim()
					}
				}
			}
		}

		return out
	}

	/**
	 * Scope
	 *
	 * @param {string} parent
	 * @param {string} current
	 * @param {number} invert
	 * @param {number} level
	 * @return {string}
	 */
	function scope (parent, current, invert, level) {
		var selector = current
		var code = selector.charCodeAt(0)

		// trim leading whitespace
		if (code < 33) {
			code = (selector = selector.trim()).charCodeAt(0)
		}

		switch (code) {
			// &
			case AND: {
				switch (cascade + level) {
					case 0:
					case 1: {
						if (parent.trim().length === 0) {
							break
						}
					}
					default: {
						return selector.replace(andptn, '$1'+parent.trim())
					}
				}
				break
			}
			// :
			case COLON: {
				switch (selector.charCodeAt(1)) {
					// g in :global
					case 103: {
						if (escape > 0 && cascade > 0) {
							return selector.replace(escapeptn, '$1').replace(andptn, '$1'+nscope)
						}
						break
					}
					default: {
						// :hover
						return parent.trim() + selector.replace(andptn, '$1'+parent.trim())
					}
				}
			}
			default: {
				// html &
				if (invert*cascade > 0 && selector.indexOf('\f') > 0) {
					return selector.replace(andptn, (parent.charCodeAt(0) === COLON ? '' : '$1')+parent.trim())
				}
			}
		}

		return parent + selector
	}

	/**
	 * Property
	 *
	 * @param {string} input
	 * @param {number} first
	 * @param {number} second
	 * @param {number} third
	 * @return {string}
	 */
	function property (input, first, second, third) {
		var index = 0
		var out = input + ';'
		var hash = (first*2) + (second*3) + (third*4)
		var cache

		// animation: a, n, i characters
		if (hash === 944) {
			return animation(out)
		} else if (prefix === 0 || (prefix === 2 && !vendor(out, 1))) {
			return out
		}

		// vendor prefix
		switch (hash) {
			// text-decoration/text-size-adjust/text-shadow/text-align/text-transform: t, e, x
			case 1015: {
				// text-shadow/text-align/text-transform, a
				return out.charCodeAt(10) === 97 ? webkit + out + out : out
			}
			// filter/fill f, i, l
			case 951: {
				// filter, t
				return out.charCodeAt(3) === 116 ? webkit + out + out : out
			}
			// color/column, c, o, l
			case 963: {
				// column, n
				return out.charCodeAt(5) === 110 ? webkit + out + out : out
			}
			// box-decoration-break, b, o, x
			case 1009: {
				if (out.charCodeAt(4) !== 100) {
					break
				}
			}
			// mask, m, a, s
			// clip-path, c, l, i
			case 969:
			case 942: {
				return webkit + out + out
			}
			// appearance: a, p, p
			case 978: {
				return webkit + out + moz + out + out
			}
			// hyphens: h, y, p
			// user-select: u, s, e
			case 1019:
			case 983: {
				return webkit + out + moz + out + ms + out + out
			}
			// background/backface-visibility, b, a, c
			case 883: {
				// backface-visibility, -
				if (out.charCodeAt(8) === DASH) {
					return webkit + out + out
				}

				// image-set(...)
				if (out.indexOf('image-set(', 11) > 0) {
					return out.replace(imgsrcptn, '$1'+webkit+'$2') + out
				}

				return out
			}
			// flex: f, l, e
			case 932: {
				if (out.charCodeAt(4) === DASH) {
					switch (out.charCodeAt(5)) {
						// flex-grow, g
						case 103: {
							return webkit + 'box-' + out.replace('-grow', '') + webkit + out + ms + out.replace('grow', 'positive') + out
						}
						// flex-shrink, s
						case 115: {
							return webkit + out + ms + out.replace('shrink', 'negative') + out
						}
						// flex-basis, b
						case 98: {
							return webkit + out + ms + out.replace('basis', 'preferred-size') + out
						}
					}
				}

				return webkit + out + ms + out + out
			}
			// order: o, r, d
			case 964: {
				return webkit + out + ms + 'flex' + '-' + out + out
			}
			// justify-items/justify-content, j, u, s
			case 1023: {
				// justify-content, c
				if (out.charCodeAt(8) !== 99) {
					break
				}

				cache = out.substring(out.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify')
				return webkit + 'box-pack' + cache + webkit + out + ms + 'flex-pack' + cache + out
			}
			// cursor, c, u, r
			case 1005: {
				return cursorptn.test(out) ? out.replace(colonptn, ':' + webkit) + out.replace(colonptn, ':' + moz) + out : out
			}
			// writing-mode, w, r, i
			case 1000: {
				cache = out.substring(13).trim()
				index = cache.indexOf('-') + 1

				switch (cache.charCodeAt(0)+cache.charCodeAt(index)) {
					// vertical-lr
					case 226: {
						cache = out.replace(writingptn, 'tb')
						break
					}
					// vertical-rl
					case 232: {
						cache = out.replace(writingptn, 'tb-rl')
						break
					}
					// horizontal-tb
					case 220: {
						cache = out.replace(writingptn, 'lr')
						break
					}
					default: {
						return out
					}
				}

				return webkit + out + ms + cache + out
			}
			// position: sticky
			case 1017: {
				if (out.indexOf('sticky', 9) === -1) {
					return out
				}
			}
			// display(flex/inline-flex/inline-box): d, i, s
			case 975: {
				index = (out = input).length - 10
				cache = (out.charCodeAt(index) === 33 ? out.substring(0, index) : out).substring(input.indexOf(':', 7) + 1).trim()

				switch (hash = cache.charCodeAt(0) + (cache.charCodeAt(7)|0)) {
					// inline-
					case 203: {
						// inline-box
						if (cache.charCodeAt(8) < 111) {
							break
						}
					}
					// inline-box/sticky
					case 115: {
						out = out.replace(cache, webkit+cache)+';'+out
						break
					}
					// inline-flex
					// flex
					case 207:
					case 102: {
						out = (
							out.replace(cache, webkit+(hash > 102 ? 'inline-' : '')+'box')+';'+
							out.replace(cache, webkit+cache)+';'+
							out.replace(cache, ms+cache+'box')+';'+
							out
						)
					}
				}

				return out + ';'
			}
			// align-items, align-center, align-self: a, l, i, -
			case 938: {
				if (out.charCodeAt(5) === DASH) {
					switch (out.charCodeAt(6)) {
						// align-items, i
						case 105: {
							cache = out.replace('-items', '')
							return webkit + out + webkit + 'box-' + cache + ms + 'flex-' + cache + out
						}
						// align-self, s
						case 115: {
							return webkit + out + ms + 'flex-item-' + out.replace(selfptn, '') + out
						}
						// align-content
						default: {
							return webkit + out + ms + 'flex-line-pack' + out.replace('align-content', '').replace(selfptn, '') + out
						}
					}
				}
				break
			}
			// min/max
			case 973:
			case 989: {
				// min-/max- height/width/block-size/inline-size
				if (out.charCodeAt(3) !== DASH || out.charCodeAt(4) === 122) {
					break
				}
			}
			// height/width: min-content / width: max-content
			case 931:
			case 953: {
				if (dimensionptn.test(input) === true) {
					// stretch
					if ((cache = input.substring(input.indexOf(':') + 1)).charCodeAt(0) === 115)
						return property(input.replace('stretch', 'fill-available'), first, second, third).replace(':fill-available', ':stretch')
					else
						return out.replace(cache, webkit + cache) + out.replace(cache, moz + cache.replace('fill-', '')) + out
				}
				break
			}
			// transform, transition: t, r, a
			case 962: {
				out = webkit + out + (out.charCodeAt(5) === 102 ? ms + out : '') + out

				// transitions
				if (second + third === 211 && out.charCodeAt(13) === 105 && out.indexOf('transform', 10) > 0) {
					return out.substring(0, out.indexOf(';', 27) + 1).replace(transformptn, '$1' + webkit + '$2') + out
				}

				break
			}
		}

		return out
	}

	/**
	 * Vendor
	 *
	 * @param {string} content
	 * @param {number} context
	 * @return {boolean}
	 */
	function vendor (content, context) {
		var index = content.indexOf(context === 1 ? ':' : '{')
		var key = content.substring(0, context !== 3 ? index : 10)
		var value = content.substring(index + 1, content.length - 1)

		return should(context !== 2 ? key : key.replace(pseudofmt, '$1'), value, context)
	}

	/**
	 * Supports
	 *
	 * @param {string} match
	 * @param {string} group
	 * @return {string}
	 */
	function supports (match, group) {
		var out = property(group, group.charCodeAt(0), group.charCodeAt(1), group.charCodeAt(2))

		return out !== group+';' ? out.replace(propertyptn, ' or ($1)').substring(4) : '('+group+')'
	}

	/**
	 * Animation
	 *
	 * @param {string} input
	 * @return {string}
	 */
	function animation (input) {
		var length = input.length
		var index = input.indexOf(':', 9) + 1
		var declare = input.substring(0, index).trim()
		var out = input.substring(index, length-1).trim()

		switch (input.charCodeAt(9)*keyed) {
			case 0: {
				break
			}
			// animation-*, -
			case DASH: {
				// animation-name, n
				if (input.charCodeAt(10) !== 110) {
					break
				}
			}
			// animation/animation-name
			default: {
				// split in case of multiple animations
				var list = out.split((out = '', animationptn))

				for (var i = 0, index = 0, length = list.length; i < length; index = 0, ++i) {
					var value = list[i]
					var items = value.split(propertiesptn)

					while (value = items[index]) {
						var peak = value.charCodeAt(0)

						if (keyed === 1 && (
							// letters
							(peak > AT && peak < 90) || (peak > 96 && peak < 123) || peak === UNDERSCORE ||
							// dash but not in sequence i.e --
							(peak === DASH && value.charCodeAt(1) !== DASH)
						)) {
							// not a number/function
							switch (isNaN(parseFloat(value)) + (value.indexOf('(') !== -1)) {
								case 1: {
									switch (value) {
										// not a valid reserved keyword
										case 'infinite': case 'alternate': case 'backwards': case 'running':
										case 'normal': case 'forwards': case 'both': case 'none': case 'linear':
										case 'ease': case 'ease-in': case 'ease-out': case 'ease-in-out':
										case 'paused': case 'reverse': case 'alternate-reverse': case 'inherit':
										case 'initial': case 'unset': case 'step-start': case 'step-end': {
											break
										}
										default: {
											value += key
										}
									}
								}
							}
						}

						items[index++] = value
					}

					out += (i === 0 ? '' : ',') + items.join(' ')
				}
			}
		}

		out = declare + out + ';'

		if (prefix === 1 || (prefix === 2 && vendor(out, 1)))
			return webkit + out + out

		return out
	}

	/**
	 * Isolate
	 *
	 * @param {Array<string>} current
	 */
	function isolate (current) {
		for (var i = 0, length = current.length, selector = Array(length), padding, element; i < length; ++i) {
			// split individual elements in a selector i.e h1 h2 === [h1, h2]
			var elements = current[i].split(elementptn)
			var out = ''

			for (var j = 0, size = 0, tail = 0, code = 0, l = elements.length; j < l; ++j) {
				// empty element
				if ((size = (element = elements[j]).length) === 0 && l > 1) {
					continue
				}

				tail = out.charCodeAt(out.length-1)
				code = element.charCodeAt(0)
				padding = ''

				if (j !== 0) {
					// determine if we need padding
					switch (tail) {
						case STAR:
						case TILDE:
						case GREATERTHAN:
						case PLUS:
						case SPACE:
						case OPENPARENTHESES:  {
							break
						}
						default: {
							padding = ' '
						}
					}
				}

				switch (code) {
					case AND: {
						element = padding + nscopealt
					}
					case TILDE:
					case GREATERTHAN:
					case PLUS:
					case SPACE:
					case CLOSEPARENTHESES:
					case OPENPARENTHESES: {
						break
					}
					case OPENBRACKET: {
						element = padding + element + nscopealt
						break
					}
					case COLON: {
						switch (element.charCodeAt(1)*2 + element.charCodeAt(2)*3) {
							// :global
							case 530: {
								if (escape > 0) {
									element = padding + element.substring(8, size - 1)
									break
								}
							}
							// :hover, :nth-child(), ...
							default: {
								if (j < 1 || elements[j-1].length < 1) {
									element = padding + nscopealt + element
								}
							}
						}
						break
					}
					case COMMA: {
						padding = ''
					}
					default: {
						if (size > 1 && element.indexOf(':') > 0) {
							element = padding + element.replace(pseudoptn, '$1' + nscopealt + '$2')
						} else {
							element = padding + element + nscopealt
						}
					}
				}

				out += element
			}

			selector[i] = out.replace(formatptn, '').trim()
		}

		return selector
	}

	/**
	 * Proxy
	 *
	 * @param {number} context
	 * @param {string} content
	 * @param {Array<string>} selectors
	 * @param {Array<string>} parents
	 * @param {number} line
	 * @param {number} column
	 * @param {number} length
	 * @param {number} id
	 * @param {number} depth
	 * @param {number} at
	 * @return {(string|void|*)}
	 */
	function proxy (context, content, selectors, parents, line, column, length, id, depth, at) {
		for (var i = 0, out = content, next; i < plugged; ++i) {
			switch (next = plugins[i].call(stylis, context, out, selectors, parents, line, column, length, id, depth, at)) {
				case void 0:
				case false:
				case true:
				case null: {
					break
				}
				default: {
					out = next
				}
			}
		}

		switch (out) {
			case void 0:
			case false:
			case true:
			case null:
			case content: {
				break
			}
			default: {
				return out
			}
		}
	}

	/**
	 * @param {number} code
	 * @param {number} index
	 * @param {number} length
	 * @param {string} body
	 * @return {number}
	 */
	function delimited (code, index, length, body) {
		for (var i = index + 1; i < length; ++i) {
			switch (body.charCodeAt(i)) {
				// /*
				case FOWARDSLASH: {
					if (code === STAR) {
						if (body.charCodeAt(i - 1) === STAR &&  index + 2 !== i) {
							return i + 1
						}
					}
					break
				}
				// //
				case NEWLINE: {
					if (code === FOWARDSLASH) {
						return i + 1
					}
				}
			}
		}

		return i
	}

	/**
	 * @param {number} type
	 * @param {number} index
	 * @param {number} length
	 * @param {number} find
	 * @param {string} body
	 * @return {number}
	 */
	function match (type, index, length, body) {
		for (var i = index + 1; i < length; ++i) {
			switch (body.charCodeAt(i)) {
				case type: {
					return i
				}
			}
		}

		return i
	}

	/**
	 * Minify
	 *
	 * @param {(string|*)} output
	 * @return {string}
	 */
	function minify (output) {
		return output
			.replace(formatptn, '')
			.replace(beforeptn, '')
			.replace(afterptn, '$1')
			.replace(tailptn, '$1')
			.replace(whiteptn, ' ')
	}

	/**
	 * Use
	 *
	 * @param {(Array<function(...?)>|function(...?)|number|void)?} plugin
	 */
	function use (plugin) {
		switch (plugin) {
			case void 0:
			case null: {
				plugged = plugins.length = 0
				break
			}
			default: {
				switch (plugin.constructor) {
					case Array: {
						for (var i = 0, length = plugin.length; i < length; ++i) {
							use(plugin[i])
						}
						break
					}
					case Function: {
						plugins[plugged++] = plugin
						break
					}
					case Boolean: {
						unkwn = !!plugin|0
					}
				}
			}
 		}

 		return use
	}

	/**
	 * Set
	 *
	 * @param {*} options
	 */
	function set (options) {
		for (var name in options) {
			var value = options[name]
			switch (name) {
				case 'keyframe': keyed = value|0; break
				case 'global': escape = value|0; break
				case 'cascade': cascade = value|0; break
				case 'compress': compress = value|0; break
				case 'semicolon': semicolon = value|0; break
				case 'preserve': preserve = value|0; break
				case 'prefix':
					should = null

					if (!value) {
						prefix = 0
					} else if (typeof value !== 'function') {
						prefix = 1
					} else {
						prefix = 2
						should = value
					}
			}
		}

		return set
	}

	/**
	 * Stylis
	 *
	 * @param {string} selector
	 * @param {string} input
	 * @return {*}
	 */
	function stylis (selector, input) {
		if (this !== void 0 && this.constructor === stylis) {
			return factory(selector)
		}

		// setup
		var ns = selector
		var code = ns.charCodeAt(0)

		// trim leading whitespace
		if (code < 33) {
			code = (ns = ns.trim()).charCodeAt(0)
		}

		// keyframe/animation namespace
		if (keyed > 0) {
			key = ns.replace(invalidptn, code === OPENBRACKET ? '' : '-')
		}

		// reset, used to assert if a plugin is moneky-patching the return value
		code = 1

		// cascade/isolate
		if (cascade === 1) {
			nscope = ns
		} else {
			nscopealt = ns
		}

		var selectors = [nscope]
		var result

		// execute plugins, pre-process context
		if (plugged > 0) {
			result = proxy(PREPS, input, selectors, selectors, line, column, 0, 0, 0, 0)

			if (result !== void 0 && typeof result === 'string') {
				input = result
			}
		}

		// build
		var output = compile(array, selectors, input, 0, 0)

		// execute plugins, post-process context
		if (plugged > 0) {
			result = proxy(POSTS, output, selectors, selectors, line, column, output.length, 0, 0, 0)

			// bypass minification
			if (result !== void 0 && typeof(output = result) !== 'string') {
				code = 0
			}
		}

		// reset
		key = ''
		nscope = ''
		nscopealt = ''
		pattern = 0
		line = 1
		column = 1

		return compress*code === 0 ? output : minify(output)
	}

	stylis['use'] = use
	stylis['set'] = set

	if (options !== void 0) {
		set(options)
	}

	return stylis
}));


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

(function (factory) {
	 true ? (module['exports'] = factory()) :
		typeof define === 'function' && define['amd'] ? define(factory()) :
			(window['stylisRuleSheet'] = factory())
}(function () {

	'use strict'

	return function (insertRule) {
		var delimiter = '/*|*/'
		var needle = delimiter+'}'

		function toSheet (block) {
			if (block)
				try {
					insertRule(block + '}')
				} catch (e) {}
		}

		return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
			switch (context) {
				// property
				case 1:
					// @import
					if (depth === 0 && content.charCodeAt(0) === 64)
						return insertRule(content+';'), ''
					break
				// selector
				case 2:
					if (ns === 0)
						return content + delimiter
					break
				// at-rule
				case 3:
					switch (ns) {
						// @font-face, @page
						case 102:
						case 112:
							return insertRule(selectors[0]+content), ''
						default:
							return content + (at === 0 ? delimiter : '')
					}
				case -2:
					content.split(needle).forEach(toSheet)
			}
		}
	}
}))


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(444);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.4.2
 * react-is.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.forward_ref"):60112,n=b?Symbol.for("react.timeout"):60113;
function q(a){if("object"===typeof a&&null!==a){var p=a.$$typeof;switch(p){case c:switch(a=a.type,a){case l:case e:case g:case f:return a;default:switch(a=a&&a.$$typeof,a){case k:case m:case h:return a;default:return p}}case d:return p}}}exports.typeOf=q;exports.AsyncMode=l;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=m;exports.Fragment=e;exports.Profiler=g;exports.Portal=d;exports.StrictMode=f;
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===l||a===g||a===f||a===n||"object"===typeof a&&null!==a&&(a.$$typeof===h||a.$$typeof===k||a.$$typeof===m)};exports.isAsyncMode=function(a){return q(a)===l};exports.isContextConsumer=function(a){return q(a)===k};exports.isContextProvider=function(a){return q(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return q(a)===m};
exports.isFragment=function(a){return q(a)===e};exports.isProfiler=function(a){return q(a)===g};exports.isPortal=function(a){return q(a)===d};exports.isStrictMode=function(a){return q(a)===f};


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.size = exports.IconWrapper = undefined;

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = __webpack_require__(45);

var _assign2 = _interopRequireDefault(_assign);

var _keys = __webpack_require__(13);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(4);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(6);

var _inherits3 = _interopRequireDefault(_inherits2);

var _taggedTemplateLiteral2 = __webpack_require__(7);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  ', ' color: ', ';\n  display: inline-block;\n  fill: ', ';\n  flex-shrink: 0;\n  line-height: 1;\n\n  > svg {\n    ', ' max-height: 100%;\n    max-width: 100%;\n    overflow: hidden;\n    pointer-events: none;\n    vertical-align: bottom;\n  }\n  /* Stop-color doesn\'t properly apply in chrome when the inherited/current color changes.\n   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS\n   * rule) and then override it with currentColor for the color changes to be picked up.\n   */\n  stop {\n    stop-color: currentColor;\n  }\n'], ['\n  ', ' color: ', ';\n  display: inline-block;\n  fill: ', ';\n  flex-shrink: 0;\n  line-height: 1;\n\n  > svg {\n    ', ' max-height: 100%;\n    max-width: 100%;\n    overflow: hidden;\n    pointer-events: none;\n    vertical-align: bottom;\n  }\n  /* Stop-color doesn\'t properly apply in chrome when the inherited/current color changes.\n   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS\n   * rule) and then override it with currentColor for the color changes to be picked up.\n   */\n  stop {\n    stop-color: currentColor;\n  }\n']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _uuid = __webpack_require__(137);

var _uuid2 = _interopRequireDefault(_uuid);

var _theme = __webpack_require__(139);

var _constants = __webpack_require__(216);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getSize = function getSize(props) {
  if (props.size) {
    return 'height: ' + _constants.sizes[props.size] + '; width: ' + _constants.sizes[props.size] + ';';
  }
  return null;
};

var IconWrapper = exports.IconWrapper = _styledComponents2.default.span(_templateObject, getSize, function (p) {
  return p.primaryColor || 'currentColor';
}, function (p) {
  return p.secondaryColor || _theme.colors.background;
}, getSize);

var Icon = function (_Component) {
  (0, _inherits3.default)(Icon, _Component);

  function Icon() {
    (0, _classCallCheck3.default)(this, Icon);
    return (0, _possibleConstructorReturn3.default)(this, (Icon.__proto__ || (0, _getPrototypeOf2.default)(Icon)).apply(this, arguments));
  }

  (0, _createClass3.default)(Icon, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          Glyph = _props.glyph,
          dangerouslySetGlyph = _props.dangerouslySetGlyph,
          onClick = _props.onClick,
          primaryColor = _props.primaryColor,
          secondaryColor = _props.secondaryColor,
          size = _props.size;

      // handling the glyphs as strings

      if (dangerouslySetGlyph) {
        return _react2.default.createElement(IconWrapper, {
          onClick: onClick,
          primaryColor: primaryColor,
          secondaryColor: secondaryColor,
          size: size,
          'aria-label': this.props.label,
          dangerouslySetInnerHTML: {
            __html: Icon.insertDynamicGradientID(dangerouslySetGlyph)
          }
        });
      }
      // handling the glyphs when passed through as functions
      return _react2.default.createElement(
        IconWrapper,
        {
          onClick: onClick,
          primaryColor: primaryColor,
          secondaryColor: secondaryColor,
          size: size,
          'aria-label': this.props.label
        },
        Glyph ? _react2.default.createElement(Glyph, { role: 'presentation' }) : null
      );
    }
  }], [{
    key: 'insertDynamicGradientID',


    /* Icons need unique gradient IDs across instances for different gradient definitions to work
     * correctly.
     * A step in the icon build process replaces linear gradient IDs and their references in paths
     * to a placeholder string so we can replace them with a dynamic ID here.
     * Replacing the original IDs with placeholders in the build process is more robust than not
     * using placeholders as we do not have to rely on regular expressions to find specific element
     * to replace.
     */
    value: function insertDynamicGradientID(svgStr) {
      var id = (0, _uuid2.default)();

      var replacedSvgStr = svgStr.replace(/id="([^"]+)-idPlaceholder"/g, 'id=$1-' + id).replace(/fill="url\(#([^"]+)-idPlaceholder\)"/g, 'fill="url(#$1-' + id + ')"');

      return replacedSvgStr;
    }
  }]);
  return Icon;
}(_react.Component);

Icon.defaultProps = {
  onClick: function onClick() {}
};
exports.default = Icon;
var size = exports.size = (0, _keys2.default)(_constants.sizes).reduce(function (p, c) {
  return (0, _assign2.default)(p, (0, _defineProperty3.default)({}, c, c));
}, {});

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(217);
var bytesToUuid = __webpack_require__(218);

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;


/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e100", function() { return e100; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e200", function() { return e200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e300", function() { return e300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e400", function() { return e400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e500", function() { return e500; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_themed__ = __webpack_require__(140);



// Cards on a board
var e100 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 1px 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px 0 ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 1px 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

// Inline dialogs
var e200 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 4px 8px -2px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 4px 8px -2px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

// Modals
var e300 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 8px 16px -4px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 8px 16px -4px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

// Panels
var e400 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 12px 24px -6px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 12px 24px -6px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

// Flag messages (notifications)
var e500 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 20px 32px -8px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 20px 32px -8px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h900", function() { return h900; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h800", function() { return h800; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h700", function() { return h700; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h600", function() { return h600; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h500", function() { return h500; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h400", function() { return h400; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h300", function() { return h300; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h200", function() { return h200; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h100", function() { return h100; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__colors__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index__ = __webpack_require__(139);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 500;\n  letter-spacing: -0.01em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 500;\n  letter-spacing: -0.01em;\n  margin-top: ', 'px;\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  margin-top: ', 'px;\n']),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 500;\n  letter-spacing: -0.008em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 500;\n  letter-spacing: -0.008em;\n  margin-top: ', 'px;\n']),
    _templateObject4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.006em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.006em;\n  margin-top: ', 'px;\n']),
    _templateObject5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.003em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.003em;\n  margin-top: ', 'px;\n']),
    _templateObject6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  margin-top: ', 'px;\n  text-transform: uppercase;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  margin-top: ', 'px;\n  text-transform: uppercase;\n']),
    _templateObject7 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  margin-top: ', 'px;\n']),
    _templateObject8 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: normal;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: normal;\n  margin-top: ', 'px;\n']);






var baseHeading = function baseHeading(size, lineHeight) {
  return '\n  font-size: ' + size / Object(__WEBPACK_IMPORTED_MODULE_3__index__["fontSize"])() + 'em;\n  font-style: inherit;\n  line-height: ' + lineHeight / size + ';\n';
};

var h900 = function h900() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject, baseHeading(35, 40), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["gridSize"])() * 6.5);
};

var h800 = function h800() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject2, baseHeading(29, 32), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["gridSize"])() * 5);
};

var h700 = function h700() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject, baseHeading(24, 28), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["gridSize"])() * 5);
};

var h600 = function h600() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject3, baseHeading(20, 24), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["gridSize"])() * 3.5);
};

var h500 = function h500() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject4, baseHeading(16, 20), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["gridSize"])() * 3);
};

var h400 = function h400() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject5, baseHeading(14, 16), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["gridSize"])() * 2);
};

var h300 = function h300() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject6, baseHeading(12, 16), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["gridSize"])() * 2.5);
};

var h200 = function h200() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject7, baseHeading(12, 16), __WEBPACK_IMPORTED_MODULE_2__colors__["subtleHeading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["gridSize"])() * 2);
};

var h100 = function h100() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject8, baseHeading(12, 16), __WEBPACK_IMPORTED_MODULE_2__colors__["subtleHeading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["gridSize"])() * 2);
};

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["add"] = add;
/* harmony export (immutable) */ __webpack_exports__["subtract"] = subtract;
/* harmony export (immutable) */ __webpack_exports__["multiply"] = multiply;
/* harmony export (immutable) */ __webpack_exports__["divide"] = divide;
function add(fn, addend) {
  return function (props) {
    return fn(props) + addend;
  };
}

function subtract(fn, subtrahend) {
  return function (props) {
    return fn(props) - subtrahend;
  };
}

function multiply(fn, factor) {
  return function (props) {
    return fn(props) * factor;
  };
}

function divide(fn, divisor) {
  return function (props) {
    return fn(props) / divisor;
  };
}

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__colors__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Context__ = __webpack_require__(80);








var _templateObject = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  background-color: ', ';\n  color: ', ';\n\n  a {\n    color: ', ';\n  }\n  a:hover {\n    color: ', ';\n  }\n  a:active {\n    color: ', ';\n  }\n  a:focus {\n    outline-color: ', ';\n  }\n  h1 {\n    color: ', ';\n  }\n  h2 {\n    color: ', ';\n  }\n  h3 {\n    color: ', ';\n  }\n  h4 {\n    color: ', ';\n  }\n  h5 {\n    color: ', ';\n  }\n  h6 {\n    color: ', ';\n  }\n  small {\n    color: ', ';\n  }\n'], ['\n  background-color: ', ';\n  color: ', ';\n\n  a {\n    color: ', ';\n  }\n  a:hover {\n    color: ', ';\n  }\n  a:active {\n    color: ', ';\n  }\n  a:focus {\n    outline-color: ', ';\n  }\n  h1 {\n    color: ', ';\n  }\n  h2 {\n    color: ', ';\n  }\n  h3 {\n    color: ', ';\n  }\n  h4 {\n    color: ', ';\n  }\n  h5 {\n    color: ', ';\n  }\n  h6 {\n    color: ', ';\n  }\n  small {\n    color: ', ';\n  }\n']);









// For forward-compat until everything is upgraded.


function getStylesheetResetCSS(state) {
  var backgroundColor = __WEBPACK_IMPORTED_MODULE_10__colors__["background"](state);
  return '\n    body { background: ' + backgroundColor + '; }\n  ';
}

function buildThemeState(mode) {
  return { theme: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_11__constants__["a" /* CHANNEL */], { mode: mode }) };
}

var LegacyReset = __WEBPACK_IMPORTED_MODULE_9_styled_components__["default"].div(_templateObject, __WEBPACK_IMPORTED_MODULE_10__colors__["background"], __WEBPACK_IMPORTED_MODULE_10__colors__["text"], __WEBPACK_IMPORTED_MODULE_10__colors__["link"], __WEBPACK_IMPORTED_MODULE_10__colors__["linkHover"], __WEBPACK_IMPORTED_MODULE_10__colors__["linkActive"], __WEBPACK_IMPORTED_MODULE_10__colors__["linkOutline"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["subtleHeading"], __WEBPACK_IMPORTED_MODULE_10__colors__["subtleText"]);

var AtlaskitThemeProvider = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(AtlaskitThemeProvider, _Component);

  function AtlaskitThemeProvider(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AtlaskitThemeProvider);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AtlaskitThemeProvider.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(AtlaskitThemeProvider)).call(this, props));

    _this.state = buildThemeState(props.mode);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(AtlaskitThemeProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return { hasAtlaskitThemeProvider: true };
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (!this.context.hasAtlaskitThemeProvider) {
        var css = getStylesheetResetCSS(this.state);
        this.stylesheet = document.createElement('style');
        this.stylesheet.type = 'text/css';
        this.stylesheet.innerHTML = css;
        if (document && document.head) {
          document.head.appendChild(this.stylesheet);
        }
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (newProps.mode !== this.props.mode) {
        var newThemeState = buildThemeState(newProps.mode);
        if (this.stylesheet) {
          var css = getStylesheetResetCSS(newThemeState);
          this.stylesheet.innerHTML = css;
        }
        this.setState(newThemeState);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.stylesheet && document && document.head) {
        document.head.removeChild(this.stylesheet);
        delete this.stylesheet;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;

      var theme = this.state.theme;
      return (
        /* Wrapping the new provider around the old one provides forward
        compatibility when using the old provider for styled components. This
        allows us to use components converted to use the new API with consumers
        using the old provider along side components that may still be using the
        old theming API. */
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12__Context__["b" /* Provider */],
          { value: { mode: theme[__WEBPACK_IMPORTED_MODULE_11__constants__["a" /* CHANNEL */]].mode } },
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_styled_components__["ThemeProvider"],
            { theme: theme },
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
              LegacyReset,
              null,
              children
            )
          )
        )
      );
    }
  }]);

  return AtlaskitThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

AtlaskitThemeProvider.defaultProps = {
  mode: __WEBPACK_IMPORTED_MODULE_11__constants__["b" /* DEFAULT_THEME_MODE */]
};
AtlaskitThemeProvider.childContextTypes = {
  hasAtlaskitThemeProvider: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
};
AtlaskitThemeProvider.contextTypes = {
  hasAtlaskitThemeProvider: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
};
/* harmony default export */ __webpack_exports__["a"] = (AtlaskitThemeProvider);

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);





/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var children = _ref.children,
      props = _ref.props,
      theme = _ref.theme;

  var appearance = (typeof props === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(props)) === 'object' ? 'default' : props;
  var merged = (typeof props === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(props)) === 'object' ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, props) : {};
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(theme).forEach(function (key) {
    if (!(key in merged)) {
      merged[key] = theme[key]({ appearance: appearance });
    }
  });
  return children(merged);
});

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__colors__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Context__ = __webpack_require__(80);








var _templateObject = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ';\n'], ['\n  ', ';\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    background-color: ', ';\n    color: ', ';\n\n    a {\n      color: ', ';\n    }\n    a:hover {\n      color: ', ';\n    }\n    a:active {\n      color: ', ';\n    }\n    a:focus {\n      outline-color: ', ';\n    }\n    h1,\n    h2,\n    h3,\n    h4,\n    h5 {\n      color: ', ';\n    }\n    h6 {\n      color: ', ';\n    }\n    small {\n      color: ', ';\n    }\n  '], ['\n    background-color: ', ';\n    color: ', ';\n\n    a {\n      color: ', ';\n    }\n    a:hover {\n      color: ', ';\n    }\n    a:active {\n      color: ', ';\n    }\n    a:focus {\n      outline-color: ', ';\n    }\n    h1,\n    h2,\n    h3,\n    h4,\n    h5 {\n      color: ', ';\n    }\n    h6 {\n      color: ', ';\n    }\n    small {\n      color: ', ';\n    }\n  ']);






var orTextColor = function orTextColor(preferred) {
  return function (p) {
    return p[preferred] || p.textColor;
  };
};
var Div = __WEBPACK_IMPORTED_MODULE_8_styled_components__["default"].div(_templateObject, function (p) {
  return Object(__WEBPACK_IMPORTED_MODULE_8_styled_components__["css"])(_templateObject2, p.backgroundColor, p.textColor, orTextColor('linkColor'), orTextColor('linkColorHover'), orTextColor('linkColorActive'), orTextColor('linkColorOutline'), orTextColor('headingColor'), orTextColor('subtleHeadingColor'), orTextColor('subtleTextColor'));
});

var defaultTheme = {
  backgroundColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N0"],
  linkColor: __WEBPACK_IMPORTED_MODULE_9__colors__["B400"],
  linkColorHover: __WEBPACK_IMPORTED_MODULE_9__colors__["B300"],
  linkColorActive: __WEBPACK_IMPORTED_MODULE_9__colors__["B500"],
  linkColorOutline: __WEBPACK_IMPORTED_MODULE_9__colors__["B100"],
  headingColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N800"],
  subtleHeadingColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N200"],
  subtleTextColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N200"],
  textColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N900"]
};

var Reset = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Reset, _Component);

  function Reset() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Reset);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Reset.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Reset)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Reset, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10__Context__["a" /* Consumer */],
        null,
        function (theme) {
          return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            Div,
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, defaultTheme, theme, _this2.props),
            _this2.props.children
          );
        }
      );
    }
  }]);

  return Reset;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Reset);

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Context__ = __webpack_require__(80);








var Theme = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Theme, _Component);

  function Theme() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Theme);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Theme.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Theme)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Theme, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          values = _props.values;

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__components_Context__["a" /* Consumer */],
        null,
        function (theme) {
          var merged = values(theme);
          return typeof children === 'function' ? children(merged) : __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__components_Context__["b" /* Provider */],
            { value: merged },
            children
          );
        }
      );
    }
  }]);

  return Theme;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Theme.defaultProps = {
  values: function values(v) {
    return v;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (Theme);

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(15);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChevronUpIcon = function ChevronUpIcon(props) {
  return _react2.default.createElement(_index2.default, _extends({ dangerouslySetGlyph: '<svg width="24" height="24" viewBox="0 0 24 24" focusable="false" role="presentation"><path d="M11.221 9.322l-2.929 2.955a1.009 1.009 0 0 0 0 1.419.986.986 0 0 0 1.405 0l2.298-2.317 2.307 2.327a.989.989 0 0 0 1.407 0 1.01 1.01 0 0 0 0-1.419l-2.94-2.965A1.106 1.106 0 0 0 11.991 9c-.279 0-.557.107-.77.322z" fill="currentColor" fill-rule="evenodd"/></svg>' }, props));
};
exports.default = ChevronUpIcon;

/***/ }),
/* 455 */
/***/ (function(module, exports) {

module.exports = {"name":"@atlaskit/flag","version":"9.0.6"}

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Header; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Icon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Title; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DismissButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Content; });
/* unused harmony export Expander */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Description; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__theme__ = __webpack_require__(143);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  background-color: ', ';\n  border-radius: ', 'px;\n  box-sizing: border-box;\n  box-shadow: ', ';\n  color: ', ';\n  padding: ', 'px;\n  transition: background-color 200ms;\n  width: 100%;\n  z-index: 600;\n\n  &:focus {\n    outline: none;\n    box-shadow: 0 0 0 2px ', ';\n  }\n'], ['\n  background-color: ', ';\n  border-radius: ', 'px;\n  box-sizing: border-box;\n  box-shadow: ', ';\n  color: ', ';\n  padding: ', 'px;\n  transition: background-color 200ms;\n  width: 100%;\n  z-index: 600;\n\n  &:focus {\n    outline: none;\n    box-shadow: 0 0 0 2px ', ';\n  }\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  align-items: center;\n  height: ', 'px;\n'], ['\n  display: flex;\n  align-items: center;\n  height: ', 'px;\n']),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  flex: 0 0 auto;\n  width: ', 'px;\n'], ['\n  flex: 0 0 auto;\n  width: ', 'px;\n']),
    _templateObject4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: ', ';\n  font-weight: 600;\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n'], ['\n  color: ', ';\n  font-weight: 600;\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n']),
    _templateObject5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  appearance: none;\n  background: none;\n  border: none;\n  border-radius: ', 'px;\n  color: ', ';\n  cursor: pointer;\n  flex: 0 0 auto;\n  margin-left: ', 'px;\n  padding: 0;\n  white-space: nowrap;\n\n  &:focus {\n    outline: none;\n    box-shadow: 0 0 0 2px ', ';\n  }\n'], ['\n  appearance: none;\n  background: none;\n  border: none;\n  border-radius: ', 'px;\n  color: ', ';\n  cursor: pointer;\n  flex: 0 0 auto;\n  margin-left: ', 'px;\n  padding: 0;\n  white-space: nowrap;\n\n  &:focus {\n    outline: none;\n    box-shadow: 0 0 0 2px ', ';\n  }\n']),
    _templateObject6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex: 1 1 100%;\n  flex-direction: column;\n  justify-content: center;\n  min-width: 0;\n  padding: 0 0 0 ', 'px;\n'], ['\n  display: flex;\n  flex: 1 1 100%;\n  flex-direction: column;\n  justify-content: center;\n  min-width: 0;\n  padding: 0 0 0 ', 'px;\n']),
    _templateObject7 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  max-height: ', 'px;\n  opacity: ', ';\n  overflow: ', ';\n  transition: max-height 0.3s, opacity 0.3s;\n'], ['\n  max-height: ', 'px;\n  opacity: ', ';\n  overflow: ', ';\n  transition: max-height 0.3s, opacity 0.3s;\n']),
    _templateObject8 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: ', ';\n  word-wrap: break-word;\n'], ['\n  color: ', ';\n  word-wrap: break-word;\n']);







var getBoxShadow = function getBoxShadow(props) {
  var borderColor = Object(__WEBPACK_IMPORTED_MODULE_3__theme__["d" /* flagBorderColor */])(props);
  var shadowColor = Object(__WEBPACK_IMPORTED_MODULE_3__theme__["f" /* flagShadowColor */])(props);

  var border = borderColor && '0 0 1px ' + borderColor;
  var shadow = '0 20px 32px -8px ' + shadowColor;

  return [border, shadow].filter(function (p) {
    return p;
  }).join(',');
};

/* harmony default export */ __webpack_exports__["g"] = (__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, __WEBPACK_IMPORTED_MODULE_3__theme__["c" /* flagBackgroundColor */], __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* borderRadius */], getBoxShadow, __WEBPACK_IMPORTED_MODULE_3__theme__["g" /* flagTextColor */], __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* math */].multiply(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */], 2), __WEBPACK_IMPORTED_MODULE_3__theme__["e" /* flagFocusRingColor */]));

// Header
var Header = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject2, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* math */].multiply(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */], 4));

var Icon = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject3, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* math */].multiply(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */], 5));

var Title = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(_templateObject4, __WEBPACK_IMPORTED_MODULE_3__theme__["g" /* flagTextColor */]);

var DismissButton = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].button(_templateObject5, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* borderRadius */], __WEBPACK_IMPORTED_MODULE_3__theme__["g" /* flagTextColor */], __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */], __WEBPACK_IMPORTED_MODULE_3__theme__["e" /* flagFocusRingColor */]);

// Content
var Content = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject6, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* math */].multiply(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */], 5));

var Expander = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject7, function (_ref) {
  var isExpanded = _ref.isExpanded;
  return isExpanded ? 150 : 0;
}, function (_ref2) {
  var isExpanded = _ref2.isExpanded;
  return isExpanded ? 1 : 0;
}, function (_ref3) {
  var isExpanded = _ref3.isExpanded;
  return isExpanded ? 'visible' : 'hidden';
});

var Description = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject8, __WEBPACK_IMPORTED_MODULE_3__theme__["g" /* flagTextColor */]);

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export e100 */
/* unused harmony export e200 */
/* unused harmony export e300 */
/* unused harmony export e400 */
/* unused harmony export e500 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_themed__ = __webpack_require__(142);



// Cards on a board
var e100 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 1px 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px 0 ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 1px 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

// Inline dialogs
var e200 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 4px 8px -2px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 4px 8px -2px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

// Modals
var e300 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 8px 16px -4px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 8px 16px -4px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

// Panels
var e400 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 12px 24px -6px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 12px 24px -6px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

// Flag messages (notifications)
var e500 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 20px 32px -8px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 20px 32px -8px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export h900 */
/* unused harmony export h800 */
/* unused harmony export h700 */
/* unused harmony export h600 */
/* unused harmony export h500 */
/* unused harmony export h400 */
/* unused harmony export h300 */
/* unused harmony export h200 */
/* unused harmony export h100 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__colors__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index__ = __webpack_require__(39);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 500;\n  letter-spacing: -0.01em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 500;\n  letter-spacing: -0.01em;\n  margin-top: ', 'px;\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  margin-top: ', 'px;\n']),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 500;\n  letter-spacing: -0.008em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 500;\n  letter-spacing: -0.008em;\n  margin-top: ', 'px;\n']),
    _templateObject4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.006em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.006em;\n  margin-top: ', 'px;\n']),
    _templateObject5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.003em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.003em;\n  margin-top: ', 'px;\n']),
    _templateObject6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  margin-top: ', 'px;\n  text-transform: uppercase;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  margin-top: ', 'px;\n  text-transform: uppercase;\n']),
    _templateObject7 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  margin-top: ', 'px;\n']),
    _templateObject8 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: normal;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: normal;\n  margin-top: ', 'px;\n']);






var baseHeading = function baseHeading(size, lineHeight) {
  return '\n  font-size: ' + size / Object(__WEBPACK_IMPORTED_MODULE_3__index__["c" /* fontSize */])() + 'em;\n  font-style: inherit;\n  line-height: ' + lineHeight / size + ';\n';
};

var h900 = function h900() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject, baseHeading(35, 40), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 6.5);
};

var h800 = function h800() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject2, baseHeading(29, 32), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 5);
};

var h700 = function h700() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject, baseHeading(24, 28), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 5);
};

var h600 = function h600() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject3, baseHeading(20, 24), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 3.5);
};

var h500 = function h500() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject4, baseHeading(16, 20), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 3);
};

var h400 = function h400() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject5, baseHeading(14, 16), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 2);
};

var h300 = function h300() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject6, baseHeading(12, 16), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 2.5);
};

var h200 = function h200() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject7, baseHeading(12, 16), __WEBPACK_IMPORTED_MODULE_2__colors__["subtleHeading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 2);
};

var h100 = function h100() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject8, baseHeading(12, 16), __WEBPACK_IMPORTED_MODULE_2__colors__["subtleHeading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 2);
};

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["add"] = add;
/* harmony export (immutable) */ __webpack_exports__["subtract"] = subtract;
/* harmony export (immutable) */ __webpack_exports__["multiply"] = multiply;
/* harmony export (immutable) */ __webpack_exports__["divide"] = divide;
function add(fn, addend) {
  return function (props) {
    return fn(props) + addend;
  };
}

function subtract(fn, subtrahend) {
  return function (props) {
    return fn(props) - subtrahend;
  };
}

function multiply(fn, factor) {
  return function (props) {
    return fn(props) * factor;
  };
}

function divide(fn, divisor) {
  return function (props) {
    return fn(props) / divisor;
  };
}

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__colors__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Context__ = __webpack_require__(81);








var _templateObject = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  background-color: ', ';\n  color: ', ';\n\n  a {\n    color: ', ';\n  }\n  a:hover {\n    color: ', ';\n  }\n  a:active {\n    color: ', ';\n  }\n  a:focus {\n    outline-color: ', ';\n  }\n  h1 {\n    color: ', ';\n  }\n  h2 {\n    color: ', ';\n  }\n  h3 {\n    color: ', ';\n  }\n  h4 {\n    color: ', ';\n  }\n  h5 {\n    color: ', ';\n  }\n  h6 {\n    color: ', ';\n  }\n  small {\n    color: ', ';\n  }\n'], ['\n  background-color: ', ';\n  color: ', ';\n\n  a {\n    color: ', ';\n  }\n  a:hover {\n    color: ', ';\n  }\n  a:active {\n    color: ', ';\n  }\n  a:focus {\n    outline-color: ', ';\n  }\n  h1 {\n    color: ', ';\n  }\n  h2 {\n    color: ', ';\n  }\n  h3 {\n    color: ', ';\n  }\n  h4 {\n    color: ', ';\n  }\n  h5 {\n    color: ', ';\n  }\n  h6 {\n    color: ', ';\n  }\n  small {\n    color: ', ';\n  }\n']);









// For forward-compat until everything is upgraded.


function getStylesheetResetCSS(state) {
  var backgroundColor = __WEBPACK_IMPORTED_MODULE_10__colors__["background"](state);
  return '\n    body { background: ' + backgroundColor + '; }\n  ';
}

function buildThemeState(mode) {
  return { theme: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_11__constants__["a" /* CHANNEL */], { mode: mode }) };
}

var LegacyReset = __WEBPACK_IMPORTED_MODULE_9_styled_components__["default"].div(_templateObject, __WEBPACK_IMPORTED_MODULE_10__colors__["background"], __WEBPACK_IMPORTED_MODULE_10__colors__["text"], __WEBPACK_IMPORTED_MODULE_10__colors__["link"], __WEBPACK_IMPORTED_MODULE_10__colors__["linkHover"], __WEBPACK_IMPORTED_MODULE_10__colors__["linkActive"], __WEBPACK_IMPORTED_MODULE_10__colors__["linkOutline"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["subtleHeading"], __WEBPACK_IMPORTED_MODULE_10__colors__["subtleText"]);

var AtlaskitThemeProvider = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(AtlaskitThemeProvider, _Component);

  function AtlaskitThemeProvider(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AtlaskitThemeProvider);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AtlaskitThemeProvider.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(AtlaskitThemeProvider)).call(this, props));

    _this.state = buildThemeState(props.mode);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(AtlaskitThemeProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return { hasAtlaskitThemeProvider: true };
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (!this.context.hasAtlaskitThemeProvider) {
        var css = getStylesheetResetCSS(this.state);
        this.stylesheet = document.createElement('style');
        this.stylesheet.type = 'text/css';
        this.stylesheet.innerHTML = css;
        if (document && document.head) {
          document.head.appendChild(this.stylesheet);
        }
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (newProps.mode !== this.props.mode) {
        var newThemeState = buildThemeState(newProps.mode);
        if (this.stylesheet) {
          var css = getStylesheetResetCSS(newThemeState);
          this.stylesheet.innerHTML = css;
        }
        this.setState(newThemeState);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.stylesheet && document && document.head) {
        document.head.removeChild(this.stylesheet);
        delete this.stylesheet;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;

      var theme = this.state.theme;
      return (
        /* Wrapping the new provider around the old one provides forward
        compatibility when using the old provider for styled components. This
        allows us to use components converted to use the new API with consumers
        using the old provider along side components that may still be using the
        old theming API. */
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12__Context__["b" /* Provider */],
          { value: { mode: theme[__WEBPACK_IMPORTED_MODULE_11__constants__["a" /* CHANNEL */]].mode } },
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_styled_components__["ThemeProvider"],
            { theme: theme },
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
              LegacyReset,
              null,
              children
            )
          )
        )
      );
    }
  }]);

  return AtlaskitThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

AtlaskitThemeProvider.defaultProps = {
  mode: __WEBPACK_IMPORTED_MODULE_11__constants__["b" /* DEFAULT_THEME_MODE */]
};
AtlaskitThemeProvider.childContextTypes = {
  hasAtlaskitThemeProvider: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
};
AtlaskitThemeProvider.contextTypes = {
  hasAtlaskitThemeProvider: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
};
/* harmony default export */ __webpack_exports__["a"] = (AtlaskitThemeProvider);

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);





/* unused harmony default export */ var _unused_webpack_default_export = (function (_ref) {
  var children = _ref.children,
      props = _ref.props,
      theme = _ref.theme;

  var appearance = (typeof props === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(props)) === 'object' ? 'default' : props;
  var merged = (typeof props === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(props)) === 'object' ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, props) : {};
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(theme).forEach(function (key) {
    if (!(key in merged)) {
      merged[key] = theme[key]({ appearance: appearance });
    }
  });
  return children(merged);
});

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__colors__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Context__ = __webpack_require__(81);








var _templateObject = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ';\n'], ['\n  ', ';\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    background-color: ', ';\n    color: ', ';\n\n    a {\n      color: ', ';\n    }\n    a:hover {\n      color: ', ';\n    }\n    a:active {\n      color: ', ';\n    }\n    a:focus {\n      outline-color: ', ';\n    }\n    h1,\n    h2,\n    h3,\n    h4,\n    h5 {\n      color: ', ';\n    }\n    h6 {\n      color: ', ';\n    }\n    small {\n      color: ', ';\n    }\n  '], ['\n    background-color: ', ';\n    color: ', ';\n\n    a {\n      color: ', ';\n    }\n    a:hover {\n      color: ', ';\n    }\n    a:active {\n      color: ', ';\n    }\n    a:focus {\n      outline-color: ', ';\n    }\n    h1,\n    h2,\n    h3,\n    h4,\n    h5 {\n      color: ', ';\n    }\n    h6 {\n      color: ', ';\n    }\n    small {\n      color: ', ';\n    }\n  ']);






var orTextColor = function orTextColor(preferred) {
  return function (p) {
    return p[preferred] || p.textColor;
  };
};
var Div = __WEBPACK_IMPORTED_MODULE_8_styled_components__["default"].div(_templateObject, function (p) {
  return Object(__WEBPACK_IMPORTED_MODULE_8_styled_components__["css"])(_templateObject2, p.backgroundColor, p.textColor, orTextColor('linkColor'), orTextColor('linkColorHover'), orTextColor('linkColorActive'), orTextColor('linkColorOutline'), orTextColor('headingColor'), orTextColor('subtleHeadingColor'), orTextColor('subtleTextColor'));
});

var defaultTheme = {
  backgroundColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N0"],
  linkColor: __WEBPACK_IMPORTED_MODULE_9__colors__["B400"],
  linkColorHover: __WEBPACK_IMPORTED_MODULE_9__colors__["B300"],
  linkColorActive: __WEBPACK_IMPORTED_MODULE_9__colors__["B500"],
  linkColorOutline: __WEBPACK_IMPORTED_MODULE_9__colors__["B100"],
  headingColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N800"],
  subtleHeadingColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N200"],
  subtleTextColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N200"],
  textColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N900"]
};

var Reset = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Reset, _Component);

  function Reset() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Reset);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Reset.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Reset)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Reset, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10__Context__["a" /* Consumer */],
        null,
        function (theme) {
          return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            Div,
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, defaultTheme, theme, _this2.props),
            _this2.props.children
          );
        }
      );
    }
  }]);

  return Reset;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

/* unused harmony default export */ var _unused_webpack_default_export = (Reset);

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Context__ = __webpack_require__(81);








var Theme = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Theme, _Component);

  function Theme() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Theme);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Theme.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Theme)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Theme, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          values = _props.values;

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__components_Context__["a" /* Consumer */],
        null,
        function (theme) {
          var merged = values(theme);
          return typeof children === 'function' ? children(merged) : __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__components_Context__["b" /* Provider */],
            { value: merged },
            children
          );
        }
      );
    }
  }]);

  return Theme;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Theme.defaultProps = {
  values: function values(v) {
    return v;
  }
};
/* unused harmony default export */ var _unused_webpack_default_export = (Theme);

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styledExpander__ = __webpack_require__(465);








var Expander = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Expander, _Component);

  function Expander() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Expander);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Expander.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Expander)).call.apply(_ref, [this].concat(args))), _this), _this.state = { isAnimating: false }, _this.handleTransitionEnd = function () {
      _this.setState({ isAnimating: false });
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  } // eslint-disable-line react/sort-comp


  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Expander, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.isExpanded !== nextProps.isExpanded) {
        this.setState({ isAnimating: true });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          isExpanded = _props.isExpanded;
      var isAnimating = this.state.isAnimating;

      // Need to always render the ExpanderInternal otherwise the
      // reveal transiton doesn't happen. We can't use CSS animation for
      // the the reveal because we don't know the height of the content.

      var childrenIfExpanded = isAnimating || isExpanded ? children : null;

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__styledExpander__["a" /* default */],
        {
          'aria-hidden': !isExpanded,
          isExpanded: isExpanded,
          onTransitionEnd: this.handleTransitionEnd
        },
        childrenIfExpanded
      );
    }
  }]);

  return Expander;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Expander.defaultProps = { isExpanded: false };
/* harmony default export */ __webpack_exports__["a"] = (Expander);

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  max-height: ', 'px;\n  opacity: ', ';\n  overflow: ', ';\n  transition: max-height 0.3s, opacity 0.3s;\n'], ['\n  max-height: ', 'px;\n  opacity: ', ';\n  overflow: ', ';\n  transition: max-height 0.3s, opacity 0.3s;\n']);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, function (_ref) {
  var isExpanded = _ref.isExpanded;
  return isExpanded ? 150 : 0;
}, function (_ref2) {
  var isExpanded = _ref2.isExpanded;
  return isExpanded ? 1 : 0;
}, function (_ref3) {
  var isExpanded = _ref3.isExpanded;
  return isExpanded ? 'visible' : 'hidden';
}));

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uuid_v1__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uuid_v1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_uuid_v1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styledFlagActions__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Flag__ = __webpack_require__(119);











var FlagActions = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(FlagActions, _Component);

  function FlagActions() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, FlagActions);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = FlagActions.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(FlagActions)).call.apply(_ref, [this].concat(args))), _this), _this.getButtonFocusRingColor = function () {
      return 'focusRingColor';
    }, _this.getButtonTheme = function () {
      return 'buttonTheme';
    }, _this.getButtonAppearance = function (b) {
      return b ? 'default' : 'subtle-link';
    }, _this.getButtonSpacing = function (b) {
      return b ? 'compact' : 'none';
    }, _this.getUniqueId = function (prefix) {
      return prefix + '-' + __WEBPACK_IMPORTED_MODULE_6_uuid_v1___default()();
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  } // eslint-disable-line react/sort-comp

  /* eslint-disable no-undef */

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(FlagActions, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          actions = _props.actions,
          appearance = _props.appearance;

      var isBold = appearance !== __WEBPACK_IMPORTED_MODULE_8__Flag__["a" /* DEFAULT_APPEARANCE */];

      if (!actions.length) return null;

      var items = actions.map(function (action, index) {
        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__styledFlagActions__["a" /* Action */],
          {
            key: _this2.getUniqueId('flag-action'),
            hasDivider: !!index,
            useMidDot: !isBold
          },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__styledFlagActions__["b" /* Button */],
            { onClick: action.onClick, appearance: appearance },
            action.content
          )
        );
      });

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__styledFlagActions__["c" /* default */],
        null,
        items
      );
    }
  }]);

  return FlagActions;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

FlagActions.defaultProps = {
  appearance: __WEBPACK_IMPORTED_MODULE_8__Flag__["a" /* DEFAULT_APPEARANCE */],
  actions: []
};
/* harmony default export */ __webpack_exports__["a"] = (FlagActions);

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Action; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Button; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__theme__ = __webpack_require__(143);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: ', ';\n  content: "', '";\n  width: ', 'px;\n'], ['\n  display: ', ';\n  content: "', '";\n  width: ', 'px;\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-wrap: wrap;\n  padding-top: ', 'px;\n'], ['\n  display: flex;\n  flex-wrap: wrap;\n  padding-top: ', 'px;\n']),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  &::before {\n    color: ', ';\n    text-align: center;\n    vertical-align: middle;\n\n    ', ';\n  }\n'], ['\n  &::before {\n    color: ', ';\n    text-align: center;\n    vertical-align: middle;\n\n    ', ';\n  }\n']),
    _templateObject4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  align-items: baseline;\n  background: ', ';\n  border-radius: ', 'px;\n  border-width: 0;\n  box-sizing: border-box;\n  color: ', ';\n  cursor: pointer;\n  display: inline-flex;\n  font-size: inherit;\n  font-style: normal;\n  font-weight: 500;\n  height: ', ';\n  line-height: ', ';\n  margin: 0;\n  outline: 0;\n  padding: 0\n    ', 'px;\n  text-align: center;\n  text-decoration: none;\n  user-select: none;\n  vertical-align: baseline;\n  white-space: nowrap;\n  width: auto;\n\n  &::-moz-focus-inner {\n    border: 0;\n    margin: 0;\n    padding: 0;\n  }\n\n  &:hover {\n    text-decoration: underline;\n  }\n\n  &:focus {\n    outline: none;\n    box-shadow: 0 0 0 2px ', ';\n  }\n'], ['\n  align-items: baseline;\n  background: ', ';\n  border-radius: ', 'px;\n  border-width: 0;\n  box-sizing: border-box;\n  color: ', ';\n  cursor: pointer;\n  display: inline-flex;\n  font-size: inherit;\n  font-style: normal;\n  font-weight: 500;\n  height: ', ';\n  line-height: ', ';\n  margin: 0;\n  outline: 0;\n  padding: 0\n    ', 'px;\n  text-align: center;\n  text-decoration: none;\n  user-select: none;\n  vertical-align: baseline;\n  white-space: nowrap;\n  width: auto;\n\n  &::-moz-focus-inner {\n    border: 0;\n    margin: 0;\n    padding: 0;\n  }\n\n  &:hover {\n    text-decoration: underline;\n  }\n\n  &:focus {\n    outline: none;\n    box-shadow: 0 0 0 2px ', ';\n  }\n']);

/* eslint-disable no-confusing-arrow */







// Outputs the styles for actions separator: mid-dot for non-bold flags, or space for bold flags.
var getDivider = function getDivider(_ref) {
  var hasDivider = _ref.hasDivider,
      useMidDot = _ref.useMidDot;
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject, hasDivider ? 'inline-block' : 'none', useMidDot ? '\xB7' : '', useMidDot ? __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* math */].multiply(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */], 2) : __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */]);
};

/* harmony default export */ __webpack_exports__["c"] = (__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject2, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */]));

var Action = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject3, __WEBPACK_IMPORTED_MODULE_3__theme__["g" /* flagTextColor */], getDivider);

// $FlowFixMe - theme is not found in props
var height = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */] * 3 / parseInt(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["c" /* fontSize */], 10) + 'em';
var Button = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].button(_templateObject4, __WEBPACK_IMPORTED_MODULE_3__theme__["a" /* buttonBackgroundColor */], __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* borderRadius */], __WEBPACK_IMPORTED_MODULE_3__theme__["b" /* buttonTextColor */], height, height, function (p) {
  return (
    // $FlowFixMe - theme is not found in props
    p.appearance === 'normal' ? 0 : Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */])(p)
  );
}, __WEBPACK_IMPORTED_MODULE_3__theme__["e" /* flagFocusRingColor */]);

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AUTO_DISMISS_SECONDS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Flag__ = __webpack_require__(119);










var AUTO_DISMISS_SECONDS = 8;

var AutoDismissFlag = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(AutoDismissFlag, _Component);

  function AutoDismissFlag() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, AutoDismissFlag);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = AutoDismissFlag.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(AutoDismissFlag)).call.apply(_ref, [this].concat(args))), _this), _this.startAutoDismissTimer = function () {
      if (!_this.isAutoDismissAllowed()) {
        return;
      }

      _this.stopAutoDismissTimer();
      _this.autoDismissTimer = setTimeout(_this.handleAutoDismissTimerEnd, AUTO_DISMISS_SECONDS * 1000);
    }, _this.stopAutoDismissTimer = function () {
      if (_this.autoDismissTimer) {
        clearTimeout(_this.autoDismissTimer);
        _this.autoDismissTimer = null;
      }
    }, _this.dismissFlag = function () {
      if (_this.isAutoDismissAllowed() && _this.props.onDismissed) {
        _this.props.onDismissed(_this.props.id);
      }
    }, _this.handleAutoDismissTimerEnd = function () {
      _this.dismissFlag();
    }, _this.handleInteractionStart = function () {
      _this.stopAutoDismissTimer();
    }, _this.isAutoDismissAllowed = function () {
      return _this.props.isDismissAllowed && _this.props.onDismissed;
    }, _this.handleInteractionEnd = function () {
      _this.startAutoDismissTimer();
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  } // eslint-disable-line react/sort-comp

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(AutoDismissFlag, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.startAutoDismissTimer();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stopAutoDismissTimer();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.isDismissAllowed && !prevProps.isDismissAllowed) {
        this.startAutoDismissTimer();
      } else if (!this.props.isDismissAllowed && prevProps.isDismissAllowed) {
        this.stopAutoDismissTimer();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Flag__["b" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        onMouseOver: this.handleInteractionStart,
        onFocus: this.handleInteractionStart,
        onMouseOut: this.handleInteractionEnd,
        onBlur: this.handleInteractionEnd
      }, this.props));
    }
  }]);

  return AutoDismissFlag;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

/* unused harmony default export */ var _unused_webpack_default_export = (AutoDismissFlag);

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_transition_group__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_portal__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__atlaskit_theme__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styled_Wrapper__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styledFlagGroup__ = __webpack_require__(480);













var FlagGroup = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(FlagGroup, _Component);

  function FlagGroup() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, FlagGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = FlagGroup.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(FlagGroup)).call.apply(_ref, [this].concat(args))), _this), _this.renderChildren = function () {
      var _this$props = _this.props,
          children = _this$props.children,
          onDismissed = _this$props.onDismissed;


      return __WEBPACK_IMPORTED_MODULE_5_react__["Children"].map(children, function (flag, idx) {
        var isDismissAllowed = idx === 0;
        var id = flag.props.id;


        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_transition_group__["Transition"],
          {
            key: id,
            addEndListener: function addEndListener(node, done) {
              node.addEventListener('animationend', done);
            }
          },
          function (transitionState) {
            return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9__styled_Wrapper__["a" /* default */],
              { transitionState: transitionState },
              Object(__WEBPACK_IMPORTED_MODULE_5_react__["cloneElement"])(flag, { onDismissed: onDismissed, isDismissAllowed: isDismissAllowed })
            );
          }
        );
      });
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  } // eslint-disable-line react/sort-comp

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(FlagGroup, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__atlaskit_portal__["a" /* default */],
        { zIndex: __WEBPACK_IMPORTED_MODULE_8__atlaskit_theme__["e" /* layers */].flag() },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10__styledFlagGroup__["c" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10__styledFlagGroup__["b" /* SROnly */],
            null,
            'Flag notifications'
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10__styledFlagGroup__["a" /* Inner */],
            { component: 'div' },
            this.renderChildren()
          )
        )
      );
    }
  }]);

  return FlagGroup;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FlagGroup);

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(9);

var PropTypes = _interopRequireWildcard(_propTypes);

var _addClass = __webpack_require__(471);

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__(473);

var _removeClass2 = _interopRequireDefault(_removeClass);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Transition = __webpack_require__(225);

var _Transition2 = _interopRequireDefault(_Transition);

var _PropTypes = __webpack_require__(227);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass2.default)(node, c);
  });
};
var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass2.default)(node, c);
  });
};

var propTypes = _extends({}, _Transition2.default.propTypes, {

  /**
   * The animation classNames applied to the component as it enters, exits or has finished the transition.
   * A single name can be provided and it will be suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`, `fade-enter-done`,
   * `fade-exit`, `fade-exit-active`, `fade-exit-done`, `fade-appear`, and `fade-appear-active`.
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply spread
   * them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: _PropTypes.classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
});

/**
 * A `Transition` component using CSS transitions and animations.
 * It's inspired by the excellent [ng-animate](http://www.nganimate.org/) library.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` stages of the transition. The first class is applied and then a
 * second "active" class in order to activate the css animation. After the animation,
 * matching `done` class names are applied to persist the animation state.
 *
 * When the `in` prop is toggled to `true` the Component will get
 * the `example-enter` CSS class and the `example-enter-active` CSS class
 * added in the next tick. This is a convention based on the `classNames` prop.
 *
 * ## Example
 *
 * <iframe src="https://codesandbox.io/embed/m77l2vp00x?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
 */

var CSSTransition = function (_React$Component) {
  _inherits(CSSTransition, _React$Component);

  function CSSTransition() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransition);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');
      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    }, _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node);
      }
    }, _this.onEntered = function (node, appearing) {
      var _this$getClassNames3 = _this.getClassNames('enter'),
          doneClassName = _this$getClassNames3.doneClassName;

      _this.removeClasses(node, appearing ? 'appear' : 'enter');
      addClass(node, doneClassName);

      if (_this.props.onEntered) {
        _this.props.onEntered(node);
      }
    }, _this.onExit = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          className = _this$getClassNames4.className;

      _this.removeClasses(node, 'appear');
      _this.removeClasses(node, 'enter');
      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    }, _this.onExiting = function (node) {
      var _this$getClassNames5 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames5.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    }, _this.onExited = function (node) {
      var _this$getClassNames6 = _this.getClassNames('exit'),
          doneClassName = _this$getClassNames6.doneClassName;

      _this.removeClasses(node, 'exit');
      addClass(node, doneClassName);

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    }, _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;


      var className = typeof classNames !== 'string' ? classNames[type] : classNames + '-' + type;

      var activeClassName = typeof classNames !== 'string' ? classNames[type + 'Active'] : className + '-active';

      var doneClassName = typeof classNames !== 'string' ? classNames[type + 'Done'] : className + '-done';

      return {
        className: className,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransition.prototype.removeClasses = function removeClasses(node, type) {
    var _getClassNames = this.getClassNames(type),
        className = _getClassNames.className,
        activeClassName = _getClassNames.activeClassName,
        doneClassName = _getClassNames.doneClassName;

    className && removeClass(node, className);
    activeClassName && removeClass(node, activeClassName);
    doneClassName && removeClass(node, doneClassName);
  };

  CSSTransition.prototype.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    if (className) {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
      /* eslint-enable no-unused-expressions */
      addClass(node, className);
    }
  };

  CSSTransition.prototype.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;

    return _react2.default.createElement(_Transition2.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react2.default.Component);

CSSTransition.propTypes =  false ? propTypes : {};

exports.default = CSSTransition;
module.exports = exports['default'];

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addClass;

var _hasClass = __webpack_require__(472);

var _hasClass2 = _interopRequireDefault(_hasClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass2.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}
module.exports = exports['default'];

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hasClass;
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = exports["default"];

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(27);

var _TransitionGroup = __webpack_require__(82);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  in: _propTypes2.default.bool.isRequired,
  children: function children(props, propName) {
    if (_react2.default.Children.count(props[propName]) !== 2) return new Error('"' + propName + '" must be exactly two transition components.');

    return null;
  }
};

/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */

var ReplaceTransition = function (_React$Component) {
  _inherits(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _temp, _this, _ret;

    _classCallCheck(this, ReplaceTransition);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  ReplaceTransition.prototype.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;

    var child = _react2.default.Children.toArray(children)[idx];

    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
  };

  ReplaceTransition.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        inProp = _props.in,
        props = _objectWithoutProperties(_props, ['children', 'in']);

    var _React$Children$toArr = _react2.default.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;

    return _react2.default.createElement(
      _TransitionGroup2.default,
      props,
      inProp ? _react2.default.cloneElement(first, {
        key: 'first',
        onEnter: this.handleEnter,
        onEntering: this.handleEntering,
        onEntered: this.handleEntered

      }) : _react2.default.cloneElement(second, {
        key: 'second',
        onEnter: this.handleExit,
        onEntering: this.handleExiting,
        onEntered: this.handleExited
      })
    );
  };

  return ReplaceTransition;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleEnter = function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _this2.handleLifecycle('onEnter', 0, args);
  };

  this.handleEntering = function () {
    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return _this2.handleLifecycle('onEntering', 0, args);
  };

  this.handleEntered = function () {
    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return _this2.handleLifecycle('onEntered', 0, args);
  };

  this.handleExit = function () {
    for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    return _this2.handleLifecycle('onExit', 1, args);
  };

  this.handleExiting = function () {
    for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }

    return _this2.handleLifecycle('onExiting', 1, args);
  };

  this.handleExited = function () {
    for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      args[_key7] = arguments[_key7];
    }

    return _this2.handleLifecycle('onExited', 1, args);
  };
};

ReplaceTransition.propTypes =  false ? propTypes : {};

exports.default = ReplaceTransition;
module.exports = exports['default'];

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;
exports.getInitialChildMapping = getInitialChildMapping;
exports.getNextChildMapping = getNextChildMapping;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = Object.create(null);

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0, _react.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}

function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);

  Object.keys(children).forEach(function (key) {
    var child = children[key];

    if (!(0, _react.isValidElement)(child)) return;

    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;

    var prevChild = prevChildMapping[key];
    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in;

    // item is new (entering)
    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0, _react.cloneElement)(child, { in: false });
    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });

  return children;
}

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_tiny_invariant__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_canUseDom__ = __webpack_require__(478);










var createContainer = function createContainer(zIndex) {
  var container = document.createElement('div');
  container.setAttribute('class', 'atlaskit-portal');
  container.setAttribute('style', 'z-index: ' + zIndex + ';');
  return container;
};

var body = function body() {
  Object(__WEBPACK_IMPORTED_MODULE_7_tiny_invariant__["a" /* default */])(document && document.body, 'cannot find document.body');
  return document.body;
};

// This is a generic component does two things:
// 1. Portals it's children using React.createPortal
// 2. Creates the DOM node container for the portal based on props

var Portal = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Portal, _React$Component);

  function Portal() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Portal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Portal.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Portal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      container: Object(__WEBPACK_IMPORTED_MODULE_8__utils_canUseDom__["a" /* default */])() ? createContainer(_this.props.zIndex) : undefined
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Portal, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var container = this.state.container;
      var zIndex = this.props.zIndex;

      if (container && prevProps.zIndex !== zIndex) {
        var newContainer = createContainer(zIndex);

        body().replaceChild(container, newContainer);
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({ container: newContainer });
      } else if (!prevState.container && container) {
        // SSR path
        body().appendChild(container);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var container = this.state.container;
      var zIndex = this.props.zIndex;

      if (container) {
        body().appendChild(container);
      } else {
        // SSR path
        var newContainer = createContainer(zIndex);
        // eslint-disable-next-line react/no-did-mount-set-state
        this.setState({ container: newContainer });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var container = this.state.container;

      if (container) {
        body().removeChild(container);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var container = this.state.container;

      return container ? __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.createPortal(this.props.children, container) : this.props.children;
    }
  }]);

  return Portal;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Portal.defaultProps = {
  zIndex: 0
};


/* harmony default export */ __webpack_exports__["a"] = (Portal);

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';

var index = (function (condition, message) {
  if (condition) {
    return;
  }

  if (isProduction) {
    throw new Error(prefix);
  }

  throw new Error(prefix + ': ' + (message || ''));
});

/* harmony default export */ __webpack_exports__["a"] = (index);


/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var canUseDom = function canUseDom() {
  return Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
};

/* harmony default export */ __webpack_exports__["a"] = (canUseDom);

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export flagWidth */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(39);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    from {\n      opacity: 0;\n      transform: translate(', ', 0);\n    }\n    to {\n      opacity: 1;\n      transform: translate(0, 0);\n    }\n'], ['\n    from {\n      opacity: 0;\n      transform: translate(', ', 0);\n    }\n    to {\n      opacity: 1;\n      transform: translate(0, 0);\n    }\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  from {\n    opacity: 1;\n    transform: translate(0, 0);\n  }\n  to {\n    opacity: 0;\n    transform: translate(', ', 0);\n  }\n'], ['\n  from {\n    opacity: 1;\n    transform: translate(0, 0);\n  }\n  to {\n    opacity: 0;\n    transform: translate(', ', 0);\n  }\n']),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  bottom: 0;\n  position: absolute;\n  transition: transform ', ' ease-in-out;\n  width: ', 'px;\n\n  &:first-child {\n    animation: ', ';\n  }\n\n  &:nth-child(n + 2) {\n    transform: translateX(0) translateY(100%) translateY(', 'px);\n  }\n\n  /* Layer the \'primary\' flag above the \'secondary\' flag */\n  &:nth-child(1) {\n    z-index: 5;\n  }\n  &:nth-child(2) {\n    z-index: 4;\n  }\n\n  /* The 2nd flag should be placed at 0,0 position when the 1st flag is animating out. */\n  ', ' &:nth-child(n+4) {\n    display: none;\n  }\n'], ['\n  bottom: 0;\n  position: absolute;\n  transition: transform ', ' ease-in-out;\n  width: ', 'px;\n\n  &:first-child {\n    animation: ', ';\n  }\n\n  &:nth-child(n + 2) {\n    transform: translateX(0) translateY(100%) translateY(', 'px);\n  }\n\n  /* Layer the \'primary\' flag above the \'secondary\' flag */\n  &:nth-child(1) {\n    z-index: 5;\n  }\n  &:nth-child(2) {\n    z-index: 4;\n  }\n\n  /* The 2nd flag should be placed at 0,0 position when the 1st flag is animating out. */\n  ', ' &:nth-child(n+4) {\n    display: none;\n  }\n']);




var flagWidth = Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */])() * 50;

// This is the translateX position that we target when animating a card out
// towards the left of screen.
var exitXPosition = 0 - flagWidth / 2 + 'px';
var flagAnimationDuration = '0.4s';

var animationEnter = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["keyframes"])(_templateObject, exitXPosition);

var animationLeave = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["keyframes"])(_templateObject2, exitXPosition);

var getAnimation = function getAnimation(_ref) {
  var transitionState = _ref.transitionState;

  if (transitionState === 'entering') {
    return animationEnter + ' ' + flagAnimationDuration;
  }

  if (transitionState === 'exiting') {
    return animationLeave + ' ' + flagAnimationDuration;
  }

  return 'initial';
};

var Wrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject3, flagAnimationDuration, flagWidth, getAnimation, 2 * Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */])(), function (_ref2) {
  var transitionState = _ref2.transitionState;
  return transitionState === 'exiting' ? '\n    && + * {\n      transform: translate(0, 0);\n    }\n  ' : null;
});
Wrapper.displayName = 'Wrapper';
/* harmony default export */ __webpack_exports__["a"] = (Wrapper);

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SROnly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Inner; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_transition_group_TransitionGroup__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_transition_group_TransitionGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_transition_group_TransitionGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__ = __webpack_require__(39);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  bottom: ', 'px;\n  left: ', 'px;\n  position: fixed;\n  z-index: ', ';\n'], ['\n  bottom: ', 'px;\n  left: ', 'px;\n  position: fixed;\n  z-index: ', ';\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  border: 0;\n  clip: rect(1px, 1px, 1px, 1px);\n  height: 1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n'], ['\n  border: 0;\n  clip: rect(1px, 1px, 1px, 1px);\n  height: 1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n']),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  position: relative;\n'], ['\n  position: relative;\n']);






/* harmony default export */ __webpack_exports__["c"] = (__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["f" /* math */].multiply(__WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["d" /* gridSize */], 6), __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["f" /* math */].multiply(__WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["d" /* gridSize */], 10), __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["e" /* layers */].flag));

var SROnly = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].h1(_templateObject2);

var Inner = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_2_react_transition_group_TransitionGroup___default.a)(_templateObject3);

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Modal__ = __webpack_require__(482);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Modal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styled_Content__ = __webpack_require__(90);
/* unused harmony reexport ModalBody */
/* unused harmony reexport ModalHeader */
/* unused harmony reexport ModalFooter */
/* unused harmony reexport ModalTitle */



/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ModalDialogWithoutAnalytics */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__atlaskit_analytics_next__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__atlaskit_layer_manager__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__atlaskit_blanket__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__package_json__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_variables__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styled_Modal__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Animation__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Content__ = __webpack_require__(527);




















// NOTE: Rename transition components so it's easier to read the render method
var FillScreen = function FillScreen(props) {
  return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Animation__["a" /* Fade */], __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({ component: __WEBPACK_IMPORTED_MODULE_13__styled_Modal__["b" /* FillScreen */] }, props));
};
// eslint-disable-next-line react/prop-types
var Positioner = function Positioner(_ref) {
  var scrollBehavior = _ref.scrollBehavior,
      props = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['scrollBehavior']);

  var component = scrollBehavior === 'inside' ? __WEBPACK_IMPORTED_MODULE_13__styled_Modal__["c" /* PositionerAbsolute */] : __WEBPACK_IMPORTED_MODULE_13__styled_Modal__["d" /* PositionerRelative */];

  return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Animation__["b" /* SlideUp */], __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({ component: component }, props));
};

function getScrollDistance() {
  return window.pageYOffset || document.documentElement && document.documentElement.scrollTop || document.body && document.body.scrollTop || 0;
}
function getInitialState() {
  return {
    dialogNode: null,
    scrollDistance: getScrollDistance(),
    hasEntered: false,
    isExiting: false
  };
}

var Modal = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Modal, _Component);

  function Modal() {
    var _ref2;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref2 = Modal.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Modal)).call.apply(_ref2, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  } // eslint-disable-line react/sort-comp


  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Modal, [{
    key: 'componentDidMount',


    // getDialogNode = (dialogNode) => {
    //   this.setState(state => !state.dialogNode && ({ dialogNode }));
    // }

    value: function componentDidMount() {
      window.addEventListener('scroll', this.handleWindowScroll);
    }

    /* Prevent window from being scrolled programatically so that the modal is positioned correctly
     * and to prevent scrollIntoView from scrolling the window.
     */

  }, {
    key: 'render',
    value: function render() {
      // NOTE: `in` is NOT public API, thus not documented (provided by react-transition-group)
      var _props = this.props,
          actions = _props.actions,
          appearance = _props.appearance,
          autoFocus = _props.autoFocus,
          body = _props.body,
          children = _props.children,
          footer = _props.footer,
          header = _props.header,
          height = _props.height,
          transitionIn = _props.in,
          isChromeless = _props.isChromeless,
          isHeadingMultiline = _props.isHeadingMultiline,
          onClose = _props.onClose,
          onCloseComplete = _props.onCloseComplete,
          onStackChange = _props.onStackChange,
          shouldCloseOnEscapePress = _props.shouldCloseOnEscapePress,
          stackIndex = _props.stackIndex,
          heading = _props.heading,
          width = _props.width,
          scrollBehavior = _props.scrollBehavior;
      var _state = this.state,
          isExiting = _state.isExiting,
          scrollDistance = _state.scrollDistance;


      var isBackground = stackIndex != null && stackIndex > 0;
      var transitionProps = { in: transitionIn, stackIndex: stackIndex };

      // If a custom width (number or percentage) is supplied, set inline style
      // otherwise allow styled component to consume as named prop
      var widthName = __WEBPACK_IMPORTED_MODULE_12__shared_variables__["a" /* WIDTH_ENUM */].values.includes(width) ? width : null;
      var widthValue = widthName ? null : width;

      // Pass an afterEnded custom transition to Positioner so we can update styles to remove the transform property
      // This fixes an issue with react-beautiful-dnd within modals - AK-4328
      var customTransition = this.state.hasEntered && !this.state.isExiting && !isBackground ? 'afterEntered' : '';

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        FillScreen,
        __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, transitionProps, {
          'aria-hidden': isBackground,
          onExit: this.handleExit,
          scrollDistance: scrollDistance
        }),
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__atlaskit_layer_manager__["a" /* FocusLock */],
          {
            enabled: stackIndex === 0 && !isExiting,
            autoFocus: autoFocus
          },
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__atlaskit_blanket__["a" /* default */], { isTinted: true, onBlanketClicked: this.handleOverlayClick }),
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            Positioner,
            __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, transitionProps, {
              customTransition: customTransition,
              onClick: this.handleOverlayClick,
              onEntered: this.handleEntered,
              onExited: onCloseComplete,
              scrollBehavior: scrollBehavior,
              widthName: widthName,
              widthValue: widthValue
            }),
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_13__styled_Modal__["a" /* Dialog */],
              {
                heightValue: height,
                isChromeless: isChromeless,
                onClick: this.handleDialogClick,
                role: 'dialog',
                tabIndex: '-1'
              },
              __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_15__Content__["a" /* default */],
                {
                  actions: actions,
                  appearance: appearance,
                  footer: footer,
                  heading: heading,
                  isHeadingMultiline: isHeadingMultiline,
                  header: header,
                  onClose: onClose,
                  shouldScroll: scrollBehavior === 'inside',
                  shouldCloseOnEscapePress: shouldCloseOnEscapePress,
                  onStackChange: onStackChange,
                  isChromeless: isChromeless,
                  stackIndex: stackIndex,
                  body: body
                },
                children
              )
            )
          )
        )
      );
    }
  }]);

  return Modal;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

Modal.defaultProps = {
  autoFocus: true,
  scrollBehavior: 'inside',
  shouldCloseOnEscapePress: true,
  shouldCloseOnOverlayClick: true,
  isChromeless: false,
  stackIndex: 0,
  width: 'medium',
  isHeadingMultiline: true
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.state = getInitialState();

  this.handleWindowScroll = function () {
    if (getScrollDistance() !== _this2.state.scrollDistance) {
      window.scrollTo(window.pageXOffset, _this2.state.scrollDistance);
    }
  };

  this.handleOverlayClick = function (e) {
    if (_this2.props.shouldCloseOnOverlayClick) {
      // $FlowFixMe - Event is incompatible with Synthetic event
      _this2.props.onClose(e);
    }
  };

  this.handleDialogClick = function (event) {
    event.stopPropagation();
  };

  this.handleEntered = function () {
    _this2.setState({
      hasEntered: true
    });
    if (_this2.props.onOpenComplete) {
      var _props2;

      (_props2 = _this2.props).onOpenComplete.apply(_props2, arguments);
    }
  };

  this.handleExit = function () {
    window.removeEventListener('scroll', _this2.handleWindowScroll);
    // disable FocusLock *before* unmount. animation may end after a new modal
    // has gained focus, breaking focus behaviour.
    _this2.setState({ isExiting: true });
  };
};

var ModalDialogWithoutAnalytics = Object(__WEBPACK_IMPORTED_MODULE_9__atlaskit_layer_manager__["b" /* withRenderTarget */])({
  target: 'modal',
  withTransitionGroup: true
}, Modal);

var createAndFireEventOnAtlaskit = Object(__WEBPACK_IMPORTED_MODULE_8__atlaskit_analytics_next__["b" /* createAndFireEvent */])('atlaskit');

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__atlaskit_analytics_next__["c" /* withAnalyticsContext */])({
  componentName: 'modalDialog',
  packageName: __WEBPACK_IMPORTED_MODULE_11__package_json__["name"],
  packageVersion: __WEBPACK_IMPORTED_MODULE_11__package_json__["version"]
})(Object(__WEBPACK_IMPORTED_MODULE_8__atlaskit_analytics_next__["d" /* withAnalyticsEvents */])({
  onClose: createAndFireEventOnAtlaskit({
    action: 'closed',
    actionSubject: 'modalDialog',

    attributes: {
      componentName: 'modalDialog',
      packageName: __WEBPACK_IMPORTED_MODULE_11__package_json__["name"],
      packageVersion: __WEBPACK_IMPORTED_MODULE_11__package_json__["version"]
    }
  })
})(ModalDialogWithoutAnalytics)));

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_LayerManager__ = __webpack_require__(484);
/* unused harmony reexport default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_withContextFromProps__ = __webpack_require__(145);
/* unused harmony reexport withContextFromProps */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_withRenderTarget__ = __webpack_require__(488);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__components_withRenderTarget__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FocusLock__ = __webpack_require__(489);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__components_FocusLock__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Portal__ = __webpack_require__(229);
/* unused harmony reexport Portal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_gateway__ = __webpack_require__(144);
/* unused harmony reexport Gateway */
/* unused harmony reexport GatewayDest */
/* unused harmony reexport GatewayProvider */
/* unused harmony reexport GatewayRegistry */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_scrolllock__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_scrolllock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_scrolllock__);
/* unused harmony reexport ScrollLock */







// DEPRECATED - we used to have a custom ScrollLock component but
// react-scrolllock already exists.


/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_transition_group__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__gateway__ = __webpack_require__(144);







var _templateObject = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  position: relative;\n  z-index: 0;\n'], ['\n  position: relative;\n  z-index: 0;\n']);







// NOTE: lock the app wrapper to a 0 z-index. This allows layer manager to
// render all gateways hierarchically, on top of the app, without needing
// incremental z-indexes.
var AppWrapper = __WEBPACK_IMPORTED_MODULE_8_styled_components__["default"].div(_templateObject);

var LayerManager = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(LayerManager, _Component);

  function LayerManager() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LayerManager);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = LayerManager.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(LayerManager)).call.apply(_ref, [this].concat(args))), _this), _this.state = { ariaHiddenNode: undefined }, _this.getAppRef = function (ref) {
      if (_this.state.ariaHiddenNode) return;

      _this.setState({ ariaHiddenNode: ref });
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(LayerManager, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        ariaHiddenNode: this.state.ariaHiddenNode
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;


      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10__gateway__["c" /* GatewayProvider */],
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          AppWrapper,
          { innerRef: this.getAppRef },
          __WEBPACK_IMPORTED_MODULE_6_react__["Children"].only(children)
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__gateway__["b" /* GatewayDest */], { name: 'modal', component: __WEBPACK_IMPORTED_MODULE_9_react_transition_group__["TransitionGroup"] }),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__gateway__["b" /* GatewayDest */], { name: 'spotlight', component: __WEBPACK_IMPORTED_MODULE_9_react_transition_group__["TransitionGroup"] }),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__gateway__["b" /* GatewayDest */], { name: 'flag' }),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__gateway__["b" /* GatewayDest */], { name: 'tooltip', component: __WEBPACK_IMPORTED_MODULE_9_react_transition_group__["TransitionGroup"] })
      );
    }
  }]);

  return LayerManager;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

LayerManager.childContextTypes = { ariaHiddenNode: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object };
/* unused harmony default export */ var _unused_webpack_default_export = (LayerManager);

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__GatewayRegistry__ = __webpack_require__(83);









var Gateway = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Gateway, _Component);

  function Gateway(props, context) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Gateway);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Gateway.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Gateway)).call(this, props, context));

    _this.id = '';

    _this.gatewayRegistry = context.gatewayRegistry;
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Gateway, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.id = this.gatewayRegistry.register(this.props.into, this.props.children);
      this.renderIntoGatewayNode(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      if (!props.shouldBlockRender) {
        this.gatewayRegistry.clearChild(this.props.into, this.id);
        this.renderIntoGatewayNode(props);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.gatewayRegistry.unregister(this.props.into, this.id);
    }
  }, {
    key: 'renderIntoGatewayNode',
    value: function renderIntoGatewayNode(props) {
      this.gatewayRegistry.addChild(this.props.into, this.id, props.children);
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return Gateway;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Gateway.contextTypes = {
  gatewayRegistry: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_7__GatewayRegistry__["a" /* default */]).isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (Gateway);

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__GatewayRegistry__ = __webpack_require__(83);










var GatewayDest = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(GatewayDest, _Component);

  function GatewayDest(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, GatewayDest);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (GatewayDest.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(GatewayDest)).call(this, props, context));

    _this.state = {
      children: null
    };

    _this.gatewayRegistry = context.gatewayRegistry;
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(GatewayDest, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.gatewayRegistry.addContainer(this.props.name, this);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.gatewayRegistry.removeContainer(this.props.name);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          component = _props.component,
          attrs = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['component']);

      delete attrs.name;

      return Object(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"])(component, attrs, this.state.children);
    }
  }]);

  return GatewayDest;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

GatewayDest.contextTypes = {
  gatewayRegistry: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_8__GatewayRegistry__["a" /* default */]).isRequired
};
GatewayDest.defaultProps = {
  component: 'div'
};
/* harmony default export */ __webpack_exports__["a"] = (GatewayDest);

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__GatewayRegistry__ = __webpack_require__(83);









var GatewayProvider = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(GatewayProvider, _Component);

  function GatewayProvider(props, context) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, GatewayProvider);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (GatewayProvider.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(GatewayProvider)).call(this, props, context));

    _this.gatewayRegistry = new __WEBPACK_IMPORTED_MODULE_7__GatewayRegistry__["a" /* default */]();
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(GatewayProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        gatewayRegistry: this.gatewayRegistry
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          Tag = _props.component;


      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        Tag,
        null,
        children
      );
    }
  }]);

  return GatewayProvider;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

GatewayProvider.childContextTypes = {
  gatewayRegistry: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_7__GatewayRegistry__["a" /* default */]).isRequired
};
GatewayProvider.defaultProps = {
  component: 'div'
};
/* harmony default export */ __webpack_exports__["a"] = (GatewayProvider);

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withRenderTarget;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__gateway__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Portal__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__withContextFromProps__ = __webpack_require__(145);














function withRenderTarget(_ref, WrappedComponent) {
  var _class, _temp2;

  var target = _ref.target,
      withTransitionGroup = _ref.withTransitionGroup;

  // Access the analytics context types so we can provide them across portal boundaries
  // until we can support React 16 where it can be provided natively
  var analyticsContextTypes = {
    // Old analytics keys
    onAnalyticsEvent: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
    getParentAnalyticsData: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
    // New analytics-next keys,
    getAtlaskitAnalyticsContext: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
    getAtlaskitAnalyticsEventHandlers: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func
  };

  // These context types have been copied from jira-frontend to temporarily fix context issues for jira-frontend with other
  // layer-manager rendered components like flag - AK-4281
  var jiraContextTypes = {
    // For react-redux
    store: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
    // For react-intl
    intl: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
    // For common/analytics/analytics-provider
    triggerAnalytics: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
    // For portfolio/common/view-awesome/validation/form/connect-to-form
    internalFormContext: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
    // For board-v2/column/column-create/column-create-form
    validateColumn: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
    // For board-v2/column/column-header/column-header
    createColumnMenu: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
    // For board-v2/column/draggable-column/draggable-column
    getScrollTop: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
    // For board/view/components/done-issues-button/done-issues-button
    configuration: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
    // For board/view/components/drag-handle/drag-handle
    getDraggableOriginCenterPos: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
    // For board/view/components/drag-handle/drag-handle
    getDraggableTranslatedCenterPos: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
    // For common/components/profilecard/profilecard-view
    akProfileClient: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
    // For common/components/profilecard/profilecard-view
    cloudId: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
    // For common/engagement/with-engagement
    subscribeEngagementState: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
    // For navigation/view/navigation-group-item/index
    perfMetricsStart: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
    // For navigation/view/onboarding/components/onboarding-manager
    spotlightRegistry: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
    // For navigation/view/project-header/index
    slideRight: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
    // For portfolio/common/view/components/tree-table/view/details/index
    consumerStore: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
    // For portfolio/page-plan/view-awesome/main/planning/schedule/schedule/lane/bar/index-dumb
    onBarSelected: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func
  };

  var portalledContextTypes = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, analyticsContextTypes, jiraContextTypes);

  var ContextProvider = Object(__WEBPACK_IMPORTED_MODULE_11__withContextFromProps__["a" /* default */])(portalledContextTypes, null);

  // eslint-disable-next-line react/prefer-stateless-function
  return _temp2 = _class = function (_Component) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(_class, _Component);

    function _class() {
      var _ref2;

      var _temp, _this, _ret;

      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, _class);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref2 = _class.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(_class)).call.apply(_ref2, [this].concat(args))), _this), _this.getWrappedComponentRef = function (ref) {
        _this.gatewayOrPortalChildRef = ref;
      }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(_class, [{
      key: 'render',
      value: function render() {
        var _context = this.context,
            gatewayRegistry = _context.gatewayRegistry,
            portalledContext = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_context, ['gatewayRegistry']);

        var GatewayOrPortal = gatewayRegistry ? __WEBPACK_IMPORTED_MODULE_9__gateway__["a" /* Gateway */] : __WEBPACK_IMPORTED_MODULE_10__Portal__["a" /* default */];

        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          GatewayOrPortal,
          {
            id:  false ? 'gateway-or-portal' : '',
            into: target,
            withTransitionGroup: withTransitionGroup,
            shouldBlockRender: this.context.blockChildGatewayRender
          },
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            ContextProvider,
            portalledContext,
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(WrappedComponent, __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({
              ref: this.getWrappedComponentRef
            }, this.props))
          )
        );
      }
    }]);

    return _class;
  }(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]), _class.contextTypes = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({
    gatewayRegistry: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_9__gateway__["d" /* GatewayRegistry */]),
    blockChildGatewayRender: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
  }, analyticsContextTypes, jiraContextTypes), _temp2;
}

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_focus_lock__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_focus_lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_focus_lock__);









/* eslint-disable react/sort-comp */
var FocusLock = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(FocusLock, _Component);

  function FocusLock() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, FocusLock);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = FocusLock.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(FocusLock)).call.apply(_ref, [this].concat(args))), _this), _this.initFromProps = false, _this.teardownFromProps = false, _this.initialise = function () {
      var autoFocus = _this.props.autoFocus;
      // set the element to hide from assistive technology

      _this.ariaHiddenNode = _this.props.ariaHiddenNode || _this.context.ariaHiddenNode;

      // accessible `popup` content
      if (_this.ariaHiddenNode) {
        _this.ariaHiddenNode.setAttribute('aria-hidden', '');
      }
      if (typeof autoFocus === 'function') {
        var elem = autoFocus();
        if (elem && elem.focus) {
          elem.focus();
        }
      }
    }, _this.teardown = function () {
      if (_this.ariaHiddenNode) {
        _this.ariaHiddenNode.removeAttribute('aria-hidden');
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(FocusLock, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          enabled = _props.enabled,
          autoFocus = _props.autoFocus;


      if (typeof autoFocus === 'function') {
        console.warn('@atlaskit/layer-manager: Passing a function as autoFocus in FocusLock is deprecated. Please see "Auto focusing an element" in https://atlaskit.atlassian.com/packages/core/layer-manager');
      }

      if (enabled) {
        this.initialise();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (!this.initFromProps && !this.teardownFromProps) {
        this.teardown();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.enabled && this.props.enabled !== prevProps.enabled) {
        this.initFromProps = true;
        this.initialise();
      }

      if (!this.props.enabled && this.props.enabled !== prevProps.enabled) {
        this.teardownFromProps = true;
        this.teardown();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          enabled = _props2.enabled,
          autoFocus = _props2.autoFocus,
          returnFocus = _props2.returnFocus;

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_focus_lock___default.a,
        {
          disabled: !enabled,
          autoFocus: !!autoFocus,
          returnFocus: returnFocus
        },
        this.props.children
      );
    }
  }]);

  return FocusLock;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

FocusLock.contextTypes = {
  /** available when invoked within @atlaskit/layer-manager */
  ariaHiddenNode: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
};
FocusLock.defaultProps = {
  autoFocus: true,
  enabled: true,
  returnFocus: true
};
/* harmony default export */ __webpack_exports__["a"] = (FocusLock);

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MoveFocusInside = exports.AutoFocusInside = undefined;

var _Lock = __webpack_require__(491);

var _Lock2 = _interopRequireDefault(_Lock);

var _AutoFocusInside = __webpack_require__(502);

var _AutoFocusInside2 = _interopRequireDefault(_AutoFocusInside);

var _MoveFocusInside = __webpack_require__(503);

var _MoveFocusInside2 = _interopRequireDefault(_MoveFocusInside);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.AutoFocusInside = _AutoFocusInside2.default;
exports.MoveFocusInside = _MoveFocusInside2.default;
exports.default = _Lock2.default;

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _focusLock = __webpack_require__(146);

var _Trap = __webpack_require__(497);

var _Trap2 = _interopRequireDefault(_Trap);

var _util = __webpack_require__(234);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RenderChildren = function RenderChildren(_ref) {
  var children = _ref.children;
  return _react2.default.createElement(
    'div',
    null,
    children
  );
};
RenderChildren.propTypes = {
  children: _propTypes2.default.node.isRequired
};
var Fragment = _react2.default.Fragment ? _react2.default.Fragment : RenderChildren;

var hidden = {
  width: '1px',
  height: '0px',
  padding: 0,
  overflow: 'hidden',
  position: 'fixed',
  top: 0,
  left: 0
};

var FocusLock = function (_Component) {
  _inherits(FocusLock, _Component);

  function FocusLock() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, FocusLock);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = FocusLock.__proto__ || Object.getPrototypeOf(FocusLock)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      observed: undefined
    }, _this.onActivation = function () {
      _this.originalFocusedElement = _this.originalFocusedElement || document.activeElement;
    }, _this.setObserveNode = function (observed) {
      return _this.setState({
        observed: observed
      });
    }, _this.update = function () {
      return _this.setState(function (prevState) {
        return {
          escapeAttempts: prevState.escapeAttempts + 1
        };
      });
    }, _this.originalFocusedElement = null, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FocusLock, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.disabled && !this.props.disabled) {
        this.originalFocusedElement = null;
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _this2 = this;

      if (this.props.returnFocus && this.originalFocusedElement && this.originalFocusedElement.focus) {
        (0, _util.deferAction)(function () {
          return _this2.originalFocusedElement.focus();
        }, 0);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _lockProps;

      var _props = this.props,
          children = _props.children,
          disabled = _props.disabled,
          noFocusGuards = _props.noFocusGuards,
          persistentFocus = _props.persistentFocus,
          autoFocus = _props.autoFocus,
          allowTextSelection = _props.allowTextSelection,
          group = _props.group;
      var observed = this.state.observed;


      if (typeof allowTextSelection !== 'undefined') {
        // eslint-disable-next-line no-console
        console.warn('React-Focus-Lock: allowTextSelection is deprecated and enabled by default');
      }

      var lockProps = (_lockProps = {}, _defineProperty(_lockProps, _focusLock.constants.FOCUS_DISABLED, disabled && 'disabled'), _defineProperty(_lockProps, _focusLock.constants.FOCUS_GROUP, group), _lockProps);

      return _react2.default.createElement(
        Fragment,
        null,
        !noFocusGuards && [_react2.default.createElement('div', { key: 'guard-first', tabIndex: disabled ? -1 : 0, style: hidden }), // nearest focus guard
        _react2.default.createElement('div', { key: 'guard-nearest', tabIndex: disabled ? -1 : 1, style: hidden })],
        _react2.default.createElement(
          'div',
          _extends({
            ref: this.setObserveNode
          }, lockProps),
          _react2.default.createElement(
            _Trap2.default,
            {
              observed: observed,
              disabled: disabled,
              persistentFocus: persistentFocus,
              autoFocus: autoFocus,
              onActivation: this.onActivation
            },
            children
          )
        ),
        !noFocusGuards && _react2.default.createElement('div', { tabIndex: disabled ? -1 : 0, style: hidden })
      );
    }
  }]);

  return FocusLock;
}(_react.Component);

FocusLock.propTypes = {
  children: _propTypes2.default.node.isRequired,
  disabled: _propTypes2.default.bool,
  returnFocus: _propTypes2.default.bool,
  noFocusGuards: _propTypes2.default.bool,

  allowTextSelection: _propTypes2.default.bool,
  autoFocus: _propTypes2.default.bool,
  persistentFocus: _propTypes2.default.bool,

  group: _propTypes2.default.string
};

FocusLock.defaultProps = {
  disabled: false,
  returnFocus: false,
  noFocusGuards: false,
  autoFocus: true,
  persistentFocus: false,
  allowTextSelection: undefined,
  group: undefined
};

exports.default = FocusLock;

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _setFocus = __webpack_require__(230);

var _focusMerge = __webpack_require__(147);

var target = void 0;

var handleTab = function handleTab(e) {
  if (!(e.key === 'Tab' || e.keyCode === 9) || !target.enabled) {
    return;
  }
  e.preventDefault();
  var tabbableNodes = (0, _focusMerge.getTabbableNodes)(target.node).map(function (_ref) {
    var node = _ref.node;
    return node;
  });
  var cnt = tabbableNodes.length;
  var currentFocusIndex = tabbableNodes.indexOf(e.target);
  var nextNode = (cnt + currentFocusIndex + (e.shiftKey ? -1 : +1)) % cnt;

  (0, _setFocus.focusOn)(tabbableNodes[nextNode]);
};

var _attach = function _attach() {
  return document.addEventListener('keydown', handleTab, true);
};
var _detach = function _detach() {
  return document.removeEventListener('keydown', handleTab, true);
};

exports.default = {
  attach: function attach(node, enabled) {
    if (enabled) {
      if (!target) {
        _attach();
      }
      target = {
        node: node, enabled: enabled
      };
    } else {
      this.detach();
    }
  },
  detach: function detach() {
    if (target) {
      _detach();
      target = null;
    }
  }
};

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parentAutofocusables = exports.getTabbableNodes = exports.getCommonParent = exports.notHiddenInput = exports.isVisible = undefined;

var _tabOrder = __webpack_require__(231);

var _tabUtils = __webpack_require__(232);

var _array = __webpack_require__(58);

var isElementHidden = function isElementHidden(computedStyle) {
  if (!computedStyle || !computedStyle.getPropertyValue) {
    return false;
  }
  return computedStyle.getPropertyValue('display') === 'none' || computedStyle.getPropertyValue('visibility') === 'hidden';
};

var isVisible = exports.isVisible = function isVisible(node) {
  return !node || node === document || !isElementHidden(window.getComputedStyle(node, null)) && isVisible(node.parentNode);
};

var notHiddenInput = exports.notHiddenInput = function notHiddenInput(node) {
  return node.tagName !== 'INPUT' || node.type !== 'hidden';
};

var getParents = function getParents(node) {
  var parents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  parents.push(node);
  if (node.parentNode) {
    getParents(node.parentNode, parents);
  }
  return parents;
};

var getCommonParent = exports.getCommonParent = function getCommonParent(nodea, nodeb) {
  var parentsA = getParents(nodea);
  var parentsB = getParents(nodeb);

  for (var i = 0; i < parentsA.length; i += 1) {
    var currentParent = parentsA[i];
    if (parentsB.indexOf(currentParent) >= 0) {
      return currentParent;
    }
  }
  return false;
};

var findFocusable = function findFocusable(nodes) {
  return (0, _array.toArray)(nodes).filter(function (node) {
    return isVisible(node);
  }).filter(function (node) {
    return notHiddenInput(node);
  });
};

var getTabbableNodes = exports.getTabbableNodes = function getTabbableNodes(topNodes) {
  return (0, _tabOrder.orderByTabIndex)(findFocusable((0, _tabUtils.getFocusables)(topNodes)));
};

var parentAutofocusables = exports.parentAutofocusables = function parentAutofocusables(topNode) {
  return findFocusable((0, _tabUtils.getParentAutofocusables)(topNode));
};

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ['button:enabled:not([readonly])', 'select:enabled:not([readonly])', 'textarea:enabled:not([readonly])', 'input:enabled:not([readonly])', 'a[href]', 'area[href]', 'iframe', 'object', 'embed', '[tabindex]', '[contenteditable]', '[autofocus]'];

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var isRadio = function isRadio(node) {
  return node.tagName === 'INPUT' && node.type === 'radio';
};

var findSelectedRadio = function findSelectedRadio(node, nodes) {
  return nodes.filter(isRadio).filter(function (el) {
    return el.name === node.name;
  }).filter(function (el) {
    return el.checked;
  })[0] || node;
};

var pickFirstFocus = function pickFirstFocus(nodes) {
  if (nodes[0] && nodes.length > 1) {
    if (isRadio(nodes[0]) && nodes[0].name) {
      return findSelectedRadio(nodes[0], nodes);
    }
  }
  return nodes[0];
};

exports.default = pickFirstFocus;

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _allAffected = __webpack_require__(148);

var _allAffected2 = _interopRequireDefault(_allAffected);

var _array = __webpack_require__(58);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusInFrame = function focusInFrame(frame) {
  return frame === document.activeElement;
};

var focusInsideIframe = function focusInsideIframe(topNode) {
  return (0, _allAffected2.default)(topNode).reduce(function (result, node) {
    return result || !!(0, _array.arrayFind)((0, _array.toArray)(node.querySelectorAll('iframe')), focusInFrame);
  }, false);
};

var focusInside = function focusInside(topNode) {
  return (0, _allAffected2.default)(topNode).reduce(function (result, node) {
    return result || node.querySelector('*:focus') || focusInsideIframe(topNode);
  }, false);
};

exports.default = focusInside;

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactClientsideEffect = __webpack_require__(498);

var _reactClientsideEffect2 = _interopRequireDefault(_reactClientsideEffect);

var _focusLock = __webpack_require__(146);

var _focusLock2 = _interopRequireDefault(_focusLock);

var _util = __webpack_require__(234);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusOnBody = function focusOnBody() {
  return document && document.activeElement === document.body;
};

var lastActiveTrap = 0;
var lastActiveFocus = null;

var lastPortaledElement = null;

var recordPortal = function recordPortal(observerNode, portaledElement) {
  lastPortaledElement = { observerNode: observerNode, portaledElement: portaledElement };
};

var focusIsPortaledPair = function focusIsPortaledPair(element) {
  return lastPortaledElement && lastPortaledElement.portaledElement === element;
};

var activateTrap = function activateTrap() {
  var result = false;
  if (lastActiveTrap) {
    var _lastActiveTrap = lastActiveTrap,
        observed = _lastActiveTrap.observed,
        onActivation = _lastActiveTrap.onActivation,
        persistentFocus = _lastActiveTrap.persistentFocus,
        autoFocus = _lastActiveTrap.autoFocus;

    var workingNode = observed || lastPortaledElement && lastPortaledElement.portaledElement;
    var activeElement = document && document.activeElement;

    if (persistentFocus || !focusOnBody() || !lastActiveFocus && autoFocus) {
      if (workingNode && !((0, _focusLock.focusInside)(workingNode) || focusIsPortaledPair(activeElement, workingNode) || workingNode.contains && workingNode.contains(activeElement))) {
        onActivation();
        if (document && !lastActiveFocus && activeElement && !autoFocus) {
          activeElement.blur();
          document.body.focus();
        } else {
          result = (0, _focusLock2.default)(workingNode, lastActiveFocus);
          lastPortaledElement = {};
        }
      }
      lastActiveFocus = document && document.activeElement;
    }
  }
  return result;
};

var onTrap = function onTrap(event) {
  if (activateTrap() && event) {
    // prevent scroll jump
    event.stopPropagation();
    event.preventDefault();
  }
};

var onBlur = function onBlur() {
  return (0, _util.deferAction)(activateTrap);
};

var onFocus = function onFocus(event) {
  // detect portal
  var source = event.target;
  var currentNode = event.currentTarget;
  if (!currentNode.contains(source)) {
    recordPortal(currentNode, source);
  }
};

var FocusTrap = function FocusTrap(_ref) {
  var children = _ref.children;
  return _react2.default.createElement(
    'div',
    { onBlur: onBlur, onFocus: onFocus },
    children
  );
};

FocusTrap.propTypes = {
  children: _propTypes2.default.node.isRequired
};

var attachHandler = function attachHandler() {
  document.addEventListener('focusin', onTrap, true);
  document.addEventListener('focusout', onBlur);
};

var detachHandler = function detachHandler() {
  document.removeEventListener('focusin', onTrap, true);
  document.removeEventListener('focusout', onBlur);
};

function reducePropsToState(propsList) {
  return propsList.filter(function (_ref2) {
    var disabled = _ref2.disabled;
    return !disabled;
  }).slice(-1)[0];
}

function handleStateChangeOnClient(trap) {
  if (trap && !lastActiveTrap) {
    attachHandler();
  }

  lastActiveTrap = trap;
  if (trap) {
    lastActiveFocus = null;
    activateTrap(true);
    (0, _util.deferAction)(activateTrap);
  } else {
    detachHandler();
    lastActiveFocus = null;
  }
}

exports.default = (0, _reactClientsideEffect2.default)(reducePropsToState, handleStateChangeOnClient)(FocusTrap);

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(0);
var React__default = _interopDefault(React);
var shallowEqual = _interopDefault(__webpack_require__(499));

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function withSideEffect(reducePropsToState, handleStateChangeOnClient) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }
  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state = void 0;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      handleStateChangeOnClient(state);
    }

    var SideEffect = function (_Component) {
      _inherits(SideEffect, _Component);

      function SideEffect() {
        _classCallCheck(this, SideEffect);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      SideEffect.peek = function peek() {
        return state;
      };
      // Try to use displayName of wrapped component


      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return !shallowEqual(nextProps, this.props);
      };

      SideEffect.prototype.componentDidMount = function componentDidMount() {
        mountedInstances.push(this);
        emitChange();
      };

      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      SideEffect.prototype.render = function render() {
        return React__default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(React.Component);

    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';


    return SideEffect;
  };
}

module.exports = withSideEffect;


/***/ }),
/* 499 */
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(501);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(72)))

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(72), __webpack_require__(215)))

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AutoFocusInside = function AutoFocusInside(_ref) {
  var disabled = _ref.disabled,
      children = _ref.children;
  return _react2.default.createElement(
    'div',
    { 'data-autofocus-inside': !disabled },
    children
  );
};

AutoFocusInside.propTypes = {
  children: _propTypes2.default.node.isRequired,
  disabled: _propTypes2.default.bool
};

AutoFocusInside.defaultProps = {
  disabled: false
};

exports.default = AutoFocusInside;

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _focusLock = __webpack_require__(146);

var _focusLock2 = _interopRequireDefault(_focusLock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MoveFocusInside = function (_Component) {
  _inherits(MoveFocusInside, _Component);

  function MoveFocusInside() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MoveFocusInside);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MoveFocusInside.__proto__ || Object.getPrototypeOf(MoveFocusInside)).call.apply(_ref, [this].concat(args))), _this), _this.setObserveNode = function (ref) {
      _this.observed = ref;
      _this.moveFocus();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MoveFocusInside, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.moveFocus();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.disabled && !this.props.disabled) {
        this.moveFocus();
      }
    }
  }, {
    key: 'moveFocus',
    value: function moveFocus() {
      var observed = this.observed;
      if (!this.props.disabled && observed) {
        if (!(0, _focusLock.focusInside)(observed)) {
          (0, _focusLock2.default)(observed, null);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          disabled = _props.disabled;

      return _react2.default.createElement(
        'div',
        { 'data-autofocus-inside': !disabled, ref: this.setObserveNode },
        children
      );
    }
  }]);

  return MoveFocusInside;
}(_react.Component);

MoveFocusInside.propTypes = {
  children: _propTypes2.default.node.isRequired,
  disabled: _propTypes2.default.bool
};
MoveFocusInside.defaultProps = {
  disabled: false
};
exports.default = MoveFocusInside;

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _exenv = __webpack_require__(85);

var _utils = __webpack_require__(149);

var _withTouchListeners = __webpack_require__(505);

var _withTouchListeners2 = _interopRequireDefault(_withTouchListeners);

var _StyleSheet = __webpack_require__(506);

var _StyleSheet2 = _interopRequireDefault(_StyleSheet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ScrollLock = function (_PureComponent) {
  _inherits(ScrollLock, _PureComponent);

  function ScrollLock() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ScrollLock);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ScrollLock.__proto__ || Object.getPrototypeOf(ScrollLock)).call.apply(_ref, [this].concat(args))), _this), _this.getStyles = function () {
      var accountForScrollbars = _this.props.accountForScrollbars;


      var height = (0, _utils.getDocumentHeight)();
      var paddingRight = accountForScrollbars ? (0, _utils.getPadding)() : null;
      var styles = 'body {\n      box-sizing: border-box !important;\n      overflow: hidden !important;\n      position: relative !important;\n      ' + (height ? 'height: ' + height + 'px !important;' : '') + '\n      ' + (paddingRight ? 'padding-right: ' + paddingRight + 'px !important;' : '') + '\n    }';

      return styles;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ScrollLock, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!_exenv.canUseDOM) return;
      this.initialHeight = window.innerHeight;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var offset = window.innerHeight - this.initialHeight;

      // adjust scroll if the window has been resized since the lock was engaged
      // e.g. mobile safari dynamic chrome heights
      if (offset) {
        window.scrollTo(0, window.pageYOffset + offset);
      }

      // reset the initial height in case this scroll lock is used again
      this.initialHeight = window.innerHeight;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_StyleSheet2.default, { styles: this.getStyles() });
    }
  }]);

  return ScrollLock;
}(_react.PureComponent);

ScrollLock.defaultProps = {
  accountForScrollbars: true
};
exports.default = (0, _withTouchListeners2.default)(ScrollLock);

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = withTouchListeners;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _exenv = __webpack_require__(85);

var _utils = __webpack_require__(149);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function withTouchListeners(WrappedComponent) {
  return function (_PureComponent) {
    _inherits(TouchProvider, _PureComponent);

    function TouchProvider() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, TouchProvider);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TouchProvider.__proto__ || Object.getPrototypeOf(TouchProvider)).call.apply(_ref, [this].concat(args))), _this), _this.listenerOptions = {
        capture: false,
        passive: false
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(TouchProvider, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (!_exenv.canUseDOM) return;

        var touchScrollTarget = this.props.touchScrollTarget;

        var target = document.body;

        // account for touch devices
        if (target && (0, _utils.isTouchDevice)()) {
          // Mobile Safari ignores { overflow: hidden } declaration on the body.
          target.addEventListener('touchmove', _utils.preventTouchMove, this.listenerOptions);

          // Allow scroll on provided target
          if (touchScrollTarget) {
            touchScrollTarget.addEventListener('touchstart', _utils.preventInertiaScroll, this.listenerOptions);
            touchScrollTarget.addEventListener('touchmove', _utils.allowTouchMove, this.listenerOptions);
          }
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (!_exenv.canUseDOM) return;

        var touchScrollTarget = this.props.touchScrollTarget;

        var target = document.body;

        // remove touch listeners
        if (target && (0, _utils.isTouchDevice)()) {
          target.removeEventListener('touchmove', _utils.preventTouchMove, this.listenerOptions);

          if (touchScrollTarget) {
            touchScrollTarget.removeEventListener('touchstart', _utils.preventInertiaScroll, this.listenerOptions);
            touchScrollTarget.removeEventListener('touchmove', _utils.allowTouchMove, this.listenerOptions);
          }
        }
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(WrappedComponent, this.props);
      }
    }]);

    return TouchProvider;
  }(_react.PureComponent);
}

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _exenv = __webpack_require__(85);

var _utils = __webpack_require__(149);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Sheet = function (_PureComponent) {
  _inherits(Sheet, _PureComponent);

  function Sheet() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Sheet);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Sheet.__proto__ || Object.getPrototypeOf(Sheet)).call.apply(_ref, [this].concat(args))), _this), _this.addSheet = function () {
      var styles = _this.props.styles;


      var sheet = (0, _utils.makeStyleTag)();
      if (!sheet) return;

      (0, _utils.injectStyles)(sheet, styles);
      (0, _utils.insertStyleTag)(sheet);

      _this.sheet = sheet;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Sheet, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!_exenv.canUseDOM) return;
      this.addSheet();
    }
  }, {
    key: 'removeSheet',
    value: function removeSheet() {
      if (!this.sheet) return;

      // $FlowFixMe
      this.sheet.parentNode.removeChild(this.sheet);
      this.sheet = null;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeSheet();
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return Sheet;
}(_react.PureComponent);

exports.default = Sheet;

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BlanketWithoutAnalytics */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_analytics_next__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__package_json__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styled__ = __webpack_require__(509);










var Blanket = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Blanket, _PureComponent);

  function Blanket() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Blanket);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Blanket.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Blanket)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Blanket, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          canClickThrough = _props.canClickThrough,
          isTinted = _props.isTinted,
          onBlanketClicked = _props.onBlanketClicked;

      var onClick = canClickThrough ? null : onBlanketClicked;
      var containerProps = { canClickThrough: canClickThrough, isTinted: isTinted, onClick: onClick };

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styled__["a" /* default */], containerProps);
    }
  }]);

  return Blanket;
}(__WEBPACK_IMPORTED_MODULE_5_react__["PureComponent"]);

Blanket.defaultProps = {
  canClickThrough: false,
  isTinted: false,
  onBlanketClicked: function onBlanketClicked() {}
};



var createAndFireEventOnAtlaskit = Object(__WEBPACK_IMPORTED_MODULE_6__atlaskit_analytics_next__["b" /* createAndFireEvent */])('atlaskit');

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__atlaskit_analytics_next__["c" /* withAnalyticsContext */])({
  componentName: 'blanket',
  packageName: __WEBPACK_IMPORTED_MODULE_7__package_json__["name"],
  packageVersion: __WEBPACK_IMPORTED_MODULE_7__package_json__["version"]
})(Object(__WEBPACK_IMPORTED_MODULE_6__atlaskit_analytics_next__["d" /* withAnalyticsEvents */])({
  onBlanketClicked: createAndFireEventOnAtlaskit({
    action: 'clicked',
    actionSubject: 'blanket',

    attributes: {
      componentName: 'blanket',
      packageName: __WEBPACK_IMPORTED_MODULE_7__package_json__["name"],
      packageVersion: __WEBPACK_IMPORTED_MODULE_7__package_json__["version"]
    }
  })
})(Blanket)));

/***/ }),
/* 508 */
/***/ (function(module, exports) {

module.exports = {"name":"@atlaskit/blanket","version":"7.0.5"}

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export opacity */
/* unused harmony export pointerEvents */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(236);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  background: ', ';\n  bottom: 0;\n  left: 0;\n  opacity: ', ';\n  pointer-events: ', ';\n  position: fixed;\n  right: 0;\n  top: 0;\n  transition: opacity 220ms;\n  z-index: ', ';\n'], ['\n  background: ', ';\n  bottom: 0;\n  left: 0;\n  opacity: ', ';\n  pointer-events: ', ';\n  position: fixed;\n  right: 0;\n  top: 0;\n  transition: opacity 220ms;\n  z-index: ', ';\n']);




var backgroundColor = Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["e" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].N100A, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].DN90A });
var opacity = function opacity(p) {
  return p.isTinted ? 1 : 0;
};
var pointerEvents = function pointerEvents(p) {
  return p.canClickThrough ? 'none' : 'initial';
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, backgroundColor, opacity, pointerEvents, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* layers */].blanket));

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export e100 */
/* unused harmony export e200 */
/* unused harmony export e300 */
/* unused harmony export e400 */
/* unused harmony export e500 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_themed__ = __webpack_require__(150);



// Cards on a board
var e100 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 1px 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px 0 ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 1px 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

// Inline dialogs
var e200 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 4px 8px -2px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 4px 8px -2px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

// Modals
var e300 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 8px 16px -4px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 8px 16px -4px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

// Panels
var e400 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 12px 24px -6px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 12px 24px -6px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

// Flag messages (notifications)
var e500 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 20px 32px -8px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 20px 32px -8px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export h900 */
/* unused harmony export h800 */
/* unused harmony export h700 */
/* unused harmony export h600 */
/* unused harmony export h500 */
/* unused harmony export h400 */
/* unused harmony export h300 */
/* unused harmony export h200 */
/* unused harmony export h100 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__colors__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index__ = __webpack_require__(236);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 500;\n  letter-spacing: -0.01em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 500;\n  letter-spacing: -0.01em;\n  margin-top: ', 'px;\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  margin-top: ', 'px;\n']),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 500;\n  letter-spacing: -0.008em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 500;\n  letter-spacing: -0.008em;\n  margin-top: ', 'px;\n']),
    _templateObject4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.006em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.006em;\n  margin-top: ', 'px;\n']),
    _templateObject5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.003em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.003em;\n  margin-top: ', 'px;\n']),
    _templateObject6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  margin-top: ', 'px;\n  text-transform: uppercase;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  margin-top: ', 'px;\n  text-transform: uppercase;\n']),
    _templateObject7 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  margin-top: ', 'px;\n']),
    _templateObject8 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: normal;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: normal;\n  margin-top: ', 'px;\n']);






var baseHeading = function baseHeading(size, lineHeight) {
  return '\n  font-size: ' + size / Object(__WEBPACK_IMPORTED_MODULE_3__index__["b" /* fontSize */])() + 'em;\n  font-style: inherit;\n  line-height: ' + lineHeight / size + ';\n';
};

var h900 = function h900() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject, baseHeading(35, 40), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["c" /* gridSize */])() * 6.5);
};

var h800 = function h800() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject2, baseHeading(29, 32), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["c" /* gridSize */])() * 5);
};

var h700 = function h700() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject, baseHeading(24, 28), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["c" /* gridSize */])() * 5);
};

var h600 = function h600() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject3, baseHeading(20, 24), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["c" /* gridSize */])() * 3.5);
};

var h500 = function h500() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject4, baseHeading(16, 20), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["c" /* gridSize */])() * 3);
};

var h400 = function h400() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject5, baseHeading(14, 16), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["c" /* gridSize */])() * 2);
};

var h300 = function h300() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject6, baseHeading(12, 16), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["c" /* gridSize */])() * 2.5);
};

var h200 = function h200() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject7, baseHeading(12, 16), __WEBPACK_IMPORTED_MODULE_2__colors__["subtleHeading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["c" /* gridSize */])() * 2);
};

var h100 = function h100() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject8, baseHeading(12, 16), __WEBPACK_IMPORTED_MODULE_2__colors__["subtleHeading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["c" /* gridSize */])() * 2);
};

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export add */
/* unused harmony export subtract */
/* unused harmony export multiply */
/* unused harmony export divide */
function add(fn, addend) {
  return function (props) {
    return fn(props) + addend;
  };
}

function subtract(fn, subtrahend) {
  return function (props) {
    return fn(props) - subtrahend;
  };
}

function multiply(fn, factor) {
  return function (props) {
    return fn(props) * factor;
  };
}

function divide(fn, divisor) {
  return function (props) {
    return fn(props) / divisor;
  };
}

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__colors__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Context__ = __webpack_require__(86);








var _templateObject = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  background-color: ', ';\n  color: ', ';\n\n  a {\n    color: ', ';\n  }\n  a:hover {\n    color: ', ';\n  }\n  a:active {\n    color: ', ';\n  }\n  a:focus {\n    outline-color: ', ';\n  }\n  h1 {\n    color: ', ';\n  }\n  h2 {\n    color: ', ';\n  }\n  h3 {\n    color: ', ';\n  }\n  h4 {\n    color: ', ';\n  }\n  h5 {\n    color: ', ';\n  }\n  h6 {\n    color: ', ';\n  }\n  small {\n    color: ', ';\n  }\n'], ['\n  background-color: ', ';\n  color: ', ';\n\n  a {\n    color: ', ';\n  }\n  a:hover {\n    color: ', ';\n  }\n  a:active {\n    color: ', ';\n  }\n  a:focus {\n    outline-color: ', ';\n  }\n  h1 {\n    color: ', ';\n  }\n  h2 {\n    color: ', ';\n  }\n  h3 {\n    color: ', ';\n  }\n  h4 {\n    color: ', ';\n  }\n  h5 {\n    color: ', ';\n  }\n  h6 {\n    color: ', ';\n  }\n  small {\n    color: ', ';\n  }\n']);









// For forward-compat until everything is upgraded.


function getStylesheetResetCSS(state) {
  var backgroundColor = __WEBPACK_IMPORTED_MODULE_10__colors__["background"](state);
  return '\n    body { background: ' + backgroundColor + '; }\n  ';
}

function buildThemeState(mode) {
  return { theme: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_11__constants__["a" /* CHANNEL */], { mode: mode }) };
}

var LegacyReset = __WEBPACK_IMPORTED_MODULE_9_styled_components__["default"].div(_templateObject, __WEBPACK_IMPORTED_MODULE_10__colors__["background"], __WEBPACK_IMPORTED_MODULE_10__colors__["text"], __WEBPACK_IMPORTED_MODULE_10__colors__["link"], __WEBPACK_IMPORTED_MODULE_10__colors__["linkHover"], __WEBPACK_IMPORTED_MODULE_10__colors__["linkActive"], __WEBPACK_IMPORTED_MODULE_10__colors__["linkOutline"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["subtleHeading"], __WEBPACK_IMPORTED_MODULE_10__colors__["subtleText"]);

var AtlaskitThemeProvider = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(AtlaskitThemeProvider, _Component);

  function AtlaskitThemeProvider(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AtlaskitThemeProvider);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AtlaskitThemeProvider.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(AtlaskitThemeProvider)).call(this, props));

    _this.state = buildThemeState(props.mode);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(AtlaskitThemeProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return { hasAtlaskitThemeProvider: true };
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (!this.context.hasAtlaskitThemeProvider) {
        var css = getStylesheetResetCSS(this.state);
        this.stylesheet = document.createElement('style');
        this.stylesheet.type = 'text/css';
        this.stylesheet.innerHTML = css;
        if (document && document.head) {
          document.head.appendChild(this.stylesheet);
        }
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (newProps.mode !== this.props.mode) {
        var newThemeState = buildThemeState(newProps.mode);
        if (this.stylesheet) {
          var css = getStylesheetResetCSS(newThemeState);
          this.stylesheet.innerHTML = css;
        }
        this.setState(newThemeState);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.stylesheet && document && document.head) {
        document.head.removeChild(this.stylesheet);
        delete this.stylesheet;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;

      var theme = this.state.theme;
      return (
        /* Wrapping the new provider around the old one provides forward
        compatibility when using the old provider for styled components. This
        allows us to use components converted to use the new API with consumers
        using the old provider along side components that may still be using the
        old theming API. */
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12__Context__["b" /* Provider */],
          { value: { mode: theme[__WEBPACK_IMPORTED_MODULE_11__constants__["a" /* CHANNEL */]].mode } },
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_styled_components__["ThemeProvider"],
            { theme: theme },
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
              LegacyReset,
              null,
              children
            )
          )
        )
      );
    }
  }]);

  return AtlaskitThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

AtlaskitThemeProvider.defaultProps = {
  mode: __WEBPACK_IMPORTED_MODULE_11__constants__["b" /* DEFAULT_THEME_MODE */]
};
AtlaskitThemeProvider.childContextTypes = {
  hasAtlaskitThemeProvider: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
};
AtlaskitThemeProvider.contextTypes = {
  hasAtlaskitThemeProvider: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
};
/* harmony default export */ __webpack_exports__["a"] = (AtlaskitThemeProvider);

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);





/* unused harmony default export */ var _unused_webpack_default_export = (function (_ref) {
  var children = _ref.children,
      props = _ref.props,
      theme = _ref.theme;

  var appearance = (typeof props === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(props)) === 'object' ? 'default' : props;
  var merged = (typeof props === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(props)) === 'object' ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, props) : {};
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(theme).forEach(function (key) {
    if (!(key in merged)) {
      merged[key] = theme[key]({ appearance: appearance });
    }
  });
  return children(merged);
});

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__colors__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Context__ = __webpack_require__(86);








var _templateObject = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ';\n'], ['\n  ', ';\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    background-color: ', ';\n    color: ', ';\n\n    a {\n      color: ', ';\n    }\n    a:hover {\n      color: ', ';\n    }\n    a:active {\n      color: ', ';\n    }\n    a:focus {\n      outline-color: ', ';\n    }\n    h1,\n    h2,\n    h3,\n    h4,\n    h5 {\n      color: ', ';\n    }\n    h6 {\n      color: ', ';\n    }\n    small {\n      color: ', ';\n    }\n  '], ['\n    background-color: ', ';\n    color: ', ';\n\n    a {\n      color: ', ';\n    }\n    a:hover {\n      color: ', ';\n    }\n    a:active {\n      color: ', ';\n    }\n    a:focus {\n      outline-color: ', ';\n    }\n    h1,\n    h2,\n    h3,\n    h4,\n    h5 {\n      color: ', ';\n    }\n    h6 {\n      color: ', ';\n    }\n    small {\n      color: ', ';\n    }\n  ']);






var orTextColor = function orTextColor(preferred) {
  return function (p) {
    return p[preferred] || p.textColor;
  };
};
var Div = __WEBPACK_IMPORTED_MODULE_8_styled_components__["default"].div(_templateObject, function (p) {
  return Object(__WEBPACK_IMPORTED_MODULE_8_styled_components__["css"])(_templateObject2, p.backgroundColor, p.textColor, orTextColor('linkColor'), orTextColor('linkColorHover'), orTextColor('linkColorActive'), orTextColor('linkColorOutline'), orTextColor('headingColor'), orTextColor('subtleHeadingColor'), orTextColor('subtleTextColor'));
});

var defaultTheme = {
  backgroundColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N0"],
  linkColor: __WEBPACK_IMPORTED_MODULE_9__colors__["B400"],
  linkColorHover: __WEBPACK_IMPORTED_MODULE_9__colors__["B300"],
  linkColorActive: __WEBPACK_IMPORTED_MODULE_9__colors__["B500"],
  linkColorOutline: __WEBPACK_IMPORTED_MODULE_9__colors__["B100"],
  headingColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N800"],
  subtleHeadingColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N200"],
  subtleTextColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N200"],
  textColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N900"]
};

var Reset = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Reset, _Component);

  function Reset() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Reset);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Reset.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Reset)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Reset, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10__Context__["a" /* Consumer */],
        null,
        function (theme) {
          return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            Div,
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, defaultTheme, theme, _this2.props),
            _this2.props.children
          );
        }
      );
    }
  }]);

  return Reset;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

/* unused harmony default export */ var _unused_webpack_default_export = (Reset);

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Context__ = __webpack_require__(86);








var Theme = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Theme, _Component);

  function Theme() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Theme);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Theme.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Theme)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Theme, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          values = _props.values;

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__components_Context__["a" /* Consumer */],
        null,
        function (theme) {
          var merged = values(theme);
          return typeof children === 'function' ? children(merged) : __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__components_Context__["b" /* Provider */],
            { value: merged },
            children
          );
        }
      );
    }
  }]);

  return Theme;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Theme.defaultProps = {
  values: function values(v) {
    return v;
  }
};
/* unused harmony default export */ var _unused_webpack_default_export = (Theme);

/***/ }),
/* 517 */
/***/ (function(module, exports) {

module.exports = {"name":"@atlaskit/modal-dialog","version":"6.0.9"}

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export dialogWidth */
/* unused harmony export dialogHeight */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FillScreen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PositionerAbsolute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PositionerRelative; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dialog; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_variables__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_flex_max_height_ie_fix__ = __webpack_require__(243);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  height: 100vh;\n  left: 0;\n  overflow-y: auto;\n  position: absolute;\n  top: ', 'px;\n  width: 100%;\n  z-index: ', ';\n  -webkit-overflow-scrolling: touch;\n'], ['\n  height: 100vh;\n  left: 0;\n  overflow-y: auto;\n  position: absolute;\n  top: ', 'px;\n  width: 100%;\n  z-index: ', ';\n  -webkit-overflow-scrolling: touch;\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  height: ', ';\n  left: 0;\n  margin-left: auto;\n  margin-right: auto;\n  max-width: ', ';\n  position: absolute;\n  right: 0;\n  top: ', 'px;\n  width: ', ';\n  z-index: ', ';\n'], ['\n  display: flex;\n  flex-direction: column;\n  height: ', ';\n  left: 0;\n  margin-left: auto;\n  margin-right: auto;\n  max-width: ', ';\n  position: absolute;\n  right: 0;\n  top: ', 'px;\n  width: ', ';\n  z-index: ', ';\n']),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  margin: ', 'px auto;\n  position: relative;\n  width: ', ';\n  z-index: ', ';\n'], ['\n  margin: ', 'px auto;\n  position: relative;\n  width: ', ';\n  z-index: ', ';\n']),
    _templateObject4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  display: flex;\n  flex-direction: column;\n  height: ', ';\n  ', ';\n  outline: 0;\n'], ['\n  ', ' color: ', ';\n  display: flex;\n  flex-direction: column;\n  height: ', ';\n  ', ';\n  outline: 0;\n']),
    _templateObject5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n          background-color: ', ';\n          border-radius: ', 'px;\n          box-shadow: ', ';\n        '], ['\n          background-color: ', ';\n          border-radius: ', 'px;\n          box-shadow: ', ';\n        ']);







var boxShadow = function boxShadow(_ref) {
  var isChromeless = _ref.isChromeless;
  return isChromeless ? 'none' : '\n    0 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].N30A + ', 0 2px 1px ' + __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].N30A + ',\n    0 0 20px -6px ' + __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].N60A + '\n  ';
};
var dialogBgColor = function dialogBgColor(_ref2) {
  var isChromeless = _ref2.isChromeless;
  return isChromeless ? 'transparent' : Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["g" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].N0, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].DN50 });
};
var maxDimensions = 'calc(100% - ' + __WEBPACK_IMPORTED_MODULE_3__shared_variables__["b" /* gutter */] * 2 + 'px)';
var maxHeightDimensions = 'calc(100% - ' + (__WEBPACK_IMPORTED_MODULE_3__shared_variables__["b" /* gutter */] * 2 - __WEBPACK_IMPORTED_MODULE_4__utils_flex_max_height_ie_fix__["a" /* IEMaxHeightCalcPx */]) + 'px)';

var dialogWidth = function dialogWidth(_ref3) {
  var widthName = _ref3.widthName,
      widthValue = _ref3.widthValue;

  if (typeof widthValue === 'number') {
    return widthValue + 'px';
  }

  return widthName ? __WEBPACK_IMPORTED_MODULE_3__shared_variables__["a" /* WIDTH_ENUM */].widths[widthName] + 'px' : widthValue || 'auto';
};
var dialogHeight = function dialogHeight(_ref4) {
  var heightValue = _ref4.heightValue;

  if (typeof heightValue === 'number') {
    return heightValue + 'px';
  }

  return heightValue || 'auto';
};

/**
  NOTE:
  z-index
  - temporarily added to beat @atlaskit/navigation

  absolute + top
  - rather than fixed position so popper.js children are properly positioned

  overflow-y
  - only active when popper.js children envoked below the dialog
*/
var FillScreen = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, function (p) {
  return p.scrollDistance;
}, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["e" /* layers */].modal);

var PositionerAbsolute = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject2, maxHeightDimensions, maxDimensions, __WEBPACK_IMPORTED_MODULE_3__shared_variables__["b" /* gutter */], dialogWidth, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["e" /* layers */].modal);
var PositionerRelative = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject3, __WEBPACK_IMPORTED_MODULE_3__shared_variables__["b" /* gutter */], dialogWidth, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["e" /* layers */].modal);

var Dialog = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject4, function (p) {
  return p.isChromeless ? null : Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject5, dialogBgColor, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* borderRadius */], boxShadow);
}, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].text, dialogHeight, __WEBPACK_IMPORTED_MODULE_4__utils_flex_max_height_ie_fix__["b" /* flexMaxHeightIEFix */]);

PositionerAbsolute.displayName = 'PositionerAbsolute';
Dialog.displayName = 'Dialog';
FillScreen.displayName = 'FillScreen';
PositionerRelative.displayName = 'PositionerRelative';

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export e100 */
/* unused harmony export e200 */
/* unused harmony export e300 */
/* unused harmony export e400 */
/* unused harmony export e500 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_themed__ = __webpack_require__(153);



// Cards on a board
var e100 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 1px 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px 0 ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 1px 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

// Inline dialogs
var e200 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 4px 8px -2px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 4px 8px -2px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

// Modals
var e300 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 8px 16px -4px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 8px 16px -4px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

// Panels
var e400 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 12px 24px -6px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 12px 24px -6px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

// Flag messages (notifications)
var e500 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 20px 32px -8px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 20px 32px -8px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export h900 */
/* unused harmony export h800 */
/* unused harmony export h700 */
/* unused harmony export h600 */
/* unused harmony export h500 */
/* unused harmony export h400 */
/* unused harmony export h300 */
/* unused harmony export h200 */
/* unused harmony export h100 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__colors__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index__ = __webpack_require__(152);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 500;\n  letter-spacing: -0.01em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 500;\n  letter-spacing: -0.01em;\n  margin-top: ', 'px;\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  margin-top: ', 'px;\n']),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 500;\n  letter-spacing: -0.008em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 500;\n  letter-spacing: -0.008em;\n  margin-top: ', 'px;\n']),
    _templateObject4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.006em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.006em;\n  margin-top: ', 'px;\n']),
    _templateObject5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.003em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.003em;\n  margin-top: ', 'px;\n']),
    _templateObject6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  margin-top: ', 'px;\n  text-transform: uppercase;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  margin-top: ', 'px;\n  text-transform: uppercase;\n']),
    _templateObject7 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  margin-top: ', 'px;\n']),
    _templateObject8 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: normal;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: normal;\n  margin-top: ', 'px;\n']);






var baseHeading = function baseHeading(size, lineHeight) {
  return '\n  font-size: ' + size / Object(__WEBPACK_IMPORTED_MODULE_3__index__["c" /* fontSize */])() + 'em;\n  font-style: inherit;\n  line-height: ' + lineHeight / size + ';\n';
};

var h900 = function h900() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject, baseHeading(35, 40), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 6.5);
};

var h800 = function h800() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject2, baseHeading(29, 32), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 5);
};

var h700 = function h700() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject, baseHeading(24, 28), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 5);
};

var h600 = function h600() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject3, baseHeading(20, 24), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 3.5);
};

var h500 = function h500() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject4, baseHeading(16, 20), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 3);
};

var h400 = function h400() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject5, baseHeading(14, 16), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 2);
};

var h300 = function h300() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject6, baseHeading(12, 16), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 2.5);
};

var h200 = function h200() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject7, baseHeading(12, 16), __WEBPACK_IMPORTED_MODULE_2__colors__["subtleHeading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 2);
};

var h100 = function h100() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject8, baseHeading(12, 16), __WEBPACK_IMPORTED_MODULE_2__colors__["subtleHeading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 2);
};

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["add"] = add;
/* harmony export (immutable) */ __webpack_exports__["subtract"] = subtract;
/* harmony export (immutable) */ __webpack_exports__["multiply"] = multiply;
/* harmony export (immutable) */ __webpack_exports__["divide"] = divide;
function add(fn, addend) {
  return function (props) {
    return fn(props) + addend;
  };
}

function subtract(fn, subtrahend) {
  return function (props) {
    return fn(props) - subtrahend;
  };
}

function multiply(fn, factor) {
  return function (props) {
    return fn(props) * factor;
  };
}

function divide(fn, divisor) {
  return function (props) {
    return fn(props) / divisor;
  };
}

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__colors__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Context__ = __webpack_require__(87);








var _templateObject = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  background-color: ', ';\n  color: ', ';\n\n  a {\n    color: ', ';\n  }\n  a:hover {\n    color: ', ';\n  }\n  a:active {\n    color: ', ';\n  }\n  a:focus {\n    outline-color: ', ';\n  }\n  h1 {\n    color: ', ';\n  }\n  h2 {\n    color: ', ';\n  }\n  h3 {\n    color: ', ';\n  }\n  h4 {\n    color: ', ';\n  }\n  h5 {\n    color: ', ';\n  }\n  h6 {\n    color: ', ';\n  }\n  small {\n    color: ', ';\n  }\n'], ['\n  background-color: ', ';\n  color: ', ';\n\n  a {\n    color: ', ';\n  }\n  a:hover {\n    color: ', ';\n  }\n  a:active {\n    color: ', ';\n  }\n  a:focus {\n    outline-color: ', ';\n  }\n  h1 {\n    color: ', ';\n  }\n  h2 {\n    color: ', ';\n  }\n  h3 {\n    color: ', ';\n  }\n  h4 {\n    color: ', ';\n  }\n  h5 {\n    color: ', ';\n  }\n  h6 {\n    color: ', ';\n  }\n  small {\n    color: ', ';\n  }\n']);









// For forward-compat until everything is upgraded.


function getStylesheetResetCSS(state) {
  var backgroundColor = __WEBPACK_IMPORTED_MODULE_10__colors__["background"](state);
  return '\n    body { background: ' + backgroundColor + '; }\n  ';
}

function buildThemeState(mode) {
  return { theme: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_11__constants__["a" /* CHANNEL */], { mode: mode }) };
}

var LegacyReset = __WEBPACK_IMPORTED_MODULE_9_styled_components__["default"].div(_templateObject, __WEBPACK_IMPORTED_MODULE_10__colors__["background"], __WEBPACK_IMPORTED_MODULE_10__colors__["text"], __WEBPACK_IMPORTED_MODULE_10__colors__["link"], __WEBPACK_IMPORTED_MODULE_10__colors__["linkHover"], __WEBPACK_IMPORTED_MODULE_10__colors__["linkActive"], __WEBPACK_IMPORTED_MODULE_10__colors__["linkOutline"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["subtleHeading"], __WEBPACK_IMPORTED_MODULE_10__colors__["subtleText"]);

var AtlaskitThemeProvider = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(AtlaskitThemeProvider, _Component);

  function AtlaskitThemeProvider(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AtlaskitThemeProvider);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AtlaskitThemeProvider.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(AtlaskitThemeProvider)).call(this, props));

    _this.state = buildThemeState(props.mode);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(AtlaskitThemeProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return { hasAtlaskitThemeProvider: true };
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (!this.context.hasAtlaskitThemeProvider) {
        var css = getStylesheetResetCSS(this.state);
        this.stylesheet = document.createElement('style');
        this.stylesheet.type = 'text/css';
        this.stylesheet.innerHTML = css;
        if (document && document.head) {
          document.head.appendChild(this.stylesheet);
        }
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (newProps.mode !== this.props.mode) {
        var newThemeState = buildThemeState(newProps.mode);
        if (this.stylesheet) {
          var css = getStylesheetResetCSS(newThemeState);
          this.stylesheet.innerHTML = css;
        }
        this.setState(newThemeState);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.stylesheet && document && document.head) {
        document.head.removeChild(this.stylesheet);
        delete this.stylesheet;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;

      var theme = this.state.theme;
      return (
        /* Wrapping the new provider around the old one provides forward
        compatibility when using the old provider for styled components. This
        allows us to use components converted to use the new API with consumers
        using the old provider along side components that may still be using the
        old theming API. */
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12__Context__["b" /* Provider */],
          { value: { mode: theme[__WEBPACK_IMPORTED_MODULE_11__constants__["a" /* CHANNEL */]].mode } },
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_styled_components__["ThemeProvider"],
            { theme: theme },
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
              LegacyReset,
              null,
              children
            )
          )
        )
      );
    }
  }]);

  return AtlaskitThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

AtlaskitThemeProvider.defaultProps = {
  mode: __WEBPACK_IMPORTED_MODULE_11__constants__["b" /* DEFAULT_THEME_MODE */]
};
AtlaskitThemeProvider.childContextTypes = {
  hasAtlaskitThemeProvider: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
};
AtlaskitThemeProvider.contextTypes = {
  hasAtlaskitThemeProvider: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
};
/* harmony default export */ __webpack_exports__["a"] = (AtlaskitThemeProvider);

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);





/* unused harmony default export */ var _unused_webpack_default_export = (function (_ref) {
  var children = _ref.children,
      props = _ref.props,
      theme = _ref.theme;

  var appearance = (typeof props === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(props)) === 'object' ? 'default' : props;
  var merged = (typeof props === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(props)) === 'object' ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, props) : {};
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(theme).forEach(function (key) {
    if (!(key in merged)) {
      merged[key] = theme[key]({ appearance: appearance });
    }
  });
  return children(merged);
});

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__colors__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Context__ = __webpack_require__(87);








var _templateObject = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ';\n'], ['\n  ', ';\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    background-color: ', ';\n    color: ', ';\n\n    a {\n      color: ', ';\n    }\n    a:hover {\n      color: ', ';\n    }\n    a:active {\n      color: ', ';\n    }\n    a:focus {\n      outline-color: ', ';\n    }\n    h1,\n    h2,\n    h3,\n    h4,\n    h5 {\n      color: ', ';\n    }\n    h6 {\n      color: ', ';\n    }\n    small {\n      color: ', ';\n    }\n  '], ['\n    background-color: ', ';\n    color: ', ';\n\n    a {\n      color: ', ';\n    }\n    a:hover {\n      color: ', ';\n    }\n    a:active {\n      color: ', ';\n    }\n    a:focus {\n      outline-color: ', ';\n    }\n    h1,\n    h2,\n    h3,\n    h4,\n    h5 {\n      color: ', ';\n    }\n    h6 {\n      color: ', ';\n    }\n    small {\n      color: ', ';\n    }\n  ']);






var orTextColor = function orTextColor(preferred) {
  return function (p) {
    return p[preferred] || p.textColor;
  };
};
var Div = __WEBPACK_IMPORTED_MODULE_8_styled_components__["default"].div(_templateObject, function (p) {
  return Object(__WEBPACK_IMPORTED_MODULE_8_styled_components__["css"])(_templateObject2, p.backgroundColor, p.textColor, orTextColor('linkColor'), orTextColor('linkColorHover'), orTextColor('linkColorActive'), orTextColor('linkColorOutline'), orTextColor('headingColor'), orTextColor('subtleHeadingColor'), orTextColor('subtleTextColor'));
});

var defaultTheme = {
  backgroundColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N0"],
  linkColor: __WEBPACK_IMPORTED_MODULE_9__colors__["B400"],
  linkColorHover: __WEBPACK_IMPORTED_MODULE_9__colors__["B300"],
  linkColorActive: __WEBPACK_IMPORTED_MODULE_9__colors__["B500"],
  linkColorOutline: __WEBPACK_IMPORTED_MODULE_9__colors__["B100"],
  headingColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N800"],
  subtleHeadingColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N200"],
  subtleTextColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N200"],
  textColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N900"]
};

var Reset = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Reset, _Component);

  function Reset() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Reset);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Reset.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Reset)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Reset, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10__Context__["a" /* Consumer */],
        null,
        function (theme) {
          return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            Div,
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, defaultTheme, theme, _this2.props),
            _this2.props.children
          );
        }
      );
    }
  }]);

  return Reset;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

/* unused harmony default export */ var _unused_webpack_default_export = (Reset);

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Context__ = __webpack_require__(87);








var Theme = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Theme, _Component);

  function Theme() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Theme);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Theme.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Theme)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Theme, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          values = _props.values;

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__components_Context__["a" /* Consumer */],
        null,
        function (theme) {
          var merged = values(theme);
          return typeof children === 'function' ? children(merged) : __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__components_Context__["b" /* Provider */],
            { value: merged },
            children
          );
        }
      );
    }
  }]);

  return Theme;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Theme.defaultProps = {
  values: function values(v) {
    return v;
  }
};
/* unused harmony default export */ var _unused_webpack_default_export = (Theme);

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Fade; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SlideUp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_transition_group__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_variables__ = __webpack_require__(151);







var duration = 500;
var easing = 'cubic-bezier(0.23, 1, 0.32, 1)'; // easeOutQuint
var verticalOffset = 16;

var DefaultProps = {
  component: 'div'
};

// BASE
// ==============================

/**
  To achieve a "lazy mount" and clean up our component after unmounting,
  the following props must be set to true:
  - appear
  - mountOnEnter
  - unmountOnExit

  Read more https://reactcommunity.org/react-transition-group/#Transition-prop-mountOnEnter
*/
function Animation(_ref) {
  var Tag = _ref.component,
      transitionIn = _ref.in,
      onEnter = _ref.onEnter,
      onEntering = _ref.onEntering,
      onEntered = _ref.onEntered,
      onExit = _ref.onExit,
      onExiting = _ref.onExiting,
      onExited = _ref.onExited,
      style = _ref.style,
      styleDefault = _ref.styleDefault,
      customTransition = _ref.customTransition,
      transition = _ref.transition,
      props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['component', 'in', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited', 'style', 'styleDefault', 'customTransition', 'transition']);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_react_transition_group__["Transition"],
    {
      appear: true,
      'in': transitionIn,
      mountOnEnter: true,
      onEnter: onEnter,
      onEntering: onEntering,
      onEntered: onEntered,
      onExit: onExit,
      onExiting: onExiting,
      onExited: onExited,
      timeout: duration,
      unmountOnExit: true
    },
    function (status) {
      if (status === 'exited') return null;

      var styles = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, styleDefault, transition[status], transition[customTransition]);

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Tag, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ style: styles }, props));
    }
  );
}
Animation.defaultProps = DefaultProps;

// FADE
// ==============================
var Fade = function Fade(props) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Animation, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    styleDefault: {
      transition: 'opacity ' + duration / 2 + 'ms'
    },
    transition: {
      entering: { opacity: 0 },
      entered: { opacity: 1 },
      exiting: { opacity: 0 }
    }
  }, props));
};

// SLIDE UP
// ==============================
var SlideUp = function SlideUp(_ref2) {
  var stackIndex = _ref2.stackIndex,
      transitionIn = _ref2.in,
      style = _ref2.style,
      component = _ref2.component,
      props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref2, ['stackIndex', 'in', 'style', 'component']);

  var translateY = stackIndex * (verticalOffset / 2);
  var restingTransform = 'translate3d(0, ' + translateY + 'px, 0)';

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Animation, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    component: component,
    'in': transitionIn,
    style: style,
    styleDefault: {
      transition: 'transform ' + duration + 'ms ' + easing,
      transform: restingTransform
    },
    transition: {
      entering: {
        transform: 'translate3d(0, ' + verticalOffset * 2 + 'px, 0)'
      },
      entered: {
        transform: restingTransform
      },
      /* Custom transition where we remove the transform so it doesn't cause issues with react-beautiful-dnd (AK-4328)
       * This can be removed once react-beautiful-dnd portals its draggables.
       */
      afterEntered: {
        transform: null,
        top: translateY + (component.displayName === 'PositionerAbsolute' ? __WEBPACK_IMPORTED_MODULE_4__shared_variables__["b" /* gutter */] : 0)
      },
      exit: {
        transform: restingTransform
      },
      exiting: {
        transform: 'translate3d(0, -' + verticalOffset * 2 + 'px, 0)'
      }
    }
  }, props));
};


/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_raf_schd__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_scrolllock__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_scrolllock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_scrolllock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Footer__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Header__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styled_Content__ = __webpack_require__(90);















function getInitialState() {
  return {
    showFooterKeyline: false,
    showHeaderKeyline: false,
    tabbableElements: []
  };
}

var Content = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Content, _Component);

  function Content(props, context) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Content);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Content.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Content)).call(this, props, context));

    _this.escapeIsHeldDown = false;
    _this._isMounted = false;
    _this.state = getInitialState();

    _this.determineKeylines = function () {
      if (!_this.scrollContainer) return;

      var _this$scrollContainer = _this.scrollContainer,
          scrollTop = _this$scrollContainer.scrollTop,
          scrollHeight = _this$scrollContainer.scrollHeight,
          clientHeight = _this$scrollContainer.clientHeight;

      var scrollableDistance = scrollHeight - clientHeight;
      var showHeaderKeyline = scrollTop > __WEBPACK_IMPORTED_MODULE_11__styled_Content__["j" /* keylineHeight */];
      var showFooterKeyline = scrollTop <= scrollableDistance - __WEBPACK_IMPORTED_MODULE_11__styled_Content__["j" /* keylineHeight */];

      _this.setState({ showHeaderKeyline: showHeaderKeyline, showFooterKeyline: showFooterKeyline });
    };

    _this.getScrollContainer = function (ref) {
      if (!ref) return;
      _this.scrollContainer = ref;
    };

    _this.handleKeyUp = function () {
      _this.escapeIsHeldDown = false;
    };

    _this.handleKeyDown = function (event) {
      var _this$props = _this.props,
          onClose = _this$props.onClose,
          shouldCloseOnEscapePress = _this$props.shouldCloseOnEscapePress,
          _this$props$stackInde = _this$props.stackIndex,
          stackIndex = _this$props$stackInde === undefined ? 0 : _this$props$stackInde;

      // avoid consumers accidently closing multiple modals if they hold escape.

      if (_this.escapeIsHeldDown) return;
      if (event.key === 'Escape') _this.escapeIsHeldDown = true;

      // only the foremost modal should be interactive.
      if (!_this._isMounted || stackIndex > 0) return;

      switch (event.key) {
        case 'Escape':
          if (shouldCloseOnEscapePress) onClose(event);
          break;
        default:
      }
    };

    _this.handleStackChange = function (stackIndex) {
      var onStackChange = _this.props.onStackChange;

      if (onStackChange) onStackChange(stackIndex);
    };

    _this.determineKeylines = Object(__WEBPACK_IMPORTED_MODULE_7_raf_schd__["a" /* default */])(_this.determineKeylines);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Content, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._isMounted = true;

      // $FlowFixMe - issue with document.addEventListener - Enum incompatible
      document.addEventListener('keydown', this.handleKeyDown, false);
      document.addEventListener('keyup', this.handleKeyUp, false);

      if (this.scrollContainer) {
        var capturedScrollContainer = this.scrollContainer;
        window.addEventListener('resize', this.determineKeylines, false);
        capturedScrollContainer.addEventListener('scroll', this.determineKeylines, false);
        this.determineKeylines();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var stackIndex = this.props.stackIndex;

      // update focus scope and let consumer know when stack index has changed

      if (nextProps.stackIndex && nextProps.stackIndex !== stackIndex) {
        this.handleStackChange(nextProps.stackIndex);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._isMounted = false;

      // $FlowFixMe - issue with document.addEventListener - Enum incompatible
      document.removeEventListener('keydown', this.handleKeyDown, false);
      document.removeEventListener('keyup', this.handleKeyUp, false);

      if (this.scrollContainer) {
        var capturedScrollContainer = this.scrollContainer;
        window.removeEventListener('resize', this.determineKeylines, false);
        capturedScrollContainer.removeEventListener('scroll', this.determineKeylines, false);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          actions = _props.actions,
          appearance = _props.appearance,
          ModalBody = _props.body,
          children = _props.children,
          footer = _props.footer,
          header = _props.header,
          heading = _props.heading,
          onClose = _props.onClose,
          isChromeless = _props.isChromeless,
          isHeadingMultiline = _props.isHeadingMultiline,
          shouldScroll = _props.shouldScroll;
      var _state = this.state,
          showFooterKeyline = _state.showFooterKeyline,
          showHeaderKeyline = _state.showHeaderKeyline;


      if (isChromeless) {
        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11__styled_Content__["i" /* Wrapper */],
          null,
          children,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_scrolllock___default.a, null)
        );
      }

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11__styled_Content__["i" /* Wrapper */],
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Header__["a" /* default */], {
          appearance: appearance,
          component: header,
          heading: heading,
          onClose: onClose,
          isHeadingMultiline: isHeadingMultiline,
          showKeyline: showHeaderKeyline
        }),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          ModalBody,
          {
            innerRef: this.getScrollContainer,
            shouldScroll: shouldScroll
          },
          children
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Footer__["a" /* default */], {
          actions: actions,
          appearance: appearance,
          component: footer,
          onClose: onClose,
          showKeyline: showFooterKeyline
        }),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_scrolllock___default.a, null)
      );
    }
  }]);

  return Content;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Content.defaultProps = {
  autoFocus: false,
  isChromeless: false,
  stackIndex: 0,
  body: __WEBPACK_IMPORTED_MODULE_11__styled_Content__["c" /* Body */],
  isHeadingMultiline: true
};
Content.contextTypes = {
  /** available when invoked within @atlaskit/layer-manager */
  appId: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (Content);

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__atlaskit_button__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styled_Content__ = __webpack_require__(90);












var JustifyShim = function JustifyShim(props) {
  return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('span', props);
};

var ModalFooter = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(ModalFooter, _Component);

  function ModalFooter() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ModalFooter);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ModalFooter.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(ModalFooter)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(ModalFooter, [{
    key: 'render',
    // eslint-disable-line react/sort-comp

    value: function render() {
      var _props = this.props,
          actions = _props.actions,
          appearance = _props.appearance,
          component = _props.component,
          onClose = _props.onClose,
          showKeyline = _props.showKeyline;

      var warning = 'You can provide `component` OR `actions`, not both.';

      if (!component && !actions) return null;
      if (component && actions) return console.warn(warning); // eslint-disable-line no-console
      if (component) {
        return Object(__WEBPACK_IMPORTED_MODULE_7_react__["createElement"])(component, {
          appearance: appearance,
          onClose: onClose,
          showKeyline: showKeyline
        });
      }

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__styled_Content__["d" /* Footer */],
        { showKeyline: showKeyline },
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(JustifyShim, null),
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__styled_Content__["b" /* Actions */],
          null,
          actions ? actions.map(function (_ref, idx) {
            var text = _ref.text,
                rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['text']);

            var variant = idx ? 'subtle' : appearance || 'primary';
            return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9__styled_Content__["a" /* ActionItem */],
              { key: text || idx },
              __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8__atlaskit_button__["b" /* default */],
                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ appearance: variant }, rest),
                text
              )
            );
          }) : null
        )
      );
    }
  }]);

  return ModalFooter;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (ModalFooter);

/***/ }),
/* 529 */
/***/ (function(module, exports) {

module.exports = {"name":"@atlaskit/button","version":"9.0.6"}

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Button__ = __webpack_require__(244);



var getAppearanceProps = function getAppearanceProps(props, state) {
  var appearance = props.appearance,
      className = props.className,
      isDisabled = props.isDisabled,
      isLoading = props.isLoading,
      isSelected = props.isSelected,
      spacing = props.spacing,
      shouldFitContainer = props.shouldFitContainer;
  var isActive = state.isActive,
      isFocus = state.isFocus,
      isHover = state.isHover;


  return {
    appearance: appearance,
    className: className,
    disabled: isDisabled,
    isActive: isActive,
    isFocus: isFocus,
    isHover: isHover,
    isLoading: isLoading,
    isSelected: isSelected,
    spacing: spacing,
    fit: shouldFitContainer
  };
};

var getInteractionProps = function getInteractionProps(component) {
  var onBlur = component.onBlur,
      onFocus = component.onFocus,
      onMouseDown = component.onMouseDown,
      onMouseEnter = component.onMouseEnter,
      onMouseLeave = component.onMouseLeave,
      onMouseUp = component.onMouseUp;
  var tabIndex = component.props.tabIndex;

  // Block onClick/Keyboard submit while isLoading

  var onClick = component.props.isLoading ? function (e) {
    e.preventDefault();
  } : component.props.onClick;

  return {
    onBlur: onBlur,
    onClick: onClick,
    onFocus: onFocus,
    onMouseDown: onMouseDown,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onMouseUp: onMouseUp,
    tabIndex: tabIndex
  };
};

var getLinkElementProps = function getLinkElementProps(props) {
  var href = props.href,
      target = props.target;


  return { href: href, target: target };
};

var getButtonElementProps = function getButtonElementProps(props) {
  var ariaHaspopup = props.ariaHaspopup,
      ariaExpanded = props.ariaExpanded,
      ariaControls = props.ariaControls,
      form = props.form,
      type = props.type;


  return {
    'aria-haspopup': ariaHaspopup,
    'aria-expanded': ariaExpanded,
    'aria-controls': ariaControls,
    form: form,
    type: type
  };
};

var getButtonProps = function getButtonProps(component) {
  var props = component.props,
      state = component.state;


  var defaultProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    id: props.id
  }, getAppearanceProps(props, state), getInteractionProps(component), {
    'aria-label': props.ariaLabel
  });

  if (props.component) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, defaultProps);
  }

  if (props.href) {
    if (props.isDisabled) {
      return defaultProps;
    }

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, defaultProps, getLinkElementProps(props));
  }

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, defaultProps, getButtonElementProps(props));
};

/* harmony default export */ __webpack_exports__["a"] = (getButtonProps);

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_analytics_next__ = __webpack_require__(21);









/**
 * Styling a button is complicated and there are a number of properties which inform its appearance.
 * We want to be able to style any arbitrary component like a button, but we don't want to pass all
 * of these appearance-related props through to the component or underlying DOM node. This component
 * acts as a layer which catches the appearance-related properties so that they can be used by
 * styled-components, then passes the rest of the props on to the custom component.
 */

var CustomComponentProxy = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(CustomComponentProxy, _Component);

  function CustomComponentProxy() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, CustomComponentProxy);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CustomComponentProxy.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(CustomComponentProxy)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(CustomComponentProxy, [{
    key: 'render',
    value: function render() {
      var _cleanProps = Object(__WEBPACK_IMPORTED_MODULE_7__atlaskit_analytics_next__["a" /* cleanProps */])(this.props),
          appearance = _cleanProps.appearance,
          children = _cleanProps.children,
          component = _cleanProps.component,
          isActive = _cleanProps.isActive,
          isDisabled = _cleanProps.isDisabled,
          isFocus = _cleanProps.isFocus,
          isHover = _cleanProps.isHover,
          isSelected = _cleanProps.isSelected,
          shouldFitContainer = _cleanProps.shouldFitContainer,
          fit = _cleanProps.fit,
          iconBefore = _cleanProps.iconBefore,
          iconAfter = _cleanProps.iconAfter,
          isLoading = _cleanProps.isLoading,
          proxiedProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_cleanProps, ['appearance', 'children', 'component', 'isActive', 'isDisabled', 'isFocus', 'isHover', 'isSelected', 'shouldFitContainer', 'fit', 'iconBefore', 'iconAfter', 'isLoading']);

      if (!component) throw new Error('No custom component provided while trying to use custom button component');
      var ProxiedComponent = component;
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        ProxiedComponent,
        proxiedProps,
        children
      );
    }
  }]);

  return CustomComponentProxy;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (CustomComponentProxy);

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getPropertyAppearance */
/* harmony export (immutable) */ __webpack_exports__["a"] = getButtonStyles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__themeDefinitions__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__theme__ = __webpack_require__(249);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n        box-shadow: 0 0 0 2px ', ';\n      '], ['\n        box-shadow: 0 0 0 2px ', ';\n      ']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    align-items: baseline;\n    background: ', ';\n    border-radius: ', 'px;\n    border-width: 0;\n    box-sizing: border-box;\n    color: ', ' !important;\n    cursor: ', ';\n    display: inline-flex;\n    font-size: inherit;\n    font-style: normal;\n    height: ', ';\n    line-height: ', ';\n    margin: 0;\n    max-width: 100%;\n    outline: ', ' !important;\n    padding: ', ';\n    text-align: center;\n    text-decoration: ', ';\n    transition: ', ';\n    transition-duration: ', ';\n    vertical-align: ', ';\n    white-space: nowrap;\n    width: ', ';\n    ', ' &::-moz-focus-inner {\n      border: 0;\n      margin: 0;\n      padding: 0;\n    }\n    ', ';\n  '], ['\n    align-items: baseline;\n    background: ', ';\n    border-radius: ', 'px;\n    border-width: 0;\n    box-sizing: border-box;\n    color: ', ' !important;\n    cursor: ', ';\n    display: inline-flex;\n    font-size: inherit;\n    font-style: normal;\n    height: ', ';\n    line-height: ', ';\n    margin: 0;\n    max-width: 100%;\n    outline: ', ' !important;\n    padding: ', ';\n    text-align: center;\n    text-decoration: ', ';\n    transition: ', ';\n    transition-duration: ', ';\n    vertical-align: ', ';\n    white-space: nowrap;\n    width: ', ';\n    ', ' &::-moz-focus-inner {\n      border: 0;\n      margin: 0;\n      padding: 0;\n    }\n    ', ';\n  ']);






var getProvidedTheme = function getProvidedTheme(_ref) {
  var theme = _ref.theme;
  return theme && theme[__WEBPACK_IMPORTED_MODULE_4__theme__["a" /* themeNamespace */]] || {};
};

var getAppearanceProperty = function getAppearanceProperty(property, appearance, providedTheme, inBuiltTheme) {
  var providedAppearanceStyles = providedTheme[appearance];
  var inBuiltAppearanceStyles = inBuiltTheme[appearance];
  var defaultAppearanceStyles = inBuiltTheme.default;

  return providedAppearanceStyles && providedAppearanceStyles[property] || inBuiltAppearanceStyles && inBuiltAppearanceStyles[property] || defaultAppearanceStyles[property];
};

var getState = function getState(_ref2) {
  var disabled = _ref2.disabled,
      isActive = _ref2.isActive,
      isFocus = _ref2.isFocus,
      isHover = _ref2.isHover,
      isSelected = _ref2.isSelected;

  if (disabled) return 'disabled';
  if (isSelected && isFocus) return 'focusSelected';
  if (isSelected) return 'selected';
  if (isActive) return 'active';
  if (isHover) return 'hover';
  if (isFocus) return 'focus';
  return 'default';
};

var getPropertyAppearance = function getPropertyAppearance(property) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var definitions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_3__themeDefinitions__["a" /* default */];
  var appearance = props.appearance;
  var fallbacks = definitions.fallbacks,
      inBuiltTheme = definitions.theme;

  var providedTheme = getProvidedTheme(props);

  var propertyStyles = getAppearanceProperty(property, appearance, providedTheme, inBuiltTheme);

  if (!propertyStyles) {
    return fallbacks[property] || 'initial';
  }

  var state = getState(props);

  return propertyStyles[state] || propertyStyles.default || fallbacks[property];
};

function getButtonStyles(props) {
  // $FlowFixMe - should be fixed when theme work is done
  var baseSize = Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["c" /* fontSize */])(props);
  var buttonHeight = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["e" /* math */].divide(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["e" /* math */].multiply(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */], 4), baseSize)(props) + 'em';
  var compactButtonHeight = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["e" /* math */].divide(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["e" /* math */].multiply(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */], 3), baseSize)(props) + 'em';

  /**
   * Variable styles
   */
  var cursor = 'default';
  var height = buttonHeight;
  var lineHeight = buttonHeight;
  var outline = 'none';
  // $FlowFixMe - should be fixed when theme work is done
  var padding = '0 ' + Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */])(props) + 'px';
  var transitionDuration = '0.1s, 0.15s';
  var transition = 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)';
  var verticalAlign = 'middle';
  var width = 'auto';

  /**
   * Appearance + Theme styles
   */
  var background = getPropertyAppearance('background', props);
  var color = getPropertyAppearance('color', props);
  var boxShadowColor = getPropertyAppearance('boxShadowColor', props);
  var boxShadow = boxShadowColor ? Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject, boxShadowColor) : null;
  var textDecoration = getPropertyAppearance('textDecoration', props);

  // Spacing: Compact
  if (props.spacing === 'compact') {
    height = compactButtonHeight;
    lineHeight = compactButtonHeight;
  }

  // Spacing: None
  if (props.spacing === 'none') {
    height = 'auto';
    lineHeight = 'inherit';
    padding = '0';
    verticalAlign = 'baseline';
  }

  // Interaction: Hover
  if (props.isHover) {
    cursor = 'pointer';
    transition = 'background 0s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)';
  }

  // Interaction: Active
  if (props.isActive) {
    transitionDuration = '0s';
  }

  // Interaction: Focus
  if (props.isFocus) {
    outline = 'none';
    transitionDuration = '0s, 0.2s';
  }

  // Disabled
  if (props.disabled) {
    cursor = 'not-allowed';
  }

  // Loading
  var isLoadingStyles = function isLoadingStyles(p) {
    return p.isLoading ? 'pointer-events: none;' : null;
  };

  // Fit to parent width
  if (props.fit) {
    width = '100%';
  }

  /* Note use of !important to override the ThemeReset on anchor tag styles */

  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject2, background, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* borderRadius */], color, cursor, height, lineHeight, outline, padding, textDecoration, transition, transitionDuration, verticalAlign, width, boxShadow, isLoadingStyles);
}

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export e100 */
/* unused harmony export e200 */
/* unused harmony export e300 */
/* unused harmony export e400 */
/* unused harmony export e500 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_themed__ = __webpack_require__(155);



// Cards on a board
var e100 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 1px 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px 0 ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 1px 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

// Inline dialogs
var e200 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 4px 8px -2px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 4px 8px -2px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

// Modals
var e300 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 8px 16px -4px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 8px 16px -4px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

// Panels
var e400 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 12px 24px -6px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 12px 24px -6px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

// Flag messages (notifications)
var e500 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 20px 32px -8px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 20px 32px -8px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export h900 */
/* unused harmony export h800 */
/* unused harmony export h700 */
/* unused harmony export h600 */
/* unused harmony export h500 */
/* unused harmony export h400 */
/* unused harmony export h300 */
/* unused harmony export h200 */
/* unused harmony export h100 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__colors__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index__ = __webpack_require__(62);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 500;\n  letter-spacing: -0.01em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 500;\n  letter-spacing: -0.01em;\n  margin-top: ', 'px;\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  margin-top: ', 'px;\n']),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 500;\n  letter-spacing: -0.008em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 500;\n  letter-spacing: -0.008em;\n  margin-top: ', 'px;\n']),
    _templateObject4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.006em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.006em;\n  margin-top: ', 'px;\n']),
    _templateObject5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.003em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.003em;\n  margin-top: ', 'px;\n']),
    _templateObject6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  margin-top: ', 'px;\n  text-transform: uppercase;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  margin-top: ', 'px;\n  text-transform: uppercase;\n']),
    _templateObject7 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  margin-top: ', 'px;\n']),
    _templateObject8 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: normal;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: normal;\n  margin-top: ', 'px;\n']);






var baseHeading = function baseHeading(size, lineHeight) {
  return '\n  font-size: ' + size / Object(__WEBPACK_IMPORTED_MODULE_3__index__["c" /* fontSize */])() + 'em;\n  font-style: inherit;\n  line-height: ' + lineHeight / size + ';\n';
};

var h900 = function h900() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject, baseHeading(35, 40), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 6.5);
};

var h800 = function h800() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject2, baseHeading(29, 32), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 5);
};

var h700 = function h700() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject, baseHeading(24, 28), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 5);
};

var h600 = function h600() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject3, baseHeading(20, 24), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 3.5);
};

var h500 = function h500() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject4, baseHeading(16, 20), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 3);
};

var h400 = function h400() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject5, baseHeading(14, 16), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 2);
};

var h300 = function h300() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject6, baseHeading(12, 16), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 2.5);
};

var h200 = function h200() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject7, baseHeading(12, 16), __WEBPACK_IMPORTED_MODULE_2__colors__["subtleHeading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 2);
};

var h100 = function h100() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject8, baseHeading(12, 16), __WEBPACK_IMPORTED_MODULE_2__colors__["subtleHeading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 2);
};

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["add"] = add;
/* harmony export (immutable) */ __webpack_exports__["subtract"] = subtract;
/* harmony export (immutable) */ __webpack_exports__["multiply"] = multiply;
/* harmony export (immutable) */ __webpack_exports__["divide"] = divide;
function add(fn, addend) {
  return function (props) {
    return fn(props) + addend;
  };
}

function subtract(fn, subtrahend) {
  return function (props) {
    return fn(props) - subtrahend;
  };
}

function multiply(fn, factor) {
  return function (props) {
    return fn(props) * factor;
  };
}

function divide(fn, divisor) {
  return function (props) {
    return fn(props) / divisor;
  };
}

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__colors__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Context__ = __webpack_require__(88);








var _templateObject = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  background-color: ', ';\n  color: ', ';\n\n  a {\n    color: ', ';\n  }\n  a:hover {\n    color: ', ';\n  }\n  a:active {\n    color: ', ';\n  }\n  a:focus {\n    outline-color: ', ';\n  }\n  h1 {\n    color: ', ';\n  }\n  h2 {\n    color: ', ';\n  }\n  h3 {\n    color: ', ';\n  }\n  h4 {\n    color: ', ';\n  }\n  h5 {\n    color: ', ';\n  }\n  h6 {\n    color: ', ';\n  }\n  small {\n    color: ', ';\n  }\n'], ['\n  background-color: ', ';\n  color: ', ';\n\n  a {\n    color: ', ';\n  }\n  a:hover {\n    color: ', ';\n  }\n  a:active {\n    color: ', ';\n  }\n  a:focus {\n    outline-color: ', ';\n  }\n  h1 {\n    color: ', ';\n  }\n  h2 {\n    color: ', ';\n  }\n  h3 {\n    color: ', ';\n  }\n  h4 {\n    color: ', ';\n  }\n  h5 {\n    color: ', ';\n  }\n  h6 {\n    color: ', ';\n  }\n  small {\n    color: ', ';\n  }\n']);









// For forward-compat until everything is upgraded.


function getStylesheetResetCSS(state) {
  var backgroundColor = __WEBPACK_IMPORTED_MODULE_10__colors__["background"](state);
  return '\n    body { background: ' + backgroundColor + '; }\n  ';
}

function buildThemeState(mode) {
  return { theme: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_11__constants__["a" /* CHANNEL */], { mode: mode }) };
}

var LegacyReset = __WEBPACK_IMPORTED_MODULE_9_styled_components__["default"].div(_templateObject, __WEBPACK_IMPORTED_MODULE_10__colors__["background"], __WEBPACK_IMPORTED_MODULE_10__colors__["text"], __WEBPACK_IMPORTED_MODULE_10__colors__["link"], __WEBPACK_IMPORTED_MODULE_10__colors__["linkHover"], __WEBPACK_IMPORTED_MODULE_10__colors__["linkActive"], __WEBPACK_IMPORTED_MODULE_10__colors__["linkOutline"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["subtleHeading"], __WEBPACK_IMPORTED_MODULE_10__colors__["subtleText"]);

var AtlaskitThemeProvider = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(AtlaskitThemeProvider, _Component);

  function AtlaskitThemeProvider(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AtlaskitThemeProvider);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AtlaskitThemeProvider.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(AtlaskitThemeProvider)).call(this, props));

    _this.state = buildThemeState(props.mode);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(AtlaskitThemeProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return { hasAtlaskitThemeProvider: true };
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (!this.context.hasAtlaskitThemeProvider) {
        var css = getStylesheetResetCSS(this.state);
        this.stylesheet = document.createElement('style');
        this.stylesheet.type = 'text/css';
        this.stylesheet.innerHTML = css;
        if (document && document.head) {
          document.head.appendChild(this.stylesheet);
        }
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (newProps.mode !== this.props.mode) {
        var newThemeState = buildThemeState(newProps.mode);
        if (this.stylesheet) {
          var css = getStylesheetResetCSS(newThemeState);
          this.stylesheet.innerHTML = css;
        }
        this.setState(newThemeState);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.stylesheet && document && document.head) {
        document.head.removeChild(this.stylesheet);
        delete this.stylesheet;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;

      var theme = this.state.theme;
      return (
        /* Wrapping the new provider around the old one provides forward
        compatibility when using the old provider for styled components. This
        allows us to use components converted to use the new API with consumers
        using the old provider along side components that may still be using the
        old theming API. */
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12__Context__["b" /* Provider */],
          { value: { mode: theme[__WEBPACK_IMPORTED_MODULE_11__constants__["a" /* CHANNEL */]].mode } },
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_styled_components__["ThemeProvider"],
            { theme: theme },
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
              LegacyReset,
              null,
              children
            )
          )
        )
      );
    }
  }]);

  return AtlaskitThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

AtlaskitThemeProvider.defaultProps = {
  mode: __WEBPACK_IMPORTED_MODULE_11__constants__["b" /* DEFAULT_THEME_MODE */]
};
AtlaskitThemeProvider.childContextTypes = {
  hasAtlaskitThemeProvider: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
};
AtlaskitThemeProvider.contextTypes = {
  hasAtlaskitThemeProvider: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
};
/* harmony default export */ __webpack_exports__["a"] = (AtlaskitThemeProvider);

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);





/* unused harmony default export */ var _unused_webpack_default_export = (function (_ref) {
  var children = _ref.children,
      props = _ref.props,
      theme = _ref.theme;

  var appearance = (typeof props === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(props)) === 'object' ? 'default' : props;
  var merged = (typeof props === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(props)) === 'object' ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, props) : {};
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(theme).forEach(function (key) {
    if (!(key in merged)) {
      merged[key] = theme[key]({ appearance: appearance });
    }
  });
  return children(merged);
});

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__colors__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Context__ = __webpack_require__(88);








var _templateObject = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ';\n'], ['\n  ', ';\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    background-color: ', ';\n    color: ', ';\n\n    a {\n      color: ', ';\n    }\n    a:hover {\n      color: ', ';\n    }\n    a:active {\n      color: ', ';\n    }\n    a:focus {\n      outline-color: ', ';\n    }\n    h1,\n    h2,\n    h3,\n    h4,\n    h5 {\n      color: ', ';\n    }\n    h6 {\n      color: ', ';\n    }\n    small {\n      color: ', ';\n    }\n  '], ['\n    background-color: ', ';\n    color: ', ';\n\n    a {\n      color: ', ';\n    }\n    a:hover {\n      color: ', ';\n    }\n    a:active {\n      color: ', ';\n    }\n    a:focus {\n      outline-color: ', ';\n    }\n    h1,\n    h2,\n    h3,\n    h4,\n    h5 {\n      color: ', ';\n    }\n    h6 {\n      color: ', ';\n    }\n    small {\n      color: ', ';\n    }\n  ']);






var orTextColor = function orTextColor(preferred) {
  return function (p) {
    return p[preferred] || p.textColor;
  };
};
var Div = __WEBPACK_IMPORTED_MODULE_8_styled_components__["default"].div(_templateObject, function (p) {
  return Object(__WEBPACK_IMPORTED_MODULE_8_styled_components__["css"])(_templateObject2, p.backgroundColor, p.textColor, orTextColor('linkColor'), orTextColor('linkColorHover'), orTextColor('linkColorActive'), orTextColor('linkColorOutline'), orTextColor('headingColor'), orTextColor('subtleHeadingColor'), orTextColor('subtleTextColor'));
});

var defaultTheme = {
  backgroundColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N0"],
  linkColor: __WEBPACK_IMPORTED_MODULE_9__colors__["B400"],
  linkColorHover: __WEBPACK_IMPORTED_MODULE_9__colors__["B300"],
  linkColorActive: __WEBPACK_IMPORTED_MODULE_9__colors__["B500"],
  linkColorOutline: __WEBPACK_IMPORTED_MODULE_9__colors__["B100"],
  headingColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N800"],
  subtleHeadingColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N200"],
  subtleTextColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N200"],
  textColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N900"]
};

var Reset = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Reset, _Component);

  function Reset() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Reset);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Reset.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Reset)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Reset, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10__Context__["a" /* Consumer */],
        null,
        function (theme) {
          return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            Div,
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, defaultTheme, theme, _this2.props),
            _this2.props.children
          );
        }
      );
    }
  }]);

  return Reset;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

/* unused harmony default export */ var _unused_webpack_default_export = (Reset);

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Context__ = __webpack_require__(88);








var Theme = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Theme, _Component);

  function Theme() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Theme);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Theme.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Theme)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Theme, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          values = _props.values;

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__components_Context__["a" /* Consumer */],
        null,
        function (theme) {
          var merged = values(theme);
          return typeof children === 'function' ? children(merged) : __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__components_Context__["b" /* Provider */],
            { value: merged },
            children
          );
        }
      );
    }
  }]);

  return Theme;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Theme.defaultProps = {
  values: function values(v) {
    return v;
  }
};
/* unused harmony default export */ var _unused_webpack_default_export = (Theme);

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__ = __webpack_require__(62);


/**
 * Convert a hex colour code to RGBA.
 * @param {String} hex Hex colour code.
 * @param {Number} alpha Optional alpha value (defaults to 1).
 *
 */
/* eslint-disable no-bitwise */
var hex2rgba = function hex2rgba(hex) {
  var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  var color = void 0;

  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    color = hex.substring(1).split('');

    if (color.length === 3) {
      color = [color[0], color[0], color[1], color[1], color[2], color[2]];
    }

    color = '0x' + color.join('');

    // $FlowFixMe - `>>` oxperand can validly take a string value
    var r = color >> 16 & 255;
    // $FlowFixMe - `>>` operand can validly take a string value
    var g = color >> 8 & 255;
    // $FlowFixMe - `>>` operand can validly take a string value
    var b = color & 255;

    return 'rgba(' + [r, g, b].join(',') + ', ' + alpha + ')';
  }

  throw new Error('Bad Hex');
};
/* eslint-enable no-bitwise */

/* harmony default export */ __webpack_exports__["a"] = ({
  // Fallbacks
  fallbacks: {
    background: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N20A, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].DN70 }),
    color: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N400, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].DN400 }),
    textDecoration: 'none'
  },

  // Themes
  theme: {
    // Default appearance
    default: {
      background: {
        default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N20A, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].DN70 }),
        hover: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N30A, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].DN60 }),
        active: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: hex2rgba(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].B75, 0.6), dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].B75 }),
        disabled: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N20A, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].DN70 }),
        selected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N700, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].DN0 }),
        focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N700, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].DN0 })
      },
      boxShadowColor: {
        focus: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: hex2rgba(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].B200, 0.6), dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].B75 }),
        focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({
          light: hex2rgba(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].B200, 0.6),
          dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].B75
        })
      },
      color: {
        default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N400, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].DN400 }),
        active: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].B400, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].B400 }),
        disabled: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N70, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].DN30 }),
        selected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N20, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].DN400 }),
        focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N20, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].DN400 })
      }
    },

    // Primary appearance
    primary: {
      background: {
        default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].B400, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].B100 }),
        hover: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].B300, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].B75 }),
        active: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].B500, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].B200 }),
        disabled: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N20A, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].DN70 }),
        selected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N700, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].DN0 }),
        focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N700, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].DN0 })
      },
      boxShadowColor: {
        focus: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: hex2rgba(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].B200, 0.6), dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].B75 }),
        focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({
          light: hex2rgba(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].B200, 0.6),
          dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].B75
        })
      },
      color: {
        default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N0, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].DN30 }),
        disabled: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N70, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].DN30 }),
        selected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N20, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].DN400 }),
        focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N20, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].DN400 })
      }
    },

    // Warning appearance
    warning: {
      background: {
        default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].Y300, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].Y300 }),
        hover: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].Y200, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].Y200 }),
        active: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].Y400, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].Y400 }),
        disabled: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N20A, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].DN70 }),
        selected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].Y400, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].Y400 }),
        focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].Y400, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].Y400 })
      },
      boxShadowColor: {
        focus: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].Y500, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].Y500 }),
        focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].Y500, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].Y500 })
      },
      color: {
        default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N800, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N800 }),
        disabled: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N70, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].DN30 }),
        selected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N800, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N800 }),
        focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N800, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N800 })
      }
    },

    // Danger appearance
    danger: {
      background: {
        default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].R400, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].R400 }),
        hover: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].R300, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].R300 }),
        active: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].R500, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].R500 }),
        disabled: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N20A, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].DN70 }),
        selected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].R500, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].R500 }),
        focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].R500, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].R500 })
      },
      boxShadowColor: {
        focus: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].R100, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].R100 }),
        focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].R100, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].R100 })
      },
      color: {
        default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N0, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N0 }),
        disabled: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N70, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].DN30 }),
        selected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N0, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N0 }),
        focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N0, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N0 })
      }
    },

    // Help appearance
    help: {
      background: {
        default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].P400, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].P400 }),
        hover: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].P200, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].P200 }),
        active: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].P500, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].P500 }),
        disabled: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N20A, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].DN70 }),
        selected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].R500, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].R500 }),
        focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].R500, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].R500 })
      },
      boxShadowColor: {
        focus: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].P100, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].P100 }),
        focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].P100, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].P100 })
      },
      color: {
        default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N0, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N0 }),
        disabled: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N70, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].DN30 }),
        selected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N0, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N0 }),
        focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N0, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N0 })
      }
    },

    // Link appearance
    link: {
      background: {
        default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: 'none', dark: 'none' }),
        selected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N700, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N20 }),
        focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N700, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N20 })
      },
      boxShadowColor: {
        focus: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: hex2rgba(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].B200, 0.6), dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].B75 }),
        focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({
          light: hex2rgba(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].B200, 0.6),
          dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].B75
        })
      },
      color: {
        default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].B400, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].B100 }),
        hover: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].B300, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].B75 }),
        active: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].B500, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].B200 }),
        disabled: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N70, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].DN100 }),
        selected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N20, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N700 }),
        focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N20, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N700 })
      },
      textDecoration: {
        hover: 'underline'
      }
    },

    // Subtle appearance
    subtle: {
      background: {
        default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: 'none', dark: 'none' }),
        hover: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N30A, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].DN60 }),
        active: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: hex2rgba(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].B75, 0.6), dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].B75 }),
        disabled: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: 'none', dark: 'none' }),
        selected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N700, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].DN0 }),
        focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N700, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].DN0 })
      },
      boxShadowColor: {
        focus: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: hex2rgba(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].B200, 0.6), dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].B75 }),
        focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({
          light: hex2rgba(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].B200, 0.6),
          dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].B75
        })
      },
      color: {
        default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N400, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].DN400 }),
        active: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].B400, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].B400 }),
        disabled: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N70, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].DN100 }),
        selected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N20, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].DN400 }),
        focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N20, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].DN400 })
      }
    },

    // Subtle Link appearance
    'subtle-link': {
      background: {
        default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: 'none', dark: 'none' }),
        selected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N700, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N20 }),
        focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N700, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N20 })
      },
      boxShadowColor: {
        focus: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: hex2rgba(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].B200, 0.6), dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].B75 }),
        focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({
          light: hex2rgba(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].B200, 0.6),
          dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].B75
        })
      },
      color: {
        default: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N200, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].DN400 }),
        hover: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N90, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].B50 }),
        active: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N400, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].DN300 }),
        disabled: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N70, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].DN100 }),
        selected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N20, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].DN400 }),
        focusSelected: Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N20, dark: __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].DN400 })
      },
      textDecoration: {
        hover: 'underline'
      }
    }
  }
});

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(250);


/* eslint-disable react/prop-types */



/* eslint-disable react/no-unused-prop-types */


var getAlignment = function getAlignment(p) {
  return p.followsIcon ? 'baseline' : 'center';
};
var gridSizeDiv2 = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["e" /* math */].divide(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */], 2);
var getMargin = function getMargin(p) {
  return p.spacing === 'none' ? 0 : '0 ' + gridSizeDiv2(p) + 'px';
};

var ButtonContent = function ButtonContent(props) {
  var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    alignItems: getAlignment(props),
    alignSelf: getAlignment(props),
    flex: '1 1 auto',
    margin: getMargin(props),
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }, Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* getLoadingStyle */])(props));
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'span',
    { style: style },
    props.children
  );
};

/* harmony default export */ __webpack_exports__["a"] = (ButtonContent);

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);



var ButtonWrapper = function ButtonWrapper(props) {
  var style = {
    alignSelf: 'center',
    display: 'inline-flex',
    flexWrap: 'nowrap',
    maxWidth: '100%',
    position: 'relative'
  };
  if (props.fit) {
    style.width = '100%';
    style.justifyContent = 'center';
  }

  var optionalProps = {};
  if (props.onClick) {
    optionalProps.onClick = props.onClick;
  }
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'span',
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ style: style }, optionalProps),
    props.children
  );
};

/* harmony default export */ __webpack_exports__["a"] = (ButtonWrapper);

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(250);


/* eslint-disable react/no-unused-prop-types */





var getMargin = function getMargin(props) {
  if (props.spacing === 'none') return 0;
  if (props.isOnlyChild) return '0 -' + __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["e" /* math */].divide(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */], 4)(props) + 'px';
  return '0 ' + __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["e" /* math */].divide(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */], 2)(props) + 'px';
};

var IconWrapper = function IconWrapper(props) {
  var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    alignSelf: 'center',
    display: 'flex',
    flexShrink: 0,
    lineHeight: 0,
    fontSize: 0,
    margin: getMargin(props),
    userSelect: 'none'
  }, Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* getLoadingStyle */])(props));
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'span',
    { style: style },
    props.children
  );
};

/* harmony default export */ __webpack_exports__["a"] = (IconWrapper);

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__atlaskit_spinner__ = __webpack_require__(251);







var _templateObject = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n'], ['\n  display: flex;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n']);





var LoadingDiv = __WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject);

var LoadingSpinner = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(LoadingSpinner, _Component);

  function LoadingSpinner() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LoadingSpinner);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = LoadingSpinner.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(LoadingSpinner)).call.apply(_ref, [this].concat(args))), _this), _this.invertSpinner = function () {
      var _this$props = _this.props,
          appearance = _this$props.appearance,
          isSelected = _this$props.isSelected,
          isDisabled = _this$props.isDisabled;

      if (isSelected) return true;else if (isDisabled) return false;else if (appearance === 'primary' || appearance === 'danger') return true;
      return false;
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(LoadingSpinner, [{
    key: 'render',
    value: function render() {
      var spacing = this.props.spacing;

      var spinnerSize = 'medium';
      if (spacing !== 'default') {
        spinnerSize = 'small';
      }
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        LoadingDiv,
        { spacing: this.props.spacing },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__atlaskit_spinner__["a" /* default */], { size: spinnerSize, invertColor: this.invertSpinner() })
      );
    }
  }]);

  return LoadingSpinner;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (LoadingSpinner);

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_transition_group__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styledContainer__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styledSvg__ = __webpack_require__(547);







var _templateObject = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: inline-block;\n  vertical-align: middle;\n'], ['\n  display: inline-block;\n  vertical-align: middle;\n']);










var Outer = __WEBPACK_IMPORTED_MODULE_8_styled_components__["default"].div(_templateObject);
Outer.displayName = 'Outer';

var Spinner = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Spinner, _Component);

  function Spinner(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Spinner);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Spinner.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Spinner)).call(this, props));

    _this.enter = function () {
      var delay = _this.props.delay;

      if (delay) {
        _this.setState({ phase: 'DELAY' });
      } else {
        _this.setState({ phase: 'ENTER' });
      }
    };

    _this.idle = function () {
      _this.setState({ phase: 'IDLE' });
    };

    _this.exit = function () {
      _this.setState({ phase: 'LEAVE' });
    };

    _this.endListener = function (node, done) {
      var executeCallback = function executeCallback(event) {
        // ignore animation events on the glyph
        // $FlowFixMe - tagName does not exist in event.target
        if (event.target.tagName === 'svg') {
          return false;
        }
        if (_this.state.phase === 'DELAY') {
          _this.setState({ phase: 'ENTER' });
          _this.endListener(node, done);
        } else {
          done();
        }
        return node && node.removeEventListener('animationend', executeCallback);
      };
      return node && node.addEventListener('animationend', executeCallback);
    };

    _this.validateSize = function () {
      var size = _this.props.size;

      var spinnerSize = __WEBPACK_IMPORTED_MODULE_9__constants__["b" /* SIZES_MAP */][size] || size;
      return typeof spinnerSize === 'number' ? spinnerSize : __WEBPACK_IMPORTED_MODULE_9__constants__["a" /* DEFAULT_SIZE */];
    };

    _this.state = {
      phase: ''
    };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Spinner, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var phase = this.state.phase;
      var _props = this.props,
          delay = _props.delay,
          invertColor = _props.invertColor,
          isCompleting = _props.isCompleting;

      var size = this.validateSize();

      var strokeWidth = Math.round(size / 10);
      var strokeRadius = size / 2 - strokeWidth / 2;
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        Outer,
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_transition_group__["Transition"],
          {
            addEndListener: this.endListener,
            appear: true,
            'in': !isCompleting,
            mountOnEnter: true,
            unmountOnExit: true,
            onEnter: this.enter,
            onEntered: this.idle,
            onExit: this.exit,
            onExited: function onExited() {
              return _this2.props.onComplete();
            },
            ref: function ref(node) {
              _this2.transitionNode = node;
            }
          },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10__styledContainer__["a" /* default */],
            { delay: delay / 1000, phase: phase, size: size },
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11__styledSvg__["a" /* default */],
              {
                focusable: 'false',
                height: size,
                invertColor: invertColor,
                phase: phase,
                size: size,
                viewBox: '0 0 ' + size + ' ' + size,
                width: size,
                xmlns: 'http://www.w3.org/2000/svg'
              },
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('circle', { cx: size / 2, cy: size / 2, r: strokeRadius })
            )
          )
        )
      );
    }
  }]);

  return Spinner;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

Spinner.defaultProps = {
  delay: 100,
  isCompleting: false,
  invertColor: false,
  onComplete: function onComplete() {},
  size: 'medium'
};
/* harmony default export */ __webpack_exports__["a"] = (Spinner);

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getContainerAnimation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    from { opacity: 0; }\n    to { opacity: 0; }\n  '], ['\n    from { opacity: 0; }\n    to { opacity: 0; }\n  ']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    from { transform: rotate(50deg); }\n    to { transform: rotate(230deg); }\n  '], ['\n    from { transform: rotate(50deg); }\n    to { transform: rotate(230deg); }\n  ']),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    from { transform: rotate(230deg); }\n    to { transform: rotate(510deg); }\n  '], ['\n    from { transform: rotate(230deg); }\n    to { transform: rotate(510deg); }\n  ']),
    _templateObject4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    from { opacity: 1; }\n    to { opacity: 0; }\n  '], ['\n    from { opacity: 1; }\n    to { opacity: 0; }\n  ']),
    _templateObject5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' display: flex;\n  height: ', ';\n  width: ', ';\n\n  /* Rapidly creating and removing spinners will result in multiple spinners being visible while\n   * they complete their exit animations. This rules hides the spinner if another one has been\n   * added. */\n  div + & {\n    display: none;\n  }\n'], ['\n  ', ' display: flex;\n  height: ', ';\n  width: ', ';\n\n  /* Rapidly creating and removing spinners will result in multiple spinners being visible while\n   * they complete their exit animations. This rules hides the spinner if another one has been\n   * added. */\n  div + & {\n    display: none;\n  }\n']);




/* Define keyframes statically to prevent a perfomance issue in styled components v1 where the keyframes function
 * does not cache previous values resulting in each spinner injecting the same keyframe definition
 * in the DOM.
 * This can be reverted to use dynamic keyframes when we upgrade to styled components v2
 */
var keyframeNames = {
  noop: Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["keyframes"])(_templateObject),
  enterRotate: Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["keyframes"])(_templateObject2),
  leaveRotate: Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["keyframes"])(_templateObject3),
  leaveOpacity: Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["keyframes"])(_templateObject4)
};

var getContainerAnimation = function getContainerAnimation(_ref) {
  var delay = _ref.delay,
      phase = _ref.phase;

  if (phase === 'DELAY') {
    /* This hides the spinner and allows us to use animationend events to move to the next phase in
     * the same way we do with the other lifecycle stages */
    return 'animation: ' + delay + 's ' + keyframeNames.noop + ';';
  }

  if (phase === 'ENTER' || phase === 'IDLE') {
    return 'animation: 1s ease-in-out forwards ' + keyframeNames.enterRotate + ';';
  }

  if (phase === 'LEAVE') {
    return 'animation: 0.53s ease-in-out forwards ' + keyframeNames.leaveRotate + ',\n      0.2s ease-in-out 0.33s ' + keyframeNames.leaveOpacity + ';';
  }

  return '';
};

var getSize = function getSize(_ref2) {
  var size = _ref2.size;
  return size + 'px';
};

var Container = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject5, getContainerAnimation, getSize, getSize);
Container.displayName = 'SpinnerContainer';
/* harmony default export */ __webpack_exports__["a"] = (Container);

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getStrokeColor */
/* unused harmony export svgStyles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(252);




var _templateObject = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    from { opacity: 0; }\n    to { opacity: 0; }\n  '], ['\n    from { opacity: 0; }\n    to { opacity: 0; }\n  ']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    to { transform: rotate(360deg); }\n  '], ['\n    to { transform: rotate(360deg); }\n  ']),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    from { opacity: 0; }\n    to { opacity: 1; }\n  '], ['\n    from { opacity: 0; }\n    to { opacity: 1; }\n  ']),
    _templateObject4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    from { stroke-dashoffset: ', 'px; }\n    to { stroke-dashoffset: ', 'px; }\n  '], ['\n    from { stroke-dashoffset: ', 'px; }\n    to { stroke-dashoffset: ', 'px; }\n  ']),
    _templateObject5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ';\n'], ['\n  ', ';\n']),
    _templateObject6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n      animation: ', ';\n      fill: none;\n      stroke: ', ';\n      stroke-dasharray: ', 'px;\n      stroke-dashoffset: ', 'px;\n      stroke-linecap: round;\n      stroke-width: ', 'px;\n      transform-origin: center;\n    '], ['\n      animation: ', ';\n      fill: none;\n      stroke: ', ';\n      stroke-dasharray: ', 'px;\n      stroke-dashoffset: ', 'px;\n      stroke-linecap: round;\n      stroke-width: ', 'px;\n      transform-origin: center;\n    ']);






var getStrokeWidth = function getStrokeWidth(size) {
  return Math.round(size / 10);
};

var getStrokeCircumference = function getStrokeCircumference(size) {
  var strokeWidth = getStrokeWidth(size);
  var strokeRadius = size / 2 - strokeWidth / 2;
  return Math.PI * strokeRadius * 2;
};

/* Define keyframes statically to prevent a perfomance issue in styled components v1 where the keyframes function
 * does not cache previous values resulting in each spinner injecting the same keyframe definition
 * in the DOM.
 * This can be reverted to dynamic keyframes when we upgrade to styled components v2
 */
var keyframeNames = {
  noop: Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["keyframes"])(_templateObject),
  rotate: Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["keyframes"])(_templateObject2),
  enterOpacity: Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["keyframes"])(_templateObject3),
  smallEnterStroke: Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["keyframes"])(_templateObject4, getStrokeCircumference(__WEBPACK_IMPORTED_MODULE_5__constants__["b" /* SIZES_MAP */].small), getStrokeCircumference(__WEBPACK_IMPORTED_MODULE_5__constants__["b" /* SIZES_MAP */].small) * 0.8),
  mediumEnterStroke: Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["keyframes"])(_templateObject4, getStrokeCircumference(__WEBPACK_IMPORTED_MODULE_5__constants__["b" /* SIZES_MAP */].medium), getStrokeCircumference(__WEBPACK_IMPORTED_MODULE_5__constants__["b" /* SIZES_MAP */].medium) * 0.8),
  largeEnterStroke: Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["keyframes"])(_templateObject4, getStrokeCircumference(__WEBPACK_IMPORTED_MODULE_5__constants__["b" /* SIZES_MAP */].large), getStrokeCircumference(__WEBPACK_IMPORTED_MODULE_5__constants__["b" /* SIZES_MAP */].large) * 0.8),
  xlargeEnterStroke: Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["keyframes"])(_templateObject4, getStrokeCircumference(__WEBPACK_IMPORTED_MODULE_5__constants__["b" /* SIZES_MAP */].xlarge), getStrokeCircumference(__WEBPACK_IMPORTED_MODULE_5__constants__["b" /* SIZES_MAP */].xlarge) * 0.8)
};

/* If a standard size is used, we can use one of our statically defined keyframes, otherwise
 * we're forced to dynamically create the keyframe and incur a performance cost.
 */
var getEnterStrokeKeyframe = function getEnterStrokeKeyframe(size) {
  var standardSizeName = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_5__constants__["b" /* SIZES_MAP */]).find(function (sizeName) {
    return size === __WEBPACK_IMPORTED_MODULE_5__constants__["b" /* SIZES_MAP */][sizeName];
  });
  if (standardSizeName) {
    return keyframeNames[standardSizeName + 'EnterStroke'];
  }

  var circumference = getStrokeCircumference(size);
  return Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["keyframes"])(_templateObject4, circumference, circumference * 0.8);
};

var spinnerColor = Object(__WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["d" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["a" /* colors */].N500, dark: __WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["a" /* colors */].N0 });
var spinnerColorInverted = Object(__WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["d" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["a" /* colors */].N0, dark: __WEBPACK_IMPORTED_MODULE_4__atlaskit_theme__["a" /* colors */].N0 });

var getStrokeColor = function getStrokeColor(_ref
// $FlowFixMe - theme is not found in props
) {
  var invertColor = _ref.invertColor,
      props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['invertColor']);

  return invertColor ? spinnerColorInverted(props) : spinnerColor(props);
};


var svgStyles = Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["css"])(_templateObject5, function (props) {
  var circumference = getStrokeCircumference(props.size);

  var idleRotation = '0.86s cubic-bezier(0.4, 0.15, 0.6, 0.85) infinite ' + keyframeNames.rotate;

  var spinUpStroke = '0.8s ease-in-out ' + getEnterStrokeKeyframe(props.size);

  var spinUpOpacity = '0.2s ease-in-out ' + keyframeNames.enterOpacity;

  var activeAnimations = [idleRotation];
  if (props.phase === 'ENTER') {
    activeAnimations.push(spinUpStroke, spinUpOpacity);
  }

  return Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["css"])(_templateObject6, activeAnimations.join(', '), getStrokeColor, circumference, circumference * 0.8, getStrokeWidth(props.size));
});

var Svg = __WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].svg(_templateObject5, svgStyles);
Svg.displayName = 'SpinnerSvg';
/* harmony default export */ __webpack_exports__["a"] = (Svg);

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export e100 */
/* unused harmony export e200 */
/* unused harmony export e300 */
/* unused harmony export e400 */
/* unused harmony export e500 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_themed__ = __webpack_require__(156);



// Cards on a board
var e100 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 1px 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px 0 ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 1px 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

// Inline dialogs
var e200 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 4px 8px -2px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 4px 8px -2px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

// Modals
var e300 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 8px 16px -4px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 8px 16px -4px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

// Panels
var e400 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 12px 24px -6px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 12px 24px -6px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

// Flag messages (notifications)
var e500 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 20px 32px -8px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 20px 32px -8px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export h900 */
/* unused harmony export h800 */
/* unused harmony export h700 */
/* unused harmony export h600 */
/* unused harmony export h500 */
/* unused harmony export h400 */
/* unused harmony export h300 */
/* unused harmony export h200 */
/* unused harmony export h100 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__colors__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index__ = __webpack_require__(253);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 500;\n  letter-spacing: -0.01em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 500;\n  letter-spacing: -0.01em;\n  margin-top: ', 'px;\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  margin-top: ', 'px;\n']),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 500;\n  letter-spacing: -0.008em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 500;\n  letter-spacing: -0.008em;\n  margin-top: ', 'px;\n']),
    _templateObject4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.006em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.006em;\n  margin-top: ', 'px;\n']),
    _templateObject5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.003em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.003em;\n  margin-top: ', 'px;\n']),
    _templateObject6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  margin-top: ', 'px;\n  text-transform: uppercase;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  margin-top: ', 'px;\n  text-transform: uppercase;\n']),
    _templateObject7 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  margin-top: ', 'px;\n']),
    _templateObject8 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: normal;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: normal;\n  margin-top: ', 'px;\n']);






var baseHeading = function baseHeading(size, lineHeight) {
  return '\n  font-size: ' + size / Object(__WEBPACK_IMPORTED_MODULE_3__index__["b" /* fontSize */])() + 'em;\n  font-style: inherit;\n  line-height: ' + lineHeight / size + ';\n';
};

var h900 = function h900() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject, baseHeading(35, 40), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["c" /* gridSize */])() * 6.5);
};

var h800 = function h800() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject2, baseHeading(29, 32), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["c" /* gridSize */])() * 5);
};

var h700 = function h700() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject, baseHeading(24, 28), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["c" /* gridSize */])() * 5);
};

var h600 = function h600() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject3, baseHeading(20, 24), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["c" /* gridSize */])() * 3.5);
};

var h500 = function h500() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject4, baseHeading(16, 20), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["c" /* gridSize */])() * 3);
};

var h400 = function h400() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject5, baseHeading(14, 16), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["c" /* gridSize */])() * 2);
};

var h300 = function h300() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject6, baseHeading(12, 16), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["c" /* gridSize */])() * 2.5);
};

var h200 = function h200() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject7, baseHeading(12, 16), __WEBPACK_IMPORTED_MODULE_2__colors__["subtleHeading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["c" /* gridSize */])() * 2);
};

var h100 = function h100() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject8, baseHeading(12, 16), __WEBPACK_IMPORTED_MODULE_2__colors__["subtleHeading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["c" /* gridSize */])() * 2);
};

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export add */
/* unused harmony export subtract */
/* unused harmony export multiply */
/* unused harmony export divide */
function add(fn, addend) {
  return function (props) {
    return fn(props) + addend;
  };
}

function subtract(fn, subtrahend) {
  return function (props) {
    return fn(props) - subtrahend;
  };
}

function multiply(fn, factor) {
  return function (props) {
    return fn(props) * factor;
  };
}

function divide(fn, divisor) {
  return function (props) {
    return fn(props) / divisor;
  };
}

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__colors__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Context__ = __webpack_require__(89);








var _templateObject = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  background-color: ', ';\n  color: ', ';\n\n  a {\n    color: ', ';\n  }\n  a:hover {\n    color: ', ';\n  }\n  a:active {\n    color: ', ';\n  }\n  a:focus {\n    outline-color: ', ';\n  }\n  h1 {\n    color: ', ';\n  }\n  h2 {\n    color: ', ';\n  }\n  h3 {\n    color: ', ';\n  }\n  h4 {\n    color: ', ';\n  }\n  h5 {\n    color: ', ';\n  }\n  h6 {\n    color: ', ';\n  }\n  small {\n    color: ', ';\n  }\n'], ['\n  background-color: ', ';\n  color: ', ';\n\n  a {\n    color: ', ';\n  }\n  a:hover {\n    color: ', ';\n  }\n  a:active {\n    color: ', ';\n  }\n  a:focus {\n    outline-color: ', ';\n  }\n  h1 {\n    color: ', ';\n  }\n  h2 {\n    color: ', ';\n  }\n  h3 {\n    color: ', ';\n  }\n  h4 {\n    color: ', ';\n  }\n  h5 {\n    color: ', ';\n  }\n  h6 {\n    color: ', ';\n  }\n  small {\n    color: ', ';\n  }\n']);









// For forward-compat until everything is upgraded.


function getStylesheetResetCSS(state) {
  var backgroundColor = __WEBPACK_IMPORTED_MODULE_10__colors__["background"](state);
  return '\n    body { background: ' + backgroundColor + '; }\n  ';
}

function buildThemeState(mode) {
  return { theme: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_11__constants__["a" /* CHANNEL */], { mode: mode }) };
}

var LegacyReset = __WEBPACK_IMPORTED_MODULE_9_styled_components__["default"].div(_templateObject, __WEBPACK_IMPORTED_MODULE_10__colors__["background"], __WEBPACK_IMPORTED_MODULE_10__colors__["text"], __WEBPACK_IMPORTED_MODULE_10__colors__["link"], __WEBPACK_IMPORTED_MODULE_10__colors__["linkHover"], __WEBPACK_IMPORTED_MODULE_10__colors__["linkActive"], __WEBPACK_IMPORTED_MODULE_10__colors__["linkOutline"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["subtleHeading"], __WEBPACK_IMPORTED_MODULE_10__colors__["subtleText"]);

var AtlaskitThemeProvider = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(AtlaskitThemeProvider, _Component);

  function AtlaskitThemeProvider(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AtlaskitThemeProvider);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AtlaskitThemeProvider.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(AtlaskitThemeProvider)).call(this, props));

    _this.state = buildThemeState(props.mode);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(AtlaskitThemeProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return { hasAtlaskitThemeProvider: true };
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (!this.context.hasAtlaskitThemeProvider) {
        var css = getStylesheetResetCSS(this.state);
        this.stylesheet = document.createElement('style');
        this.stylesheet.type = 'text/css';
        this.stylesheet.innerHTML = css;
        if (document && document.head) {
          document.head.appendChild(this.stylesheet);
        }
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (newProps.mode !== this.props.mode) {
        var newThemeState = buildThemeState(newProps.mode);
        if (this.stylesheet) {
          var css = getStylesheetResetCSS(newThemeState);
          this.stylesheet.innerHTML = css;
        }
        this.setState(newThemeState);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.stylesheet && document && document.head) {
        document.head.removeChild(this.stylesheet);
        delete this.stylesheet;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;

      var theme = this.state.theme;
      return (
        /* Wrapping the new provider around the old one provides forward
        compatibility when using the old provider for styled components. This
        allows us to use components converted to use the new API with consumers
        using the old provider along side components that may still be using the
        old theming API. */
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12__Context__["b" /* Provider */],
          { value: { mode: theme[__WEBPACK_IMPORTED_MODULE_11__constants__["a" /* CHANNEL */]].mode } },
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_styled_components__["ThemeProvider"],
            { theme: theme },
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
              LegacyReset,
              null,
              children
            )
          )
        )
      );
    }
  }]);

  return AtlaskitThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

AtlaskitThemeProvider.defaultProps = {
  mode: __WEBPACK_IMPORTED_MODULE_11__constants__["b" /* DEFAULT_THEME_MODE */]
};
AtlaskitThemeProvider.childContextTypes = {
  hasAtlaskitThemeProvider: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
};
AtlaskitThemeProvider.contextTypes = {
  hasAtlaskitThemeProvider: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
};
/* harmony default export */ __webpack_exports__["a"] = (AtlaskitThemeProvider);

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);





/* unused harmony default export */ var _unused_webpack_default_export = (function (_ref) {
  var children = _ref.children,
      props = _ref.props,
      theme = _ref.theme;

  var appearance = (typeof props === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(props)) === 'object' ? 'default' : props;
  var merged = (typeof props === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(props)) === 'object' ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, props) : {};
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(theme).forEach(function (key) {
    if (!(key in merged)) {
      merged[key] = theme[key]({ appearance: appearance });
    }
  });
  return children(merged);
});

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__colors__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Context__ = __webpack_require__(89);








var _templateObject = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ';\n'], ['\n  ', ';\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    background-color: ', ';\n    color: ', ';\n\n    a {\n      color: ', ';\n    }\n    a:hover {\n      color: ', ';\n    }\n    a:active {\n      color: ', ';\n    }\n    a:focus {\n      outline-color: ', ';\n    }\n    h1,\n    h2,\n    h3,\n    h4,\n    h5 {\n      color: ', ';\n    }\n    h6 {\n      color: ', ';\n    }\n    small {\n      color: ', ';\n    }\n  '], ['\n    background-color: ', ';\n    color: ', ';\n\n    a {\n      color: ', ';\n    }\n    a:hover {\n      color: ', ';\n    }\n    a:active {\n      color: ', ';\n    }\n    a:focus {\n      outline-color: ', ';\n    }\n    h1,\n    h2,\n    h3,\n    h4,\n    h5 {\n      color: ', ';\n    }\n    h6 {\n      color: ', ';\n    }\n    small {\n      color: ', ';\n    }\n  ']);






var orTextColor = function orTextColor(preferred) {
  return function (p) {
    return p[preferred] || p.textColor;
  };
};
var Div = __WEBPACK_IMPORTED_MODULE_8_styled_components__["default"].div(_templateObject, function (p) {
  return Object(__WEBPACK_IMPORTED_MODULE_8_styled_components__["css"])(_templateObject2, p.backgroundColor, p.textColor, orTextColor('linkColor'), orTextColor('linkColorHover'), orTextColor('linkColorActive'), orTextColor('linkColorOutline'), orTextColor('headingColor'), orTextColor('subtleHeadingColor'), orTextColor('subtleTextColor'));
});

var defaultTheme = {
  backgroundColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N0"],
  linkColor: __WEBPACK_IMPORTED_MODULE_9__colors__["B400"],
  linkColorHover: __WEBPACK_IMPORTED_MODULE_9__colors__["B300"],
  linkColorActive: __WEBPACK_IMPORTED_MODULE_9__colors__["B500"],
  linkColorOutline: __WEBPACK_IMPORTED_MODULE_9__colors__["B100"],
  headingColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N800"],
  subtleHeadingColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N200"],
  subtleTextColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N200"],
  textColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N900"]
};

var Reset = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Reset, _Component);

  function Reset() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Reset);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Reset.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Reset)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Reset, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10__Context__["a" /* Consumer */],
        null,
        function (theme) {
          return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            Div,
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, defaultTheme, theme, _this2.props),
            _this2.props.children
          );
        }
      );
    }
  }]);

  return Reset;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

/* unused harmony default export */ var _unused_webpack_default_export = (Reset);

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Context__ = __webpack_require__(89);








var Theme = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Theme, _Component);

  function Theme() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Theme);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Theme.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Theme)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Theme, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          values = _props.values;

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__components_Context__["a" /* Consumer */],
        null,
        function (theme) {
          var merged = values(theme);
          return typeof children === 'function' ? children(merged) : __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__components_Context__["b" /* Provider */],
            { value: merged },
            children
          );
        }
      );
    }
  }]);

  return Theme;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Theme.defaultProps = {
  values: function values(v) {
    return v;
  }
};
/* unused harmony default export */ var _unused_webpack_default_export = (Theme);

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__withDeprecationWarnings__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styled_ButtonGroup__ = __webpack_require__(556);









var ButtonGroup = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ButtonGroup, _Component);

  function ButtonGroup() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ButtonGroup);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ButtonGroup.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ButtonGroup)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ButtonGroup, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          appearance = _props.appearance,
          children = _props.children;


      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__styled_ButtonGroup__["b" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_5_react__["Children"].map(children, function (child, idx) {
          if (!child) {
            return null;
          }
          return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__styled_ButtonGroup__["a" /* GroupItem */],
            { key: idx },
            appearance ? Object(__WEBPACK_IMPORTED_MODULE_5_react__["cloneElement"])(child, { appearance: appearance }) : child
          );
        })
      );
    }
  }]);

  return ButtonGroup;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__withDeprecationWarnings__["a" /* default */])(ButtonGroup));

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GroupItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: inline-flex;\n  margin: 0 -', 'px;\n'], ['\n  display: inline-flex;\n  margin: 0 -', 'px;\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  flex: 1 0 auto;\n  margin: 0 ', 'px;\n'], ['\n  flex: 1 0 auto;\n  margin: 0 ', 'px;\n']);



var gutter = 4;

/* harmony default export */ __webpack_exports__["b"] = (__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, gutter / 2));

var GroupItem = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject2, gutter / 2);

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_error__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_error__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_icon_glyph_warning__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_icon_glyph_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__atlaskit_icon_glyph_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styled_Content__ = __webpack_require__(90);











var icon = { danger: __WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_error___default.a, warning: __WEBPACK_IMPORTED_MODULE_7__atlaskit_icon_glyph_warning___default.a };
var TitleIcon = function TitleIcon(_ref) {
  var appearance = _ref.appearance;

  if (!appearance) return null;

  var Icon = icon[appearance];

  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_8__styled_Content__["g" /* TitleIconWrapper */],
    { appearance: appearance },
    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Icon, { label: appearance + ' icon' })
  );
};

var ModalHeader = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ModalHeader, _Component);

  function ModalHeader() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ModalHeader);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ModalHeader.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ModalHeader)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ModalHeader, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          appearance = _props.appearance,
          component = _props.component,
          heading = _props.heading,
          onClose = _props.onClose,
          showKeyline = _props.showKeyline,
          isHeadingMultiline = _props.isHeadingMultiline;

      var warning = 'You can provide `component` OR `heading`, not both.';

      if (!component && !heading) return null;
      if (component && heading) return console.warn(warning); // eslint-disable-line no-console
      if (component) {
        return Object(__WEBPACK_IMPORTED_MODULE_5_react__["createElement"])(component, {
          appearance: appearance,
          onClose: onClose,
          showKeyline: showKeyline,
          isHeadingMultiline: isHeadingMultiline
        });
      }

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__styled_Content__["e" /* Header */],
        { showKeyline: showKeyline },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__styled_Content__["f" /* Title */],
          { isHeadingMultiline: isHeadingMultiline },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(TitleIcon, { appearance: appearance }),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8__styled_Content__["h" /* TitleText */],
            { isHeadingMultiline: isHeadingMultiline },
            heading
          )
        )
      );
    } // eslint-disable-line react/sort-comp

  }]);

  return ModalHeader;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

ModalHeader.defaultProps = {
  isHeadingMultiline: true
};
/* harmony default export */ __webpack_exports__["a"] = (ModalHeader);

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(15);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ErrorIcon = function ErrorIcon(props) {
  return _react2.default.createElement(_index2.default, _extends({ dangerouslySetGlyph: '<svg width="24" height="24" viewBox="0 0 24 24" focusable="false" role="presentation"><g fill-rule="evenodd"><path d="M13.416 4.417a2.002 2.002 0 0 0-2.832 0l-6.168 6.167a2.002 2.002 0 0 0 0 2.833l6.168 6.167a2.002 2.002 0 0 0 2.832 0l6.168-6.167a2.002 2.002 0 0 0 0-2.833l-6.168-6.167z" fill="currentColor"/><path d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2" fill="inherit"/></g></svg>' }, props));
};
exports.default = ErrorIcon;

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(15);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WarningIcon = function WarningIcon(props) {
  return _react2.default.createElement(_index2.default, _extends({ dangerouslySetGlyph: '<svg width="24" height="24" viewBox="0 0 24 24" focusable="false" role="presentation"><g fill-rule="evenodd"><path d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771L12.938 4.967z" fill="currentColor"/><path d="M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2" fill="inherit"/></g></svg>' }, props));
};
exports.default = WarningIcon;

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(1);







var _templateObject = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  min-height: 100%;\n  width: 100%;\n'], ['\n  display: flex;\n  flex-direction: column;\n  min-height: 100%;\n  width: 100%;\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex: 1 1 auto;\n'], ['\n  display: flex;\n  flex: 1 1 auto;\n']),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  flex: 1 0 auto;\n  transition: height 0.25s ease-in-out;\n  height: ', 'px;\n  position: relative;\n  width: 100%;\n  z-index: 3;\n'], ['\n  flex: 1 0 auto;\n  transition: height 0.25s ease-in-out;\n  height: ', 'px;\n  position: relative;\n  width: 100%;\n  z-index: 3;\n']),
    _templateObject4 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  position: fixed;\n  width: 100%;\n'], ['\n  position: fixed;\n  width: 100%;\n']),
    _templateObject5 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  position: relative;\n  z-index: 2;\n'], ['\n  position: relative;\n  z-index: 2;\n']),
    _templateObject6 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  flex: 1 1 auto;\n  position: relative;\n  z-index: 1;\n  min-width: 0;\n'], ['\n  flex: 1 1 auto;\n  position: relative;\n  z-index: 1;\n  min-width: 0;\n']);




var Wrapper = __WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject);

var NavigationAndContent = __WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject2);

var BannerContainer = __WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject3, function (props) {
  return props.isBannerOpen ? props.bannerHeight : 0;
});

var Banner = __WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject4);

var Navigation = __WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject5);

var PageContent = __WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].div(_templateObject6);

var emptyTheme = {};

var Page = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Page, _Component);

  function Page() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Page);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Page.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Page)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Page, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isBannerOpen = _props.isBannerOpen,
          banner = _props.banner,
          navigation = _props.navigation,
          children = _props.children,
          bannerHeight = _props.bannerHeight;


      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_styled_components__["ThemeProvider"],
        { theme: emptyTheme },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          Wrapper,
          null,
          this.props.banner ? __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            BannerContainer,
            {
              'aria-hidden': isBannerOpen,
              isBannerOpen: isBannerOpen,
              bannerHeight: bannerHeight
            },
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              Banner,
              null,
              banner
            )
          ) : null,
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            NavigationAndContent,
            null,
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              Navigation,
              null,
              navigation
            ),
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              PageContent,
              null,
              children
            )
          )
        )
      );
    }
  }]);

  return Page;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

Page.displayName = 'AkPage';
Page.defaultProps = {
  isBannerOpen: false,
  bannerHeight: 52
};
/* harmony default export */ __webpack_exports__["a"] = (Page);

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__internal_vars__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__internal_GridElement__ = __webpack_require__(562);






var _class, _temp2;







/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_styled_components__["withTheme"])((_temp2 = _class = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(AkGrid, _Component);

  function AkGrid() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AkGrid);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = AkGrid.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(AkGrid)).call.apply(_ref, [this].concat(args))), _this), _this.getTheme = function (props) {
      return {
        columns: props.theme && props.theme.columns ? props.theme.columns : __WEBPACK_IMPORTED_MODULE_7__internal_vars__["b" /* defaultGridColumns */],
        spacing: props.theme && props.theme.spacing ? props.theme.spacing : props.spacing,
        isNestedGrid: props.theme && props.theme.isNestedGrid ? props.theme.isNestedGrid : false
      };
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(AkGrid, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_styled_components__["ThemeProvider"],
        { theme: this.getTheme(this.props) },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__internal_GridElement__["a" /* default */],
          { spacing: this.props.spacing, layout: this.props.layout },
          this.props.children
        )
      );
    }
  }]);

  return AkGrid;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]), _class.defaultProps = {
  spacing: 'cosy',
  layout: 'fixed'
}, _temp2)));

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getMargin */
/* unused harmony export getMaxWidth */
/* unused harmony export getPadding */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vars__ = __webpack_require__(91);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  align-items: flex-start;\n  display: flex;\n  flex-wrap: wrap;\n  margin: 0 ', ';\n  max-width: ', ';\n  padding: 0 ', ';\n  position: relative;\n'], ['\n  align-items: flex-start;\n  display: flex;\n  flex-wrap: wrap;\n  margin: 0 ', ';\n  max-width: ', ';\n  padding: 0 ', ';\n  position: relative;\n']);





var getMargin = function getMargin(props) {
  return props.theme.isNestedGrid ? '-' + __WEBPACK_IMPORTED_MODULE_2__vars__["c" /* spacing */][props.theme.spacing] + 'px' : 'auto';
};
var getMaxWidth = function getMaxWidth(props) {
  return props.layout === 'fixed' ? __WEBPACK_IMPORTED_MODULE_2__vars__["a" /* defaultGridColumnWidth */] * props.theme.columns + 'px' : '100%';
};
var getPadding = function getPadding(props) {
  return __WEBPACK_IMPORTED_MODULE_2__vars__["c" /* spacing */][props.theme.spacing] / 2 + 'px';
};

var Grid = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, getMargin, getMaxWidth, getPadding);

/* harmony default export */ __webpack_exports__["a"] = (Grid);


/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__internal_vars__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__internal_GridColumnElement__ = __webpack_require__(564);






var _class, _temp2;







var defaultSpacing = 'cosy';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_styled_components__["withTheme"])((_temp2 = _class = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(AkGridColumn, _Component);

  function AkGridColumn() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AkGridColumn);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = AkGridColumn.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(AkGridColumn)).call.apply(_ref, [this].concat(args))), _this), _this.getTheme = function (props) {
      return {
        columns: props.theme && props.theme.columns ? props.theme.columns : __WEBPACK_IMPORTED_MODULE_7__internal_vars__["b" /* defaultGridColumns */],
        spacing: props.theme && props.theme.spacing ? props.theme.spacing : defaultSpacing,
        isNestedGrid: false
      };
    }, _this.getNestedTheme = function (props) {
      return {
        columns: props.medium,
        spacing: props.theme && props.theme.spacing ? props.theme.spacing : defaultSpacing,
        isNestedGrid: true
      };
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(AkGridColumn, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_styled_components__["ThemeProvider"],
        { theme: this.getTheme(this.props) },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__internal_GridColumnElement__["a" /* default */],
          { medium: this.props.medium },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_styled_components__["ThemeProvider"],
            { theme: this.getNestedTheme(this.props) },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              'div',
              null,
              this.props.children
            )
          )
        )
      );
    }
  }]);

  return AkGridColumn;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]), _class.defaultProps = {
  medium: 0
}, _temp2)));

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getColumnWidth */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vars__ = __webpack_require__(91);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  flex-grow: 1;\n  flex-shrink: 0;\n  flex-basis: ', ';\n  margin: 0 ', 'px;\n  max-width: calc(', ' - ', 'px);\n  min-width: calc(99.9999% / ', ' - ', 'px);\n  word-wrap: break-word;\n'], ['\n  flex-grow: 1;\n  flex-shrink: 0;\n  flex-basis: ', ';\n  margin: 0 ', 'px;\n  max-width: calc(', ' - ', 'px);\n  min-width: calc(99.9999% / ', ' - ', 'px);\n  word-wrap: break-word;\n']);





var getColumnRatio = function getColumnRatio(props) {
  if (props.medium === props.theme.columns) {
    return '100%';
  }
  return '99.9999% / ' + props.theme.columns + ' * ' + props.medium;
};
var getColumnWidth = function getColumnWidth(props) {
  return props.medium > 0 ? 'calc(' + getColumnRatio(props) + ' - ' + __WEBPACK_IMPORTED_MODULE_2__vars__["c" /* spacing */][props.theme.spacing] + 'px)' : 'auto';
};
var availableColumns = function availableColumns(props) {
  return props.theme.columns;
};
var specifiedColumns = function specifiedColumns(props) {
  return props.medium ? props.medium : availableColumns(props);
};
var columns = function columns(props) {
  return Math.min(availableColumns(props), specifiedColumns(props));
};
var gridSpacing = function gridSpacing(props) {
  return __WEBPACK_IMPORTED_MODULE_2__vars__["c" /* spacing */][props.theme.spacing];
};
var getMaxWidthColumnRatio = function getMaxWidthColumnRatio(props) {
  if (columns(props) >= availableColumns(props)) {
    return '100%';
  }
  return '99.9999% / ' + availableColumns(props) + ' * ' + columns(props);
};

// Unable to use the flexbox shorthand rules because Styled Components doesn't
// handle them correctly for IE11.
// Also IE11 and Edge both have rounding issues for flexbox which is why a width of
// 99.9999% is used. Using 100% here causes columns to wrap prematurely.
var GridColumn = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, getColumnWidth, function (props) {
  return __WEBPACK_IMPORTED_MODULE_2__vars__["c" /* spacing */][props.theme.spacing] / 2;
}, getMaxWidthColumnRatio, gridSpacing, availableColumns, gridSpacing);

/* harmony default export */ __webpack_exports__["a"] = (GridColumn);


/***/ }),
/* 565 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(15);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CheckCircleIcon = function CheckCircleIcon(props) {
  return _react2.default.createElement(_index2.default, _extends({ dangerouslySetGlyph: '<svg width="24" height="24" viewBox="0 0 24 24" focusable="false" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" cx="12" cy="12" r="10"/><path d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z" fill="inherit"/></g></svg>' }, props));
};
exports.default = CheckCircleIcon;

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_navigation__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_dashboard__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_dashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_settings__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_settings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_search__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_icon_glyph_add__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_icon_glyph_add___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__atlaskit_icon_glyph_add__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_jira_software__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_jira_software___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_jira_software__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__atlaskit_icon_glyph_arrow_left__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__atlaskit_icon_glyph_arrow_left___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__atlaskit_icon_glyph_arrow_left__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_CreateDrawer__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_SearchDrawer__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_HelpDropdownMenu__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_AccountDropdownMenu__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_atlaskit_png__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_atlaskit_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__images_atlaskit_png__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StarterNavigation=function(_React$Component){_inherits(StarterNavigation,_React$Component);function StarterNavigation(){var _ref;var _temp,_this,_ret;_classCallCheck(this,StarterNavigation);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=StarterNavigation.__proto__||Object.getPrototypeOf(StarterNavigation)).call.apply(_ref,[this].concat(args))),_this),_this.state={navLinks:[['/','Home',__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_dashboard___default.a],['/settings','Settings',__WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_settings___default.a]]},_this.openDrawer=function(openDrawer){_this.setState({openDrawer:openDrawer});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StarterNavigation,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextContext){return true;}},{key:'render',value:function render(){var _this2=this;var backIcon=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__atlaskit_icon_glyph_arrow_left___default.a,{label:'Back icon',size:'medium'});var globalPrimaryIcon=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_jira_software___default.a,{label:'Atlassian icon',size:'large'});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__atlaskit_navigation__["g" /* default */],{isOpen:this.context.navOpenState.isOpen,width:this.context.navOpenState.width,onResize:this.props.onNavResize,containerHeaderComponent:function containerHeaderComponent(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__atlaskit_navigation__["a" /* AkContainerTitle */],{href:'https://atlaskit.atlassian.com/',icon:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{alt:'atlaskit logo',src:__WEBPACK_IMPORTED_MODULE_14__images_atlaskit_png___default.a}),text:'Atlaskit'});},globalPrimaryIcon:globalPrimaryIcon,globalPrimaryItemHref:'/',globalSearchIcon:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_search___default.a,{label:'Search icon'}),hasBlanket:true,drawers:[__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__atlaskit_navigation__["f" /* AkSearchDrawer */],{backIcon:backIcon,isOpen:this.state.openDrawer==='search',key:'search',onBackButton:function onBackButton(){return _this2.openDrawer(null);},primaryIcon:globalPrimaryIcon},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_SearchDrawer__["a" /* default */],{onResultClicked:function onResultClicked(){return _this2.openDrawer(null);},onSearchInputRef:function onSearchInputRef(ref){_this2.searchInputRef=ref;}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__atlaskit_navigation__["b" /* AkCreateDrawer */],{backIcon:backIcon,isOpen:this.state.openDrawer==='create',key:'create',onBackButton:function onBackButton(){return _this2.openDrawer(null);},primaryIcon:globalPrimaryIcon},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_CreateDrawer__["a" /* default */],{onItemClicked:function onItemClicked(){return _this2.openDrawer(null);}}))],globalAccountItem:__WEBPACK_IMPORTED_MODULE_13__components_AccountDropdownMenu__["a" /* default */],globalCreateIcon:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__atlaskit_icon_glyph_add___default.a,{label:'Create icon'}),globalHelpItem:__WEBPACK_IMPORTED_MODULE_12__components_HelpDropdownMenu__["a" /* default */],onSearchDrawerOpen:function onSearchDrawerOpen(){return _this2.openDrawer('search');},onCreateDrawerOpen:function onCreateDrawerOpen(){return _this2.openDrawer('create');}},this.state.navLinks.map(function(link){var _link=_slicedToArray(link,3),url=_link[0],title=_link[1],Icon=_link[2];return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* Link */],{key:url,to:url},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__atlaskit_navigation__["d" /* AkNavigationItem */],{icon:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Icon,{label:title,size:'medium'}),text:title,isSelected:_this2.context.router.isActive(url,true)}));},this));}}]);return StarterNavigation;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);StarterNavigation.contextTypes={navOpenState:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,router:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (StarterNavigation);

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export e100 */
/* unused harmony export e200 */
/* unused harmony export e300 */
/* unused harmony export e400 */
/* unused harmony export e500 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_themed__ = __webpack_require__(158);



// Cards on a board
var e100 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 1px 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px 0 ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 1px 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

// Inline dialogs
var e200 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 4px 8px -2px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 4px 8px -2px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

// Modals
var e300 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 8px 16px -4px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 8px 16px -4px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

// Panels
var e400 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 12px 24px -6px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 12px 24px -6px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

// Flag messages (notifications)
var e500 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 20px 32px -8px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 20px 32px -8px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export h900 */
/* unused harmony export h800 */
/* unused harmony export h700 */
/* unused harmony export h600 */
/* unused harmony export h500 */
/* unused harmony export h400 */
/* unused harmony export h300 */
/* unused harmony export h200 */
/* unused harmony export h100 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__colors__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index__ = __webpack_require__(20);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 500;\n  letter-spacing: -0.01em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 500;\n  letter-spacing: -0.01em;\n  margin-top: ', 'px;\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  margin-top: ', 'px;\n']),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 500;\n  letter-spacing: -0.008em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 500;\n  letter-spacing: -0.008em;\n  margin-top: ', 'px;\n']),
    _templateObject4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.006em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.006em;\n  margin-top: ', 'px;\n']),
    _templateObject5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.003em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.003em;\n  margin-top: ', 'px;\n']),
    _templateObject6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  margin-top: ', 'px;\n  text-transform: uppercase;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  margin-top: ', 'px;\n  text-transform: uppercase;\n']),
    _templateObject7 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  margin-top: ', 'px;\n']),
    _templateObject8 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: normal;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: normal;\n  margin-top: ', 'px;\n']);






var baseHeading = function baseHeading(size, lineHeight) {
  return '\n  font-size: ' + size / Object(__WEBPACK_IMPORTED_MODULE_3__index__["b" /* fontSize */])() + 'em;\n  font-style: inherit;\n  line-height: ' + lineHeight / size + ';\n';
};

var h900 = function h900() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject, baseHeading(35, 40), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 6.5);
};

var h800 = function h800() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject2, baseHeading(29, 32), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 5);
};

var h700 = function h700() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject, baseHeading(24, 28), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 5);
};

var h600 = function h600() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject3, baseHeading(20, 24), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 3.5);
};

var h500 = function h500() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject4, baseHeading(16, 20), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 3);
};

var h400 = function h400() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject5, baseHeading(14, 16), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 2);
};

var h300 = function h300() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject6, baseHeading(12, 16), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 2.5);
};

var h200 = function h200() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject7, baseHeading(12, 16), __WEBPACK_IMPORTED_MODULE_2__colors__["subtleHeading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 2);
};

var h100 = function h100() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject8, baseHeading(12, 16), __WEBPACK_IMPORTED_MODULE_2__colors__["subtleHeading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 2);
};

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["add"] = add;
/* harmony export (immutable) */ __webpack_exports__["subtract"] = subtract;
/* harmony export (immutable) */ __webpack_exports__["multiply"] = multiply;
/* harmony export (immutable) */ __webpack_exports__["divide"] = divide;
function add(fn, addend) {
  return function (props) {
    return fn(props) + addend;
  };
}

function subtract(fn, subtrahend) {
  return function (props) {
    return fn(props) - subtrahend;
  };
}

function multiply(fn, factor) {
  return function (props) {
    return fn(props) * factor;
  };
}

function divide(fn, divisor) {
  return function (props) {
    return fn(props) / divisor;
  };
}

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__colors__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Context__ = __webpack_require__(93);








var _templateObject = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  background-color: ', ';\n  color: ', ';\n\n  a {\n    color: ', ';\n  }\n  a:hover {\n    color: ', ';\n  }\n  a:active {\n    color: ', ';\n  }\n  a:focus {\n    outline-color: ', ';\n  }\n  h1 {\n    color: ', ';\n  }\n  h2 {\n    color: ', ';\n  }\n  h3 {\n    color: ', ';\n  }\n  h4 {\n    color: ', ';\n  }\n  h5 {\n    color: ', ';\n  }\n  h6 {\n    color: ', ';\n  }\n  small {\n    color: ', ';\n  }\n'], ['\n  background-color: ', ';\n  color: ', ';\n\n  a {\n    color: ', ';\n  }\n  a:hover {\n    color: ', ';\n  }\n  a:active {\n    color: ', ';\n  }\n  a:focus {\n    outline-color: ', ';\n  }\n  h1 {\n    color: ', ';\n  }\n  h2 {\n    color: ', ';\n  }\n  h3 {\n    color: ', ';\n  }\n  h4 {\n    color: ', ';\n  }\n  h5 {\n    color: ', ';\n  }\n  h6 {\n    color: ', ';\n  }\n  small {\n    color: ', ';\n  }\n']);









// For forward-compat until everything is upgraded.


function getStylesheetResetCSS(state) {
  var backgroundColor = __WEBPACK_IMPORTED_MODULE_10__colors__["background"](state);
  return '\n    body { background: ' + backgroundColor + '; }\n  ';
}

function buildThemeState(mode) {
  return { theme: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_11__constants__["a" /* CHANNEL */], { mode: mode }) };
}

var LegacyReset = __WEBPACK_IMPORTED_MODULE_9_styled_components__["default"].div(_templateObject, __WEBPACK_IMPORTED_MODULE_10__colors__["background"], __WEBPACK_IMPORTED_MODULE_10__colors__["text"], __WEBPACK_IMPORTED_MODULE_10__colors__["link"], __WEBPACK_IMPORTED_MODULE_10__colors__["linkHover"], __WEBPACK_IMPORTED_MODULE_10__colors__["linkActive"], __WEBPACK_IMPORTED_MODULE_10__colors__["linkOutline"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["subtleHeading"], __WEBPACK_IMPORTED_MODULE_10__colors__["subtleText"]);

var AtlaskitThemeProvider = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(AtlaskitThemeProvider, _Component);

  function AtlaskitThemeProvider(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AtlaskitThemeProvider);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AtlaskitThemeProvider.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(AtlaskitThemeProvider)).call(this, props));

    _this.state = buildThemeState(props.mode);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(AtlaskitThemeProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return { hasAtlaskitThemeProvider: true };
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (!this.context.hasAtlaskitThemeProvider) {
        var css = getStylesheetResetCSS(this.state);
        this.stylesheet = document.createElement('style');
        this.stylesheet.type = 'text/css';
        this.stylesheet.innerHTML = css;
        if (document && document.head) {
          document.head.appendChild(this.stylesheet);
        }
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (newProps.mode !== this.props.mode) {
        var newThemeState = buildThemeState(newProps.mode);
        if (this.stylesheet) {
          var css = getStylesheetResetCSS(newThemeState);
          this.stylesheet.innerHTML = css;
        }
        this.setState(newThemeState);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.stylesheet && document && document.head) {
        document.head.removeChild(this.stylesheet);
        delete this.stylesheet;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;

      var theme = this.state.theme;
      return (
        /* Wrapping the new provider around the old one provides forward
        compatibility when using the old provider for styled components. This
        allows us to use components converted to use the new API with consumers
        using the old provider along side components that may still be using the
        old theming API. */
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12__Context__["b" /* Provider */],
          { value: { mode: theme[__WEBPACK_IMPORTED_MODULE_11__constants__["a" /* CHANNEL */]].mode } },
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_styled_components__["ThemeProvider"],
            { theme: theme },
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
              LegacyReset,
              null,
              children
            )
          )
        )
      );
    }
  }]);

  return AtlaskitThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

AtlaskitThemeProvider.defaultProps = {
  mode: __WEBPACK_IMPORTED_MODULE_11__constants__["b" /* DEFAULT_THEME_MODE */]
};
AtlaskitThemeProvider.childContextTypes = {
  hasAtlaskitThemeProvider: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
};
AtlaskitThemeProvider.contextTypes = {
  hasAtlaskitThemeProvider: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
};
/* harmony default export */ __webpack_exports__["a"] = (AtlaskitThemeProvider);

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);





/* unused harmony default export */ var _unused_webpack_default_export = (function (_ref) {
  var children = _ref.children,
      props = _ref.props,
      theme = _ref.theme;

  var appearance = (typeof props === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(props)) === 'object' ? 'default' : props;
  var merged = (typeof props === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(props)) === 'object' ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, props) : {};
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(theme).forEach(function (key) {
    if (!(key in merged)) {
      merged[key] = theme[key]({ appearance: appearance });
    }
  });
  return children(merged);
});

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__colors__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Context__ = __webpack_require__(93);








var _templateObject = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ';\n'], ['\n  ', ';\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    background-color: ', ';\n    color: ', ';\n\n    a {\n      color: ', ';\n    }\n    a:hover {\n      color: ', ';\n    }\n    a:active {\n      color: ', ';\n    }\n    a:focus {\n      outline-color: ', ';\n    }\n    h1,\n    h2,\n    h3,\n    h4,\n    h5 {\n      color: ', ';\n    }\n    h6 {\n      color: ', ';\n    }\n    small {\n      color: ', ';\n    }\n  '], ['\n    background-color: ', ';\n    color: ', ';\n\n    a {\n      color: ', ';\n    }\n    a:hover {\n      color: ', ';\n    }\n    a:active {\n      color: ', ';\n    }\n    a:focus {\n      outline-color: ', ';\n    }\n    h1,\n    h2,\n    h3,\n    h4,\n    h5 {\n      color: ', ';\n    }\n    h6 {\n      color: ', ';\n    }\n    small {\n      color: ', ';\n    }\n  ']);






var orTextColor = function orTextColor(preferred) {
  return function (p) {
    return p[preferred] || p.textColor;
  };
};
var Div = __WEBPACK_IMPORTED_MODULE_8_styled_components__["default"].div(_templateObject, function (p) {
  return Object(__WEBPACK_IMPORTED_MODULE_8_styled_components__["css"])(_templateObject2, p.backgroundColor, p.textColor, orTextColor('linkColor'), orTextColor('linkColorHover'), orTextColor('linkColorActive'), orTextColor('linkColorOutline'), orTextColor('headingColor'), orTextColor('subtleHeadingColor'), orTextColor('subtleTextColor'));
});

var defaultTheme = {
  backgroundColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N0"],
  linkColor: __WEBPACK_IMPORTED_MODULE_9__colors__["B400"],
  linkColorHover: __WEBPACK_IMPORTED_MODULE_9__colors__["B300"],
  linkColorActive: __WEBPACK_IMPORTED_MODULE_9__colors__["B500"],
  linkColorOutline: __WEBPACK_IMPORTED_MODULE_9__colors__["B100"],
  headingColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N800"],
  subtleHeadingColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N200"],
  subtleTextColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N200"],
  textColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N900"]
};

var Reset = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Reset, _Component);

  function Reset() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Reset);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Reset.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Reset)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Reset, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10__Context__["a" /* Consumer */],
        null,
        function (theme) {
          return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            Div,
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, defaultTheme, theme, _this2.props),
            _this2.props.children
          );
        }
      );
    }
  }]);

  return Reset;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

/* unused harmony default export */ var _unused_webpack_default_export = (Reset);

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Context__ = __webpack_require__(93);








var Theme = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Theme, _Component);

  function Theme() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Theme);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Theme.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Theme)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Theme, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          values = _props.values;

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__components_Context__["a" /* Consumer */],
        null,
        function (theme) {
          var merged = values(theme);
          return typeof children === 'function' ? children(merged) : __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__components_Context__["b" /* Provider */],
            { value: merged },
            children
          );
        }
      );
    }
  }]);

  return Theme;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Theme.defaultProps = {
  values: function values(v) {
    return v;
  }
};
/* unused harmony default export */ var _unused_webpack_default_export = (Theme);

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Navigation__ = __webpack_require__(576);




var NavigationWithTheme = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["withTheme"])(__WEBPACK_IMPORTED_MODULE_2__Navigation__["a" /* default */]);

var emptyTheme = {};

/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_styled_components__["ThemeProvider"],
    { theme: emptyTheme },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavigationWithTheme, props)
  );
});

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NavigationWithoutAnalytics */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_polyfills_object_assign__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_polyfills_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__atlaskit_polyfills_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_theme__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__atlaskit_analytics_next__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__package_json__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__GlobalNavigation__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ContainerNavigation__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styled_NavigationFixedContainer__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styled_NavigationGlobalNavigationWrapper__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styled_NavigationContainerNavigationWrapper__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Resizer__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Spacer__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__shared_variables__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__theme_util__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__theme_with_electron_theme__ = __webpack_require__(620);






















var warnIfCollapsedPropsAreInvalid = function warnIfCollapsedPropsAreInvalid(_ref) {
  var isCollapsible = _ref.isCollapsible,
      isOpen = _ref.isOpen;

  if (!isCollapsible && !isOpen) {
    // eslint-disable-next-line no-console
    console.warn('\n        Navigation is being told it cannot collapse and that it is not open.\n        When Navigation cannot collapse it must always be open.\n        Ignoring isOpen={true}\n      ');
  }
};

var defaultWidth = Object(__WEBPACK_IMPORTED_MODULE_17__shared_variables__["k" /* globalOpenWidth */])() + __WEBPACK_IMPORTED_MODULE_17__shared_variables__["d" /* containerOpenWidth */];

var Navigation = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Navigation, _PureComponent);

  function Navigation(props, context) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Navigation);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Navigation.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Navigation)).call(this, props, context));

    _this.getSnappedWidth = function (width) {
      // |------------------------------|
      //      |           |             |
      //    closed    breakpoint       open
      //          * snap closed
      //                       * snap open
      //                                    * maintain expanded width

      var isElectronMac = _this.props.isElectronMac;

      var resizeClosedBreakpointResult = Object(__WEBPACK_IMPORTED_MODULE_17__shared_variables__["q" /* resizeClosedBreakpoint */])(isElectronMac);

      // Snap closed if width ever goes below the resizeClosedBreakpoint
      if (width < resizeClosedBreakpointResult) {
        return Object(__WEBPACK_IMPORTED_MODULE_17__shared_variables__["k" /* globalOpenWidth */])(isElectronMac);
      }

      // Snap open if in between the closed breakpoint and the standard width
      if (width > resizeClosedBreakpointResult && width < Object(__WEBPACK_IMPORTED_MODULE_17__shared_variables__["w" /* standardOpenWidth */])(isElectronMac)) {
        return Object(__WEBPACK_IMPORTED_MODULE_17__shared_variables__["w" /* standardOpenWidth */])(isElectronMac);
      }

      // At this point the width > standard width.
      // We allow you to have your own wider width.
      return width;
    };

    _this.onResize = function (resizeDelta) {
      _this.setState({
        isResizing: true,
        resizeDelta: resizeDelta
      });
    };

    _this.onResizeEnd = function () {
      var width = _this.getRenderedWidth();
      var snappedWidth = _this.getSnappedWidth(width);

      var resizeState = {
        isOpen: snappedWidth >= Object(__WEBPACK_IMPORTED_MODULE_17__shared_variables__["w" /* standardOpenWidth */])(_this.props.isElectronMac),
        width: snappedWidth
      };

      _this.setState({
        resizeDelta: 0,
        isResizing: false
      }, function callOnResizeAfterSetState() {
        this.props.onResize(resizeState);
      });
    };

    _this.getRenderedWidth = function () {
      var _this$props = _this.props,
          isOpen = _this$props.isOpen,
          width = _this$props.width,
          isCollapsible = _this$props.isCollapsible,
          isElectronMac = _this$props.isElectronMac;

      var baselineWidth = isOpen ? width : Object(__WEBPACK_IMPORTED_MODULE_17__shared_variables__["c" /* containerClosedWidth */])(isElectronMac);
      var minWidth = isCollapsible ? Object(__WEBPACK_IMPORTED_MODULE_17__shared_variables__["c" /* containerClosedWidth */])(isElectronMac) : Object(__WEBPACK_IMPORTED_MODULE_17__shared_variables__["w" /* standardOpenWidth */])(isElectronMac);
      return Math.max(minWidth, baselineWidth + _this.state.resizeDelta);
    };

    _this.triggerResizeButtonHandler = function (resizeState) {
      if (resizeState) {
        _this.props.onResize(resizeState);
      }
    };

    _this.registerSpacerRef = function (spacerRef) {
      _this.spacerRef = spacerRef;
    };

    _this.onSpacerTransitionEnd = function (e) {
      if (!_this.spacerRef || e.target !== _this.spacerRef) {
        return;
      }
      _this.props.onToggleEnd();
    };

    var containerTheme = props.containerTheme,
        globalTheme = props.globalTheme;
    // $FlowFixMe  - theme is not found in props

    var _getTheme = Object(__WEBPACK_IMPORTED_MODULE_7__atlaskit_theme__["c" /* getTheme */])(props),
        mode = _getTheme.mode;

    _this.state = {
      containerTheme: Object(__WEBPACK_IMPORTED_MODULE_18__theme_util__["b" /* defaultContainerTheme */])(containerTheme, mode),
      globalTheme: Object(__WEBPACK_IMPORTED_MODULE_18__theme_util__["c" /* defaultGlobalTheme */])(globalTheme, mode),
      resizeDelta: 0,
      isResizing: false,
      isTogglingIsOpen: false
    };

    warnIfCollapsedPropsAreInvalid(props);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Navigation, [{
    key: 'componentDidMount',


    // It is possible that Navigation.width will not be supplied by the product, which means the
    // default width will be used, which assumes a non-Electron environment. We update the width
    // for this specific case in componentDidMount.
    value: function componentDidMount() {
      if (this.props.isElectronMac && this.props.isOpen && this.props.width === defaultWidth) {
        this.props.onResize({
          isOpen: true,
          width: Object(__WEBPACK_IMPORTED_MODULE_17__shared_variables__["k" /* globalOpenWidth */])(true) + __WEBPACK_IMPORTED_MODULE_17__shared_variables__["d" /* containerOpenWidth */]
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var containerTheme = nextProps.containerTheme,
          globalTheme = nextProps.globalTheme;
      // TODO work out why nextProps.theme.__ATLASKIT_THEME__.mode always returns the mode
      // that was applied at time of first page load.

      // $FlowFixMe - theme is not found in props

      var _getTheme2 = Object(__WEBPACK_IMPORTED_MODULE_7__atlaskit_theme__["c" /* getTheme */])(nextProps),
          mode = _getTheme2.mode;

      var isTogglingIsOpen = this.props.isOpen !== nextProps.isOpen;

      if (isTogglingIsOpen) {
        this.props.onToggleStart();
      }

      this.setState({
        containerTheme: Object(__WEBPACK_IMPORTED_MODULE_18__theme_util__["b" /* defaultContainerTheme */])(containerTheme, mode),
        globalTheme: Object(__WEBPACK_IMPORTED_MODULE_18__theme_util__["c" /* defaultGlobalTheme */])(globalTheme, mode),
        isTogglingIsOpen: isTogglingIsOpen
      });

      warnIfCollapsedPropsAreInvalid(nextProps);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          containerHeaderComponent = _props.containerHeaderComponent,
          containerScrollRef = _props.containerScrollRef,
          drawers = _props.drawers,
          globalCreateIcon = _props.globalCreateIcon,
          globalPrimaryActions = _props.globalPrimaryActions,
          globalPrimaryIcon = _props.globalPrimaryIcon,
          globalPrimaryIconAppearance = _props.globalPrimaryIconAppearance,
          globalPrimaryItemHref = _props.globalPrimaryItemHref,
          globalSearchIcon = _props.globalSearchIcon,
          globalSecondaryActions = _props.globalSecondaryActions,
          hasScrollHintTop = _props.hasScrollHintTop,
          isCollapsible = _props.isCollapsible,
          isElectronMac = _props.isElectronMac,
          isOpen = _props.isOpen,
          isResizeable = _props.isResizeable,
          linkComponent = _props.linkComponent,
          onCreateDrawerOpen = _props.onCreateDrawerOpen,
          onResizeStart = _props.onResizeStart,
          onSearchDrawerOpen = _props.onSearchDrawerOpen,
          topOffset = _props.topOffset;
      var _state = this.state,
          containerTheme = _state.containerTheme,
          globalTheme = _state.globalTheme,
          isTogglingIsOpen = _state.isTogglingIsOpen,
          isResizing = _state.isResizing;

      // if collapsed then:
      // 1. isOpen is ignored
      // 2. You cannot resize to a size smaller than the default open size

      var renderedWidth = this.getRenderedWidth();

      var globalOpenWidthResult = Object(__WEBPACK_IMPORTED_MODULE_17__shared_variables__["k" /* globalOpenWidth */])(isElectronMac);
      var containerClosedWidthResult = Object(__WEBPACK_IMPORTED_MODULE_17__shared_variables__["c" /* containerClosedWidth */])(isElectronMac);

      var isGlobalNavPartiallyCollapsed = isResizing && renderedWidth < globalOpenWidthResult + containerClosedWidthResult;

      // Cover over the global navigation when it is partially collapsed
      var containerOffsetX = isGlobalNavPartiallyCollapsed ? renderedWidth - (globalOpenWidthResult + containerClosedWidthResult) : 0;

      // always show global navigation if it is not collapsible
      var showGlobalNavigation = !isCollapsible || isOpen || isResizing;

      var containerWidth = showGlobalNavigation ? Math.max(renderedWidth - globalOpenWidthResult, containerClosedWidthResult) : containerClosedWidthResult;

      var isContainerCollapsed = !showGlobalNavigation || containerWidth === containerClosedWidthResult;
      var shouldAnimateContainer = isTogglingIsOpen && !isResizing;

      // When the navigation is not collapsible, and the width is expanded.
      // Users should be able to click the collapse button to go back to the original width
      var canCollapse = isCollapsible || containerWidth > __WEBPACK_IMPORTED_MODULE_17__shared_variables__["d" /* containerOpenWidth */];

      var globalNavigation = showGlobalNavigation ? __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_13__styled_NavigationGlobalNavigationWrapper__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__GlobalNavigation__["a" /* default */], {
          theme: globalTheme,
          primaryActions: globalPrimaryActions,
          createIcon: globalCreateIcon,
          linkComponent: linkComponent,
          onCreateActivate: onCreateDrawerOpen,
          onSearchActivate: onSearchDrawerOpen,
          primaryIcon: globalPrimaryIcon,
          primaryIconAppearance: globalPrimaryIconAppearance,
          primaryItemHref: globalPrimaryItemHref,
          searchIcon: globalSearchIcon,
          secondaryActions: globalSecondaryActions
        })
      ) : null;

      var resizer = isResizeable ? __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Resizer__["a" /* default */], {
        navigationWidth: renderedWidth,
        onResize: this.onResize,
        onResizeButton: this.triggerResizeButtonHandler,
        onResizeStart: onResizeStart,
        onResizeEnd: this.onResizeEnd,
        showResizeButton: canCollapse
      }) : null;

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_19__theme_with_electron_theme__["a" /* default */],
        { isElectronMac: isElectronMac },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_16__Spacer__["a" /* default */],
            {
              innerRef: this.registerSpacerRef,
              onTransitionEnd: this.onSpacerTransitionEnd,
              shouldAnimate: shouldAnimateContainer,
              width: renderedWidth
            },
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_12__styled_NavigationFixedContainer__["a" /* default */],
              { topOffset: topOffset },
              globalNavigation,
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_14__styled_NavigationContainerNavigationWrapper__["a" /* default */],
                {
                  horizontalOffset: containerOffsetX
                },
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_11__ContainerNavigation__["a" /* default */],
                  {
                    scrollRef: containerScrollRef,
                    theme: containerTheme,
                    showGlobalActions: !showGlobalNavigation,
                    globalCreateIcon: globalCreateIcon,
                    globalPrimaryActions: globalPrimaryActions,
                    globalPrimaryIcon: globalPrimaryIcon,
                    globalPrimaryItemHref: globalPrimaryItemHref,
                    globalSearchIcon: globalSearchIcon,
                    globalSecondaryActions: globalSecondaryActions,
                    hasScrollHintTop: hasScrollHintTop,
                    headerComponent: containerHeaderComponent,
                    linkComponent: linkComponent,
                    onGlobalCreateActivate: onCreateDrawerOpen,
                    onGlobalSearchActivate: onSearchDrawerOpen,
                    isCollapsed: isContainerCollapsed
                  },
                  children
                )
              ),
              resizer
            )
          ),
          drawers
        )
      );
    }
  }]);

  return Navigation;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

Navigation.defaultProps = {
  drawers: [],
  globalPrimaryIconAppearance: 'round',
  globalSecondaryActions: [],
  isCollapsible: true,
  isOpen: true,
  isResizeable: true,
  isElectronMac: false,
  onCreateDrawerOpen: function onCreateDrawerOpen() {},
  onResize: function onResize() {},
  onResizeStart: function onResizeStart() {},
  onSearchDrawerOpen: function onSearchDrawerOpen() {},
  onToggleEnd: function onToggleEnd() {},
  onToggleStart: function onToggleStart() {},
  topOffset: 0,
  width: defaultWidth
};



var createAndFireEventOnAtlaskit = Object(__WEBPACK_IMPORTED_MODULE_8__atlaskit_analytics_next__["b" /* createAndFireEvent */])('atlaskit');

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__atlaskit_analytics_next__["c" /* withAnalyticsContext */])({
  componentName: 'navigationSidebar',
  packageName: __WEBPACK_IMPORTED_MODULE_9__package_json__["name"],
  packageVersion: __WEBPACK_IMPORTED_MODULE_9__package_json__["version"]
})(Object(__WEBPACK_IMPORTED_MODULE_8__atlaskit_analytics_next__["d" /* withAnalyticsEvents */])({
  onResize: createAndFireEventOnAtlaskit({
    action: 'resized',
    actionSubject: 'navigationSidebar',

    attributes: {
      componentName: 'navigation',
      packageName: __WEBPACK_IMPORTED_MODULE_9__package_json__["name"],
      packageVersion: __WEBPACK_IMPORTED_MODULE_9__package_json__["version"]
    }
  }),

  onResizeStart: createAndFireEventOnAtlaskit({
    action: 'resizeStarted',
    actionSubject: 'navigationSidebar',

    attributes: {
      componentName: 'navigation',
      packageName: __WEBPACK_IMPORTED_MODULE_9__package_json__["name"],
      packageVersion: __WEBPACK_IMPORTED_MODULE_9__package_json__["version"]
    }
  })
})(Navigation)));

/***/ }),
/* 577 */
/***/ (function(module, exports) {

/* eslint-disable */
'function' != typeof Object.assign &&
  (Object.assign = function(n, t) {
    'use strict';
    if (null == n)
      throw new TypeError('Cannot convert undefined or null to object');
    for (var r = Object(n), e = 1; e < arguments.length; e++) {
      var o = arguments[e];
      if (null != o)
        for (var c in o)
          Object.prototype.hasOwnProperty.call(o, c) && (r[c] = o[c]);
    }
    return r;
  });


/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key);
});

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__atlaskit_item__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_memoize_one__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__map_navigation_theme_to_item_theme__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util__ = __webpack_require__(11);















var WithRootTheme = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(WithRootTheme, _PureComponent);

  function WithRootTheme() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, WithRootTheme);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = WithRootTheme.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(WithRootTheme)).call.apply(_ref, [this].concat(args))), _this), _this.getWithOuterTheme = Object(__WEBPACK_IMPORTED_MODULE_10_memoize_one__["a" /* default */])(function (provided, isCollapsed) {
      return function () {
        var _extends2;

        var outerTheme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var theme = {
          isCollapsed: isCollapsed || false,
          provided: provided
        };

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, outerTheme, (_extends2 = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, __WEBPACK_IMPORTED_MODULE_12__util__["l" /* rootKey */], theme), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, __WEBPACK_IMPORTED_MODULE_9__atlaskit_item__["c" /* itemThemeNamespace */], Object(__WEBPACK_IMPORTED_MODULE_11__map_navigation_theme_to_item_theme__["a" /* default */])(provided)), _extends2));
      };
    }), _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  // We want to memoize the 'withOuterTheme' function based on the props that can affect it.
  // This achieves 2 things:
  // 1. A consistent function reference is passed to the ThemeProvider, which avoids it broadcasting
  //    updates to all components using the withTheme HOC
  // 2. The function reference will change if new 'provided' or 'isCollapsed' props are provided,
  //    which will force ThemeProvider to broadcast the update


  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(WithRootTheme, [{
    key: 'render',
    value: function render() {
      var withOuterTheme = this.getWithOuterTheme(this.props.provided, this.props.isCollapsed);
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_styled_components__["ThemeProvider"],
        { theme: withOuterTheme },
        this.props.children
      );
    }
  }]);

  return WithRootTheme;
}(__WEBPACK_IMPORTED_MODULE_7_react__["PureComponent"]);

WithRootTheme.defaultProps = {
  isCollapsed: false
};
/* harmony default export */ __webpack_exports__["a"] = (WithRootTheme);

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styled_Item__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styled_ItemParts__ = __webpack_require__(589);












var Item = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Item, _Component);

  function Item(props) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Item);

    // The type of element rendered at the root of render() can vary based on the `href`
    // and `linkComponent` props provided. We generate this component here to avoid re-
    // generating the component inside render(). This is for performance reasons, and also
    // allows us to avoid generating a new `ref` for the root element each render().
    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Item.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Item)).call(this, props));

    _this.setRef = function (ref) {
      _this.ref = ref;
    };

    _this.href = function () {
      return _this.props.isDisabled ? null : _this.props.href;
    };

    _this.rootComponent = Object(__WEBPACK_IMPORTED_MODULE_8__styled_Item__["a" /* default */])({
      href: _this.href(),
      linkComponent: props.linkComponent
    });
    return _this;
  }
  // eslint-disable-next-line react/sort-comp


  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Item, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.ref && this.props.autoFocus) {
        this.ref.focus();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          onClick = _props.onClick,
          onKeyDown = _props.onKeyDown,
          isCompact = _props.isCompact,
          isDisabled = _props.isDisabled,
          isDragging = _props.isDragging,
          isHidden = _props.isHidden,
          isSelected = _props.isSelected,
          onMouseEnter = _props.onMouseEnter,
          onMouseLeave = _props.onMouseLeave,
          role = _props.role,
          dnd = _props.dnd,
          otherProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['onClick', 'onKeyDown', 'isCompact', 'isDisabled', 'isDragging', 'isHidden', 'isSelected', 'onMouseEnter', 'onMouseLeave', 'role', 'dnd']);

      var Root = this.rootComponent;

      var dragHandleProps = dnd && dnd.dragHandleProps || null;

      var patchedEventHandlers = {
        onClick: function (_onClick) {
          function onClick(_x) {
            return _onClick.apply(this, arguments);
          }

          onClick.toString = function () {
            return _onClick.toString();
          };

          return onClick;
        }(function (event) {
          var original = function original() {
            if (!isDisabled && onClick) {
              onClick(event);
            }
          };

          if (!dragHandleProps || !dragHandleProps.onClick) {
            original();
            return;
          }

          // Drag and drop has its own disabled mechansim
          // So not checking for isDisabled
          dragHandleProps.onClick(event);

          // if default is prevent - do not fire the onClick prop
          if (event.defaultPrevented) {
            return;
          }

          original();
        }),
        onMouseDown: function onMouseDown(event) {
          if (dragHandleProps && dragHandleProps.onMouseDown) {
            dragHandleProps.onMouseDown(event);
          }

          // We want to prevent the item from getting focus when clicked
          event.preventDefault();
        },
        onKeyDown: function (_onKeyDown) {
          function onKeyDown(_x2) {
            return _onKeyDown.apply(this, arguments);
          }

          onKeyDown.toString = function () {
            return _onKeyDown.toString();
          };

          return onKeyDown;
        }(function (event) {
          var original = function original() {
            if (!isDisabled && onKeyDown) {
              onKeyDown(event);
            }
          };

          if (!dragHandleProps || !dragHandleProps.onKeyDown) {
            original();
            return;
          }

          dragHandleProps.onKeyDown(event);

          // if default is prevent - do not fire other handlers
          if (event.defaultPrevented) {
            return;
          }

          // not allowing keyboard events on the element while dragging
          if (isDragging) {
            return;
          }

          original();
        })
      };

      var patchedInnerRef = function patchedInnerRef(ref) {
        _this2.setRef(ref);

        if (dnd && dnd.innerRef) {
          dnd.innerRef(ref);
        }
      };

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        Root,
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          'aria-disabled': isDisabled,
          href: this.href(),
          isCompact: isCompact,
          isDisabled: isDisabled,
          isDragging: isDragging,
          isHidden: isHidden,
          isSelected: isSelected,
          onMouseEnter: onMouseEnter,
          onMouseLeave: onMouseLeave,
          role: role,
          tabIndex: isDisabled || isHidden || this.props.href ? null : 0,
          target: this.props.target,
          title: this.props.title,
          innerRef: patchedInnerRef
        }, dnd && dnd.draggableProps, dragHandleProps, patchedEventHandlers, otherProps),
        !!this.props.elemBefore && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__styled_ItemParts__["b" /* Before */],
          { isCompact: isCompact },
          this.props.elemBefore
        ),
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__styled_ItemParts__["d" /* ContentWrapper */],
          null,
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__styled_ItemParts__["c" /* Content */],
            { allowMultiline: this.props.shouldAllowMultiline },
            this.props.children
          ),
          !!this.props.description && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__styled_ItemParts__["e" /* Description */],
            {
              isCompact: this.props.isCompact,
              isDisabled: this.props.isDisabled
            },
            this.props.description
          )
        ),
        !!this.props.elemAfter && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__styled_ItemParts__["a" /* After */],
          { isCompact: isCompact },
          this.props.elemAfter
        )
      );
    }
  }]);

  return Item;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

Item.defaultProps = {
  autoFocus: false,
  description: '',
  isCompact: false,
  isDisabled: false,
  isHidden: false,
  role: 'button',
  shouldAllowMultiline: false
};
/* harmony default export */ __webpack_exports__["a"] = (Item);

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ItemBase */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_theme__ = __webpack_require__(96);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    background-color: ', ';\n    color: ', ';\n    fill: ', ';\n    text-decoration: none;\n\n    &:focus {\n      color: ', ';\n    }\n  '], ['\n    background-color: ', ';\n    color: ', ';\n    fill: ', ';\n    text-decoration: none;\n\n    &:focus {\n      color: ', ';\n    }\n  ']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    padding: ', 'px ', 'px ', 'px ', 'px;\n  '], ['\n    padding: ', 'px ', 'px ', 'px ', 'px;\n  ']),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n        height: ', 'px;\n      '], ['\n        height: ', 'px;\n      ']),
    _templateObject4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n      ', ' box-shadow: 0 4px 8px -2px ', ',\n        0 0 1px ', ';\n    '], ['\n      ', ' box-shadow: 0 4px 8px -2px ', ',\n        0 0 1px ', ';\n    ']),
    _templateObject5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    &:focus {\n      box-shadow: 0 0 0 2px\n        ', ' inset;\n      text-decoration: none;\n    }\n  '], ['\n    &:focus {\n      box-shadow: 0 0 0 2px\n        ', ' inset;\n      text-decoration: none;\n    }\n  ']),
    _templateObject6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n      cursor: not-allowed;\n      ', ' ', ';\n    '], ['\n      cursor: not-allowed;\n      ', ' ', ';\n    ']),
    _templateObject7 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n      ', ' &:hover {\n        ', ';\n      }\n\n      &:active {\n        ', ';\n      }\n\n      ', ';\n    '], ['\n      ', ' &:hover {\n        ', ';\n      }\n\n      &:active {\n        ', ';\n      }\n\n      ', ';\n    ']),
    _templateObject8 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    &:hover {\n      ', ';\n    }\n\n    &:active {\n      ', ';\n    }\n\n    ', ';\n  '], ['\n    &:hover {\n      ', ';\n    }\n\n    &:active {\n      ', ';\n    }\n\n    ', ';\n  ']),
    _templateObject9 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  && {\n    align-items: center;\n    border-radius: ', 'px;\n    box-sizing: border-box;\n    cursor: pointer;\n    display: ', ';\n    flex: none;\n    ', ' ', ' ', ' ', ' &:focus {\n      /* focus shadow drawn by getInteractiveStyles */\n\n      outline: none;\n      /* relative position prevents bgcolor of a hovered element from\n      obfuscating focus ring of a focused sibling element */\n      position: relative;\n    }\n  }\n'], ['\n  && {\n    align-items: center;\n    border-radius: ', 'px;\n    box-sizing: border-box;\n    cursor: pointer;\n    display: ', ';\n    flex: none;\n    ', ' ', ' ', ' ', ' &:focus {\n      /* focus shadow drawn by getInteractiveStyles */\n\n      outline: none;\n      /* relative position prevents bgcolor of a hovered element from\n      obfuscating focus ring of a focused sibling element */\n      position: relative;\n    }\n  }\n']),
    _templateObject10 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n      ', ';\n    '], ['\n      ', ';\n    ']),
    _templateObject11 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    ', ';\n  '], ['\n    ', ';\n  ']);





var getItemState = function getItemState(stateName) {
  return function (_ref) {
    var theme = _ref.theme;

    var stateStyles = Object(__WEBPACK_IMPORTED_MODULE_3__util_theme__["c" /* getThemeStyle */])(theme[__WEBPACK_IMPORTED_MODULE_3__util_theme__["f" /* themeNamespace */]], stateName);
    return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject, stateStyles.background, stateStyles.text, stateStyles.background, stateStyles.text);
  };
};

var getPadding = function getPadding(_ref2) {
  var isCompact = _ref2.isCompact,
      theme = _ref2.theme,
      description = _ref2.description;

  var paddingKey = isCompact ? 'compact' : 'default';

  var _getThemeStyle = Object(__WEBPACK_IMPORTED_MODULE_3__util_theme__["c" /* getThemeStyle */])(theme[__WEBPACK_IMPORTED_MODULE_3__util_theme__["f" /* themeNamespace */]], paddingKey, 'padding'),
      _getThemeStyle$bottom = _getThemeStyle.bottom,
      bottom = _getThemeStyle$bottom === undefined ? 0 : _getThemeStyle$bottom,
      _getThemeStyle$left = _getThemeStyle.left,
      left = _getThemeStyle$left === undefined ? 0 : _getThemeStyle$left,
      _getThemeStyle$right = _getThemeStyle.right,
      right = _getThemeStyle$right === undefined ? 0 : _getThemeStyle$right,
      _getThemeStyle$top = _getThemeStyle.top,
      top = _getThemeStyle$top === undefined ? 0 : _getThemeStyle$top;

  var adjustedTop = typeof top === 'function' ? top() : top;
  var adjustedBottom = typeof bottom === 'function' ? bottom() : bottom;

  // Subtract the 1px padding-bottom added to the content and description elements
  // to maintain original height
  adjustedTop = Math.max(description ? adjustedTop - 1 : adjustedTop, 0);
  adjustedBottom = Math.max(adjustedBottom - 1, 0);

  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject2, adjustedTop, right, adjustedBottom, left);
};

var getHeightStyles = function getHeightStyles(_ref3) {
  var isCompact = _ref3.isCompact,
      theme = _ref3.theme;

  var heightKey = isCompact ? 'compact' : 'default';
  var height = Object(__WEBPACK_IMPORTED_MODULE_3__util_theme__["c" /* getThemeStyle */])(theme[__WEBPACK_IMPORTED_MODULE_3__util_theme__["f" /* themeNamespace */]], heightKey, 'height');
  return height ? Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject3, height) : '';
};

// This function is responsible for drawing any focus styles for the element
var getInteractiveStyles = function getInteractiveStyles(_ref4) {
  var theme = _ref4.theme,
      isDisabled = _ref4.isDisabled,
      isDragging = _ref4.isDragging,
      isSelected = _ref4.isSelected;

  if (isDragging) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject4, getItemState('dragging'), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].N60A, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].N60A);
  }

  var standardFocus = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject5, Object(__WEBPACK_IMPORTED_MODULE_3__util_theme__["c" /* getThemeStyle */])(theme[__WEBPACK_IMPORTED_MODULE_3__util_theme__["f" /* themeNamespace */]], 'outline', 'focus'));

  if (isDisabled) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject6, getItemState('disabled'), standardFocus);
  }

  if (isSelected) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject7, getItemState('selected'), getItemState('hover'), getItemState('active'), standardFocus);
  }

  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject8, getItemState('hover'), getItemState('active'), standardFocus);
};

// This is the main item style. It is defined as a basic style variable so it can
// later be applied to different component types (span / a / custom link component)

var ItemBase = function ItemBase(_ref5) {
  var theme = _ref5.theme;
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject9, Object(__WEBPACK_IMPORTED_MODULE_3__util_theme__["c" /* getThemeStyle */])(theme[__WEBPACK_IMPORTED_MODULE_3__util_theme__["f" /* themeNamespace */]], 'borderRadius'), function (_ref6) {
    var isHidden = _ref6.isHidden;
    return isHidden ? 'none' : 'flex';
  }, getItemState('default'), getPadding, getInteractiveStyles, getHeightStyles);
};

// Given some optional link-related props, returns the relevant styled
// component. For links, it styles the linkComponent if provided, otherwise
// falling back to a styled <a> tag. If no href is present, a styled <span>
// is returned. When we upgrade to styled-components@2.x we will be able to
// simplify this by taking advantage of the withComponent() functionality.
var styledRootElement = function styledRootElement(_ref7) {
  var href = _ref7.href,
      linkComponent = _ref7.linkComponent;

  if (linkComponent) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(linkComponent)(_templateObject10, ItemBase);
  }
  if (href) {
    return __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].a(_templateObject10, ItemBase);
  }
  return __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(_templateObject11, ItemBase);
};

/* harmony default export */ __webpack_exports__["a"] = (styledRootElement);

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export e100 */
/* unused harmony export e200 */
/* unused harmony export e300 */
/* unused harmony export e400 */
/* unused harmony export e500 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_themed__ = __webpack_require__(159);



// Cards on a board
var e100 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 1px 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px 0 ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 1px 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

// Inline dialogs
var e200 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 4px 8px -2px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 4px 8px -2px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

// Modals
var e300 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 8px 16px -4px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 8px 16px -4px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

// Panels
var e400 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 12px 24px -6px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 12px 24px -6px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

// Flag messages (notifications)
var e500 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 20px 32px -8px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 20px 32px -8px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export h900 */
/* unused harmony export h800 */
/* unused harmony export h700 */
/* unused harmony export h600 */
/* unused harmony export h500 */
/* unused harmony export h400 */
/* unused harmony export h300 */
/* unused harmony export h200 */
/* unused harmony export h100 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__colors__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index__ = __webpack_require__(94);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 500;\n  letter-spacing: -0.01em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 500;\n  letter-spacing: -0.01em;\n  margin-top: ', 'px;\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  margin-top: ', 'px;\n']),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 500;\n  letter-spacing: -0.008em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 500;\n  letter-spacing: -0.008em;\n  margin-top: ', 'px;\n']),
    _templateObject4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.006em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.006em;\n  margin-top: ', 'px;\n']),
    _templateObject5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.003em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.003em;\n  margin-top: ', 'px;\n']),
    _templateObject6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  margin-top: ', 'px;\n  text-transform: uppercase;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  margin-top: ', 'px;\n  text-transform: uppercase;\n']),
    _templateObject7 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  margin-top: ', 'px;\n']),
    _templateObject8 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: normal;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: normal;\n  margin-top: ', 'px;\n']);






var baseHeading = function baseHeading(size, lineHeight) {
  return '\n  font-size: ' + size / Object(__WEBPACK_IMPORTED_MODULE_3__index__["c" /* fontSize */])() + 'em;\n  font-style: inherit;\n  line-height: ' + lineHeight / size + ';\n';
};

var h900 = function h900() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject, baseHeading(35, 40), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 6.5);
};

var h800 = function h800() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject2, baseHeading(29, 32), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 5);
};

var h700 = function h700() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject, baseHeading(24, 28), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 5);
};

var h600 = function h600() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject3, baseHeading(20, 24), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 3.5);
};

var h500 = function h500() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject4, baseHeading(16, 20), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 3);
};

var h400 = function h400() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject5, baseHeading(14, 16), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 2);
};

var h300 = function h300() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject6, baseHeading(12, 16), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 2.5);
};

var h200 = function h200() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject7, baseHeading(12, 16), __WEBPACK_IMPORTED_MODULE_2__colors__["subtleHeading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 2);
};

var h100 = function h100() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject8, baseHeading(12, 16), __WEBPACK_IMPORTED_MODULE_2__colors__["subtleHeading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 2);
};

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export add */
/* unused harmony export subtract */
/* unused harmony export multiply */
/* unused harmony export divide */
function add(fn, addend) {
  return function (props) {
    return fn(props) + addend;
  };
}

function subtract(fn, subtrahend) {
  return function (props) {
    return fn(props) - subtrahend;
  };
}

function multiply(fn, factor) {
  return function (props) {
    return fn(props) * factor;
  };
}

function divide(fn, divisor) {
  return function (props) {
    return fn(props) / divisor;
  };
}

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__colors__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Context__ = __webpack_require__(95);








var _templateObject = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  background-color: ', ';\n  color: ', ';\n\n  a {\n    color: ', ';\n  }\n  a:hover {\n    color: ', ';\n  }\n  a:active {\n    color: ', ';\n  }\n  a:focus {\n    outline-color: ', ';\n  }\n  h1 {\n    color: ', ';\n  }\n  h2 {\n    color: ', ';\n  }\n  h3 {\n    color: ', ';\n  }\n  h4 {\n    color: ', ';\n  }\n  h5 {\n    color: ', ';\n  }\n  h6 {\n    color: ', ';\n  }\n  small {\n    color: ', ';\n  }\n'], ['\n  background-color: ', ';\n  color: ', ';\n\n  a {\n    color: ', ';\n  }\n  a:hover {\n    color: ', ';\n  }\n  a:active {\n    color: ', ';\n  }\n  a:focus {\n    outline-color: ', ';\n  }\n  h1 {\n    color: ', ';\n  }\n  h2 {\n    color: ', ';\n  }\n  h3 {\n    color: ', ';\n  }\n  h4 {\n    color: ', ';\n  }\n  h5 {\n    color: ', ';\n  }\n  h6 {\n    color: ', ';\n  }\n  small {\n    color: ', ';\n  }\n']);









// For forward-compat until everything is upgraded.


function getStylesheetResetCSS(state) {
  var backgroundColor = __WEBPACK_IMPORTED_MODULE_10__colors__["background"](state);
  return '\n    body { background: ' + backgroundColor + '; }\n  ';
}

function buildThemeState(mode) {
  return { theme: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_11__constants__["a" /* CHANNEL */], { mode: mode }) };
}

var LegacyReset = __WEBPACK_IMPORTED_MODULE_9_styled_components__["default"].div(_templateObject, __WEBPACK_IMPORTED_MODULE_10__colors__["background"], __WEBPACK_IMPORTED_MODULE_10__colors__["text"], __WEBPACK_IMPORTED_MODULE_10__colors__["link"], __WEBPACK_IMPORTED_MODULE_10__colors__["linkHover"], __WEBPACK_IMPORTED_MODULE_10__colors__["linkActive"], __WEBPACK_IMPORTED_MODULE_10__colors__["linkOutline"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["subtleHeading"], __WEBPACK_IMPORTED_MODULE_10__colors__["subtleText"]);

var AtlaskitThemeProvider = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(AtlaskitThemeProvider, _Component);

  function AtlaskitThemeProvider(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AtlaskitThemeProvider);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AtlaskitThemeProvider.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(AtlaskitThemeProvider)).call(this, props));

    _this.state = buildThemeState(props.mode);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(AtlaskitThemeProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return { hasAtlaskitThemeProvider: true };
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (!this.context.hasAtlaskitThemeProvider) {
        var css = getStylesheetResetCSS(this.state);
        this.stylesheet = document.createElement('style');
        this.stylesheet.type = 'text/css';
        this.stylesheet.innerHTML = css;
        if (document && document.head) {
          document.head.appendChild(this.stylesheet);
        }
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (newProps.mode !== this.props.mode) {
        var newThemeState = buildThemeState(newProps.mode);
        if (this.stylesheet) {
          var css = getStylesheetResetCSS(newThemeState);
          this.stylesheet.innerHTML = css;
        }
        this.setState(newThemeState);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.stylesheet && document && document.head) {
        document.head.removeChild(this.stylesheet);
        delete this.stylesheet;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;

      var theme = this.state.theme;
      return (
        /* Wrapping the new provider around the old one provides forward
        compatibility when using the old provider for styled components. This
        allows us to use components converted to use the new API with consumers
        using the old provider along side components that may still be using the
        old theming API. */
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12__Context__["b" /* Provider */],
          { value: { mode: theme[__WEBPACK_IMPORTED_MODULE_11__constants__["a" /* CHANNEL */]].mode } },
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_styled_components__["ThemeProvider"],
            { theme: theme },
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
              LegacyReset,
              null,
              children
            )
          )
        )
      );
    }
  }]);

  return AtlaskitThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

AtlaskitThemeProvider.defaultProps = {
  mode: __WEBPACK_IMPORTED_MODULE_11__constants__["b" /* DEFAULT_THEME_MODE */]
};
AtlaskitThemeProvider.childContextTypes = {
  hasAtlaskitThemeProvider: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
};
AtlaskitThemeProvider.contextTypes = {
  hasAtlaskitThemeProvider: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
};
/* harmony default export */ __webpack_exports__["a"] = (AtlaskitThemeProvider);

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);





/* unused harmony default export */ var _unused_webpack_default_export = (function (_ref) {
  var children = _ref.children,
      props = _ref.props,
      theme = _ref.theme;

  var appearance = (typeof props === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(props)) === 'object' ? 'default' : props;
  var merged = (typeof props === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(props)) === 'object' ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, props) : {};
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(theme).forEach(function (key) {
    if (!(key in merged)) {
      merged[key] = theme[key]({ appearance: appearance });
    }
  });
  return children(merged);
});

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__colors__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Context__ = __webpack_require__(95);








var _templateObject = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ';\n'], ['\n  ', ';\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    background-color: ', ';\n    color: ', ';\n\n    a {\n      color: ', ';\n    }\n    a:hover {\n      color: ', ';\n    }\n    a:active {\n      color: ', ';\n    }\n    a:focus {\n      outline-color: ', ';\n    }\n    h1,\n    h2,\n    h3,\n    h4,\n    h5 {\n      color: ', ';\n    }\n    h6 {\n      color: ', ';\n    }\n    small {\n      color: ', ';\n    }\n  '], ['\n    background-color: ', ';\n    color: ', ';\n\n    a {\n      color: ', ';\n    }\n    a:hover {\n      color: ', ';\n    }\n    a:active {\n      color: ', ';\n    }\n    a:focus {\n      outline-color: ', ';\n    }\n    h1,\n    h2,\n    h3,\n    h4,\n    h5 {\n      color: ', ';\n    }\n    h6 {\n      color: ', ';\n    }\n    small {\n      color: ', ';\n    }\n  ']);






var orTextColor = function orTextColor(preferred) {
  return function (p) {
    return p[preferred] || p.textColor;
  };
};
var Div = __WEBPACK_IMPORTED_MODULE_8_styled_components__["default"].div(_templateObject, function (p) {
  return Object(__WEBPACK_IMPORTED_MODULE_8_styled_components__["css"])(_templateObject2, p.backgroundColor, p.textColor, orTextColor('linkColor'), orTextColor('linkColorHover'), orTextColor('linkColorActive'), orTextColor('linkColorOutline'), orTextColor('headingColor'), orTextColor('subtleHeadingColor'), orTextColor('subtleTextColor'));
});

var defaultTheme = {
  backgroundColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N0"],
  linkColor: __WEBPACK_IMPORTED_MODULE_9__colors__["B400"],
  linkColorHover: __WEBPACK_IMPORTED_MODULE_9__colors__["B300"],
  linkColorActive: __WEBPACK_IMPORTED_MODULE_9__colors__["B500"],
  linkColorOutline: __WEBPACK_IMPORTED_MODULE_9__colors__["B100"],
  headingColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N800"],
  subtleHeadingColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N200"],
  subtleTextColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N200"],
  textColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N900"]
};

var Reset = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Reset, _Component);

  function Reset() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Reset);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Reset.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Reset)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Reset, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10__Context__["a" /* Consumer */],
        null,
        function (theme) {
          return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            Div,
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, defaultTheme, theme, _this2.props),
            _this2.props.children
          );
        }
      );
    }
  }]);

  return Reset;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

/* unused harmony default export */ var _unused_webpack_default_export = (Reset);

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Context__ = __webpack_require__(95);








var Theme = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Theme, _Component);

  function Theme() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Theme);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Theme.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Theme)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Theme, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          values = _props.values;

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__components_Context__["a" /* Consumer */],
        null,
        function (theme) {
          var merged = values(theme);
          return typeof children === 'function' ? children(merged) : __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__components_Context__["b" /* Provider */],
            { value: merged },
            children
          );
        }
      );
    }
  }]);

  return Theme;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Theme.defaultProps = {
  values: function values(v) {
    return v;
  }
};
/* unused harmony default export */ var _unused_webpack_default_export = (Theme);

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InputWrapper */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Before; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return After; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ContentWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Content; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Description; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_theme__ = __webpack_require__(96);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  margin: 0 2px;\n'], ['\n  display: flex;\n  margin: 0 2px;\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  align-items: center;\n  display: flex;\n  flex-shrink: 0;\n  /* Fix windows line-height issue */\n  padding-bottom: 1px;\n'], ['\n  align-items: center;\n  display: flex;\n  flex-shrink: 0;\n  /* Fix windows line-height issue */\n  padding-bottom: 1px;\n']),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    margin-right: ', 'px;\n  '], ['\n    margin-right: ', 'px;\n  ']),
    _templateObject4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ';\n'], ['\n  ', ';\n']),
    _templateObject5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    margin-left: ', 'px;\n  '], ['\n    margin-left: ', 'px;\n  ']),
    _templateObject6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  margin: 0;\n  overflow: hidden;\n\n  &:first-child {\n    margin: 0;\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  margin: 0;\n  overflow: hidden;\n\n  &:first-child {\n    margin: 0;\n  }\n']),
    _templateObject7 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: block;\n  flex: 1 1 auto;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: ', ';\n  line-height: ', ';\n  /* Fix windows line-height issue */\n  padding-bottom: 1px;\n'], ['\n  display: block;\n  flex: 1 1 auto;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: ', ';\n  line-height: ', ';\n  /* Fix windows line-height issue */\n  padding-bottom: 1px;\n']),
    _templateObject8 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n      color: ', ';\n    '], ['\n      color: ', ';\n    ']),
    _templateObject9 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    color: ', ';\n\n    /* This detects hover on the grandparent. Saves us having to maintain isHovered\n       state in the grandparent. */\n    *:hover > * > & {\n      color: ', ';\n    }\n\n    *:active > * > & {\n      color: ', ';\n    }\n  '], ['\n    color: ', ';\n\n    /* This detects hover on the grandparent. Saves us having to maintain isHovered\n       state in the grandparent. */\n    *:hover > * > & {\n      color: ', ';\n    }\n\n    *:active > * > & {\n      color: ', ';\n    }\n  ']),
    _templateObject10 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    font-size: ', 'px;\n    line-height: ', ';\n    /* Fix windows line-height issue */\n    padding-bottom: 1px;\n  '], ['\n    font-size: ', 'px;\n    line-height: ', ';\n    /* Fix windows line-height issue */\n    padding-bottom: 1px;\n  ']),
    _templateObject11 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  flex: 1 1 auto;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  ', ' ', ';\n'], ['\n  flex: 1 1 auto;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  ', ' ', ';\n']);






// Checkbox/Radio wrapper -- sits left of the children
var InputWrapper = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].span(_templateObject);

// Elements injected before/after the children
var BeforeAfterBase = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].span(_templateObject2);

var getBeforeSpacing = function getBeforeSpacing(_ref) {
  var isCompact = _ref.isCompact,
      theme = _ref.theme;

  var spaceKey = isCompact ? 'compact' : 'default';
  var space = Object(__WEBPACK_IMPORTED_MODULE_4__util_theme__["c" /* getThemeStyle */])(theme[__WEBPACK_IMPORTED_MODULE_4__util_theme__["f" /* themeNamespace */]], spaceKey, 'beforeItemSpacing');
  return Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["css"])(_templateObject3, space);
};
var Before = Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"])(BeforeAfterBase)(_templateObject4, getBeforeSpacing);

var getAfterSpacing = function getAfterSpacing(_ref2) {
  var isCompact = _ref2.isCompact,
      theme = _ref2.theme;

  var spaceKey = isCompact ? 'compact' : 'default';
  var space = Object(__WEBPACK_IMPORTED_MODULE_4__util_theme__["c" /* getThemeStyle */])(theme[__WEBPACK_IMPORTED_MODULE_4__util_theme__["f" /* themeNamespace */]], spaceKey, 'afterItemSpacing');
  return Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["css"])(_templateObject5, space);
};
var After = Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["default"])(BeforeAfterBase)(_templateObject4, getAfterSpacing);

// Alignment and layout for the children
var ContentWrapper = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].span(_templateObject6);

var Content = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].span(_templateObject7, function (_ref3) {
  var allowMultiline = _ref3.allowMultiline;
  return allowMultiline ? 'normal' : 'nowrap';
}, 16 / Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["c" /* fontSize */])());

var getColorStyle = function getColorStyle(_ref4) {
  var isDisabled = _ref4.isDisabled,
      theme = _ref4.theme;

  if (isDisabled) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["css"])(_templateObject8, Object(__WEBPACK_IMPORTED_MODULE_4__util_theme__["c" /* getThemeStyle */])(theme[__WEBPACK_IMPORTED_MODULE_4__util_theme__["f" /* themeNamespace */]], 'secondaryText', 'disabled'));
  }

  return Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["css"])(_templateObject9, Object(__WEBPACK_IMPORTED_MODULE_4__util_theme__["c" /* getThemeStyle */])(theme[__WEBPACK_IMPORTED_MODULE_4__util_theme__["f" /* themeNamespace */]], 'secondaryText', 'default'), function () {
    return Object(__WEBPACK_IMPORTED_MODULE_4__util_theme__["c" /* getThemeStyle */])(theme[__WEBPACK_IMPORTED_MODULE_4__util_theme__["f" /* themeNamespace */]], 'secondaryText', 'hover');
  }, function () {
    return Object(__WEBPACK_IMPORTED_MODULE_4__util_theme__["c" /* getThemeStyle */])(theme[__WEBPACK_IMPORTED_MODULE_4__util_theme__["f" /* themeNamespace */]], 'secondaryText', 'active');
  });
};

var getDescriptionFontStyles = function getDescriptionFontStyles(_ref5) {
  var isCompact = _ref5.isCompact;

  var descriptionFontSize = isCompact ? __WEBPACK_IMPORTED_MODULE_4__util_theme__["b" /* compactSmallFontSize */] : __WEBPACK_IMPORTED_MODULE_4__util_theme__["e" /* smallFontSize */];
  var lineHeight = isCompact ? __WEBPACK_IMPORTED_MODULE_4__util_theme__["a" /* compactLineHeight */] : 14 / descriptionFontSize;
  return Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["css"])(_templateObject10, descriptionFontSize, lineHeight);
};

// Description is a block element below the children, like a subtitle
var Description = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].span(_templateObject11, getColorStyle, getDescriptionFontStyles);

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_addons_text_content__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_addons_text_content___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_addons_text_content__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styled_ItemGroup__ = __webpack_require__(592);










var ItemGroup = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ItemGroup, _Component);

  function ItemGroup() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ItemGroup);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ItemGroup.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ItemGroup)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ItemGroup, [{
    key: 'render',
    // eslint-disable-line react/sort-comp

    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          elemAfter = _props.elemAfter,
          isCompact = _props.isCompact,
          title = _props.title,
          label = _props.label,
          innerRef = _props.innerRef,
          role = _props.role;


      var ariaLabel = function () {
        if (label) {
          return __WEBPACK_IMPORTED_MODULE_6_react_addons_text_content___default()(label);
        }
        if (title) {
          return __WEBPACK_IMPORTED_MODULE_6_react_addons_text_content___default()(title);
        }
        return '';
      }();
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { 'aria-label': ariaLabel, role: role, ref: innerRef },
        title ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__styled_ItemGroup__["a" /* GroupTitle */],
          { 'aria-hidden': 'true', isCompact: isCompact },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__styled_ItemGroup__["c" /* GroupTitleText */],
            null,
            title
          ),
          elemAfter ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__styled_ItemGroup__["b" /* GroupTitleAfter */],
            {
              innerRef: function innerRef(r) {
                _this2.headingAfterElement = r;
              }
            },
            elemAfter
          ) : null
        ) : null,
        children
      );
    }
  }]);

  return ItemGroup;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

ItemGroup.defaultProps = {
  role: 'group'
};
/* harmony default export */ __webpack_exports__["a"] = (ItemGroup);

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function getText(rootChild) {
  var res = '';
  var rr = function rr(child) {
    if (typeof child === 'string' || typeof child === 'number') {
      res += child;
    } else if (Array.isArray(child)) {
      child.forEach(function (c) {
        return rr(c);
      });
    } else if (child && child.props) {
      var children = child.props.children;


      if (Array.isArray(children)) {
        children.forEach(function (c) {
          return rr(c);
        });
      } else {
        rr(children);
      }
    }
  };

  rr(rootChild);

  return res;
}

module.exports = getText;

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GroupTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GroupTitleAfter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GroupTitleText; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_theme__ = __webpack_require__(96);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    padding: ', 'px ', 'px ', 'px ', 'px;\n  '], ['\n    padding: ', 'px ', 'px ', 'px ', 'px;\n  ']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  align-items: center;\n  color: ', ';\n  display: flex;\n  flex: 1 1 auto;\n  ', ';\n'], ['\n  align-items: center;\n  color: ', ';\n  display: flex;\n  flex: 1 1 auto;\n  ', ';\n']),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  flex: 0 0 auto;\n  margin-right: -', 'px;\n'], ['\n  flex: 0 0 auto;\n  margin-right: -', 'px;\n']),
    _templateObject4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  flex: 1 1 auto;\n  font-size: ', 'px;\n  line-height: 1;\n  text-transform: uppercase;\n  /* Required for children to truncate */\n  min-width: 0;\n'], ['\n  flex: 1 1 auto;\n  font-size: ', 'px;\n  line-height: 1;\n  text-transform: uppercase;\n  /* Required for children to truncate */\n  min-width: 0;\n']);




var getPadding = function getPadding(_ref) {
  var isCompact = _ref.isCompact,
      theme = _ref.theme;

  var paddingType = isCompact ? 'compact' : 'default';

  var _getThemeStyle = Object(__WEBPACK_IMPORTED_MODULE_2__util_theme__["c" /* getThemeStyle */])(theme[__WEBPACK_IMPORTED_MODULE_2__util_theme__["f" /* themeNamespace */]], paddingType, 'padding'),
      _getThemeStyle$bottom = _getThemeStyle.bottom,
      bottom = _getThemeStyle$bottom === undefined ? 0 : _getThemeStyle$bottom,
      _getThemeStyle$left = _getThemeStyle.left,
      left = _getThemeStyle$left === undefined ? 0 : _getThemeStyle$left,
      _getThemeStyle$right = _getThemeStyle.right,
      right = _getThemeStyle$right === undefined ? 0 : _getThemeStyle$right,
      _getThemeStyle$top = _getThemeStyle.top,
      top = _getThemeStyle$top === undefined ? 0 : _getThemeStyle$top;

  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject, top, right, bottom, left);
};

// eslint-disable-next-line import/prefer-default-export
var GroupTitle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject2, function (_ref2) {
  var theme = _ref2.theme;
  return Object(__WEBPACK_IMPORTED_MODULE_2__util_theme__["c" /* getThemeStyle */])(theme[__WEBPACK_IMPORTED_MODULE_2__util_theme__["f" /* themeNamespace */]], 'secondaryText', 'default');
}, getPadding);
GroupTitle.displayName = 'ItemGroupTitle';

var GroupTitleAfter = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject3, __WEBPACK_IMPORTED_MODULE_2__util_theme__["d" /* gridSize */] / 2);
GroupTitleAfter.displayName = 'ItemGroupTitleAfter';

var GroupTitleText = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject4, __WEBPACK_IMPORTED_MODULE_2__util_theme__["e" /* smallFontSize */]);
GroupTitleText.displayName = 'ItemGroupTitleText';



/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_getDisplayName__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_safeContextCall__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_contextNamespace__ = __webpack_require__(270);









// We currently need to keep the dropdown open if an item with `href` is clicked, to avoid the
// analytics package to track the href value without the event target disappearing. Without this
// requirement, we could just use a native click event all the way up to DropdownMenuStateless,
// and could get rid of this HOC and DropdownItemClickManager.








// HOC that typically wraps @atlaskit/item
var withItemClick = function withItemClick(WrappedItem) {
  var _class, _temp2;

  return _temp2 = _class = function (_Component) {
    __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(WithItemClick, _Component);

    function WithItemClick() {
      var _ref;

      var _temp, _this, _ret;

      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, WithItemClick);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = WithItemClick.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(WithItemClick)).call.apply(_ref, [this].concat(args))), _this), _this.callContextFn = Object(__WEBPACK_IMPORTED_MODULE_11__util_safeContextCall__["a" /* default */])(_this, __WEBPACK_IMPORTED_MODULE_12__util_contextNamespace__["a" /* clickManagerContext */]), _this.shouldCloseAfterClick = function () {
        return !_this.props.isDisabled && !_this.props.href;
      }, _this.handleClick = function (event) {
        _this.props.onClick(event);
        if (_this.shouldCloseAfterClick()) {
          _this.callContextFn('itemClicked');
        }
      }, _this.handleKeyDown = function (event) {
        if (_this.props.onKeyDown) {
          _this.props.onKeyDown(event);
        } else if (event.key === 'Space' || event.key === 'Enter') {
          _this.handleClick(event);
        }
      }, _temp), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(WithItemClick, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            children = _props.children,
            otherProps = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['children']);

        return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
          WrappedItem,
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, otherProps, {
            onClick: this.handleClick,
            onKeyDown: this.handleKeyDown
          }),
          children
        );
      }
    }]);

    return WithItemClick;
  }(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]), _class.displayName = 'WithItemClick(' + Object(__WEBPACK_IMPORTED_MODULE_10__util_getDisplayName__["a" /* default */])(WrappedItem) + ')', _class.defaultProps = {
    onClick: function onClick() {}
  }, _class.contextTypes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_12__util_contextNamespace__["a" /* clickManagerContext */], __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object), _temp2;
};

/* harmony default export */ __webpack_exports__["a"] = (withItemClick);

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_uuid__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_getDisplayName__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_safeContextCall__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_contextNamespace__ = __webpack_require__(270);

















// HOC that typically wraps @atlaskit/item

var withItemFocus = function withItemFocus(WrappedComponent) {
  var _class, _temp2;

  return _temp2 = _class = function (_Component) {
    __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(WithItemFocus, _Component);

    function WithItemFocus() {
      var _ref;

      var _temp, _this, _ret;

      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, WithItemFocus);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = WithItemFocus.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(WithItemFocus)).call.apply(_ref, [this].concat(args))), _this), _this.callContextFn = Object(__WEBPACK_IMPORTED_MODULE_13__util_safeContextCall__["a" /* default */])(_this, __WEBPACK_IMPORTED_MODULE_14__util_contextNamespace__["b" /* focusManagerContext */]), _this.isFocusable = function () {
        return !_this.props.isDisabled && !_this.props.isHidden;
      }, _this.handleFocus = function () {
        if (_this.isFocusable()) {
          _this.callContextFn('itemFocused', _this.contextId);
        }
      }, _temp), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(WithItemFocus, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (!this.isFocusable()) {
          return;
        }

        this.contextId = __WEBPACK_IMPORTED_MODULE_11_uuid___default()();

        this.callContextFn('registerItem', this.contextId, __WEBPACK_IMPORTED_MODULE_10_react_dom___default.a.findDOMNode(this) // eslint-disable-line react/no-find-dom-node
        );
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate() {
        if (!this.isFocusable()) {
          return;
        }

        this.callContextFn('updateItem', this.contextId, __WEBPACK_IMPORTED_MODULE_10_react_dom___default.a.findDOMNode(this) // eslint-disable-line react/no-find-dom-node
        );
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.isFocusable()) {
          this.callContextFn('deregisterItem', this.contextId);
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            children = _props.children,
            otherProps = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['children']);

        return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
          WrappedComponent,
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
            onFocus: this.handleFocus,
            role: 'menuitem'
          }, otherProps),
          children
        );
      }
    }]);

    return WithItemFocus;
  }(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]), _class.displayName = 'WithItemFocus(' + Object(__WEBPACK_IMPORTED_MODULE_12__util_getDisplayName__["a" /* default */])(WrappedComponent) + ')', _class.contextTypes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_14__util_contextNamespace__["b" /* focusManagerContext */], __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object), _temp2;
};

/* harmony default export */ __webpack_exports__["a"] = (withItemFocus);

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_variables__ = __webpack_require__(10);



// Converts the top-level 'Provided' container navigation theme into the
// format the @atlaskit/item expects.

var itemThemeFromNavTheme = function itemThemeFromNavTheme(navigationTheme) {
  return {
    padding: {
      compact: {
        bottom: __WEBPACK_IMPORTED_MODULE_0__shared_variables__["n" /* gridSize */],
        left: __WEBPACK_IMPORTED_MODULE_0__shared_variables__["n" /* gridSize */],
        right: __WEBPACK_IMPORTED_MODULE_0__shared_variables__["n" /* gridSize */],
        top: __WEBPACK_IMPORTED_MODULE_0__shared_variables__["n" /* gridSize */]
      },
      default: {
        bottom: __WEBPACK_IMPORTED_MODULE_0__shared_variables__["n" /* gridSize */],
        left: __WEBPACK_IMPORTED_MODULE_0__shared_variables__["n" /* gridSize */] * 1.5,
        right: __WEBPACK_IMPORTED_MODULE_0__shared_variables__["n" /* gridSize */] * 1.5,
        top: __WEBPACK_IMPORTED_MODULE_0__shared_variables__["n" /* gridSize */]
      }
    },
    borderRadius: 3,
    height: {
      compact: __WEBPACK_IMPORTED_MODULE_0__shared_variables__["n" /* gridSize */] * 4.5,
      default: __WEBPACK_IMPORTED_MODULE_0__shared_variables__["n" /* gridSize */] * 5
    },
    beforeItemSpacing: {
      compact: __WEBPACK_IMPORTED_MODULE_0__shared_variables__["n" /* gridSize */],
      default: __WEBPACK_IMPORTED_MODULE_0__shared_variables__["n" /* gridSize */] * 2
    },
    default: {
      background: navigationTheme.item.default.background,
      text: navigationTheme.text,
      secondaryText: navigationTheme.subText
    },
    hover: {
      background: navigationTheme.item.hover.background,
      text: navigationTheme.text,
      secondaryText: navigationTheme.subText
    },
    active: {
      background: navigationTheme.item.active.background,
      text: navigationTheme.item.active.text || navigationTheme.text,
      secondaryText: navigationTheme.subText
    },
    selected: {
      background: navigationTheme.item.selected.background,
      text: navigationTheme.item.selected.text || '',
      secondaryText: navigationTheme.subText
    },
    focus: {
      outline: navigationTheme.item.focus.outline
    },
    dragging: {
      background: navigationTheme.item.dragging.background
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (itemThemeFromNavTheme);

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

!function(root, factory) {
     true ? module.exports = factory(__webpack_require__(45), __webpack_require__(13), __webpack_require__(17)) : "function" == typeof define && define.amd ? define([ "babel-runtime/core-js/object/assign", "babel-runtime/core-js/object/keys", "babel-runtime/helpers/typeof" ], factory) : "object" == typeof exports ? exports["@atlaskit/utilSharedStyles"] = factory(require("babel-runtime/core-js/object/assign"), require("babel-runtime/core-js/object/keys"), require("babel-runtime/helpers/typeof")) : root["@atlaskit/utilSharedStyles"] = factory(root["babel-runtime/core-js/object/assign"], root["babel-runtime/core-js/object/keys"], root["babel-runtime/helpers/typeof"]);
}(this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_6__) {
    /******/
    return function(modules) {
        /******/
        /******/
        // The require function
        /******/
        function __webpack_require__(moduleId) {
            /******/
            /******/
            // Check if module is in cache
            /******/
            if (installedModules[moduleId]) /******/
            return installedModules[moduleId].exports;
            /******/
            /******/
            // Create a new module (and put it into the cache)
            /******/
            var module = installedModules[moduleId] = {
                /******/
                exports: {},
                /******/
                id: moduleId,
                /******/
                loaded: !1
            };
            /******/
            /******/
            // Return the exports of the module
            /******/
            /******/
            /******/
            // Execute the module function
            /******/
            /******/
            /******/
            // Flag the module as loaded
            /******/
            return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), 
            module.loaded = !0, module.exports;
        }
        // webpackBootstrap
        /******/
        // The module cache
        /******/
        var installedModules = {};
        /******/
        /******/
        // Load entry module and return exports
        /******/
        /******/
        /******/
        /******/
        // expose the modules object (__webpack_modules__)
        /******/
        /******/
        /******/
        // expose the module cache
        /******/
        /******/
        /******/
        // __webpack_public_path__
        /******/
        return __webpack_require__.m = modules, __webpack_require__.c = installedModules, 
        __webpack_require__.p = "", __webpack_require__(0);
    }([ /* 0 */
    /***/
    function(module, exports, __webpack_require__) {
        module.exports = __webpack_require__(1);
    }, /* 1 */
    /***/
    function(module, exports, __webpack_require__) {
        "use strict";
        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                default: obj
            };
        }
        var _assign = __webpack_require__(2), _assign2 = _interopRequireDefault(_assign), _keys = __webpack_require__(3), _keys2 = _interopRequireDefault(_keys), lessVarsAsJS = __webpack_require__(4), intVariableNames = [ "akGridSizeUnitless", "akZIndexNavigation", "akZIndexLayer", "akZIndexBlanket", "akZIndexFlag", "akZIndexCard", "akZIndexDialog", "akZIndexModal" ];
        (0, _keys2.default)(lessVarsAsJS).forEach(function(varName) {
            intVariableNames.indexOf(varName) > -1 ? module.exports[varName] = parseInt(lessVarsAsJS[varName], 10) : module.exports[varName] = lessVarsAsJS[varName];
        });
        // the order is very important here if these requires happen before the computation above
        // then the exported consts will interpolate undefined into their variables,
        // since the values won't exist on the exports of this module before the requires resolve.
        // this is a known issue encompased by AK-3182, and will be removed in that issue.
        var _require = __webpack_require__(5), akAnimationMixins = _require.default, _require2 = __webpack_require__(7), akElevationMixins = _require2.default, _require3 = __webpack_require__(8), akHelperMixins = _require3.default, _require4 = __webpack_require__(9), akTypographyMixins = _require4.default;
        module.exports = (0, _assign2.default)(module.exports, {
            // this default export only exists for backwards compat
            // and should be removed on the next breaking change.
            // See issue no: AK-3182
            default: lessVarsAsJS,
            akAnimationMixins: akAnimationMixins,
            akElevationMixins: akElevationMixins,
            akHelperMixins: akHelperMixins,
            akTypographyMixins: akTypographyMixins
        });
    }, /* 2 */
    /***/
    function(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_2__;
    }, /* 3 */
    /***/
    function(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_3__;
    }, /* 4 */
    /***/
    function(module, exports) {
        "use strict";
        /** ***************************************************************************
	 **  THIS FILE IS GENERATED - DO NOT MODIFY AND DO NOT CHECK INTO THE REPO   **
	 *************************************************************************** **/
        module.exports = {
            akBorderRadius: "3px",
            akColorPrimary1: "#172B4D",
            akColorPrimary2: "#0747A6",
            akColorPrimary3: "#FFFFFF",
            akColorSecondary1: "#FF5630",
            akColorSecondary2: "#FFAB00",
            akColorSecondary3: "#36B37E",
            akColorSecondary4: "#6554C0",
            akColorSecondary5: "#00B8D9",
            akColorR50: "#FFEBE6",
            akColorR75: "#FFBDAD",
            akColorR100: "#FF8F73",
            akColorR200: "#FF7452",
            akColorR300: "#FF5630",
            akColorR400: "#DE350B",
            akColorR500: "#BF2600",
            akColorY50: "#FFFAE6",
            akColorY75: "#FFF0B3",
            akColorY100: "#FFE380",
            akColorY200: "#FFC400",
            akColorY300: "#FFAB00",
            akColorY400: "#FF991F",
            akColorY500: "#FF8B00",
            akColorG50: "#E3FCEF",
            akColorG75: "#ABF5D1",
            akColorG100: "#79F2C0",
            akColorG200: "#57D9A3",
            akColorG300: "#36B37E",
            akColorG400: "#00875A",
            akColorG500: "#006644",
            akColorB50: "#DEEBFF",
            akColorB75: "#B3D4FF",
            akColorB100: "#4C9AFF",
            akColorB200: "#2684FF",
            akColorB300: "#0065FF",
            akColorB400: "#0052CC",
            akColorB500: "#0747A6",
            akColorP50: "#EAE6FF",
            akColorP75: "#C0B6F2",
            akColorP100: "#998DD9",
            akColorP200: "#8777D9",
            akColorP300: "#6554C0",
            akColorP400: "#5243AA",
            akColorP500: "#403294",
            akColorT50: "#E6FCFF",
            akColorT75: "#B3F5FF",
            akColorT100: "#79E2F2",
            akColorT200: "#00C7E6",
            akColorT300: "#00B8D9",
            akColorT400: "#00A3BF",
            akColorT500: "#008DA6",
            akColorN0: "#FFFFFF",
            akColorN10: "#FAFBFC",
            akColorN20: "#F4F5F7",
            akColorN30: "#EBECF0",
            akColorN40: "#DFE1E6",
            akColorN50: "#C1C7D0",
            akColorN60: "#B3BAC5",
            akColorN70: "#A5ADBA",
            akColorN80: "#97A0AF",
            akColorN90: "#8993A4",
            akColorN100: "#7A869A",
            akColorN200: "#6B778C",
            akColorN300: "#5E6C84",
            akColorN400: "#505F79",
            akColorN500: "#42526E",
            akColorN600: "#344563",
            akColorN700: "#253858",
            akColorN800: "#172B4D",
            akColorN900: "#091E42",
            akColorN10A: "rgba(9, 30, 66, 0.02)",
            akColorN20A: "rgba(9, 30, 66, 0.04)",
            akColorN30A: "rgba(9, 30, 66, 0.08)",
            akColorN40A: "rgba(9, 30, 66, 0.13)",
            akColorN50A: "rgba(9, 30, 66, 0.25)",
            akColorN60A: "rgba(9, 30, 66, 0.31)",
            akColorN70A: "rgba(9, 30, 66, 0.36)",
            akColorN80A: "rgba(9, 30, 66, 0.42)",
            akColorN90A: "rgba(9, 30, 66, 0.48)",
            akColorN100A: "rgba(9, 30, 66, 0.54)",
            akColorN200A: "rgba(9, 30, 66, 0.60)",
            akColorN300A: "rgba(9, 30, 66, 0.66)",
            akColorN400A: "rgba(9, 30, 66, 0.71)",
            akColorN500A: "rgba(9, 30, 66, 0.77)",
            akColorN600A: "rgba(9, 30, 66, 0.82)",
            akColorN700A: "rgba(9, 30, 66, 0.89)",
            akColorN800A: "rgba(9, 30, 66, 0.95)",
            akFontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
            akFontSizeDefault: "14px",
            akCodeFontFamily: "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Courier, monospace",
            akGridSizeUnitless: "8",
            akGridSize: "8px",
            akZIndexCard: "100",
            akZIndexDialog: "200",
            akZIndexNavigation: "300",
            akZIndexLayer: "400",
            akZIndexBlanket: "500",
            akZIndexModal: "510",
            akZIndexFlag: "600"
        };
    }, /* 5 */
    /***/
    function(module, exports, __webpack_require__) {
        "use strict";
        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                default: obj
            };
        }
        // ==============================
        // PRIVATE
        // ==============================
        // Function for calculating one prop value into one prop of a keyframe. i.e
        // For arguments: ({
        //    property: 'transform',
        //    value: interpolate`translateY(${t => t}px) translateX(${t => t}px)`,
        //    deltas: [{ from: 0, to: -200 }, { from: 0, to: -50 }]
        // }, 0.5)
        //
        // Will output: transform: translateY(-100px) translateX(-25px);
        function calculateValue(_ref, mod) {
            var deltas = _ref.deltas, value = _ref.value, modifiedDeltas = deltas.map(function(_ref2) {
                var from = _ref2.from, to = _ref2.to;
                return from + (to - from) * mod;
            });
            return value ? value(modifiedDeltas) : modifiedDeltas[0];
        }
        // Function used to create the content inside each keyframe.
        function calculateKeyframe(options, mod) {
            if (!Array.isArray(options)) throw new Error("Animation mixin expects an array, but received `" + ("undefined" == typeof options ? "undefined" : (0, 
            _typeof3.default)(options)) + "`");
            return options.map(function(opt) {
                return opt.property + ": " + calculateValue(opt, mod) + ";";
            }).join("\n").trim();
        }
        // ==============================
        // PUBLIC
        // ==============================
        // Create an animation by defining an object with the following properties:
        //
        // const slideUpAndRight = {
        //   property: 'transform',
        //   value: interpolate`translateY(${y => y}px) translateX(${x => x}px)`,
        //   deltas: [{ from: 0, to: -200 }, { from: 0, to: 100 }],
        // };
        // const fadeOut = {
        //   property: 'opacity',
        //   deltas: [{ from: 1, to: 0 }],
        // };
        //
        // Animation options require:
        //   - @property [String] is the name of a CSS property (i.e 'transform')
        //   - @value [Function] use the `interpolate` function as a tagged template
        //     literal to evaluate the value for each keyframe.
        //     NOTE: The @value prop can be omitted when the value directly maps to
        //     a number, and doesn't need to be transformed. For instance with `opacity`.
        //   - @deltas [ArrayOfObjects]
        //     - @from [Number] the start value
        //     - @to [Number] the end value
        //
        // Pass the options as an array to one of the mixins below. i.e.
        // const keyframes = akAnimationMixins.createBold([slideUp, fadeOut]);
        function createBold(options) {
            return "\n    0% {\n      " + calculateKeyframe(options, 0) + ";\n      animation-timing-function: cubic-bezier(0.23830050393398, 0, 0.25586732616931, 0.79011192334632);\n    }\n    20% {\n      " + calculateKeyframe(options, .8) + ";\n      animation-timing-function: cubic-bezier(0.21787238302442, 0.98324004924648, 0.58694150667646, 1);\n    }\n    100% {\n      " + calculateKeyframe(options, 1) + ";\n    }\n  ";
        }
        function createOptimistic(options) {
            return "\n    0% {\n      " + calculateKeyframe(options, 0) + ";\n      animation-timing-function: cubic-bezier(0.33333333, 0, 0.4, 1);\n    }\n    20% {\n      " + calculateKeyframe(options, 1.05) + ";\n      animation-timing-function: cubic-bezier(0.4, 0, 0.6, 1);\n    }\n    76% {\n      " + calculateKeyframe(options, .975) + ";\n      animation-timing-function: cubic-bezier(0.4, 0, 0.6, 1);\n    }\n    100% {\n      " + calculateKeyframe(options, 1) + ";\n    }\n  ";
        }
        function createCombined(options) {
            return "\n    0% {\n      " + calculateKeyframe(options, 0) + ";\n      animation-timing-function: cubic-bezier(0.4, 0, 0.15, 1);\n    }\n    50% {\n      " + calculateKeyframe(options, 1.1) + ";\n      animation-timing-function: cubic-bezier(0.4, 0, 0.6, 1);\n    }\n    100% {\n      " + calculateKeyframe(options, 1) + ";\n    }\n  ";
        }
        // Function to be used as a tagged template literal that evaluates it's
        // value given the progress through an animation and concatenates
        function interpolate(strings) {
            for (var _len = arguments.length, expressions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) expressions[_key - 1] = arguments[_key];
            return function(mods) {
                if (0 === expressions.length) // eslint-disable-next-line no-console
                return console.warn("Interpolate is not required. Use a `String` or remove the value property for direct numeric mapping."), 
                strings.join("");
                var results = [];
                return expressions.forEach(function(e, i) {
                    results.push(strings[i]), results.push(e(mods[i]));
                }), results.push(strings[strings.length - 1]), results.join("");
            };
        }
        Object.defineProperty(exports, "__esModule", {
            value: !0
        });
        var _typeof2 = __webpack_require__(6), _typeof3 = _interopRequireDefault(_typeof2);
        exports.createBold = createBold, exports.createOptimistic = createOptimistic, exports.createCombined = createCombined, 
        exports.interpolate = interpolate, exports.default = {
            createBold: createBold,
            createCombined: createCombined,
            createOptimistic: createOptimistic,
            interpolate: interpolate
        };
    }, /* 6 */
    /***/
    function(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_6__;
    }, /* 7 */
    /***/
    function(module, exports, __webpack_require__) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: !0
        });
        var _index = __webpack_require__(1), e100 = "\n  box-shadow: 0 1px 1px " + _index.akColorN50A + ", 0 0 1px 0 " + _index.akColorN60A + ";\n  z-index: " + _index.akZIndexCard + ";\n", e200 = "\n  box-shadow: 0 4px 8px -2px " + _index.akColorN60A + ", 0 0 1px " + _index.akColorN60A + ";\n  z-index: " + _index.akZIndexDialog + ";\n", e500 = "\n  box-shadow: 0 8px 16px -4px " + _index.akColorN60A + ", 0 0 1px " + _index.akColorN60A + ";\n  z-index: " + _index.akZIndexModal + ";\n", e600 = "\n  box-shadow: 0 20px 32px -8px " + _index.akColorN50A + ", 0 0 1px " + _index.akColorN60A + ";\n  z-index: " + _index.akZIndexFlag + ";\n";
        exports.default = {
            e100: e100,
            e200: e200,
            e500: e500,
            e600: e600
        };
    }, /* 8 */
    /***/
    function(module, exports, __webpack_require__) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: !0
        });
        var _index = __webpack_require__(1), createFocusRing = function() {
            var color = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : _index.akColorB100, width = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "2px";
            return "\n  &:focus {\n    box-shadow: 0 0 0 " + width + " " + color + ";\n    outline: none;\n  }\n";
        }, withFocusRing = "\n  " + createFocusRing() + "\n", withoutFocusRing = "\n  box-shadow: none;\n", truncate = function(width) {
            return "\n  max-width: " + width + ";\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n";
        }, placeholder = function(styles) {
            return "\n    &::-webkit-input-placeholder {\n      " + styles + "\n    }\n    &:-moz-placeholder {\n      " + styles + "\n    }\n    &::-moz-placeholder {\n      " + styles + "\n    }\n    &:-ms-input-placeholder {\n      " + styles + "\n    }\n  ";
        };
        // prefer default export
        exports.default = {
            focusRing: {
                generate: createFocusRing,
                default: withFocusRing,
                none: withoutFocusRing
            },
            text: {
                truncate: truncate
            },
            placeholder: placeholder
        };
    }, /* 9 */
    /***/
    function(module, exports, __webpack_require__) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: !0
        });
        var _index = __webpack_require__(1), fontSizeDefault = parseInt(_index.akFontSizeDefault, 10), gridSize = parseInt(_index.akGridSizeUnitless, 10), baseHeading = function(fontSize, lineHeight) {
            return "\n  font-size: " + fontSize / fontSizeDefault + "em;\n  font-style: inherit;\n  line-height: " + lineHeight / fontSize + ";\n";
        }, h900 = "\n  " + baseHeading(35, 40) + "\n  font-weight: 500;\n  letter-spacing: -0.01em;\n  margin-top: " + 6.5 * gridSize + "px;\n", h800 = "\n  " + baseHeading(29, 32) + "\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  margin-top: " + 5 * gridSize + "px;\n", h700 = "\n  " + baseHeading(24, 28) + "\n  font-weight: 500;\n  letter-spacing: -0.01em;\n  margin-top: " + 5 * gridSize + "px;\n", h600 = "\n  " + baseHeading(20, 24) + "\n  font-weight: 500;\n  letter-spacing: -0.008em;\n  margin-top: " + 3.5 * gridSize + "px;\n", h500 = "\n  " + baseHeading(16, 20) + "\n  font-weight: 600;\n  letter-spacing: -0.006em;\n  margin-top: " + 3 * gridSize + "px;\n", h400 = "\n  " + baseHeading(14, 16) + "\n  font-weight: 600;\n  letter-spacing: -0.003em;\n  margin-top: " + 2 * gridSize + "px;\n", h300 = "\n  " + baseHeading(12, 16) + "\n  color: " + _index.akColorN300 + ";\n  font-weight: 600;\n  margin-top: " + 2.5 * gridSize + "px;\n  text-transform: uppercase;\n", h200 = "\n  " + baseHeading(12, 16) + "\n  color: " + _index.akColorN300 + ";\n  font-weight: 600;\n  margin-top: " + 2 * gridSize + "px;\n", h100 = "\n  " + baseHeading(12, 16) + "\n  color: " + _index.akColorN300 + ";\n  font-weight: normal;\n  margin-top: " + 2 * gridSize + "px;\n";
        exports.default = {
            h100: h100,
            h200: h200,
            h300: h300,
            h400: h400,
            h500: h500,
            h600: h600,
            h700: h700,
            h800: h800,
            h900: h900
        };
    } ]);
});

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return globalItemStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_variables__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_mixins__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__theme_util__ = __webpack_require__(11);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: ', ';\n  background-color: ', ';\n  /* fill controls the secondary color used by some icons like the help icon */\n  fill: ', ';\n  align-items: center;\n  border: none;\n  border-radius: ', ';\n  cursor: pointer;\n  display: flex;\n  line-height: 1;\n  width: ', 'px;\n  height: ', 'px;\n  justify-content: center;\n  margin-top: ', 'px;\n  padding: 0;\n  outline: none;\n  text-align: center;\n\n  &:hover {\n    background-color: ', ';\n  }\n\n  &:focus {\n    background-color: ', ';\n    ', ';\n  }\n\n  &:active {\n    background-color: ', ';\n  }\n'], ['\n  color: ', ';\n  background-color: ', ';\n  /* fill controls the secondary color used by some icons like the help icon */\n  fill: ', ';\n  align-items: center;\n  border: none;\n  border-radius: ', ';\n  cursor: pointer;\n  display: flex;\n  line-height: 1;\n  width: ', 'px;\n  height: ', 'px;\n  justify-content: center;\n  margin-top: ', 'px;\n  padding: 0;\n  outline: none;\n  text-align: center;\n\n  &:hover {\n    background-color: ', ';\n  }\n\n  &:focus {\n    background-color: ', ';\n    ', ';\n  }\n\n  &:active {\n    background-color: ', ';\n  }\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  -moz-appearance: none;\n  -webkit-appearance: none;\n  ', ';\n'], ['\n  -moz-appearance: none;\n  -webkit-appearance: none;\n  ', ';\n']);







var getOutline = function getOutline(props) {
  var provided = Object(__WEBPACK_IMPORTED_MODULE_4__theme_util__["e" /* getProvided */])(props.theme);

  return Object(__WEBPACK_IMPORTED_MODULE_3__utils_mixins__["a" /* focusOutline */])(provided.item.focus.outline);
};

var globalItemStyles = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject, function (_ref) {
  var theme = _ref.theme;
  return Object(__WEBPACK_IMPORTED_MODULE_4__theme_util__["e" /* getProvided */])(theme).text;
}, function (_ref2) {
  var isSelected = _ref2.isSelected,
      theme = _ref2.theme;
  return isSelected ? Object(__WEBPACK_IMPORTED_MODULE_4__theme_util__["e" /* getProvided */])(theme).item.selected.background : Object(__WEBPACK_IMPORTED_MODULE_4__theme_util__["e" /* getProvided */])(theme).item.default.background;
}, function (_ref3) {
  var theme = _ref3.theme;
  return Object(__WEBPACK_IMPORTED_MODULE_4__theme_util__["e" /* getProvided */])(theme).background.primary;
}, function (_ref4) {
  var appearance = _ref4.appearance;
  return appearance === 'square' ? '5px' : '50%';
}, function (_ref5) {
  var size = _ref5.size;
  return __WEBPACK_IMPORTED_MODULE_2__shared_variables__["j" /* globalItemSizes */][size];
}, function (_ref6) {
  var size = _ref6.size;
  return __WEBPACK_IMPORTED_MODULE_2__shared_variables__["j" /* globalItemSizes */][size];
}, function (_ref7) {
  var size = _ref7.size;
  return size === 'small' ? __WEBPACK_IMPORTED_MODULE_2__shared_variables__["n" /* gridSize */] : 0;
}, function (_ref8) {
  var theme = _ref8.theme;
  return Object(__WEBPACK_IMPORTED_MODULE_4__theme_util__["e" /* getProvided */])(theme).item.hover.background;
}, function (_ref9) {
  var theme = _ref9.theme;
  return Object(__WEBPACK_IMPORTED_MODULE_4__theme_util__["e" /* getProvided */])(theme).item.focus.background;
}, getOutline, function (_ref10) {
  var theme = _ref10.theme;
  return Object(__WEBPACK_IMPORTED_MODULE_4__theme_util__["e" /* getProvided */])(theme).item.active.background;
});

var GlobalItemInner = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].button(_templateObject2, globalItemStyles);

GlobalItemInner.displayName = 'GlobalItemInner';
/* harmony default export */ __webpack_exports__["a"] = (GlobalItemInner);


/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_variables__ = __webpack_require__(10);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0;\n  background: none;\n  border: none;\n  border-radius: 50%;\n  padding: 0;\n  width: ', 'px;\n  height: ', 'px;\n  outline: none;\n'], ['\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0;\n  background: none;\n  border: none;\n  border-radius: 50%;\n  padding: 0;\n  width: ', 'px;\n  height: ', 'px;\n  outline: none;\n']);




var DrawerTriggerInner = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, __WEBPACK_IMPORTED_MODULE_2__shared_variables__["n" /* gridSize */] * 5, __WEBPACK_IMPORTED_MODULE_2__shared_variables__["n" /* gridSize */] * 5);

DrawerTriggerInner.displayName = 'DrawerTriggerInner';
/* harmony default export */ __webpack_exports__["a"] = (DrawerTriggerInner);

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export maxPrimaryItems */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);







var maxPrimaryItems = 3;

function checkIfTooManyPrimaryActions() {
  var actions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  if (actions.length > maxPrimaryItems) {
    // eslint-disable-next-line no-console
    console.warn('AkGlobalNavigation will only render up to ' + maxPrimaryItems + ' primary actions.');
  }
}

var GlobalPrimaryActionsList = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(GlobalPrimaryActionsList, _PureComponent);

  function GlobalPrimaryActionsList(props, context) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, GlobalPrimaryActionsList);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (GlobalPrimaryActionsList.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(GlobalPrimaryActionsList)).call(this, props, context));

    checkIfTooManyPrimaryActions(props.actions);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(GlobalPrimaryActionsList, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      checkIfTooManyPrimaryActions(nextProps.actions);
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        null,
        this.props.actions.map(function (action, index) {
          return (
            // eslint-disable-next-line react/no-array-index-key
            index < maxPrimaryItems ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              'div',
              { key: index },
              action
            ) : null
          );
        })
      );
    }
  }]);

  return GlobalPrimaryActionsList;
}(__WEBPACK_IMPORTED_MODULE_5_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (GlobalPrimaryActionsList);

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_variables__ = __webpack_require__(10);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  box-sizing: border-box;\n  padding: ', 'px 0 ', 'px 0;\n'], ['\n  box-sizing: border-box;\n  padding: ', 'px 0 ', 'px 0;\n']);




var GlobalPrimaryActionsInner = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, __WEBPACK_IMPORTED_MODULE_2__shared_variables__["n" /* gridSize */], __WEBPACK_IMPORTED_MODULE_2__shared_variables__["l" /* globalPrimaryActions */].margin.bottom);

GlobalPrimaryActionsInner.displayName = 'GlobalPrimaryActionsInner';

/* harmony default export */ __webpack_exports__["a"] = (GlobalPrimaryActionsInner);

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n'], ['\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n']);



var GlobalPrimaryActionsPrimaryItem = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject);

GlobalPrimaryActionsPrimaryItem.displayName = 'GlobalPrimaryActionsPrimaryItem';
/* harmony default export */ __webpack_exports__["a"] = (GlobalPrimaryActionsPrimaryItem);

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export actionsMarginTop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_variables__ = __webpack_require__(10);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  margin-top: ', 'px;\n'], ['\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  margin-top: ', 'px;\n']);




var actionsMarginTop = __WEBPACK_IMPORTED_MODULE_2__shared_variables__["n" /* gridSize */] * 2;

var GlobalPrimaryActionsItemsWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, actionsMarginTop);

GlobalPrimaryActionsItemsWrapper.displayName = 'GlobalPrimaryActionsItemsWrapper';
/* harmony default export */ __webpack_exports__["a"] = (GlobalPrimaryActionsItemsWrapper);

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_variables__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__theme_util__ = __webpack_require__(11);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  align-items: center;\n  color: ', ';\n  background-color: ', ';\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  padding: ', 'px 0 ', 'px;\n  /* always keeping a fixed width so that the ContainerNavigation bleeds over the top of this */\n  width: ', 'px;\n'], ['\n  align-items: center;\n  color: ', ';\n  background-color: ', ';\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  padding: ', 'px 0 ', 'px;\n  /* always keeping a fixed width so that the ContainerNavigation bleeds over the top of this */\n  width: ', 'px;\n']);





var getTopPadding = function getTopPadding(props) {
  return __WEBPACK_IMPORTED_MODULE_2__shared_variables__["o" /* layout */].padding.top + (Object(__WEBPACK_IMPORTED_MODULE_3__theme_util__["i" /* isElectronMac */])(props.theme) ? __WEBPACK_IMPORTED_MODULE_3__theme_util__["d" /* electronMacTopPadding */] : 0);
};

var GlobalNavigationInner = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, function (_ref) {
  var theme = _ref.theme;
  return Object(__WEBPACK_IMPORTED_MODULE_3__theme_util__["e" /* getProvided */])(theme).text;
}, function (_ref2) {
  var theme = _ref2.theme;
  return Object(__WEBPACK_IMPORTED_MODULE_3__theme_util__["e" /* getProvided */])(theme).background.primary;
}, getTopPadding, __WEBPACK_IMPORTED_MODULE_2__shared_variables__["o" /* layout */].padding.bottom, function (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__shared_variables__["k" /* globalOpenWidth */])(Object(__WEBPACK_IMPORTED_MODULE_3__theme_util__["i" /* isElectronMac */])(props.theme));
});

GlobalNavigationInner.displayName = 'GlobalNavigationInner';
/* harmony default export */ __webpack_exports__["a"] = (GlobalNavigationInner);

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  /* definition is spread out to be correctly understood by ie11 */\n  flex-grow: 1;\n  flex-shrink: 1;\n  flex-basis: 0;\n'], ['\n  /* definition is spread out to be correctly understood by ie11 */\n  flex-grow: 1;\n  flex-shrink: 1;\n  flex-basis: 0;\n']);



var GlobalNavigationPrimaryContainer = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject);

GlobalNavigationPrimaryContainer.displayName = 'GlobalNavigationPrimaryContainer';
/* harmony default export */ __webpack_exports__["a"] = (GlobalNavigationPrimaryContainer);

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_variables__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__theme_util__ = __webpack_require__(11);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  flex-basis: ', ';\n  flex-shrink: 0;\n  min-height: ', ';\n  overflow: hidden;\n  padding: 0 ', 'px 0 ', 'px;\n  transition: flex-basis ', ',\n    padding ', ';\n\n  ', ' > *:first-child {\n    margin-bottom: ', 'px;\n  }\n'], ['\n  flex-basis: ', ';\n  flex-shrink: 0;\n  min-height: ', ';\n  overflow: hidden;\n  padding: 0 ', 'px 0 ', 'px;\n  transition: flex-basis ', ',\n    padding ', ';\n\n  ', ' > *:first-child {\n    margin-bottom: ', 'px;\n  }\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    /* centering the icon */\n    display: flex;\n    flex-basis: auto;\n    flex-direction: column;\n    justify-content: center;\n    min-height: 0;\n    padding: 0 ', 'px 0 ', 'px;\n  '], ['\n    /* centering the icon */\n    display: flex;\n    flex-basis: auto;\n    flex-direction: column;\n    justify-content: center;\n    min-height: 0;\n    padding: 0 ', 'px 0 ', 'px;\n  ']);





var padding = {
  top: __WEBPACK_IMPORTED_MODULE_2__shared_variables__["n" /* gridSize */],
  right: __WEBPACK_IMPORTED_MODULE_2__shared_variables__["n" /* gridSize */] * 2,
  bottom: __WEBPACK_IMPORTED_MODULE_2__shared_variables__["n" /* gridSize */],
  left: __WEBPACK_IMPORTED_MODULE_2__shared_variables__["n" /* gridSize */] * 2
};

var minHeight = function minHeight(props) {
  if (props.isInDrawer) {
    // the header content isn't rendered in a full-width Drawer
    return 0;
  }
  // the height of the container icon and the margin below it
  return padding.bottom + padding.top + __WEBPACK_IMPORTED_MODULE_2__shared_variables__["j" /* globalItemSizes */].medium + __WEBPACK_IMPORTED_MODULE_2__shared_variables__["e" /* containerTitleBottomMargin */] + 'px';
};

var flexBasis = function flexBasis(props) {
  if (props.isFullWidth) {
    return 0;
  } else if (props.isInDrawer) {
    return '\n      ' + (props.iconOffset - __WEBPACK_IMPORTED_MODULE_2__shared_variables__["o" /* layout */].padding.top) + 'px\n    ';
  }
  return 'auto';
};

var ContainerHeaderWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, flexBasis, minHeight, padding.right, padding.left, __WEBPACK_IMPORTED_MODULE_2__shared_variables__["h" /* drawerContainerHeaderAnimationSpeed */], __WEBPACK_IMPORTED_MODULE_2__shared_variables__["h" /* drawerContainerHeaderAnimationSpeed */], Object(__WEBPACK_IMPORTED_MODULE_3__theme_util__["m" /* whenCollapsed */])(_templateObject2, __WEBPACK_IMPORTED_MODULE_2__shared_variables__["n" /* gridSize */], __WEBPACK_IMPORTED_MODULE_2__shared_variables__["n" /* gridSize */]), __WEBPACK_IMPORTED_MODULE_2__shared_variables__["e" /* containerTitleBottomMargin */]);

ContainerHeaderWrapper.displayName = 'ContainerHeaderWrapper';

/* harmony default export */ __webpack_exports__["a"] = (ContainerHeaderWrapper);

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styled_ScrollHintWrapper__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styled_ScrollHintScrollContainer__ = __webpack_require__(278);





var ContainerNavigationChildren = function ContainerNavigationChildren(_ref) {
  var children = _ref.children,
      hasScrollHintTop = _ref.hasScrollHintTop,
      scrollRef = _ref.scrollRef;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__styled_ScrollHintWrapper__["a" /* default */],
    { hasScrollHintTop: hasScrollHintTop },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__styled_ScrollHintScrollContainer__["a" /* default */],
      { innerRef: scrollRef },
      children
    )
  );
};
ContainerNavigationChildren.displayName = 'ContainerNavigationChildren';
/* harmony default export */ __webpack_exports__["a"] = (ContainerNavigationChildren);

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__theme_util__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_variables__ = __webpack_require__(10);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 100%;\n  overflow: hidden;\n  /* Position relative is required so products can position fixed items at top or bottom\n   * of the container scrollable area. */\n  position: relative;\n\n  ', ';\n'], ['\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 100%;\n  overflow: hidden;\n  /* Position relative is required so products can position fixed items at top or bottom\n   * of the container scrollable area. */\n  position: relative;\n\n  ', ';\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    &:before,\n    &:after {\n      background: ', ';\n      display: block;\n      flex: 0;\n      height: ', 'px;\n      left: ', 'px;\n      position: absolute;\n      z-index: 1;\n\n      // Because we are using a custom scrollbar for WebKit in ScrollHintScrollContainer, the\n      // right margin needs to be calculated based on whether that feature is in use.\n      right: ', 'px;\n    }\n\n    &:before {\n      top: 0;\n      content: ', ';\n    }\n  '], ['\n    &:before,\n    &:after {\n      background: ', ';\n      display: block;\n      flex: 0;\n      height: ', 'px;\n      left: ', 'px;\n      position: absolute;\n      z-index: 1;\n\n      // Because we are using a custom scrollbar for WebKit in ScrollHintScrollContainer, the\n      // right margin needs to be calculated based on whether that feature is in use.\n      right: ', 'px;\n    }\n\n    &:before {\n      top: 0;\n      content: ', ';\n    }\n  ']);





var doubleIfNotWebkit = function doubleIfNotWebkit(width) {
  return width * (typeof window !== 'undefined' && window.navigator && window.navigator.userAgent.indexOf('AppleWebKit') >= 0 ? 1 : 2);
};

var ContainerNavigationChildrenWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, Object(__WEBPACK_IMPORTED_MODULE_2__theme_util__["o" /* whenNotCollapsed */])(_templateObject2, function (_ref) {
  var theme = _ref.theme;
  return Object(__WEBPACK_IMPORTED_MODULE_2__theme_util__["e" /* getProvided */])(theme).keyline;
}, __WEBPACK_IMPORTED_MODULE_3__shared_variables__["u" /* scrollHintHeight */], __WEBPACK_IMPORTED_MODULE_3__shared_variables__["v" /* scrollHintSpacing */], __WEBPACK_IMPORTED_MODULE_3__shared_variables__["v" /* scrollHintSpacing */] + doubleIfNotWebkit(__WEBPACK_IMPORTED_MODULE_3__shared_variables__["t" /* scrollBarSize */]), function (_ref2) {
  var hasScrollHintTop = _ref2.hasScrollHintTop;
  return hasScrollHintTop ? "''" : 'none';
}));
ContainerNavigationChildrenWrapper.displayName = 'ContainerNavigationChildrenWrapper';
/* harmony default export */ __webpack_exports__["a"] = (ContainerNavigationChildrenWrapper);

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styled_RevealInner__ = __webpack_require__(609);








var Reveal = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Reveal, _PureComponent);

  function Reveal(props, context) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Reveal);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Reveal.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Reveal)).call(this, props, context));

    _this.onTransitionEnd = function () {
      if (_this.props.isOpen) {
        return;
      }

      // hide children after animation to close them
      _this.setState({
        shouldRenderChildren: false
      });
    };

    var isOpen = props.isOpen,
        shouldAnimate = props.shouldAnimate;


    _this.state = {
      isAnimatingInOnMount: isOpen && shouldAnimate,
      shouldRenderChildren: isOpen
    };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Reveal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (!this.state.isAnimatingInOnMount) {
        return;
      }
      // Forcing async to obtain clean render.
      // Needed to use a setTimeout to force this,
      // could not just rely on the requestAnimationFrame.
      setTimeout(function () {
        // optimised render
        requestAnimationFrame(function () {
          _this2.setState({
            isAnimatingInOnMount: false
          });
        });
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var isClosed = !this.props.isOpen;
      var willClose = !nextProps.isOpen;
      var willOpen = nextProps.isOpen;
      var shouldAnimate = nextProps.shouldAnimate;

      // ensure children are rendered before open animation occurs
      if (isClosed && willOpen) {
        this.setState({
          shouldRenderChildren: true
        });
      }

      // if closing with no animation: hide the children immediately
      if (willClose && !shouldAnimate) {
        this.setState({
          shouldRenderChildren: false
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          isOpen = _props.isOpen,
          openHeight = _props.openHeight,
          shouldAnimate = _props.shouldAnimate;
      var _state = this.state,
          isAnimatingInOnMount = _state.isAnimatingInOnMount,
          shouldRenderChildren = _state.shouldRenderChildren;


      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__styled_RevealInner__["a" /* default */],
        {
          isOpen: isAnimatingInOnMount ? false : isOpen,
          openHeight: openHeight,
          shouldAnimate: shouldAnimate,
          onTransitionEnd: this.onTransitionEnd
        },
        shouldRenderChildren ? children : null
      );
    }
  }]);

  return Reveal;
}(__WEBPACK_IMPORTED_MODULE_5_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Reveal);

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_variables__ = __webpack_require__(10);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  flex-shrink: 0;\n  height: ', 'px;\n  opacity: ', ';\n  transition: ', ';\n'], ['\n  flex-shrink: 0;\n  height: ', 'px;\n  opacity: ', ';\n  transition: ', ';\n']);





var transition = 'height ' + __WEBPACK_IMPORTED_MODULE_3__shared_variables__["a" /* animationTime */] + ', opacity ' + __WEBPACK_IMPORTED_MODULE_3__shared_variables__["a" /* animationTime */];

var RevealInner = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject, function (props) {
  return props.isOpen ? props.openHeight : 0;
}, function (props) {
  return props.isOpen ? 1 : 0;
}, function (props) {
  return props.shouldAnimate ? transition : 'none';
});

RevealInner.displayName = 'RevealInner';

RevealInner.propTypes = {
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  openHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (RevealInner);

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_variables__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__theme_util__ = __webpack_require__(11);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  background-color: ', ';\n  color: ', ';\n  display: flex;\n  flex-direction: column;\n  padding-top: ', 'px;\n  /* fill the entire space of the flex container */\n  width: 100%;\n'], ['\n  background-color: ', ';\n  color: ', ';\n  display: flex;\n  flex-direction: column;\n  padding-top: ', 'px;\n  /* fill the entire space of the flex container */\n  width: 100%;\n']);





var getTopPadding = function getTopPadding(props) {
  return __WEBPACK_IMPORTED_MODULE_2__shared_variables__["o" /* layout */].padding.top + (Object(__WEBPACK_IMPORTED_MODULE_3__theme_util__["i" /* isElectronMac */])(props.theme) ? __WEBPACK_IMPORTED_MODULE_3__theme_util__["d" /* electronMacTopPadding */] : 0);
};

var ContainerNavigationInner = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, function (_ref) {
  var theme = _ref.theme;

  var background = Object(__WEBPACK_IMPORTED_MODULE_3__theme_util__["e" /* getProvided */])(theme).background;
  if (background.secondary) {
    return background.secondary;
  }

  return background.primary;
}, function (_ref2) {
  var theme = _ref2.theme;
  return Object(__WEBPACK_IMPORTED_MODULE_3__theme_util__["e" /* getProvided */])(theme).text;
}, getTopPadding);

ContainerNavigationInner.displayName = 'ContainerNavigationInner';

/* harmony default export */ __webpack_exports__["a"] = (ContainerNavigationInner);

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_variables__ = __webpack_require__(10);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  height: ', ';\n  /* This transition height is borrowed from banner specifically to make the\n  shortening occur in line with banner\'s lengthening. */\n  transition: height 0.25s ease-in-out;\n  display: flex;\n  flex-direction: row;\n  position: fixed;\n  left: 0;\n  /* force this to have the width of the Spacer above */\n  width: inherit;\n  z-index: ', ';\n'], ['\n  height: ', ';\n  /* This transition height is borrowed from banner specifically to make the\n  shortening occur in line with banner\'s lengthening. */\n  transition: height 0.25s ease-in-out;\n  display: flex;\n  flex-direction: row;\n  position: fixed;\n  left: 0;\n  /* force this to have the width of the Spacer above */\n  width: inherit;\n  z-index: ', ';\n']);




var NavigationFixedContainer = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, function (_ref) {
  var topOffset = _ref.topOffset;
  return topOffset ? 'calc(100vh - ' + topOffset + 'px)' : '100vh';
}, __WEBPACK_IMPORTED_MODULE_2__shared_variables__["y" /* zIndex */].base);

NavigationFixedContainer.displayName = 'NavigationFixedContainer';
/* harmony default export */ __webpack_exports__["a"] = (NavigationFixedContainer);

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  /* make full height */\n  display: flex;\n\n  /* prevent the global navigation being crushed while resizing */\n  flex-shrink: 0;\n'], ['\n  /* make full height */\n  display: flex;\n\n  /* prevent the global navigation being crushed while resizing */\n  flex-shrink: 0;\n']);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject));

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_variables__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__theme_util__ = __webpack_require__(11);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  flex-grow: 1;\n  flex-shrink: 1;\n  /* allowing the container to collapse down to its min width */\n  min-width: ', 'px;\n  ', ' display: flex;\n'], ['\n  flex-grow: 1;\n  flex-shrink: 1;\n  /* allowing the container to collapse down to its min width */\n  min-width: ', 'px;\n  ', ' display: flex;\n']);





var getTransform = function getTransform(_ref) {
  var horizontalOffset = _ref.horizontalOffset;

  if (!horizontalOffset || horizontalOffset === 0) {
    return '';
  }
  return 'transform: translateX(' + horizontalOffset + 'px);';
};

var NavigationContainerNavigationWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, function (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__shared_variables__["c" /* containerClosedWidth */])(Object(__WEBPACK_IMPORTED_MODULE_3__theme_util__["i" /* isElectronMac */])(props.theme));
}, getTransform);

NavigationContainerNavigationWrapper.displayName = 'NavigationContainerNavigationWrapper';

/* harmony default export */ __webpack_exports__["a"] = (NavigationContainerNavigationWrapper);

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_raf_schd__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styled_ResizerInner__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ResizerButton__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_variables__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__theme_util__ = __webpack_require__(11);













var Resizer = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Resizer, _PureComponent);

  function Resizer() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Resizer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Resizer.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Resizer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      startScreenX: 0,
      isHovering: false,
      isResizing: false
    }, _this.scheduleResize = Object(__WEBPACK_IMPORTED_MODULE_7_raf_schd__["a" /* default */])(function (delta) {
      if (_this.state.isResizing && delta) {
        _this.props.onResize(delta);
      }
    }), _this.mouseDownHandler = function (e) {
      e.preventDefault();
      if (!_this.resizerNode || e.target !== _this.resizerNode) {
        return;
      }

      if (_this.state.isResizing) {
        // eslint-disable-next-line no-console
        console.error('attempting to start a resize when another is occurring');
        return;
      }

      _this.setState({
        isResizing: true,
        startScreenX: e.screenX
      });
      _this.props.onResizeStart();
      window.addEventListener('mousemove', _this.mouseMoveHandler);
      window.addEventListener('mouseup', _this.mouseUpHandler);
      window.addEventListener('mouseout', _this.handleOutofBounds);
    }, _this.mouseUpHandler = function (e) {
      var outOfBounds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      window.removeEventListener('mousemove', _this.mouseMoveHandler);
      window.removeEventListener('mouseup', _this.mouseUpHandler);
      window.removeEventListener('mouseout', _this.handleOutofBounds);
      _this.setState({
        isResizing: false
      });

      var screenX = outOfBounds ? // If we have gone out of bounds, reduce the nav width so the resizer is still visible
      e.screenX - 2 * __WEBPACK_IMPORTED_MODULE_10__shared_variables__["r" /* resizerClickableWidth */] : e.screenX;

      var delta = screenX - _this.state.startScreenX;

      if (delta === 0) {
        _this.resizeButtonHandler();
      }

      // Perform one final resize before ending
      _this.props.onResize(delta);

      _this.props.onResizeEnd(delta);
    }, _this.mouseMoveHandler = function (e) {
      _this.scheduleResize(e.screenX - _this.state.startScreenX);
    }, _this.mouseEnterHandler = function () {
      _this.setState({
        isHovering: true
      });
    }, _this.mouseLeaveHandler = function () {
      _this.setState({
        isHovering: false
      });
    }, _this.handleOutofBounds = function (e) {
      var toEl = e.relatedTarget;
      var disableResizeNodes = ['IFRAME', // Moving into an iframe
      'HTML', // Moving out of an iframe or root window - Safari
      null];

      if (_this.state.isResizing && disableResizeNodes.includes(toEl && toEl.nodeName)) {
        _this.mouseUpHandler(e, true);
      }
    }, _this.isElectronMac = function () {
      return Object(__WEBPACK_IMPORTED_MODULE_11__theme_util__["i" /* isElectronMac */])(_this.props.theme);
    }, _this.isPointingRight = function () {
      return _this.props.navigationWidth < Object(__WEBPACK_IMPORTED_MODULE_10__shared_variables__["w" /* standardOpenWidth */])(_this.isElectronMac());
    }, _this.resizeButtonHandler = function () {
      var isElectron = _this.isElectronMac();
      var _this$props = _this.props,
          navigationWidth = _this$props.navigationWidth,
          onResizeButton = _this$props.onResizeButton;

      var standardOpenWidthResult = Object(__WEBPACK_IMPORTED_MODULE_10__shared_variables__["w" /* standardOpenWidth */])(isElectron);
      var isExpanded = navigationWidth > standardOpenWidthResult;
      var isPointingRight = _this.isPointingRight();

      if (isPointingRight || isExpanded) {
        onResizeButton({
          isOpen: true,
          width: standardOpenWidthResult
        });
      } else {
        onResizeButton({
          isOpen: false,
          width: Object(__WEBPACK_IMPORTED_MODULE_10__shared_variables__["k" /* globalOpenWidth */])(isElectron)
        });
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  // Handle when mouse moves over an element that won't fire mouse events.
  // Fires a mouseup immediately to prevent mouseup not being fired at all.


  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Resizer, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var resizerButton = this.props.showResizeButton ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ResizerButton__["a" /* default */], {
        isVisible: this.state.isHovering,
        isPointingRight: this.isPointingRight(),
        onClick: this.resizeButtonHandler
      }) : null;

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__styled_ResizerInner__["a" /* default */],
        {
          innerRef: function innerRef(resizerNode) {
            _this2.resizerNode = resizerNode;
          },
          onMouseDown: this.mouseDownHandler,
          onMouseEnter: this.mouseEnterHandler,
          onMouseLeave: this.mouseLeaveHandler
        },
        resizerButton
      );
    }
  }]);

  return Resizer;
}(__WEBPACK_IMPORTED_MODULE_5_react__["PureComponent"]);

Resizer.defaultProps = {
  onResizeStart: function onResizeStart() {},
  onResizeEnd: function onResizeEnd() {},
  onResizeButton: function onResizeButton() {},
  onResize: function onResize() {},
  navigationWidth: Object(__WEBPACK_IMPORTED_MODULE_10__shared_variables__["w" /* standardOpenWidth */])(false),
  showResizeButton: true,
  theme: {}
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_styled_components__["withTheme"])(Resizer));

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_variables__ = __webpack_require__(10);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  cursor: ew-resize;\n  height: 100%;\n\n  /* position: absolute so that it will not effect the width of the navigation */\n  position: absolute;\n\n  right: -', 'px;\n  width: ', 'px;\n\n  &::before {\n    content: \'\';\n    height: 100%;\n    left: -', 'px;\n    position: absolute;\n    transition: background-color ', 'ms ease-in-out\n      ', 'ms;\n    width: ', 'px;\n  }\n  &:hover::before {\n    background: ', ';\n  }\n'], ['\n  cursor: ew-resize;\n  height: 100%;\n\n  /* position: absolute so that it will not effect the width of the navigation */\n  position: absolute;\n\n  right: -', 'px;\n  width: ', 'px;\n\n  &::before {\n    content: \'\';\n    height: 100%;\n    left: -', 'px;\n    position: absolute;\n    transition: background-color ', 'ms ease-in-out\n      ', 'ms;\n    width: ', 'px;\n  }\n  &:hover::before {\n    background: ', ';\n  }\n']);




var ResizerInner = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, __WEBPACK_IMPORTED_MODULE_2__shared_variables__["r" /* resizerClickableWidth */], __WEBPACK_IMPORTED_MODULE_2__shared_variables__["r" /* resizerClickableWidth */], __WEBPACK_IMPORTED_MODULE_2__shared_variables__["s" /* resizerVisibleWidth */] / 2, __WEBPACK_IMPORTED_MODULE_2__shared_variables__["b" /* animationTimeUnitless */] + 100, __WEBPACK_IMPORTED_MODULE_2__shared_variables__["b" /* animationTimeUnitless */], __WEBPACK_IMPORTED_MODULE_2__shared_variables__["s" /* resizerVisibleWidth */], __WEBPACK_IMPORTED_MODULE_2__shared_variables__["x" /* unthemedColors */].resizer);

ResizerInner.displayName = 'ResizerInner';
/* harmony default export */ __webpack_exports__["a"] = (ResizerInner);

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styled_ResizerButtonInner__ = __webpack_require__(617);








var ResizerButton = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ResizerButton, _PureComponent);

  function ResizerButton() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ResizerButton);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ResizerButton.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ResizerButton)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ResizerButton, [{
    key: 'render',

    // Note: we always render the ResizerButtonInner here (instead of returning null immediately
    // when isVisible = false) because we want the user to be able to tab to the button always.
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styled_ResizerButtonInner__["a" /* default */], {
        'aria-expanded': !this.props.isPointingRight,
        isPointingRight: this.props.isPointingRight,
        onClick: this.props.onClick,
        isVisible: this.props.isVisible,
        onMouseDown: function onMouseDown(e) {
          return e.preventDefault();
        }
      });
    }
  }]);

  return ResizerButton;
}(__WEBPACK_IMPORTED_MODULE_5_react__["PureComponent"]);

ResizerButton.defaultProps = {
  isPointingRight: false,
  isVisible: false
};
/* harmony default export */ __webpack_exports__["a"] = (ResizerButton);

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_variables__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_mixins__ = __webpack_require__(161);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  position: relative;\n  top: calc(50% - ', 'px);\n  height: ', 'px;\n  background: none;\n  border: none;\n  color: transparent;\n  width: ', 'px;\n  left: -', 'px;\n  cursor: pointer;\n\n  &:focus {\n    ', ';\n  }\n\n  &::before,\n  &::after {\n    content: \'\';\n    background-color: ', ';\n    width: ', 'px;\n    border-radius: ', 'px;\n    height: ', 'px;\n    position: absolute;\n    left: 8px;\n    opacity: ', ';\n    transition: ', ', ', ';\n    transform: rotate(0deg);\n  }\n\n  &::before {\n    top: ', 'px;\n    transform-origin: ', 'px\n      ', 'px;\n  }\n\n  &::after {\n    top: ', 'px;\n    transform-origin: ', 'px ', 'px;\n  }\n\n  &:hover,\n  &:focus {\n    &::before,\n    &::after {\n      opacity: 1;\n    }\n    &::before {\n      transform: rotate(\n        ', '\n      );\n    }\n    &::after {\n      transform: rotate(\n        ', '\n      );\n    }\n  }\n'], ['\n  position: relative;\n  top: calc(50% - ', 'px);\n  height: ', 'px;\n  background: none;\n  border: none;\n  color: transparent;\n  width: ', 'px;\n  left: -', 'px;\n  cursor: pointer;\n\n  &:focus {\n    ', ';\n  }\n\n  &::before,\n  &::after {\n    content: \'\';\n    background-color: ', ';\n    width: ', 'px;\n    border-radius: ', 'px;\n    height: ', 'px;\n    position: absolute;\n    left: 8px;\n    opacity: ', ';\n    transition: ', ', ', ';\n    transform: rotate(0deg);\n  }\n\n  &::before {\n    top: ', 'px;\n    transform-origin: ', 'px\n      ', 'px;\n  }\n\n  &::after {\n    top: ', 'px;\n    transform-origin: ', 'px ', 'px;\n  }\n\n  &:hover,\n  &:focus {\n    &::before,\n    &::after {\n      opacity: 1;\n    }\n    &::before {\n      transform: rotate(\n        ', '\n      );\n    }\n    &::after {\n      transform: rotate(\n        ', '\n      );\n    }\n  }\n']);





var toggleButtonHeight = __WEBPACK_IMPORTED_MODULE_2__shared_variables__["n" /* gridSize */] * 4.5;
var toggleArrowHeight = __WEBPACK_IMPORTED_MODULE_2__shared_variables__["n" /* gridSize */] * 2;
var toggleArrowWidth = 2;
var toggleArrowTopVerticalOffset = (toggleButtonHeight - toggleArrowHeight) / 2;
var toggleArrowBottomVerticalOffset = toggleArrowTopVerticalOffset - toggleArrowWidth + toggleArrowHeight / 2;
var opacityTransition = 'opacity ' + (__WEBPACK_IMPORTED_MODULE_2__shared_variables__["b" /* animationTimeUnitless */] + 100) + 'ms ease-in-out ' + __WEBPACK_IMPORTED_MODULE_2__shared_variables__["b" /* animationTimeUnitless */] + 'ms';
var transformTransition = 'transform ' + __WEBPACK_IMPORTED_MODULE_2__shared_variables__["a" /* animationTime */] + ' ease-in-out';

var ResizerButtonInner = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].button(_templateObject, toggleButtonHeight / 2, toggleButtonHeight, __WEBPACK_IMPORTED_MODULE_2__shared_variables__["n" /* gridSize */] * 3, __WEBPACK_IMPORTED_MODULE_2__shared_variables__["s" /* resizerVisibleWidth */] / 2, Object(__WEBPACK_IMPORTED_MODULE_3__utils_mixins__["a" /* focusOutline */])(__WEBPACK_IMPORTED_MODULE_2__shared_variables__["x" /* unthemedColors */].resizer), __WEBPACK_IMPORTED_MODULE_2__shared_variables__["x" /* unthemedColors */].resizer, toggleArrowWidth, toggleArrowHeight, toggleArrowHeight / 2, function (props) {
  return props.isVisible ? 1 : 0;
}, transformTransition, opacityTransition, toggleArrowTopVerticalOffset, toggleArrowWidth / 2, toggleArrowHeight / 2 - toggleArrowWidth / 2, toggleArrowBottomVerticalOffset, toggleArrowWidth / 2, toggleArrowWidth / 2, function (_ref) {
  var isPointingRight = _ref.isPointingRight;
  return isPointingRight ? '-40deg' : '40deg';
}, function (_ref2) {
  var isPointingRight = _ref2.isPointingRight;
  return isPointingRight ? '40deg' : '-40deg';
});

ResizerButtonInner.displayName = 'ResizerButtonInner';
/* harmony default export */ __webpack_exports__["a"] = (ResizerButtonInner);

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styled_SpacerInner__ = __webpack_require__(619);








var Spacer = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Spacer, _PureComponent);

  function Spacer() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Spacer);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Spacer.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Spacer)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Spacer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          innerRef = _props.innerRef,
          onTransitionEnd = _props.onTransitionEnd,
          shouldAnimate = _props.shouldAnimate,
          width = _props.width;


      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__styled_SpacerInner__["a" /* default */],
        {
          innerRef: innerRef,
          onTransitionEnd: onTransitionEnd,
          shouldAnimate: shouldAnimate,
          style: { width: width }
        },
        children
      );
    }
  }]);

  return Spacer;
}(__WEBPACK_IMPORTED_MODULE_5_react__["PureComponent"]);

Spacer.defaultProps = {
  shouldAnimate: false,
  width: 0
};
/* harmony default export */ __webpack_exports__["a"] = (Spacer);

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_variables__ = __webpack_require__(10);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  transition: ', ';\n'], ['\n  transition: ', ';\n']);




var SpacerInner = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, function (_ref) {
  var shouldAnimate = _ref.shouldAnimate;
  return shouldAnimate ? 'width ' + __WEBPACK_IMPORTED_MODULE_2__shared_variables__["p" /* resizeAnimationTime */] : 'none';
});

SpacerInner.displayName = 'SpacerInner';
/* harmony default export */ __webpack_exports__["a"] = (SpacerInner);

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_memoize_one__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util__ = __webpack_require__(11);











var getTheme = Object(__WEBPACK_IMPORTED_MODULE_8_memoize_one__["a" /* default */])(function (isElectronMac) {
  return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_9__util__["j" /* isElectronMacKey */], isElectronMac);
});

var WithElectronTheme = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(WithElectronTheme, _PureComponent);

  function WithElectronTheme() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, WithElectronTheme);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (WithElectronTheme.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(WithElectronTheme)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(WithElectronTheme, [{
    key: 'render',
    value: function render() {
      var theme = getTheme(this.props.isElectronMac);
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_styled_components__["ThemeProvider"],
        { theme: theme },
        this.props.children
      );
    }
  }]);

  return WithElectronTheme;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

WithElectronTheme.defaultProps = {
  isElectronMac: false
};
/* harmony default export */ __webpack_exports__["a"] = (WithElectronTheme);

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_item__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styled_NavigationItemGroupTitle__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styled_NavigationItemGroupSeparator__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styled_NavigationItemGroupHeader__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styled_NavigationItemGroupAction__ = __webpack_require__(625);












var NavigationItemGroup = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(NavigationItemGroup, _Component);

  function NavigationItemGroup() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, NavigationItemGroup);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (NavigationItemGroup.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(NavigationItemGroup)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(NavigationItemGroup, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          title = _props.title,
          action = _props.action,
          isCompact = _props.isCompact,
          hasSeparator = _props.hasSeparator,
          children = _props.children,
          innerRef = _props.innerRef;


      var wrappedTitle = title ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__styled_NavigationItemGroupTitle__["a" /* default */],
        null,
        title
      ) : null;

      var wrappedAction = action ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10__styled_NavigationItemGroupAction__["a" /* default */],
        null,
        action
      ) : null;

      var separator = hasSeparator ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__styled_NavigationItemGroupSeparator__["a" /* default */], null) : null;

      var header = title || action ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__styled_NavigationItemGroupHeader__["a" /* default */],
        null,
        wrappedTitle
      ) : null;

      var groupHeading = separator || header ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        null,
        separator,
        header
      ) : null;

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__atlaskit_item__["a" /* ItemGroup */],
        {
          title: groupHeading,
          elemAfter: wrappedAction,
          isCompact: isCompact,
          innerRef: innerRef
        },
        children
      );
    }
  }]);

  return NavigationItemGroup;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

NavigationItemGroup.defaultProps = {
  isCompact: false,
  hasSeparator: false
};
/* harmony default export */ __webpack_exports__["a"] = (NavigationItemGroup);

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__theme_util__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_mixins__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_variables__ = __webpack_require__(10);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  font-size: ', 'px;\n  line-height: ', ';\n  font-weight: 600;\n  ', ' ', ';\n'], ['\n  font-size: ', 'px;\n  line-height: ', ';\n  font-weight: 600;\n  ', ' ', ';\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    display: none;\n  '], ['\n    display: none;\n  ']);






var groupTitleFontSize = 11;

var NavigationItemGroupTitle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, groupTitleFontSize, __WEBPACK_IMPORTED_MODULE_4__shared_variables__["n" /* gridSize */] * 2 / groupTitleFontSize, Object(__WEBPACK_IMPORTED_MODULE_3__utils_mixins__["b" /* truncate */])(), Object(__WEBPACK_IMPORTED_MODULE_2__theme_util__["n" /* whenCollapsedAndNotInOverflowDropdown */])(_templateObject2));

NavigationItemGroupTitle.displayName = 'NavigationItemGroupTitle';
/* harmony default export */ __webpack_exports__["a"] = (NavigationItemGroupTitle);

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_variables__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__theme_util__ = __webpack_require__(11);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  margin-top: ', 'px;\n  margin-bottom: ', 'px;\n  margin-left: -', 'px;\n  height: ', 'px;\n  background: ', ';\n  border-radius: 1px;\n'], ['\n  margin-top: ', 'px;\n  margin-bottom: ', 'px;\n  margin-left: -', 'px;\n  height: ', 'px;\n  background: ', ';\n  border-radius: 1px;\n']);





var dividerLineHeight = 2;
var dividerTotalHeight = __WEBPACK_IMPORTED_MODULE_2__shared_variables__["n" /* gridSize */] * 5;

var NavigationItemGroupSeparator = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, (dividerTotalHeight - dividerLineHeight) / 2, (dividerTotalHeight - dividerLineHeight) / 2, __WEBPACK_IMPORTED_MODULE_2__shared_variables__["n" /* gridSize */], dividerLineHeight, function (_ref) {
  var theme = _ref.theme;
  return Object(__WEBPACK_IMPORTED_MODULE_3__theme_util__["e" /* getProvided */])(theme).keyline;
});

NavigationItemGroupSeparator.displayName = 'NavigationItemGroupSeparator';

/* harmony default export */ __webpack_exports__["a"] = (NavigationItemGroupSeparator);

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_variables__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__theme_util__ = __webpack_require__(11);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  ', ' ', ';\n'], ['\n  display: flex;\n  ', ' ', ';\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    margin-left: -', 'px;\n    margin-top: ', 'px;\n  '], ['\n    margin-left: -', 'px;\n    margin-top: ', 'px;\n  ']),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    margin-left: -', 'px;\n    margin-right: -', 'px;\n    margin-top: ', 'px;\n    margin-bottom: ', 'px;\n    border-top: 1px solid ', ';\n  '], ['\n    margin-left: -', 'px;\n    margin-right: -', 'px;\n    margin-top: ', 'px;\n    margin-bottom: ', 'px;\n    border-top: 1px solid ', ';\n  ']);





var NavigationItemGroupHeader = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, Object(__WEBPACK_IMPORTED_MODULE_3__theme_util__["p" /* whenNotInOverflowDropdown */])(_templateObject2, __WEBPACK_IMPORTED_MODULE_2__shared_variables__["n" /* gridSize */], __WEBPACK_IMPORTED_MODULE_2__shared_variables__["n" /* gridSize */] * 1.5), Object(__WEBPACK_IMPORTED_MODULE_3__theme_util__["n" /* whenCollapsedAndNotInOverflowDropdown */])(_templateObject3, __WEBPACK_IMPORTED_MODULE_2__shared_variables__["n" /* gridSize */], __WEBPACK_IMPORTED_MODULE_2__shared_variables__["n" /* gridSize */], __WEBPACK_IMPORTED_MODULE_2__shared_variables__["n" /* gridSize */], __WEBPACK_IMPORTED_MODULE_2__shared_variables__["n" /* gridSize */], function (_ref) {
  var theme = _ref.theme;
  return Object(__WEBPACK_IMPORTED_MODULE_3__theme_util__["e" /* getProvided */])(theme).keyline;
}));

NavigationItemGroupHeader.displayName = 'NavigationItemGroupHeader';
/* harmony default export */ __webpack_exports__["a"] = (NavigationItemGroupHeader);

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_variables__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__theme_util__ = __webpack_require__(11);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  margin-left: ', 'px;\n  min-width: ', 'px;\n\n  ', ' ', ';\n'], ['\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  margin-left: ', 'px;\n  min-width: ', 'px;\n\n  ', ' ', ';\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    display: none;\n  '], ['\n    display: none;\n  ']),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    margin-top: ', 'px;\n  '], ['\n    margin-top: ', 'px;\n  ']);





var NavigationItemGroupAction = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, __WEBPACK_IMPORTED_MODULE_2__shared_variables__["n" /* gridSize */] / 2, __WEBPACK_IMPORTED_MODULE_2__shared_variables__["n" /* gridSize */] * 3, Object(__WEBPACK_IMPORTED_MODULE_3__theme_util__["m" /* whenCollapsed */])(_templateObject2), Object(__WEBPACK_IMPORTED_MODULE_3__theme_util__["p" /* whenNotInOverflowDropdown */])(_templateObject3, __WEBPACK_IMPORTED_MODULE_2__shared_variables__["n" /* gridSize */]));

NavigationItemGroupAction.displayName = 'NavigationItemGroupAction';
/* harmony default export */ __webpack_exports__["a"] = (NavigationItemGroupAction);

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styled_ContainerLogo__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__theme_util__ = __webpack_require__(11);










var ContainerLogo = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ContainerLogo, _PureComponent);

  function ContainerLogo() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ContainerLogo);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ContainerLogo.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ContainerLogo)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ContainerLogo, [{
    key: 'render',
    value: function render() {
      /* eslint-disable react/prop-types */
      // theme is passed in via context and not part of the props API for this component
      var isNavCollapsed = this.props.theme[__WEBPACK_IMPORTED_MODULE_8__theme_util__["l" /* rootKey */]] ? this.props.theme[__WEBPACK_IMPORTED_MODULE_8__theme_util__["l" /* rootKey */]].isCollapsed : false;
      /* eslint-enable react/prop-types */

      return isNavCollapsed ? null : __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__styled_ContainerLogo__["a" /* default */],
        null,
        this.props.children
      );
    }
  }]);

  return ContainerLogo;
}(__WEBPACK_IMPORTED_MODULE_5_react__["PureComponent"]);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6_styled_components__["withTheme"])(ContainerLogo));

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_variables__ = __webpack_require__(10);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  height: ', 'px;\n  padding: ', 'px ', 'px;\n'], ['\n  height: ', 'px;\n  padding: ', 'px ', 'px;\n']);




var ContainerLogo = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, __WEBPACK_IMPORTED_MODULE_2__shared_variables__["n" /* gridSize */] * 4, __WEBPACK_IMPORTED_MODULE_2__shared_variables__["n" /* gridSize */] * 1.5, __WEBPACK_IMPORTED_MODULE_2__shared_variables__["n" /* gridSize */] / 2);

ContainerLogo.displayName = 'ContainerLogo';
/* harmony default export */ __webpack_exports__["a"] = (ContainerLogo);

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__atlaskit_item__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_memoize_one__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__NavigationItem__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styled_ContainerTitleIcon__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styled_ContainerTitleText__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__theme_util__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__theme_create_container_title_item_theme__ = __webpack_require__(281);
















var key = __WEBPACK_IMPORTED_MODULE_8__atlaskit_item__["c" /* itemThemeNamespace */];

var ContainerTitle = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ContainerTitle, _PureComponent);

  function ContainerTitle() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ContainerTitle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = ContainerTitle.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(ContainerTitle)).call.apply(_ref, [this].concat(args))), _this), _this.withOuterTheme = Object(__WEBPACK_IMPORTED_MODULE_9_memoize_one__["a" /* default */])(function (outerTheme) {
      return Object(__WEBPACK_IMPORTED_MODULE_14__theme_create_container_title_item_theme__["a" /* default */])(outerTheme, key);
    }), _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ContainerTitle, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          text = _props.text,
          subText = _props.subText,
          icon = _props.icon;

      /* eslint-disable react/prop-types */
      // theme is passed in via context and not part of the props API for this component

      var isNavCollapsed = this.props.theme[__WEBPACK_IMPORTED_MODULE_13__theme_util__["l" /* rootKey */]] ? this.props.theme[__WEBPACK_IMPORTED_MODULE_13__theme_util__["l" /* rootKey */]].isCollapsed : false;
      var theme = this.withOuterTheme(this.props.theme);
      /* eslint-enable react/prop-types */

      var interactiveWrapperProps = {
        onClick: this.props.onClick,
        onKeyDown: this.props.onKeyDown,
        onMouseEnter: this.props.onMouseEnter,
        onMouseLeave: this.props.onMouseLeave,
        href: this.props.href,
        linkComponent: this.props.linkComponent
      };

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_styled_components__["ThemeProvider"],
        { theme: theme },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__NavigationItem__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          icon: isNavCollapsed ? null : __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_11__styled_ContainerTitleIcon__["a" /* default */],
            null,
            icon
          ),
          subText: isNavCollapsed ? null : subText,
          text: isNavCollapsed ? __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_11__styled_ContainerTitleIcon__["a" /* default */],
            { 'aria-label': text },
            icon
          ) : __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_12__styled_ContainerTitleText__["a" /* default */],
            null,
            text
          )
        }, interactiveWrapperProps))
      );
    }
  }]);

  return ContainerTitle;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_styled_components__["withTheme"])(ContainerTitle));

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__theme_util__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_variables__ = __webpack_require__(10);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  align-items: center;\n  display: flex;\n  flex-shrink: 0;\n  justify-content: center;\n  margin-left: ', 'px;\n\n  ', ';\n'], ['\n  align-items: center;\n  display: flex;\n  flex-shrink: 0;\n  justify-content: center;\n  margin-left: ', 'px;\n\n  ', ';\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    flex-shrink: 1;\n    margin: 0;\n    opacity: 0;\n  '], ['\n    flex-shrink: 1;\n    margin: 0;\n    opacity: 0;\n  ']);





var NavigationItemAction = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, __WEBPACK_IMPORTED_MODULE_3__shared_variables__["n" /* gridSize */] / 2, Object(__WEBPACK_IMPORTED_MODULE_2__theme_util__["m" /* whenCollapsed */])(_templateObject2));

NavigationItemAction.displayName = 'NavigationItemAction';
/* harmony default export */ __webpack_exports__["a"] = (NavigationItemAction);

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__theme_util__ = __webpack_require__(11);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: ', ';\n  min-width: ', ';\n'], ['\n  display: ', ';\n  min-width: ', ';\n']);




var getDisplay = function getDisplay(_ref) {
  var theme = _ref.theme,
      isDropdownTrigger = _ref.isDropdownTrigger;

  if (isDropdownTrigger && Object(__WEBPACK_IMPORTED_MODULE_2__theme_util__["g" /* isCollapsed */])(theme)) {
    return 'none';
  }

  return 'block';
};

var NavigationItemAfter = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, getDisplay, function (_ref2) {
  var shouldTakeSpace = _ref2.shouldTakeSpace;
  return shouldTakeSpace ? '24px' : 0;
});

NavigationItemAfter.displayName = 'NavigationItemAfter';
/* harmony default export */ __webpack_exports__["a"] = (NavigationItemAfter);

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__theme_util__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_variables__ = __webpack_require__(10);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  color: ', ';\n  margin-left: ', 'px;\n'], ['\n  color: ', ';\n  margin-left: ', 'px;\n']);





var NavigationItemCaption = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].span(_templateObject, function (_ref) {
  var theme = _ref.theme;
  return Object(__WEBPACK_IMPORTED_MODULE_2__theme_util__["e" /* getProvided */])(theme).subText;
}, __WEBPACK_IMPORTED_MODULE_3__shared_variables__["o" /* layout */].padding.side);

NavigationItemCaption.displayName = 'NavigationItemCaption';
/* harmony default export */ __webpack_exports__["a"] = (NavigationItemCaption);

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_variables__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__theme_util__ = __webpack_require__(11);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  align-items: center;\n  justify-content: center;\n  display: ', ';\n  flex-shrink: 0;\n  transition: padding 200ms;\n\n  > * {\n    flex: 1 0 auto;\n  }\n\n  /* We need to ensure that any image passed in as a child (<img/>, <svg/>\n    etc.) receives the correct width, height and border radius. We don\'t\n    currently assume that the image passed in is the correct dimensions, or has\n    width / height 100% */\n  > img {\n    height: ', 'px;\n    width: ', 'px;\n  }\n'], ['\n  align-items: center;\n  justify-content: center;\n  display: ', ';\n  flex-shrink: 0;\n  transition: padding 200ms;\n\n  > * {\n    flex: 1 0 auto;\n  }\n\n  /* We need to ensure that any image passed in as a child (<img/>, <svg/>\n    etc.) receives the correct width, height and border radius. We don\'t\n    currently assume that the image passed in is the correct dimensions, or has\n    width / height 100% */\n  > img {\n    height: ', 'px;\n    width: ', 'px;\n  }\n']);





var getDisplay = function getDisplay(_ref) {
  var theme = _ref.theme,
      isDropdownTrigger = _ref.isDropdownTrigger;

  if (isDropdownTrigger && Object(__WEBPACK_IMPORTED_MODULE_3__theme_util__["g" /* isCollapsed */])(theme)) {
    return 'none';
  }
  return 'flex';
};

var iconSize = __WEBPACK_IMPORTED_MODULE_2__shared_variables__["n" /* gridSize */] * 3;

var NavigationItemIcon = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, getDisplay, iconSize, iconSize);

NavigationItemIcon.displayName = 'NavigationItemIcon';
/* harmony default export */ __webpack_exports__["a"] = (NavigationItemIcon);

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__theme_util__ = __webpack_require__(11);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  position: relative;\n  z-index: 1;\n\n  ', ';\n'], ['\n  position: relative;\n  z-index: 1;\n\n  ', ';\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    opacity: 0;\n  '], ['\n    opacity: 0;\n  ']);




var NavigationItemTextAfter = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, Object(__WEBPACK_IMPORTED_MODULE_2__theme_util__["m" /* whenCollapsed */])(_templateObject2));

NavigationItemTextAfter.displayName = 'NavigationItemTextAfter';
/* harmony default export */ __webpack_exports__["a"] = (NavigationItemTextAfter);

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n'], ['\n  display: flex;\n']);



var NavigationItemAfterWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject);

NavigationItemAfterWrapper.displayName = 'NavigationItemAfterWrapper';
/* harmony default export */ __webpack_exports__["a"] = (NavigationItemAfterWrapper);

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
  var result;
  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      if (isHostObject(value)) {
        return object ? value : {};
      }
      result = initCloneObject(isFunc ? {} : value);
      if (!isDeep) {
        return copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (!isArr) {
    var props = isFull ? getAllKeys(value) : keys(value);
  }
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
  });
  return result;
}

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */
function baseCreate(proto) {
  return isObject(proto) ? objectCreate(proto) : {};
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var result = new buffer.constructor(buffer.length);
  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor);
}

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor);
}

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag:
      return cloneSymbol(object);
  }
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, true, true);
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = cloneDeep;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(72), __webpack_require__(636)(module)))

/***/ }),
/* 636 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_item__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__atlaskit_dropdown_menu__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__atlaskit_icon_glyph_chevron_down__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__atlaskit_icon_glyph_chevron_down___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__atlaskit_icon_glyph_chevron_down__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_memoize_one__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__NavigationItem__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styled_ContainerTitleIcon__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styled_ContainerTitleText__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__theme_util__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__theme_create_container_title_item_theme__ = __webpack_require__(281);

















var key = __WEBPACK_IMPORTED_MODULE_7__atlaskit_item__["c" /* itemThemeNamespace */];

var ContainerTitleDropdown = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ContainerTitleDropdown, _PureComponent);

  function ContainerTitleDropdown() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ContainerTitleDropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = ContainerTitleDropdown.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ContainerTitleDropdown)).call.apply(_ref, [this].concat(args))), _this), _this.withOuterTheme = Object(__WEBPACK_IMPORTED_MODULE_10_memoize_one__["a" /* default */])(function (outerTheme) {
      return Object(__WEBPACK_IMPORTED_MODULE_15__theme_create_container_title_item_theme__["a" /* default */])(outerTheme, key);
    }), _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ContainerTitleDropdown, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          icon = _props.icon,
          subText = _props.subText,
          text = _props.text,
          defaultDropdownOpen = _props.defaultDropdownOpen,
          isDropdownOpen = _props.isDropdownOpen,
          isDropdownLoading = _props.isDropdownLoading,
          onDropdownOpenChange = _props.onDropdownOpenChange;

      /* eslint-disable react/prop-types */
      // theme is passed in via context and not part of the props API for this component

      var isNavCollapsed = this.props.theme[__WEBPACK_IMPORTED_MODULE_14__theme_util__["l" /* rootKey */]] ? this.props.theme[__WEBPACK_IMPORTED_MODULE_14__theme_util__["l" /* rootKey */]].isCollapsed : false;
      var theme = this.withOuterTheme(this.props.theme);
      /* eslint-enable react/prop-types */

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__atlaskit_dropdown_menu__["a" /* default */],
        {
          appearance: 'tall',
          shouldFitContainer: !isNavCollapsed,
          position: isNavCollapsed ? 'right top' : 'bottom left',
          shouldFlip: false,
          defaultOpen: defaultDropdownOpen,
          isLoading: isDropdownLoading,
          isOpen: isDropdownOpen,
          onOpenChange: onDropdownOpenChange,
          trigger: __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_styled_components__["ThemeProvider"],
            { theme: theme },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__NavigationItem__["a" /* default */], {
              dropIcon: isNavCollapsed ? null : __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__atlaskit_icon_glyph_chevron_down___default.a, { label: 'chevron' }),
              isDropdownTrigger: true,
              icon: isNavCollapsed ? null : __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_12__styled_ContainerTitleIcon__["a" /* default */],
                null,
                icon
              ),
              subText: isNavCollapsed ? null : subText,
              text: isNavCollapsed ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_12__styled_ContainerTitleIcon__["a" /* default */],
                { 'aria-label': text },
                icon
              ) : __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_13__styled_ContainerTitleText__["a" /* default */],
                null,
                text
              )
            })
          )
        },
        children
      );
    }
  }]);

  return ContainerTitleDropdown;
}(__WEBPACK_IMPORTED_MODULE_5_react__["PureComponent"]);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6_styled_components__["withTheme"])(ContainerTitleDropdown));

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DropdownMenuStateless__ = __webpack_require__(282);









var DropdownMenu = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(DropdownMenu, _Component);

  function DropdownMenu() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, DropdownMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = DropdownMenu.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(DropdownMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isOpen: _this.props.defaultOpen,
      items: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this.props.items))
    }, _this.findActivatedGroup = function (item) {
      return _this.state.items.filter(function (group) {
        return group.items.indexOf(item) > -1;
      })[0];
    }, _this.handleItemActivation = function (attrs) {
      var activatedItem = attrs.item;
      var activatedGroup = _this.findActivatedGroup(activatedItem);
      var items = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this.state.items));

      switch (activatedItem.type) {
        case 'checkbox':
          activatedItem.isChecked = !activatedItem.isChecked;
          _this.props.onItemActivated({ item: activatedItem });
          _this.setState({ items: items });
          break;
        case 'radio':
          activatedGroup.items.forEach(function (i) {
            if (i === activatedItem) {
              i.isChecked = true; // eslint-disable-line no-param-reassign
            } else {
              i.isChecked = false; // eslint-disable-line no-param-reassign
            }
          });
          _this.props.onItemActivated({ item: activatedItem });
          _this.setState({ items: items });
          break;
        case 'link':
        default:
          _this.props.onItemActivated({ item: activatedItem });
          _this.close();
          break;
      }
    }, _this.handleOpenChange = function (attrs) {
      if (_this.state.isOpen === attrs.isOpen) return;
      _this.setState({ isOpen: attrs.isOpen });
      _this.props.onOpenChange(attrs);
    }, _this.close = function () {
      if (_this.state.isOpen === false) return;
      _this.setState({ isOpen: false });
      _this.props.onOpenChange({ isOpen: false });
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  } // eslint-disable-line react/sort-comp

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(DropdownMenu, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.items !== this.state.items) {
        this.setState({ items: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(nextProps.items)) });
      }
      if (nextProps.isOpen !== this.props.isOpen) {
        this.setState({ isOpen: nextProps.isOpen });
      }
    } // eslint-disable-line

  }, {
    key: 'render',
    value: function render() {
      var isOpen = this.state.isOpen;
      var _props = this.props,
          appearance = _props.appearance,
          boundariesElement = _props.boundariesElement,
          children = _props.children,
          isLoading = _props.isLoading,
          items = _props.items,
          position = _props.position,
          isMenuFixed = _props.isMenuFixed,
          shouldAllowMultilineItems = _props.shouldAllowMultilineItems,
          shouldFitContainer = _props.shouldFitContainer,
          shouldFlip = _props.shouldFlip,
          trigger = _props.trigger,
          triggerButtonProps = _props.triggerButtonProps,
          triggerType = _props.triggerType,
          onPositioned = _props.onPositioned;


      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__DropdownMenuStateless__["a" /* default */],
        {
          appearance: appearance,
          boundariesElement: boundariesElement,
          isOpen: isOpen,
          isLoading: isLoading,
          items: items,
          onItemActivated: this.handleItemActivation,
          onOpenChange: this.handleOpenChange,
          position: position,
          isMenuFixed: isMenuFixed,
          shouldAllowMultilineItems: shouldAllowMultilineItems,
          shouldFitContainer: shouldFitContainer,
          shouldFlip: shouldFlip,
          trigger: trigger,
          triggerButtonProps: triggerButtonProps,
          triggerType: triggerType,
          onPositioned: onPositioned
        },
        children
      );
    }
  }]);

  return DropdownMenu;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

DropdownMenu.defaultProps = {
  appearance: 'default',
  boundariesElement: 'viewport',
  defaultOpen: false,
  isLoading: false,
  isOpen: false,
  items: [],
  onItemActivated: function onItemActivated() {},
  onOpenChange: function onOpenChange() {},
  position: 'bottom left',
  isMenuFixed: false,
  shouldAllowMultilineItems: false,
  shouldFitContainer: false,
  shouldFlip: true,
  triggerType: 'default',
  onPositioned: function onPositioned() {}
};
/* harmony default export */ __webpack_exports__["a"] = (DropdownMenu);

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Droplist__ = __webpack_require__(640);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Droplist__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Item__ = __webpack_require__(656);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__components_Item__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Group__ = __webpack_require__(674);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__components_Group__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styled_Item__ = __webpack_require__(167);
/* unused harmony reexport SecondaryText */





/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DroplistWithoutAnalytics */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_analytics_next__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__atlaskit_layer__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__atlaskit_spinner__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__atlaskit_theme__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__package_json__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styled_Droplist__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__theme_item_theme__ = __webpack_require__(655);
















var halfFocusRing = 1;
var dropOffset = '0 ' + Object(__WEBPACK_IMPORTED_MODULE_11__atlaskit_theme__["d" /* gridSize */])() + 'px';

var Droplist = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Droplist, _Component);

  function Droplist() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Droplist);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Droplist.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Droplist)).call.apply(_ref, [this].concat(args))), _this), _this.componentDidMount = function () {
      _this.setContentWidth();
      // We use a captured event here to avoid a radio or checkbox dropdown item firing its
      // click event first, which would cause a re-render of the element and prevent Droplist
      // from detecting the actual source of this original click event.
      document.addEventListener('click', _this.handleClickOutside, true);
      document.addEventListener('keydown', _this.handleEsc);
    }, _this.componentDidUpdate = function () {
      if (_this.props.isOpen) {
        _this.setContentWidth();
      }
    }, _this.componentWillUnmount = function () {
      document.removeEventListener('click', _this.handleClickOutside, true);
      document.removeEventListener('keydown', _this.handleEsc);
    }, _this.setContentWidth = function () {
      var _this2 = _this,
          dropContentRef = _this2.dropContentRef,
          triggerRef = _this2.triggerRef;
      var shouldFitContainer = _this.props.shouldFitContainer;

      // We need to manually set the content width to match the trigger width
      // if props.shouldFitContainer is true

      if (shouldFitContainer && dropContentRef && triggerRef) {
        dropContentRef.style.width = triggerRef.offsetWidth - halfFocusRing * 2 + 'px';
      }
    }, _this.handleEsc = function (event) {
      if (event.key === 'Escape') {
        _this.close(event);
      }
    }, _this.handleClickOutside = function (event) {
      if (_this.props.isOpen) {
        // $FlowFixMe - flow is lost and if not an instance of Node
        if (event.target instanceof Node) {
          // Rather than check for the target within the entire Droplist, we specify the trigger/content.
          // This aids with future effort in scroll-locking Droplist when isMenuFixed is enabled; the scroll
          // blanket which stretches to the viewport should not stop 'close' from being triggered.
          var withinTrigger = _this.triggerRef && _this.triggerRef.contains(event.target);
          var withinContent = _this.dropContentRef && _this.dropContentRef.contains(event.target);

          if (!withinTrigger && !withinContent) {
            _this.close(event);
          }
        }
      }
    }, _this.close = function (event) {
      if (_this.props.onOpenChange) {
        _this.props.onOpenChange({ isOpen: false, event: event });
      }
    }, _this.handleContentRef = function (ref) {
      _this.dropContentRef = ref;

      // If the dropdown has just been opened, we focus on the containing element so the
      // user can tab to the first dropdown item. We will only receive this ref if isOpen
      // is true or null, so no need to check for truthiness here.
      if (ref) {
        ref.focus();
      }
    }, _this.handleTriggerRef = function (ref) {
      _this.triggerRef = ref;
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Droplist, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return { shouldAllowMultilineItems: this.props.shouldAllowMultilineItems };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          appearance = _props.appearance,
          boundariesElement = _props.boundariesElement,
          children = _props.children,
          isLoading = _props.isLoading,
          isOpen = _props.isOpen,
          maxHeight = _props.maxHeight,
          onClick = _props.onClick,
          onKeyDown = _props.onKeyDown,
          position = _props.position,
          isMenuFixed = _props.isMenuFixed,
          shouldFitContainer = _props.shouldFitContainer,
          shouldFlip = _props.shouldFlip,
          trigger = _props.trigger,
          onPositioned = _props.onPositioned;


      var layerContent = isOpen ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_13__styled_Droplist__["a" /* Content */],
        {
          'data-role': 'droplistContent',
          isTall: appearance === 'tall',
          innerRef: this.handleContentRef,
          maxHeight: maxHeight
        },
        isLoading ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_13__styled_Droplist__["b" /* SpinnerContainer */],
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__atlaskit_spinner__["a" /* default */], { size: 'small' })
        ) : __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_styled_components__["ThemeProvider"],
          { theme: __WEBPACK_IMPORTED_MODULE_14__theme_item_theme__["a" /* default */] },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'div',
            null,
            children
          )
        )
      ) : null;

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_13__styled_Droplist__["d" /* default */],
        { fit: shouldFitContainer, onClick: onClick, onKeyDown: onKeyDown },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__atlaskit_layer__["a" /* default */],
          {
            autoFlip: shouldFlip,
            boundariesElement: boundariesElement,
            content: layerContent,
            offset: dropOffset
            // $FlowFixMe - Cannot create `Layer` element because in property `position
            , position: position,
            isAlwaysFixed: isOpen && isMenuFixed,
            onPositioned: onPositioned
          },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_13__styled_Droplist__["c" /* Trigger */],
            { fit: shouldFitContainer, innerRef: this.handleTriggerRef },
            trigger
          )
        )
      );
    }
  }]);

  return Droplist;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Droplist.defaultProps = {
  appearance: 'default',
  boundariesElement: 'viewport',
  children: null,
  isLoading: false,
  isOpen: false,
  onClick: function onClick() {},
  onKeyDown: function onKeyDown() {},
  onOpenChange: function onOpenChange() {},
  position: 'bottom left',
  isMenuFixed: false,
  shouldAllowMultilineItems: false,
  shouldFitContainer: false,
  shouldFlip: true,
  trigger: null,
  onPositioned: function onPositioned() {}
};
Droplist.childContextTypes = {
  shouldAllowMultilineItems: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
};



var createAndFireEventOnAtlaskit = Object(__WEBPACK_IMPORTED_MODULE_7__atlaskit_analytics_next__["b" /* createAndFireEvent */])('atlaskit');

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__atlaskit_analytics_next__["c" /* withAnalyticsContext */])({
  componentName: 'droplist',
  packageName: __WEBPACK_IMPORTED_MODULE_12__package_json__["name"],
  packageVersion: __WEBPACK_IMPORTED_MODULE_12__package_json__["version"]
})(Object(__WEBPACK_IMPORTED_MODULE_7__atlaskit_analytics_next__["d" /* withAnalyticsEvents */])({
  onOpenChange: createAndFireEventOnAtlaskit({
    action: 'toggled',
    actionSubject: 'droplist',

    attributes: {
      componentName: 'droplist',
      packageName: __WEBPACK_IMPORTED_MODULE_12__package_json__["name"],
      packageVersion: __WEBPACK_IMPORTED_MODULE_12__package_json__["version"]
    }
  })
})(Droplist)));

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Layer__ = __webpack_require__(642);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Layer__["a"]; });


/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_raf_schd__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__popper_index_min__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__popper_index_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__popper_index_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__internal_ScrollBlock__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__internal_helpers__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styledContentContainer__ = __webpack_require__(646);









var _templateObject = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ';\n'], ['\n  ', ';\n']);










/* eslint-disable react/no-unused-prop-types */

// We create a dummy target when making the menu fixed so that we can force popper.js to use fixed positioning
// without affecting child layout of the actual target since children of fixed position elements can't use percentage
// heights/widths.
var FixedTarget = __WEBPACK_IMPORTED_MODULE_9_styled_components__["default"].div(_templateObject, function (_ref) {
  var fixedOffset = _ref.fixedOffset,
      targetRef = _ref.targetRef;

  if (fixedOffset && targetRef) {
    var actualTarget = targetRef.firstChild;
    var rect = actualTarget.getBoundingClientRect();
    return '\n        position: fixed;\n        top: ' + fixedOffset.top + 'px;\n        left: ' + fixedOffset.left + 'px;\n        height: ' + rect.height + 'px;\n        width: ' + rect.width + 'px;\n        z-index: -1;\n      ';
  }
  return 'display: none;';
});

var Layer = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Layer, _Component);

  function Layer(props) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Layer);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Layer.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Layer)).call(this, props));

    _this.extractStyles = function (state) {
      if (state) {
        var popperHeight = state.offsets.popper.height;
        var left = Math.round(state.offsets.popper.left);
        // The offset position is sometimes an object and sometimes just a string...
        var _cssPosition = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(state.offsets.popper.position) === 'object' ? state.offsets.popper.position.position : state.offsets.popper.position;
        var top = _this.fixPositionTopUnderflow(state.offsets.popper.top, _cssPosition);

        var _originalHeight = _this.state.originalHeight || popperHeight;
        var _maxHeight = _this.calculateMaxHeight(_originalHeight, popperHeight, top, _cssPosition);
        _this.setState({
          // position: fixed or absolute
          cssPosition: _cssPosition,
          hasExtractedStyles: true,
          transform: 'translate3d(' + left + 'px, ' + top + 'px, 0px)',
          // state.flipped is either true or undefined
          flipped: !!state.flipped,
          actualPosition: state.position,
          originalPosition: state.originalPosition,
          originalHeight: _originalHeight,
          maxHeight: _maxHeight
        });
      }
    };

    _this.state = {
      hasExtractedStyles: false,
      position: null,
      transform: null,
      flipped: false,
      actualPosition: null,
      // We set these default offsets to prevent a flash of popper content in the wrong position
      // which can cause incorrect height calculations. Popper will calculate these values
      offsets: {
        popper: {
          left: -9999,
          top: -9999
        }
      },
      originalPosition: null,
      // fix Safari parent width: https://product-fabric.atlassian.net/browse/ED-1784
      cssPosition: 'absolute',
      originalHeight: null,
      maxHeight: null,
      fixedOffset: null
    };

    _this.extractStyles = Object(__WEBPACK_IMPORTED_MODULE_10_raf_schd__["a" /* default */])(_this.extractStyles.bind(_this));
    return _this;
  }

  // TODO: get the value of zIndex from theme, not using it now as it is not
  // working with extract-react-types


  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Layer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.applyPopper(this.props);
      this.calculateFixedOffset(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.applyPopper(nextProps);
      this.calculateFixedOffset(nextProps);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _props = this.props,
          onFlippedChange = _props.onFlippedChange,
          onPositioned = _props.onPositioned;
      var _state = this.state,
          flipped = _state.flipped,
          actualPosition = _state.actualPosition,
          originalPosition = _state.originalPosition,
          hasExtractedStyles = _state.hasExtractedStyles;


      if (prevState.flipped !== flipped && onFlippedChange) {
        onFlippedChange({ flipped: flipped, actualPosition: actualPosition, originalPosition: originalPosition });
      }

      // This flag is set the first time the position is calculated from Popper and applied to the content
      if (!prevState.hasExtractedStyles && hasExtractedStyles && onPositioned) {
        onPositioned();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.extractStyles.cancel();
      if (this.popper) {
        this.popper.destroy();
      }
    }

    /* Calculate the max height of the popper if it's height is greater than the viewport to prevent
     * the bottom of the popper not being viewable.
     * Only works if the popper uses viewport as the boundary and has a fixed position ancestor.
     */

  }, {
    key: 'calculateMaxHeight',
    value: function calculateMaxHeight(originalHeight, currentHeight, positionTop, cssPosition) {
      var DocumentElementClientHeight = 0;

      if (document.documentElement) {
        DocumentElementClientHeight = document.documentElement.clientHeight;
      }
      if (cssPosition !== 'fixed' || this.props.boundariesElement !== 'viewport') {
        return null;
      }
      var viewportHeight = Math.max(DocumentElementClientHeight, window.innerHeight || 0);
      return viewportHeight < originalHeight && currentHeight + positionTop >= viewportHeight - 50 ? // allow some spacing either side of viewport height
      viewportHeight - 12 : null;
    }

    /* Popper may return either a fixed or absolute position which would be applied to the
     * content style. In order to overcome clipping issues for overflow containing blocks when
     * the position is absolute, we create a fixed position wrapper.
     */

  }, {
    key: 'calculateFixedOffset',
    value: function calculateFixedOffset(props) {
      var isAlwaysFixed = props.isAlwaysFixed;


      if (isAlwaysFixed && this.targetRef) {
        var actualTarget = this.targetRef.firstChild;
        this.setState({
          fixedOffset: {
            top: actualTarget.getBoundingClientRect().top,
            left: actualTarget.getBoundingClientRect().left
          }
        });
      } else if (!isAlwaysFixed && this.state.fixedOffset !== null) {
        this.setState({
          fixedOffset: null
        });
      }
    }

    /* Clamp fixed position to the window for fixed position poppers that flow off the top of the
     * window.
     * A fixed position popper is a popper who has an ancestor with position: fixed.
     *
     * It is too difficult to fix this for non-fixed position poppers without re-implementing popper's
     * offset functionality or fixing the issue upstream.
     */
    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'fixPositionTopUnderflow',
    value: function fixPositionTopUnderflow(popperTop, cssPosition) {
      return popperTop >= 0 || cssPosition !== 'fixed' ? Math.round(popperTop) : 0;
    }
  }, {
    key: 'applyPopper',
    value: function applyPopper(props) {
      if (!this.fixedRef || !this.targetRef || !this.contentRef) {
        return;
      }

      if (this.popper) {
        this.popper.destroy();
      }

      // "new Popper(...)" operation is very expensive when called on virtual DOM.
      // This condition reduces the number of calls so we can run our tests faster
      // (time was reduced from 100s to 13s).
      if (!props.content) {
        return;
      }

      // we wrap our target in a div so that we can safely get a reference to it, but we pass the
      // actual target to popper
      var actualTarget = props.isAlwaysFixed ? this.fixedRef : this.targetRef.firstChild;
      var popperOpts = {
        placement: Object(__WEBPACK_IMPORTED_MODULE_13__internal_helpers__["b" /* positionPropToPopperPosition */])(props.position),
        onCreate: this.extractStyles,
        onUpdate: this.extractStyles,
        modifiers: {
          applyStyle: {
            enabled: false
          },
          hide: {
            enabled: false
          },
          offset: {
            enabled: true,
            offset: this.props.offset
          },
          flip: {
            enabled: !!this.props.autoFlip,
            flipVariations: true,
            boundariesElement: this.props.boundariesElement,
            padding: 0 // leave 0 pixels between popper and the boundariesElement
          },
          preventOverflow: {
            enabled: !!this.props.autoFlip,
            escapeWithReference: !(this.props.boundariesElement === 'scrollParent')
          }
        }
      };

      var flipBehavior = Object(__WEBPACK_IMPORTED_MODULE_13__internal_helpers__["a" /* getFlipBehavior */])(props);
      if (flipBehavior) {
        popperOpts.modifiers.flip.behavior = flipBehavior;
      }

      this.popper = new __WEBPACK_IMPORTED_MODULE_11__popper_index_min___default.a(actualTarget, this.contentRef, popperOpts);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          zIndex = _props2.zIndex,
          lockScroll = _props2.lockScroll;
      var _state2 = this.state,
          cssPosition = _state2.cssPosition,
          transform = _state2.transform,
          hasExtractedStyles = _state2.hasExtractedStyles,
          maxHeight = _state2.maxHeight,
          fixedOffset = _state2.fixedOffset;

      var opacity = hasExtractedStyles ? {} : { opacity: 0 };

      return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
          'div',
          {
            ref: function ref(_ref2) {
              _this2.targetRef = _ref2;
            }
          },
          this.props.children
        ),
        __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
          FixedTarget,
          { targetRef: this.targetRef, fixedOffset: fixedOffset },
          __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div', {
            style: { height: '100%', width: '100%' },
            ref: function ref(_ref3) {
              _this2.fixedRef = _ref3;
            }
          })
        ),
        lockScroll && __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__internal_ScrollBlock__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_14__styledContentContainer__["a" /* default */],
          { maxHeight: maxHeight },
          __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
            'div',
            {
              ref: function ref(_ref4) {
                _this2.contentRef = _ref4;
              },
              style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
                top: 0,
                left: 0,
                position: cssPosition,
                transform: transform,
                zIndex: zIndex
              }, opacity)
            },
            this.props.content
          )
        )
      );
    }
  }]);

  return Layer;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

/* eslint-enable react/no-unused-prop-types */


Layer.defaultProps = {
  autoFlip: true,
  boundariesElement: 'viewport',
  children: null,
  content: null,
  offset: '0 0',
  onFlippedChange: function onFlippedChange() {},
  position: 'right middle',
  zIndex: 400,
  lockScroll: false,
  isAlwaysFixed: false,
  onPositioned: function onPositioned() {}
};
/* harmony default export */ __webpack_exports__["a"] = (Layer);

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/* eslint-disable */
/**
 * This file was copied from https://github.com/Blasz/popper.js/blob/v1.0.10/dist/popper.es5.min.js which contains a patch
 * to 1.0.8 containing a fix to stop repainting before popper flipping.
 * License below.
 */
/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.0.10
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var _typeof = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (e) { return typeof e } : function (e) { return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? 'symbol' : typeof e }; (function (e, t) { 'object' === ( false ? 'undefined' : _typeof(exports)) && 'undefined' != typeof module ? module.exports = t() :  true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (t),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : e.Popper = t() })(this, function () { 'use strict'; function e(ue) { var ge = ue.offsetParent, be = ge && ge.nodeName; return be && 'BODY' !== be && 'HTML' !== be ? ge : window.document.documentElement } function t(ue, ge) { if (1 !== ue.nodeType) return []; var be = window.getComputedStyle(ue, null); return ge ? be[ge] : be } function o(ue) { return 'HTML' === ue.nodeName ? ue : ue.parentNode || ue.host } function r(ue) { if (!ue || -1 !== ['HTML', 'BODY', '#document'].indexOf(ue.nodeName)) return window.document.body; var ge = t(ue), be = ge.overflow, ye = ge.overflowX, we = ge.overflowY; return /(auto|scroll)/.test(be + we + ye) ? ue : r(o(ue)) } function s(ue) { var ge = ue.nodeName; return 'BODY' === ge || 'HTML' === ge ? !1 : 'fixed' === t(ue, 'position') || s(o(ue)) } function p(ue) { var ge = e(ue), be = s(ge); return be ? 'fixed' : 'absolute' } function f(ue, ge) { var be = 'x' === ge ? 'Left' : 'Top', ye = 'Left' == be ? 'Right' : 'Bottom'; return +ue['border' + be + 'Width'].split('px')[0] + +ue['border' + ye + 'Width'].split('px')[0] } function d(ue) { var be, ge = -1 !== navigator.appVersion.indexOf('MSIE 10'); if (ge) try { be = ue.getBoundingClientRect() } catch (Le) { be = {} } else be = ue.getBoundingClientRect(); var ye = { left: be.left, top: be.top, right: be.right, bottom: be.bottom, width: be.right - be.left, height: be.bottom - be.top }; if ('HTML' === ue.nodeName && ge) { var we = window.document.documentElement, xe = we.scrollTop, ve = we.scrollLeft; ye.top -= xe, ye.bottom -= xe, ye.left -= ve, ye.right -= ve } var Ee = be.width - (ue.clientWidth || be.right - be.left), Oe = be.height - (ue.clientHeight || be.bottom - be.top); if (Ee || Oe) { var Se = t(ue); Ee -= f(Se, 'x'), Oe -= f(Se, 'y') } return ye.right -= Ee, ye.width -= Ee, ye.bottom -= Oe, ye.height -= Oe, ye } function l(ue) { var ge = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 'top', be = 'top' === ge ? 'scrollTop' : 'scrollLeft', ye = ue.nodeName; if ('BODY' === ye || 'HTML' === ye) { var we = window.document.documentElement, xe = window.document.scrollingElement || we; return xe[be] } return ue[be] } function m(ue, ge) { var be = 2 < arguments.length && void 0 !== arguments[2] && arguments[2], ye = l(ge, 'top'), we = l(ge, 'left'), xe = be ? -1 : 1; return ue.top += ye * xe, ue.bottom += ye * xe, ue.left += we * xe, ue.right += we * xe, ue } function h(ue, ge) { var be = 2 < arguments.length && void 0 !== arguments[2] && arguments[2], ye = 3 < arguments.length && void 0 !== arguments[3] && arguments[3], we = r(ge), xe = d(ue), ve = d(ge), Ee = { top: xe.top - ve.top, left: xe.left - ve.left, bottom: xe.top - ve.top + xe.height, right: xe.left - ve.left + xe.width, width: xe.width, height: xe.height }; be && !ye ? Ee = m(Ee, we, !0) : e(ue).contains(we) && 'BODY' !== we.nodeName && (Ee = m(Ee, ge)); var Oe = t(ge), Se = +Oe.borderTopWidth.split('px')[0], Le = +Oe.borderLeftWidth.split('px')[0]; return Ee.top -= Se, Ee.bottom -= Se, Ee.left -= Le, Ee.right -= Le, Ee } function c() { var ue = window.document.body, ge = window.document.documentElement; return { height: Math.max(ue.scrollHeight, ue.offsetHeight, ge.clientHeight, ge.scrollHeight, ge.offsetHeight), width: Math.max(ue.scrollWidth, ue.offsetWidth, ge.clientWidth, ge.scrollWidth, ge.offsetWidth) } } function u(ue) { var ge; if ('HTML' === ue.nodeName) { var be = c(), ye = be.width, we = be.height; ge = { width: ye, height: we, left: 0, top: 0 } } else ge = { width: ue.offsetWidth, height: ue.offsetHeight, left: ue.offsetLeft, top: ue.offsetTop }; return ge.right = ge.left + ge.width, ge.bottom = ge.top + ge.height, ge } function g(ue) { var ge = u(ue); if ('HTML' !== ue.nodeName) { var be = e(ue), ye = g(be), we = { width: ge.offsetWidth, height: ge.offsetHeight, left: ge.left + ye.left, top: ge.top + ye.top, right: ge.right - ye.right, bottom: ge.bottom - ye.bottom }; return we } return ge } function w(ue) { var ge = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 'top', be = r(ue), ye = l(be, ge); return -1 === ['BODY', 'HTML'].indexOf(be.nodeName) ? ye + w(o(be), ge) : ye } function v(ue, ge, be) { var ye = { top: 0, left: 0 }, we = e(ue); if ('viewport' === be) { var xe = g(we), ve = xe.left, Ee = xe.top, Oe = window.document.documentElement, Se = Oe.clientWidth, Le = Oe.clientHeight; if (s(ue) || 'fixed' === p(ue)) ye.right = Se, ye.bottom = Le; else { var Pe = w(ue, 'left'), Ne = w(ue, 'top'); ye = { top: 0 - Ee, right: Se - ve + Pe, bottom: Le - Ee + Ne, left: 0 - ve } } } else { var Te; if (Te = 'scrollParent' === be ? r(o(ue)) : 'window' === be ? window.document.body : be, 'BODY' === Te.nodeName) { var We = c(), Be = We.height, He = We.width; ye.right = He, ye.bottom = Be } else ye = h(Te, we, s(ue)) } return ye.left += ge, ye.top += ge, ye.right -= ge, ye.bottom -= ge, ye } function E(ue, ge, be) { if (-1 === ue.indexOf('auto')) return ue; var ye = v(be, 0, 'scrollParent'), we = { top: ge.top - ye.top, right: ye.right - ge.right, bottom: ye.bottom - ge.bottom, left: ge.left - ye.left }, xe = Object.keys(we).sort(function (Ee, Oe) { return we[Oe] - we[Ee] })[0], ve = ue.split('-')[1]; return xe + (ve ? '-' + ve : '') } function L(ue, ge) { return Array.prototype.find ? ue.find(ge) : ue.filter(ge)[0] } function P(ue, ge, be) { if (Array.prototype.findIndex) return ue.findIndex(function (we) { return we[ge] === be }); var ye = L(ue, function (we) { return we[ge] === be }); return ue.indexOf(ye) } function N(ue) { return le({}, ue, { right: ue.left + ue.width, bottom: ue.top + ue.height }) } function T(ue) { var ge = window.getComputedStyle(ue), be = parseFloat(ge.marginTop) + parseFloat(ge.marginBottom), ye = parseFloat(ge.marginLeft) + parseFloat(ge.marginRight), we = { width: ue.offsetWidth + ye, height: ue.offsetHeight + be }; return we } function W(ue) { var ge = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' }; return ue.replace(/left|right|bottom|top/g, function (be) { return ge[be] }) } function B(ue, ge, be, ye) { ye = ye.split('-')[0]; var we = T(ge), xe = { position: ue, width: we.width, height: we.height }, ve = -1 !== ['right', 'left'].indexOf(ye), Ee = ve ? 'top' : 'left', Oe = ve ? 'left' : 'top', Se = ve ? 'height' : 'width', Le = ve ? 'width' : 'height'; return xe[Ee] = be[Ee] + be[Se] / 2 - we[Se] / 2, xe[Oe] = ye === Oe ? be[Oe] - we[Le] : be[W(Oe)], xe } function H(ue, ge, be) { var ye = 'fixed' === ue.position, we = ue.isParentTransformed, xe = e(ye && we ? be : ge); return h(be, xe, ye, we) } function k(ue) { for (var ge = [!1, 'ms', 'webkit', 'moz', 'o'], be = ue.charAt(0).toUpperCase() + ue.slice(1), ye = 0; ye < ge.length - 1; ye++) { var we = ge[ye], xe = we ? '' + we + be : ue; if ('undefined' != typeof window.document.body.style[xe]) return xe } return null } function D(ue) { return ue && '[object Function]' === {}.toString.call(ue) } function C(ue, ge) { return ue.some(function (be) { var ye = be.name, we = be.enabled; return we && ye === ge }) } function R(ue, ge, be) { var ye = L(ue, function (we) { var xe = we.name; return xe === ge }); return !!ye && ue.some(function (we) { return we.name === be && we.enabled && we.order < ye.order }) } function M(ue) { return '' !== ue && !isNaN(parseFloat(ue)) && isFinite(ue) } function A(ue) { return 'BODY' !== ue.nodeName && ('none' !== t(ue, 'transform') || (o(ue) ? A(o(ue)) : ue)) } function Y(ue, ge) { return window.removeEventListener('resize', ge.updateBound), ge.scrollParents.forEach(function (be) { be.removeEventListener('scroll', ge.updateBound) }), ge.updateBound = null, ge.scrollParents = [], ge.scrollElement = null, ge.eventsEnabled = !1, ge } function I(ue, ge, be) { var ye = void 0 === be ? ue : ue.slice(0, P(ue, 'name', be)); return ye.forEach(function (we) { we.enabled && D(we.function) && (ge = we.function(ge, we)) }), ge } function U(ue, ge) { Object.keys(ge).forEach(function (be) { var ye = ge[be]; !1 === ye ? ue.removeAttribute(be) : ue.setAttribute(be, ge[be]) }) } function q(ue, ge) { Object.keys(ge).forEach(function (be) { var ye = ''; -1 !== ['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(be) && M(ge[be]) && (ye = 'px'), ue.style[be] = ge[be] + ye }) } function z(ue, ge, be, ye) { var we = 'BODY' === ue.nodeName, xe = we ? window : ue; xe.addEventListener(ge, be, { passive: !0 }), we || z(r(xe.parentNode), ge, be, ye), ye.push(xe) } function F(ue, ge, be, ye) { be.updateBound = ye, window.addEventListener('resize', be.updateBound, { passive: !0 }); var we = r(ue); return z(we, 'scroll', be.updateBound, be.scrollParents), be.scrollElement = we, be.eventsEnabled = !0, be } function X(ue) { return 'end' === ue ? 'start' : 'start' === ue ? 'end' : ue } for (var te = 'undefined' != typeof window && 'undefined' != typeof window.document, oe = ['Edge', 'Trident', 'Firefox'], ie = 0, re = 0; re < oe.length; re += 1)if (te && 0 <= navigator.userAgent.indexOf(oe[re])) { ie = 1; break } var ne = te && window.Promise, se = ne ? function (ue) { var ge = !1; return function () { ge || (ge = !0, Promise.resolve().then(function () { ge = !1, ue() })) } } : function (ue) { var ge = !1; return function () { ge || (ge = !0, setTimeout(function () { ge = !1, ue() }, ie)) } }, pe = function classCallCheck(ue, ge) { if (!(ue instanceof ge)) throw new TypeError('Cannot call a class as a function') }, fe = function () { function ue(ge, be) { for (var we, ye = 0; ye < be.length; ye++)we = be[ye], we.enumerable = we.enumerable || !1, we.configurable = !0, 'value' in we && (we.writable = !0), Object.defineProperty(ge, we.key, we) } return function (ge, be, ye) { return be && ue(ge.prototype, be), ye && ue(ge, ye), ge } }(), de = function defineProperty(ue, ge, be) { return ge in ue ? Object.defineProperty(ue, ge, { value: be, enumerable: !0, configurable: !0, writable: !0 }) : ue[ge] = be, ue }, le = Object.assign || function (ue) { for (var be, ge = 1; ge < arguments.length; ge++)for (var ye in be = arguments[ge], be) Object.prototype.hasOwnProperty.call(be, ye) && (ue[ye] = be[ye]); return ue }, ce = function () { function ue(ge, be) { var ye = this, we = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {}; pe(this, ue), this.scheduleUpdate = function () { return requestAnimationFrame(ye.update) }, this.update = se(this.update.bind(this)), this.options = le({}, ue.Defaults, we), this.state = { isDestroyed: !1, isCreated: !1, scrollParents: [] }, this.reference = ge.jquery ? ge[0] : ge, this.popper = be.jquery ? be[0] : be, this.modifiers = Object.keys(ue.Defaults.modifiers).map(function (ve) { return le({ name: ve }, ue.Defaults.modifiers[ve]) }), this.modifiers = this.modifiers.map(function (ve) { var Ee = we.modifiers && we.modifiers[ve.name] || {}; return le({}, ve, Ee) }), we.modifiers && (this.options.modifiers = le({}, ue.Defaults.modifiers, we.modifiers), Object.keys(we.modifiers).forEach(function (ve) { if (void 0 === ue.Defaults.modifiers[ve]) { var Ee = we.modifiers[ve]; Ee.name = ve, ye.modifiers.push(Ee) } })), this.state.position = p(this.reference), this.modifiers = this.modifiers.sort(function (ve, Ee) { return ve.order - Ee.order }), this.modifiers.forEach(function (ve) { ve.enabled && D(ve.onLoad) && ve.onLoad(ye.reference, ye.popper, ye.options, ve, ye.state) }), this.state.isParentTransformed = A(this.popper.parentNode), this.update(); var xe = this.options.eventsEnabled; xe && this.enableEventListeners(), this.state.eventsEnabled = xe } return fe(ue, [{ key: 'update', value: function () { if (!this.state.isDestroyed) { var be = { instance: this, styles: {}, attributes: {}, flipped: !1, offsets: {} }; this.state.position = p(this.reference), q(this.popper, { position: this.state.position }), be.offsets.reference = H(this.state, this.popper, this.reference), be.placement = E(this.options.placement, be.offsets.reference, this.popper), be.originalPlacement = this.options.placement, be.offsets.popper = B(this.state, this.popper, be.offsets.reference, be.placement), be = I(this.modifiers, be), this.state.isCreated ? this.options.onUpdate(be) : (this.state.isCreated = !0, this.options.onCreate(be)) } } }, { key: 'destroy', value: function () { return this.state.isDestroyed = !0, C(this.modifiers, 'applyStyle') && (this.popper.removeAttribute('x-placement'), this.popper.style.left = '', this.popper.style.position = '', this.popper.style.top = '', this.popper.style[k('transform')] = ''), this.disableEventListeners(), this.options.removeOnDestroy && this.popper.parentNode.removeChild(this.popper), this } }, { key: 'enableEventListeners', value: function () { this.state.eventsEnabled || (this.state = F(this.reference, this.options, this.state, this.scheduleUpdate)) } }, { key: 'disableEventListeners', value: function () { this.state.eventsEnabled && (window.cancelAnimationFrame(this.scheduleUpdate), this.state = Y(this.reference, this.state)) } }]), ue }(); return ce.Utils = { computeAutoPlacement: E, debounce: se, findIndex: P, getBordersSize: f, getBoundaries: v, getBoundingClientRect: d, getClientRect: N, getOffsetParent: e, getOffsetRect: u, getOffsetRectRelativeToCustomParent: h, getOuterSizes: T, getParentNode: o, getPopperOffsets: B, getPosition: p, getReferenceOffsets: H, getScroll: l, getScrollParent: r, getStyleComputedProperty: t, getSupportedPropertyName: k, getTotalScroll: w, getWindowSizes: c, includeScroll: m, isFixed: s, isFunction: D, isModifierEnabled: C, isModifierRequired: R, isNumeric: M, isTransformed: A, removeEventListeners: Y, runModifiers: I, setAttributes: U, setStyles: q, setupEventListeners: F }, ce.placements = ['auto', 'auto-start', 'auto-end', 'top', 'top-start', 'top-end', 'right', 'right-start', 'right-end', 'bottom', 'bottom-start', 'bottom-end', 'left', 'left-start', 'left-end'], ce.Defaults = { placement: 'bottom', eventsEnabled: !0, onCreate: function () { }, onUpdate: function () { }, modifiers: { shift: { order: 100, enabled: !0, function: function (ue) { var ge = ue.placement, be = ge.split('-')[0], ye = ge.split('-')[1]; if (ye) { var we = ue.offsets.reference, xe = N(ue.offsets.popper), ve = -1 !== ['bottom', 'top'].indexOf(be), Ee = ve ? 'left' : 'top', Oe = ve ? 'width' : 'height', Se = { start: de({}, Ee, we[Ee]), end: de({}, Ee, we[Ee] + we[Oe] - xe[Oe]) }; ue.offsets.popper = le({}, xe, Se[ye]) } return ue } }, offset: { order: 200, enabled: !0, function: function (ue, ge) { var we, be = ue.placement, ye = ue.offsets.popper; return M(ge.offset) ? we = [ge.offset, 0] : (we = ge.offset.split(' '), we = we.map(function (xe, ve) { var Ee = xe.match(/(\d*\.?\d*)(.*)/), Oe = +Ee[1], Se = Ee[2], Le = -1 !== be.indexOf('right') || -1 !== be.indexOf('left'); 1 === ve && (Le = !Le); var Pe = Le ? 'height' : 'width'; if (0 === Se.indexOf('%')) { var Ne; switch (Se) { case '%p': Ne = ue.offsets.popper; break; case '%': case '$r': default: Ne = ue.offsets.reference; }var Te = N(Ne), We = Te[Pe]; return We / 100 * Oe } if ('vh' === Se || 'vw' === Se) { var Be; return Be = 'vh' === Se ? Math.max(document.documentElement.clientHeight, window.innerHeight || 0) : Math.max(document.documentElement.clientWidth, window.innerWidth || 0), Be / 100 * Oe } return 'px' === Se ? +Oe : +xe })), -1 === ue.placement.indexOf('left') ? -1 === ue.placement.indexOf('right') ? -1 === ue.placement.indexOf('top') ? -1 !== ue.placement.indexOf('bottom') && (ye.left += we[0], ye.top += we[1] || 0) : (ye.left += we[0], ye.top -= we[1] || 0) : (ye.top += we[0], ye.left += we[1] || 0) : (ye.top += we[0], ye.left -= we[1] || 0), ue }, offset: 0 }, preventOverflow: { order: 300, enabled: !0, function: function (ue, ge) { var be = ge.boundariesElement || e(ue.instance.popper), ye = v(ue.instance.popper, ge.padding, be); ge.boundaries = ye; var we = ge.priority, xe = N(ue.offsets.popper), ve = { primary: function (Oe) { var Se = xe[Oe]; return xe[Oe] < ye[Oe] && !ge.escapeWithReference && (Se = Math.max(xe[Oe], ye[Oe])), de({}, Oe, Se) }, secondary: function (Oe) { var Se = 'right' === Oe ? 'left' : 'top', Le = xe[Se]; return xe[Oe] > ye[Oe] && !ge.escapeWithReference && (Le = Math.min(xe[Se], ye[Oe] - ('right' === Oe ? xe.width : xe.height))), de({}, Se, Le) } }; return we.forEach(function (Ee) { var Oe = -1 === ['left', 'top'].indexOf(Ee) ? 'secondary' : 'primary'; xe = le({}, xe, ve[Oe](Ee)) }), ue.offsets.popper = xe, ue }, priority: ['left', 'right', 'top', 'bottom'], padding: 5, boundariesElement: 'scrollParent' }, keepTogether: { order: 400, enabled: !0, function: function (ue) { var ge = N(ue.offsets.popper), be = ue.offsets.reference, ye = ue.placement.split('-')[0], we = Math.floor, xe = -1 !== ['top', 'bottom'].indexOf(ye), ve = xe ? 'right' : 'bottom', Ee = xe ? 'left' : 'top', Oe = xe ? 'width' : 'height'; return ge[ve] < we(be[Ee]) && (ue.offsets.popper[Ee] = we(be[Ee]) - ge[Oe]), ge[Ee] > we(be[ve]) && (ue.offsets.popper[Ee] = we(be[ve])), ue } }, arrow: { order: 500, enabled: !0, function: function (ue, ge) { if (!R(ue.instance.modifiers, 'arrow', 'keepTogether')) return console.warn('WARNING: `keepTogether` modifier is required by arrow modifier in order to work, be sure to include it before `arrow`!'), ue; var be = ge.element; if ('string' == typeof be) { if (be = ue.instance.popper.querySelector(be), !be) return ue; } else if (!ue.instance.popper.contains(be)) return console.warn('WARNING: `arrow.element` must be child of its popper element!'), ue; var ye = ue.placement.split('-')[0], we = N(ue.offsets.popper), xe = ue.offsets.reference, ve = -1 !== ['left', 'right'].indexOf(ye), Ee = ve ? 'height' : 'width', Oe = ve ? 'top' : 'left', Se = ve ? 'left' : 'top', Le = ve ? 'bottom' : 'right', Pe = T(be)[Ee]; xe[Le] - Pe < we[Oe] && (ue.offsets.popper[Oe] -= we[Oe] - (xe[Le] - Pe)), xe[Oe] + Pe > we[Le] && (ue.offsets.popper[Oe] += xe[Oe] + Pe - we[Le]); var Ne = xe[Oe] + xe[Ee] / 2 - Pe / 2, Te = Ne - N(ue.offsets.popper)[Oe]; return Te = Math.max(Math.min(we[Ee] - Pe, Te), 0), ue.arrowElement = be, ue.offsets.arrow = {}, ue.offsets.arrow[Oe] = Te, ue.offsets.arrow[Se] = '', ue }, element: '[x-arrow]' }, flip: { order: 600, enabled: !0, function: function (ue, ge) { if (C(ue.instance.modifiers, 'inner')) return ue; if (ue.flipped && ue.placement === ue.originalPlacement) return ue; var be = v(ue.instance.popper, ge.padding, ge.boundariesElement), ye = ue.placement.split('-')[0], we = W(ye), xe = ue.placement.split('-')[1] || '', ve = []; return ve = 'flip' === ge.behavior ? [ye, we] : ge.behavior, ve.forEach(function (Ee, Oe) { if (ye !== Ee || ve.length === Oe + 1) return ue; ye = ue.placement.split('-')[0], we = W(ye); var Se = N(ue.offsets.popper), Le = ue.offsets.reference, Pe = Math.floor, Ne = 'left' === ye && Pe(Se.right) > Pe(Le.left) || 'right' === ye && Pe(Se.left) < Pe(Le.right) || 'top' === ye && Pe(Se.bottom) > Pe(Le.top) || 'bottom' === ye && Pe(Se.top) < Pe(Le.bottom), Te = Pe(Se.left) < Pe(be.left), We = Pe(Se.right) > Pe(be.right), Be = Pe(Se.top) < Pe(be.top), He = Pe(Se.bottom) > Pe(be.bottom), ke = 'left' === ye && Te || 'right' === ye && We || 'top' === ye && Be || 'bottom' === ye && He, De = -1 !== ['top', 'bottom'].indexOf(ye), Ce = !!ge.flipVariations && (De && 'start' === xe && Te || De && 'end' === xe && We || !De && 'start' === xe && Be || !De && 'end' === xe && He); (Ne || ke || Ce) && (ue.flipped = !0, (Ne || ke) && (ye = ve[Oe + 1]), Ce && (xe = X(xe)), ue.placement = ye + (xe ? '-' + xe : ''), ue.offsets.popper = B(ue.instance.state.position, ue.instance.popper, ue.offsets.reference, ue.placement), ue = I(ue.instance.modifiers, ue, 'flip')) }), ue }, behavior: 'flip', padding: 5, boundariesElement: 'viewport' }, inner: { order: 700, enabled: !1, function: function (ue) { var ge = ue.placement, be = ge.split('-')[0], ye = N(ue.offsets.popper), we = N(ue.offsets.reference), xe = -1 !== ['left', 'right'].indexOf(be), ve = -1 === ['top', 'left'].indexOf(be); return ye[xe ? 'left' : 'top'] = we[ge] - (ve ? ye[xe ? 'width' : 'height'] : 0), ue.placement = W(ge), ue.offsets.popper = N(ye), ue } }, hide: { order: 800, enabled: !0, function: function (ue) { if (!R(ue.instance.modifiers, 'hide', 'preventOverflow')) return console.warn('WARNING: preventOverflow modifier is required by hide modifier in order to work, be sure to include it before hide!'), ue; var ge = ue.offsets.reference, be = L(ue.instance.modifiers, function (ye) { return 'preventOverflow' === ye.name }).boundaries; if (ge.bottom < be.top || ge.left > be.right || ge.top > be.bottom || ge.right < be.left) { if (!0 === ue.hide) return ue; ue.hide = !0, ue.attributes['x-out-of-boundaries'] = '' } else { if (!1 === ue.hide) return ue; ue.hide = !1, ue.attributes['x-out-of-boundaries'] = !1 } return ue } }, applyStyle: { order: 900, enabled: !0, gpuAcceleration: !0, function: function (ue, ge) { var be = { position: ue.offsets.popper.position }, ye = { 'x-placement': ue.placement }, we = Math.round(ue.offsets.popper.left), xe = Math.round(ue.offsets.popper.top), ve = k('transform'); return ge.gpuAcceleration && ve ? (be[ve] = 'translate3d(' + we + 'px, ' + xe + 'px, 0)', be.top = 0, be.left = 0, be.willChange = 'transform') : (be.left = we, be.top = xe, be.willChange = 'top, left'), q(ue.instance.popper, le({}, be, ue.styles)), U(ue.instance.popper, le({}, ye, ue.attributes)), ue.offsets.arrow && q(ue.arrowElement, ue.offsets.arrow), ue }, onLoad: function (ue, ge, be, ye, we) { var xe = H(we, ge, ue); return be.placement = E(be.placement, xe, ge), ge.setAttribute('x-placement', be.placement), be } } } }, ce });

//# sourceMappingURL=popper.es5.min.js.map


/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ScrollBlock;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_scrolllock__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_scrolllock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_scrolllock__);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: transparent;\n'], ['\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: transparent;\n']);





var Blanket = __WEBPACK_IMPORTED_MODULE_2_styled_components__["default"].div(_templateObject);

function ScrollBlock() {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    Blanket,
    null,
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_scrolllock___default.a, null)
  );
}

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export POSITION_ATTRIBUTE_ENUM */
/* harmony export (immutable) */ __webpack_exports__["a"] = getFlipBehavior;
/* harmony export (immutable) */ __webpack_exports__["b"] = positionPropToPopperPosition;
var positionMap = {
  'top left': { position: 'top-start', animation: 'top' },
  'top center': { position: 'top', animation: 'top' },
  'top right': { position: 'top-end', animation: 'top' },
  'right top': { position: 'right-start', animation: 'right' },
  'right middle': { position: 'right', animation: 'right' },
  'right bottom': { position: 'right-end', animation: 'right' },
  'bottom left': { position: 'bottom-start', animation: 'bottom' },
  'bottom center': { position: 'bottom', animation: 'bottom' },
  'bottom right': { position: 'bottom-end', animation: 'bottom' },
  'left top': { position: 'left-start', animation: 'left' },
  'left middle': { position: 'left', animation: 'left' },
  'left bottom': { position: 'left-end', animation: 'left' }
};

var POSITION_ATTRIBUTE_ENUM = {
  values: ['top left', 'top center', 'top right', 'right top', 'right middle', 'right bottom', 'bottom left', 'bottom center', 'bottom right', 'left top', 'left middle', 'left bottom'],
  default: 'right middle'
};

function positionToPopper(position) {
  return position && positionMap[position] ? positionMap[position].position : null;
}

/* Convert the autoFlip property into the array format that Popper expects.
 * The first item must not include the edge-position variation, or Popper will not understand it.
 */
function getFlipBehavior(props) {
  return props.position && Array.isArray(props.autoFlip) ? [props.position.split(' ')[0]].concat(props.autoFlip) : null;
}

function positionPropToPopperPosition(position) {
  return positionToPopper(position) || positionMap[POSITION_ATTRIBUTE_ENUM.default].position;
}

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  [data-role=\'droplistContent\'] {\n    ', ';\n  }\n'], ['\n  [data-role=\'droplistContent\'] {\n    ', ';\n  }\n']);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, function (_ref) {
  var maxHeight = _ref.maxHeight;
  return maxHeight ? 'max-height: ' + maxHeight + 'px' : '';
}));

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export e100 */
/* unused harmony export e200 */
/* unused harmony export e300 */
/* unused harmony export e400 */
/* unused harmony export e500 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_themed__ = __webpack_require__(163);



// Cards on a board
var e100 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 1px 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px 0 ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 1px 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

// Inline dialogs
var e200 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 4px 8px -2px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 4px 8px -2px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

// Modals
var e300 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 8px 16px -4px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 8px 16px -4px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

// Panels
var e400 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 12px 24px -6px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 12px 24px -6px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

// Flag messages (notifications)
var e500 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 20px 32px -8px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 20px 32px -8px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export h900 */
/* unused harmony export h800 */
/* unused harmony export h700 */
/* unused harmony export h600 */
/* unused harmony export h500 */
/* unused harmony export h400 */
/* unused harmony export h300 */
/* unused harmony export h200 */
/* unused harmony export h100 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__colors__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index__ = __webpack_require__(41);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 500;\n  letter-spacing: -0.01em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 500;\n  letter-spacing: -0.01em;\n  margin-top: ', 'px;\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  margin-top: ', 'px;\n']),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 500;\n  letter-spacing: -0.008em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 500;\n  letter-spacing: -0.008em;\n  margin-top: ', 'px;\n']),
    _templateObject4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.006em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.006em;\n  margin-top: ', 'px;\n']),
    _templateObject5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.003em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.003em;\n  margin-top: ', 'px;\n']),
    _templateObject6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  margin-top: ', 'px;\n  text-transform: uppercase;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  margin-top: ', 'px;\n  text-transform: uppercase;\n']),
    _templateObject7 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  margin-top: ', 'px;\n']),
    _templateObject8 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: normal;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: normal;\n  margin-top: ', 'px;\n']);






var baseHeading = function baseHeading(size, lineHeight) {
  return '\n  font-size: ' + size / Object(__WEBPACK_IMPORTED_MODULE_3__index__["c" /* fontSize */])() + 'em;\n  font-style: inherit;\n  line-height: ' + lineHeight / size + ';\n';
};

var h900 = function h900() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject, baseHeading(35, 40), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 6.5);
};

var h800 = function h800() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject2, baseHeading(29, 32), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 5);
};

var h700 = function h700() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject, baseHeading(24, 28), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 5);
};

var h600 = function h600() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject3, baseHeading(20, 24), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 3.5);
};

var h500 = function h500() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject4, baseHeading(16, 20), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 3);
};

var h400 = function h400() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject5, baseHeading(14, 16), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 2);
};

var h300 = function h300() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject6, baseHeading(12, 16), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 2.5);
};

var h200 = function h200() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject7, baseHeading(12, 16), __WEBPACK_IMPORTED_MODULE_2__colors__["subtleHeading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 2);
};

var h100 = function h100() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject8, baseHeading(12, 16), __WEBPACK_IMPORTED_MODULE_2__colors__["subtleHeading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 2);
};

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["add"] = add;
/* harmony export (immutable) */ __webpack_exports__["subtract"] = subtract;
/* harmony export (immutable) */ __webpack_exports__["multiply"] = multiply;
/* harmony export (immutable) */ __webpack_exports__["divide"] = divide;
function add(fn, addend) {
  return function (props) {
    return fn(props) + addend;
  };
}

function subtract(fn, subtrahend) {
  return function (props) {
    return fn(props) - subtrahend;
  };
}

function multiply(fn, factor) {
  return function (props) {
    return fn(props) * factor;
  };
}

function divide(fn, divisor) {
  return function (props) {
    return fn(props) / divisor;
  };
}

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__colors__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Context__ = __webpack_require__(99);








var _templateObject = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  background-color: ', ';\n  color: ', ';\n\n  a {\n    color: ', ';\n  }\n  a:hover {\n    color: ', ';\n  }\n  a:active {\n    color: ', ';\n  }\n  a:focus {\n    outline-color: ', ';\n  }\n  h1 {\n    color: ', ';\n  }\n  h2 {\n    color: ', ';\n  }\n  h3 {\n    color: ', ';\n  }\n  h4 {\n    color: ', ';\n  }\n  h5 {\n    color: ', ';\n  }\n  h6 {\n    color: ', ';\n  }\n  small {\n    color: ', ';\n  }\n'], ['\n  background-color: ', ';\n  color: ', ';\n\n  a {\n    color: ', ';\n  }\n  a:hover {\n    color: ', ';\n  }\n  a:active {\n    color: ', ';\n  }\n  a:focus {\n    outline-color: ', ';\n  }\n  h1 {\n    color: ', ';\n  }\n  h2 {\n    color: ', ';\n  }\n  h3 {\n    color: ', ';\n  }\n  h4 {\n    color: ', ';\n  }\n  h5 {\n    color: ', ';\n  }\n  h6 {\n    color: ', ';\n  }\n  small {\n    color: ', ';\n  }\n']);









// For forward-compat until everything is upgraded.


function getStylesheetResetCSS(state) {
  var backgroundColor = __WEBPACK_IMPORTED_MODULE_10__colors__["background"](state);
  return '\n    body { background: ' + backgroundColor + '; }\n  ';
}

function buildThemeState(mode) {
  return { theme: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_11__constants__["a" /* CHANNEL */], { mode: mode }) };
}

var LegacyReset = __WEBPACK_IMPORTED_MODULE_9_styled_components__["default"].div(_templateObject, __WEBPACK_IMPORTED_MODULE_10__colors__["background"], __WEBPACK_IMPORTED_MODULE_10__colors__["text"], __WEBPACK_IMPORTED_MODULE_10__colors__["link"], __WEBPACK_IMPORTED_MODULE_10__colors__["linkHover"], __WEBPACK_IMPORTED_MODULE_10__colors__["linkActive"], __WEBPACK_IMPORTED_MODULE_10__colors__["linkOutline"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["subtleHeading"], __WEBPACK_IMPORTED_MODULE_10__colors__["subtleText"]);

var AtlaskitThemeProvider = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(AtlaskitThemeProvider, _Component);

  function AtlaskitThemeProvider(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AtlaskitThemeProvider);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AtlaskitThemeProvider.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(AtlaskitThemeProvider)).call(this, props));

    _this.state = buildThemeState(props.mode);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(AtlaskitThemeProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return { hasAtlaskitThemeProvider: true };
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (!this.context.hasAtlaskitThemeProvider) {
        var css = getStylesheetResetCSS(this.state);
        this.stylesheet = document.createElement('style');
        this.stylesheet.type = 'text/css';
        this.stylesheet.innerHTML = css;
        if (document && document.head) {
          document.head.appendChild(this.stylesheet);
        }
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (newProps.mode !== this.props.mode) {
        var newThemeState = buildThemeState(newProps.mode);
        if (this.stylesheet) {
          var css = getStylesheetResetCSS(newThemeState);
          this.stylesheet.innerHTML = css;
        }
        this.setState(newThemeState);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.stylesheet && document && document.head) {
        document.head.removeChild(this.stylesheet);
        delete this.stylesheet;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;

      var theme = this.state.theme;
      return (
        /* Wrapping the new provider around the old one provides forward
        compatibility when using the old provider for styled components. This
        allows us to use components converted to use the new API with consumers
        using the old provider along side components that may still be using the
        old theming API. */
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12__Context__["b" /* Provider */],
          { value: { mode: theme[__WEBPACK_IMPORTED_MODULE_11__constants__["a" /* CHANNEL */]].mode } },
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_styled_components__["ThemeProvider"],
            { theme: theme },
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
              LegacyReset,
              null,
              children
            )
          )
        )
      );
    }
  }]);

  return AtlaskitThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

AtlaskitThemeProvider.defaultProps = {
  mode: __WEBPACK_IMPORTED_MODULE_11__constants__["b" /* DEFAULT_THEME_MODE */]
};
AtlaskitThemeProvider.childContextTypes = {
  hasAtlaskitThemeProvider: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
};
AtlaskitThemeProvider.contextTypes = {
  hasAtlaskitThemeProvider: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
};
/* harmony default export */ __webpack_exports__["a"] = (AtlaskitThemeProvider);

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);





/* unused harmony default export */ var _unused_webpack_default_export = (function (_ref) {
  var children = _ref.children,
      props = _ref.props,
      theme = _ref.theme;

  var appearance = (typeof props === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(props)) === 'object' ? 'default' : props;
  var merged = (typeof props === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(props)) === 'object' ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, props) : {};
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(theme).forEach(function (key) {
    if (!(key in merged)) {
      merged[key] = theme[key]({ appearance: appearance });
    }
  });
  return children(merged);
});

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__colors__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Context__ = __webpack_require__(99);








var _templateObject = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ';\n'], ['\n  ', ';\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    background-color: ', ';\n    color: ', ';\n\n    a {\n      color: ', ';\n    }\n    a:hover {\n      color: ', ';\n    }\n    a:active {\n      color: ', ';\n    }\n    a:focus {\n      outline-color: ', ';\n    }\n    h1,\n    h2,\n    h3,\n    h4,\n    h5 {\n      color: ', ';\n    }\n    h6 {\n      color: ', ';\n    }\n    small {\n      color: ', ';\n    }\n  '], ['\n    background-color: ', ';\n    color: ', ';\n\n    a {\n      color: ', ';\n    }\n    a:hover {\n      color: ', ';\n    }\n    a:active {\n      color: ', ';\n    }\n    a:focus {\n      outline-color: ', ';\n    }\n    h1,\n    h2,\n    h3,\n    h4,\n    h5 {\n      color: ', ';\n    }\n    h6 {\n      color: ', ';\n    }\n    small {\n      color: ', ';\n    }\n  ']);






var orTextColor = function orTextColor(preferred) {
  return function (p) {
    return p[preferred] || p.textColor;
  };
};
var Div = __WEBPACK_IMPORTED_MODULE_8_styled_components__["default"].div(_templateObject, function (p) {
  return Object(__WEBPACK_IMPORTED_MODULE_8_styled_components__["css"])(_templateObject2, p.backgroundColor, p.textColor, orTextColor('linkColor'), orTextColor('linkColorHover'), orTextColor('linkColorActive'), orTextColor('linkColorOutline'), orTextColor('headingColor'), orTextColor('subtleHeadingColor'), orTextColor('subtleTextColor'));
});

var defaultTheme = {
  backgroundColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N0"],
  linkColor: __WEBPACK_IMPORTED_MODULE_9__colors__["B400"],
  linkColorHover: __WEBPACK_IMPORTED_MODULE_9__colors__["B300"],
  linkColorActive: __WEBPACK_IMPORTED_MODULE_9__colors__["B500"],
  linkColorOutline: __WEBPACK_IMPORTED_MODULE_9__colors__["B100"],
  headingColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N800"],
  subtleHeadingColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N200"],
  subtleTextColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N200"],
  textColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N900"]
};

var Reset = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Reset, _Component);

  function Reset() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Reset);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Reset.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Reset)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Reset, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10__Context__["a" /* Consumer */],
        null,
        function (theme) {
          return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            Div,
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, defaultTheme, theme, _this2.props),
            _this2.props.children
          );
        }
      );
    }
  }]);

  return Reset;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

/* unused harmony default export */ var _unused_webpack_default_export = (Reset);

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Context__ = __webpack_require__(99);








var Theme = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Theme, _Component);

  function Theme() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Theme);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Theme.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Theme)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Theme, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          values = _props.values;

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__components_Context__["a" /* Consumer */],
        null,
        function (theme) {
          var merged = values(theme);
          return typeof children === 'function' ? children(merged) : __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__components_Context__["b" /* Provider */],
            { value: merged },
            children
          );
        }
      );
    }
  }]);

  return Theme;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Theme.defaultProps = {
  values: function values(v) {
    return v;
  }
};
/* unused harmony default export */ var _unused_webpack_default_export = (Theme);

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Content; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SpinnerContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Trigger; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(41);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: inline-flex;\n\n  ', ';\n'], ['\n  display: inline-flex;\n\n  ', ';\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  box-shadow: 0 ', 'px ', 'px -', 'px ', ',\n    0 0 1px ', ';\n'], ['\n  box-shadow: 0 ', 'px ', 'px -', 'px ', ',\n    0 0 1px ', ';\n']),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  background: ', ';\n  border-radius: ', 'px;\n  ', ';\n  box-sizing: border-box;\n  overflow: auto;\n  padding: ', 'px 0;\n  max-height: ', ';\n'], ['\n  background: ', ';\n  border-radius: ', 'px;\n  ', ';\n  box-sizing: border-box;\n  overflow: auto;\n  padding: ', 'px 0;\n  max-height: ', ';\n']),
    _templateObject4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  justify-content: center;\n  min-width: ', 'px;\n  padding: ', 'px;\n'], ['\n  display: flex;\n  justify-content: center;\n  min-width: ', 'px;\n  padding: ', 'px;\n']),
    _templateObject5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: inline-flex;\n  transition-duration: 0.2s;\n  transition: box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38);\n\n  ', ';\n'], ['\n  display: inline-flex;\n  transition-duration: 0.2s;\n  transition: box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38);\n\n  ', ';\n']);




/* When dropdown contains more than 9 elements (droplist items, droplist groups),
 * it should have scroll and cut off half of the 10th item to indicate that there are more
 * items then are seen. This was previously calculated by mapping over children, but with
 * the current composed API it is simpler to just assume 9 items. */
var getMaxHeight = function getMaxHeight(_ref) {
  var isTall = _ref.isTall,
      maxHeight = _ref.maxHeight;

  if (maxHeight) return maxHeight + 'px';

  var heightWithoutPadding = 17;
  var verticalPadding = Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */])();
  var height = heightWithoutPadding + verticalPadding * 2;
  var defaultMaxHeight = 9.5 * height + verticalPadding / 2;

  return isTall ? 'none' : defaultMaxHeight + 'px';
};

/* harmony default export */ __webpack_exports__["d"] = (__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, function (props) {
  return props.fit && '\n    display: block;\n    flex: 1 1 auto;\n  ';
}));

var backgroundColor = __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].backgroundOnLayer;
var boxShadow = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject2, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["e" /* math */].divide(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */], 2), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */], __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["e" /* math */].divide(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */], 4), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].N50A, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].N60A);

var Content = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject3, backgroundColor, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* borderRadius */], boxShadow, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["e" /* math */].divide(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */], 2), getMaxHeight);

var SpinnerContainer = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject4, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["e" /* math */].multiply(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */], 20), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["e" /* math */].multiply(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */], 2.5));

var Trigger = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject5, function (props) {
  return props.fit && '\n    box-sizing: border-box;\n    display: block;\n  ';
});

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_item__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(41);




var dropdownPadding = {
  bottom: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */],
  left: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["e" /* math */].multiply(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */], 1.5),
  right: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["e" /* math */].multiply(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */], 1.5),
  top: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */]
};

var droplistItemTheme = {
  padding: {
    default: dropdownPadding,
    compact: dropdownPadding
  },
  borderRadius: function borderRadius() {
    return 0;
  },
  default: {
    background: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].N0, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].DN50 }),
    text: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].N800, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].DN600 }),
    secondaryText: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].N200, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].DN300 })
  },
  hover: {
    background: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].N20, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].DN70 }),
    text: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].N800, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].DN600 }),
    secondaryText: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].N200, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].DN300 })
  },
  active: {
    background: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].B75, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].B75 }),
    text: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].N800, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].B400 }),
    secondaryText: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].N200, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].DN300 })
  },
  selected: {
    background: 'transparent',
    text: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].N800, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].DN600 }),
    secondaryText: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].N200, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].DN300 })
  },
  disabled: {
    background: 'transparent',
    text: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].N70, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].DN80 }),
    secondaryText: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].N50, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].DN70 })
  },
  focus: {
    outline: Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].B100, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].B75 })
  }
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__atlaskit_item__["c" /* itemThemeNamespace */], droplistItemTheme));

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DroplistItemWithoutAnalytics */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__atlaskit_analytics_next__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__atlaskit_icon_glyph_radio__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__atlaskit_icon_glyph_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__atlaskit_icon_glyph_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__atlaskit_icon_glyph_checkbox__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__atlaskit_icon_glyph_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__atlaskit_icon_glyph_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__atlaskit_tooltip__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__package_json__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styled_Item__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Element__ = __webpack_require__(673);




















var inputTypes = { checkbox: __WEBPACK_IMPORTED_MODULE_10__atlaskit_icon_glyph_checkbox___default.a, radio: __WEBPACK_IMPORTED_MODULE_9__atlaskit_icon_glyph_radio___default.a };

var Item = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Item, _PureComponent);

  function Item() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Item);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Item.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Item)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isHovered: false,
      isPressed: false
    }, _this.componentDidMount = function () {
      return document.addEventListener('mouseup', _this.handleMouseUp);
    }, _this.componentWillUnmount = function () {
      return document.removeEventListener('mouseup', _this.handleMouseUp);
    }, _this.guardedActivate = function (event) {
      var _this$props = _this.props,
          isDisabled = _this$props.isDisabled,
          onActivate = _this$props.onActivate;


      if (!isDisabled && onActivate) onActivate({ item: _this, event: event });
    }, _this.handleClick = function (event) {
      return _this.guardedActivate(event);
    }, _this.handleKeyPress = function (event) {
      var keyIsValid = ['Enter', ' '].indexOf(event.key) > -1;

      if (keyIsValid) _this.guardedActivate(event);
    }, _this.handleMouseDown = function () {
      return _this.setState({ isPressed: true });
    }, _this.handleMouseUp = function () {
      return _this.setState({ isPressed: false });
    }, _this.handleMouseOut = function () {
      return _this.setState({ isHovered: false });
    }, _this.handleMouseOver = function () {
      return _this.setState({ isHovered: true });
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Item, [{
    key: 'render',
    value: function render() {
      var props = this.props;
      var _state = this.state,
          isHovered = _state.isHovered,
          isPressed = _state.isPressed;


      var type = props.type || '';
      var hasInput = ['checkbox', 'radio'].indexOf(type) > -1;
      var Input = inputTypes[type];

      var appearanceProps = {
        isActive: props.type === 'link' && props.isActive || props.type === 'option' && props.isSelected,
        isChecked: ['checkbox', 'radio'].indexOf(type) > -1 && props.isChecked,
        isDisabled: props.isDisabled,
        isFocused: props.isFocused,
        isHidden: props.isHidden,
        isHovered: isHovered,
        isPressed: isPressed,
        isSelected: type === 'option' && props.isSelected,
        isPrimary: props.appearance === 'primary'
      };

      var element = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_15__Element__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, appearanceProps, {
          handleClick: this.handleClick,
          handleKeyPress: this.handleKeyPress,
          handleMouseOut: this.handleMouseOut,
          handleMouseOver: this.handleMouseOver,
          handleMouseUp: this.handleMouseUp,
          handleMouseDown: this.handleMouseDown,
          href: props.href,
          target: props.target,
          title: props.title,
          type: props.type
        }),
        hasInput && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_13__styled_Item__["g" /* InputWrapper */],
          appearanceProps,
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Input, {
            label: '',
            primaryColor: Object(__WEBPACK_IMPORTED_MODULE_14__utils__["a" /* getInputBackground */])(appearanceProps),
            secondaryColor: Object(__WEBPACK_IMPORTED_MODULE_14__utils__["b" /* getInputFill */])(appearanceProps),
            size: 'medium'
          })
        ),
        !!props.elemBefore && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_13__styled_Item__["c" /* Before */],
          null,
          props.elemBefore
        ),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_13__styled_Item__["e" /* ContentWrapper */],
          null,
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_13__styled_Item__["d" /* Content */],
            { allowMultiline: this.context.shouldAllowMultilineItems },
            props.children
          ),
          !!props.description && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_13__styled_Item__["f" /* Description */],
            null,
            props.description
          )
        ),
        !!props.elemAfter && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_13__styled_Item__["a" /* After */],
          null,
          props.elemAfter
        )
      );

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'span',
        { role: 'presentation' },
        props.tooltipDescription ? __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11__atlaskit_tooltip__["a" /* default */],
          {
            content: props.tooltipDescription,
            position: props.tooltipPosition
          },
          element
        ) : element
      );
    }
  }]);

  return Item;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

Item.defaultProps = {
  appearance: 'default',
  children: null,
  description: '',
  elemAfter: null,
  elemBefore: null,
  href: null,
  isActive: false,
  isChecked: false,
  isDisabled: false,
  isFocused: false,
  isHidden: false,
  isSelected: false,
  itemContext: 'menu',
  onActivate: function onActivate() {},
  target: null,
  title: null,
  tooltipDescription: null,
  tooltipPosition: 'right',
  type: 'link'
};
Item.contextTypes = {
  shouldAllowMultilineItems: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
};



var createAndFireEventOnAtlaskit = Object(__WEBPACK_IMPORTED_MODULE_8__atlaskit_analytics_next__["b" /* createAndFireEvent */])('atlaskit');

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__atlaskit_analytics_next__["c" /* withAnalyticsContext */])({
  componentName: 'droplistItem',
  packageName: __WEBPACK_IMPORTED_MODULE_12__package_json__["name"],
  packageVersion: __WEBPACK_IMPORTED_MODULE_12__package_json__["version"]
})(Object(__WEBPACK_IMPORTED_MODULE_8__atlaskit_analytics_next__["d" /* withAnalyticsEvents */])({
  onActivate: createAndFireEventOnAtlaskit({
    action: 'selected',
    actionSubject: 'droplistItem',

    attributes: {
      componentName: 'droplistItem',
      packageName: __WEBPACK_IMPORTED_MODULE_12__package_json__["name"],
      packageVersion: __WEBPACK_IMPORTED_MODULE_12__package_json__["version"]
    }
  })
})(Item)));

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TooltipWithoutAnalytics */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_node_resolver__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_node_resolver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_node_resolver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_flushable__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_flushable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_flushable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__atlaskit_portal__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__atlaskit_analytics_next__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__atlaskit_theme__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__package_json__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styled__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Animation__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Position__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_analytics_payloads__ = __webpack_require__(671);







/* eslint-disable react/require-default-props */
















var pendingHide = void 0;

var showTooltip = function showTooltip(fn, defaultDelay) {
  var isHidePending = pendingHide && pendingHide.pending();
  if (isHidePending) {
    pendingHide.flush();
  }
  var pendingShow = __WEBPACK_IMPORTED_MODULE_8_flushable___default()(function () {
    return fn(isHidePending);
  }, isHidePending ? 0 : defaultDelay);
  return pendingShow.cancel;
};

var hideTooltip = function hideTooltip(fn, defaultDelay) {
  pendingHide = __WEBPACK_IMPORTED_MODULE_8_flushable___default()(function (flushed) {
    return fn(flushed);
  }, defaultDelay);
  return pendingHide.cancel;
};

var Tooltip = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Tooltip, _Component);

  function Tooltip() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Tooltip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Tooltip.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Tooltip)).call.apply(_ref, [this].concat(args))), _this), _this.mouseCoordinates = null, _this.cancelPendingSetState = function () {}, _this.state = {
      immediatelyHide: false,
      immediatelyShow: false,
      isVisible: false,
      everBeenVisible: false
    }, _this.handleWindowScroll = function () {
      if (_this.state.isVisible) {
        _this.cancelPendingSetState();
        _this.setState({ isVisible: false, immediatelyHide: true });
      }
    }, _this.handleMouseClick = function () {
      if (_this.props.hideTooltipOnClick) {
        _this.cancelPendingSetState();
        _this.setState({ isVisible: false, immediatelyHide: true });
      }
    }, _this.handleMouseOver = function (e) {
      if (e.target === _this.wrapperRef) return;
      _this.cancelPendingSetState();
      if (Boolean(_this.props.content) && !_this.state.isVisible) {
        _this.cancelPendingSetState = showTooltip(function (immediatelyShow) {
          _this.setState({
            isVisible: true,
            everBeenVisible: true,
            immediatelyShow: immediatelyShow
          });
          if (_this.props.onShow) {
            _this.props.onShow();
          }
        }, _this.props.delay);
      }
    }, _this.handleMouseLeave = function (e) {
      if (e.target === _this.wrapperRef) return;
      _this.cancelPendingSetState();
      if (_this.state.isVisible) {
        _this.cancelPendingSetState = hideTooltip(function (immediatelyHide) {
          _this.setState({ isVisible: false, immediatelyHide: immediatelyHide });
          if (_this.props.onHide) {
            _this.props.onHide();
          }
        }, _this.props.delay);
      }
    }, _this.handleMouseMove = function (event) {
      _this.mouseCoordinates = {
        left: event.clientX,
        top: event.clientY
      };
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  } // set in mouseover/mouseout handlers


  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Tooltip, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var scrollOptions = { capture: true, passive: true };
      if (!prevState.isVisible && this.state.isVisible) {
        window.addEventListener('scroll', this.handleWindowScroll, scrollOptions);
      } else if (prevState.isVisible && !this.state.isVisible) {
        window.removeEventListener('scroll', this.handleWindowScroll, scrollOptions);
      }
    }

    // Update mouse coordinates, used when position is 'mouse'.
    // We are not debouncing/throttling this function because we aren't causing any
    // re-renders or performaing any intensive calculations, we're just updating a value.
    // React also doesn't play nice debounced DOM event handlers because they pool their
    // SyntheticEvent objects. Need to use event.persist as a workaround - https://stackoverflow.com/a/24679479/893630

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          content = _props.content,
          position = _props.position,
          mousePosition = _props.mousePosition,
          truncate = _props.truncate,
          TooltipContainer = _props.component,
          TargetContainer = _props.tag;
      var _state = this.state,
          isVisible = _state.isVisible,
          everBeenVisible = _state.everBeenVisible,
          immediatelyShow = _state.immediatelyShow,
          immediatelyHide = _state.immediatelyHide;

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.Fragment,
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          TargetContainer,
          {
            onClick: this.handleMouseClick,
            onMouseOver: this.handleMouseOver,
            onMouseOut: this.handleMouseLeave,
            onMouseMove: this.handleMouseMove,
            ref: function ref(wrapperRef) {
              _this2.wrapperRef = wrapperRef;
            }
          },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_node_resolver___default.a,
            {
              innerRef: function innerRef(targetRef) {
                _this2.targetRef = targetRef;
              }
            },
            __WEBPACK_IMPORTED_MODULE_6_react__["Children"].only(children)
          )
        ),
        everBeenVisible && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_14__Animation__["a" /* default */],
          {
            immediatelyShow: immediatelyShow,
            immediatelyHide: immediatelyHide,
            'in': isVisible
          },
          function (getAnimationStyles) {
            return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9__atlaskit_portal__["a" /* default */],
              { zIndex: __WEBPACK_IMPORTED_MODULE_11__atlaskit_theme__["e" /* layers */].tooltip() },
              __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_15__Position__["a" /* default */],
                {
                  key: position,
                  mouseCoordinates: _this2.mouseCoordinates,
                  mousePosition: mousePosition,
                  position: position,
                  target: _this2.targetRef
                },
                function (ref, placement, positionStyles) {
                  return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                    TooltipContainer,
                    {
                      innerRef: ref,
                      style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, positionStyles, getAnimationStyles(placement)),
                      truncate: truncate,
                      'data-placement': placement
                    },
                    content
                  );
                }
              )
            );
          }
        )
      );
    }
  }]);

  return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

Tooltip.defaultProps = {
  component: __WEBPACK_IMPORTED_MODULE_13__styled__["a" /* Tooltip */],
  delay: 300,
  mousePosition: 'bottom',
  position: 'bottom',
  tag: 'div'
};



var createAndFireEventOnAtlaskit = Object(__WEBPACK_IMPORTED_MODULE_10__atlaskit_analytics_next__["b" /* createAndFireEvent */])('atlaskit');

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10__atlaskit_analytics_next__["c" /* withAnalyticsContext */])({
  componentName: 'tooltip',
  packageName: __WEBPACK_IMPORTED_MODULE_12__package_json__["name"],
  packageVersion: __WEBPACK_IMPORTED_MODULE_12__package_json__["version"]
})(Object(__WEBPACK_IMPORTED_MODULE_10__atlaskit_analytics_next__["d" /* withAnalyticsEvents */])({
  onHide: __WEBPACK_IMPORTED_MODULE_16__utils_analytics_payloads__["b" /* unhoveredPayload */],
  onShow: createAndFireEventOnAtlaskit(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_16__utils_analytics_payloads__["a" /* hoveredPayload */]))
})(Tooltip)));

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NodeResolver = __webpack_require__(659);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_NodeResolver).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _reactDom = __webpack_require__(27);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NodeResolver = function (_Component) {
  _inherits(NodeResolver, _Component);

  function NodeResolver() {
    _classCallCheck(this, NodeResolver);

    return _possibleConstructorReturn(this, (NodeResolver.__proto__ || Object.getPrototypeOf(NodeResolver)).apply(this, arguments));
  }

  _createClass(NodeResolver, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.innerRef((0, _reactDom.findDOMNode)(this));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.innerRef(null);
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return NodeResolver;
}(_react.Component);

exports.default = NodeResolver;

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global.map = factory());
}(this, (function () { 'use strict';

  // a timeout function that can be flushed and cancelled
  var flushable = function flushable(onComplete, delay) {
    var timeoutId = setTimeout(function () {
      timeoutId = null;
      onComplete(false);
    }, delay);

    var clearTimer = function clearTimer() {
      if (timeoutId) {
        clearTimeout(timeoutId);
        timeoutId = null;
      }
    };

    return {
      cancel: clearTimer,
      flush: function flush() {
        if (!timeoutId) {
          return;
        }

        clearTimer();
        onComplete(true);
      },
      pending: function pending() {
        return Boolean(timeoutId);
      }
    };
  };

  return flushable;

})));


/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export e100 */
/* unused harmony export e200 */
/* unused harmony export e300 */
/* unused harmony export e400 */
/* unused harmony export e500 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_themed__ = __webpack_require__(166);



// Cards on a board
var e100 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 1px 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px 0 ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 1px 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

// Inline dialogs
var e200 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 4px 8px -2px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 4px 8px -2px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

// Modals
var e300 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 8px 16px -4px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 8px 16px -4px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

// Panels
var e400 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 12px 24px -6px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 12px 24px -6px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

// Flag messages (notifications)
var e500 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 20px 32px -8px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 20px 32px -8px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export h900 */
/* unused harmony export h800 */
/* unused harmony export h700 */
/* unused harmony export h600 */
/* unused harmony export h500 */
/* unused harmony export h400 */
/* unused harmony export h300 */
/* unused harmony export h200 */
/* unused harmony export h100 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__colors__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index__ = __webpack_require__(165);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 500;\n  letter-spacing: -0.01em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 500;\n  letter-spacing: -0.01em;\n  margin-top: ', 'px;\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  margin-top: ', 'px;\n']),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 500;\n  letter-spacing: -0.008em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 500;\n  letter-spacing: -0.008em;\n  margin-top: ', 'px;\n']),
    _templateObject4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.006em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.006em;\n  margin-top: ', 'px;\n']),
    _templateObject5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.003em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.003em;\n  margin-top: ', 'px;\n']),
    _templateObject6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  margin-top: ', 'px;\n  text-transform: uppercase;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  margin-top: ', 'px;\n  text-transform: uppercase;\n']),
    _templateObject7 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  margin-top: ', 'px;\n']),
    _templateObject8 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: normal;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: normal;\n  margin-top: ', 'px;\n']);






var baseHeading = function baseHeading(size, lineHeight) {
  return '\n  font-size: ' + size / Object(__WEBPACK_IMPORTED_MODULE_3__index__["c" /* fontSize */])() + 'em;\n  font-style: inherit;\n  line-height: ' + lineHeight / size + ';\n';
};

var h900 = function h900() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject, baseHeading(35, 40), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 6.5);
};

var h800 = function h800() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject2, baseHeading(29, 32), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 5);
};

var h700 = function h700() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject, baseHeading(24, 28), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 5);
};

var h600 = function h600() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject3, baseHeading(20, 24), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 3.5);
};

var h500 = function h500() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject4, baseHeading(16, 20), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 3);
};

var h400 = function h400() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject5, baseHeading(14, 16), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 2);
};

var h300 = function h300() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject6, baseHeading(12, 16), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 2.5);
};

var h200 = function h200() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject7, baseHeading(12, 16), __WEBPACK_IMPORTED_MODULE_2__colors__["subtleHeading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 2);
};

var h100 = function h100() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject8, baseHeading(12, 16), __WEBPACK_IMPORTED_MODULE_2__colors__["subtleHeading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 2);
};

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export add */
/* unused harmony export subtract */
/* unused harmony export multiply */
/* unused harmony export divide */
function add(fn, addend) {
  return function (props) {
    return fn(props) + addend;
  };
}

function subtract(fn, subtrahend) {
  return function (props) {
    return fn(props) - subtrahend;
  };
}

function multiply(fn, factor) {
  return function (props) {
    return fn(props) * factor;
  };
}

function divide(fn, divisor) {
  return function (props) {
    return fn(props) / divisor;
  };
}

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__colors__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Context__ = __webpack_require__(100);








var _templateObject = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  background-color: ', ';\n  color: ', ';\n\n  a {\n    color: ', ';\n  }\n  a:hover {\n    color: ', ';\n  }\n  a:active {\n    color: ', ';\n  }\n  a:focus {\n    outline-color: ', ';\n  }\n  h1 {\n    color: ', ';\n  }\n  h2 {\n    color: ', ';\n  }\n  h3 {\n    color: ', ';\n  }\n  h4 {\n    color: ', ';\n  }\n  h5 {\n    color: ', ';\n  }\n  h6 {\n    color: ', ';\n  }\n  small {\n    color: ', ';\n  }\n'], ['\n  background-color: ', ';\n  color: ', ';\n\n  a {\n    color: ', ';\n  }\n  a:hover {\n    color: ', ';\n  }\n  a:active {\n    color: ', ';\n  }\n  a:focus {\n    outline-color: ', ';\n  }\n  h1 {\n    color: ', ';\n  }\n  h2 {\n    color: ', ';\n  }\n  h3 {\n    color: ', ';\n  }\n  h4 {\n    color: ', ';\n  }\n  h5 {\n    color: ', ';\n  }\n  h6 {\n    color: ', ';\n  }\n  small {\n    color: ', ';\n  }\n']);









// For forward-compat until everything is upgraded.


function getStylesheetResetCSS(state) {
  var backgroundColor = __WEBPACK_IMPORTED_MODULE_10__colors__["background"](state);
  return '\n    body { background: ' + backgroundColor + '; }\n  ';
}

function buildThemeState(mode) {
  return { theme: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_11__constants__["a" /* CHANNEL */], { mode: mode }) };
}

var LegacyReset = __WEBPACK_IMPORTED_MODULE_9_styled_components__["default"].div(_templateObject, __WEBPACK_IMPORTED_MODULE_10__colors__["background"], __WEBPACK_IMPORTED_MODULE_10__colors__["text"], __WEBPACK_IMPORTED_MODULE_10__colors__["link"], __WEBPACK_IMPORTED_MODULE_10__colors__["linkHover"], __WEBPACK_IMPORTED_MODULE_10__colors__["linkActive"], __WEBPACK_IMPORTED_MODULE_10__colors__["linkOutline"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["subtleHeading"], __WEBPACK_IMPORTED_MODULE_10__colors__["subtleText"]);

var AtlaskitThemeProvider = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(AtlaskitThemeProvider, _Component);

  function AtlaskitThemeProvider(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AtlaskitThemeProvider);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AtlaskitThemeProvider.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(AtlaskitThemeProvider)).call(this, props));

    _this.state = buildThemeState(props.mode);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(AtlaskitThemeProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return { hasAtlaskitThemeProvider: true };
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (!this.context.hasAtlaskitThemeProvider) {
        var css = getStylesheetResetCSS(this.state);
        this.stylesheet = document.createElement('style');
        this.stylesheet.type = 'text/css';
        this.stylesheet.innerHTML = css;
        if (document && document.head) {
          document.head.appendChild(this.stylesheet);
        }
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (newProps.mode !== this.props.mode) {
        var newThemeState = buildThemeState(newProps.mode);
        if (this.stylesheet) {
          var css = getStylesheetResetCSS(newThemeState);
          this.stylesheet.innerHTML = css;
        }
        this.setState(newThemeState);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.stylesheet && document && document.head) {
        document.head.removeChild(this.stylesheet);
        delete this.stylesheet;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;

      var theme = this.state.theme;
      return (
        /* Wrapping the new provider around the old one provides forward
        compatibility when using the old provider for styled components. This
        allows us to use components converted to use the new API with consumers
        using the old provider along side components that may still be using the
        old theming API. */
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12__Context__["b" /* Provider */],
          { value: { mode: theme[__WEBPACK_IMPORTED_MODULE_11__constants__["a" /* CHANNEL */]].mode } },
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_styled_components__["ThemeProvider"],
            { theme: theme },
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
              LegacyReset,
              null,
              children
            )
          )
        )
      );
    }
  }]);

  return AtlaskitThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

AtlaskitThemeProvider.defaultProps = {
  mode: __WEBPACK_IMPORTED_MODULE_11__constants__["b" /* DEFAULT_THEME_MODE */]
};
AtlaskitThemeProvider.childContextTypes = {
  hasAtlaskitThemeProvider: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
};
AtlaskitThemeProvider.contextTypes = {
  hasAtlaskitThemeProvider: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
};
/* harmony default export */ __webpack_exports__["a"] = (AtlaskitThemeProvider);

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);





/* unused harmony default export */ var _unused_webpack_default_export = (function (_ref) {
  var children = _ref.children,
      props = _ref.props,
      theme = _ref.theme;

  var appearance = (typeof props === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(props)) === 'object' ? 'default' : props;
  var merged = (typeof props === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(props)) === 'object' ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, props) : {};
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(theme).forEach(function (key) {
    if (!(key in merged)) {
      merged[key] = theme[key]({ appearance: appearance });
    }
  });
  return children(merged);
});

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__colors__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Context__ = __webpack_require__(100);








var _templateObject = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ';\n'], ['\n  ', ';\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    background-color: ', ';\n    color: ', ';\n\n    a {\n      color: ', ';\n    }\n    a:hover {\n      color: ', ';\n    }\n    a:active {\n      color: ', ';\n    }\n    a:focus {\n      outline-color: ', ';\n    }\n    h1,\n    h2,\n    h3,\n    h4,\n    h5 {\n      color: ', ';\n    }\n    h6 {\n      color: ', ';\n    }\n    small {\n      color: ', ';\n    }\n  '], ['\n    background-color: ', ';\n    color: ', ';\n\n    a {\n      color: ', ';\n    }\n    a:hover {\n      color: ', ';\n    }\n    a:active {\n      color: ', ';\n    }\n    a:focus {\n      outline-color: ', ';\n    }\n    h1,\n    h2,\n    h3,\n    h4,\n    h5 {\n      color: ', ';\n    }\n    h6 {\n      color: ', ';\n    }\n    small {\n      color: ', ';\n    }\n  ']);






var orTextColor = function orTextColor(preferred) {
  return function (p) {
    return p[preferred] || p.textColor;
  };
};
var Div = __WEBPACK_IMPORTED_MODULE_8_styled_components__["default"].div(_templateObject, function (p) {
  return Object(__WEBPACK_IMPORTED_MODULE_8_styled_components__["css"])(_templateObject2, p.backgroundColor, p.textColor, orTextColor('linkColor'), orTextColor('linkColorHover'), orTextColor('linkColorActive'), orTextColor('linkColorOutline'), orTextColor('headingColor'), orTextColor('subtleHeadingColor'), orTextColor('subtleTextColor'));
});

var defaultTheme = {
  backgroundColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N0"],
  linkColor: __WEBPACK_IMPORTED_MODULE_9__colors__["B400"],
  linkColorHover: __WEBPACK_IMPORTED_MODULE_9__colors__["B300"],
  linkColorActive: __WEBPACK_IMPORTED_MODULE_9__colors__["B500"],
  linkColorOutline: __WEBPACK_IMPORTED_MODULE_9__colors__["B100"],
  headingColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N800"],
  subtleHeadingColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N200"],
  subtleTextColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N200"],
  textColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N900"]
};

var Reset = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Reset, _Component);

  function Reset() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Reset);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Reset.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Reset)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Reset, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10__Context__["a" /* Consumer */],
        null,
        function (theme) {
          return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            Div,
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, defaultTheme, theme, _this2.props),
            _this2.props.children
          );
        }
      );
    }
  }]);

  return Reset;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

/* unused harmony default export */ var _unused_webpack_default_export = (Reset);

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Context__ = __webpack_require__(100);








var Theme = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Theme, _Component);

  function Theme() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Theme);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Theme.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Theme)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Theme, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          values = _props.values;

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__components_Context__["a" /* Consumer */],
        null,
        function (theme) {
          var merged = values(theme);
          return typeof children === 'function' ? children(merged) : __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__components_Context__["b" /* Provider */],
            { value: merged },
            children
          );
        }
      );
    }
  }]);

  return Theme;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Theme.defaultProps = {
  values: function values(v) {
    return v;
  }
};
/* unused harmony default export */ var _unused_webpack_default_export = (Theme);

/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_transition_group__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_transition_group__);




var ENTER_DURATION = 120;
var EXIT_DURATION = 80;
var easing = 'cubic-bezier(0.23, 1, 0.32, 1)'; // easeOutQuint
var distance = 8;

var horizontalOffset = {
  left: distance,
  right: -distance,
  top: 0,
  bottom: 0
};
var verticalOffset = {
  bottom: -distance,
  top: distance,
  left: 0,
  right: 0
};

var defaultStyle = function defaultStyle(timeout) {
  return {
    transition: 'transform ' + timeout.enter + 'ms ' + easing + ', opacity ' + timeout.enter + 'ms linear',
    opacity: 0
  };
};

var transitionStyle = function transitionStyle(timeout, state, position) {
  var transitions = {
    entering: {
      transform: 'translate3d(' + horizontalOffset[position] + 'px, ' + verticalOffset[position] + 'px, 0)'
    },
    entered: {
      opacity: 1
    },
    exiting: {
      opacity: 0,
      transition: timeout.exit + 'ms linear',
      transform: 'translate3d(' + horizontalOffset[position] / 2 + 'px, ' + verticalOffset[position] / 2 + 'px, 0)'
    }
  };
  return transitions[state];
};

var getStyle = function getStyle(timeout, state) {
  return function (position) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, defaultStyle(timeout), transitionStyle(timeout, state, position));
  };
};

var Animation = function Animation(_ref) {
  var children = _ref.children,
      immediatelyHide = _ref.immediatelyHide,
      immediatelyShow = _ref.immediatelyShow,
      inProp = _ref.in;

  var timeout = {
    enter: immediatelyShow ? 1 : ENTER_DURATION,
    exit: immediatelyHide ? 1 : EXIT_DURATION
  };
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_transition_group__["Transition"],
    { timeout: timeout, 'in': inProp, unmountOnExit: true, appear: true },
    function (state) {
      return children(getStyle(timeout, state));
    }
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Animation);

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_getPosition__ = __webpack_require__(670);









var Position = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Position, _React$Component);

  function Position() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Position);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Position.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Position)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      ref: null
    }, _this.initialMouseCoordinates = undefined, _this.setRef = function (ref) {
      _this.setState({ ref: ref });
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Position, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          position = _props.position,
          mouseCoordinates = _props.mouseCoordinates,
          mousePosition = _props.mousePosition,
          target = _props.target;
      var ref = this.state.ref;

      var adjustedPosition = {};
      if (target && ref) {
        if (!this.initialMouseCoordinates) {
          // when we show the tooltip relative to the mouse position, always use
          // the initial mouse coordinates so the tooltip is placed in the same spot.
          this.initialMouseCoordinates = mouseCoordinates;
        }
        adjustedPosition = Object(__WEBPACK_IMPORTED_MODULE_6__utils_getPosition__["a" /* default */])({
          position: position,
          target: target,
          tooltip: ref,
          mouseCoordinates: this.initialMouseCoordinates,
          mousePosition: mousePosition
        });
      }
      return this.props.children(this.setRef, adjustedPosition.position || position, adjustedPosition.coordinates || {});
    }
  }]);

  return Position;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Position);

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getPosition;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);




var FLIPPED_POSITION = {
  top: 'bottom',
  right: 'left',
  bottom: 'top',
  left: 'right'
};

// Get viewport height excluding scrollbars


function getViewportHeight() {
  var docEl = document.documentElement;
  return docEl && docEl.clientHeight || window.innerHeight || 0;
}

// Get viewport width excluding scrollbars
function getViewportWidth() {
  var docEl = document.documentElement;
  return docEl && docEl.clientWidth || window.innerWidth || 0;
}

// Returns a top or left position that shifts the original coord to within viewport
function shiftCoord(coordName, coords, gutter) {
  var shiftedCoord = {};
  if (coordName === 'top' || coordName === 'left') {
    shiftedCoord[coordName] = 0 + gutter;
  }

  if (coordName === 'bottom') {
    var amountClipped = coords.bottom - getViewportHeight();
    var shiftedTop = coords.top - amountClipped - gutter;

    shiftedCoord.top = shiftedTop >= 0 ? shiftedTop : 0 + gutter;
  } else if (coordName === 'right') {
    var _amountClipped = coords.right - getViewportWidth();
    var shiftedLeft = coords.left - _amountClipped - gutter;

    shiftedCoord.left = shiftedLeft >= 0 ? shiftedLeft : 0 + gutter;
  }

  return shiftedCoord;
}

// Returns a map of positions to whether they fit in viewport
function getViewportBounds(_ref, gutter) {
  var top = _ref.top,
      right = _ref.right,
      bottom = _ref.bottom,
      left = _ref.left;

  return {
    top: top >= 0 + gutter,
    left: left >= 0 + gutter,
    bottom: bottom <= getViewportHeight() - gutter,
    right: right <= getViewportWidth() - gutter
  };
}

// Get the viewport bounds for each position coord
function getAllViewportBounds(allCoords, gutter) {
  var viewportBounds = {};
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(allCoords).forEach(function (position) {
    var coords = allCoords[position];

    viewportBounds[position] = getViewportBounds(coords, gutter);
  });

  return viewportBounds;
}

// Adjust the position and top/left coords to fit inside viewport
// Performs flipping on the primary axis and shifting on the secondary axis
function adjustPosition(originalPosition, positionCoords, gutter) {
  var flippedPosition = FLIPPED_POSITION[originalPosition];

  var viewportBounds = getAllViewportBounds(positionCoords, gutter);

  // Should flip if the original position was not within bounds and the new position is
  var shouldFlip = !viewportBounds[originalPosition][originalPosition] && viewportBounds[flippedPosition][originalPosition];

  var adjustedPosition = shouldFlip ? flippedPosition : originalPosition;

  // Check secondary axis, for positional shift
  var shiftedCoords = {};
  var secondaryPositions = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(FLIPPED_POSITION).filter(function (position) {
    return position !== originalPosition && position !== flippedPosition;
  });

  secondaryPositions.forEach(function (position) {
    var inViewport = viewportBounds[adjustedPosition][position];
    if (!inViewport) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(shiftedCoords, shiftCoord(position, positionCoords[adjustedPosition], gutter));
    }
  });

  // adjust positions with flipped position on main axis + shifted position on secondary axis
  var left = shiftedCoords.left != null ? shiftedCoords.left : positionCoords[adjustedPosition].left;
  var top = shiftedCoords.top != null ? shiftedCoords.top : positionCoords[adjustedPosition].top;

  return { left: left, top: top, adjustedPosition: adjustedPosition };
}

function getCoords(_ref2) {
  var targetRect = _ref2.targetRect,
      tooltipRect = _ref2.tooltipRect,
      gutter = _ref2.gutter;

  return {
    top: {
      top: targetRect.top - (tooltipRect.height + gutter),
      right: targetRect.right - (targetRect.width - tooltipRect.width) / 2,
      bottom: targetRect.top - gutter,
      left: targetRect.left + (targetRect.width - tooltipRect.width) / 2
    },
    right: {
      top: targetRect.top + (targetRect.height - tooltipRect.height) / 2,
      right: targetRect.right + gutter + tooltipRect.width,
      bottom: targetRect.bottom - (targetRect.height - tooltipRect.height) / 2,
      left: targetRect.right + gutter
    },
    bottom: {
      top: targetRect.bottom + gutter,
      right: targetRect.right - (targetRect.width - tooltipRect.width) / 2,
      bottom: targetRect.bottom + gutter + tooltipRect.height,
      left: targetRect.left + (targetRect.width - tooltipRect.width) / 2
    },
    left: {
      top: targetRect.top + (targetRect.height - tooltipRect.height) / 2,
      right: targetRect.left - gutter,
      bottom: targetRect.bottom - (targetRect.height - tooltipRect.height) / 2,
      left: targetRect.left - (tooltipRect.width + gutter)
    }
  };
}

function getMouseCoords(_ref3) {
  var mouseCoordinates = _ref3.mouseCoordinates,
      tooltipRect = _ref3.tooltipRect,
      gutter = _ref3.gutter;

  var cursorPaddingRight = 8;
  var cursorPaddingBottom = 16;
  return {
    top: {
      top: mouseCoordinates.top - (tooltipRect.height + gutter),
      right: mouseCoordinates.left + tooltipRect.width / 2,
      bottom: mouseCoordinates.top - gutter,
      left: mouseCoordinates.left - tooltipRect.width / 2
    },
    right: {
      top: mouseCoordinates.top - tooltipRect.height / 2,
      right: mouseCoordinates.left + cursorPaddingRight + gutter + tooltipRect.width,
      bottom: mouseCoordinates.top + tooltipRect.height / 2,
      left: mouseCoordinates.left + cursorPaddingRight + gutter
    },
    bottom: {
      top: mouseCoordinates.top + cursorPaddingBottom + gutter,
      right: mouseCoordinates.left + tooltipRect.width / 2,
      bottom: mouseCoordinates.top + cursorPaddingBottom + gutter + tooltipRect.height,
      left: mouseCoordinates.left - tooltipRect.width / 2
    },
    left: {
      top: mouseCoordinates.top - tooltipRect.height / 2,
      right: mouseCoordinates.left - gutter,
      bottom: mouseCoordinates.top + tooltipRect.height / 2,
      left: mouseCoordinates.left - (tooltipRect.width + gutter)
    }
  };
}

function getMousePosition(_ref4) {
  var mousePosition = _ref4.mousePosition,
      tooltip = _ref4.tooltip,
      mouseCoordinates = _ref4.mouseCoordinates;

  var noPosition = {
    coordinates: { left: 0, top: 0 },
    position: 'mouse',
    mousePosition: 'bottom'
  };

  if (!mousePosition) throw new Error('Property "mousePosition" is required.');
  if (!tooltip) throw new Error('Property "tooltip" is required.');

  if (!mouseCoordinates) return noPosition;

  // get the original coordinates
  var gutter = 8;
  var tooltipRect = tooltip.getBoundingClientRect();

  var POSITIONS = getMouseCoords({ mouseCoordinates: mouseCoordinates, tooltipRect: tooltipRect, gutter: gutter });

  var _adjustPosition = adjustPosition(mousePosition, POSITIONS, gutter),
      left = _adjustPosition.left,
      top = _adjustPosition.top,
      adjustedPosition = _adjustPosition.adjustedPosition;

  return {
    coordinates: { left: left, top: top },
    position: 'mouse',
    mousePosition: adjustedPosition
  };
}

/**
 * Gets the coordinates and adjusted position of a tooltip.
 * Position will be flipped on the primary axis with respect to the initial position
 * if there is not enough space in the viewport.
 * Coordinates will be shifted along the secondary axis to render within viewport.
 */
function getPosition(_ref5) {
  var position = _ref5.position,
      target = _ref5.target,
      tooltip = _ref5.tooltip,
      mouseCoordinates = _ref5.mouseCoordinates,
      mousePosition = _ref5.mousePosition;

  if (position === 'mouse') {
    return getMousePosition({ mousePosition: mousePosition, tooltip: tooltip, mouseCoordinates: mouseCoordinates });
  }

  var noPosition = {
    coordinates: { left: 0, top: 0 },
    position: 'bottom',
    mousePosition: mousePosition
  };
  /* eslint-disable no-console */
  if (!position) console.error('Property "position" is required.');
  if (!target) console.error('Property "target" is required.');
  if (!tooltip) console.error('Property "tooltip" is required.');
  if (!position || !target || !tooltip) return noPosition;
  /* eslint-enable no-console */

  // get the original coordinates
  var gutter = 8;
  var targetRect = target.getBoundingClientRect();
  var tooltipRect = tooltip.getBoundingClientRect();

  var POSITIONS = getCoords({ targetRect: targetRect, tooltipRect: tooltipRect, gutter: gutter });

  var _adjustPosition2 = adjustPosition(position, POSITIONS, gutter),
      left = _adjustPosition2.left,
      top = _adjustPosition2.top,
      adjustedPosition = _adjustPosition2.adjustedPosition;

  return {
    coordinates: { left: left, top: top },
    position: adjustedPosition,
    mousePosition: mousePosition
  };
}

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hoveredPayload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return unhoveredPayload; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_json__);


var hoveredPayload = {
  action: 'displayed',
  actionSubject: 'tooltip',

  attributes: {
    componentName: 'tooltip',
    packageName: __WEBPACK_IMPORTED_MODULE_0__package_json__["name"],
    packageVersion: __WEBPACK_IMPORTED_MODULE_0__package_json__["version"]
  }
};

var unhoveredPayload = {
  action: 'hidden',
  actionSubject: 'tooltip',

  attributes: {
    componentName: 'tooltip',
    packageName: __WEBPACK_IMPORTED_MODULE_0__package_json__["name"],
    packageVersion: __WEBPACK_IMPORTED_MODULE_0__package_json__["version"]
  }
};

/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getInputBackground;
/* harmony export (immutable) */ __webpack_exports__["b"] = getInputFill;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__ = __webpack_require__(41);


function getInputBackground(_ref) {
  var isChecked = _ref.isChecked,
      isDisabled = _ref.isDisabled,
      isHovered = _ref.isHovered,
      isPressed = _ref.isPressed;

  var background = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N40;

  if (isHovered) background = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N50;
  if (isPressed) background = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].B200;
  if (isChecked) background = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].B400;
  if (isDisabled) background = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N20;
  if (isChecked && isDisabled) background = __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N600;

  return background;
}

function getInputFill(appearanceProps) {
  return appearanceProps.isChecked ? __WEBPACK_IMPORTED_MODULE_0__atlaskit_theme__["b" /* colors */].N0 : 'transparent';
}

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export supportsVoiceOver */
/* unused harmony export getAriaRoles */
/* unused harmony export baseTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styled_Item__ = __webpack_require__(167);









var supportsVoiceOver = function supportsVoiceOver() {
  return (/Mac OS X/.test(navigator.userAgent)
  );
};

var getAriaRoles = function getAriaRoles() {
  return {
    checkbox: supportsVoiceOver() ? 'checkbox' : 'menuitemcheckbox',
    link: 'menuitem',
    option: 'option',
    radio: supportsVoiceOver() ? 'radio' : 'menuitemradio'
  };
};
var baseTypes = {
  default: 'link',
  values: ['link', 'radio', 'checkbox', 'option']
};

var Element = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Element, _PureComponent);

  function Element() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Element);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Element.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Element)).call.apply(_ref, [this].concat(args))), _this), _this.handleMouseDown = function (e) {
      e.preventDefault();
      _this.props.handleMouseDown();
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }
  // this prevents the focus ring from appearing when the element is clicked.
  // It doesn't interfere with the onClick handler


  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Element, [{
    key: 'render',
    value: function render() {
      var props = this.props;
      var isActive = props.isActive,
          isChecked = props.isChecked,
          isDisabled = props.isDisabled,
          isFocused = props.isFocused,
          isHidden = props.isHidden,
          isSelected = props.isSelected,
          isPrimary = props.isPrimary;

      var type = this.props.type || '';
      var appearanceProps = {
        isActive: isActive,
        isChecked: isChecked,
        isDisabled: isDisabled,
        isFocused: isFocused,
        isHidden: isHidden,
        isSelected: isSelected,
        isPrimary: isPrimary
      };

      var ariaProps = {
        'aria-checked': !!isChecked,
        'aria-disabled': !!isDisabled,
        'aria-hidden': !!isHidden,
        'aria-selected': !!isSelected
      };
      var ariaRoles = getAriaRoles();
      var commonProps = {
        'data-role': 'droplistItem',
        onClick: props.handleClick,
        onKeyPress: props.handleKeyPress,
        onMouseDown: this.handleMouseDown,
        onMouseOut: props.handleMouseOut,
        onMouseOver: props.handleMouseOver,
        onMouseUp: props.handleMouseUp,
        role: ariaRoles[type],
        title: props.title,
        tabIndex: props.type === 'option' ? null : 0
      };
      var testingProps =  false ? {
        'data-test-active': isActive,
        'data-test-checked': isChecked,
        'data-test-disabled': isDisabled,
        'data-test-hidden': isHidden,
        'data-test-selected': isSelected
      } : {};
      var consolidatedProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, appearanceProps, ariaProps, commonProps, testingProps);

      if (props.href && !isDisabled) {
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__styled_Item__["b" /* Anchor */],
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ href: props.href, target: props.target }, consolidatedProps),
          props.children
        );
      }

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__styled_Item__["h" /* Span */],
        consolidatedProps,
        props.children
      );
    }
  }]);

  return Element;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Element);

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styled_Group__ = __webpack_require__(675);








var DroplistGroup = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(DroplistGroup, _PureComponent);

  function DroplistGroup() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DroplistGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = DroplistGroup.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(DroplistGroup)).call.apply(_ref, [this].concat(args))), _this), _this.state = { ariaLabel: _this.props.heading }, _this.componentDidMount = function () {
      if (_this.props.heading || _this.props.elemAfter) {
        _this.setState({ ariaLabel: _this.getAriaLabel() });
      }
    }, _this.componentDidUpdate = function () {
      if (_this.props.heading || _this.props.elemAfter) {
        _this.setState({ ariaLabel: _this.getAriaLabel() });
      }
    }, _this.getAriaLabel = function () {
      var _this$props = _this.props,
          elemAfter = _this$props.elemAfter,
          heading = _this$props.heading;

      var afterText = elemAfter && typeof elemAfter === 'string' ? elemAfter : _this.headingElement && _this.headingElement.textContent;

      return (heading || '') + ' ' + (afterText || '');
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(DroplistGroup, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          elemAfter = _props.elemAfter,
          heading = _props.heading;
      var ariaLabel = this.state.ariaLabel;


      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__styled_Group__["d" /* default */],
        { 'aria-label': ariaLabel, role: 'group' },
        heading ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__styled_Group__["a" /* Heading */],
          { 'aria-hidden': 'true', 'data-role': 'droplistGroupHeading' },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__styled_Group__["c" /* HeadingText */],
            null,
            heading
          ),
          elemAfter ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__styled_Group__["b" /* HeadingAfter */],
            {
              innerRef: function innerRef(r) {
                _this2.headingElement = r;
              }
            },
            elemAfter
          ) : null
        ) : null,
        children
      );
    }
  }]);

  return DroplistGroup;
}(__WEBPACK_IMPORTED_MODULE_5_react__["PureComponent"]);

DroplistGroup.displayName = 'Group';
/* harmony default export */ __webpack_exports__["a"] = (DroplistGroup);

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Heading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HeadingAfter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return HeadingText; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(41);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  box-sizing: border-box;\n  display: block;\n  margin-top: ', 'px;\n\n  &:first-child {\n    margin-top: 0;\n  }\n'], ['\n  box-sizing: border-box;\n  display: block;\n  margin-top: ', 'px;\n\n  &:first-child {\n    margin-top: 0;\n  }\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  align-items: baseline;\n  color: ', ';\n  display: flex;\n  flex: 1 1 auto;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 1;\n  margin: 0;\n  padding: ', 'px ', 'px;\n'], ['\n  align-items: baseline;\n  color: ', ';\n  display: flex;\n  flex: 1 1 auto;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 1;\n  margin: 0;\n  padding: ', 'px ', 'px;\n']),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  flex: 0 0 auto;\n'], ['\n  flex: 0 0 auto;\n']),
    _templateObject4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  flex: 1 1 auto;\n  font-size: 12px;\n  text-transform: uppercase;\n'], ['\n  flex: 1 1 auto;\n  font-size: 12px;\n  text-transform: uppercase;\n']);




/* harmony default export */ __webpack_exports__["d"] = (__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */]));

var Heading = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject2, Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* themed */])({
  light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].N300,
  dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["b" /* colors */].DN300
}), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */], __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["e" /* math */].multiply(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */], 1.5));
var HeadingAfter = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject3);
var HeadingText = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject4);

/***/ }),
/* 676 */
/***/ (function(module, exports) {

module.exports = {"name":"@atlaskit/dropdown-menu","version":"6.1.9"}

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_contextNamespace__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_keys__ = __webpack_require__(168);












var DropdownItemFocusManager = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(DropdownItemFocusManager, _Component);

  function DropdownItemFocusManager() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, DropdownItemFocusManager);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = DropdownItemFocusManager.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(DropdownItemFocusManager)).call.apply(_ref, [this].concat(args))), _this), _this.registeredItems = [], _this.handleItemRegistered = function (itemId, itemNode) {
      _this.registeredItems.push({ itemId: itemId, itemNode: itemNode });

      if (_this.props.autoFocus && _this.registeredItems.length === 1) {
        _this.focusedItemId = itemId;
        itemNode.focus();
      }
    }, _this.handleItemDeregistered = function (itemId) {
      _this.registeredItems = _this.registeredItems.filter(function (item) {
        return item.itemId !== itemId;
      });
    }, _this.handleItemFocused = function (itemId) {
      _this.focusedItemId = itemId;
    }, _this.handleItemUpdated = function (itemId, itemNode) {
      var matchingIndex = -1;
      for (var i = 0; i < _this.registeredItems.length; i++) {
        if (_this.registeredItems[i].itemId === itemId) {
          matchingIndex = i;
          break;
        }
      }

      if (matchingIndex === -1) {
        _this.handleItemRegistered(itemId, itemNode);
        return;
      }

      _this.registeredItems[matchingIndex].itemNode = itemNode;
      if (_this.focusedItemIndex() === matchingIndex) {
        itemNode.focus();
      }
    }, _this.focusedItemIndex = function () {
      var _this2 = _this,
          focusedItemId = _this2.focusedItemId,
          registeredItems = _this2.registeredItems;

      for (var i = 0; i < registeredItems.length; i++) {
        if (registeredItems[i].itemId === focusedItemId) {
          return i;
        }
      }
      return -1;
    }, _this.handleKeyboard = function (event) {
      var key = event.key,
          shiftKey = event.shiftKey;

      var focusedItemIndex = _this.focusedItemIndex();
      if (key === __WEBPACK_IMPORTED_MODULE_9__util_keys__["e" /* KEY_UP */] || key === __WEBPACK_IMPORTED_MODULE_9__util_keys__["a" /* KEY_DOWN */]) {
        // We prevent default here to avoid page scrolling when up/down
        // pressed while dropdown is focused.
        event.preventDefault();

        if (focusedItemIndex < 0) {
          return;
        }

        var nextItemIndex = key === __WEBPACK_IMPORTED_MODULE_9__util_keys__["e" /* KEY_UP */] ? Math.max(0, focusedItemIndex - 1) : Math.min(_this.registeredItems.length - 1, focusedItemIndex + 1);
        _this.registeredItems[nextItemIndex].itemNode.focus();
      }

      if (key === __WEBPACK_IMPORTED_MODULE_9__util_keys__["d" /* KEY_TAB */]) {
        if (!shiftKey && focusedItemIndex === _this.registeredItems.length - 1) {
          if (_this.props.close) _this.props.close({ event: event, source: 'keydown' });
        }

        if (shiftKey && focusedItemIndex === 0) {
          if (_this.props.close) _this.props.close({ event: event, source: 'keydown' });
        }
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(DropdownItemFocusManager, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_8__util_contextNamespace__["b" /* focusManagerContext */], {
        itemFocused: this.handleItemFocused,
        registerItem: this.handleItemRegistered,
        deregisterItem: this.handleItemDeregistered,
        updateItem: this.handleItemUpdated
      });
    }
  }, {
    key: 'render',
    value: function render() {
      // eslint-disable-next-line jsx-a11y/no-static-element-interactions
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { onKeyDown: this.handleKeyboard },
        this.props.children
      );
    }
  }]);

  return DropdownItemFocusManager;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

DropdownItemFocusManager.childContextTypes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_8__util_contextNamespace__["b" /* focusManagerContext */], __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object);
/* harmony default export */ __webpack_exports__["a"] = (DropdownItemFocusManager);

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_contextNamespace__ = __webpack_require__(69);










var DropdownItemClickManager = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(DropdownItemClickManager, _Component);

  function DropdownItemClickManager() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, DropdownItemClickManager);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = DropdownItemClickManager.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(DropdownItemClickManager)).call.apply(_ref, [this].concat(args))), _this), _this.handleItemClicked = function (event) {
      _this.props.onItemClicked(event);
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(DropdownItemClickManager, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_8__util_contextNamespace__["a" /* clickManagerContext */], {
        itemClicked: this.handleItemClicked
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return DropdownItemClickManager;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

DropdownItemClickManager.childContextTypes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_8__util_contextNamespace__["a" /* clickManagerContext */], __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object);
/* harmony default export */ __webpack_exports__["a"] = (DropdownItemClickManager);

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_array_find__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_array_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_contextNamespace__ = __webpack_require__(69);













var isItemInList = function isItemInList(itemList, itemId, groupId) {
  return Boolean(__WEBPACK_IMPORTED_MODULE_9_array_find___default()(itemList, function (item) {
    return item.id === itemId && item.groupId === groupId;
  }));
};

var DropdownItemSelectionCache = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(DropdownItemSelectionCache, _Component);

  function DropdownItemSelectionCache() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, DropdownItemSelectionCache);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = DropdownItemSelectionCache.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(DropdownItemSelectionCache)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      lastCacheUpdate: 0
    }, _this.selectedItems = [], _this.alreadyDefaultedItems = [], _this.handleItemSelectionsChanged = function (groupId, newGroupSelections) {
      var newSelectedItems = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(_this.selectedItems.filter(function (item) {
        return item.groupId !== groupId;
      })), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(newGroupSelections));

      _this.selectedItems = newSelectedItems;

      // We store selectedItems in an instance variable (this.selectedItems) instead of state,
      // because if multiple children update the cache at the same time it causes unexpected
      // behaviour due to the asynchronous behaviour of setState. So we need to trigger setState
      // with a different value to cause the children to be updated with their new selection values.
      _this.setState({ lastCacheUpdate: Date.now() });
    }, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  // Need to store selectedItemValues in state rather than component instance property
  // to ensure that re-render happens down the tree via context when selectedItemValues
  // is updated.
  // eslint-disable-line react/sort-comp

  // If any radio/checkbox items have defaultSelected applied, we need to keep track of whether
  // each of those items has had it's state set to 'selected'. This is because when the dropdown
  // menu is closed and then opened again, all of the radio/checkbox items re-mount so they
  // try to again apply their defaultSelected status. defaultSelected should only be applied on
  // the initial mount, as users can change the value post-mount. Alternatively, products can use
  // the isSelected prop with the onClick handler to control the selected state manually if needed.


  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(DropdownItemSelectionCache, [{
    key: 'getChildContext',
    // eslint-disable-line react/sort-comp

    value: function getChildContext() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_10__util_contextNamespace__["c" /* selectionCacheContext */], {
        // This function returns true/false describing whether the supplied navigation item
        // (which must have a unique item and group ID) is currently selected - this is used
        // by radio and checkbox dropdown items to retreive their 'selected' state when they
        // re-mount, which happens when the dropdown is closed and then re-opened.
        isItemSelected: function isItemSelected(groupId, itemId) {
          return isItemInList(_this2.selectedItems, itemId, groupId);
        },
        itemsInGroup: function itemsInGroup(groupId) {
          return _this2.selectedItems.filter(function (item) {
            return item.groupId === groupId;
          });
        },
        itemSelectionsChanged: this.handleItemSelectionsChanged,
        hasItemAlreadyHadDefaultSelectedApplied: function hasItemAlreadyHadDefaultSelectedApplied(groupId, itemId) {
          return isItemInList(_this2.alreadyDefaultedItems, itemId, groupId);
        },
        markItemAsDefaultApplied: function markItemAsDefaultApplied(groupId, itemId) {
          _this2.alreadyDefaultedItems.push({ id: itemId, groupId: groupId });
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        null,
        this.props.children
      );
    }
  }]);

  return DropdownItemSelectionCache;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

DropdownItemSelectionCache.childContextTypes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_10__util_contextNamespace__["c" /* selectionCacheContext */], __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.shape({
  isItemSelected: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  itemsInGroup: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  itemSelectionsChanged: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func
}));
/* harmony default export */ __webpack_exports__["a"] = (DropdownItemSelectionCache);

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function find(array, predicate, context) {
  if (typeof Array.prototype.find === 'function') {
    return array.find(predicate, context);
  }

  context = context || this;
  var length = array.length;
  var i;

  if (typeof predicate !== 'function') {
    throw new TypeError(predicate + ' is not a function');
  }

  for (i = 0; i < length; i++) {
    if (predicate.call(context, array[i], i, array)) {
      return array[i];
    }
  }
}

module.exports = find;


/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ';\n'], ['\n  ', ';\n']);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, function (_ref) {
  var shouldFitContainer = _ref.shouldFitContainer;
  return shouldFitContainer ? '' : 'max-width: 300px;';
}));

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_item__ = __webpack_require__(22);


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_item__["d" /* withItemClick */])(Object(__WEBPACK_IMPORTED_MODULE_0__atlaskit_item__["e" /* withItemFocus */])(__WEBPACK_IMPORTED_MODULE_0__atlaskit_item__["b" /* default */])));

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_icon_glyph_radio__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_icon_glyph_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__atlaskit_icon_glyph_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_item__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hoc_withToggleInteraction__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_supportsVoiceover__ = __webpack_require__(300);





/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2__hoc_withToggleInteraction__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_item__["e" /* withItemFocus */])(__WEBPACK_IMPORTED_MODULE_1__atlaskit_item__["b" /* default */]), __WEBPACK_IMPORTED_MODULE_0__atlaskit_icon_glyph_radio___default.a, function () {
  return Object(__WEBPACK_IMPORTED_MODULE_3__util_supportsVoiceover__["a" /* default */])() ? 'radio' : 'menuitemradio';
}));

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export e100 */
/* unused harmony export e200 */
/* unused harmony export e300 */
/* unused harmony export e400 */
/* unused harmony export e500 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_themed__ = __webpack_require__(169);



// Cards on a board
var e100 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 1px 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px 0 ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 1px 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

// Inline dialogs
var e200 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 4px 8px -2px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 4px 8px -2px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

// Modals
var e300 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 8px 16px -4px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 8px 16px -4px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

// Panels
var e400 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 12px 24px -6px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 12px 24px -6px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

// Flag messages (notifications)
var e500 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 20px 32px -8px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 20px 32px -8px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export h900 */
/* unused harmony export h800 */
/* unused harmony export h700 */
/* unused harmony export h600 */
/* unused harmony export h500 */
/* unused harmony export h400 */
/* unused harmony export h300 */
/* unused harmony export h200 */
/* unused harmony export h100 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__colors__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index__ = __webpack_require__(295);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 500;\n  letter-spacing: -0.01em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 500;\n  letter-spacing: -0.01em;\n  margin-top: ', 'px;\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  margin-top: ', 'px;\n']),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 500;\n  letter-spacing: -0.008em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 500;\n  letter-spacing: -0.008em;\n  margin-top: ', 'px;\n']),
    _templateObject4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.006em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.006em;\n  margin-top: ', 'px;\n']),
    _templateObject5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.003em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.003em;\n  margin-top: ', 'px;\n']),
    _templateObject6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  margin-top: ', 'px;\n  text-transform: uppercase;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  margin-top: ', 'px;\n  text-transform: uppercase;\n']),
    _templateObject7 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  margin-top: ', 'px;\n']),
    _templateObject8 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: normal;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: normal;\n  margin-top: ', 'px;\n']);






var baseHeading = function baseHeading(size, lineHeight) {
  return '\n  font-size: ' + size / Object(__WEBPACK_IMPORTED_MODULE_3__index__["b" /* fontSize */])() + 'em;\n  font-style: inherit;\n  line-height: ' + lineHeight / size + ';\n';
};

var h900 = function h900() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject, baseHeading(35, 40), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["c" /* gridSize */])() * 6.5);
};

var h800 = function h800() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject2, baseHeading(29, 32), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["c" /* gridSize */])() * 5);
};

var h700 = function h700() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject, baseHeading(24, 28), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["c" /* gridSize */])() * 5);
};

var h600 = function h600() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject3, baseHeading(20, 24), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["c" /* gridSize */])() * 3.5);
};

var h500 = function h500() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject4, baseHeading(16, 20), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["c" /* gridSize */])() * 3);
};

var h400 = function h400() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject5, baseHeading(14, 16), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["c" /* gridSize */])() * 2);
};

var h300 = function h300() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject6, baseHeading(12, 16), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["c" /* gridSize */])() * 2.5);
};

var h200 = function h200() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject7, baseHeading(12, 16), __WEBPACK_IMPORTED_MODULE_2__colors__["subtleHeading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["c" /* gridSize */])() * 2);
};

var h100 = function h100() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject8, baseHeading(12, 16), __WEBPACK_IMPORTED_MODULE_2__colors__["subtleHeading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["c" /* gridSize */])() * 2);
};

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export add */
/* unused harmony export subtract */
/* unused harmony export multiply */
/* unused harmony export divide */
function add(fn, addend) {
  return function (props) {
    return fn(props) + addend;
  };
}

function subtract(fn, subtrahend) {
  return function (props) {
    return fn(props) - subtrahend;
  };
}

function multiply(fn, factor) {
  return function (props) {
    return fn(props) * factor;
  };
}

function divide(fn, divisor) {
  return function (props) {
    return fn(props) / divisor;
  };
}

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__colors__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Context__ = __webpack_require__(101);








var _templateObject = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  background-color: ', ';\n  color: ', ';\n\n  a {\n    color: ', ';\n  }\n  a:hover {\n    color: ', ';\n  }\n  a:active {\n    color: ', ';\n  }\n  a:focus {\n    outline-color: ', ';\n  }\n  h1 {\n    color: ', ';\n  }\n  h2 {\n    color: ', ';\n  }\n  h3 {\n    color: ', ';\n  }\n  h4 {\n    color: ', ';\n  }\n  h5 {\n    color: ', ';\n  }\n  h6 {\n    color: ', ';\n  }\n  small {\n    color: ', ';\n  }\n'], ['\n  background-color: ', ';\n  color: ', ';\n\n  a {\n    color: ', ';\n  }\n  a:hover {\n    color: ', ';\n  }\n  a:active {\n    color: ', ';\n  }\n  a:focus {\n    outline-color: ', ';\n  }\n  h1 {\n    color: ', ';\n  }\n  h2 {\n    color: ', ';\n  }\n  h3 {\n    color: ', ';\n  }\n  h4 {\n    color: ', ';\n  }\n  h5 {\n    color: ', ';\n  }\n  h6 {\n    color: ', ';\n  }\n  small {\n    color: ', ';\n  }\n']);









// For forward-compat until everything is upgraded.


function getStylesheetResetCSS(state) {
  var backgroundColor = __WEBPACK_IMPORTED_MODULE_10__colors__["background"](state);
  return '\n    body { background: ' + backgroundColor + '; }\n  ';
}

function buildThemeState(mode) {
  return { theme: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_11__constants__["a" /* CHANNEL */], { mode: mode }) };
}

var LegacyReset = __WEBPACK_IMPORTED_MODULE_9_styled_components__["default"].div(_templateObject, __WEBPACK_IMPORTED_MODULE_10__colors__["background"], __WEBPACK_IMPORTED_MODULE_10__colors__["text"], __WEBPACK_IMPORTED_MODULE_10__colors__["link"], __WEBPACK_IMPORTED_MODULE_10__colors__["linkHover"], __WEBPACK_IMPORTED_MODULE_10__colors__["linkActive"], __WEBPACK_IMPORTED_MODULE_10__colors__["linkOutline"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["subtleHeading"], __WEBPACK_IMPORTED_MODULE_10__colors__["subtleText"]);

var AtlaskitThemeProvider = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(AtlaskitThemeProvider, _Component);

  function AtlaskitThemeProvider(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AtlaskitThemeProvider);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AtlaskitThemeProvider.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(AtlaskitThemeProvider)).call(this, props));

    _this.state = buildThemeState(props.mode);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(AtlaskitThemeProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return { hasAtlaskitThemeProvider: true };
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (!this.context.hasAtlaskitThemeProvider) {
        var css = getStylesheetResetCSS(this.state);
        this.stylesheet = document.createElement('style');
        this.stylesheet.type = 'text/css';
        this.stylesheet.innerHTML = css;
        if (document && document.head) {
          document.head.appendChild(this.stylesheet);
        }
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (newProps.mode !== this.props.mode) {
        var newThemeState = buildThemeState(newProps.mode);
        if (this.stylesheet) {
          var css = getStylesheetResetCSS(newThemeState);
          this.stylesheet.innerHTML = css;
        }
        this.setState(newThemeState);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.stylesheet && document && document.head) {
        document.head.removeChild(this.stylesheet);
        delete this.stylesheet;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;

      var theme = this.state.theme;
      return (
        /* Wrapping the new provider around the old one provides forward
        compatibility when using the old provider for styled components. This
        allows us to use components converted to use the new API with consumers
        using the old provider along side components that may still be using the
        old theming API. */
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12__Context__["b" /* Provider */],
          { value: { mode: theme[__WEBPACK_IMPORTED_MODULE_11__constants__["a" /* CHANNEL */]].mode } },
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_styled_components__["ThemeProvider"],
            { theme: theme },
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
              LegacyReset,
              null,
              children
            )
          )
        )
      );
    }
  }]);

  return AtlaskitThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

AtlaskitThemeProvider.defaultProps = {
  mode: __WEBPACK_IMPORTED_MODULE_11__constants__["b" /* DEFAULT_THEME_MODE */]
};
AtlaskitThemeProvider.childContextTypes = {
  hasAtlaskitThemeProvider: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
};
AtlaskitThemeProvider.contextTypes = {
  hasAtlaskitThemeProvider: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
};
/* harmony default export */ __webpack_exports__["a"] = (AtlaskitThemeProvider);

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);





/* unused harmony default export */ var _unused_webpack_default_export = (function (_ref) {
  var children = _ref.children,
      props = _ref.props,
      theme = _ref.theme;

  var appearance = (typeof props === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(props)) === 'object' ? 'default' : props;
  var merged = (typeof props === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(props)) === 'object' ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, props) : {};
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(theme).forEach(function (key) {
    if (!(key in merged)) {
      merged[key] = theme[key]({ appearance: appearance });
    }
  });
  return children(merged);
});

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__colors__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Context__ = __webpack_require__(101);








var _templateObject = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ';\n'], ['\n  ', ';\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    background-color: ', ';\n    color: ', ';\n\n    a {\n      color: ', ';\n    }\n    a:hover {\n      color: ', ';\n    }\n    a:active {\n      color: ', ';\n    }\n    a:focus {\n      outline-color: ', ';\n    }\n    h1,\n    h2,\n    h3,\n    h4,\n    h5 {\n      color: ', ';\n    }\n    h6 {\n      color: ', ';\n    }\n    small {\n      color: ', ';\n    }\n  '], ['\n    background-color: ', ';\n    color: ', ';\n\n    a {\n      color: ', ';\n    }\n    a:hover {\n      color: ', ';\n    }\n    a:active {\n      color: ', ';\n    }\n    a:focus {\n      outline-color: ', ';\n    }\n    h1,\n    h2,\n    h3,\n    h4,\n    h5 {\n      color: ', ';\n    }\n    h6 {\n      color: ', ';\n    }\n    small {\n      color: ', ';\n    }\n  ']);






var orTextColor = function orTextColor(preferred) {
  return function (p) {
    return p[preferred] || p.textColor;
  };
};
var Div = __WEBPACK_IMPORTED_MODULE_8_styled_components__["default"].div(_templateObject, function (p) {
  return Object(__WEBPACK_IMPORTED_MODULE_8_styled_components__["css"])(_templateObject2, p.backgroundColor, p.textColor, orTextColor('linkColor'), orTextColor('linkColorHover'), orTextColor('linkColorActive'), orTextColor('linkColorOutline'), orTextColor('headingColor'), orTextColor('subtleHeadingColor'), orTextColor('subtleTextColor'));
});

var defaultTheme = {
  backgroundColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N0"],
  linkColor: __WEBPACK_IMPORTED_MODULE_9__colors__["B400"],
  linkColorHover: __WEBPACK_IMPORTED_MODULE_9__colors__["B300"],
  linkColorActive: __WEBPACK_IMPORTED_MODULE_9__colors__["B500"],
  linkColorOutline: __WEBPACK_IMPORTED_MODULE_9__colors__["B100"],
  headingColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N800"],
  subtleHeadingColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N200"],
  subtleTextColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N200"],
  textColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N900"]
};

var Reset = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Reset, _Component);

  function Reset() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Reset);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Reset.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Reset)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Reset, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10__Context__["a" /* Consumer */],
        null,
        function (theme) {
          return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            Div,
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, defaultTheme, theme, _this2.props),
            _this2.props.children
          );
        }
      );
    }
  }]);

  return Reset;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

/* unused harmony default export */ var _unused_webpack_default_export = (Reset);

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Context__ = __webpack_require__(101);








var Theme = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Theme, _Component);

  function Theme() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Theme);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Theme.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Theme)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Theme, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          values = _props.values;

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__components_Context__["a" /* Consumer */],
        null,
        function (theme) {
          var merged = values(theme);
          return typeof children === 'function' ? children(merged) : __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__components_Context__["b" /* Provider */],
            { value: merged },
            children
          );
        }
      );
    }
  }]);

  return Theme;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Theme.defaultProps = {
  values: function values(v) {
    return v;
  }
};
/* unused harmony default export */ var _unused_webpack_default_export = (Theme);

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


// There are cases where the context is not available, such as when a dropdown item is used
// inside @atlaskit/navigation. For this reason we have this helper function which safely calls
// the context functions if they are available.
/* harmony default export */ __webpack_exports__["a"] = (function (instance, contextKey) {
  return function (fnToCall) {
    var _instance$context$con;

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (!instance.context[contextKey]) {
      return null;
    }

    return (_instance$context$con = instance.context[contextKey])[fnToCall].apply(_instance$context$con, args);
  };
});

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_icon_glyph_checkbox__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__atlaskit_icon_glyph_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__atlaskit_icon_glyph_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_item__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hoc_withToggleInteraction__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_supportsVoiceover__ = __webpack_require__(300);





/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2__hoc_withToggleInteraction__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__atlaskit_item__["e" /* withItemFocus */])(__WEBPACK_IMPORTED_MODULE_1__atlaskit_item__["b" /* default */]), __WEBPACK_IMPORTED_MODULE_0__atlaskit_icon_glyph_checkbox___default.a, function () {
  return Object(__WEBPACK_IMPORTED_MODULE_3__util_supportsVoiceover__["a" /* default */])() ? 'checkbox' : 'menuitemcheckbox';
}));

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DropdownItemGroup__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hoc_withItemSelectionManager__ = __webpack_require__(301);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__hoc_withItemSelectionManager__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__DropdownItemGroup__["a" /* default */], 'radio'));

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_contextNamespace__ = __webpack_require__(69);











var DropdownItemSelectionManager = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(DropdownItemSelectionManager, _Component);

  function DropdownItemSelectionManager() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, DropdownItemSelectionManager);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = DropdownItemSelectionManager.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(DropdownItemSelectionManager)).call.apply(_ref, [this].concat(args))), _this), _this.setItemSelected = function (itemId, isSelected, defaultSelected) {
      var _this$props = _this.props,
          behavior = _this$props.behavior,
          groupId = _this$props.groupId;


      var setSelected = function setSelected(finalBool) {
        if (behavior === 'checkbox' || behavior === 'menuitemcheckbox') {
          _this.setCheckboxItemSelected(itemId, finalBool);
        } else if (behavior === 'radio' || behavior === 'menuitemradio') {
          _this.setRadioItemSelected(itemId, finalBool);
        }
      };

      // If a radio or checkbox item has defaultSelected set on it, that it will try to set its
      // selected state to true each time it mounts (which happens whenever the dropdown is re-
      // opened by the user. The following check makes sure that the defaultSelected behaviour
      // only applies on the first mount of the radio/checkbox.

      if (typeof isSelected === 'boolean') {
        // If isSelected is explicitly provided, set it to that
        setSelected(isSelected);
      } else if (defaultSelected) {
        if (!_this.hasAlreadyAppliedDefaultSelected(itemId)) {
          // If using defaultSelected and this is first mount, select the item
          setSelected(true);
          _this.context[__WEBPACK_IMPORTED_MODULE_9__util_contextNamespace__["c" /* selectionCacheContext */]].markItemAsDefaultApplied(groupId, itemId);
        } else {
          // If using defaultSelected and not first mount, set isSelected to cached value
          setSelected(_this.isItemSelectedInCache(itemId));
        }
      } else {
        setSelected(_this.isItemSelectedInCache(itemId));
      }
    }, _this.setCheckboxItemSelected = function (itemId, isSelected) {
      var cache = _this.context[__WEBPACK_IMPORTED_MODULE_9__util_contextNamespace__["c" /* selectionCacheContext */]];

      var alreadySelected = cache.itemsInGroup(_this.props.groupId);
      var isAlreadySelected = cache.isItemSelected(_this.props.groupId, itemId);
      if (isSelected && !isAlreadySelected) {
        _this.updateCacheContextWithSelections([].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(alreadySelected), [{ id: itemId, groupId: _this.props.groupId }]));
      } else if (!isSelected && isAlreadySelected) {
        var withoutCurrentItem = alreadySelected.filter(function (item) {
          return item.id !== itemId;
        });
        _this.updateCacheContextWithSelections(withoutCurrentItem);
      }
    }, _this.setRadioItemSelected = function (itemId, isSelected) {
      var cache = _this.context[__WEBPACK_IMPORTED_MODULE_9__util_contextNamespace__["c" /* selectionCacheContext */]];

      var isAlreadySelected = cache.isItemSelected(_this.props.groupId, itemId);
      if (isAlreadySelected && !isSelected) {
        _this.updateCacheContextWithSelections([]);
      } else if (!isAlreadySelected && isSelected) {
        _this.updateCacheContextWithSelections([{ id: itemId, groupId: _this.props.groupId }]);
      }
    }, _this.isItemSelectedInCache = function (itemId) {
      return _this.context[__WEBPACK_IMPORTED_MODULE_9__util_contextNamespace__["c" /* selectionCacheContext */]].isItemSelected(_this.props.groupId, itemId);
    }, _this.handleItemClicked = function (clickedItemId) {
      var behavior = _this.props.behavior;


      if (behavior === 'checkbox' || behavior === 'menuitemcheckbox') {
        _this.handleCheckboxItemClicked(clickedItemId);
      } else if (behavior === 'radio' || behavior === 'menuitemradio') {
        _this.handleRadioItemClicked(clickedItemId);
      }
    }, _this.hasAlreadyAppliedDefaultSelected = function (itemId) {
      return _this.context[__WEBPACK_IMPORTED_MODULE_9__util_contextNamespace__["c" /* selectionCacheContext */]].hasItemAlreadyHadDefaultSelectedApplied(_this.props.groupId, itemId);
    }, _this.handleCheckboxItemClicked = function (clickedItemId) {
      var cache = _this.context[__WEBPACK_IMPORTED_MODULE_9__util_contextNamespace__["c" /* selectionCacheContext */]];

      var itemsInGroup = cache.itemsInGroup(_this.props.groupId);

      var newSelections = cache.isItemSelected(_this.props.groupId, clickedItemId) ? itemsInGroup.filter(function (item) {
        return item.id !== clickedItemId;
      }) : [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(itemsInGroup), [{ id: clickedItemId, groupId: _this.props.groupId }]);

      _this.updateCacheContextWithSelections(newSelections);
    }, _this.handleRadioItemClicked = function (clickedItemId) {
      _this.updateCacheContextWithSelections([{ id: clickedItemId, groupId: _this.props.groupId }]);
    }, _this.updateCacheContextWithSelections = function (itemSelections) {
      _this.context[__WEBPACK_IMPORTED_MODULE_9__util_contextNamespace__["c" /* selectionCacheContext */]].itemSelectionsChanged(_this.props.groupId, itemSelections);
    }, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(DropdownItemSelectionManager, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_9__util_contextNamespace__["d" /* selectionManagerContext */], {
        isItemSelected: function isItemSelected(itemId) {
          return _this2.context[__WEBPACK_IMPORTED_MODULE_9__util_contextNamespace__["c" /* selectionCacheContext */]].isItemSelected(_this2.props.groupId, itemId);
        },
        itemClicked: this.handleItemClicked,
        setItemSelected: this.setItemSelected
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        null,
        this.props.children
      );
    }
  }]);

  return DropdownItemSelectionManager;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

DropdownItemSelectionManager.childContextTypes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_9__util_contextNamespace__["d" /* selectionManagerContext */], __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object);
DropdownItemSelectionManager.contextTypes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_9__util_contextNamespace__["c" /* selectionCacheContext */], __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object.isRequired);
/* harmony default export */ __webpack_exports__["a"] = (DropdownItemSelectionManager);

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DropdownItemGroup__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hoc_withItemSelectionManager__ = __webpack_require__(301);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__hoc_withItemSelectionManager__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__DropdownItemGroup__["a" /* default */], 'checkbox'));

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_transition_group__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styled_NestedNavigationPage__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styled_NestedNavigationWrapper__ = __webpack_require__(698);











var ContainerNavigationNested = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ContainerNavigationNested, _PureComponent);

  function ContainerNavigationNested() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ContainerNavigationNested);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = ContainerNavigationNested.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ContainerNavigationNested)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      stack: _this.props.stack,
      traversalDirection: 'down'
    }, _this.handleAnimationEnd = function () {
      if (_this.props.onAnimationEnd) {
        _this.props.onAnimationEnd({
          traversalDirection: _this.state.traversalDirection
        });
      }
    }, _this.renderChildren = function () {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_transition_group__["Transition"],
        {
          addEndListener: function addEndListener(node, done) {
            node.addEventListener('animationend', done);
          },
          key: _this.state.stack.length,
          onExited: _this.handleAnimationEnd
        },
        function (transitionState) {
          return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7__styled_NestedNavigationPage__["a" /* default */],
            {
              transitionState: transitionState,
              traversalDirection: _this.state.traversalDirection
            },
            _this.state.stack[_this.state.stack.length - 1]
          );
        }
      );
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ContainerNavigationNested, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref2) {
      var _this2 = this;

      var stack = _ref2.stack;

      var traversalDirection = function () {
        if (stack.length !== _this2.props.stack.length) {
          return stack.length < _this2.props.stack.length ? 'up' : 'down';
        }
        return _this2.state.traversalDirection;
      }();

      this.setState({ traversalDirection: traversalDirection }, function () {
        _this2.setState({ stack: stack });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__styled_NestedNavigationWrapper__["a" /* default */],
        {
          component: 'div',
          traversalDirection: this.state.traversalDirection
        },
        this.renderChildren()
      );
    }
  }]);

  return ContainerNavigationNested;
}(__WEBPACK_IMPORTED_MODULE_5_react__["PureComponent"]);

/* unused harmony default export */ var _unused_webpack_default_export = (ContainerNavigationNested);

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getAnimation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_variables__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styled_ScrollHintScrollContainer__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__theme_util__ = __webpack_require__(11);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n      from { transform: translateX(', '%); }\n      to { transform: translateX(0); }\n    '], ['\n      from { transform: translateX(', '%); }\n      to { transform: translateX(0); }\n    ']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' flex-shrink: 0;\n  /* we want each page to have internal scrolling */\n  overflow-y: auto;\n  /* The parent container nav scroll container already sets padding left/right.\n   * Set extra padding right to account for the negative margin-right that is set\n   * on NestedNavigationWrapper to pull the scrollbar over to the edge of the nav\n   */\n  padding-left: 0;\n  padding-right: ', 'px;\n\n  ', ';\n'], ['\n  ', ' flex-shrink: 0;\n  /* we want each page to have internal scrolling */\n  overflow-y: auto;\n  /* The parent container nav scroll container already sets padding left/right.\n   * Set extra padding right to account for the negative margin-right that is set\n   * on NestedNavigationWrapper to pull the scrollbar over to the edge of the nav\n   */\n  padding-left: 0;\n  padding-right: ', 'px;\n\n  ', ';\n']),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    padding-right: ', 'px;\n  '], ['\n    padding-right: ', 'px;\n  ']);






var animationTime = __WEBPACK_IMPORTED_MODULE_2__shared_variables__["b" /* animationTimeUnitless */] / 1000;

var getAnimation = function getAnimation(_ref) {
  var transitionState = _ref.transitionState,
      traversalDirection = _ref.traversalDirection;
  return transitionState === 'entering' || transitionState === 'exiting' ? 'animation: ' + animationTime + 's ' + Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["keyframes"])(_templateObject, traversalDirection === 'down' ? 100 : -100) + ';' : null;
};

// Use the same scrollbar styling as the main container navigation
var NestedNavigationPage = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"])(__WEBPACK_IMPORTED_MODULE_3__styled_ScrollHintScrollContainer__["a" /* default */])(_templateObject2, getAnimation, __WEBPACK_IMPORTED_MODULE_2__shared_variables__["v" /* scrollHintSpacing */], Object(__WEBPACK_IMPORTED_MODULE_4__theme_util__["m" /* whenCollapsed */])(_templateObject3, __WEBPACK_IMPORTED_MODULE_2__shared_variables__["n" /* gridSize */]));

NestedNavigationPage.displayName = 'NestedNavigationPage';

/* harmony default export */ __webpack_exports__["a"] = (NestedNavigationPage);

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_transition_group_TransitionGroup__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_transition_group_TransitionGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_transition_group_TransitionGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_variables__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__theme_util__ = __webpack_require__(11);



var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  flex-direction: ', ';\n  /* take up the full height - desirable when using drag-and-drop in nested nav */\n  flex-grow: 1;\n  flex-wrap: nowrap;\n  /* Set height so NestedNavigationPages height 100% matches this height */\n  height: 100%;\n  /* pull scrollbar to the edge of the container nav */\n  margin-right: -', 'px;\n  max-height: 100%;\n  /* make sure the wrapper doesn\'t scroll - each page should be an independent scroll container */\n  overflow: hidden;\n\n  ', ';\n'], ['\n  display: flex;\n  flex-direction: ', ';\n  /* take up the full height - desirable when using drag-and-drop in nested nav */\n  flex-grow: 1;\n  flex-wrap: nowrap;\n  /* Set height so NestedNavigationPages height 100% matches this height */\n  height: 100%;\n  /* pull scrollbar to the edge of the container nav */\n  margin-right: -', 'px;\n  max-height: 100%;\n  /* make sure the wrapper doesn\'t scroll - each page should be an independent scroll container */\n  overflow: hidden;\n\n  ', ';\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    margin-right: -', 'px;\n  '], ['\n    margin-right: -', 'px;\n  ']);







var NestedNavigation = function NestedNavigation(_ref) {
  var traversalDirection = _ref.traversalDirection,
      children = _ref.children,
      props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['traversalDirection', 'children']);

  return (
    // Don't pass the traversalDirection prop to the TransitionGroup
    // eslint-disable-next-line no-unused-vars
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_react_transition_group_TransitionGroup___default.a,
      props,
      children
    )
  );
};

var NestedNavigationWrapper = Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["default"])(NestedNavigation)(_templateObject, function (_ref2) {
  var traversalDirection = _ref2.traversalDirection;
  return traversalDirection === 'up' ? 'row' : 'row-reverse';
}, __WEBPACK_IMPORTED_MODULE_5__shared_variables__["v" /* scrollHintSpacing */], Object(__WEBPACK_IMPORTED_MODULE_6__theme_util__["m" /* whenCollapsed */])(_templateObject2, __WEBPACK_IMPORTED_MODULE_5__shared_variables__["n" /* gridSize */]));

NestedNavigationWrapper.displayName = 'NestedNavigationWrapper';

/* harmony default export */ __webpack_exports__["a"] = (NestedNavigationWrapper);

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__OverflowHeightReportEnabler__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__OverflowDropdown__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__HeightDetector__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_variables__ = __webpack_require__(102);















var OverflowManager = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(OverflowManager, _Component);

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(OverflowManager, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_12__shared_variables__["d" /* overflowManagerNamespace */], {
        reportGroupHeightToManager: this.handleItemGroupHeightReport,
        isGroupVisibleInNav: this.isGroupVisibleInNav,
        isGroupItemVisibleInNav: this.isGroupItemVisibleInNav,
        isGroupVisibleInDropdown: this.isGroupVisibleInDropdown,
        isGroupItemVisibleInDropdown: this.isGroupItemVisibleInDropdown
      });
    }
  }]);

  function OverflowManager(props) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, OverflowManager);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (OverflowManager.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(OverflowManager)).call(this, props));

    _this.state = {
      // eslint-disable-line react/sort-comp
      breakAt: { group: 999, item: 999 }
    };
    _this.availableHeight = 0;
    _this.groupHeights = [];

    _this.isGroupVisibleInNav = function (groupIndex) {
      return groupIndex < _this.state.breakAt.group || groupIndex === _this.state.breakAt.group && _this.state.breakAt.item !== 0;
    };

    _this.isGroupItemVisibleInNav = function (groupIndex, itemIndex) {
      return groupIndex < _this.state.breakAt.group || groupIndex === _this.state.breakAt.group && itemIndex < _this.state.breakAt.item;
    };

    _this.isGroupVisibleInDropdown = function (groupIndex) {
      return groupIndex >= _this.state.breakAt.group;
    };

    _this.isGroupItemVisibleInDropdown = function (groupIndex, itemIndex) {
      return groupIndex > _this.state.breakAt.group || groupIndex === _this.state.breakAt.group && itemIndex >= _this.state.breakAt.item;
    };

    _this.calculateBreakItem = function () {
      if (!_this.hasAllGroupHeights()) {
        return;
      }

      var newBreak = { group: 999, item: 999 };
      var availableHeight = _this.availableHeight,
          groupHeights = _this.groupHeights;

      var cumulativeHeight = __WEBPACK_IMPORTED_MODULE_12__shared_variables__["a" /* dropdownHeight */] + __WEBPACK_IMPORTED_MODULE_12__shared_variables__["e" /* reservedGapHeight */];
      // eslint-disable-line no-restricted-syntax,no-labels

      groupLoop: for (var g = 0; g < _this.props.groupCount; g++) {
        var _group = groupHeights[g];

        cumulativeHeight += _group.nonItemHeight;
        if (cumulativeHeight >= availableHeight) {
          newBreak.group = g;
          newBreak.item = 0;
          break;
        }
        var itemCount = _group.itemHeights.length;
        for (var i = 0; i < itemCount; i++) {
          cumulativeHeight += _group.itemHeights[i];
          if (cumulativeHeight >= availableHeight) {
            newBreak.group = g;
            newBreak.item = i;
            break groupLoop; // eslint-disable-line no-restricted-syntax,no-labels
          }
        }
      }
      if (_this.state.breakAt.group !== newBreak.group || _this.state.breakAt.item !== newBreak.item) {
        _this.setState({ breakAt: newBreak });
      }
    };

    _this.hasAllGroupHeights = function () {
      return Object(__WEBPACK_IMPORTED_MODULE_12__shared_variables__["b" /* isArrayFilled */])(_this.groupHeights);
    };

    _this.handleItemGroupHeightReport = function (_ref2) {
      var groupIndex = _ref2.groupIndex,
          groupHeightInfo = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_ref2, ['groupIndex']);

      _this.groupHeights[groupIndex] = groupHeightInfo;
      _this.calculateBreakItem();
    };

    _this.handleAvailableHeightChange = function (availableHeight) {
      if (availableHeight === _this.availableHeight) {
        return;
      }
      _this.availableHeight = availableHeight;
      _this.calculateBreakItem();
    };

    _this.groupHeights = new Array(_this.props.groupCount);
    return _this;
  }

  //  works out the first group+item that CANNOT fit in the nav


  /* eslint-disable react/no-unused-prop-types */

  /* eslint-enable react/no-unused-prop-types */

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(OverflowManager, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        { style: { position: 'relative', height: '100%' } },
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11__HeightDetector__["a" /* default */],
          { onHeightChange: this.handleAvailableHeightChange },
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__OverflowHeightReportEnabler__["a" /* default */],
            null,
            this.props.children
          ),
          this.state.breakAt.group <= this.props.groupCount ? __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10__OverflowDropdown__["a" /* default */],
            null,
            this.props.children
          ) : null
        )
      );
    }
  }]);

  return OverflowManager;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

OverflowManager.childContextTypes = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_12__shared_variables__["d" /* overflowManagerNamespace */], __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object);
/* unused harmony default export */ var _unused_webpack_default_export = (OverflowManager);

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_variables__ = __webpack_require__(102);











var OverflowHeightReportEnabler = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(OverflowHeightReportEnabler, _Component);

  function OverflowHeightReportEnabler() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, OverflowHeightReportEnabler);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (OverflowHeightReportEnabler.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(OverflowHeightReportEnabler)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(OverflowHeightReportEnabler, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_8__shared_variables__["f" /* shouldReportItemHeight */], true);
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        null,
        this.props.children
      );
    }
  }]);

  return OverflowHeightReportEnabler;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

OverflowHeightReportEnabler.childContextTypes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_8__shared_variables__["f" /* shouldReportItemHeight */], __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool);
/* harmony default export */ __webpack_exports__["a"] = (OverflowHeightReportEnabler);

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__atlaskit_dropdown_menu__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__atlaskit_item__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__atlaskit_icon_glyph_more_vertical__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__atlaskit_icon_glyph_more_vertical___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__atlaskit_icon_glyph_more_vertical__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__atlaskit_tooltip__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styled_OverflowDropdownButtonWrapper__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__theme_util__ = __webpack_require__(11);
















var theme = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_13__theme_util__["h" /* isDropdownOverflowKey */], true);

var OverflowDropdown = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(OverflowDropdown, _Component);

  function OverflowDropdown(props, context) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, OverflowDropdown);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (OverflowDropdown.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(OverflowDropdown)).call(this, props, context));

    _this.handleDropdownToggle = function (_ref) {
      var isOpen = _ref.isOpen;

      _this.setState({ isOpen: isOpen });
    };

    _this.state = { isOpen: false };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(OverflowDropdown, [{
    key: 'render',
    value: function render() {
      // The OverflowDropdownButtonWrapper is used to control the width of the button, because
      // setting DropdownMenu.shouldFitContainer causes the dropdown layer to receive the same
      // constrained width as the button, which is way too small. This can be fixed in the
      // @atlaskit/dropdown-menu component then OverflowDropdownButtonWrapper can be removed.
      var dropdownTrigger = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_12__styled_OverflowDropdownButtonWrapper__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__atlaskit_item__["b" /* default */],
          { 'aria-haspopup': 'true', 'aria-expanded': this.state.isOpen },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__atlaskit_icon_glyph_more_vertical___default.a, { size: 'small', label: 'More items' })
        )
      );

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_styled_components__["ThemeProvider"],
        { theme: theme },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__atlaskit_dropdown_menu__["a" /* default */],
          {
            onOpenChange: this.handleDropdownToggle,
            shouldFlip: false,
            trigger: this.state.isOpen ? dropdownTrigger : __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11__atlaskit_tooltip__["a" /* default */],
              { content: 'Show more', position: 'right' },
              dropdownTrigger
            ),
            position: 'right bottom'
          },
          this.props.children
        )
      );
    }
  }]);

  return OverflowDropdown;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (OverflowDropdown);

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(15);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MoreVerticalIcon = function MoreVerticalIcon(props) {
  return _react2.default.createElement(_index2.default, _extends({ dangerouslySetGlyph: '<svg width="24" height="24" viewBox="0 0 24 24" focusable="false" role="presentation"><g fill="currentColor" fill-rule="evenodd"><circle cx="12" cy="19" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="12" cy="5" r="2"/></g></svg>' }, props));
};
exports.default = MoreVerticalIcon;

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_variables__ = __webpack_require__(10);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: ', 'px;\n  text-align: center;\n'], ['\n  width: ', 'px;\n  text-align: center;\n']);




var OverflowDropdownButtonWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, __WEBPACK_IMPORTED_MODULE_2__shared_variables__["n" /* gridSize */] * 6);

OverflowDropdownButtonWrapper.displayName = 'OverflowDropdownButtonWrapper';

/* harmony default export */ __webpack_exports__["a"] = (OverflowDropdownButtonWrapper);

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_size_detector__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_raf_schd__ = __webpack_require__(61);









var HeightDetector = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(HeightDetector, _Component);

  function HeightDetector() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, HeightDetector);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = HeightDetector.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(HeightDetector)).call.apply(_ref, [this].concat(args))), _this), _this.notifyHeight = Object(__WEBPACK_IMPORTED_MODULE_7_raf_schd__["a" /* default */])(function (height) {
      _this.props.onHeightChange(height);
    }), _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(HeightDetector, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__atlaskit_size_detector__["a" /* default */],
        null,
        function (size) {
          _this2.notifyHeight(size.height);
          return _this2.props.children;
        }
      );
    }
  }]);

  return HeightDetector;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (HeightDetector);

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SizeDetector__ = __webpack_require__(706);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__SizeDetector__["a"]; });


/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_raf_schd__ = __webpack_require__(61);









// Need to make outer div full height in case consumer wants to align
// child content vertically center. These styles can be overridden by the
// product using the optional SizeDetector.containerStyle prop.
var containerDivStyle = {
  height: '100%',
  flex: '1 0 auto',
  position: 'relative'
};

// Not using styled-components here for performance
// and framework-agnostic reasons.
var objectStyle = {
  display: 'block',
  position: 'absolute',
  top: 0,
  left: 0,
  height: '100%',
  width: '100%',
  opacity: 0,
  overflow: 'hidden',
  pointerEvents: 'none',
  zIndex: -1
};

var SizeDetector = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(SizeDetector, _Component);

  function SizeDetector(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, SizeDetector);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SizeDetector.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(SizeDetector)).call(this, props));

    _this.handleResize = Object(__WEBPACK_IMPORTED_MODULE_7_raf_schd__["a" /* default */])(function () {
      var container = _this.container;

      if (!container) {
        return;
      }

      var sizeMetrics = {
        width: container.offsetWidth,
        height: container.offsetHeight
      };

      _this.setState({
        sizeMetrics: sizeMetrics
      });

      if (_this.props.onResize) {
        _this.props.onResize(sizeMetrics);
      }
    });

    _this.handleContainerRef = function (ref) {
      if (!ref) {
        return;
      }
      _this.container = ref;
      _this.handleResize();
    };

    _this.handleObjectRef = function (ref) {
      if (!ref) {
        return;
      }
      _this.resizeObject = ref;
    };

    _this.handleObjectLoad = function () {
      if (!_this.resizeObject) {
        return;
      }

      // $FlowFixMe - resizeObject is typed as HTMLElement which has no contentDocument prop
      _this.resizeObjectDocument = _this.resizeObject.contentDocument.defaultView;
      _this.resizeObjectDocument.addEventListener('resize', _this.handleResize);
    };

    _this.renderChildren = function () {
      var sizeMetrics = _this.state.sizeMetrics;

      if (!sizeMetrics) {
        return null;
      }
      return _this.props.children(sizeMetrics);
    };

    _this.state = {};
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(SizeDetector, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.resizeObject) {
        // $FlowFixMe - resizeObject is HTMLElement which doesn't contain .data prop
        this.resizeObject.data = 'about:blank';
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.handleResize.cancel();

      if (this.resizeObjectDocument) {
        this.resizeObjectDocument.removeEventListener('resize', this.handleResize);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        {
          style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, containerDivStyle, this.props.containerStyle),
          ref: this.handleContainerRef
        },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('object', {
          type: 'text/html',
          style: objectStyle,
          ref: this.handleObjectRef,
          onLoad: this.handleObjectLoad,
          'aria-hidden': true,
          tabIndex: -1
        }),
        this.renderChildren()
      );
    }
  }]);

  return SizeDetector;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

SizeDetector.defaultProps = {
  // eslint-disable-line react/sort-comp
  containerStyle: {}
};
/* harmony default export */ __webpack_exports__["a"] = (SizeDetector);

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_variables__ = __webpack_require__(102);







var _OverflowItem$context;






var OverflowItem = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(OverflowItem, _Component);

  function OverflowItem() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, OverflowItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = OverflowItem.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(OverflowItem)).call.apply(_ref, [this].concat(args))), _this), _this.measureHeight = function (ref) {
      if (ref) {
        _this.context[__WEBPACK_IMPORTED_MODULE_8__shared_variables__["c" /* overflowGroupNamespace */]].reportItemHeightToGroup(_this.props.overflowItemIndex, ref.clientHeight);
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(OverflowItem, [{
    key: 'render',
    value: function render() {
      if (!this.context[__WEBPACK_IMPORTED_MODULE_8__shared_variables__["c" /* overflowGroupNamespace */]].shouldRenderItem(this.props.overflowItemIndex)) {
        return null;
      }

      if (this.context[__WEBPACK_IMPORTED_MODULE_8__shared_variables__["f" /* shouldReportItemHeight */]]) {
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'div',
          { ref: this.measureHeight },
          this.props.children
        );
      }

      return this.props.children;
    }
  }]);

  return OverflowItem;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

OverflowItem.contextTypes = (_OverflowItem$context = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_OverflowItem$context, __WEBPACK_IMPORTED_MODULE_8__shared_variables__["c" /* overflowGroupNamespace */], __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_OverflowItem$context, __WEBPACK_IMPORTED_MODULE_8__shared_variables__["f" /* shouldReportItemHeight */], __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool), _OverflowItem$context);
/* unused harmony default export */ var _unused_webpack_default_export = (OverflowItem);

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_variables__ = __webpack_require__(102);







var _OverflowItemGroup$co;






var OverflowItemGroup = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(OverflowItemGroup, _Component);

  function OverflowItemGroup(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, OverflowItemGroup);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (OverflowItemGroup.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(OverflowItemGroup)).call(this, props));

    _this.isInNavigation = function () {
      return !!_this.context[__WEBPACK_IMPORTED_MODULE_8__shared_variables__["f" /* shouldReportItemHeight */]];
    };

    _this.shouldRender = function () {
      var overflowGroupIndex = _this.props.overflowGroupIndex;

      if (_this.isInNavigation()) {
        return _this.context[__WEBPACK_IMPORTED_MODULE_8__shared_variables__["d" /* overflowManagerNamespace */]].isGroupVisibleInNav(overflowGroupIndex);
      }
      return _this.context[__WEBPACK_IMPORTED_MODULE_8__shared_variables__["d" /* overflowManagerNamespace */]].isGroupVisibleInDropdown(overflowGroupIndex);
    };

    _this.shouldRenderItem = function (overflowItemIndex) {
      if (_this.isInNavigation()) {
        return _this.context[__WEBPACK_IMPORTED_MODULE_8__shared_variables__["d" /* overflowManagerNamespace */]].isGroupItemVisibleInNav(_this.props.overflowGroupIndex, overflowItemIndex);
      }
      return _this.context[__WEBPACK_IMPORTED_MODULE_8__shared_variables__["d" /* overflowManagerNamespace */]].isGroupItemVisibleInDropdown(_this.props.overflowGroupIndex, overflowItemIndex);
    };

    _this.hasAllItemHeights = function () {
      return Object(__WEBPACK_IMPORTED_MODULE_8__shared_variables__["b" /* isArrayFilled */])(_this.heights);
    };

    _this.combinedItemHeights = function () {
      return _this.heights.reduce(function (sum, value, i) {
        return sum + (_this.shouldRenderItem(i) ? value : 0);
      }, 0);
    };

    _this.nonItemHeight = function () {
      return _this.groupHeight() - _this.combinedItemHeights();
    };

    _this.groupHeight = function () {
      return _this.rootNode ? _this.rootNode.clientHeight : 0;
    };

    _this.reportHeightsToOverflowManager = function () {
      if (!_this.isInNavigation() || !_this.rootNode || !_this.hasAllItemHeights()) {
        return;
      }
      _this.context[__WEBPACK_IMPORTED_MODULE_8__shared_variables__["d" /* overflowManagerNamespace */]].reportGroupHeightToManager({
        groupIndex: _this.props.overflowGroupIndex,
        itemHeights: _this.heights,
        nonItemHeight: _this.nonItemHeight()
      });
    };

    _this.handleItemHeightReport = function (overflowItemIndex, height) {
      _this.heights[overflowItemIndex] = height;
      _this.reportHeightsToOverflowManager();
    };

    _this.handleRootNodeRef = function (ref) {
      _this.rootNode = ref;
      _this.reportHeightsToOverflowManager();
    };

    _this.heights = new Array(_this.props.itemCount);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(OverflowItemGroup, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_8__shared_variables__["c" /* overflowGroupNamespace */], {
        reportItemHeightToGroup: this.handleItemHeightReport,
        shouldRenderItem: this.shouldRenderItem
      });
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.shouldRender()) {
        return null;
      }

      if (this.context[__WEBPACK_IMPORTED_MODULE_8__shared_variables__["f" /* shouldReportItemHeight */]]) {
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'div',
          { ref: this.handleRootNodeRef },
          this.props.children
        );
      }

      return this.props.children;
    }
  }]);

  return OverflowItemGroup;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

OverflowItemGroup.childContextTypes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_8__shared_variables__["c" /* overflowGroupNamespace */], __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object);
OverflowItemGroup.contextTypes = (_OverflowItemGroup$co = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_OverflowItemGroup$co, __WEBPACK_IMPORTED_MODULE_8__shared_variables__["d" /* overflowManagerNamespace */], __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_OverflowItemGroup$co, __WEBPACK_IMPORTED_MODULE_8__shared_variables__["f" /* shouldReportItemHeight */], __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool), _OverflowItemGroup$co);
/* unused harmony default export */ var _unused_webpack_default_export = (OverflowItemGroup);

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Drawer__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_variables__ = __webpack_require__(10);










/*
NOTE: All drawers mirror each other in design, with the only difference
being the offset.
*/
var CreateDrawer = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(CreateDrawer, _PureComponent);

  function CreateDrawer() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, CreateDrawer);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CreateDrawer.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(CreateDrawer)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(CreateDrawer, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Drawer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        iconOffset: __WEBPACK_IMPORTED_MODULE_8__shared_variables__["i" /* drawerIconOffset */],
        width: this.props.isFullWidth ? 'full' : 'narrow'
      }, this.props));
    }
  }]);

  return CreateDrawer;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (CreateDrawer);

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AnalyticsDecorator__ = __webpack_require__(711);
/* unused harmony reexport AnalyticsDecorator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AnalyticsDelegate__ = __webpack_require__(712);
/* unused harmony reexport AnalyticsDelegate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AnalyticsListener__ = __webpack_require__(713);
/* unused harmony reexport AnalyticsListener */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cleanProps__ = __webpack_require__(714);
/* unused harmony reexport cleanProps */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__withAnalytics__ = __webpack_require__(715);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__withAnalytics__["a"]; });






/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__matchEvent__ = __webpack_require__(302);









/* eslint-disable react/sort-comp */





/* The Decorator component extends analytics event data for any events fired by
its descendents, then passes the event up the hierarchy */

var ContextTypes = {
  onAnalyticsEvent: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  getParentAnalyticsData: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func
};

var AnalyticsDecorator = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(AnalyticsDecorator, _Component);

  function AnalyticsDecorator() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, AnalyticsDecorator);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = AnalyticsDecorator.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(AnalyticsDecorator)).call.apply(_ref, [this].concat(args))), _this), _this.getDecoratedAnalyticsData = function (name, srcData, isPrivate) {
      // Decorate the event data if this decorator matches the event name
      var _this$props = _this.props,
          data = _this$props.data,
          getData = _this$props.getData,
          match = _this$props.match,
          matchPrivate = _this$props.matchPrivate;

      var decoratedData = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, srcData);
      if (matchPrivate === isPrivate && Object(__WEBPACK_IMPORTED_MODULE_10__matchEvent__["a" /* default */])(match, name)) {
        if ((typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(data)) === 'object') {
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(decoratedData, data);
        }
        if (typeof getData === 'function') {
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(decoratedData, getData(name, decoratedData));
        }
      }
      return decoratedData;
    }, _this.onAnalyticsEvent = function (name, srcData, isPrivate) {
      // Check there is a listener to pass the event to, otherwise there's no need
      // to do any of this work
      var onAnalyticsEvent = _this.context.onAnalyticsEvent;

      if (typeof onAnalyticsEvent !== 'function') return;
      var decoratedData = _this.getDecoratedAnalyticsData(name, srcData, isPrivate);
      // Pass the decorated event data to the next listener up the hierarchy
      onAnalyticsEvent(name, decoratedData, isPrivate);
    }, _this.getParentAnalyticsData = function (name, isPrivate) {
      var parentData = _this.getDecoratedAnalyticsData(name, {}, isPrivate);
      // Get any analytics data from any decorators up the hierarchy
      var getParentAnalyticsData = _this.context.getParentAnalyticsData;

      if (typeof getParentAnalyticsData === 'function') {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(parentData, getParentAnalyticsData(name, isPrivate));
      }
      return parentData;
    }, _temp), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(AnalyticsDecorator, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        onAnalyticsEvent: this.onAnalyticsEvent,
        getParentAnalyticsData: this.getParentAnalyticsData
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children; // eslint-disable-line react/prop-types

      return __WEBPACK_IMPORTED_MODULE_8_react___default.a.Children.only(children);
    }
  }]);

  return AnalyticsDecorator;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

AnalyticsDecorator.defaultProps = {
  match: '*',
  matchPrivate: false
};
AnalyticsDecorator.contextTypes = ContextTypes;
AnalyticsDecorator.childContextTypes = ContextTypes;


/* unused harmony default export */ var _unused_webpack_default_export = (AnalyticsDecorator);

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);







/* eslint-disable react/sort-comp */



/*
Listens to public and private events and delegates to an analytics
stack in a different React root.
*/

var ContextTypes = {
  onAnalyticsEvent: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};

var AnalyticsDelegate = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(AnalyticsDelegate, _Component);

  function AnalyticsDelegate() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, AnalyticsDelegate);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = AnalyticsDelegate.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(AnalyticsDelegate)).call.apply(_ref, [this].concat(args))), _this), _this.onAnalyticsEvent = function (name, data, isPrivate) {
      var delegateAnalyticsEvent = _this.props.delegateAnalyticsEvent;

      // send a clean data object so it can't be mutated between listeners

      var eventData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data);
      if (delegateAnalyticsEvent) {
        delegateAnalyticsEvent(name, eventData, isPrivate);
      }

      // Pass the event up the hierarchy
      var onAnalyticsEvent = _this.context.onAnalyticsEvent;

      if (typeof onAnalyticsEvent === 'function') {
        onAnalyticsEvent(name, data, isPrivate);
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(AnalyticsDelegate, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        onAnalyticsEvent: this.onAnalyticsEvent
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children; // eslint-disable-line react/prop-types

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.Children.only(children);
    }
  }]);

  return AnalyticsDelegate;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

AnalyticsDelegate.contextTypes = ContextTypes;
AnalyticsDelegate.childContextTypes = ContextTypes;


/* unused harmony default export */ var _unused_webpack_default_export = (AnalyticsDelegate);

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__matchEvent__ = __webpack_require__(302);







/* eslint-disable react/sort-comp */





/*
The Listener component is responsible for calling its `onEvent` handler when a
child component fires an analytics event, and passing the event up the hierarchy
*/

var ContextTypes = {
  onAnalyticsEvent: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};

var AnalyticsListener = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(AnalyticsListener, _Component);

  function AnalyticsListener() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, AnalyticsListener);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = AnalyticsListener.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(AnalyticsListener)).call.apply(_ref, [this].concat(args))), _this), _this.onAnalyticsEvent = function (name, data, isPrivate) {
      // Call this component's onEvent method if it's a match
      var _this$props = _this.props,
          onEvent = _this$props.onEvent,
          match = _this$props.match,
          matchPrivate = _this$props.matchPrivate;

      if (matchPrivate === isPrivate && Object(__WEBPACK_IMPORTED_MODULE_8__matchEvent__["a" /* default */])(match, name) && typeof onEvent === 'function') {
        // send a clean data object so it can't be mutated between listeners
        var _eventData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data);
        onEvent(name, _eventData);
      }

      // Pass the event up the hierarchy
      var onAnalyticsEvent = _this.context.onAnalyticsEvent;

      if (typeof onAnalyticsEvent === 'function') {
        onAnalyticsEvent(name, data, isPrivate);
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(AnalyticsListener, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        onAnalyticsEvent: this.onAnalyticsEvent
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children; // eslint-disable-line react/prop-types

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.Children.only(children);
    }
  }]);

  return AnalyticsListener;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

AnalyticsListener.defaultProps = {
  match: '*',
  matchPrivate: false
};
AnalyticsListener.contextTypes = ContextTypes;
AnalyticsListener.childContextTypes = ContextTypes;


/* unused harmony default export */ var _unused_webpack_default_export = (AnalyticsListener);

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);



/*
cleanProps removes props added by the withAnalytics HOC from an object
*/

function cleanProps(props) {
  /* eslint-disable no-unused-vars */
  var analyticsId = props.analyticsId,
      analyticsData = props.analyticsData,
      delegateAnalyticsEvent = props.delegateAnalyticsEvent,
      fireAnalyticsEvent = props.fireAnalyticsEvent,
      firePrivateAnalyticsEvent = props.firePrivateAnalyticsEvent,
      getParentAnalyticsData = props.getParentAnalyticsData,
      cleanedProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(props, ["analyticsId", "analyticsData", "delegateAnalyticsEvent", "fireAnalyticsEvent", "firePrivateAnalyticsEvent", "getParentAnalyticsData"]);
  /* eslint-enable no-unused-vars */


  return cleanedProps;
}

/* unused harmony default export */ var _unused_webpack_default_export = (cleanProps);

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);











/*
The withAnalytics HOC wraps a component and provides the `fireAnalyticsEvent`
and `firePrivateAnalyticsEvent` methods to it as props. It contains the logic
for how to fire events, including handling the analyticsId and analyticsData
props. The `map` argument may be an object or a function that returns an object.
The properties of the `map` object/result can be strings (the name of the event
that will be fired) or functions (which are responsible for firing the event).
You can specify a default `analyticsId` and `analyticsData` with the `defaultProps`
param. Please be aware that specifying a default `analyticsId` will cause public
events to always fire for your component unless it has been set to a falsy by
the component consumer.
*/
var withAnalytics = function withAnalytics(WrappedComponent) {
  var map = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _class, _temp2;

  var defaultProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var withDelegation = arguments[3];
  return _temp2 = _class = function (_Component) {
    __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(WithAnalytics, _Component);

    function WithAnalytics() {
      var _ref;

      var _temp, _this, _ret;

      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, WithAnalytics);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = WithAnalytics.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(WithAnalytics)).call.apply(_ref, [this].concat(args))), _this), _this.evaluatedMap = {}, _this.delegateAnalyticsEvent = function (analyticsId, data, isPrivate) {
        var onAnalyticsEvent = _this.context.onAnalyticsEvent;

        if (!onAnalyticsEvent) return;
        onAnalyticsEvent(analyticsId, data, isPrivate);
      }, _this.fireAnalyticsEvent = function (name, data) {
        var _this$props = _this.props,
            analyticsData = _this$props.analyticsData,
            analyticsId = _this$props.analyticsId;
        var onAnalyticsEvent = _this.context.onAnalyticsEvent;

        if (!analyticsId || !onAnalyticsEvent) return;
        var eventData = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, analyticsData, data);
        onAnalyticsEvent(analyticsId + '.' + name, eventData, false);
      }, _this.privateAnalyticsEvent = function (name, data) {
        var onAnalyticsEvent = _this.context.onAnalyticsEvent;

        if (!onAnalyticsEvent) return;
        onAnalyticsEvent('' + name, data, true);
      }, _this.getParentAnalyticsData = function (name) {
        var getParentAnalyticsData = _this.context.getParentAnalyticsData;

        var parentData = {};
        if (typeof getParentAnalyticsData === 'function' && _this.props.analyticsId) {
          var _analyticsId = _this.props.analyticsId;

          parentData = getParentAnalyticsData(_analyticsId + '.' + name, false);
        }
        return parentData;
      }, _temp), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(WithAnalytics, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        this.evaluatedMap = typeof map === 'function' ? map(this.fireAnalyticsEvent) : map;
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        /* eslint-disable no-unused-vars */
        var _props = this.props,
            analyticsId = _props.analyticsId,
            analyticsData = _props.analyticsData,
            componentProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['analyticsId', 'analyticsData']);
        /* eslint-enable no-unused-vars */


        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.evaluatedMap).forEach(function (prop) {
          var handler = _this2.evaluatedMap[prop]; // may be eventName or a function
          var originalProp = componentProps[prop];
          componentProps[prop] = function () {
            if (typeof handler === 'function') {
              handler.apply(undefined, arguments);
            } else {
              _this2.fireAnalyticsEvent(handler);
            }
            if (typeof originalProp === 'function') originalProp.apply(undefined, arguments);
          };
        });

        return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(WrappedComponent, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
          fireAnalyticsEvent: this.fireAnalyticsEvent,
          firePrivateAnalyticsEvent: this.privateAnalyticsEvent,
          getParentAnalyticsData: this.getParentAnalyticsData,
          delegateAnalyticsEvent: withDelegation ? this.delegateAnalyticsEvent : undefined,
          analyticsId: analyticsId,
          ref: this.props.innerRef
        }, componentProps));
      }
    }]);

    return WithAnalytics;
  }(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]), _class.displayName = 'WithAnalytics(' + (WrappedComponent.displayName || WrappedComponent.name) + ')', _class.contextTypes = {
    onAnalyticsEvent: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
    getParentAnalyticsData: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func
  }, _class.defaultProps = {
    analyticsId: defaultProps.analyticsId,
    analyticsData: defaultProps.analyticsData
  }, _temp2;
};

/* harmony default export */ __webpack_exports__["a"] = (withAnalytics);

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styled_DrawerBackIconInner__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styled_DrawerBackIconOuter__ = __webpack_require__(718);









var DrawerBackIcon = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(DrawerBackIcon, _PureComponent);

  function DrawerBackIcon() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DrawerBackIcon);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (DrawerBackIcon.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(DrawerBackIcon)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(DrawerBackIcon, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          isVisible = _props.isVisible;

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__styled_DrawerBackIconOuter__["a" /* default */],
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__styled_DrawerBackIconInner__["a" /* default */],
          { isVisible: isVisible },
          children
        )
      );
    }
  }]);

  return DrawerBackIcon;
}(__WEBPACK_IMPORTED_MODULE_5_react__["PureComponent"]);

DrawerBackIcon.defaultProps = {
  isVisible: false
};
/* harmony default export */ __webpack_exports__["a"] = (DrawerBackIcon);

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_variables__ = __webpack_require__(10);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  align-items: center;\n  display: flex;\n  transform: ', ';\n  transition: transform 220ms;\n'], ['\n  align-items: center;\n  display: flex;\n  transform: ', ';\n  transition: transform 220ms;\n']);




var DrawerBackIconInner = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, function (_ref) {
  var isVisible = _ref.isVisible;
  return isVisible ? 'translateX(0)' : 'translateX(' + -__WEBPACK_IMPORTED_MODULE_2__shared_variables__["n" /* gridSize */] * 2 + 'px)';
});

DrawerBackIconInner.displayName = 'DrawerBackIconInner';
/* harmony default export */ __webpack_exports__["a"] = (DrawerBackIconInner);

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_drawer_style_variables__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__theme_util__ = __webpack_require__(11);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  background-color: ', ';\n  border-radius: 50%;\n  color: ', ';\n  cursor: pointer;\n  display: flex;\n  height: ', 'px;\n  justify-content: center;\n  width: ', 'px;\n\n  &:active {\n    background-color: ', ';\n  }\n'], ['\n  background-color: ', ';\n  border-radius: 50%;\n  color: ', ';\n  cursor: pointer;\n  display: flex;\n  height: ', 'px;\n  justify-content: center;\n  width: ', 'px;\n\n  &:active {\n    background-color: ', ';\n  }\n']);





var DrawerBackIconOuter = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, function (_ref) {
  var theme = _ref.theme;
  return Object(__WEBPACK_IMPORTED_MODULE_3__theme_util__["e" /* getProvided */])(theme).item.default.background;
}, function (_ref2) {
  var theme = _ref2.theme;
  return Object(__WEBPACK_IMPORTED_MODULE_3__theme_util__["e" /* getProvided */])(theme).text;
}, __WEBPACK_IMPORTED_MODULE_2__utils_drawer_style_variables__["c" /* drawerBackIconSize */], __WEBPACK_IMPORTED_MODULE_2__utils_drawer_style_variables__["c" /* drawerBackIconSize */], function (_ref3) {
  var theme = _ref3.theme;
  return Object(__WEBPACK_IMPORTED_MODULE_3__theme_util__["e" /* getProvided */])(theme).item.active.background;
});

DrawerBackIconOuter.displayName = 'DrawerBackIconOuter';
/* harmony default export */ __webpack_exports__["a"] = (DrawerBackIconOuter);

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_variables__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__theme_util__ = __webpack_require__(11);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  align-items: center;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  flex: 1 0 auto;\n  padding: ', 'px 0 ', 'px 0;\n  position: relative;\n  width: ', 'px;\n'], ['\n  align-items: center;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  flex: 1 0 auto;\n  padding: ', 'px 0 ', 'px 0;\n  position: relative;\n  width: ', 'px;\n']);





var getWidth = function getWidth(_ref) {
  var theme = _ref.theme;
  return Object(__WEBPACK_IMPORTED_MODULE_3__theme_util__["i" /* isElectronMac */])(theme) ? __WEBPACK_IMPORTED_MODULE_2__shared_variables__["o" /* layout */].width.closed.electron : __WEBPACK_IMPORTED_MODULE_2__shared_variables__["o" /* layout */].width.closed.default;
};

var baseTopPadding = __WEBPACK_IMPORTED_MODULE_2__shared_variables__["o" /* layout */].padding.top + __WEBPACK_IMPORTED_MODULE_2__shared_variables__["n" /* gridSize */];
var getTopPadding = function getTopPadding(props) {
  return baseTopPadding + (Object(__WEBPACK_IMPORTED_MODULE_3__theme_util__["i" /* isElectronMac */])(props.theme) ? __WEBPACK_IMPORTED_MODULE_3__theme_util__["d" /* electronMacTopPadding */] : 0);
};

var DrawerSide = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, getTopPadding, baseTopPadding, getWidth);

DrawerSide.displayName = 'DrawerSide';
/* harmony default export */ __webpack_exports__["a"] = (DrawerSide);

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_drawer_style_variables__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__theme_util__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_variables__ = __webpack_require__(10);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  from { transform: translateX(', '); }\n  to { transform: translateX(0); }\n'], ['\n  from { transform: translateX(', '); }\n  to { transform: translateX(0); }\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  from { transform: translateX(0); }\n  to { transform: translateX(', '); }\n'], ['\n  from { transform: translateX(0); }\n  to { transform: translateX(', '); }\n']),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  background-color: ', ';\n  color: ', ';\n  display: flex;\n  height: 100%;\n  overflow: hidden;\n  position: fixed;\n  left: 0;\n  top: 0;\n  transition: ', ';\n  width: ', ';\n  z-index: ', ';\n  ', ';\n'], ['\n  background-color: ', ';\n  color: ', ';\n  display: flex;\n  height: 100%;\n  overflow: hidden;\n  position: fixed;\n  left: 0;\n  top: 0;\n  transition: ', ';\n  width: ', ';\n  z-index: ', ';\n  ', ';\n']);






var entryAnimation = function entryAnimation(offscreenX) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["keyframes"])(_templateObject, offscreenX);
};

var exitAnimation = function exitAnimation(offscreenX) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["keyframes"])(_templateObject2, offscreenX);
};

var getAnimation = function getAnimation(_ref) {
  var isOpen = _ref.isOpen,
      isAnimating = _ref.isAnimating,
      width = _ref.width;

  var offscreenX = __WEBPACK_IMPORTED_MODULE_2__utils_drawer_style_variables__["e" /* widths */][width].offScreenTranslateX;
  var animation = isOpen ? entryAnimation(offscreenX) : exitAnimation(offscreenX);
  if (isAnimating) {
    return '\n      animation: ' + animation + ' ' + __WEBPACK_IMPORTED_MODULE_2__utils_drawer_style_variables__["a" /* animationSpeed */] + ' ' + __WEBPACK_IMPORTED_MODULE_2__utils_drawer_style_variables__["b" /* animationTiming */] + ' forwards;\n    ';
  }

  return '\n    animation: none;\n    left: ' + (isOpen ? 0 : offscreenX) + ';\n  ';
};

var DrawerInner = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject3, function (_ref2) {
  var theme = _ref2.theme;
  return Object(__WEBPACK_IMPORTED_MODULE_3__theme_util__["e" /* getProvided */])(theme).background.tertiary;
}, function (_ref3) {
  var theme = _ref3.theme;
  return Object(__WEBPACK_IMPORTED_MODULE_3__theme_util__["e" /* getProvided */])(theme).text;
}, __WEBPACK_IMPORTED_MODULE_2__utils_drawer_style_variables__["d" /* widthTransition */], function (_ref4) {
  var width = _ref4.width;
  return __WEBPACK_IMPORTED_MODULE_2__utils_drawer_style_variables__["e" /* widths */][width].width;
}, __WEBPACK_IMPORTED_MODULE_4__shared_variables__["y" /* zIndex */].drawer, getAnimation);

DrawerInner.displayName = 'DrawerInner';
/* harmony default export */ __webpack_exports__["a"] = (DrawerInner);

/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_drawer_style_variables__ = __webpack_require__(172);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  align-items: center;\n  display: flex;\n  height: ', 'px;\n  justify-content: center;\n  width: ', 'px;\n  color: ', ';\n'], ['\n  align-items: center;\n  display: flex;\n  height: ', 'px;\n  justify-content: center;\n  width: ', 'px;\n  color: ', ';\n']);





var DrawerPrimaryIcon = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, __WEBPACK_IMPORTED_MODULE_3__utils_drawer_style_variables__["c" /* drawerBackIconSize */], __WEBPACK_IMPORTED_MODULE_3__utils_drawer_style_variables__["c" /* drawerBackIconSize */], Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].N500, dark: __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["a" /* colors */].DN500 }));

DrawerPrimaryIcon.displayName = 'DrawerPrimaryIcon';
/* harmony default export */ __webpack_exports__["a"] = (DrawerPrimaryIcon);

/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_variables__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__theme_util__ = __webpack_require__(11);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  padding: ', 'px 0 0;\n  overflow-y: auto;\n  width: 100%;\n'], ['\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  padding: ', 'px 0 0;\n  overflow-y: auto;\n  width: 100%;\n']);





var getTopPadding = function getTopPadding(props) {
  return __WEBPACK_IMPORTED_MODULE_2__shared_variables__["o" /* layout */].padding.top + (Object(__WEBPACK_IMPORTED_MODULE_3__theme_util__["i" /* isElectronMac */])(props.theme) ? __WEBPACK_IMPORTED_MODULE_3__theme_util__["d" /* electronMacTopPadding */] : 0);
};

var DrawerMain = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, getTopPadding);

DrawerMain.displayName = 'DrawerMain';
/* harmony default export */ __webpack_exports__["a"] = (DrawerMain);

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_variables__ = __webpack_require__(10);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  padding: 0 ', 'px;\n  width: 100%;\n  overflow-y: auto;\n'], ['\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  padding: 0 ', 'px;\n  width: 100%;\n  overflow-y: auto;\n']);




var DrawerContent = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, __WEBPACK_IMPORTED_MODULE_2__shared_variables__["o" /* layout */].padding.side);

DrawerContent.displayName = 'DrawerContent';
/* harmony default export */ __webpack_exports__["a"] = (DrawerContent);

/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__theme_util__ = __webpack_require__(11);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  /** This needs to be display flex to fix an IE11 bug with position: absolute and a display: flex parent */\n  display: flex;\n  justify-content: center;\n  left: 0;\n  position: absolute;\n  width: 100%;\n  top: ', 'px;\n'], ['\n  /** This needs to be display flex to fix an IE11 bug with position: absolute and a display: flex parent */\n  display: flex;\n  justify-content: center;\n  left: 0;\n  position: absolute;\n  width: 100%;\n  top: ', 'px;\n']);




var getTopOffset = function getTopOffset(_ref) {
  var iconOffset = _ref.iconOffset,
      theme = _ref.theme;
  return Object(__WEBPACK_IMPORTED_MODULE_2__theme_util__["i" /* isElectronMac */])(theme) ? __WEBPACK_IMPORTED_MODULE_2__theme_util__["d" /* electronMacTopPadding */] + iconOffset : iconOffset;
};

var DrawerBackIconWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, getTopOffset);

DrawerBackIconWrapper.displayName = 'DrawerBackIconWrapper';
/* harmony default export */ __webpack_exports__["a"] = (DrawerBackIconWrapper);

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Drawer__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_variables__ = __webpack_require__(10);










/*
NOTE: All drawers mirror each other in design, with the only difference
being the offset.
*/
var CustomDrawer = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(CustomDrawer, _PureComponent);

  function CustomDrawer() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, CustomDrawer);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CustomDrawer.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(CustomDrawer)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(CustomDrawer, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Drawer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ iconOffset: __WEBPACK_IMPORTED_MODULE_8__shared_variables__["i" /* drawerIconOffset */] }, this.props));
    }
  }]);

  return CustomDrawer;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

CustomDrawer.defaultProps = {
  width: 'wide'
};
/* unused harmony default export */ var _unused_webpack_default_export = (CustomDrawer);

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Drawer__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_variables__ = __webpack_require__(10);










/*
NOTE: All drawers mirror each other in design, with the only difference
being the offset.
*/
var SearchDrawer = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(SearchDrawer, _PureComponent);

  function SearchDrawer() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, SearchDrawer);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SearchDrawer.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(SearchDrawer)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(SearchDrawer, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Drawer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        iconOffset: __WEBPACK_IMPORTED_MODULE_8__shared_variables__["i" /* drawerIconOffset */],
        width: this.props.isFullWidth ? 'full' : 'wide'
      }, this.props));
    }
  }]);

  return SearchDrawer;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (SearchDrawer);

/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createGlobalTheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chromatism__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__presets__ = __webpack_require__(48);


// 'chromatism' adds 1.9kb to the bundle.
// After the nwb merge it should be able to be tree shaken out for those who are not using it




var globalTheme = __WEBPACK_IMPORTED_MODULE_1__presets__["c" /* global */];

// eslint-disable-next-line import/prefer-default-export

var createGlobalTheme = function createGlobalTheme(text, background) {
  var active = __WEBPACK_IMPORTED_MODULE_0_chromatism__["a" /* default */].brightness(10, background).hex;

  var item = {
    default: {
      background: 'transparent'
    },
    hover: {
      background: __WEBPACK_IMPORTED_MODULE_0_chromatism__["a" /* default */].brightness(-10, background).hex
    },
    active: {
      background: active
    },
    selected: {
      background: __WEBPACK_IMPORTED_MODULE_0_chromatism__["a" /* default */].brightness(-20, background).hex,
      text: text
    },
    focus: {
      outline: text
    },
    dragging: {
      background: active
    }
  };

  // Here we take the default global theme and selectively override some of the customisable values
  // with values based on the function input. We are currently not encouraging the overriding of
  // these default properties.
  var customisedGlobal = {
    background: {
      primary: background,
      secondary: background,
      tertiary: globalTheme.background.tertiary
    },
    text: text,
    subText: __WEBPACK_IMPORTED_MODULE_0_chromatism__["a" /* default */].brightness(20, text).hex,
    keyline: globalTheme.keyline,
    item: item,
    dropdown: globalTheme.dropdown
  };

  return customisedGlobal;
};

/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styled_SkeletonNavigationOuter__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styled_SkeletonNavigationInner__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SkeletonGlobalNavigation__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SkeletonContainerNavigation__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SkeletonDefaultContainerHeader__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ToggleWhenCollapsed__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__theme_util__ = __webpack_require__(11);

















var SkeletonNavigation = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(SkeletonNavigation, _Component);

  function SkeletonNavigation() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SkeletonNavigation);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SkeletonNavigation.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(SkeletonNavigation)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(SkeletonNavigation, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isCollapsed = _props.isCollapsed,
          globalTheme = _props.globalTheme,
          containerTheme = _props.containerTheme,
          containerHeaderComponent = _props.containerHeaderComponent;


      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__styled_SkeletonNavigationOuter__["a" /* default */],
        { isCollapsed: isCollapsed },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__styled_SkeletonNavigationInner__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_11__ToggleWhenCollapsed__["a" /* HiddenWhenCollapsed */],
            { isCollapsed: isCollapsed },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__SkeletonGlobalNavigation__["a" /* default */], { theme: Object(__WEBPACK_IMPORTED_MODULE_12__theme_util__["c" /* defaultGlobalTheme */])(globalTheme) })
          ),
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__SkeletonContainerNavigation__["a" /* default */], {
            theme: Object(__WEBPACK_IMPORTED_MODULE_12__theme_util__["b" /* defaultContainerTheme */])(containerTheme),
            isCollapsed: isCollapsed,
            containerHeaderComponent: containerHeaderComponent
          })
        )
      );
    }
  }]);

  return SkeletonNavigation;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

SkeletonNavigation.defaultProps = {
  isCollapsed: false,
  containerHeaderComponent: __WEBPACK_IMPORTED_MODULE_10__SkeletonDefaultContainerHeader__["a" /* default */]
};
/* unused harmony default export */ var _unused_webpack_default_export = (SkeletonNavigation);

/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_variables__ = __webpack_require__(10);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: ', 'px;\n  height: 100vh;\n'], ['\n  width: ', 'px;\n  height: 100vh;\n']);





var SkeletonNavigationOuter = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, function (_ref) {
  var isCollapsed = _ref.isCollapsed;
  return isCollapsed ? Object(__WEBPACK_IMPORTED_MODULE_2__shared_variables__["c" /* containerClosedWidth */])() : __WEBPACK_IMPORTED_MODULE_2__shared_variables__["w" /* standardOpenWidth */];
});

SkeletonNavigationOuter.displayName = 'SkeletonNavigationOuter';
/* harmony default export */ __webpack_exports__["a"] = (SkeletonNavigationOuter);

/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  height: 100%;\n  position: fixed;\n  top: 0;\n  left: 0;\n'], ['\n  display: flex;\n  height: 100%;\n  position: fixed;\n  top: 0;\n  left: 0;\n']);



var SkeletonNavigationInner = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject);

SkeletonNavigationInner.displayName = 'SkeletonNavigationInner';
/* harmony default export */ __webpack_exports__["a"] = (SkeletonNavigationInner);

/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IconWrapper */
/* unused harmony export size */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_uuid__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__atlaskit_theme__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants__ = __webpack_require__(304);










var _templateObject = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  display: inline-block;\n  fill: ', ';\n  flex-shrink: 0;\n  line-height: 1;\n\n  > svg {\n    ', ' max-height: 100%;\n    max-width: 100%;\n    overflow: hidden;\n    pointer-events: none;\n    vertical-align: bottom;\n  }\n  /* Stop-color doesn\'t properly apply in chrome when the inherited/current color changes.\n   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS\n   * rule) and then override it with currentColor for the color changes to be picked up.\n   */\n  stop {\n    stop-color: currentColor;\n  }\n'], ['\n  ', ' color: ', ';\n  display: inline-block;\n  fill: ', ';\n  flex-shrink: 0;\n  line-height: 1;\n\n  > svg {\n    ', ' max-height: 100%;\n    max-width: 100%;\n    overflow: hidden;\n    pointer-events: none;\n    vertical-align: bottom;\n  }\n  /* Stop-color doesn\'t properly apply in chrome when the inherited/current color changes.\n   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS\n   * rule) and then override it with currentColor for the color changes to be picked up.\n   */\n  stop {\n    stop-color: currentColor;\n  }\n']);







var getSize = function getSize(props) {
  if (props.size) {
    return 'height: ' + __WEBPACK_IMPORTED_MODULE_13__constants__["a" /* sizes */][props.size] + '; width: ' + __WEBPACK_IMPORTED_MODULE_13__constants__["a" /* sizes */][props.size] + ';';
  }
  return null;
};

var IconWrapper = __WEBPACK_IMPORTED_MODULE_10_styled_components__["default"].span(_templateObject, getSize, function (p) {
  return p.primaryColor || 'currentColor';
}, function (p) {
  return p.secondaryColor || __WEBPACK_IMPORTED_MODULE_12__atlaskit_theme__["colors"].background;
}, getSize);

var Icon = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(Icon, _Component);

  function Icon() {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, Icon);

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Icon.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(Icon)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(Icon, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          Glyph = _props.glyph,
          dangerouslySetGlyph = _props.dangerouslySetGlyph,
          onClick = _props.onClick,
          primaryColor = _props.primaryColor,
          secondaryColor = _props.secondaryColor,
          size = _props.size;

      // handling the glyphs as strings

      if (dangerouslySetGlyph) {
        return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(IconWrapper, {
          onClick: onClick,
          primaryColor: primaryColor,
          secondaryColor: secondaryColor,
          size: size,
          'aria-label': this.props.label,
          dangerouslySetInnerHTML: {
            __html: Icon.insertDynamicGradientID(dangerouslySetGlyph)
          }
        });
      }
      // handling the glyphs when passed through as functions
      return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        IconWrapper,
        {
          onClick: onClick,
          primaryColor: primaryColor,
          secondaryColor: secondaryColor,
          size: size,
          'aria-label': this.props.label
        },
        Glyph ? __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(Glyph, { role: 'presentation' }) : null
      );
    }
  }], [{
    key: 'insertDynamicGradientID',


    /* Icons need unique gradient IDs across instances for different gradient definitions to work
     * correctly.
     * A step in the icon build process replaces linear gradient IDs and their references in paths
     * to a placeholder string so we can replace them with a dynamic ID here.
     * Replacing the original IDs with placeholders in the build process is more robust than not
     * using placeholders as we do not have to rely on regular expressions to find specific element
     * to replace.
     */
    value: function insertDynamicGradientID(svgStr) {
      var id = __WEBPACK_IMPORTED_MODULE_11_uuid___default()();

      var replacedSvgStr = svgStr.replace(/id="([^"]+)-idPlaceholder"/g, 'id=$1-' + id).replace(/fill="url\(#([^"]+)-idPlaceholder\)"/g, 'fill="url(#$1-' + id + ')"');

      return replacedSvgStr;
    }
  }]);

  return Icon;
}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]);

Icon.defaultProps = {
  onClick: function onClick() {}
};
/* harmony default export */ __webpack_exports__["a"] = (Icon);


var size = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_13__constants__["a" /* sizes */]).reduce(function (p, c) {
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(p, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, c, c));
}, {});

/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styled_Skeleton__ = __webpack_require__(733);









var Skeleton = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Skeleton, _Component);

  function Skeleton() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Skeleton);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Skeleton.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Skeleton)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Skeleton, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styled_Skeleton__["a" /* default */], this.props);
    }
  }]);

  return Skeleton;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Skeleton.defaultProps = {
  size: 'medium',
  weight: 'normal'
};
/* harmony default export */ __webpack_exports__["a"] = (Skeleton);

/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(304);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: ', ';\n  height: ', ';\n  display: inline-block;\n  border-radius: 50%;\n  background-color: ', ';\n  opacity: ', ';\n'], ['\n  width: ', ';\n  height: ', ';\n  display: inline-block;\n  border-radius: 50%;\n  background-color: ', ';\n  opacity: ', ';\n']);




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, function (props) {
  return __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* sizes */][props.size];
}, function (props) {
  return __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* sizes */][props.size];
}, function (_ref) {
  var color = _ref.color;
  return color || 'currentColor';
}, function (_ref2) {
  var weight = _ref2.weight;
  return weight === 'strong' ? 0.3 : 0.15;
}));

/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(20);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  margin-bottom: ', 'px;\n'], ['\n  margin-bottom: ', 'px;\n']);





var SkeletonGlobalPrimaryIconOuter = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["e" /* math */].multiply(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */], 1.5));

SkeletonGlobalPrimaryIconOuter.displayName = 'SkeletonGlobalPrimaryIconOuter';
/* harmony default export */ __webpack_exports__["a"] = (SkeletonGlobalPrimaryIconOuter);

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(20);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  margin-bottom: ', 'px;\n'], ['\n  margin-bottom: ', 'px;\n']);





var SkeletonGlobalTopItemsInner = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */])() * 3);

SkeletonGlobalTopItemsInner.displayName = 'SkeletonGlobalTopItemsInner';
/* harmony default export */ __webpack_exports__["a"] = (SkeletonGlobalTopItemsInner);

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_variables__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__theme_util__ = __webpack_require__(11);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  height: 100%;\n  width: ', 'px;\n  color: ', ';\n  background-color: ', ';\n'], ['\n  height: 100%;\n  width: ', 'px;\n  color: ', ';\n  background-color: ', ';\n']);






var SkeletonGlobalNavigationInner = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, Object(__WEBPACK_IMPORTED_MODULE_2__shared_variables__["c" /* containerClosedWidth */])(), function (_ref) {
  var theme = _ref.theme;
  return Object(__WEBPACK_IMPORTED_MODULE_3__theme_util__["e" /* getProvided */])(theme).text;
}, function (_ref2) {
  var theme = _ref2.theme;
  return Object(__WEBPACK_IMPORTED_MODULE_3__theme_util__["e" /* getProvided */])(theme).background.primary;
});

SkeletonGlobalNavigationInner.displayName = 'SkeletonGlobalNavigationInner';
/* harmony default export */ __webpack_exports__["a"] = (SkeletonGlobalNavigationInner);

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(20);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  box-sizing: border-box; /* to make width: 100%; work properly when padding or border is specified - so that item width is not bigger than container width */\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding-left: ', 'px;\n  margin-top: ', 'px;\n  margin-bottom: ', 'px;\n'], ['\n  box-sizing: border-box; /* to make width: 100%; work properly when padding or border is specified - so that item width is not bigger than container width */\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding-left: ', 'px;\n  margin-top: ', 'px;\n  margin-bottom: ', 'px;\n']);





var SkeletonContainerItemWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */])() * 2, Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */])(), Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */])());

SkeletonContainerItemWrapper.displayName = 'SkeletonContainerItemWrapper';
/* harmony default export */ __webpack_exports__["a"] = (SkeletonContainerItemWrapper);

/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(20);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  height: ', 'px;\n  background-color: currentColor;\n  border-radius: ', 'px;\n  opacity: 0.15;\n  margin-left: ', 'px;\n  width: ', ';\n'], ['\n  height: ', 'px;\n  background-color: currentColor;\n  border-radius: ', 'px;\n  opacity: 0.15;\n  margin-left: ', 'px;\n  width: ', ';\n']);





var SkeletonContainerItemText = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["e" /* math */].multiply(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */], 2.5), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["e" /* math */].divide(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */], 2), Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */])() * 3, function (props) {
  return props.textWidth || Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */])() * 17 + 'px';
});

SkeletonContainerItemText.displayName = 'SkeletonContainerItemText';
/* harmony default export */ __webpack_exports__["a"] = (SkeletonContainerItemText);

/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex; /* to fix "baseline space below inline-block element problem" https://stackoverflow.com/q/17905827/1343917 */\n  flex-shrink: 0; /* so that too big width of header text does not change width of avatar */\n'], ['\n  display: flex; /* to fix "baseline space below inline-block element problem" https://stackoverflow.com/q/17905827/1343917 */\n  flex-shrink: 0; /* so that too big width of header text does not change width of avatar */\n']);



var SkeletonIconWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject);

SkeletonIconWrapper.displayName = 'SkeletonIconWrapper';
/* harmony default export */ __webpack_exports__["a"] = (SkeletonIconWrapper);

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_variables__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__theme_util__ = __webpack_require__(11);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  height: 100%;\n  width: ', 'px;\n  color: ', ';\n  background-color: ', ';\n'], ['\n  height: 100%;\n  width: ', 'px;\n  color: ', ';\n  background-color: ', ';\n']);






var SkeletonContainerNavigationInner = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, function (_ref) {
  var isCollapsed = _ref.isCollapsed;
  return isCollapsed ? Object(__WEBPACK_IMPORTED_MODULE_2__shared_variables__["c" /* containerClosedWidth */])() : __WEBPACK_IMPORTED_MODULE_2__shared_variables__["d" /* containerOpenWidth */];
}, function (_ref2) {
  var theme = _ref2.theme;
  return Object(__WEBPACK_IMPORTED_MODULE_3__theme_util__["e" /* getProvided */])(theme).text;
}, function (_ref3) {
  var theme = _ref3.theme;

  var background = Object(__WEBPACK_IMPORTED_MODULE_3__theme_util__["e" /* getProvided */])(theme).background;
  return background.secondary || background.primary;
});

SkeletonContainerNavigationInner.displayName = 'SkeletonContainerNavigationInner';
/* harmony default export */ __webpack_exports__["a"] = (SkeletonContainerNavigationInner);

/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(20);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  margin-bottom: ', 'px;\n'], ['\n  margin-bottom: ', 'px;\n']);





var SkeletonContainerHeaderWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */])() * 2);

SkeletonContainerHeaderWrapper.displayName = 'SkeletonContainerHeaderWrapper';
/* harmony default export */ __webpack_exports__["a"] = (SkeletonContainerHeaderWrapper);

/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AvatarWithoutAnalytics */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__atlaskit_analytics_next__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__atlaskit_tooltip__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__package_json__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Presence__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__AvatarImage__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Status__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styled_Avatar__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__helpers__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__hoc__ = __webpack_require__(180);























var warn = function warn(message) {
  if (false) {
    console.warn(message); // eslint-disable-line no-console
  }
};

var Avatar = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(Avatar, _Component);

  function Avatar() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, Avatar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Avatar.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(Avatar)).call.apply(_ref, [this].concat(args))), _this), _this.blur = function () {
      if (_this.ref) _this.ref.blur();
    }, _this.focus = function () {
      if (_this.ref) _this.ref.focus();
    }, _this.guardedClick = function (event) {
      var _this$props = _this.props,
          isDisabled = _this$props.isDisabled,
          onClick = _this$props.onClick;


      if (isDisabled || typeof onClick !== 'function') return;

      var item = __WEBPACK_IMPORTED_MODULE_17__utils__["b" /* omit */].apply(undefined, [_this.props].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_12__constants__["a" /* propsOmittedFromClickData */])));

      onClick({ item: item, event: event });
    }, _this.renderIcon = function () {
      var _this$props2 = _this.props,
          appearance = _this$props2.appearance,
          borderColor = _this$props2.borderColor,
          presence = _this$props2.presence,
          status = _this$props2.status;

      var showPresence = Boolean(presence);
      var showStatus = Boolean(status);

      // no icon needed
      if (!showStatus && !showPresence) {
        return null;
      }

      // cannot display both
      if (showStatus && showPresence) {
        warn('Avatar supports `presence` OR `status` properties, not both.');
        return null;
      }

      // only support particular sizes
      if (__WEBPACK_IMPORTED_MODULE_12__constants__["b" /* validIconSizes */].indexOf(_this.props.size) === -1) {
        warn('Avatar size "' + String(_this.props.size) + '" does NOT support ' + (showPresence ? 'presence' : 'status'));
        return null;
      }

      // we can cast here because we already know that it is a valid icon size
      var size = _this.props.size;

      var indicator = function () {
        if (showPresence) {
          var customPresenceNode = (typeof presence === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(presence)) === 'object' ? presence : null;

          return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_16__styled_Avatar__["a" /* PresenceWrapper */],
            { appearance: appearance, size: size },
            __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_13__Presence__["a" /* default */],
              {
                borderColor: borderColor,
                presence: !customPresenceNode && presence,
                size: size
              },
              customPresenceNode
            )
          );
        }

        // showStatus
        return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_16__styled_Avatar__["b" /* StatusWrapper */],
          { appearance: appearance, size: size },
          __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Status__["a" /* default */], { status: status, borderColor: borderColor, size: size })
        );
      }();

      return indicator;
    }, _this.setRef = function (ref) {
      _this.ref = ref;
    }, _temp), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  // expose blur/focus to consumers via ref


  // disallow click on disabled avatars
  // only return avatar data properties


  // enforce status / presence rules
  /* eslint-disable no-console */


  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(Avatar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          appearance = _props.appearance,
          enableTooltip = _props.enableTooltip,
          name = _props.name,
          size = _props.size,
          src = _props.src,
          stackIndex = _props.stackIndex,
          onClick = _props.onClick;

      // distill props from context, props, and state

      var enhancedProps = Object(__WEBPACK_IMPORTED_MODULE_18__helpers__["a" /* getProps */])(this);

      // provide element type based on props
      // TODO: why not enhanced props?
      var Inner = Object(__WEBPACK_IMPORTED_MODULE_18__helpers__["b" /* getStyledAvatar */])(this.props);

      var AvatarNode = __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_16__styled_Avatar__["c" /* default */],
        { size: size, stackIndex: stackIndex },
        __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
          Inner,
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            innerRef: this.setRef
          }, enhancedProps, {
            onClick: onClick != null ? this.guardedClick : undefined
          }),
          __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__AvatarImage__["a" /* default */], {
            alt: name,
            appearance: appearance,
            size: size,
            src: src
          })
        ),
        this.renderIcon()
      );

      return enableTooltip && name ? __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10__atlaskit_tooltip__["a" /* default */],
        { content: name },
        AvatarNode
      ) : AvatarNode;
    }
  }]);

  return Avatar;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

Avatar.defaultProps = {
  appearance: 'circle',
  enableTooltip: true,
  size: 'medium'
};


var AvatarWithoutAnalytics = Object(__WEBPACK_IMPORTED_MODULE_19__hoc__["a" /* mapProps */])({
  appearance: function appearance(props) {
    return props.appearance || Avatar.defaultProps.appearance;
  }, // 1
  isInteractive: function isInteractive(props) {
    return Boolean((typeof props.enableTooltip !== 'undefined' ? props.enableTooltip : Avatar.defaultProps.enableTooltip) && props.name);
  } // 2
})(Object(__WEBPACK_IMPORTED_MODULE_19__hoc__["b" /* withPseudoState */])(Avatar));

var createAndFireEventOnAtlaskit = Object(__WEBPACK_IMPORTED_MODULE_9__atlaskit_analytics_next__["b" /* createAndFireEvent */])('atlaskit');

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__atlaskit_analytics_next__["c" /* withAnalyticsContext */])({
  componentName: 'avatar',
  packageName: __WEBPACK_IMPORTED_MODULE_11__package_json__["name"],
  packageVersion: __WEBPACK_IMPORTED_MODULE_11__package_json__["version"]
})(Object(__WEBPACK_IMPORTED_MODULE_9__atlaskit_analytics_next__["d" /* withAnalyticsEvents */])({
  onClick: createAndFireEventOnAtlaskit({
    action: 'clicked',
    actionSubject: 'avatar',

    attributes: {
      componentName: 'avatar',
      packageName: __WEBPACK_IMPORTED_MODULE_11__package_json__["name"],
      packageVersion: __WEBPACK_IMPORTED_MODULE_11__package_json__["version"]
    }
  })
})(AvatarWithoutAnalytics)));

/***/ }),
/* 743 */
/***/ (function(module, exports) {

module.exports = {"name":"@atlaskit/avatar","version":"14.0.8","sideEffects":false}

/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export e100 */
/* unused harmony export e200 */
/* unused harmony export e300 */
/* unused harmony export e400 */
/* unused harmony export e500 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_themed__ = __webpack_require__(178);



// Cards on a board
var e100 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 1px 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px 0 ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 1px 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

// Inline dialogs
var e200 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 4px 8px -2px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 4px 8px -2px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

// Modals
var e300 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 8px 16px -4px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 8px 16px -4px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

// Panels
var e400 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 12px 24px -6px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 12px 24px -6px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

// Flag messages (notifications)
var e500 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: 'box-shadow: 0 20px 32px -8px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["N60A"] + ';',
  dark: 'box-shadow: 0 20px 32px -8px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN50A"] + ', 0 0 1px ' + __WEBPACK_IMPORTED_MODULE_0__colors__["DN60A"] + ';'
});

/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export h900 */
/* unused harmony export h800 */
/* unused harmony export h700 */
/* unused harmony export h600 */
/* unused harmony export h500 */
/* unused harmony export h400 */
/* unused harmony export h300 */
/* unused harmony export h200 */
/* unused harmony export h100 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__colors__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index__ = __webpack_require__(26);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 500;\n  letter-spacing: -0.01em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 500;\n  letter-spacing: -0.01em;\n  margin-top: ', 'px;\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  margin-top: ', 'px;\n']),
    _templateObject3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 500;\n  letter-spacing: -0.008em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 500;\n  letter-spacing: -0.008em;\n  margin-top: ', 'px;\n']),
    _templateObject4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.006em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.006em;\n  margin-top: ', 'px;\n']),
    _templateObject5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.003em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.003em;\n  margin-top: ', 'px;\n']),
    _templateObject6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  margin-top: ', 'px;\n  text-transform: uppercase;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  margin-top: ', 'px;\n  text-transform: uppercase;\n']),
    _templateObject7 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: 600;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  margin-top: ', 'px;\n']),
    _templateObject8 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ' color: ', ';\n  font-weight: normal;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: normal;\n  margin-top: ', 'px;\n']);






var baseHeading = function baseHeading(size, lineHeight) {
  return '\n  font-size: ' + size / Object(__WEBPACK_IMPORTED_MODULE_3__index__["c" /* fontSize */])() + 'em;\n  font-style: inherit;\n  line-height: ' + lineHeight / size + ';\n';
};

var h900 = function h900() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject, baseHeading(35, 40), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 6.5);
};

var h800 = function h800() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject2, baseHeading(29, 32), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 5);
};

var h700 = function h700() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject, baseHeading(24, 28), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 5);
};

var h600 = function h600() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject3, baseHeading(20, 24), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 3.5);
};

var h500 = function h500() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject4, baseHeading(16, 20), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 3);
};

var h400 = function h400() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject5, baseHeading(14, 16), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 2);
};

var h300 = function h300() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject6, baseHeading(12, 16), __WEBPACK_IMPORTED_MODULE_2__colors__["heading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 2.5);
};

var h200 = function h200() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject7, baseHeading(12, 16), __WEBPACK_IMPORTED_MODULE_2__colors__["subtleHeading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 2);
};

var h100 = function h100() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject8, baseHeading(12, 16), __WEBPACK_IMPORTED_MODULE_2__colors__["subtleHeading"], Object(__WEBPACK_IMPORTED_MODULE_3__index__["d" /* gridSize */])() * 2);
};

/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["add"] = add;
/* harmony export (immutable) */ __webpack_exports__["subtract"] = subtract;
/* harmony export (immutable) */ __webpack_exports__["multiply"] = multiply;
/* harmony export (immutable) */ __webpack_exports__["divide"] = divide;
function add(fn, addend) {
  return function (props) {
    return fn(props) + addend;
  };
}

function subtract(fn, subtrahend) {
  return function (props) {
    return fn(props) - subtrahend;
  };
}

function multiply(fn, factor) {
  return function (props) {
    return fn(props) * factor;
  };
}

function divide(fn, divisor) {
  return function (props) {
    return fn(props) / divisor;
  };
}

/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__colors__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Context__ = __webpack_require__(104);








var _templateObject = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  background-color: ', ';\n  color: ', ';\n\n  a {\n    color: ', ';\n  }\n  a:hover {\n    color: ', ';\n  }\n  a:active {\n    color: ', ';\n  }\n  a:focus {\n    outline-color: ', ';\n  }\n  h1 {\n    color: ', ';\n  }\n  h2 {\n    color: ', ';\n  }\n  h3 {\n    color: ', ';\n  }\n  h4 {\n    color: ', ';\n  }\n  h5 {\n    color: ', ';\n  }\n  h6 {\n    color: ', ';\n  }\n  small {\n    color: ', ';\n  }\n'], ['\n  background-color: ', ';\n  color: ', ';\n\n  a {\n    color: ', ';\n  }\n  a:hover {\n    color: ', ';\n  }\n  a:active {\n    color: ', ';\n  }\n  a:focus {\n    outline-color: ', ';\n  }\n  h1 {\n    color: ', ';\n  }\n  h2 {\n    color: ', ';\n  }\n  h3 {\n    color: ', ';\n  }\n  h4 {\n    color: ', ';\n  }\n  h5 {\n    color: ', ';\n  }\n  h6 {\n    color: ', ';\n  }\n  small {\n    color: ', ';\n  }\n']);









// For forward-compat until everything is upgraded.


function getStylesheetResetCSS(state) {
  var backgroundColor = __WEBPACK_IMPORTED_MODULE_10__colors__["background"](state);
  return '\n    body { background: ' + backgroundColor + '; }\n  ';
}

function buildThemeState(mode) {
  return { theme: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_11__constants__["a" /* CHANNEL */], { mode: mode }) };
}

var LegacyReset = __WEBPACK_IMPORTED_MODULE_9_styled_components__["default"].div(_templateObject, __WEBPACK_IMPORTED_MODULE_10__colors__["background"], __WEBPACK_IMPORTED_MODULE_10__colors__["text"], __WEBPACK_IMPORTED_MODULE_10__colors__["link"], __WEBPACK_IMPORTED_MODULE_10__colors__["linkHover"], __WEBPACK_IMPORTED_MODULE_10__colors__["linkActive"], __WEBPACK_IMPORTED_MODULE_10__colors__["linkOutline"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["heading"], __WEBPACK_IMPORTED_MODULE_10__colors__["subtleHeading"], __WEBPACK_IMPORTED_MODULE_10__colors__["subtleText"]);

var AtlaskitThemeProvider = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(AtlaskitThemeProvider, _Component);

  function AtlaskitThemeProvider(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AtlaskitThemeProvider);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AtlaskitThemeProvider.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(AtlaskitThemeProvider)).call(this, props));

    _this.state = buildThemeState(props.mode);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(AtlaskitThemeProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return { hasAtlaskitThemeProvider: true };
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (!this.context.hasAtlaskitThemeProvider) {
        var css = getStylesheetResetCSS(this.state);
        this.stylesheet = document.createElement('style');
        this.stylesheet.type = 'text/css';
        this.stylesheet.innerHTML = css;
        if (document && document.head) {
          document.head.appendChild(this.stylesheet);
        }
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (newProps.mode !== this.props.mode) {
        var newThemeState = buildThemeState(newProps.mode);
        if (this.stylesheet) {
          var css = getStylesheetResetCSS(newThemeState);
          this.stylesheet.innerHTML = css;
        }
        this.setState(newThemeState);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.stylesheet && document && document.head) {
        document.head.removeChild(this.stylesheet);
        delete this.stylesheet;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;

      var theme = this.state.theme;
      return (
        /* Wrapping the new provider around the old one provides forward
        compatibility when using the old provider for styled components. This
        allows us to use components converted to use the new API with consumers
        using the old provider along side components that may still be using the
        old theming API. */
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12__Context__["b" /* Provider */],
          { value: { mode: theme[__WEBPACK_IMPORTED_MODULE_11__constants__["a" /* CHANNEL */]].mode } },
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_styled_components__["ThemeProvider"],
            { theme: theme },
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
              LegacyReset,
              null,
              children
            )
          )
        )
      );
    }
  }]);

  return AtlaskitThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

AtlaskitThemeProvider.defaultProps = {
  mode: __WEBPACK_IMPORTED_MODULE_11__constants__["b" /* DEFAULT_THEME_MODE */]
};
AtlaskitThemeProvider.childContextTypes = {
  hasAtlaskitThemeProvider: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
};
AtlaskitThemeProvider.contextTypes = {
  hasAtlaskitThemeProvider: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
};
/* harmony default export */ __webpack_exports__["a"] = (AtlaskitThemeProvider);

/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);





/* unused harmony default export */ var _unused_webpack_default_export = (function (_ref) {
  var children = _ref.children,
      props = _ref.props,
      theme = _ref.theme;

  var appearance = (typeof props === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(props)) === 'object' ? 'default' : props;
  var merged = (typeof props === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(props)) === 'object' ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, props) : {};
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(theme).forEach(function (key) {
    if (!(key in merged)) {
      merged[key] = theme[key]({ appearance: appearance });
    }
  });
  return children(merged);
});

/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__colors__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Context__ = __webpack_require__(104);








var _templateObject = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ';\n'], ['\n  ', ';\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n    background-color: ', ';\n    color: ', ';\n\n    a {\n      color: ', ';\n    }\n    a:hover {\n      color: ', ';\n    }\n    a:active {\n      color: ', ';\n    }\n    a:focus {\n      outline-color: ', ';\n    }\n    h1,\n    h2,\n    h3,\n    h4,\n    h5 {\n      color: ', ';\n    }\n    h6 {\n      color: ', ';\n    }\n    small {\n      color: ', ';\n    }\n  '], ['\n    background-color: ', ';\n    color: ', ';\n\n    a {\n      color: ', ';\n    }\n    a:hover {\n      color: ', ';\n    }\n    a:active {\n      color: ', ';\n    }\n    a:focus {\n      outline-color: ', ';\n    }\n    h1,\n    h2,\n    h3,\n    h4,\n    h5 {\n      color: ', ';\n    }\n    h6 {\n      color: ', ';\n    }\n    small {\n      color: ', ';\n    }\n  ']);






var orTextColor = function orTextColor(preferred) {
  return function (p) {
    return p[preferred] || p.textColor;
  };
};
var Div = __WEBPACK_IMPORTED_MODULE_8_styled_components__["default"].div(_templateObject, function (p) {
  return Object(__WEBPACK_IMPORTED_MODULE_8_styled_components__["css"])(_templateObject2, p.backgroundColor, p.textColor, orTextColor('linkColor'), orTextColor('linkColorHover'), orTextColor('linkColorActive'), orTextColor('linkColorOutline'), orTextColor('headingColor'), orTextColor('subtleHeadingColor'), orTextColor('subtleTextColor'));
});

var defaultTheme = {
  backgroundColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N0"],
  linkColor: __WEBPACK_IMPORTED_MODULE_9__colors__["B400"],
  linkColorHover: __WEBPACK_IMPORTED_MODULE_9__colors__["B300"],
  linkColorActive: __WEBPACK_IMPORTED_MODULE_9__colors__["B500"],
  linkColorOutline: __WEBPACK_IMPORTED_MODULE_9__colors__["B100"],
  headingColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N800"],
  subtleHeadingColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N200"],
  subtleTextColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N200"],
  textColor: __WEBPACK_IMPORTED_MODULE_9__colors__["N900"]
};

var Reset = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Reset, _Component);

  function Reset() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Reset);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Reset.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Reset)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Reset, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10__Context__["a" /* Consumer */],
        null,
        function (theme) {
          return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            Div,
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, defaultTheme, theme, _this2.props),
            _this2.props.children
          );
        }
      );
    }
  }]);

  return Reset;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

/* unused harmony default export */ var _unused_webpack_default_export = (Reset);

/***/ }),
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Context__ = __webpack_require__(104);








var Theme = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Theme, _Component);

  function Theme() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Theme);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Theme.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Theme)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Theme, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          values = _props.values;

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6__components_Context__["a" /* Consumer */],
        null,
        function (theme) {
          var merged = values(theme);
          return typeof children === 'function' ? children(merged) : __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__components_Context__["b" /* Provider */],
            { value: merged },
            children
          );
        }
      );
    }
  }]);

  return Theme;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Theme.defaultProps = {
  values: function values(v) {
    return v;
  }
};
/* unused harmony default export */ var _unused_webpack_default_export = (Theme);

/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DefaultImage */
/* unused harmony export clearCache */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__atlaskit_theme__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styled_AvatarImage__ = __webpack_require__(752);







var _templateObject = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  & circle,\n  & rect {\n    fill: ', ';\n  }\n  & g {\n    fill: ', ';\n  }\n'], ['\n  & circle,\n  & rect {\n    fill: ', ';\n  }\n  & g {\n    fill: ', ';\n  }\n']);







var ShapeGroup = __WEBPACK_IMPORTED_MODULE_7_styled_components__["default"].g(_templateObject, Object(__WEBPACK_IMPORTED_MODULE_8__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_8__atlaskit_theme__["b" /* colors */].N50, dark: __WEBPACK_IMPORTED_MODULE_8__atlaskit_theme__["b" /* colors */].DN100 }), __WEBPACK_IMPORTED_MODULE_8__atlaskit_theme__["b" /* colors */].background);

function DefaultImage(_ref) {
  var appearance = _ref.appearance,
      size = _ref.size,
      title = _ref.title;

  var rectBounds = 128;

  return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_9__styled_AvatarImage__["b" /* Svg */],
    {
      appearance: appearance,
      size: size,
      viewBox: '0 0 ' + rectBounds + ' ' + rectBounds,
      version: '1.1',
      xmlns: 'http://www.w3.org/2000/svg',
      role: 'img',
      'aria-label': title
    },
    appearance === 'circle' ? __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      ShapeGroup,
      null,
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('circle', { cx: '64', cy: '64', r: '64' }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'g',
        null,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('path', { d: 'M103,102.1388 C93.094,111.92 79.3504,118 64.1638,118 C48.8056,118 34.9294,111.768 25,101.7892 L25,95.2 C25,86.8096 31.981,80 40.6,80 L87.4,80 C96.019,80 103,86.8096 103,95.2 L103,102.1388 Z' }),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('path', { d: 'M63.9961647,24 C51.2938136,24 41,34.2938136 41,46.9961647 C41,59.7061864 51.2938136,70 63.9961647,70 C76.6985159,70 87,59.7061864 87,46.9961647 C87,34.2938136 76.6985159,24 63.9961647,24' })
      )
    ) : __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      ShapeGroup,
      null,
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('rect', { x: '0', y: '0', width: rectBounds, height: rectBounds }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'g',
        { transform: 'translate(19.000000, 32.000000)' },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('path', { d: 'M18.25,32.5 L54.5833333,32.5 L54.5833333,23.4166667 L18.25,23.4166667 L18.25,32.5 Z M9.16666667,18.8331166 C9.16666667,16.3479549 11.236581,14.3333333 13.7195662,14.3333333 L59.1137671,14.3333333 C61.6282641,14.3333333 63.6666667,16.3815123 63.6666667,18.8331166 L63.6666667,41.5833333 L9.16666667,41.5833333 L9.16666667,18.8331166 Z' }),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('path', { d: 'M18.25,9.81383682 C18.25,4.7850061 22.3296003,0.708333333 27.3238554,0.708333333 L36.4261446,0.708333333 C41.4374965,0.708333333 45.5,4.76812825 45.5,9.81383682 L45.5,23.4166667 L18.25,23.4166667 L18.25,9.81383682 Z M36.4166667,9.81383682 C36.4166667,9.79803315 36.4184748,9.79303784 36.4207515,9.79166667 L27.3238554,9.79166667 C27.3447224,9.79166667 27.3333333,9.80308059 27.3333333,9.81383682 L27.3333333,14.3333333 L36.4166667,14.3333333 L36.4166667,9.81383682 Z' }),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('path', { d: 'M11.4386532,55.2083333 L74.9953562,55.2083333 L79.5452242,41.5833333 L9.80449752,41.5833333 L11.4386532,55.2083333 Z M0.1048547,36.987541 C-0.192399775,34.5091405 1.5865717,32.5 4.09502839,32.5 L87.6264735,32.5 C90.1274401,32.5 91.5225656,34.393506 90.7231047,36.7875656 L82.9702846,60.004101 C82.1795402,62.3720582 79.5279445,64.2916667 76.9985338,64.2916667 L7.91963924,64.2916667 C5.41227673,64.2916667 3.14113571,62.3029555 2.84143097,59.8041257 L0.1048547,36.987541 Z' })
      )
    )
  );
}

var cache = {};

var clearCache = function clearCache() {
  cache = {};
};

var AvatarImage = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(AvatarImage, _PureComponent);

  function AvatarImage() {
    var _ref2;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AvatarImage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref2 = AvatarImage.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(AvatarImage)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      hasError: false,
      // if provided a scr - we need to load it
      isLoading: Boolean(_this.props.src)
    }, _this.loadImage = function () {
      // nothing to load
      if (!_this.props.src) {
        return;
      }

      var img = new Image();
      img.onload = _this.handleLoadSuccess;
      img.onerror = _this.handleLoadError;
      img.src = _this.props.src;
    }, _this.handleLoad = function (hasError) {
      if (_this.isComponentMounted) {
        _this.setState({ hasError: hasError, isLoading: false });
      }
    }, _this.handleLoadSuccess = function () {
      if (typeof _this.props.src === 'string') {
        cache[_this.props.src] = true;
      }
      _this.handleLoad(false);
    }, _this.handleLoadError = function () {
      return _this.handleLoad(true);
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(AvatarImage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.isComponentMounted = true;
      this.loadImage();
    }
    // handle case where `src` is modified after mount

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.src && this.props.src !== nextProps.src) {
        this.setState({ isLoading: true });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.src && this.props.src !== prevProps.src) {
        this.loadImage();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.isComponentMounted = false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          alt = _props.alt,
          src = _props.src,
          appearance = _props.appearance,
          size = _props.size;
      var _state = this.state,
          hasError = _state.hasError,
          isLoading = _state.isLoading;

      var showDefault = !isLoading && (!src || hasError);
      var imageUrl = src && (!isLoading || cache[src]) ? src : null;
      return showDefault ? __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(DefaultImage, { appearance: appearance, size: size, title: alt }) : __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__styled_AvatarImage__["a" /* Slot */], {
        appearance: appearance,
        isLoading: isLoading,
        size: size,
        role: 'img',
        label: alt,
        backgroundImage: imageUrl
      });
    }
  }]);

  return AvatarImage;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (AvatarImage);

/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Slot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Svg; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(105);








// if image is loading, we hide the image so it doesn't obscure the gray loading
// block until the source image is loaded.
var getBackgroundColor = function getBackgroundColor(_ref) {
  var isLoading = _ref.isLoading;
  return isLoading ? Object(__WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["f" /* themed */])({ light: __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["b" /* colors */].N40, dark: __WEBPACK_IMPORTED_MODULE_3__atlaskit_theme__["b" /* colors */].DN50 }) : 'transparent';
};

var Slot = function Slot(_ref2) {
  var isLoading = _ref2.isLoading,
      appearance = _ref2.appearance,
      size = _ref2.size,
      backgroundImage = _ref2.backgroundImage,
      label = _ref2.label,
      role = _ref2.role;
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', {
    style: {
      backgroundColor: getBackgroundColor({ isLoading: isLoading }),
      backgroundImage: backgroundImage ? 'url(' + backgroundImage + ')' : null,
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      borderRadius: Object(__WEBPACK_IMPORTED_MODULE_4__utils__["b" /* getBorderRadius */])({ appearance: appearance, size: size }),
      display: 'flex',
      flex: '1 1 100%',
      height: '100%',
      width: '100%'
    },
    role: role,
    'aria-label': label
  });
};

var Svg = function Svg(_ref3) {
  var appearance = _ref3.appearance,
      size = _ref3.size,
      children = _ref3.children,
      otherProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref3, ['appearance', 'size', 'children']);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'svg',
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
      style: {
        backgroundColor: getBackgroundColor({ isLoading: false }),
        borderRadius: Object(__WEBPACK_IMPORTED_MODULE_4__utils__["b" /* getBorderRadius */])({ appearance: appearance, size: size }),
        height: '100%',
        width: '100%'
      }
    }, otherProps),
    children
  );
};


/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Inner */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PresenceWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StatusWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(105);



var _templateObject = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  ', ';\n'], ['\n  ', ';\n']);








// OUTER WRAPPER
// eslint-disable-next-line react/prop-types


/* harmony default export */ __webpack_exports__["c"] = (function (_ref) {
  var children = _ref.children,
      size = _ref.size,
      stackIndex = _ref.stackIndex;

  var sizeValue = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* getAvatarDimensions */])({ size: size }, {
    includeBorderWidth: true,
    sizeOnly: true
  }) + 'px';
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'div',
    {
      style: {
        display: 'inline-block',
        position: 'relative',
        outline: 0,
        width: sizeValue,
        height: sizeValue,
        zIndex: stackIndex
      }
    },
    children
  );
});

// INNER WRAPPER
var Inner = __WEBPACK_IMPORTED_MODULE_3_styled_components__["default"].div(_templateObject, __WEBPACK_IMPORTED_MODULE_5__utils__["c" /* getInnerStyles */]);

// PRESENCE WRAPPER


// TODO: do not have all icon sizes!
var getPresenceLayout = function getPresenceLayout(_ref2) {
  var appearance = _ref2.appearance,
      size = _ref2.size;

  var presencePosition = appearance === 'square' ? -(__WEBPACK_IMPORTED_MODULE_4__constants__["c" /* BORDER_WIDTH */][size] * 2) : __WEBPACK_IMPORTED_MODULE_4__constants__["d" /* ICON_OFFSET */][size];
  var presenceSize = __WEBPACK_IMPORTED_MODULE_4__constants__["e" /* ICON_SIZES */][size];

  return {
    bottom: presencePosition + 'px',
    height: presenceSize + 'px',
    right: presencePosition + 'px',
    width: presenceSize + 'px'
  };
};

var PresenceWrapper = function PresenceWrapper(args) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'span',
    {
      style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        pointerEvents: 'none',
        position: 'absolute'
      }, getPresenceLayout(args))
    },
    args.children
  );
};

// STATUS WRAPPER
var getStatusLayout = function getStatusLayout(_ref3) {
  var appearance = _ref3.appearance,
      size = _ref3.size;

  var statusPosition = appearance === 'square' ? __WEBPACK_IMPORTED_MODULE_4__constants__["f" /* SQUARE_ICON_OFFSET */][size] : __WEBPACK_IMPORTED_MODULE_4__constants__["d" /* ICON_OFFSET */][size];
  var statusSize = __WEBPACK_IMPORTED_MODULE_4__constants__["e" /* ICON_SIZES */][size];

  return {
    height: statusSize + 'px',
    right: statusPosition + 'px',
    top: statusPosition + 'px',
    width: statusSize + 'px'
  };
};

// eslint-disable-next-line react/prop-types
var StatusWrapper = function StatusWrapper(args) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'span',
    {
      style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        position: 'absolute'
      }, getStatusLayout(args))
    },
    args.children
  );
};

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(755), __esModule: true };

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(209);
__webpack_require__(129);
module.exports = __webpack_require__(756);


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(35);
var get = __webpack_require__(212);
module.exports = __webpack_require__(18).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getProps;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

var getAppearanceProps = function getAppearanceProps(props) {
  var appearance = props.appearance,
      backgroundColor = props.backgroundColor,
      borderColor = props.borderColor,
      groupAppearance = props.groupAppearance,
      isActive = props.isActive,
      isDisabled = props.isDisabled,
      isFocus = props.isFocus,
      isHover = props.isHover,
      isInteractive = props.isInteractive,
      isSelected = props.isSelected,
      size = props.size,
      stackIndex = props.stackIndex;


  return {
    appearance: appearance,
    backgroundColor: backgroundColor,
    borderColor: borderColor,
    groupAppearance: groupAppearance,
    isActive: isActive,
    isDisabled: isDisabled,
    isFocus: isFocus,
    isHover: isHover,
    isInteractive: isInteractive,
    isSelected: isSelected,
    size: size,
    stackIndex: stackIndex
  };
};

var getInteractionProps = function getInteractionProps(props) {
  var onBlur = props.onBlur,
      onClick = props.onClick,
      onFocus = props.onFocus,
      onKeyDown = props.onKeyDown,
      onKeyUp = props.onKeyUp,
      onMouseDown = props.onMouseDown,
      onMouseEnter = props.onMouseEnter,
      onMouseLeave = props.onMouseLeave,
      onMouseUp = props.onMouseUp,
      tabIndex = props.tabIndex;


  return {
    onBlur: onBlur,
    onClick: onClick,
    onFocus: onFocus,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp,
    onMouseDown: onMouseDown,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onMouseUp: onMouseUp,
    tabIndex: tabIndex
  };
};

var getLinkElementProps = function getLinkElementProps(props) {
  var href = props.href,
      target = props.target;

  // handle security issue for consumer
  // https://mathiasbynens.github.io/rel-noopener

  var rel = target === '_blank' ? 'noopener noreferrer' : null;

  return { href: href, rel: rel, target: target };
};

var getButtonElementProps = function getButtonElementProps(props) {
  var id = props.id,
      isDisabled = props.isDisabled;


  return { id: id, type: 'button', disabled: isDisabled };
};

// TODO: type this correctly
function getProps(component) {
  var props = component.props;


  var defaultProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, getAppearanceProps(props), getInteractionProps(props));

  if (props.component) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, defaultProps, props);
  }

  if (props.href) {
    if (props.isDisabled) {
      return defaultProps;
    }

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, defaultProps, getLinkElementProps(props));
  }

  if (props.onClick) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, defaultProps, getButtonElementProps(props));
  }

  return defaultProps;
}

/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styledCache__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styled_utils__ = __webpack_require__(105);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__styledCache__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__styled_utils__["c" /* getInnerStyles */]));

/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);








/**
 * innerRef is passed by Avatar component
 * TODO: Check if other props are needed?
 */

/**
 * Styling a avatar is complicated and there are a number of properties which
 * inform its appearance. We want to be able to style any arbitrary component
 * like a Link, but we don't want to pass all of these appearance-related props
 * through to the component or underlying DOM node. This component acts as a
 * layer which catches the appearance-related properties so that they can be
 * used by styled-components, then passes the rest of the props on to the custom
 * component.
 */

var CustomComponentProxy = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(CustomComponentProxy, _Component);

  function CustomComponentProxy() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, CustomComponentProxy);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CustomComponentProxy.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(CustomComponentProxy)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(CustomComponentProxy, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          appearance = _props.appearance,
          avatar = _props.avatar,
          borderColor = _props.borderColor,
          ProxiedComponent = _props.component,
          enableTooltip = _props.enableTooltip,
          groupAppearance = _props.groupAppearance,
          innerRef = _props.innerRef,
          isActive = _props.isActive,
          isDisabled = _props.isDisabled,
          isFocus = _props.isFocus,
          isHover = _props.isHover,
          isSelected = _props.isSelected,
          primaryText = _props.primaryText,
          secondaryText = _props.secondaryText,
          stackIndex = _props.stackIndex,
          rest = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['appearance', 'avatar', 'borderColor', 'component', 'enableTooltip', 'groupAppearance', 'innerRef', 'isActive', 'isDisabled', 'isFocus', 'isHover', 'isSelected', 'primaryText', 'secondaryText', 'stackIndex']);

      return ProxiedComponent ? __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ProxiedComponent, rest) : null;
    }
  }]);

  return CustomComponentProxy;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (CustomComponentProxy);

/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styledCache__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styled_AvatarItem__ = __webpack_require__(321);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__styledCache__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__styled_AvatarItem__["e" /* getStyles */]));

/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mapProps;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(106);











function mapProps(mapping) {
  return function (DecoratedComponent
  // TODO: type this correctly
  ) {
    var _class, _temp2;

    return _temp2 = _class = function (_Component) {
      __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(MapProps, _Component);

      function MapProps() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, MapProps);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = MapProps.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(MapProps)).call.apply(_ref, [this].concat(args))), _this), _this.blur = function () {
          if (_this.component && _this.component.blur) _this.component.blur();
        }, _this.focus = function () {
          if (_this.component && _this.component.focus) _this.component.focus();
        }, _this.setComponent = function (component) {
          _this.component = component;
        }, _temp), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
      }

      // expose blur/focus to consumers via ref


      __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(MapProps, [{
        key: 'render',
        value: function render() {
          var _this2 = this;

          var mapped = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.props, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(mapping).reduce(function (acc, key) {
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, acc, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, key, mapping[key](_this2.props)));
          }, {}));

          return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(DecoratedComponent, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({ ref: this.setComponent }, mapped));
        }
      }]);

      return MapProps;
    }(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]), _class.displayName = Object(__WEBPACK_IMPORTED_MODULE_9__utils__["a" /* getDisplayName */])('mapProps', DecoratedComponent), _class.DecoratedComponent = DecoratedComponent, _temp2;
  };
}

/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withPseudoState;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(106);









var INTERNAL_HANDLERS = ['onBlur', 'onFocus', 'onKeyDown', 'onKeyUp', 'onMouseDown', 'onMouseEnter', 'onMouseLeave', 'onMouseUp'];

function withPseudoState(WrappedComponent) {
  var _class, _temp2, _initialiseProps;

  return _temp2 = _class = function (_Component) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ComponentWithPseudoState, _Component);

    function ComponentWithPseudoState() {
      var _ref;

      var _temp, _this, _ret;

      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ComponentWithPseudoState);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = ComponentWithPseudoState.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(ComponentWithPseudoState)).call.apply(_ref, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ComponentWithPseudoState, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        var _props = this.props,
            href = _props.href,
            isInteractive = _props.isInteractive,
            onClick = _props.onClick;


        if (href || isInteractive || onClick) {
          this.actionKeys = onClick || isInteractive ? ['Enter', ' '] : ['Enter'];
        }
      }

      // expose blur/focus to consumers via ref

    }, {
      key: 'render',
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(WrappedComponent, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          ref: this.setComponent
        }, this.state, this.getProps()));
      }
    }]);

    return ComponentWithPseudoState;
  }(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]), _class.displayName = Object(__WEBPACK_IMPORTED_MODULE_7__utils__["a" /* getDisplayName */])('withPseudoState', WrappedComponent), _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.state = {
      isActive: Boolean(this.props.isActive),
      isFocus: Boolean(this.props.isActive),
      isHover: Boolean(this.props.isActive),
      isInteractive: Boolean(this.props.href || this.props.isInteractive || this.props.onClick)
    };

    this.blur = function () {
      if (_this2.component && _this2.component.blur) _this2.component.blur();
    };

    this.focus = function () {
      if (_this2.component && _this2.component.focus) _this2.component.focus();
    };

    this.setComponent = function (component) {
      _this2.component = component;
    };

    this.onBlur = function () {
      return _this2.setState({ isActive: false, isFocus: false });
    };

    this.onFocus = function () {
      return _this2.setState({ isFocus: true });
    };

    this.onMouseLeave = function () {
      return _this2.setState({ isActive: false, isHover: false });
    };

    this.onMouseEnter = function () {
      return _this2.setState({ isHover: true });
    };

    this.onMouseUp = function () {
      return _this2.setState({ isActive: false });
    };

    this.onMouseDown = function () {
      return _this2.setState({ isActive: true });
    };

    this.onKeyDown = function (event) {
      if (_this2.actionKeys.indexOf(event.key) > -1) {
        _this2.setState({ isActive: true });
      }
    };

    this.onKeyUp = function (event) {
      if (_this2.actionKeys.indexOf(event.key) > -1) {
        _this2.setState({ isActive: false });
      }
    };

    this.getProps = function () {
      var isInteractive = _this2.state.isInteractive;

      // strip the consumer's handlers off props, then merge with our handlers
      // if the element is interactive
      // We cannot properly type omit because of the inability to convert from
      // an array to a union of the array's items. See https://github.com/facebook/flow/issues/961
      // if you want to learn more about this
      // $FlowFixMe

      var props = __WEBPACK_IMPORTED_MODULE_7__utils__["b" /* omit */].apply(undefined, [_this2.props].concat(INTERNAL_HANDLERS));

      var self = _this2;

      if (isInteractive) {
        INTERNAL_HANDLERS.forEach(function (handler) {
          if (_this2.props[handler]) {
            props[handler] = function () {
              var _props2;

              self[handler].apply(self, arguments);
              (_props2 = _this2.props)[handler].apply(_props2, arguments);
            };
          } else {
            props[handler] = self[handler];
          }
        });
      }

      return props;
    };
  }, _temp2;
}

/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styled_AvatarItem__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__hoc__ = __webpack_require__(180);















/* eslint-disable react/no-unused-prop-types */

var AvatarItem = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(AvatarItem, _Component);

  function AvatarItem() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, AvatarItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = AvatarItem.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(AvatarItem)).call.apply(_ref, [this].concat(args))), _this), _this.blur = function () {
      if (_this.node) _this.node.blur();
    }, _this.focus = function () {
      if (_this.node) _this.node.focus();
    }, _this.guardedClick = function (event) {
      var _this$props = _this.props,
          isDisabled = _this$props.isDisabled,
          onClick = _this$props.onClick;


      if (isDisabled || typeof onClick !== 'function') return;

      var item = __WEBPACK_IMPORTED_MODULE_9__utils__["b" /* omit */].apply(undefined, [_this.props].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_8__constants__["a" /* propsOmittedFromClickData */])));

      onClick({ item: item, event: event });
    }, _this.setNode = function (ref) {
      _this.node = ref;
    }, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  // expose blur/focus to consumers via ref


  // disallow click on disabled avatars


  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(AvatarItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          avatar = _props.avatar,
          enableTextTruncate = _props.enableTextTruncate,
          primaryText = _props.primaryText,
          secondaryText = _props.secondaryText;

      // maintain the illusion of a mask around presence/status

      var borderColor = Object(__WEBPACK_IMPORTED_MODULE_10__styled_AvatarItem__["d" /* getBackgroundColor */])(this.props);

      // distill props from context, props, and state
      var enhancedProps = Object(__WEBPACK_IMPORTED_MODULE_11__helpers__["a" /* getProps */])(this);

      // provide element type based on props
      var StyledComponent = Object(__WEBPACK_IMPORTED_MODULE_11__helpers__["c" /* getStyledAvatarItem */])(this.props);

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        StyledComponent,
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          innerRef: this.setNode
        }, enhancedProps, {
          onClick: this.guardedClick
        }),
        Object(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(avatar, { borderColor: borderColor }),
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10__styled_AvatarItem__["a" /* Content */],
          { truncate: enableTextTruncate },
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10__styled_AvatarItem__["b" /* PrimaryText */],
            { truncate: enableTextTruncate },
            primaryText
          ),
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10__styled_AvatarItem__["c" /* SecondaryText */],
            { truncate: enableTextTruncate },
            secondaryText
          )
        )
      );
    }
  }]);

  return AvatarItem;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

AvatarItem.defaultProps = { enableTextTruncate: true };


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_12__hoc__["b" /* withPseudoState */])(AvatarItem));

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styled_Skeleton__ = __webpack_require__(765);









var Skeleton = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Skeleton, _Component);

  function Skeleton() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Skeleton);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Skeleton.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Skeleton)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Skeleton, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__styled_Skeleton__["a" /* default */], this.props);
    }
  }]);

  return Skeleton;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Skeleton.defaultProps = {
  appearance: 'circle',
  size: 'medium',
  weight: 'normal'
};
/* harmony default export */ __webpack_exports__["a"] = (Skeleton);

/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(49);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  width: ', 'px;\n  height: ', 'px;\n  display: inline-block;\n  border-radius: ', ';\n  background-color: ', ';\n  border: ', 'px solid transparent;\n  opacity: ', ';\n'], ['\n  width: ', 'px;\n  height: ', 'px;\n  display: inline-block;\n  border-radius: ', ';\n  background-color: ', ';\n  border: ', 'px solid transparent;\n  opacity: ', ';\n']);





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, function (_ref) {
  var size = _ref.size;
  return __WEBPACK_IMPORTED_MODULE_2__constants__["b" /* AVATAR_SIZES */][size];
}, function (_ref2) {
  var size = _ref2.size;
  return __WEBPACK_IMPORTED_MODULE_2__constants__["b" /* AVATAR_SIZES */][size];
}, function (props) {
  return props.appearance === 'square' ? __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* AVATAR_RADIUS */][props.size] + 'px' : '50%';
}, function (_ref3) {
  var color = _ref3.color;
  return color || 'currentColor';
}, function (_ref4) {
  var size = _ref4.size;
  return __WEBPACK_IMPORTED_MODULE_2__constants__["c" /* BORDER_WIDTH */][size];
}, function (_ref5) {
  var weight = _ref5.weight;
  return weight === 'strong' ? 0.3 : 0.15;
}));

/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(20);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  height: ', 'px;\n  background-color: currentColor;\n  border-radius: ', 'px;\n  opacity: 0.3;\n  ', ';\n  width: ', 'px;\n'], ['\n  height: ', 'px;\n  background-color: currentColor;\n  border-radius: ', 'px;\n  opacity: 0.3;\n  ', ';\n  width: ', 'px;\n']);





var SkeletonContainerHeaderText = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["e" /* math */].multiply(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */], 2.5), __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["e" /* math */].divide(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */], 2), function (props) {
  return !props.isAvatarHidden && 'margin-left: ' + Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */])() * 2 + 'px';
}, Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */])() * 18);

SkeletonContainerHeaderText.displayName = 'SkeletonContainerHeaderText';
/* harmony default export */ __webpack_exports__["a"] = (SkeletonContainerHeaderText);

/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__ = __webpack_require__(20);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  display: flex;\n  align-items: center;\n  margin: ', 'px\n    ', 'px 0 ', 'px;\n'], ['\n  display: flex;\n  align-items: center;\n  margin: ', 'px\n    ', 'px 0 ', 'px;\n']);





var SkeletonDefaultContainerHeaderInner = __WEBPACK_IMPORTED_MODULE_1_styled_components__["default"].div(_templateObject, function (props) {
  return props.isAvatarHidden ? Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */])() * 2 : __WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["e" /* math */].divide(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */], 2);
}, Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */])(), Object(__WEBPACK_IMPORTED_MODULE_2__atlaskit_theme__["d" /* gridSize */])());

SkeletonDefaultContainerHeaderInner.displayName = 'SkeletonDefaultContainerHeaderInner';
/* harmony default export */ __webpack_exports__["a"] = (SkeletonDefaultContainerHeaderInner);

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(15);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DashboardIcon = function DashboardIcon(props) {
  return _react2.default.createElement(_index2.default, _extends({ dangerouslySetGlyph: '<svg width="24" height="24" viewBox="0 0 24 24" focusable="false" role="presentation"><g fill="currentColor"><path d="M4 18h16.008C20 18 20 6 20 6H3.992C4 6 4 18 4 18zM2 5.994C2 4.893 2.898 4 3.99 4h16.02C21.108 4 22 4.895 22 5.994v12.012A1.997 1.997 0 0 1 20.01 20H3.99A1.994 1.994 0 0 1 2 18.006V5.994z"/><path d="M7 5v14h2V5z"/><path d="M7 11h14V9H7z"/></g></svg>' }, props));
};
exports.default = DashboardIcon;

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(15);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SettingsIcon = function SettingsIcon(props) {
  return _react2.default.createElement(_index2.default, _extends({ dangerouslySetGlyph: '<svg width="24" height="24" viewBox="0 0 24 24" focusable="false" role="presentation"><path d="M11.701 16.7a5.002 5.002 0 1 1 0-10.003 5.002 5.002 0 0 1 0 10.004m8.368-3.117a1.995 1.995 0 0 1-1.346-1.885c0-.876.563-1.613 1.345-1.885a.48.48 0 0 0 .315-.574 8.947 8.947 0 0 0-.836-1.993.477.477 0 0 0-.598-.195 2.04 2.04 0 0 1-1.29.08 1.988 1.988 0 0 1-1.404-1.395 2.04 2.04 0 0 1 .076-1.297.478.478 0 0 0-.196-.597 8.98 8.98 0 0 0-1.975-.826.479.479 0 0 0-.574.314 1.995 1.995 0 0 1-1.885 1.346 1.994 1.994 0 0 1-1.884-1.345.482.482 0 0 0-.575-.315c-.708.2-1.379.485-2.004.842a.47.47 0 0 0-.198.582A2.002 2.002 0 0 1 4.445 7.06a.478.478 0 0 0-.595.196 8.946 8.946 0 0 0-.833 1.994.48.48 0 0 0 .308.572 1.995 1.995 0 0 1 1.323 1.877c0 .867-.552 1.599-1.324 1.877a.479.479 0 0 0-.308.57 8.99 8.99 0 0 0 .723 1.79.477.477 0 0 0 .624.194c.595-.273 1.343-.264 2.104.238.117.077.225.185.302.3.527.8.512 1.58.198 2.188a.473.473 0 0 0 .168.628 8.946 8.946 0 0 0 2.11.897.474.474 0 0 0 .57-.313 1.995 1.995 0 0 1 1.886-1.353c.878 0 1.618.567 1.887 1.353a.475.475 0 0 0 .57.313 8.964 8.964 0 0 0 2.084-.883.473.473 0 0 0 .167-.631c-.318-.608-.337-1.393.191-2.195.077-.116.185-.225.302-.302.772-.511 1.527-.513 2.125-.23a.477.477 0 0 0 .628-.19 8.925 8.925 0 0 0 .728-1.793.478.478 0 0 0-.314-.573" fill="currentColor" fill-rule="evenodd"/></svg>' }, props));
};
exports.default = SettingsIcon;

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(15);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchIcon = function SearchIcon(props) {
  return _react2.default.createElement(_index2.default, _extends({ dangerouslySetGlyph: '<svg width="24" height="24" viewBox="0 0 24 24" focusable="false" role="presentation"><path d="M16.436 15.085l3.94 4.01a1 1 0 0 1-1.425 1.402l-3.938-4.006a7.5 7.5 0 1 1 1.423-1.406zM10.5 16a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11z" fill="currentColor" fill-rule="evenodd"/></svg>' }, props));
};
exports.default = SearchIcon;

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(15);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddIcon = function AddIcon(props) {
  return _react2.default.createElement(_index2.default, _extends({ dangerouslySetGlyph: '<svg width="24" height="24" viewBox="0 0 24 24" focusable="false" role="presentation"><path d="M13 11V3.993A.997.997 0 0 0 12 3c-.556 0-1 .445-1 .993V11H3.993A.997.997 0 0 0 3 12c0 .557.445 1 .993 1H11v7.007c0 .548.448.993 1 .993.556 0 1-.445 1-.993V13h7.007A.997.997 0 0 0 21 12c0-.556-.445-1-.993-1H13z" fill="currentColor" fill-rule="evenodd"/></svg>' }, props));
};
exports.default = AddIcon;

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(15);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var JiraSoftwareIcon = function JiraSoftwareIcon(props) {
  return _react2.default.createElement(_index2.default, _extends({ dangerouslySetGlyph: '<svg width="24" height="24" viewBox="0 0 24 24" focusable="false" role="presentation"><defs><linearGradient x1="28.264%" y1="81.66%" x2="80.418%" y2="47.767%" id="a-idPlaceholder"><stop stop-color="inherit" stop-opacity=".4" offset="0%"/><stop stop-color="inherit" offset="100%"/></linearGradient><linearGradient x1="89.327%" y1="41.805%" x2="36.752%" y2="75.932%" id="b-idPlaceholder"><stop stop-color="inherit" stop-opacity=".4" offset="0%"/><stop stop-color="inherit" offset="100%"/></linearGradient></defs><path d="M11.903 22.185a5.082 5.082 0 0 0 0-7.196L5.259 8.38l-3.021 3.016a.808.808 0 0 0 0 1.143l9.665 9.646z" fill="currentColor"/><path d="M15.208 11.69l-3.305 3.299a5.082 5.082 0 0 1 0 7.196l6.91-6.897-3.605-3.598z" fill="url(#a-idPlaceholder)"/><path d="M21.568 11.396L11.903 1.75l-.03.03a5.08 5.08 0 0 0 .022 7.172l6.648 6.606 3.025-3.019a.808.808 0 0 0 0-1.143z" fill="currentColor"/><path d="M11.903 8.947a5.08 5.08 0 0 1-.022-7.173L4.986 8.653l3.606 3.598 3.31-3.304z" fill="url(#b-idPlaceholder)"/></svg>' }, props));
};
exports.default = JiraSoftwareIcon;

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(15);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ArrowLeftIcon = function ArrowLeftIcon(props) {
  return _react2.default.createElement(_index2.default, _extends({ dangerouslySetGlyph: '<svg width="24" height="24" viewBox="0 0 24 24" focusable="false" role="presentation"><path d="M8.414 11.5H18a1 1 0 0 1 0 2H8.414l3.793 3.793a1 1 0 0 1-1.414 1.414l-5.5-5.5a1 1 0 0 1 0-1.414l5.5-5.5a1 1 0 0 1 1.414 1.414L8.414 11.5z" fill="currentColor" fill-rule="evenodd"/></svg>' }, props));
};
exports.default = ArrowLeftIcon;

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_navigation__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_bitbucket_branches__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_bitbucket_branches___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_bitbucket_branches__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_page__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_page___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_page__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_calendar__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_calendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_calendar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_emoji_objects__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_emoji_objects___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_emoji_objects__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_icon_glyph_emoji_nature__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__atlaskit_icon_glyph_emoji_nature___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__atlaskit_icon_glyph_emoji_nature__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_emoji_travel__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_emoji_travel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_emoji_travel__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var createItems=[{title:null,items:[['/#event','Create Event','Create Event',__WEBPACK_IMPORTED_MODULE_5__atlaskit_icon_glyph_calendar___default.a],['/#nature','Create Nature','Create Nature',__WEBPACK_IMPORTED_MODULE_7__atlaskit_icon_glyph_emoji_nature___default.a],['/#idea','Create Idea','Create Idea',__WEBPACK_IMPORTED_MODULE_6__atlaskit_icon_glyph_emoji_objects___default.a],['/#travel','Create Travel Plans','Create Travel Plans',__WEBPACK_IMPORTED_MODULE_8__atlaskit_icon_glyph_emoji_travel___default.a]]},{title:'Group with title',items:[['/#branch',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,"Create a ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("strong",null,"Bitbucket branch")),'Bitbucket branch',__WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_bitbucket_branches___default.a],['/#page',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,"Create a ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("strong",null,"Confluence page")),'Confluence page',__WEBPACK_IMPORTED_MODULE_4__atlaskit_icon_glyph_page___default.a]]}];var CreateDrawer=function(_Component){_inherits(CreateDrawer,_Component);function CreateDrawer(){_classCallCheck(this,CreateDrawer);return _possibleConstructorReturn(this,(CreateDrawer.__proto__||Object.getPrototypeOf(CreateDrawer)).apply(this,arguments));}_createClass(CreateDrawer,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,createItems.map(function(itemGroup){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__atlaskit_navigation__["e" /* AkNavigationItemGroup */],{key:itemGroup.title,title:itemGroup.title},itemGroup.items.map(function(item){var _item=_slicedToArray(item,4),url=_item[0],text=_item[1],label=_item[2],Icon=_item[3];return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__atlaskit_navigation__["d" /* AkNavigationItem */],{key:url,href:url,icon:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Icon,{label:label}),text:text.valueOf(),onClick:_this2.props.onItemClicked});}));}));}}]);return CreateDrawer;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);CreateDrawer.propTypes={onItemClicked:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (CreateDrawer);

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(15);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BitbucketBranchesIcon = function BitbucketBranchesIcon(props) {
  return _react2.default.createElement(_index2.default, _extends({ dangerouslySetGlyph: '<svg width="24" height="24" viewBox="0 0 24 24" focusable="false" role="presentation"><path d="M19 11c0 1.3-.8 2.4-2 2.8V15c0 2.2-1.8 4-4 4h-2.2c-.4 1.2-1.5 2-2.8 2-1.7 0-3-1.3-3-3 0-1.3.8-2.4 2-2.8V8.8C5.9 8.4 5 7.3 5 6c0-1.7 1.3-3 3-3s3 1.3 3 3c0 1.3-.8 2.4-2.1 2.8v6.4c.9.3 1.6.9 1.9 1.8H13c1.1 0 2-.9 2-2v-1.2c-1.2-.4-2-1.5-2-2.8 0-1.7 1.3-3 3-3s3 1.3 3 3zM8 5c-.5 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1zm8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1zm-8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1z" fill="currentColor" fill-rule="evenodd"/></svg>' }, props));
};
exports.default = BitbucketBranchesIcon;

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(15);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PageIcon = function PageIcon(props) {
  return _react2.default.createElement(_index2.default, _extends({ dangerouslySetGlyph: '<svg width="24" height="24" viewBox="0 0 24 24" focusable="false" role="presentation"><g fill="currentColor" fill-rule="evenodd"><rect x="8" y="6" width="8" height="2" rx="1"/><rect x="8" y="9" width="8" height="2" rx="1"/><rect x="8" y="12" width="4" height="2" rx="1"/><path d="M7 4v16h10V4H7zm-2-.01C5 2.892 5.897 2 7.006 2h9.988C18.102 2 19 2.898 19 3.99v16.02c0 1.099-.897 1.99-2.006 1.99H7.006A2.003 2.003 0 0 1 5 20.01V3.99z" fill-rule="nonzero"/></g></svg>' }, props));
};
exports.default = PageIcon;

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(15);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CalendarIcon = function CalendarIcon(props) {
  return _react2.default.createElement(_index2.default, _extends({ dangerouslySetGlyph: '<svg width="24" height="24" viewBox="0 0 24 24" focusable="false" role="presentation"><path d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.006V6.994C3 5.893 3.892 5 4.995 5zM5 9v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9H5zm1-5a1 1 0 0 1 2 0v1H6V4zm10 0a1 1 0 0 1 2 0v1h-2V4zm-9 9v-2.001h2V13H7zm8 0v-2.001h2V13h-2zm-4 0v-2.001h2.001V13H11zm-4 4v-2h2v2H7zm4 0v-2h2.001v2H11zm4 0v-2h2v2h-2z" fill="currentColor" fill-rule="evenodd"/></svg>' }, props));
};
exports.default = CalendarIcon;

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(15);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmojiObjectsIcon = function EmojiObjectsIcon(props) {
  return _react2.default.createElement(_index2.default, _extends({ dangerouslySetGlyph: '<svg width="24" height="24" viewBox="0 0 24 24" focusable="false" role="presentation"><path d="M11.998 4A5.997 5.997 0 0 0 6 9.998c0 2.218 2.288 4.484 2.288 4.484.39.387.71 1.112.71 1.611 0 .499.45.907 1 .907h4c.55 0 1-.408 1-.907 0-.499.32-1.224.71-1.611 0 0 2.288-2.266 2.288-4.484A5.997 5.997 0 0 0 11.998 4zm0 2a4.003 4.003 0 0 1 3.998 3.998c0 1.029-1.145 2.511-1.695 3.064-.507.501-.912 1.216-1.13 1.938h-2.346c-.217-.722-.622-1.435-1.125-1.934-.555-.557-1.7-2.039-1.7-3.068A4.003 4.003 0 0 1 11.998 6zm2.965 13c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v.003c0 .55.45 1 1 1h4c.55 0 1-.45 1-1V19z" fill="currentColor" fill-rule="evenodd"/></svg>' }, props));
};
exports.default = EmojiObjectsIcon;

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(15);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmojiNatureIcon = function EmojiNatureIcon(props) {
  return _react2.default.createElement(_index2.default, _extends({ dangerouslySetGlyph: '<svg width="24" height="24" viewBox="0 0 24 24" focusable="false" role="presentation"><path d="M13 16h3.625l-2.5-4h1.208L12 7l-3.333 5h1.208l-2.5 4H11v2h2v-2zm4.33-2.06l1.527 2.546A1 1 0 0 1 18 18h-3c-.003 1.105-.9 2-1.998 2h-2.004A1.999 1.999 0 0 1 9 18H6a1 1 0 0 1-.857-1.514L6.67 13.94c-.6-.23-.888-1.068-.484-1.697l5-7.778c.4-.62 1.229-.62 1.628 0l5 7.778c.404.629.117 1.467-.484 1.697z" fill="currentColor" fill-rule="evenodd"/></svg>' }, props));
};
exports.default = EmojiNatureIcon;

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(15);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmojiTravelIcon = function EmojiTravelIcon(props) {
  return _react2.default.createElement(_index2.default, _extends({ dangerouslySetGlyph: '<svg width="24" height="24" viewBox="0 0 24 24" focusable="false" role="presentation"><path d="M15.584 17H8.416l-2.708 2.709a1.004 1.004 0 0 1-1.415 0l-.002-.002a1.004 1.004 0 0 1 0-1.415l1.618-1.617A1.998 1.998 0 0 1 5 14.997V6.003C5 4.897 5.897 4 7.006 4h9.988C18.102 4 19 4.894 19 6.003v8.994a2 2 0 0 1-.909 1.678l1.618 1.617a1.004 1.004 0 0 1 0 1.415 1.004 1.004 0 0 1-1.417.002L15.584 17zM17 10V6H7v4h10zm0 2v3H7v-3h10zm-1.5 6.997c0 .55-.45 1-1 1h-5c-.55 0-1-.45-1-1s.45-1 1-1h5c.55 0 1 .45 1 1zm.2-5.517a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-6.691 1a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" fill="currentColor" fill-rule="evenodd"/></svg>' }, props));
};
exports.default = EmojiTravelIcon;

/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SearchResults__ = __webpack_require__(782);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var items=[{name:'Events',link:'/#events',description:'List of events.'},{name:'Nature',link:'/#nature',description:'Types of things found in nature.'},{name:'Ideas',link:'/#ideas',description:'Page detailing specific project ideas.'},{name:'Travel Plans',link:'/#travel-plans',description:'People\'s travel plans.'},{name:'Branches',link:'/#branches',description:'All BitBucket branches you have access to.'},{name:'Pages',link:'/#pages',description:'Confluence pages you have made.'}];var SearchDrawer=function(_Component){_inherits(SearchDrawer,_Component);function SearchDrawer(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SearchDrawer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SearchDrawer.__proto__||Object.getPrototypeOf(SearchDrawer)).call.apply(_ref,[this].concat(args))),_this),_this.state={searchString:'',results:items},_this.filterChange=function(){_this.setState({searchString:_this.searchInput.value});},_this.searchResults=function(){var _this$state=_this.state,results=_this$state.results,searchString=_this$state.searchString;var matchingResults=results.filter(function(c){return c.name.toLowerCase().indexOf(searchString.toLowerCase())>=0||c.description&&c.description.toLowerCase().indexOf(searchString.toLowerCase())>=0;}).slice(0,10);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SearchResults__["a" /* default */],{matchingResults:matchingResults,onResultClicked:function onResultClicked(){_this.props.onResultClicked();_this.searchInput.value='';_this.filterChange();}});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SearchDrawer,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input",{type:"text",placeholder:"Search...",onKeyUp:this.filterChange,ref:function ref(el){_this2.searchInput=el;if(_this2.props.onSearchInputRef){_this2.props.onSearchInputRef(el);}},style:{border:'none',display:'block',fontSize:24,fontWeight:200,outline:'none',padding:'0 0 0 12px'}}),this.searchResults());}}]);return SearchDrawer;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);SearchDrawer.propTypes={onResultClicked:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,onSearchInputRef:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (SearchDrawer);

/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(110);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SearchResults=function(_Component){_inherits(SearchResults,_Component);function SearchResults(){_classCallCheck(this,SearchResults);return _possibleConstructorReturn(this,(SearchResults.__proto__||Object.getPrototypeOf(SearchResults)).apply(this,arguments));}_createClass(SearchResults,[{key:"render",value:function render(){var _this2=this;if(!this.props.matchingResults.length){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,"Nothing found, keep on searching!");}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",{style:{listStyleType:'none',margin:'16px 0',padding:0}},this.props.matchingResults.map(function(result){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",{key:result.name,style:{padding:8}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* Link */],{to:result.link,onClick:_this2.props.onResultClicked},result.name),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{style:{display:'block'}},result.description));}));}}]);return SearchResults;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);SearchResults.propTypes={matchingResults:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object),onResultClicked:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (SearchResults);

/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_dropdown_menu__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_navigation__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_question_circle__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_question_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_question_circle__);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__atlaskit_dropdown_menu__["a" /* default */],{appearance:'tall',items:[{heading:'Help',items:[{content:'Documentation'},{content:'Learn Git'},{content:'Keyboard shortcuts'},{content:'Bitbucket tutorials'},{content:'API'},{content:'Support'}]}],position:'right bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__atlaskit_navigation__["c" /* AkGlobalItem */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__atlaskit_icon_glyph_question_circle___default.a,{label:'Help icon'}))));

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(15);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuestionCircleIcon = function QuestionCircleIcon(props) {
  return _react2.default.createElement(_index2.default, _extends({ dangerouslySetGlyph: '<svg width="24" height="24" viewBox="0 0 24 24" focusable="false" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" cx="12" cy="12" r="10"/><circle fill="inherit" cx="12" cy="18" r="1"/><path d="M15.89 9.05a3.975 3.975 0 0 0-2.957-2.942C10.321 5.514 8.017 7.446 8 9.95l.005.147a.992.992 0 0 0 .982.904c.552 0 1-.447 1.002-.998a2.004 2.004 0 0 1 4.007-.002c0 1.102-.898 2-2.003 2H12a1 1 0 0 0-1 .987v2.014a1.001 1.001 0 0 0 2.004 0v-.782c0-.217.145-.399.35-.472A3.99 3.99 0 0 0 15.89 9.05" fill="inherit"/></g></svg>' }, props));
};
exports.default = QuestionCircleIcon;

/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__atlaskit_dropdown_menu__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_navigation__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__atlaskit_avatar__ = __webpack_require__(310);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__atlaskit_dropdown_menu__["a" /* default */],{appearance:'tall',position:'right bottom',items:[{heading:'Jacob',items:[{content:'View profile'},{content:'Manage Atlassian account'},{content:'Bitbucket settings'},{content:'Integrations'},{content:'Bitbucket labs'},{content:'Log out'}]}]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__atlaskit_navigation__["c" /* AkGlobalItem */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__atlaskit_avatar__["b" /* default */],{size:'small'}))));

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/atlaskit.a379dc57.png";

/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__atlaskit_button__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_MainSection__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ContentWrapper__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_PageTitle__ = __webpack_require__(329);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HomePage=function(_Component){_inherits(HomePage,_Component);function HomePage(){_classCallCheck(this,HomePage);return _possibleConstructorReturn(this,(HomePage.__proto__||Object.getPrototypeOf(HomePage)).apply(this,arguments));}_createClass(HomePage,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_ContentWrapper__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_PageTitle__["a" /* default */],null,'Home'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_MainSection__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__atlaskit_button__["a" /* ButtonGroup */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__atlaskit_button__["b" /* default */],{appearance:'primary',onClick:this.context.showModal,onClose:function onClose(){}},'Click to view Atlaskit modal'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__atlaskit_button__["b" /* default */],{onClick:this.context.addFlag},'click to view Atlaskit flag')));}}]);return HomePage;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);HomePage.contextTypes={showModal:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,addFlag:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,onConfirm:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,onCancel:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,onClose:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (HomePage);

/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export colorPalette8 */
/* unused harmony export colorPalette16 */
/* unused harmony export colorPalette24 */
/* unused harmony export colorPalette */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__colors__ = __webpack_require__(34);

 // Jira Portfolio

var colorPalette8 = [{
  background: __WEBPACK_IMPORTED_MODULE_1__colors__["y" /* N800 */],
  text: __WEBPACK_IMPORTED_MODULE_1__colors__["n" /* N0 */]
}, {
  background: __WEBPACK_IMPORTED_MODULE_1__colors__["F" /* R400 */],
  text: __WEBPACK_IMPORTED_MODULE_1__colors__["n" /* N0 */]
}, {
  background: __WEBPACK_IMPORTED_MODULE_1__colors__["A" /* P400 */],
  text: __WEBPACK_IMPORTED_MODULE_1__colors__["B" /* P50 */]
}, {
  background: __WEBPACK_IMPORTED_MODULE_1__colors__["c" /* B400 */],
  text: __WEBPACK_IMPORTED_MODULE_1__colors__["f" /* B75 */]
}, {
  background: __WEBPACK_IMPORTED_MODULE_1__colors__["I" /* T300 */],
  text: __WEBPACK_IMPORTED_MODULE_1__colors__["y" /* N800 */]
}, {
  background: __WEBPACK_IMPORTED_MODULE_1__colors__["k" /* G400 */],
  text: __WEBPACK_IMPORTED_MODULE_1__colors__["n" /* N0 */]
}, {
  background: __WEBPACK_IMPORTED_MODULE_1__colors__["L" /* Y400 */],
  text: __WEBPACK_IMPORTED_MODULE_1__colors__["y" /* N800 */]
}, {
  background: __WEBPACK_IMPORTED_MODULE_1__colors__["x" /* N70 */],
  text: __WEBPACK_IMPORTED_MODULE_1__colors__["y" /* N800 */]
}];
var colorPalette16 = [].concat(colorPalette8, [{
  background: __WEBPACK_IMPORTED_MODULE_1__colors__["u" /* N500 */],
  text: __WEBPACK_IMPORTED_MODULE_1__colors__["n" /* N0 */]
}, {
  background: __WEBPACK_IMPORTED_MODULE_1__colors__["E" /* R100 */],
  text: __WEBPACK_IMPORTED_MODULE_1__colors__["y" /* N800 */]
}, {
  background: __WEBPACK_IMPORTED_MODULE_1__colors__["D" /* P75 */],
  text: __WEBPACK_IMPORTED_MODULE_1__colors__["y" /* N800 */]
}, {
  background: __WEBPACK_IMPORTED_MODULE_1__colors__["a" /* B100 */],
  text: __WEBPACK_IMPORTED_MODULE_1__colors__["y" /* N800 */]
}, {
  background: __WEBPACK_IMPORTED_MODULE_1__colors__["H" /* T100 */],
  text: __WEBPACK_IMPORTED_MODULE_1__colors__["y" /* N800 */]
}, {
  background: __WEBPACK_IMPORTED_MODULE_1__colors__["j" /* G100 */],
  text: __WEBPACK_IMPORTED_MODULE_1__colors__["m" /* G500 */]
}, {
  background: __WEBPACK_IMPORTED_MODULE_1__colors__["K" /* Y200 */],
  text: __WEBPACK_IMPORTED_MODULE_1__colors__["y" /* N800 */]
}, {
  background: __WEBPACK_IMPORTED_MODULE_1__colors__["n" /* N0 */],
  text: __WEBPACK_IMPORTED_MODULE_1__colors__["y" /* N800 */]
}]);
var colorPalette24 = [].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(colorPalette16), [{
  background: __WEBPACK_IMPORTED_MODULE_1__colors__["o" /* N100 */],
  text: __WEBPACK_IMPORTED_MODULE_1__colors__["n" /* N0 */]
}, {
  background: __WEBPACK_IMPORTED_MODULE_1__colors__["r" /* N40 */],
  text: __WEBPACK_IMPORTED_MODULE_1__colors__["y" /* N800 */]
}, {
  background: __WEBPACK_IMPORTED_MODULE_1__colors__["t" /* N50 */],
  text: __WEBPACK_IMPORTED_MODULE_1__colors__["G" /* R500 */]
}, {
  background: __WEBPACK_IMPORTED_MODULE_1__colors__["B" /* P50 */],
  text: __WEBPACK_IMPORTED_MODULE_1__colors__["C" /* P500 */]
}, {
  background: __WEBPACK_IMPORTED_MODULE_1__colors__["d" /* B50 */],
  text: __WEBPACK_IMPORTED_MODULE_1__colors__["e" /* B500 */]
}, {
  background: __WEBPACK_IMPORTED_MODULE_1__colors__["J" /* T75 */],
  text: __WEBPACK_IMPORTED_MODULE_1__colors__["y" /* N800 */]
}, {
  background: __WEBPACK_IMPORTED_MODULE_1__colors__["l" /* G50 */],
  text: __WEBPACK_IMPORTED_MODULE_1__colors__["m" /* G500 */]
}, {
  background: __WEBPACK_IMPORTED_MODULE_1__colors__["M" /* Y75 */],
  text: __WEBPACK_IMPORTED_MODULE_1__colors__["y" /* N800 */]
}]);
var colorPalette = function colorPalette() {
  var palette = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '8';

  switch (palette) {
    case '8':
      return colorPalette8;

    case '16':
      return colorPalette16;

    case '24':
      return colorPalette24;

    default:
      throw new Error('The only available color palette is 8, 16, 24');
  }
};

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(790);

var iterableToArray = __webpack_require__(791);

var unsupportedIterableToArray = __webpack_require__(792);

var nonIterableSpread = __webpack_require__(793);

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(325);

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}

module.exports = _arrayWithoutHoles;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 791 */
/***/ (function(module, exports) {

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

module.exports = _iterableToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(325);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

module.exports = _unsupportedIterableToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 793 */
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableSpread;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export e100 */
/* unused harmony export e200 */
/* unused harmony export e300 */
/* unused harmony export e400 */
/* unused harmony export e500 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_themed__ = __webpack_require__(157);

 // Cards on a board

var e100 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: "box-shadow: 0 1px 1px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["v" /* N50A */], ", 0 0 1px 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["s" /* N40A */], ";"),
  dark: "box-shadow: 0 1px 1px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["h" /* DN50A */], ", 0 0 1px 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["g" /* DN40A */], ";")
}); // Inline dialogs

var e200 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: "box-shadow: 0 4px 8px -2px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["v" /* N50A */], ", 0 0 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["w" /* N60A */], ";"),
  dark: "box-shadow: 0 4px 8px -2px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["h" /* DN50A */], ", 0 0 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["i" /* DN60A */], ";")
}); // Modals

var e300 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: "box-shadow: 0 8px 16px -4px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["v" /* N50A */], ", 0 0 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["w" /* N60A */], ";"),
  dark: "box-shadow: 0 8px 16px -4px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["h" /* DN50A */], ", 0 0 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["i" /* DN60A */], ";")
}); // Panels

var e400 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: "box-shadow: 0 12px 24px -6px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["v" /* N50A */], ", 0 0 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["w" /* N60A */], ";"),
  dark: "box-shadow: 0 12px 24px -6px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["h" /* DN50A */], ", 0 0 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["i" /* DN60A */], ";")
}); // Flag messages (notifications)

var e500 = Object(__WEBPACK_IMPORTED_MODULE_1__utils_themed__["a" /* default */])({
  light: "box-shadow: 0 20px 32px -8px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["v" /* N50A */], ", 0 0 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["w" /* N60A */], ";"),
  dark: "box-shadow: 0 20px 32px -8px ".concat(__WEBPACK_IMPORTED_MODULE_0__colors__["h" /* DN50A */], ", 0 0 1px ").concat(__WEBPACK_IMPORTED_MODULE_0__colors__["i" /* DN60A */], ";")
});

/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export headingSizes */
/* unused harmony export h900 */
/* unused harmony export h800 */
/* unused harmony export h700 */
/* unused harmony export h600 */
/* unused harmony export h500 */
/* unused harmony export h400 */
/* unused harmony export h300 */
/* unused harmony export h200 */
/* unused harmony export h100 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__colors__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(181);


function _templateObject9() {
  var data = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_taggedTemplateLiteral___default()(["\n  ", "\n  color: ", ";\n  font-weight: 700;\n  margin-top: ", "px;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_taggedTemplateLiteral___default()(["\n  ", "\n  color: ", ";\n  font-weight: 600;\n  margin-top: ", "px;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_taggedTemplateLiteral___default()(["\n  ", "\n  color: ", ";\n  font-weight: 600;\n  margin-top: ", "px;\n  text-transform: uppercase;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_taggedTemplateLiteral___default()(["\n  ", "\n  color: ", ";\n  font-weight: 600;\n  letter-spacing: -0.003em;\n  margin-top: ", "px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_taggedTemplateLiteral___default()(["\n  ", "\n  color: ", ";\n  font-weight: 600;\n  letter-spacing: -0.006em;\n  margin-top: ", "px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_taggedTemplateLiteral___default()(["\n  ", "\n  color: ", ";\n  font-weight: 500;\n  letter-spacing: -0.008em;\n  margin-top: ", "px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_taggedTemplateLiteral___default()(["\n  ", "\n  color: ", ";\n  font-weight: 500;\n  letter-spacing: -0.01em;\n  margin-top: ", "px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_taggedTemplateLiteral___default()(["\n  ", "\n  color: ", ";\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  margin-top: ", "px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_taggedTemplateLiteral___default()(["\n  ", "\n  color: ", ";\n  font-weight: 500;\n  letter-spacing: -0.01em;\n  margin-top: ", "px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}





var baseHeading = function baseHeading(size, lineHeight) {
  return "\n  font-size: ".concat(size / Object(__WEBPACK_IMPORTED_MODULE_3__constants__["c" /* fontSize */])(), "em;\n  font-style: inherit;\n  line-height: ").concat(lineHeight / size, ";\n");
};

var headingSizes = {
  h900: {
    size: 35,
    lineHeight: 40
  },
  h800: {
    size: 29,
    lineHeight: 32
  },
  h700: {
    size: 24,
    lineHeight: 28
  },
  h600: {
    size: 20,
    lineHeight: 24
  },
  h500: {
    size: 16,
    lineHeight: 20
  },
  h400: {
    size: 14,
    lineHeight: 16
  },
  h300: {
    size: 12,
    lineHeight: 16
  },
  h200: {
    size: 12,
    lineHeight: 16
  },
  h100: {
    size: 11,
    lineHeight: 16
  }
};
var h900 = function h900() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject(), baseHeading(headingSizes.h900.size, headingSizes.h900.lineHeight), __WEBPACK_IMPORTED_MODULE_2__colors__["O" /* heading */], Object(__WEBPACK_IMPORTED_MODULE_3__constants__["d" /* gridSize */])() * 6.5);
};
var h800 = function h800() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject2(), baseHeading(headingSizes.h800.size, headingSizes.h800.lineHeight), __WEBPACK_IMPORTED_MODULE_2__colors__["O" /* heading */], Object(__WEBPACK_IMPORTED_MODULE_3__constants__["d" /* gridSize */])() * 5);
};
var h700 = function h700() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject3(), baseHeading(headingSizes.h700.size, headingSizes.h700.lineHeight), __WEBPACK_IMPORTED_MODULE_2__colors__["O" /* heading */], Object(__WEBPACK_IMPORTED_MODULE_3__constants__["d" /* gridSize */])() * 5);
};
var h600 = function h600() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject4(), baseHeading(headingSizes.h600.size, headingSizes.h600.lineHeight), __WEBPACK_IMPORTED_MODULE_2__colors__["O" /* heading */], Object(__WEBPACK_IMPORTED_MODULE_3__constants__["d" /* gridSize */])() * 3.5);
};
var h500 = function h500() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject5(), baseHeading(headingSizes.h500.size, headingSizes.h500.lineHeight), __WEBPACK_IMPORTED_MODULE_2__colors__["O" /* heading */], Object(__WEBPACK_IMPORTED_MODULE_3__constants__["d" /* gridSize */])() * 3);
};
var h400 = function h400() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject6(), baseHeading(headingSizes.h400.size, headingSizes.h400.lineHeight), __WEBPACK_IMPORTED_MODULE_2__colors__["O" /* heading */], Object(__WEBPACK_IMPORTED_MODULE_3__constants__["d" /* gridSize */])() * 2);
};
var h300 = function h300() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject7(), baseHeading(headingSizes.h300.size, headingSizes.h300.lineHeight), __WEBPACK_IMPORTED_MODULE_2__colors__["O" /* heading */], Object(__WEBPACK_IMPORTED_MODULE_3__constants__["d" /* gridSize */])() * 2.5);
};
var h200 = function h200() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject8(), baseHeading(headingSizes.h200.size, headingSizes.h200.lineHeight), __WEBPACK_IMPORTED_MODULE_2__colors__["U" /* subtleHeading */], Object(__WEBPACK_IMPORTED_MODULE_3__constants__["d" /* gridSize */])() * 2);
};
var h100 = function h100() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["css"])(_templateObject9(), baseHeading(headingSizes.h100.size, headingSizes.h100.lineHeight), __WEBPACK_IMPORTED_MODULE_2__colors__["U" /* subtleHeading */], Object(__WEBPACK_IMPORTED_MODULE_3__constants__["d" /* gridSize */])() * 2);
};

/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export add */
/* unused harmony export subtract */
/* unused harmony export multiply */
/* unused harmony export divide */
// If a generic is used here, props can be inferred never and passed up (even with defaults)
function add(fn, addend) {
  return function (props) {
    return fn(props) + addend;
  };
}
function subtract(fn, subtrahend) {
  return function (props) {
    return fn(props) - subtrahend;
  };
}
function multiply(fn, factor) {
  return function (props) {
    return fn(props) * factor;
  };
}
function divide(fn, divisor) {
  return function (props) {
    return fn(props) / divisor;
  };
}

/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AtlaskitThemeProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_inherits__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_exenv__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_exenv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_exenv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__colors__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Theme__ = __webpack_require__(183);









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _templateObject() {
  var data = __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_taggedTemplateLiteral___default()(["\n  background-color: ", ";\n  color: ", ";\n\n  a {\n    color: ", ";\n  }\n  a:hover {\n    color: ", ";\n  }\n  a:active {\n    color: ", ";\n  }\n  a:focus {\n    outline-color: ", ";\n  }\n  h1 {\n    color: ", ";\n  }\n  h2 {\n    color: ", ";\n  }\n  h3 {\n    color: ", ";\n  }\n  h4 {\n    color: ", ";\n  }\n  h5 {\n    color: ", ";\n  }\n  h6 {\n    color: ", ";\n  }\n  small {\n    color: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}






 // For forward-compat until everything is upgraded.



function getStylesheetResetCSS(backgroundColor) {
  return "\n    body { background: ".concat(backgroundColor, "; }\n  ");
}

function buildThemeState(mode) {
  return {
    theme: __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_13__constants__["a" /* CHANNEL */], {
      mode: mode
    })
  };
}

var LegacyReset = __WEBPACK_IMPORTED_MODULE_10_styled_components__["default"].div(_templateObject(), function (p) {
  return p.background;
}, __WEBPACK_IMPORTED_MODULE_12__colors__["W" /* text */], __WEBPACK_IMPORTED_MODULE_12__colors__["P" /* link */], __WEBPACK_IMPORTED_MODULE_12__colors__["R" /* linkHover */], __WEBPACK_IMPORTED_MODULE_12__colors__["Q" /* linkActive */], __WEBPACK_IMPORTED_MODULE_12__colors__["S" /* linkOutline */], __WEBPACK_IMPORTED_MODULE_12__colors__["O" /* heading */], __WEBPACK_IMPORTED_MODULE_12__colors__["O" /* heading */], __WEBPACK_IMPORTED_MODULE_12__colors__["O" /* heading */], __WEBPACK_IMPORTED_MODULE_12__colors__["O" /* heading */], __WEBPACK_IMPORTED_MODULE_12__colors__["O" /* heading */], __WEBPACK_IMPORTED_MODULE_12__colors__["U" /* subtleHeading */], __WEBPACK_IMPORTED_MODULE_12__colors__["V" /* subtleText */]);

var AtlaskitThemeProvider = /*#__PURE__*/function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_inherits___default()(AtlaskitThemeProvider, _Component);

  var _super = _createSuper(AtlaskitThemeProvider);

  /**
   * This function never changes its reference because it accesses
   * `this` in the function call - thereby sidestepping the need for
   * creating a new reference everytime theme state changes.
   * NOTE: When moving to hooks watch out for this regressing.
   */
  function AtlaskitThemeProvider(props) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, AtlaskitThemeProvider);

    _this = _super.call(this, props);

    __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "getThemeMode", function () {
      return {
        mode: _this.state.theme[__WEBPACK_IMPORTED_MODULE_13__constants__["a" /* CHANNEL */]].mode
      };
    });

    _this.state = buildThemeState(props.mode);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(AtlaskitThemeProvider, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        hasAtlaskitThemeProvider: true
      };
    }
  }, {
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      if (!this.context.hasAtlaskitThemeProvider && __WEBPACK_IMPORTED_MODULE_11_exenv___default.a.canUseDOM) {
        var css = getStylesheetResetCSS(this.props.background(this.state));
        this.stylesheet = document.createElement('style');
        this.stylesheet.type = 'text/css';
        this.stylesheet.innerHTML = css;

        if (document && document.head) {
          document.head.appendChild(this.stylesheet);
        }
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(newProps) {
      if (newProps.mode !== this.props.mode) {
        var newThemeState = buildThemeState(newProps.mode);

        if (this.stylesheet) {
          var css = getStylesheetResetCSS(newProps.background(newThemeState));
          this.stylesheet.innerHTML = css;
        }

        this.setState(newThemeState);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.stylesheet && document && document.head) {
        document.head.removeChild(this.stylesheet);
        delete this.stylesheet;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var theme = this.state.theme;
      return (
        /*#__PURE__*/

        /* Wrapping the new provider around the old one provides forward
        compatibility when using the old provider for styled components. This
        allows us to use components converted to use the new API with consumers
        using the old provider along side components that may still be using the
        old theming API. */
        __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Theme__["a" /* default */].Provider, {
          value: this.getThemeMode
        }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_styled_components__["ThemeProvider"], {
          theme: theme
        }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(LegacyReset, {
          background: this.props.background
        }, children)))
      );
    }
  }]);

  return AtlaskitThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(AtlaskitThemeProvider, "defaultProps", {
  mode: __WEBPACK_IMPORTED_MODULE_13__constants__["b" /* DEFAULT_THEME_MODE */],
  background: __WEBPACK_IMPORTED_MODULE_12__colors__["N" /* background */]
});

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(AtlaskitThemeProvider, "childContextTypes", {
  hasAtlaskitThemeProvider: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool
});

__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_defineProperty___default()(AtlaskitThemeProvider, "contextTypes", {
  hasAtlaskitThemeProvider: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool
});



/***/ }),
/* 798 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 799 */
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(801);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 801 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  module.exports["default"] = module.exports, module.exports.__esModule = true;
  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(327)["default"];

var assertThisInitialized = __webpack_require__(326);

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 803 */
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(805);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 805 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* unused harmony default export */ var _unused_webpack_default_export = (function (_ref) {
  var children = _ref.children,
      props = _ref.props,
      theme = _ref.theme;
  var appearance = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default()(props) === 'object' ? 'default' : props;
  var merged = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default()(props) === 'object' ? _objectSpread({}, props) : {};
  Object.keys(theme).forEach(function (key) {
    if (!(key in merged)) {
      merged[key] = theme[key]({
        appearance: appearance
      });
    }
  });
  return children(merged);
});

/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ResetTheme */
/* unused harmony export Reset */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__colors__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_createTheme__ = __webpack_require__(184);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject2() {
  var data = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_taggedTemplateLiteral___default()(["\n    background-color: ", ";\n    color: ", ";\n\n    a {\n      color: ", ";\n    }\n    a:hover {\n      color: ", ";\n    }\n    a:active {\n      color: ", ";\n    }\n    a:focus {\n      outline-color: ", ";\n    }\n    h1,\n    h2,\n    h3,\n    h4,\n    h5 {\n      color: ", ";\n    }\n    h6 {\n      color: ", ";\n    }\n    small {\n      color: ", ";\n    }\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_taggedTemplateLiteral___default()(["\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}






var orTextColor = function orTextColor(preferred) {
  return function (p) {
    return p[preferred] || p.textColor;
  };
};

var Div = __WEBPACK_IMPORTED_MODULE_4_styled_components__["default"].div(_templateObject(), function (p) {
  return Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["css"])(_templateObject2(), p.backgroundColor, p.textColor, orTextColor('linkColor'), orTextColor('linkColorHover'), orTextColor('linkColorActive'), orTextColor('linkColorOutline'), orTextColor('headingColor'), orTextColor('subtleHeadingColor'), orTextColor('subtleTextColor'));
});
var ResetTheme = Object(__WEBPACK_IMPORTED_MODULE_6__utils_createTheme__["a" /* createTheme */])(function () {
  return {
    backgroundColor: __WEBPACK_IMPORTED_MODULE_5__colors__["n" /* N0 */],
    linkColor: __WEBPACK_IMPORTED_MODULE_5__colors__["c" /* B400 */],
    linkColorHover: __WEBPACK_IMPORTED_MODULE_5__colors__["b" /* B300 */],
    linkColorActive: __WEBPACK_IMPORTED_MODULE_5__colors__["e" /* B500 */],
    linkColorOutline: __WEBPACK_IMPORTED_MODULE_5__colors__["a" /* B100 */],
    headingColor: __WEBPACK_IMPORTED_MODULE_5__colors__["y" /* N800 */],
    subtleHeadingColor: __WEBPACK_IMPORTED_MODULE_5__colors__["p" /* N200 */],
    subtleTextColor: __WEBPACK_IMPORTED_MODULE_5__colors__["p" /* N200 */],
    textColor: __WEBPACK_IMPORTED_MODULE_5__colors__["z" /* N900 */]
  };
});
function Reset(props) {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ResetTheme.Provider, {
    value: props.theme
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ResetTheme.Consumer, null, function (tokens) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Div, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, _objectSpread(_objectSpread({}, tokens), {}, {
      mode: undefined
    }), props), props.children);
  }));
}

/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export withTheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Theme__ = __webpack_require__(183);



// Pre-executes the (global) theme and passes it as a prop to the supplied component.
// This is useful for ensuring that the current theme is accessible as props
// in styled-components.
function withTheme(InnerComponent) {
  return function ComponentWithTheme(props) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_Theme__["a" /* default */].Consumer, null, function (tokens) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(InnerComponent, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, props, {
        theme: tokens
      }));
    });
  };
}

/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_MainSection__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ContentWrapper__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PageTitle__ = __webpack_require__(329);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HomePage=function(_Component){_inherits(HomePage,_Component);function HomePage(){_classCallCheck(this,HomePage);return _possibleConstructorReturn(this,(HomePage.__proto__||Object.getPrototypeOf(HomePage)).apply(this,arguments));}_createClass(HomePage,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_ContentWrapper__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_PageTitle__["a" /* default */],null,'Settings'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_MainSection__["a" /* default */],null));}}]);return HomePage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (HomePage);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.6ecfbafd.js